import { jsx as le, jsxs as tn, Fragment as RE } from "react/jsx-runtime";
import * as Te from "react";
import xt, { createContext as PE, useContext as NE, useCallback as NL, useState as Vl, useRef as OE, useEffect as nm, useMemo as LE, createElement as OL, forwardRef as Qk } from "react";
import { k as $S, c as LL, l as DE, s as DL } from "./stay-request-B0Ml54R3.js";
import { e as V3, h as B3, f as W3, a as q3, g as H3, b as Z3, d as Q3, i as K3, j as Y3, m as G3, p as J3, u as X3 } from "./stay-request-B0Ml54R3.js";
var ym = (u) => u.type === "checkbox", ic = (u) => u instanceof Date, ra = (u) => u == null;
const zE = (u) => typeof u == "object";
var Nn = (u) => !ra(u) && !Array.isArray(u) && zE(u) && !ic(u), IE = (u) => Nn(u) && u.target ? ym(u.target) ? u.target.checked : u.target.value : u, zL = (u) => u.substring(0, u.search(/\.\d+(\.|$)/)) || u, AE = (u, o) => u.has(zL(o)), IL = (u) => {
  const o = u.constructor && u.constructor.prototype;
  return Nn(o) && o.hasOwnProperty("isPrototypeOf");
}, Kk = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ea(u) {
  let o;
  const s = Array.isArray(u), d = typeof FileList < "u" ? u instanceof FileList : !1;
  if (u instanceof Date)
    o = new Date(u);
  else if (u instanceof Set)
    o = new Set(u);
  else if (!(Kk && (u instanceof Blob || d)) && (s || Nn(u)))
    if (o = s ? [] : {}, !s && !IL(u))
      o = u;
    else
      for (const h in u)
        u.hasOwnProperty(h) && (o[h] = Ea(u[h]));
  else
    return u;
  return o;
}
var Jy = (u) => Array.isArray(u) ? u.filter(Boolean) : [], Pn = (u) => u === void 0, ge = (u, o, s) => {
  if (!o || !Nn(u))
    return s;
  const d = Jy(o.split(/[,[\].]+?/)).reduce((h, m) => ra(h) ? h : h[m], u);
  return Pn(d) || d === u ? Pn(u[o]) ? s : u[o] : d;
}, go = (u) => typeof u == "boolean", Yk = (u) => /^\w*$/.test(u), ME = (u) => Jy(u.replace(/["|']|\]/g, "").split(/\.|\[/)), Vt = (u, o, s) => {
  let d = -1;
  const h = Yk(o) ? [o] : ME(o), m = h.length, g = m - 1;
  for (; ++d < m; ) {
    const k = h[d];
    let S = s;
    if (d !== g) {
      const E = u[k];
      S = Nn(E) || Array.isArray(E) ? E : isNaN(+h[d + 1]) ? {} : [];
    }
    if (k === "__proto__" || k === "constructor" || k === "prototype")
      return;
    u[k] = S, u = u[k];
  }
  return u;
};
const Dy = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Ko = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Us = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, AL = xt.createContext(null), Gk = () => xt.useContext(AL);
var FE = (u, o, s, d = !0) => {
  const h = {
    defaultValues: o._defaultValues
  };
  for (const m in u)
    Object.defineProperty(h, m, {
      get: () => {
        const g = m;
        return o._proxyFormState[g] !== Ko.all && (o._proxyFormState[g] = !d || Ko.all), s && (s[g] = !0), u[g];
      }
    });
  return h;
}, Ca = (u) => Nn(u) && !Object.keys(u).length, $E = (u, o, s, d) => {
  s(u);
  const { name: h, ...m } = u;
  return Ca(m) || Object.keys(m).length >= Object.keys(o).length || Object.keys(m).find((g) => o[g] === (!d || Ko.all));
}, Xh = (u) => Array.isArray(u) ? u : [u], jE = (u, o, s) => !u || !o || u === o || Xh(u).some((d) => d && (s ? d === o : d.startsWith(o) || o.startsWith(d)));
function Jk(u) {
  const o = xt.useRef(u);
  o.current = u, xt.useEffect(() => {
    const s = !u.disabled && o.current.subject && o.current.subject.subscribe({
      next: o.current.next
    });
    return () => {
      s && s.unsubscribe();
    };
  }, [u.disabled]);
}
function ML(u) {
  const o = Gk(), { control: s = o.control, disabled: d, name: h, exact: m } = u || {}, [g, k] = xt.useState(s._formState), S = xt.useRef(!0), E = xt.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), R = xt.useRef(h);
  return R.current = h, Jk({
    disabled: d,
    next: (P) => S.current && jE(R.current, P.name, m) && $E(P, E.current, s._updateFormState) && k({
      ...s._formState,
      ...P
    }),
    subject: s._subjects.state
  }), xt.useEffect(() => (S.current = !0, E.current.isValid && s._updateValid(!0), () => {
    S.current = !1;
  }), [s]), xt.useMemo(() => FE(g, s, E.current, !1), [g, s]);
}
var Mi = (u) => typeof u == "string", UE = (u, o, s, d, h) => Mi(u) ? (d && o.watch.add(u), ge(s, u, h)) : Array.isArray(u) ? u.map((m) => (d && o.watch.add(m), ge(s, m))) : (d && (o.watchAll = !0), s);
function FL(u) {
  const o = Gk(), { control: s = o.control, name: d, defaultValue: h, disabled: m, exact: g } = u || {}, k = xt.useRef(d);
  k.current = d, Jk({
    disabled: m,
    subject: s._subjects.values,
    next: (R) => {
      jE(k.current, R.name, g) && E(Ea(UE(k.current, s._names, R.values || s._formValues, !1, h)));
    }
  });
  const [S, E] = xt.useState(s._getWatch(d, h));
  return xt.useEffect(() => s._removeUnmounted()), S;
}
function $L(u) {
  const o = Gk(), { name: s, disabled: d, control: h = o.control, shouldUnregister: m } = u, g = AE(h._names.array, s), k = FL({
    control: h,
    name: s,
    defaultValue: ge(h._formValues, s, ge(h._defaultValues, s, u.defaultValue)),
    exact: !0
  }), S = ML({
    control: h,
    name: s,
    exact: !0
  }), E = xt.useRef(h.register(s, {
    ...u.rules,
    value: k,
    ...go(u.disabled) ? { disabled: u.disabled } : {}
  })), R = xt.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!ge(S.errors, s)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!ge(S.dirtyFields, s)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!ge(S.touchedFields, s)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!ge(S.validatingFields, s)
    },
    error: {
      enumerable: !0,
      get: () => ge(S.errors, s)
    }
  }), [S, s]), P = xt.useMemo(() => ({
    name: s,
    value: k,
    ...go(d) || S.disabled ? { disabled: S.disabled || d } : {},
    onChange: (O) => E.current.onChange({
      target: {
        value: IE(O),
        name: s
      },
      type: Dy.CHANGE
    }),
    onBlur: () => E.current.onBlur({
      target: {
        value: ge(h._formValues, s),
        name: s
      },
      type: Dy.BLUR
    }),
    ref: (O) => {
      const M = ge(h._fields, s);
      M && O && (M._f.ref = {
        focus: () => O.focus(),
        select: () => O.select(),
        setCustomValidity: ($) => O.setCustomValidity($),
        reportValidity: () => O.reportValidity()
      });
    }
  }), [
    s,
    h._formValues,
    d,
    S.disabled,
    k,
    h._fields
  ]);
  return xt.useEffect(() => {
    const O = h._options.shouldUnregister || m, M = ($, Z) => {
      const G = ge(h._fields, $);
      G && G._f && (G._f.mount = Z);
    };
    if (M(s, !0), O) {
      const $ = Ea(ge(h._options.defaultValues, s));
      Vt(h._defaultValues, s, $), Pn(ge(h._formValues, s)) && Vt(h._formValues, s, $);
    }
    return !g && h.register(s), () => {
      (g ? O && !h._state.action : O) ? h.unregister(s) : M(s, !1);
    };
  }, [s, h, g, m]), xt.useEffect(() => {
    h._updateDisabledField({
      disabled: d,
      fields: h._fields,
      name: s
    });
  }, [d, s, h]), xt.useMemo(() => ({
    field: P,
    formState: S,
    fieldState: R
  }), [P, S, R]);
}
const jS = (u) => u.render($L(u));
var VE = (u, o, s, d, h) => o ? {
  ...s[u],
  types: {
    ...s[u] && s[u].types ? s[u].types : {},
    [d]: h || !0
  }
} : {}, US = (u) => ({
  isOnSubmit: !u || u === Ko.onSubmit,
  isOnBlur: u === Ko.onBlur,
  isOnChange: u === Ko.onChange,
  isOnAll: u === Ko.all,
  isOnTouch: u === Ko.onTouched
}), VS = (u, o, s) => !s && (o.watchAll || o.watch.has(u) || [...o.watch].some((d) => u.startsWith(d) && /^\.\w+/.test(u.slice(d.length))));
const em = (u, o, s, d) => {
  for (const h of s || Object.keys(u)) {
    const m = ge(u, h);
    if (m) {
      const { _f: g, ...k } = m;
      if (g) {
        if (g.refs && g.refs[0] && o(g.refs[0], h) && !d)
          return !0;
        if (g.ref && o(g.ref, g.name) && !d)
          return !0;
        if (em(k, o))
          break;
      } else if (Nn(k) && em(k, o))
        break;
    }
  }
};
var jL = (u, o, s) => {
  const d = Xh(ge(u, s));
  return Vt(d, "root", o[s]), Vt(u, s, d), u;
}, Xk = (u) => u.type === "file", Ai = (u) => typeof u == "function", zy = (u) => {
  if (!Kk)
    return !1;
  const o = u ? u.ownerDocument : 0;
  return u instanceof (o && o.defaultView ? o.defaultView.HTMLElement : HTMLElement);
}, Ly = (u) => Mi(u), ex = (u) => u.type === "radio", Iy = (u) => u instanceof RegExp;
const BS = {
  value: !1,
  isValid: !1
}, WS = { value: !0, isValid: !0 };
var BE = (u) => {
  if (Array.isArray(u)) {
    if (u.length > 1) {
      const o = u.filter((s) => s && s.checked && !s.disabled).map((s) => s.value);
      return { value: o, isValid: !!o.length };
    }
    return u[0].checked && !u[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      u[0].attributes && !Pn(u[0].attributes.value) ? Pn(u[0].value) || u[0].value === "" ? WS : { value: u[0].value, isValid: !0 } : WS
    ) : BS;
  }
  return BS;
};
const qS = {
  isValid: !1,
  value: null
};
var WE = (u) => Array.isArray(u) ? u.reduce((o, s) => s && s.checked && !s.disabled ? {
  isValid: !0,
  value: s.value
} : o, qS) : qS;
function HS(u, o, s = "validate") {
  if (Ly(u) || Array.isArray(u) && u.every(Ly) || go(u) && !u)
    return {
      type: s,
      message: Ly(u) ? u : "",
      ref: o
    };
}
var df = (u) => Nn(u) && !Iy(u) ? u : {
  value: u,
  message: ""
}, ZS = async (u, o, s, d, h, m) => {
  const { ref: g, refs: k, required: S, maxLength: E, minLength: R, min: P, max: O, pattern: M, validate: $, name: Z, valueAsNumber: G, mount: Pe } = u._f, re = ge(s, Z);
  if (!Pe || o.has(Z))
    return {};
  const ve = k ? k[0] : g, qe = (fe) => {
    h && ve.reportValidity && (ve.setCustomValidity(go(fe) ? "" : fe || ""), ve.reportValidity());
  }, Re = {}, ft = ex(g), Oe = ym(g), ye = ft || Oe, rt = (G || Xk(g)) && Pn(g.value) && Pn(re) || zy(g) && g.value === "" || re === "" || Array.isArray(re) && !re.length, st = VE.bind(null, Z, d, Re), Ie = (fe, Ae, Ke, et = Us.maxLength, _t = Us.minLength) => {
    const qt = fe ? Ae : Ke;
    Re[Z] = {
      type: fe ? et : _t,
      message: qt,
      ref: g,
      ...st(fe ? et : _t, qt)
    };
  };
  if (m ? !Array.isArray(re) || !re.length : S && (!ye && (rt || ra(re)) || go(re) && !re || Oe && !BE(k).isValid || ft && !WE(k).isValid)) {
    const { value: fe, message: Ae } = Ly(S) ? { value: !!S, message: S } : df(S);
    if (fe && (Re[Z] = {
      type: Us.required,
      message: Ae,
      ref: ve,
      ...st(Us.required, Ae)
    }, !d))
      return qe(Ae), Re;
  }
  if (!rt && (!ra(P) || !ra(O))) {
    let fe, Ae;
    const Ke = df(O), et = df(P);
    if (!ra(re) && !isNaN(re)) {
      const _t = g.valueAsNumber || re && +re;
      ra(Ke.value) || (fe = _t > Ke.value), ra(et.value) || (Ae = _t < et.value);
    } else {
      const _t = g.valueAsDate || new Date(re), qt = (pe) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + pe), ue = g.type == "time", ke = g.type == "week";
      Mi(Ke.value) && re && (fe = ue ? qt(re) > qt(Ke.value) : ke ? re > Ke.value : _t > new Date(Ke.value)), Mi(et.value) && re && (Ae = ue ? qt(re) < qt(et.value) : ke ? re < et.value : _t < new Date(et.value));
    }
    if ((fe || Ae) && (Ie(!!fe, Ke.message, et.message, Us.max, Us.min), !d))
      return qe(Re[Z].message), Re;
  }
  if ((E || R) && !rt && (Mi(re) || m && Array.isArray(re))) {
    const fe = df(E), Ae = df(R), Ke = !ra(fe.value) && re.length > +fe.value, et = !ra(Ae.value) && re.length < +Ae.value;
    if ((Ke || et) && (Ie(Ke, fe.message, Ae.message), !d))
      return qe(Re[Z].message), Re;
  }
  if (M && !rt && Mi(re)) {
    const { value: fe, message: Ae } = df(M);
    if (Iy(fe) && !re.match(fe) && (Re[Z] = {
      type: Us.pattern,
      message: Ae,
      ref: g,
      ...st(Us.pattern, Ae)
    }, !d))
      return qe(Ae), Re;
  }
  if ($) {
    if (Ai($)) {
      const fe = await $(re, s), Ae = HS(fe, ve);
      if (Ae && (Re[Z] = {
        ...Ae,
        ...st(Us.validate, Ae.message)
      }, !d))
        return qe(Ae.message), Re;
    } else if (Nn($)) {
      let fe = {};
      for (const Ae in $) {
        if (!Ca(fe) && !d)
          break;
        const Ke = HS(await $[Ae](re, s), ve, Ae);
        Ke && (fe = {
          ...Ke,
          ...st(Ae, Ke.message)
        }, qe(Ke.message), d && (Re[Z] = fe));
      }
      if (!Ca(fe) && (Re[Z] = {
        ref: ve,
        ...fe
      }, !d))
        return Re;
    }
  }
  return qe(!0), Re;
};
function UL(u, o) {
  const s = o.slice(0, -1).length;
  let d = 0;
  for (; d < s; )
    u = Pn(u) ? d++ : u[o[d++]];
  return u;
}
function VL(u) {
  for (const o in u)
    if (u.hasOwnProperty(o) && !Pn(u[o]))
      return !1;
  return !0;
}
function ar(u, o) {
  const s = Array.isArray(o) ? o : Yk(o) ? [o] : ME(o), d = s.length === 1 ? u : UL(u, s), h = s.length - 1, m = s[h];
  return d && delete d[m], h !== 0 && (Nn(d) && Ca(d) || Array.isArray(d) && VL(d)) && ar(u, s.slice(0, -1)), u;
}
var Ck = () => {
  let u = [];
  return {
    get observers() {
      return u;
    },
    next: (h) => {
      for (const m of u)
        m.next && m.next(h);
    },
    subscribe: (h) => (u.push(h), {
      unsubscribe: () => {
        u = u.filter((m) => m !== h);
      }
    }),
    unsubscribe: () => {
      u = [];
    }
  };
}, Ik = (u) => ra(u) || !zE(u);
function Ul(u, o) {
  if (Ik(u) || Ik(o))
    return u === o;
  if (ic(u) && ic(o))
    return u.getTime() === o.getTime();
  const s = Object.keys(u), d = Object.keys(o);
  if (s.length !== d.length)
    return !1;
  for (const h of s) {
    const m = u[h];
    if (!d.includes(h))
      return !1;
    if (h !== "ref") {
      const g = o[h];
      if (ic(m) && ic(g) || Nn(m) && Nn(g) || Array.isArray(m) && Array.isArray(g) ? !Ul(m, g) : m !== g)
        return !1;
    }
  }
  return !0;
}
var qE = (u) => u.type === "select-multiple", BL = (u) => ex(u) || ym(u), Tk = (u) => zy(u) && u.isConnected, HE = (u) => {
  for (const o in u)
    if (Ai(u[o]))
      return !0;
  return !1;
};
function Ay(u, o = {}) {
  const s = Array.isArray(u);
  if (Nn(u) || s)
    for (const d in u)
      Array.isArray(u[d]) || Nn(u[d]) && !HE(u[d]) ? (o[d] = Array.isArray(u[d]) ? [] : {}, Ay(u[d], o[d])) : ra(u[d]) || (o[d] = !0);
  return o;
}
function ZE(u, o, s) {
  const d = Array.isArray(u);
  if (Nn(u) || d)
    for (const h in u)
      Array.isArray(u[h]) || Nn(u[h]) && !HE(u[h]) ? Pn(o) || Ik(s[h]) ? s[h] = Array.isArray(u[h]) ? Ay(u[h], []) : { ...Ay(u[h]) } : ZE(u[h], ra(o) ? {} : o[h], s[h]) : s[h] = !Ul(u[h], o[h]);
  return s;
}
var Qh = (u, o) => ZE(u, o, Ay(o)), QE = (u, { valueAsNumber: o, valueAsDate: s, setValueAs: d }) => Pn(u) ? u : o ? u === "" ? NaN : u && +u : s && Mi(u) ? new Date(u) : d ? d(u) : u;
function Rk(u) {
  const o = u.ref;
  return Xk(o) ? o.files : ex(o) ? WE(u.refs).value : qE(o) ? [...o.selectedOptions].map(({ value: s }) => s) : ym(o) ? BE(u.refs).value : QE(Pn(o.value) ? u.ref.value : o.value, u);
}
var WL = (u, o, s, d) => {
  const h = {};
  for (const m of u) {
    const g = ge(o, m);
    g && Vt(h, m, g._f);
  }
  return {
    criteriaMode: s,
    names: [...u],
    fields: h,
    shouldUseNativeValidation: d
  };
}, Kh = (u) => Pn(u) ? u : Iy(u) ? u.source : Nn(u) ? Iy(u.value) ? u.value.source : u.value : u;
const QS = "AsyncFunction";
var qL = (u) => !!u && !!u.validate && !!(Ai(u.validate) && u.validate.constructor.name === QS || Nn(u.validate) && Object.values(u.validate).find((o) => o.constructor.name === QS)), HL = (u) => u.mount && (u.required || u.min || u.max || u.maxLength || u.minLength || u.pattern || u.validate);
function KS(u, o, s) {
  const d = ge(u, s);
  if (d || Yk(s))
    return {
      error: d,
      name: s
    };
  const h = s.split(".");
  for (; h.length; ) {
    const m = h.join("."), g = ge(o, m), k = ge(u, m);
    if (g && !Array.isArray(g) && s !== m)
      return { name: s };
    if (k && k.type)
      return {
        name: m,
        error: k
      };
    h.pop();
  }
  return {
    name: s
  };
}
var ZL = (u, o, s, d, h) => h.isOnAll ? !1 : !s && h.isOnTouch ? !(o || u) : (s ? d.isOnBlur : h.isOnBlur) ? !u : (s ? d.isOnChange : h.isOnChange) ? u : !0, QL = (u, o) => !Jy(ge(u, o)).length && ar(u, o);
const KL = {
  mode: Ko.onSubmit,
  reValidateMode: Ko.onChange,
  shouldFocusError: !0
};
function YL(u = {}) {
  let o = {
    ...KL,
    ...u
  }, s = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Ai(o.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: o.errors || {},
    disabled: o.disabled || !1
  }, d = {}, h = Nn(o.defaultValues) || Nn(o.values) ? Ea(o.defaultValues || o.values) || {} : {}, m = o.shouldUnregister ? {} : Ea(h), g = {
    action: !1,
    mount: !1,
    watch: !1
  }, k = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, S, E = 0;
  const R = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, P = {
    values: Ck(),
    array: Ck(),
    state: Ck()
  }, O = US(o.mode), M = US(o.reValidateMode), $ = o.criteriaMode === Ko.all, Z = (L) => (W) => {
    clearTimeout(E), E = setTimeout(L, W);
  }, G = async (L) => {
    if (!o.disabled && (R.isValid || L)) {
      const W = o.resolver ? Ca((await ye()).errors) : await st(d, !0);
      W !== s.isValid && P.state.next({
        isValid: W
      });
    }
  }, Pe = (L, W) => {
    !o.disabled && (R.isValidating || R.validatingFields) && ((L || Array.from(k.mount)).forEach((Q) => {
      Q && (W ? Vt(s.validatingFields, Q, W) : ar(s.validatingFields, Q));
    }), P.state.next({
      validatingFields: s.validatingFields,
      isValidating: !Ca(s.validatingFields)
    }));
  }, re = (L, W = [], Q, ce, de = !0, ae = !0) => {
    if (ce && Q && !o.disabled) {
      if (g.action = !0, ae && Array.isArray(ge(d, L))) {
        const Fe = Q(ge(d, L), ce.argA, ce.argB);
        de && Vt(d, L, Fe);
      }
      if (ae && Array.isArray(ge(s.errors, L))) {
        const Fe = Q(ge(s.errors, L), ce.argA, ce.argB);
        de && Vt(s.errors, L, Fe), QL(s.errors, L);
      }
      if (R.touchedFields && ae && Array.isArray(ge(s.touchedFields, L))) {
        const Fe = Q(ge(s.touchedFields, L), ce.argA, ce.argB);
        de && Vt(s.touchedFields, L, Fe);
      }
      R.dirtyFields && (s.dirtyFields = Qh(h, m)), P.state.next({
        name: L,
        isDirty: fe(L, W),
        dirtyFields: s.dirtyFields,
        errors: s.errors,
        isValid: s.isValid
      });
    } else
      Vt(m, L, W);
  }, ve = (L, W) => {
    Vt(s.errors, L, W), P.state.next({
      errors: s.errors
    });
  }, qe = (L) => {
    s.errors = L, P.state.next({
      errors: s.errors,
      isValid: !1
    });
  }, Re = (L, W, Q, ce) => {
    const de = ge(d, L);
    if (de) {
      const ae = ge(m, L, Pn(Q) ? ge(h, L) : Q);
      Pn(ae) || ce && ce.defaultChecked || W ? Vt(m, L, W ? ae : Rk(de._f)) : et(L, ae), g.mount && G();
    }
  }, ft = (L, W, Q, ce, de) => {
    let ae = !1, Fe = !1;
    const Ye = {
      name: L
    };
    if (!o.disabled) {
      const Mt = !!(ge(d, L) && ge(d, L)._f && ge(d, L)._f.disabled);
      if (!Q || ce) {
        R.isDirty && (Fe = s.isDirty, s.isDirty = Ye.isDirty = fe(), ae = Fe !== Ye.isDirty);
        const Zt = Mt || Ul(ge(h, L), W);
        Fe = !!(!Mt && ge(s.dirtyFields, L)), Zt || Mt ? ar(s.dirtyFields, L) : Vt(s.dirtyFields, L, !0), Ye.dirtyFields = s.dirtyFields, ae = ae || R.dirtyFields && Fe !== !Zt;
      }
      if (Q) {
        const Zt = ge(s.touchedFields, L);
        Zt || (Vt(s.touchedFields, L, Q), Ye.touchedFields = s.touchedFields, ae = ae || R.touchedFields && Zt !== Q);
      }
      ae && de && P.state.next(Ye);
    }
    return ae ? Ye : {};
  }, Oe = (L, W, Q, ce) => {
    const de = ge(s.errors, L), ae = R.isValid && go(W) && s.isValid !== W;
    if (o.delayError && Q ? (S = Z(() => ve(L, Q)), S(o.delayError)) : (clearTimeout(E), S = null, Q ? Vt(s.errors, L, Q) : ar(s.errors, L)), (Q ? !Ul(de, Q) : de) || !Ca(ce) || ae) {
      const Fe = {
        ...ce,
        ...ae && go(W) ? { isValid: W } : {},
        errors: s.errors,
        name: L
      };
      s = {
        ...s,
        ...Fe
      }, P.state.next(Fe);
    }
  }, ye = async (L) => {
    Pe(L, !0);
    const W = await o.resolver(m, o.context, WL(L || k.mount, d, o.criteriaMode, o.shouldUseNativeValidation));
    return Pe(L), W;
  }, rt = async (L) => {
    const { errors: W } = await ye(L);
    if (L)
      for (const Q of L) {
        const ce = ge(W, Q);
        ce ? Vt(s.errors, Q, ce) : ar(s.errors, Q);
      }
    else
      s.errors = W;
    return W;
  }, st = async (L, W, Q = {
    valid: !0
  }) => {
    for (const ce in L) {
      const de = L[ce];
      if (de) {
        const { _f: ae, ...Fe } = de;
        if (ae) {
          const Ye = k.array.has(ae.name), Mt = de._f && qL(de._f);
          Mt && R.validatingFields && Pe([ce], !0);
          const Zt = await ZS(de, k.disabled, m, $, o.shouldUseNativeValidation && !W, Ye);
          if (Mt && R.validatingFields && Pe([ce]), Zt[ae.name] && (Q.valid = !1, W))
            break;
          !W && (ge(Zt, ae.name) ? Ye ? jL(s.errors, Zt, ae.name) : Vt(s.errors, ae.name, Zt[ae.name]) : ar(s.errors, ae.name));
        }
        !Ca(Fe) && await st(Fe, W, Q);
      }
    }
    return Q.valid;
  }, Ie = () => {
    for (const L of k.unMount) {
      const W = ge(d, L);
      W && (W._f.refs ? W._f.refs.every((Q) => !Tk(Q)) : !Tk(W._f.ref)) && Ln(L);
    }
    k.unMount = /* @__PURE__ */ new Set();
  }, fe = (L, W) => !o.disabled && (L && W && Vt(m, L, W), !Ul(gt(), h)), Ae = (L, W, Q) => UE(L, k, {
    ...g.mount ? m : Pn(W) ? h : Mi(L) ? { [L]: W } : W
  }, Q, W), Ke = (L) => Jy(ge(g.mount ? m : h, L, o.shouldUnregister ? ge(h, L, []) : [])), et = (L, W, Q = {}) => {
    const ce = ge(d, L);
    let de = W;
    if (ce) {
      const ae = ce._f;
      ae && (!ae.disabled && Vt(m, L, QE(W, ae)), de = zy(ae.ref) && ra(W) ? "" : W, qE(ae.ref) ? [...ae.ref.options].forEach((Fe) => Fe.selected = de.includes(Fe.value)) : ae.refs ? ym(ae.ref) ? ae.refs.length > 1 ? ae.refs.forEach((Fe) => (!Fe.defaultChecked || !Fe.disabled) && (Fe.checked = Array.isArray(de) ? !!de.find((Ye) => Ye === Fe.value) : de === Fe.value)) : ae.refs[0] && (ae.refs[0].checked = !!de) : ae.refs.forEach((Fe) => Fe.checked = Fe.value === de) : Xk(ae.ref) ? ae.ref.value = "" : (ae.ref.value = de, ae.ref.type || P.values.next({
        name: L,
        values: { ...m }
      })));
    }
    (Q.shouldDirty || Q.shouldTouch) && ft(L, de, Q.shouldTouch, Q.shouldDirty, !0), Q.shouldValidate && pe(L);
  }, _t = (L, W, Q) => {
    for (const ce in W) {
      const de = W[ce], ae = `${L}.${ce}`, Fe = ge(d, ae);
      (k.array.has(L) || Nn(de) || Fe && !Fe._f) && !ic(de) ? _t(ae, de, Q) : et(ae, de, Q);
    }
  }, qt = (L, W, Q = {}) => {
    const ce = ge(d, L), de = k.array.has(L), ae = Ea(W);
    Vt(m, L, ae), de ? (P.array.next({
      name: L,
      values: { ...m }
    }), (R.isDirty || R.dirtyFields) && Q.shouldDirty && P.state.next({
      name: L,
      dirtyFields: Qh(h, m),
      isDirty: fe(L, ae)
    })) : ce && !ce._f && !ra(ae) ? _t(L, ae, Q) : et(L, ae, Q), VS(L, k) && P.state.next({ ...s }), P.values.next({
      name: g.mount ? L : void 0,
      values: { ...m }
    });
  }, ue = async (L) => {
    g.mount = !0;
    const W = L.target;
    let Q = W.name, ce = !0;
    const de = ge(d, Q), ae = () => W.type ? Rk(de._f) : IE(L), Fe = (Ye) => {
      ce = Number.isNaN(Ye) || ic(Ye) && isNaN(Ye.getTime()) || Ul(Ye, ge(m, Q, Ye));
    };
    if (de) {
      let Ye, Mt;
      const Zt = ae(), sr = L.type === Dy.BLUR || L.type === Dy.FOCUS_OUT, xe = !HL(de._f) && !o.resolver && !ge(s.errors, Q) && !de._f.deps || ZL(sr, ge(s.touchedFields, Q), s.isSubmitted, M, O), $e = VS(Q, k, sr);
      Vt(m, Q, Zt), sr ? (de._f.onBlur && de._f.onBlur(L), S && S(0)) : de._f.onChange && de._f.onChange(L);
      const lt = ft(Q, Zt, sr, !1), Ft = !Ca(lt) || $e;
      if (!sr && P.values.next({
        name: Q,
        type: L.type,
        values: { ...m }
      }), xe)
        return R.isValid && (o.mode === "onBlur" && sr ? G() : sr || G()), Ft && P.state.next({ name: Q, ...$e ? {} : lt });
      if (!sr && $e && P.state.next({ ...s }), o.resolver) {
        const { errors: Qt } = await ye([Q]);
        if (Fe(Zt), ce) {
          const Un = KS(s.errors, d, Q), hn = KS(Qt, d, Un.name || Q);
          Ye = hn.error, Q = hn.name, Mt = Ca(Qt);
        }
      } else
        Pe([Q], !0), Ye = (await ZS(de, k.disabled, m, $, o.shouldUseNativeValidation))[Q], Pe([Q]), Fe(Zt), ce && (Ye ? Mt = !1 : R.isValid && (Mt = await st(d, !0)));
      ce && (de._f.deps && pe(de._f.deps), Oe(Q, Mt, Ye, lt));
    }
  }, ke = (L, W) => {
    if (ge(s.errors, W) && L.focus)
      return L.focus(), 1;
  }, pe = async (L, W = {}) => {
    let Q, ce;
    const de = Xh(L);
    if (o.resolver) {
      const ae = await rt(Pn(L) ? L : de);
      Q = Ca(ae), ce = L ? !de.some((Fe) => ge(ae, Fe)) : Q;
    } else L ? (ce = (await Promise.all(de.map(async (ae) => {
      const Fe = ge(d, ae);
      return await st(Fe && Fe._f ? { [ae]: Fe } : Fe);
    }))).every(Boolean), !(!ce && !s.isValid) && G()) : ce = Q = await st(d);
    return P.state.next({
      ...!Mi(L) || R.isValid && Q !== s.isValid ? {} : { name: L },
      ...o.resolver || !L ? { isValid: Q } : {},
      errors: s.errors
    }), W.shouldFocus && !ce && em(d, ke, L ? de : k.mount), ce;
  }, gt = (L) => {
    const W = {
      ...g.mount ? m : h
    };
    return Pn(L) ? W : Mi(L) ? ge(W, L) : L.map((Q) => ge(W, Q));
  }, Ct = (L, W) => ({
    invalid: !!ge((W || s).errors, L),
    isDirty: !!ge((W || s).dirtyFields, L),
    error: ge((W || s).errors, L),
    isValidating: !!ge(s.validatingFields, L),
    isTouched: !!ge((W || s).touchedFields, L)
  }), or = (L) => {
    L && Xh(L).forEach((W) => ar(s.errors, W)), P.state.next({
      errors: L ? s.errors : {}
    });
  }, On = (L, W, Q) => {
    const ce = (ge(d, L, { _f: {} })._f || {}).ref, de = ge(s.errors, L) || {}, { ref: ae, message: Fe, type: Ye, ...Mt } = de;
    Vt(s.errors, L, {
      ...Mt,
      ...W,
      ref: ce
    }), P.state.next({
      name: L,
      errors: s.errors,
      isValid: !1
    }), Q && Q.shouldFocus && ce && ce.focus && ce.focus();
  }, vo = (L, W) => Ai(L) ? P.values.subscribe({
    next: (Q) => L(Ae(void 0, W), Q)
  }) : Ae(L, W, !0), Ln = (L, W = {}) => {
    for (const Q of L ? Xh(L) : k.mount)
      k.mount.delete(Q), k.array.delete(Q), W.keepValue || (ar(d, Q), ar(m, Q)), !W.keepError && ar(s.errors, Q), !W.keepDirty && ar(s.dirtyFields, Q), !W.keepTouched && ar(s.touchedFields, Q), !W.keepIsValidating && ar(s.validatingFields, Q), !o.shouldUnregister && !W.keepDefaultValue && ar(h, Q);
    P.values.next({
      values: { ...m }
    }), P.state.next({
      ...s,
      ...W.keepDirty ? { isDirty: fe() } : {}
    }), !W.keepIsValid && G();
  }, $n = ({ disabled: L, name: W, field: Q, fields: ce }) => {
    (go(L) && g.mount || L || k.disabled.has(W)) && (L ? k.disabled.add(W) : k.disabled.delete(W), ft(W, Rk(Q ? Q._f : ge(ce, W)._f), !1, !1, !0));
  }, ir = (L, W = {}) => {
    let Q = ge(d, L);
    const ce = go(W.disabled) || go(o.disabled);
    return Vt(d, L, {
      ...Q || {},
      _f: {
        ...Q && Q._f ? Q._f : { ref: { name: L } },
        name: L,
        mount: !0,
        ...W
      }
    }), k.mount.add(L), Q ? $n({
      field: Q,
      disabled: go(W.disabled) ? W.disabled : o.disabled,
      name: L
    }) : Re(L, !0, W.value), {
      ...ce ? { disabled: W.disabled || o.disabled } : {},
      ...o.progressive ? {
        required: !!W.required,
        min: Kh(W.min),
        max: Kh(W.max),
        minLength: Kh(W.minLength),
        maxLength: Kh(W.maxLength),
        pattern: Kh(W.pattern)
      } : {},
      name: L,
      onChange: ue,
      onBlur: ue,
      ref: (de) => {
        if (de) {
          ir(L, W), Q = ge(d, L);
          const ae = Pn(de.value) && de.querySelectorAll && de.querySelectorAll("input,select,textarea")[0] || de, Fe = BL(ae), Ye = Q._f.refs || [];
          if (Fe ? Ye.find((Mt) => Mt === ae) : ae === Q._f.ref)
            return;
          Vt(d, L, {
            _f: {
              ...Q._f,
              ...Fe ? {
                refs: [
                  ...Ye.filter(Tk),
                  ae,
                  ...Array.isArray(ge(h, L)) ? [{}] : []
                ],
                ref: { type: ae.type, name: L }
              } : { ref: ae }
            }
          }), Re(L, !1, void 0, ae);
        } else
          Q = ge(d, L, {}), Q._f && (Q._f.mount = !1), (o.shouldUnregister || W.shouldUnregister) && !(AE(k.array, L) && g.action) && k.unMount.add(L);
      }
    };
  }, Br = () => o.shouldFocusError && em(d, ke, k.mount), Ha = (L) => {
    go(L) && (P.state.next({ disabled: L }), em(d, (W, Q) => {
      const ce = ge(d, Q);
      ce && (W.disabled = ce._f.disabled || L, Array.isArray(ce._f.refs) && ce._f.refs.forEach((de) => {
        de.disabled = ce._f.disabled || L;
      }));
    }, 0, !1));
  }, kn = (L, W) => async (Q) => {
    let ce;
    Q && (Q.preventDefault && Q.preventDefault(), Q.persist && Q.persist());
    let de = Ea(m);
    if (k.disabled.size)
      for (const ae of k.disabled)
        Vt(de, ae, void 0);
    if (P.state.next({
      isSubmitting: !0
    }), o.resolver) {
      const { errors: ae, values: Fe } = await ye();
      s.errors = ae, de = Fe;
    } else
      await st(d);
    if (ar(s.errors, "root"), Ca(s.errors)) {
      P.state.next({
        errors: {}
      });
      try {
        await L(de, Q);
      } catch (ae) {
        ce = ae;
      }
    } else
      W && await W({ ...s.errors }, Q), Br(), setTimeout(Br);
    if (P.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Ca(s.errors) && !ce,
      submitCount: s.submitCount + 1,
      errors: s.errors
    }), ce)
      throw ce;
  }, pr = (L, W = {}) => {
    ge(d, L) && (Pn(W.defaultValue) ? qt(L, Ea(ge(h, L))) : (qt(L, W.defaultValue), Vt(h, L, Ea(W.defaultValue))), W.keepTouched || ar(s.touchedFields, L), W.keepDirty || (ar(s.dirtyFields, L), s.isDirty = W.defaultValue ? fe(L, Ea(ge(h, L))) : fe()), W.keepError || (ar(s.errors, L), R.isValid && G()), P.state.next({ ...s }));
  }, jn = (L, W = {}) => {
    const Q = L ? Ea(L) : h, ce = Ea(Q), de = Ca(L), ae = de ? h : ce;
    if (W.keepDefaultValues || (h = Q), !W.keepValues) {
      if (W.keepDirtyValues) {
        const Fe = /* @__PURE__ */ new Set([
          ...k.mount,
          ...Object.keys(Qh(h, m))
        ]);
        for (const Ye of Array.from(Fe))
          ge(s.dirtyFields, Ye) ? Vt(ae, Ye, ge(m, Ye)) : qt(Ye, ge(ae, Ye));
      } else {
        if (Kk && Pn(L))
          for (const Fe of k.mount) {
            const Ye = ge(d, Fe);
            if (Ye && Ye._f) {
              const Mt = Array.isArray(Ye._f.refs) ? Ye._f.refs[0] : Ye._f.ref;
              if (zy(Mt)) {
                const Zt = Mt.closest("form");
                if (Zt) {
                  Zt.reset();
                  break;
                }
              }
            }
          }
        d = {};
      }
      m = o.shouldUnregister ? W.keepDefaultValues ? Ea(h) : {} : Ea(ae), P.array.next({
        values: { ...ae }
      }), P.values.next({
        values: { ...ae }
      });
    }
    k = {
      mount: W.keepDirtyValues ? k.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, g.mount = !R.isValid || !!W.keepIsValid || !!W.keepDirtyValues, g.watch = !!o.shouldUnregister, P.state.next({
      submitCount: W.keepSubmitCount ? s.submitCount : 0,
      isDirty: de ? !1 : W.keepDirty ? s.isDirty : !!(W.keepDefaultValues && !Ul(L, h)),
      isSubmitted: W.keepIsSubmitted ? s.isSubmitted : !1,
      dirtyFields: de ? {} : W.keepDirtyValues ? W.keepDefaultValues && m ? Qh(h, m) : s.dirtyFields : W.keepDefaultValues && L ? Qh(h, L) : W.keepDirty ? s.dirtyFields : {},
      touchedFields: W.keepTouched ? s.touchedFields : {},
      errors: W.keepErrors ? s.errors : {},
      isSubmitSuccessful: W.keepIsSubmitSuccessful ? s.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, hr = (L, W) => jn(Ai(L) ? L(m) : L, W);
  return {
    control: {
      register: ir,
      unregister: Ln,
      getFieldState: Ct,
      handleSubmit: kn,
      setError: On,
      _executeSchema: ye,
      _getWatch: Ae,
      _getDirty: fe,
      _updateValid: G,
      _removeUnmounted: Ie,
      _updateFieldArray: re,
      _updateDisabledField: $n,
      _getFieldArray: Ke,
      _reset: jn,
      _resetDefaultValues: () => Ai(o.defaultValues) && o.defaultValues().then((L) => {
        hr(L, o.resetOptions), P.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (L) => {
        s = {
          ...s,
          ...L
        };
      },
      _disableForm: Ha,
      _subjects: P,
      _proxyFormState: R,
      _setErrors: qe,
      get _fields() {
        return d;
      },
      get _formValues() {
        return m;
      },
      get _state() {
        return g;
      },
      set _state(L) {
        g = L;
      },
      get _defaultValues() {
        return h;
      },
      get _names() {
        return k;
      },
      set _names(L) {
        k = L;
      },
      get _formState() {
        return s;
      },
      set _formState(L) {
        s = L;
      },
      get _options() {
        return o;
      },
      set _options(L) {
        o = {
          ...o,
          ...L
        };
      }
    },
    trigger: pe,
    register: ir,
    handleSubmit: kn,
    watch: vo,
    setValue: qt,
    getValues: gt,
    reset: hr,
    resetField: pr,
    clearErrors: or,
    unregister: Ln,
    setError: On,
    setFocus: (L, W = {}) => {
      const Q = ge(d, L), ce = Q && Q._f;
      if (ce) {
        const de = ce.refs ? ce.refs[0] : ce.ref;
        de.focus && (de.focus(), W.shouldSelect && Ai(de.select) && de.select());
      }
    },
    getFieldState: Ct
  };
}
function GL(u = {}) {
  const o = xt.useRef(void 0), s = xt.useRef(void 0), [d, h] = xt.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Ai(u.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: u.errors || {},
    disabled: u.disabled || !1,
    defaultValues: Ai(u.defaultValues) ? void 0 : u.defaultValues
  });
  o.current || (o.current = {
    ...YL(u),
    formState: d
  });
  const m = o.current.control;
  return m._options = u, Jk({
    subject: m._subjects.state,
    next: (g) => {
      $E(g, m._proxyFormState, m._updateFormState, !0) && h({ ...m._formState });
    }
  }), xt.useEffect(() => m._disableForm(u.disabled), [m, u.disabled]), xt.useEffect(() => {
    if (m._proxyFormState.isDirty) {
      const g = m._getDirty();
      g !== d.isDirty && m._subjects.state.next({
        isDirty: g
      });
    }
  }, [m, d.isDirty]), xt.useEffect(() => {
    u.values && !Ul(u.values, s.current) ? (m._reset(u.values, m._options.resetOptions), s.current = u.values, h((g) => ({ ...g }))) : m._resetDefaultValues();
  }, [u.values, m]), xt.useEffect(() => {
    u.errors && m._setErrors(u.errors);
  }, [u.errors, m]), xt.useEffect(() => {
    m._state.mount || (m._updateValid(), m._state.mount = !0), m._state.watch && (m._state.watch = !1, m._subjects.state.next({ ...m._formState })), m._removeUnmounted();
  }), xt.useEffect(() => {
    u.shouldUnregister && m._subjects.values.next({
      values: m._getWatch()
    });
  }, [u.shouldUnregister, m]), o.current.formState = FE(d, m), o.current;
}
const JL = (u, o, s, d) => {
  var m, g, k, S;
  const h = [s, {
    code: o,
    ...d || {}
  }];
  if ((g = (m = u == null ? void 0 : u.services) == null ? void 0 : m.logger) != null && g.forward)
    return u.services.logger.forward(h, "warn", "react-i18next::", !0);
  sc(h[0]) && (h[0] = `react-i18next:: ${h[0]}`), (S = (k = u == null ? void 0 : u.services) == null ? void 0 : k.logger) != null && S.warn ? u.services.logger.warn(...h) : console != null && console.warn && console.warn(...h);
}, YS = {}, Ak = (u, o, s, d) => {
  sc(s) && YS[s] || (sc(s) && (YS[s] = /* @__PURE__ */ new Date()), JL(u, o, s, d));
}, KE = (u, o) => () => {
  if (u.isInitialized)
    o();
  else {
    const s = () => {
      setTimeout(() => {
        u.off("initialized", s);
      }, 0), o();
    };
    u.on("initialized", s);
  }
}, Mk = (u, o, s) => {
  u.loadNamespaces(o, KE(u, s));
}, GS = (u, o, s, d) => {
  if (sc(s) && (s = [s]), u.options.preload && u.options.preload.indexOf(o) > -1) return Mk(u, s, d);
  s.forEach((h) => {
    u.options.ns.indexOf(h) < 0 && u.options.ns.push(h);
  }), u.loadLanguages(o, KE(u, d));
}, XL = (u, o, s = {}) => !o.languages || !o.languages.length ? (Ak(o, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: o.languages
}), !0) : o.hasLoadedNamespace(u, {
  lng: s.lng,
  precheck: (d, h) => {
    var m;
    if (((m = s.bindI18n) == null ? void 0 : m.indexOf("languageChanging")) > -1 && d.services.backendConnector.backend && d.isLanguageChangingTo && !h(d.isLanguageChangingTo, u)) return !1;
  }
}), sc = (u) => typeof u == "string", eD = (u) => typeof u == "object" && u !== null, tD = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, nD = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, rD = (u) => nD[u], aD = (u) => u.replace(tD, rD);
let oD = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: aD
};
const iD = () => oD;
let sD;
const lD = () => sD, YE = PE();
class uD {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(o) {
    o.forEach((s) => {
      this.usedNamespaces[s] || (this.usedNamespaces[s] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const cD = (u, o) => {
  const s = OE();
  return nm(() => {
    s.current = u;
  }, [u, o]), s.current;
}, GE = (u, o, s, d) => u.getFixedT(o, s, d), dD = (u, o, s, d) => NL(GE(u, o, s, d), [u, o, s, d]), tx = (u, o = {}) => {
  var qe, Re, ft, Oe;
  const {
    i18n: s
  } = o, {
    i18n: d,
    defaultNS: h
  } = NE(YE) || {}, m = s || d || lD();
  if (m && !m.reportNamespaces && (m.reportNamespaces = new uD()), !m) {
    Ak(m, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const ye = (st, Ie) => sc(Ie) ? Ie : eD(Ie) && sc(Ie.defaultValue) ? Ie.defaultValue : Array.isArray(st) ? st[st.length - 1] : st, rt = [ye, {}, !1];
    return rt.t = ye, rt.i18n = {}, rt.ready = !1, rt;
  }
  (qe = m.options.react) != null && qe.wait && Ak(m, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const g = {
    ...iD(),
    ...m.options.react,
    ...o
  }, {
    useSuspense: k,
    keyPrefix: S
  } = g;
  let E = u || h || ((Re = m.options) == null ? void 0 : Re.defaultNS);
  E = sc(E) ? [E] : E || ["translation"], (Oe = (ft = m.reportNamespaces).addUsedNamespaces) == null || Oe.call(ft, E);
  const R = (m.isInitialized || m.initializedStoreOnce) && E.every((ye) => XL(ye, m, g)), P = dD(m, o.lng || null, g.nsMode === "fallback" ? E : E[0], S), O = () => P, M = () => GE(m, o.lng || null, g.nsMode === "fallback" ? E : E[0], S), [$, Z] = Vl(O);
  let G = E.join();
  o.lng && (G = `${o.lng}${G}`);
  const Pe = cD(G), re = OE(!0);
  nm(() => {
    const {
      bindI18n: ye,
      bindI18nStore: rt
    } = g;
    re.current = !0, !R && !k && (o.lng ? GS(m, o.lng, E, () => {
      re.current && Z(M);
    }) : Mk(m, E, () => {
      re.current && Z(M);
    })), R && Pe && Pe !== G && re.current && Z(M);
    const st = () => {
      re.current && Z(M);
    };
    return ye && (m == null || m.on(ye, st)), rt && (m == null || m.store.on(rt, st)), () => {
      re.current = !1, m && (ye == null || ye.split(" ").forEach((Ie) => m.off(Ie, st))), rt && m && rt.split(" ").forEach((Ie) => m.store.off(Ie, st));
    };
  }, [m, G]), nm(() => {
    re.current && R && Z(O);
  }, [m, S, R]);
  const ve = [$, m, R];
  if (ve.t = $, ve.i18n = m, ve.ready = R, R || !R && !k) return ve;
  throw new Promise((ye) => {
    o.lng ? GS(m, o.lng, E, () => ye()) : Mk(m, E, () => ye());
  });
};
function fD({
  i18n: u,
  defaultNS: o,
  children: s
}) {
  const d = LE(() => ({
    i18n: u,
    defaultNS: o
  }), [u, o]);
  return OL(YE.Provider, {
    value: d
  }, s);
}
function JE(u) {
  var o, s, d = "";
  if (typeof u == "string" || typeof u == "number") d += u;
  else if (typeof u == "object") if (Array.isArray(u)) {
    var h = u.length;
    for (o = 0; o < h; o++) u[o] && (s = JE(u[o])) && (d && (d += " "), d += s);
  } else for (s in u) u[s] && (d && (d += " "), d += s);
  return d;
}
function Fn() {
  for (var u, o, s = 0, d = "", h = arguments.length; s < h; s++) (u = arguments[s]) && (o = JE(u)) && (d && (d += " "), d += o);
  return d;
}
const pD = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook-path1",
  "icon_facebook-path2",
  "icon_gmail-path1",
  "icon_gmail-path2",
  "icon_gmail-path3",
  "icon_gmail-path4",
  "icon_gmail-path5",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], hD = pD.map((u) => ({
  name: u,
  class: `icon-${u}`
})), mD = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, gD = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl"
};
function vD(u = 0) {
  const o = [];
  for (let s = 0; s < u; s++)
    o[s] = `path${s + 1}`;
  return o.map((s) => /* @__PURE__ */ le("span", { className: s }, s));
}
const kf = Qk(
  ({ name: u, size: o = "medium", color: s = "base", className: d = "", ...h }, m) => {
    const g = hD.find((S) => S.name === u), k = Fn("icon", `ds-${g == null ? void 0 : g.class}`, gD[o], mD[s], d);
    return /* @__PURE__ */ le("i", { className: k, ...h, ref: m, children: vD(g == null ? void 0 : g.transform) });
  }
);
kf.displayName = "Icon";
const yD = "_loader_1ksyv_29", bD = "_circle_1ksyv_41", ff = {
  loader: yD,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: bD,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, _D = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, wD = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function kD({ onDark: u, size: o = "medium", color: s = "primary", className: d }) {
  return /* @__PURE__ */ tn(
    "svg",
    {
      className: Fn(
        ff.loader,
        ff[_D[o]],
        ff[wD[s]],
        u && ff["on-dark"],
        d
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ le("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ le("circle", { className: ff.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ tn(
          "circle",
          {
            className: ff["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ le("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ le(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const xD = "_button_pocty_29", SD = "_disabled_pocty_43", ED = "_loader_pocty_263", Vs = {
  button: xD,
  disabled: SD,
  "is-primary": "_is-primary_pocty_51",
  "is-contrasted": "_is-contrasted_pocty_65",
  "is-secondary": "_is-secondary_pocty_74",
  "is-tertiary": "_is-tertiary_pocty_97",
  "is-eco-green": "_is-eco-green_pocty_120",
  "is-ghost": "_is-ghost_pocty_134",
  "is-destructive": "_is-destructive_pocty_157",
  "is-hollow": "_is-hollow_pocty_171",
  "is-destructive-ghost": "_is-destructive-ghost_pocty_189",
  "is-facebook": "_is-facebook_pocty_203",
  "is-apple": "_is-apple_pocty_217",
  "is-google": "_is-google_pocty_231",
  "is-regular": "_is-regular_pocty_245",
  "is-medium": "_is-medium_pocty_248",
  "is-small": "_is-small_pocty_251",
  "is-full-width": "_is-full-width_pocty_254",
  "is-loading": "_is-loading_pocty_257",
  loader: ED,
  "dialog-overlay-show": "_dialog-overlay-show_pocty_1",
  "dialog-content-show": "_dialog-content-show_pocty_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_pocty_1"
}, rm = Qk(
  ({
    color: u = "primary",
    text: o,
    size: s = "regular",
    isFullWidth: d = !1,
    icon: h,
    iconPosition: m = "left",
    iconSize: g,
    onClick: k,
    children: S,
    disabled: E,
    type: R = "button",
    className: P = "",
    href: O,
    isLoading: M,
    isContrasted: $ = !1,
    ...Z
  }, G) => {
    const Pe = Fn(
      Vs.button,
      Vs[CD[u]],
      Vs[TD[s]],
      d && Vs["is-full-width"],
      E && Vs.disabled,
      m === "right" && Vs["has-icon-right"],
      $ && Vs["is-contrasted"],
      M && Vs["is-loading"],
      P
    ), re = /* @__PURE__ */ tn(RE, { children: [
      M && /* @__PURE__ */ le(kD, { className: Vs.loader, onDark: !0, size: "small" }),
      h && m === "left" && /* @__PURE__ */ le(kf, { color: "inherit", size: g, name: h }),
      S ?? o,
      h && m === "right" && /* @__PURE__ */ le(kf, { color: "inherit", size: g, name: h })
    ] }), ve = {
      onClick: k,
      className: Pe,
      ...Z
    };
    return O ? /* @__PURE__ */ le("a", { href: E ? void 0 : O, ref: G, ...ve, children: re }) : /* @__PURE__ */ le(
      "button",
      {
        ref: G,
        disabled: M || E,
        type: R,
        ...ve,
        children: re
      }
    );
  }
);
rm.displayName = "Button";
const CD = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, TD = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
}, RD = "_buttons_rhll9_29", JS = {
  buttons: RD,
  "flex-grow-buttons": "_flex-grow-buttons_rhll9_44"
}, XE = ({ children: u, flexGrowButtons: o }) => /* @__PURE__ */ le("div", { className: Fn(JS.buttons, o && JS["flex-grow-buttons"]), children: u }), PD = "_text_1i6g5_29", pf = {
  text: PD,
  "is-small": "_is-small_1i6g5_34",
  "is-ellipsis": "_is-ellipsis_1i6g5_38",
  "color-primary": "_color-primary_1i6g5_43",
  "color-secondary": "_color-secondary_1i6g5_46",
  "color-tertiary": "_color-tertiary_1i6g5_49",
  "color-eco-green": "_color-eco-green_1i6g5_52",
  "color-success": "_color-success_1i6g5_55",
  "color-error": "_color-error_1i6g5_58",
  "color-inverted": "_color-inverted_1i6g5_61",
  "is-bold": "_is-bold_1i6g5_64",
  "size-xs": "_size-xs_1i6g5_67",
  "size-sm": "_size-sm_1i6g5_70",
  "size-base": "_size-base_1i6g5_73",
  "size-lg": "_size-lg_1i6g5_76",
  "size-xl": "_size-xl_1i6g5_79",
  "dialog-overlay-show": "_dialog-overlay-show_1i6g5_1",
  "dialog-content-show": "_dialog-content-show_1i6g5_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1i6g5_1"
};
function Fk({
  children: u,
  dangerouslySetInnerHTML: o,
  isSmall: s,
  ellipsis: d,
  isSpan: h,
  className: m = "",
  color: g,
  isBold: k,
  size: S,
  ...E
}) {
  const R = Fn(
    pf.text,
    s && pf["is-small"],
    d && pf["is-ellipsis"],
    g && pf[`color-${g}`],
    k && pf["is-bold"],
    S && pf[`size-${S}`],
    m
  ), P = h ? "span" : "div";
  return o ? /* @__PURE__ */ le(P, { className: R, dangerouslySetInnerHTML: o, ...E }) : /* @__PURE__ */ le(P, { className: R, ...E, children: u });
}
function qs(u, o, { checkForDefaultPrevented: s = !0 } = {}) {
  return function(d) {
    if (u == null || u(d), s === !1 || !d.defaultPrevented)
      return o == null ? void 0 : o(d);
  };
}
var My = globalThis != null && globalThis.document ? Te.useLayoutEffect : () => {
};
function nx(u) {
  const o = Te.useRef(u);
  return Te.useEffect(() => {
    o.current = u;
  }), Te.useMemo(() => (...s) => {
    var d;
    return (d = o.current) == null ? void 0 : d.call(o, ...s);
  }, []);
}
function eC({
  prop: u,
  defaultProp: o,
  onChange: s = () => {
  }
}) {
  const [d, h] = ND({ defaultProp: o, onChange: s }), m = u !== void 0, g = m ? u : d, k = nx(s), S = Te.useCallback(
    (E) => {
      if (m) {
        const R = typeof E == "function" ? E(u) : E;
        R !== u && k(R);
      } else
        h(E);
    },
    [m, u, h, k]
  );
  return [g, S];
}
function ND({
  defaultProp: u,
  onChange: o
}) {
  const s = Te.useState(u), [d] = s, h = Te.useRef(d), m = nx(o);
  return Te.useEffect(() => {
    h.current !== d && (m(d), h.current = d);
  }, [d, h, m]), s;
}
function XS(u, o) {
  if (typeof u == "function")
    return u(o);
  u != null && (u.current = o);
}
function tC(...u) {
  return (o) => {
    let s = !1;
    const d = u.map((h) => {
      const m = XS(h, o);
      return !s && typeof m == "function" && (s = !0), m;
    });
    if (s)
      return () => {
        for (let h = 0; h < d.length; h++) {
          const m = d[h];
          typeof m == "function" ? m() : XS(u[h], null);
        }
      };
  };
}
function xf(...u) {
  return Te.useCallback(tC(...u), u);
}
function Xy(u, o = []) {
  let s = [];
  function d(m, g) {
    const k = Te.createContext(g), S = s.length;
    s = [...s, g];
    const E = (P) => {
      var O;
      const { scope: M, children: $, ...Z } = P, G = ((O = M == null ? void 0 : M[u]) == null ? void 0 : O[S]) || k, Pe = Te.useMemo(() => Z, Object.values(Z));
      return /* @__PURE__ */ le(G.Provider, { value: Pe, children: $ });
    };
    E.displayName = m + "Provider";
    function R(P, O) {
      var M;
      const $ = ((M = O == null ? void 0 : O[u]) == null ? void 0 : M[S]) || k, Z = Te.useContext($);
      if (Z) return Z;
      if (g !== void 0) return g;
      throw new Error(`\`${P}\` must be used within \`${m}\``);
    }
    return [E, R];
  }
  const h = () => {
    const m = s.map((g) => Te.createContext(g));
    return function(g) {
      const k = (g == null ? void 0 : g[u]) || m;
      return Te.useMemo(
        () => ({ [`__scope${u}`]: { ...g, [u]: k } }),
        [g, k]
      );
    };
  };
  return h.scopeName = u, [d, OD(h, ...o)];
}
function OD(...u) {
  const o = u[0];
  if (u.length === 1) return o;
  const s = () => {
    const d = u.map((h) => ({
      useScope: h(),
      scopeName: h.scopeName
    }));
    return function(h) {
      const m = d.reduce((g, { useScope: k, scopeName: S }) => {
        const E = k(h)[`__scope${S}`];
        return { ...g, ...E };
      }, {});
      return Te.useMemo(() => ({ [`__scope${o.scopeName}`]: m }), [m]);
    };
  };
  return s.scopeName = o.scopeName, s;
}
var Ty = { exports: {} }, Sa = {}, Pk = { exports: {} }, eE = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tE;
function LD() {
  return tE || (tE = 1, function(u) {
    function o(ue, ke) {
      var pe = ue.length;
      ue.push(ke);
      e: for (; 0 < pe; ) {
        var gt = pe - 1 >>> 1, Ct = ue[gt];
        if (0 < h(Ct, ke)) ue[gt] = ke, ue[pe] = Ct, pe = gt;
        else break e;
      }
    }
    function s(ue) {
      return ue.length === 0 ? null : ue[0];
    }
    function d(ue) {
      if (ue.length === 0) return null;
      var ke = ue[0], pe = ue.pop();
      if (pe !== ke) {
        ue[0] = pe;
        e: for (var gt = 0, Ct = ue.length, or = Ct >>> 1; gt < or; ) {
          var On = 2 * (gt + 1) - 1, vo = ue[On], Ln = On + 1, $n = ue[Ln];
          if (0 > h(vo, pe)) Ln < Ct && 0 > h($n, vo) ? (ue[gt] = $n, ue[Ln] = pe, gt = Ln) : (ue[gt] = vo, ue[On] = pe, gt = On);
          else if (Ln < Ct && 0 > h($n, pe)) ue[gt] = $n, ue[Ln] = pe, gt = Ln;
          else break e;
        }
      }
      return ke;
    }
    function h(ue, ke) {
      var pe = ue.sortIndex - ke.sortIndex;
      return pe !== 0 ? pe : ue.id - ke.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var m = performance;
      u.unstable_now = function() {
        return m.now();
      };
    } else {
      var g = Date, k = g.now();
      u.unstable_now = function() {
        return g.now() - k;
      };
    }
    var S = [], E = [], R = 1, P = null, O = 3, M = !1, $ = !1, Z = !1, G = typeof setTimeout == "function" ? setTimeout : null, Pe = typeof clearTimeout == "function" ? clearTimeout : null, re = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function ve(ue) {
      for (var ke = s(E); ke !== null; ) {
        if (ke.callback === null) d(E);
        else if (ke.startTime <= ue) d(E), ke.sortIndex = ke.expirationTime, o(S, ke);
        else break;
        ke = s(E);
      }
    }
    function qe(ue) {
      if (Z = !1, ve(ue), !$) if (s(S) !== null) $ = !0, _t(Re);
      else {
        var ke = s(E);
        ke !== null && qt(qe, ke.startTime - ue);
      }
    }
    function Re(ue, ke) {
      $ = !1, Z && (Z = !1, Pe(ye), ye = -1), M = !0;
      var pe = O;
      try {
        for (ve(ke), P = s(S); P !== null && (!(P.expirationTime > ke) || ue && !Ie()); ) {
          var gt = P.callback;
          if (typeof gt == "function") {
            P.callback = null, O = P.priorityLevel;
            var Ct = gt(P.expirationTime <= ke);
            ke = u.unstable_now(), typeof Ct == "function" ? P.callback = Ct : P === s(S) && d(S), ve(ke);
          } else d(S);
          P = s(S);
        }
        if (P !== null) var or = !0;
        else {
          var On = s(E);
          On !== null && qt(qe, On.startTime - ke), or = !1;
        }
        return or;
      } finally {
        P = null, O = pe, M = !1;
      }
    }
    var ft = !1, Oe = null, ye = -1, rt = 5, st = -1;
    function Ie() {
      return !(u.unstable_now() - st < rt);
    }
    function fe() {
      if (Oe !== null) {
        var ue = u.unstable_now();
        st = ue;
        var ke = !0;
        try {
          ke = Oe(!0, ue);
        } finally {
          ke ? Ae() : (ft = !1, Oe = null);
        }
      } else ft = !1;
    }
    var Ae;
    if (typeof re == "function") Ae = function() {
      re(fe);
    };
    else if (typeof MessageChannel < "u") {
      var Ke = new MessageChannel(), et = Ke.port2;
      Ke.port1.onmessage = fe, Ae = function() {
        et.postMessage(null);
      };
    } else Ae = function() {
      G(fe, 0);
    };
    function _t(ue) {
      Oe = ue, ft || (ft = !0, Ae());
    }
    function qt(ue, ke) {
      ye = G(function() {
        ue(u.unstable_now());
      }, ke);
    }
    u.unstable_IdlePriority = 5, u.unstable_ImmediatePriority = 1, u.unstable_LowPriority = 4, u.unstable_NormalPriority = 3, u.unstable_Profiling = null, u.unstable_UserBlockingPriority = 2, u.unstable_cancelCallback = function(ue) {
      ue.callback = null;
    }, u.unstable_continueExecution = function() {
      $ || M || ($ = !0, _t(Re));
    }, u.unstable_forceFrameRate = function(ue) {
      0 > ue || 125 < ue ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : rt = 0 < ue ? Math.floor(1e3 / ue) : 5;
    }, u.unstable_getCurrentPriorityLevel = function() {
      return O;
    }, u.unstable_getFirstCallbackNode = function() {
      return s(S);
    }, u.unstable_next = function(ue) {
      switch (O) {
        case 1:
        case 2:
        case 3:
          var ke = 3;
          break;
        default:
          ke = O;
      }
      var pe = O;
      O = ke;
      try {
        return ue();
      } finally {
        O = pe;
      }
    }, u.unstable_pauseExecution = function() {
    }, u.unstable_requestPaint = function() {
    }, u.unstable_runWithPriority = function(ue, ke) {
      switch (ue) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          ue = 3;
      }
      var pe = O;
      O = ue;
      try {
        return ke();
      } finally {
        O = pe;
      }
    }, u.unstable_scheduleCallback = function(ue, ke, pe) {
      var gt = u.unstable_now();
      switch (typeof pe == "object" && pe !== null ? (pe = pe.delay, pe = typeof pe == "number" && 0 < pe ? gt + pe : gt) : pe = gt, ue) {
        case 1:
          var Ct = -1;
          break;
        case 2:
          Ct = 250;
          break;
        case 5:
          Ct = 1073741823;
          break;
        case 4:
          Ct = 1e4;
          break;
        default:
          Ct = 5e3;
      }
      return Ct = pe + Ct, ue = { id: R++, callback: ke, priorityLevel: ue, startTime: pe, expirationTime: Ct, sortIndex: -1 }, pe > gt ? (ue.sortIndex = pe, o(E, ue), s(S) === null && ue === s(E) && (Z ? (Pe(ye), ye = -1) : Z = !0, qt(qe, pe - gt))) : (ue.sortIndex = Ct, o(S, ue), $ || M || ($ = !0, _t(Re))), ue;
    }, u.unstable_shouldYield = Ie, u.unstable_wrapCallback = function(ue) {
      var ke = O;
      return function() {
        var pe = O;
        O = ke;
        try {
          return ue.apply(this, arguments);
        } finally {
          O = pe;
        }
      };
    };
  }(eE)), eE;
}
var nE = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rE;
function DD() {
  return rE || (rE = 1, function(u) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var o = !1, s = 5;
      function d(xe, $e) {
        var lt = xe.length;
        xe.push($e), g(xe, $e, lt);
      }
      function h(xe) {
        return xe.length === 0 ? null : xe[0];
      }
      function m(xe) {
        if (xe.length === 0)
          return null;
        var $e = xe[0], lt = xe.pop();
        return lt !== $e && (xe[0] = lt, k(xe, lt, 0)), $e;
      }
      function g(xe, $e, lt) {
        for (var Ft = lt; Ft > 0; ) {
          var Qt = Ft - 1 >>> 1, Un = xe[Qt];
          if (S(Un, $e) > 0)
            xe[Qt] = $e, xe[Ft] = Un, Ft = Qt;
          else
            return;
        }
      }
      function k(xe, $e, lt) {
        for (var Ft = lt, Qt = xe.length, Un = Qt >>> 1; Ft < Un; ) {
          var hn = (Ft + 1) * 2 - 1, ia = xe[hn], nn = hn + 1, Qa = xe[nn];
          if (S(ia, $e) < 0)
            nn < Qt && S(Qa, ia) < 0 ? (xe[Ft] = Qa, xe[nn] = $e, Ft = nn) : (xe[Ft] = ia, xe[hn] = $e, Ft = hn);
          else if (nn < Qt && S(Qa, $e) < 0)
            xe[Ft] = Qa, xe[nn] = $e, Ft = nn;
          else
            return;
        }
      }
      function S(xe, $e) {
        var lt = xe.sortIndex - $e.sortIndex;
        return lt !== 0 ? lt : xe.id - $e.id;
      }
      var E = 1, R = 2, P = 3, O = 4, M = 5, $ = typeof performance == "object" && typeof performance.now == "function";
      if ($) {
        var Z = performance;
        u.unstable_now = function() {
          return Z.now();
        };
      } else {
        var G = Date, Pe = G.now();
        u.unstable_now = function() {
          return G.now() - Pe;
        };
      }
      var re = 1073741823, ve = -1, qe = 250, Re = 5e3, ft = 1e4, Oe = re, ye = [], rt = [], st = 1, Ie = null, fe = P, Ae = !1, Ke = !1, et = !1, _t = typeof setTimeout == "function" ? setTimeout : null, qt = typeof clearTimeout == "function" ? clearTimeout : null, ue = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function ke(xe) {
        for (var $e = h(rt); $e !== null; ) {
          if ($e.callback === null)
            m(rt);
          else if ($e.startTime <= xe)
            m(rt), $e.sortIndex = $e.expirationTime, d(ye, $e);
          else
            return;
          $e = h(rt);
        }
      }
      function pe(xe) {
        if (et = !1, ke(xe), !Ke)
          if (h(ye) !== null)
            Ke = !0, Fe(gt);
          else {
            var $e = h(rt);
            $e !== null && Ye(pe, $e.startTime - xe);
          }
      }
      function gt(xe, $e) {
        Ke = !1, et && (et = !1, Mt()), Ae = !0;
        var lt = fe;
        try {
          var Ft;
          if (!o) return Ct(xe, $e);
        } finally {
          Ie = null, fe = lt, Ae = !1;
        }
      }
      function Ct(xe, $e) {
        var lt = $e;
        for (ke(lt), Ie = h(ye); Ie !== null && !(Ie.expirationTime > lt && (!xe || Vi())); ) {
          var Ft = Ie.callback;
          if (typeof Ft == "function") {
            Ie.callback = null, fe = Ie.priorityLevel;
            var Qt = Ie.expirationTime <= lt, Un = Ft(Qt);
            lt = u.unstable_now(), typeof Un == "function" ? Ie.callback = Un : Ie === h(ye) && m(ye), ke(lt);
          } else
            m(ye);
          Ie = h(ye);
        }
        if (Ie !== null)
          return !0;
        var hn = h(rt);
        return hn !== null && Ye(pe, hn.startTime - lt), !1;
      }
      function or(xe, $e) {
        switch (xe) {
          case E:
          case R:
          case P:
          case O:
          case M:
            break;
          default:
            xe = P;
        }
        var lt = fe;
        fe = xe;
        try {
          return $e();
        } finally {
          fe = lt;
        }
      }
      function On(xe) {
        var $e;
        switch (fe) {
          case E:
          case R:
          case P:
            $e = P;
            break;
          default:
            $e = fe;
            break;
        }
        var lt = fe;
        fe = $e;
        try {
          return xe();
        } finally {
          fe = lt;
        }
      }
      function vo(xe) {
        var $e = fe;
        return function() {
          var lt = fe;
          fe = $e;
          try {
            return xe.apply(this, arguments);
          } finally {
            fe = lt;
          }
        };
      }
      function Ln(xe, $e, lt) {
        var Ft = u.unstable_now(), Qt;
        if (typeof lt == "object" && lt !== null) {
          var Un = lt.delay;
          typeof Un == "number" && Un > 0 ? Qt = Ft + Un : Qt = Ft;
        } else
          Qt = Ft;
        var hn;
        switch (xe) {
          case E:
            hn = ve;
            break;
          case R:
            hn = qe;
            break;
          case M:
            hn = Oe;
            break;
          case O:
            hn = ft;
            break;
          case P:
          default:
            hn = Re;
            break;
        }
        var ia = Qt + hn, nn = {
          id: st++,
          callback: $e,
          priorityLevel: xe,
          startTime: Qt,
          expirationTime: ia,
          sortIndex: -1
        };
        return Qt > Ft ? (nn.sortIndex = Qt, d(rt, nn), h(ye) === null && nn === h(rt) && (et ? Mt() : et = !0, Ye(pe, Qt - Ft))) : (nn.sortIndex = ia, d(ye, nn), !Ke && !Ae && (Ke = !0, Fe(gt))), nn;
      }
      function $n() {
      }
      function ir() {
        !Ke && !Ae && (Ke = !0, Fe(gt));
      }
      function Br() {
        return h(ye);
      }
      function Ha(xe) {
        xe.callback = null;
      }
      function kn() {
        return fe;
      }
      var pr = !1, jn = null, hr = -1, Wr = s, Za = -1;
      function Vi() {
        var xe = u.unstable_now() - Za;
        return !(xe < Wr);
      }
      function L() {
      }
      function W(xe) {
        if (xe < 0 || xe > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        xe > 0 ? Wr = Math.floor(1e3 / xe) : Wr = s;
      }
      var Q = function() {
        if (jn !== null) {
          var xe = u.unstable_now();
          Za = xe;
          var $e = !0, lt = !0;
          try {
            lt = jn($e, xe);
          } finally {
            lt ? ce() : (pr = !1, jn = null);
          }
        } else
          pr = !1;
      }, ce;
      if (typeof ue == "function")
        ce = function() {
          ue(Q);
        };
      else if (typeof MessageChannel < "u") {
        var de = new MessageChannel(), ae = de.port2;
        de.port1.onmessage = Q, ce = function() {
          ae.postMessage(null);
        };
      } else
        ce = function() {
          _t(Q, 0);
        };
      function Fe(xe) {
        jn = xe, pr || (pr = !0, ce());
      }
      function Ye(xe, $e) {
        hr = _t(function() {
          xe(u.unstable_now());
        }, $e);
      }
      function Mt() {
        qt(hr), hr = -1;
      }
      var Zt = L, sr = null;
      u.unstable_IdlePriority = M, u.unstable_ImmediatePriority = E, u.unstable_LowPriority = O, u.unstable_NormalPriority = P, u.unstable_Profiling = sr, u.unstable_UserBlockingPriority = R, u.unstable_cancelCallback = Ha, u.unstable_continueExecution = ir, u.unstable_forceFrameRate = W, u.unstable_getCurrentPriorityLevel = kn, u.unstable_getFirstCallbackNode = Br, u.unstable_next = On, u.unstable_pauseExecution = $n, u.unstable_requestPaint = Zt, u.unstable_runWithPriority = or, u.unstable_scheduleCallback = Ln, u.unstable_shouldYield = Vi, u.unstable_wrapCallback = vo, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(nE)), nE;
}
var aE;
function nC() {
  return aE || (aE = 1, process.env.NODE_ENV === "production" ? Pk.exports = LD() : Pk.exports = DD()), Pk.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oE;
function zD() {
  if (oE) return Sa;
  oE = 1;
  var u = xt, o = nC();
  function s(n) {
    for (var r = "https://reactjs.org/docs/error-decoder.html?invariant=" + n, l = 1; l < arguments.length; l++) r += "&args[]=" + encodeURIComponent(arguments[l]);
    return "Minified React error #" + n + "; visit " + r + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var d = /* @__PURE__ */ new Set(), h = {};
  function m(n, r) {
    g(n, r), g(n + "Capture", r);
  }
  function g(n, r) {
    for (h[n] = r, n = 0; n < r.length; n++) d.add(r[n]);
  }
  var k = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), S = Object.prototype.hasOwnProperty, E = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, R = {}, P = {};
  function O(n) {
    return S.call(P, n) ? !0 : S.call(R, n) ? !1 : E.test(n) ? P[n] = !0 : (R[n] = !0, !1);
  }
  function M(n, r, l, f) {
    if (l !== null && l.type === 0) return !1;
    switch (typeof r) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return f ? !1 : l !== null ? !l.acceptsBooleans : (n = n.toLowerCase().slice(0, 5), n !== "data-" && n !== "aria-");
      default:
        return !1;
    }
  }
  function $(n, r, l, f) {
    if (r === null || typeof r > "u" || M(n, r, l, f)) return !0;
    if (f) return !1;
    if (l !== null) switch (l.type) {
      case 3:
        return !r;
      case 4:
        return r === !1;
      case 5:
        return isNaN(r);
      case 6:
        return isNaN(r) || 1 > r;
    }
    return !1;
  }
  function Z(n, r, l, f, v, b, x) {
    this.acceptsBooleans = r === 2 || r === 3 || r === 4, this.attributeName = f, this.attributeNamespace = v, this.mustUseProperty = l, this.propertyName = n, this.type = r, this.sanitizeURL = b, this.removeEmptyString = x;
  }
  var G = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(n) {
    G[n] = new Z(n, 0, !1, n, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(n) {
    var r = n[0];
    G[r] = new Z(r, 1, !1, n[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(n) {
    G[n] = new Z(n, 2, !1, n.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(n) {
    G[n] = new Z(n, 2, !1, n, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(n) {
    G[n] = new Z(n, 3, !1, n.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(n) {
    G[n] = new Z(n, 3, !0, n, null, !1, !1);
  }), ["capture", "download"].forEach(function(n) {
    G[n] = new Z(n, 4, !1, n, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(n) {
    G[n] = new Z(n, 6, !1, n, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(n) {
    G[n] = new Z(n, 5, !1, n.toLowerCase(), null, !1, !1);
  });
  var Pe = /[\-:]([a-z])/g;
  function re(n) {
    return n[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(n) {
    var r = n.replace(
      Pe,
      re
    );
    G[r] = new Z(r, 1, !1, n, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(n) {
    var r = n.replace(Pe, re);
    G[r] = new Z(r, 1, !1, n, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(n) {
    var r = n.replace(Pe, re);
    G[r] = new Z(r, 1, !1, n, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(n) {
    G[n] = new Z(n, 1, !1, n.toLowerCase(), null, !1, !1);
  }), G.xlinkHref = new Z("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(n) {
    G[n] = new Z(n, 1, !1, n.toLowerCase(), null, !0, !0);
  });
  function ve(n, r, l, f) {
    var v = G.hasOwnProperty(r) ? G[r] : null;
    (v !== null ? v.type !== 0 : f || !(2 < r.length) || r[0] !== "o" && r[0] !== "O" || r[1] !== "n" && r[1] !== "N") && ($(r, l, v, f) && (l = null), f || v === null ? O(r) && (l === null ? n.removeAttribute(r) : n.setAttribute(r, "" + l)) : v.mustUseProperty ? n[v.propertyName] = l === null ? v.type === 3 ? !1 : "" : l : (r = v.attributeName, f = v.attributeNamespace, l === null ? n.removeAttribute(r) : (v = v.type, l = v === 3 || v === 4 && l === !0 ? "" : "" + l, f ? n.setAttributeNS(f, r, l) : n.setAttribute(r, l))));
  }
  var qe = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, Re = Symbol.for("react.element"), ft = Symbol.for("react.portal"), Oe = Symbol.for("react.fragment"), ye = Symbol.for("react.strict_mode"), rt = Symbol.for("react.profiler"), st = Symbol.for("react.provider"), Ie = Symbol.for("react.context"), fe = Symbol.for("react.forward_ref"), Ae = Symbol.for("react.suspense"), Ke = Symbol.for("react.suspense_list"), et = Symbol.for("react.memo"), _t = Symbol.for("react.lazy"), qt = Symbol.for("react.offscreen"), ue = Symbol.iterator;
  function ke(n) {
    return n === null || typeof n != "object" ? null : (n = ue && n[ue] || n["@@iterator"], typeof n == "function" ? n : null);
  }
  var pe = Object.assign, gt;
  function Ct(n) {
    if (gt === void 0) try {
      throw Error();
    } catch (l) {
      var r = l.stack.trim().match(/\n( *(at )?)/);
      gt = r && r[1] || "";
    }
    return `
` + gt + n;
  }
  var or = !1;
  function On(n, r) {
    if (!n || or) return "";
    or = !0;
    var l = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (r) if (r = function() {
        throw Error();
      }, Object.defineProperty(r.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(r, []);
        } catch (q) {
          var f = q;
        }
        Reflect.construct(n, [], r);
      } else {
        try {
          r.call();
        } catch (q) {
          f = q;
        }
        n.call(r.prototype);
      }
      else {
        try {
          throw Error();
        } catch (q) {
          f = q;
        }
        n();
      }
    } catch (q) {
      if (q && f && typeof q.stack == "string") {
        for (var v = q.stack.split(`
`), b = f.stack.split(`
`), x = v.length - 1, N = b.length - 1; 1 <= x && 0 <= N && v[x] !== b[N]; ) N--;
        for (; 1 <= x && 0 <= N; x--, N--) if (v[x] !== b[N]) {
          if (x !== 1 || N !== 1)
            do
              if (x--, N--, 0 > N || v[x] !== b[N]) {
                var D = `
` + v[x].replace(" at new ", " at ");
                return n.displayName && D.includes("<anonymous>") && (D = D.replace("<anonymous>", n.displayName)), D;
              }
            while (1 <= x && 0 <= N);
          break;
        }
      }
    } finally {
      or = !1, Error.prepareStackTrace = l;
    }
    return (n = n ? n.displayName || n.name : "") ? Ct(n) : "";
  }
  function vo(n) {
    switch (n.tag) {
      case 5:
        return Ct(n.type);
      case 16:
        return Ct("Lazy");
      case 13:
        return Ct("Suspense");
      case 19:
        return Ct("SuspenseList");
      case 0:
      case 2:
      case 15:
        return n = On(n.type, !1), n;
      case 11:
        return n = On(n.type.render, !1), n;
      case 1:
        return n = On(n.type, !0), n;
      default:
        return "";
    }
  }
  function Ln(n) {
    if (n == null) return null;
    if (typeof n == "function") return n.displayName || n.name || null;
    if (typeof n == "string") return n;
    switch (n) {
      case Oe:
        return "Fragment";
      case ft:
        return "Portal";
      case rt:
        return "Profiler";
      case ye:
        return "StrictMode";
      case Ae:
        return "Suspense";
      case Ke:
        return "SuspenseList";
    }
    if (typeof n == "object") switch (n.$$typeof) {
      case Ie:
        return (n.displayName || "Context") + ".Consumer";
      case st:
        return (n._context.displayName || "Context") + ".Provider";
      case fe:
        var r = n.render;
        return n = n.displayName, n || (n = r.displayName || r.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
      case et:
        return r = n.displayName || null, r !== null ? r : Ln(n.type) || "Memo";
      case _t:
        r = n._payload, n = n._init;
        try {
          return Ln(n(r));
        } catch {
        }
    }
    return null;
  }
  function $n(n) {
    var r = n.type;
    switch (n.tag) {
      case 24:
        return "Cache";
      case 9:
        return (r.displayName || "Context") + ".Consumer";
      case 10:
        return (r._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return n = r.render, n = n.displayName || n.name || "", r.displayName || (n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return r;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return Ln(r);
      case 8:
        return r === ye ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof r == "function") return r.displayName || r.name || null;
        if (typeof r == "string") return r;
    }
    return null;
  }
  function ir(n) {
    switch (typeof n) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return n;
      case "object":
        return n;
      default:
        return "";
    }
  }
  function Br(n) {
    var r = n.type;
    return (n = n.nodeName) && n.toLowerCase() === "input" && (r === "checkbox" || r === "radio");
  }
  function Ha(n) {
    var r = Br(n) ? "checked" : "value", l = Object.getOwnPropertyDescriptor(n.constructor.prototype, r), f = "" + n[r];
    if (!n.hasOwnProperty(r) && typeof l < "u" && typeof l.get == "function" && typeof l.set == "function") {
      var v = l.get, b = l.set;
      return Object.defineProperty(n, r, { configurable: !0, get: function() {
        return v.call(this);
      }, set: function(x) {
        f = "" + x, b.call(this, x);
      } }), Object.defineProperty(n, r, { enumerable: l.enumerable }), { getValue: function() {
        return f;
      }, setValue: function(x) {
        f = "" + x;
      }, stopTracking: function() {
        n._valueTracker = null, delete n[r];
      } };
    }
  }
  function kn(n) {
    n._valueTracker || (n._valueTracker = Ha(n));
  }
  function pr(n) {
    if (!n) return !1;
    var r = n._valueTracker;
    if (!r) return !0;
    var l = r.getValue(), f = "";
    return n && (f = Br(n) ? n.checked ? "true" : "false" : n.value), n = f, n !== l ? (r.setValue(n), !0) : !1;
  }
  function jn(n) {
    if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u") return null;
    try {
      return n.activeElement || n.body;
    } catch {
      return n.body;
    }
  }
  function hr(n, r) {
    var l = r.checked;
    return pe({}, r, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: l ?? n._wrapperState.initialChecked });
  }
  function Wr(n, r) {
    var l = r.defaultValue == null ? "" : r.defaultValue, f = r.checked != null ? r.checked : r.defaultChecked;
    l = ir(r.value != null ? r.value : l), n._wrapperState = { initialChecked: f, initialValue: l, controlled: r.type === "checkbox" || r.type === "radio" ? r.checked != null : r.value != null };
  }
  function Za(n, r) {
    r = r.checked, r != null && ve(n, "checked", r, !1);
  }
  function Vi(n, r) {
    Za(n, r);
    var l = ir(r.value), f = r.type;
    if (l != null) f === "number" ? (l === 0 && n.value === "" || n.value != l) && (n.value = "" + l) : n.value !== "" + l && (n.value = "" + l);
    else if (f === "submit" || f === "reset") {
      n.removeAttribute("value");
      return;
    }
    r.hasOwnProperty("value") ? W(n, r.type, l) : r.hasOwnProperty("defaultValue") && W(n, r.type, ir(r.defaultValue)), r.checked == null && r.defaultChecked != null && (n.defaultChecked = !!r.defaultChecked);
  }
  function L(n, r, l) {
    if (r.hasOwnProperty("value") || r.hasOwnProperty("defaultValue")) {
      var f = r.type;
      if (!(f !== "submit" && f !== "reset" || r.value !== void 0 && r.value !== null)) return;
      r = "" + n._wrapperState.initialValue, l || r === n.value || (n.value = r), n.defaultValue = r;
    }
    l = n.name, l !== "" && (n.name = ""), n.defaultChecked = !!n._wrapperState.initialChecked, l !== "" && (n.name = l);
  }
  function W(n, r, l) {
    (r !== "number" || jn(n.ownerDocument) !== n) && (l == null ? n.defaultValue = "" + n._wrapperState.initialValue : n.defaultValue !== "" + l && (n.defaultValue = "" + l));
  }
  var Q = Array.isArray;
  function ce(n, r, l, f) {
    if (n = n.options, r) {
      r = {};
      for (var v = 0; v < l.length; v++) r["$" + l[v]] = !0;
      for (l = 0; l < n.length; l++) v = r.hasOwnProperty("$" + n[l].value), n[l].selected !== v && (n[l].selected = v), v && f && (n[l].defaultSelected = !0);
    } else {
      for (l = "" + ir(l), r = null, v = 0; v < n.length; v++) {
        if (n[v].value === l) {
          n[v].selected = !0, f && (n[v].defaultSelected = !0);
          return;
        }
        r !== null || n[v].disabled || (r = n[v]);
      }
      r !== null && (r.selected = !0);
    }
  }
  function de(n, r) {
    if (r.dangerouslySetInnerHTML != null) throw Error(s(91));
    return pe({}, r, { value: void 0, defaultValue: void 0, children: "" + n._wrapperState.initialValue });
  }
  function ae(n, r) {
    var l = r.value;
    if (l == null) {
      if (l = r.children, r = r.defaultValue, l != null) {
        if (r != null) throw Error(s(92));
        if (Q(l)) {
          if (1 < l.length) throw Error(s(93));
          l = l[0];
        }
        r = l;
      }
      r == null && (r = ""), l = r;
    }
    n._wrapperState = { initialValue: ir(l) };
  }
  function Fe(n, r) {
    var l = ir(r.value), f = ir(r.defaultValue);
    l != null && (l = "" + l, l !== n.value && (n.value = l), r.defaultValue == null && n.defaultValue !== l && (n.defaultValue = l)), f != null && (n.defaultValue = "" + f);
  }
  function Ye(n) {
    var r = n.textContent;
    r === n._wrapperState.initialValue && r !== "" && r !== null && (n.value = r);
  }
  function Mt(n) {
    switch (n) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Zt(n, r) {
    return n == null || n === "http://www.w3.org/1999/xhtml" ? Mt(r) : n === "http://www.w3.org/2000/svg" && r === "foreignObject" ? "http://www.w3.org/1999/xhtml" : n;
  }
  var sr, xe = function(n) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(r, l, f, v) {
      MSApp.execUnsafeLocalFunction(function() {
        return n(r, l, f, v);
      });
    } : n;
  }(function(n, r) {
    if (n.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in n) n.innerHTML = r;
    else {
      for (sr = sr || document.createElement("div"), sr.innerHTML = "<svg>" + r.valueOf().toString() + "</svg>", r = sr.firstChild; n.firstChild; ) n.removeChild(n.firstChild);
      for (; r.firstChild; ) n.appendChild(r.firstChild);
    }
  });
  function $e(n, r) {
    if (r) {
      var l = n.firstChild;
      if (l && l === n.lastChild && l.nodeType === 3) {
        l.nodeValue = r;
        return;
      }
    }
    n.textContent = r;
  }
  var lt = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, Ft = ["Webkit", "ms", "Moz", "O"];
  Object.keys(lt).forEach(function(n) {
    Ft.forEach(function(r) {
      r = r + n.charAt(0).toUpperCase() + n.substring(1), lt[r] = lt[n];
    });
  });
  function Qt(n, r, l) {
    return r == null || typeof r == "boolean" || r === "" ? "" : l || typeof r != "number" || r === 0 || lt.hasOwnProperty(n) && lt[n] ? ("" + r).trim() : r + "px";
  }
  function Un(n, r) {
    n = n.style;
    for (var l in r) if (r.hasOwnProperty(l)) {
      var f = l.indexOf("--") === 0, v = Qt(l, r[l], f);
      l === "float" && (l = "cssFloat"), f ? n.setProperty(l, v) : n[l] = v;
    }
  }
  var hn = pe({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function ia(n, r) {
    if (r) {
      if (hn[n] && (r.children != null || r.dangerouslySetInnerHTML != null)) throw Error(s(137, n));
      if (r.dangerouslySetInnerHTML != null) {
        if (r.children != null) throw Error(s(60));
        if (typeof r.dangerouslySetInnerHTML != "object" || !("__html" in r.dangerouslySetInnerHTML)) throw Error(s(61));
      }
      if (r.style != null && typeof r.style != "object") throw Error(s(62));
    }
  }
  function nn(n, r) {
    if (n.indexOf("-") === -1) return typeof r.is == "string";
    switch (n) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Qa = null;
  function Vn(n) {
    return n = n.target || n.srcElement || window, n.correspondingUseElement && (n = n.correspondingUseElement), n.nodeType === 3 ? n.parentNode : n;
  }
  var xn = null, Zs = null, Xo = null;
  function fc(n) {
    if (n = We(n)) {
      if (typeof xn != "function") throw Error(s(280));
      var r = n.stateNode;
      r && (r = sn(r), xn(n.stateNode, n.type, r));
    }
  }
  function wm(n) {
    Zs ? Xo ? Xo.push(n) : Xo = [n] : Zs = n;
  }
  function km() {
    if (Zs) {
      var n = Zs, r = Xo;
      if (Xo = Zs = null, fc(n), r) for (n = 0; n < r.length; n++) fc(r[n]);
    }
  }
  function Tf(n, r) {
    return n(r);
  }
  function Rf() {
  }
  var Pf = !1;
  function Nf(n, r, l) {
    if (Pf) return n(r, l);
    Pf = !0;
    try {
      return Tf(n, r, l);
    } finally {
      Pf = !1, (Zs !== null || Xo !== null) && (Rf(), km());
    }
  }
  function Bi(n, r) {
    var l = n.stateNode;
    if (l === null) return null;
    var f = sn(l);
    if (f === null) return null;
    l = f[r];
    e: switch (r) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (f = !f.disabled) || (n = n.type, f = !(n === "button" || n === "input" || n === "select" || n === "textarea")), n = !f;
        break e;
      default:
        n = !1;
    }
    if (n) return null;
    if (l && typeof l != "function") throw Error(s(231, r, typeof l));
    return l;
  }
  var ei = !1;
  if (k) try {
    var Ta = {};
    Object.defineProperty(Ta, "passive", { get: function() {
      ei = !0;
    } }), window.addEventListener("test", Ta, Ta), window.removeEventListener("test", Ta, Ta);
  } catch {
    ei = !1;
  }
  function Qs(n, r, l, f, v, b, x, N, D) {
    var q = Array.prototype.slice.call(arguments, 3);
    try {
      r.apply(l, q);
    } catch (te) {
      this.onError(te);
    }
  }
  var Wi = !1, Ks = null, Ys = !1, Zl = null, Gs = { onError: function(n) {
    Wi = !0, Ks = n;
  } };
  function pc(n, r, l, f, v, b, x, N, D) {
    Wi = !1, Ks = null, Qs.apply(Gs, arguments);
  }
  function hc(n, r, l, f, v, b, x, N, D) {
    if (pc.apply(this, arguments), Wi) {
      if (Wi) {
        var q = Ks;
        Wi = !1, Ks = null;
      } else throw Error(s(198));
      Ys || (Ys = !0, Zl = q);
    }
  }
  function Ra(n) {
    var r = n, l = n;
    if (n.alternate) for (; r.return; ) r = r.return;
    else {
      n = r;
      do
        r = n, r.flags & 4098 && (l = r.return), n = r.return;
      while (n);
    }
    return r.tag === 3 ? l : null;
  }
  function lr(n) {
    if (n.tag === 13) {
      var r = n.memoizedState;
      if (r === null && (n = n.alternate, n !== null && (r = n.memoizedState)), r !== null) return r.dehydrated;
    }
    return null;
  }
  function xm(n) {
    if (Ra(n) !== n) throw Error(s(188));
  }
  function rb(n) {
    var r = n.alternate;
    if (!r) {
      if (r = Ra(n), r === null) throw Error(s(188));
      return r !== n ? null : n;
    }
    for (var l = n, f = r; ; ) {
      var v = l.return;
      if (v === null) break;
      var b = v.alternate;
      if (b === null) {
        if (f = v.return, f !== null) {
          l = f;
          continue;
        }
        break;
      }
      if (v.child === b.child) {
        for (b = v.child; b; ) {
          if (b === l) return xm(v), n;
          if (b === f) return xm(v), r;
          b = b.sibling;
        }
        throw Error(s(188));
      }
      if (l.return !== f.return) l = v, f = b;
      else {
        for (var x = !1, N = v.child; N; ) {
          if (N === l) {
            x = !0, l = v, f = b;
            break;
          }
          if (N === f) {
            x = !0, f = v, l = b;
            break;
          }
          N = N.sibling;
        }
        if (!x) {
          for (N = b.child; N; ) {
            if (N === l) {
              x = !0, l = b, f = v;
              break;
            }
            if (N === f) {
              x = !0, f = b, l = v;
              break;
            }
            N = N.sibling;
          }
          if (!x) throw Error(s(189));
        }
      }
      if (l.alternate !== f) throw Error(s(190));
    }
    if (l.tag !== 3) throw Error(s(188));
    return l.stateNode.current === l ? n : r;
  }
  function Of(n) {
    return n = rb(n), n !== null ? Sm(n) : null;
  }
  function Sm(n) {
    if (n.tag === 5 || n.tag === 6) return n;
    for (n = n.child; n !== null; ) {
      var r = Sm(n);
      if (r !== null) return r;
      n = n.sibling;
    }
    return null;
  }
  var Em = o.unstable_scheduleCallback, Cm = o.unstable_cancelCallback, Tm = o.unstable_shouldYield, ab = o.unstable_requestPaint, Bt = o.unstable_now, bt = o.unstable_getCurrentPriorityLevel, qi = o.unstable_ImmediatePriority, Lf = o.unstable_UserBlockingPriority, Ql = o.unstable_NormalPriority, Rm = o.unstable_LowPriority, Df = o.unstable_IdlePriority, Kl = null, Pa = null;
  function Pm(n) {
    if (Pa && typeof Pa.onCommitFiberRoot == "function") try {
      Pa.onCommitFiberRoot(Kl, n, void 0, (n.current.flags & 128) === 128);
    } catch {
    }
  }
  var sa = Math.clz32 ? Math.clz32 : zf, ob = Math.log, ib = Math.LN2;
  function zf(n) {
    return n >>>= 0, n === 0 ? 32 : 31 - (ob(n) / ib | 0) | 0;
  }
  var Js = 64, Na = 4194304;
  function Hi(n) {
    switch (n & -n) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return n & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return n & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return n;
    }
  }
  function Zi(n, r) {
    var l = n.pendingLanes;
    if (l === 0) return 0;
    var f = 0, v = n.suspendedLanes, b = n.pingedLanes, x = l & 268435455;
    if (x !== 0) {
      var N = x & ~v;
      N !== 0 ? f = Hi(N) : (b &= x, b !== 0 && (f = Hi(b)));
    } else x = l & ~v, x !== 0 ? f = Hi(x) : b !== 0 && (f = Hi(b));
    if (f === 0) return 0;
    if (r !== 0 && r !== f && !(r & v) && (v = f & -f, b = r & -r, v >= b || v === 16 && (b & 4194240) !== 0)) return r;
    if (f & 4 && (f |= l & 16), r = n.entangledLanes, r !== 0) for (n = n.entanglements, r &= f; 0 < r; ) l = 31 - sa(r), v = 1 << l, f |= n[l], r &= ~v;
    return f;
  }
  function sb(n, r) {
    switch (n) {
      case 1:
      case 2:
      case 4:
        return r + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return r + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function If(n, r) {
    for (var l = n.suspendedLanes, f = n.pingedLanes, v = n.expirationTimes, b = n.pendingLanes; 0 < b; ) {
      var x = 31 - sa(b), N = 1 << x, D = v[x];
      D === -1 ? (!(N & l) || N & f) && (v[x] = sb(N, r)) : D <= r && (n.expiredLanes |= N), b &= ~N;
    }
  }
  function Af(n) {
    return n = n.pendingLanes & -1073741825, n !== 0 ? n : n & 1073741824 ? 1073741824 : 0;
  }
  function mc() {
    var n = Js;
    return Js <<= 1, !(Js & 4194240) && (Js = 64), n;
  }
  function Mf(n) {
    for (var r = [], l = 0; 31 > l; l++) r.push(n);
    return r;
  }
  function Qi(n, r, l) {
    n.pendingLanes |= r, r !== 536870912 && (n.suspendedLanes = 0, n.pingedLanes = 0), n = n.eventTimes, r = 31 - sa(r), n[r] = l;
  }
  function lb(n, r) {
    var l = n.pendingLanes & ~r;
    n.pendingLanes = r, n.suspendedLanes = 0, n.pingedLanes = 0, n.expiredLanes &= r, n.mutableReadLanes &= r, n.entangledLanes &= r, r = n.entanglements;
    var f = n.eventTimes;
    for (n = n.expirationTimes; 0 < l; ) {
      var v = 31 - sa(l), b = 1 << v;
      r[v] = 0, f[v] = -1, n[v] = -1, l &= ~b;
    }
  }
  function gc(n, r) {
    var l = n.entangledLanes |= r;
    for (n = n.entanglements; l; ) {
      var f = 31 - sa(l), v = 1 << f;
      v & r | n[f] & r && (n[f] |= r), l &= ~v;
    }
  }
  var It = 0;
  function Ff(n) {
    return n &= -n, 1 < n ? 4 < n ? n & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var At, $f, jf, ut, Uf, mr = !1, ti = [], la = null, ni = null, rn = null, Kt = /* @__PURE__ */ new Map(), Yl = /* @__PURE__ */ new Map(), Bn = [], ua = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function yo(n, r) {
    switch (n) {
      case "focusin":
      case "focusout":
        la = null;
        break;
      case "dragenter":
      case "dragleave":
        ni = null;
        break;
      case "mouseover":
      case "mouseout":
        rn = null;
        break;
      case "pointerover":
      case "pointerout":
        Kt.delete(r.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Yl.delete(r.pointerId);
    }
  }
  function Gl(n, r, l, f, v, b) {
    return n === null || n.nativeEvent !== b ? (n = { blockedOn: r, domEventName: l, eventSystemFlags: f, nativeEvent: b, targetContainers: [v] }, r !== null && (r = We(r), r !== null && $f(r)), n) : (n.eventSystemFlags |= f, r = n.targetContainers, v !== null && r.indexOf(v) === -1 && r.push(v), n);
  }
  function Vf(n, r, l, f, v) {
    switch (r) {
      case "focusin":
        return la = Gl(la, n, r, l, f, v), !0;
      case "dragenter":
        return ni = Gl(ni, n, r, l, f, v), !0;
      case "mouseover":
        return rn = Gl(rn, n, r, l, f, v), !0;
      case "pointerover":
        var b = v.pointerId;
        return Kt.set(b, Gl(Kt.get(b) || null, n, r, l, f, v)), !0;
      case "gotpointercapture":
        return b = v.pointerId, Yl.set(b, Gl(Yl.get(b) || null, n, r, l, f, v)), !0;
    }
    return !1;
  }
  function Bf(n) {
    var r = as(n.target);
    if (r !== null) {
      var l = Ra(r);
      if (l !== null) {
        if (r = l.tag, r === 13) {
          if (r = lr(l), r !== null) {
            n.blockedOn = r, Uf(n.priority, function() {
              jf(l);
            });
            return;
          }
        } else if (r === 3 && l.stateNode.current.memoizedState.isDehydrated) {
          n.blockedOn = l.tag === 3 ? l.stateNode.containerInfo : null;
          return;
        }
      }
    }
    n.blockedOn = null;
  }
  function Jl(n) {
    if (n.blockedOn !== null) return !1;
    for (var r = n.targetContainers; 0 < r.length; ) {
      var l = yc(n.domEventName, n.eventSystemFlags, r[0], n.nativeEvent);
      if (l === null) {
        l = n.nativeEvent;
        var f = new l.constructor(l.type, l);
        Qa = f, l.target.dispatchEvent(f), Qa = null;
      } else return r = We(l), r !== null && $f(r), n.blockedOn = l, !1;
      r.shift();
    }
    return !0;
  }
  function Nm(n, r, l) {
    Jl(n) && l.delete(r);
  }
  function ub() {
    mr = !1, la !== null && Jl(la) && (la = null), ni !== null && Jl(ni) && (ni = null), rn !== null && Jl(rn) && (rn = null), Kt.forEach(Nm), Yl.forEach(Nm);
  }
  function Xl(n, r) {
    n.blockedOn === r && (n.blockedOn = null, mr || (mr = !0, o.unstable_scheduleCallback(o.unstable_NormalPriority, ub)));
  }
  function ri(n) {
    function r(v) {
      return Xl(v, n);
    }
    if (0 < ti.length) {
      Xl(ti[0], n);
      for (var l = 1; l < ti.length; l++) {
        var f = ti[l];
        f.blockedOn === n && (f.blockedOn = null);
      }
    }
    for (la !== null && Xl(la, n), ni !== null && Xl(ni, n), rn !== null && Xl(rn, n), Kt.forEach(r), Yl.forEach(r), l = 0; l < Bn.length; l++) f = Bn[l], f.blockedOn === n && (f.blockedOn = null);
    for (; 0 < Bn.length && (l = Bn[0], l.blockedOn === null); ) Bf(l), l.blockedOn === null && Bn.shift();
  }
  var Ki = qe.ReactCurrentBatchConfig, Yi = !0;
  function Om(n, r, l, f) {
    var v = It, b = Ki.transition;
    Ki.transition = null;
    try {
      It = 1, vc(n, r, l, f);
    } finally {
      It = v, Ki.transition = b;
    }
  }
  function Lm(n, r, l, f) {
    var v = It, b = Ki.transition;
    Ki.transition = null;
    try {
      It = 4, vc(n, r, l, f);
    } finally {
      It = v, Ki.transition = b;
    }
  }
  function vc(n, r, l, f) {
    if (Yi) {
      var v = yc(n, r, l, f);
      if (v === null) Ac(n, r, f, eu, l), yo(n, f);
      else if (Vf(v, n, r, l, f)) f.stopPropagation();
      else if (yo(n, f), r & 4 && -1 < ua.indexOf(n)) {
        for (; v !== null; ) {
          var b = We(v);
          if (b !== null && At(b), b = yc(n, r, l, f), b === null && Ac(n, r, f, eu, l), b === v) break;
          v = b;
        }
        v !== null && f.stopPropagation();
      } else Ac(n, r, f, null, l);
    }
  }
  var eu = null;
  function yc(n, r, l, f) {
    if (eu = null, n = Vn(f), n = as(n), n !== null) if (r = Ra(n), r === null) n = null;
    else if (l = r.tag, l === 13) {
      if (n = lr(r), n !== null) return n;
      n = null;
    } else if (l === 3) {
      if (r.stateNode.current.memoizedState.isDehydrated) return r.tag === 3 ? r.stateNode.containerInfo : null;
      n = null;
    } else r !== n && (n = null);
    return eu = n, null;
  }
  function bc(n) {
    switch (n) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (bt()) {
          case qi:
            return 1;
          case Lf:
            return 4;
          case Ql:
          case Rm:
            return 16;
          case Df:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var bo = null, _c = null, Xs = null;
  function Wf() {
    if (Xs) return Xs;
    var n, r = _c, l = r.length, f, v = "value" in bo ? bo.value : bo.textContent, b = v.length;
    for (n = 0; n < l && r[n] === v[n]; n++) ;
    var x = l - n;
    for (f = 1; f <= x && r[l - f] === v[b - f]; f++) ;
    return Xs = v.slice(n, 1 < f ? 1 - f : void 0);
  }
  function wc(n) {
    var r = n.keyCode;
    return "charCode" in n ? (n = n.charCode, n === 0 && r === 13 && (n = 13)) : n = r, n === 10 && (n = 13), 32 <= n || n === 13 ? n : 0;
  }
  function kc() {
    return !0;
  }
  function xc() {
    return !1;
  }
  function Er(n) {
    function r(l, f, v, b, x) {
      this._reactName = l, this._targetInst = v, this.type = f, this.nativeEvent = b, this.target = x, this.currentTarget = null;
      for (var N in n) n.hasOwnProperty(N) && (l = n[N], this[N] = l ? l(b) : b[N]);
      return this.isDefaultPrevented = (b.defaultPrevented != null ? b.defaultPrevented : b.returnValue === !1) ? kc : xc, this.isPropagationStopped = xc, this;
    }
    return pe(r.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var l = this.nativeEvent;
      l && (l.preventDefault ? l.preventDefault() : typeof l.returnValue != "unknown" && (l.returnValue = !1), this.isDefaultPrevented = kc);
    }, stopPropagation: function() {
      var l = this.nativeEvent;
      l && (l.stopPropagation ? l.stopPropagation() : typeof l.cancelBubble != "unknown" && (l.cancelBubble = !0), this.isPropagationStopped = kc);
    }, persist: function() {
    }, isPersistent: kc }), r;
  }
  var Gi = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(n) {
    return n.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Sc = Er(Gi), el = pe({}, Gi, { view: 0, detail: 0 }), cb = Er(el), qf, Wn, Ji, tu = pe({}, el, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Yf, button: 0, buttons: 0, relatedTarget: function(n) {
    return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
  }, movementX: function(n) {
    return "movementX" in n ? n.movementX : (n !== Ji && (Ji && n.type === "mousemove" ? (qf = n.screenX - Ji.screenX, Wn = n.screenY - Ji.screenY) : Wn = qf = 0, Ji = n), qf);
  }, movementY: function(n) {
    return "movementY" in n ? n.movementY : Wn;
  } }), Hf = Er(tu), db = pe({}, tu, { dataTransfer: 0 }), tl = Er(db), Zf = pe({}, el, { relatedTarget: 0 }), Ec = Er(Zf), fb = pe({}, Gi, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), pb = Er(fb), hb = pe({}, Gi, { clipboardData: function(n) {
    return "clipboardData" in n ? n.clipboardData : window.clipboardData;
  } }), Dm = Er(hb), Qf = pe({}, Gi, { data: 0 }), Kf = Er(Qf), zm = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Im = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, mb = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function _o(n) {
    var r = this.nativeEvent;
    return r.getModifierState ? r.getModifierState(n) : (n = mb[n]) ? !!r[n] : !1;
  }
  function Yf() {
    return _o;
  }
  var Gf = pe({}, el, { key: function(n) {
    if (n.key) {
      var r = zm[n.key] || n.key;
      if (r !== "Unidentified") return r;
    }
    return n.type === "keypress" ? (n = wc(n), n === 13 ? "Enter" : String.fromCharCode(n)) : n.type === "keydown" || n.type === "keyup" ? Im[n.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Yf, charCode: function(n) {
    return n.type === "keypress" ? wc(n) : 0;
  }, keyCode: function(n) {
    return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
  }, which: function(n) {
    return n.type === "keypress" ? wc(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
  } }), Jf = Er(Gf), Xf = pe({}, tu, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Am = Er(Xf), Cc = pe({}, el, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Yf }), Mm = Er(Cc), Cr = pe({}, Gi, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), wo = Er(Cr), mn = pe({}, tu, {
    deltaX: function(n) {
      return "deltaX" in n ? n.deltaX : "wheelDeltaX" in n ? -n.wheelDeltaX : 0;
    },
    deltaY: function(n) {
      return "deltaY" in n ? n.deltaY : "wheelDeltaY" in n ? -n.wheelDeltaY : "wheelDelta" in n ? -n.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), ko = Er(mn), ep = [9, 13, 27, 32], nl = k && "CompositionEvent" in window, nu = null;
  k && "documentMode" in document && (nu = document.documentMode);
  var ru = k && "TextEvent" in window && !nu, Fm = k && (!nl || nu && 8 < nu && 11 >= nu), $m = " ", Tc = !1;
  function jm(n, r) {
    switch (n) {
      case "keyup":
        return ep.indexOf(r.keyCode) !== -1;
      case "keydown":
        return r.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Um(n) {
    return n = n.detail, typeof n == "object" && "data" in n ? n.data : null;
  }
  var rl = !1;
  function Vm(n, r) {
    switch (n) {
      case "compositionend":
        return Um(r);
      case "keypress":
        return r.which !== 32 ? null : (Tc = !0, $m);
      case "textInput":
        return n = r.data, n === $m && Tc ? null : n;
      default:
        return null;
    }
  }
  function gb(n, r) {
    if (rl) return n === "compositionend" || !nl && jm(n, r) ? (n = Wf(), Xs = _c = bo = null, rl = !1, n) : null;
    switch (n) {
      case "paste":
        return null;
      case "keypress":
        if (!(r.ctrlKey || r.altKey || r.metaKey) || r.ctrlKey && r.altKey) {
          if (r.char && 1 < r.char.length) return r.char;
          if (r.which) return String.fromCharCode(r.which);
        }
        return null;
      case "compositionend":
        return Fm && r.locale !== "ko" ? null : r.data;
      default:
        return null;
    }
  }
  var vb = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function Bm(n) {
    var r = n && n.nodeName && n.nodeName.toLowerCase();
    return r === "input" ? !!vb[n.type] : r === "textarea";
  }
  function tp(n, r, l, f) {
    wm(f), r = uu(r, "onChange"), 0 < r.length && (l = new Sc("onChange", "change", null, l, f), n.push({ event: l, listeners: r }));
  }
  var Ka = null, Xi = null;
  function Wm(n) {
    ns(n, 0);
  }
  function au(n) {
    var r = La(n);
    if (pr(r)) return n;
  }
  function yb(n, r) {
    if (n === "change") return r;
  }
  var qm = !1;
  if (k) {
    var np;
    if (k) {
      var rp = "oninput" in document;
      if (!rp) {
        var Hm = document.createElement("div");
        Hm.setAttribute("oninput", "return;"), rp = typeof Hm.oninput == "function";
      }
      np = rp;
    } else np = !1;
    qm = np && (!document.documentMode || 9 < document.documentMode);
  }
  function Zm() {
    Ka && (Ka.detachEvent("onpropertychange", Qm), Xi = Ka = null);
  }
  function Qm(n) {
    if (n.propertyName === "value" && au(Xi)) {
      var r = [];
      tp(r, Xi, n, Vn(n)), Nf(Wm, r);
    }
  }
  function bb(n, r, l) {
    n === "focusin" ? (Zm(), Ka = r, Xi = l, Ka.attachEvent("onpropertychange", Qm)) : n === "focusout" && Zm();
  }
  function Km(n) {
    if (n === "selectionchange" || n === "keyup" || n === "keydown") return au(Xi);
  }
  function _b(n, r) {
    if (n === "click") return au(r);
  }
  function Ym(n, r) {
    if (n === "input" || n === "change") return au(r);
  }
  function wb(n, r) {
    return n === r && (n !== 0 || 1 / n === 1 / r) || n !== n && r !== r;
  }
  var Oa = typeof Object.is == "function" ? Object.is : wb;
  function ou(n, r) {
    if (Oa(n, r)) return !0;
    if (typeof n != "object" || n === null || typeof r != "object" || r === null) return !1;
    var l = Object.keys(n), f = Object.keys(r);
    if (l.length !== f.length) return !1;
    for (f = 0; f < l.length; f++) {
      var v = l[f];
      if (!S.call(r, v) || !Oa(n[v], r[v])) return !1;
    }
    return !0;
  }
  function Gm(n) {
    for (; n && n.firstChild; ) n = n.firstChild;
    return n;
  }
  function Rc(n, r) {
    var l = Gm(n);
    n = 0;
    for (var f; l; ) {
      if (l.nodeType === 3) {
        if (f = n + l.textContent.length, n <= r && f >= r) return { node: l, offset: r - n };
        n = f;
      }
      e: {
        for (; l; ) {
          if (l.nextSibling) {
            l = l.nextSibling;
            break e;
          }
          l = l.parentNode;
        }
        l = void 0;
      }
      l = Gm(l);
    }
  }
  function ai(n, r) {
    return n && r ? n === r ? !0 : n && n.nodeType === 3 ? !1 : r && r.nodeType === 3 ? ai(n, r.parentNode) : "contains" in n ? n.contains(r) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(r) & 16) : !1 : !1;
  }
  function iu() {
    for (var n = window, r = jn(); r instanceof n.HTMLIFrameElement; ) {
      try {
        var l = typeof r.contentWindow.location.href == "string";
      } catch {
        l = !1;
      }
      if (l) n = r.contentWindow;
      else break;
      r = jn(n.document);
    }
    return r;
  }
  function Pc(n) {
    var r = n && n.nodeName && n.nodeName.toLowerCase();
    return r && (r === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || r === "textarea" || n.contentEditable === "true");
  }
  function al(n) {
    var r = iu(), l = n.focusedElem, f = n.selectionRange;
    if (r !== l && l && l.ownerDocument && ai(l.ownerDocument.documentElement, l)) {
      if (f !== null && Pc(l)) {
        if (r = f.start, n = f.end, n === void 0 && (n = r), "selectionStart" in l) l.selectionStart = r, l.selectionEnd = Math.min(n, l.value.length);
        else if (n = (r = l.ownerDocument || document) && r.defaultView || window, n.getSelection) {
          n = n.getSelection();
          var v = l.textContent.length, b = Math.min(f.start, v);
          f = f.end === void 0 ? b : Math.min(f.end, v), !n.extend && b > f && (v = f, f = b, b = v), v = Rc(l, b);
          var x = Rc(
            l,
            f
          );
          v && x && (n.rangeCount !== 1 || n.anchorNode !== v.node || n.anchorOffset !== v.offset || n.focusNode !== x.node || n.focusOffset !== x.offset) && (r = r.createRange(), r.setStart(v.node, v.offset), n.removeAllRanges(), b > f ? (n.addRange(r), n.extend(x.node, x.offset)) : (r.setEnd(x.node, x.offset), n.addRange(r)));
        }
      }
      for (r = [], n = l; n = n.parentNode; ) n.nodeType === 1 && r.push({ element: n, left: n.scrollLeft, top: n.scrollTop });
      for (typeof l.focus == "function" && l.focus(), l = 0; l < r.length; l++) n = r[l], n.element.scrollLeft = n.left, n.element.scrollTop = n.top;
    }
  }
  var kb = k && "documentMode" in document && 11 >= document.documentMode, ol = null, ap = null, su = null, op = !1;
  function ip(n, r, l) {
    var f = l.window === l ? l.document : l.nodeType === 9 ? l : l.ownerDocument;
    op || ol == null || ol !== jn(f) || (f = ol, "selectionStart" in f && Pc(f) ? f = { start: f.selectionStart, end: f.selectionEnd } : (f = (f.ownerDocument && f.ownerDocument.defaultView || window).getSelection(), f = { anchorNode: f.anchorNode, anchorOffset: f.anchorOffset, focusNode: f.focusNode, focusOffset: f.focusOffset }), su && ou(su, f) || (su = f, f = uu(ap, "onSelect"), 0 < f.length && (r = new Sc("onSelect", "select", null, r, l), n.push({ event: r, listeners: f }), r.target = ol)));
  }
  function Nc(n, r) {
    var l = {};
    return l[n.toLowerCase()] = r.toLowerCase(), l["Webkit" + n] = "webkit" + r, l["Moz" + n] = "moz" + r, l;
  }
  var es = { animationend: Nc("Animation", "AnimationEnd"), animationiteration: Nc("Animation", "AnimationIteration"), animationstart: Nc("Animation", "AnimationStart"), transitionend: Nc("Transition", "TransitionEnd") }, qn = {}, sp = {};
  k && (sp = document.createElement("div").style, "AnimationEvent" in window || (delete es.animationend.animation, delete es.animationiteration.animation, delete es.animationstart.animation), "TransitionEvent" in window || delete es.transitionend.transition);
  function Oc(n) {
    if (qn[n]) return qn[n];
    if (!es[n]) return n;
    var r = es[n], l;
    for (l in r) if (r.hasOwnProperty(l) && l in sp) return qn[n] = r[l];
    return n;
  }
  var Jm = Oc("animationend"), Xm = Oc("animationiteration"), eg = Oc("animationstart"), tg = Oc("transitionend"), lp = /* @__PURE__ */ new Map(), Lc = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function ca(n, r) {
    lp.set(n, r), m(r, [n]);
  }
  for (var up = 0; up < Lc.length; up++) {
    var ts = Lc[up], xb = ts.toLowerCase(), Sb = ts[0].toUpperCase() + ts.slice(1);
    ca(xb, "on" + Sb);
  }
  ca(Jm, "onAnimationEnd"), ca(Xm, "onAnimationIteration"), ca(eg, "onAnimationStart"), ca("dblclick", "onDoubleClick"), ca("focusin", "onFocus"), ca("focusout", "onBlur"), ca(tg, "onTransitionEnd"), g("onMouseEnter", ["mouseout", "mouseover"]), g("onMouseLeave", ["mouseout", "mouseover"]), g("onPointerEnter", ["pointerout", "pointerover"]), g("onPointerLeave", ["pointerout", "pointerover"]), m("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), m("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), m("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), m("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), m("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), m("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var lu = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), cp = new Set("cancel close invalid load scroll toggle".split(" ").concat(lu));
  function Dc(n, r, l) {
    var f = n.type || "unknown-event";
    n.currentTarget = l, hc(f, r, void 0, n), n.currentTarget = null;
  }
  function ns(n, r) {
    r = (r & 4) !== 0;
    for (var l = 0; l < n.length; l++) {
      var f = n[l], v = f.event;
      f = f.listeners;
      e: {
        var b = void 0;
        if (r) for (var x = f.length - 1; 0 <= x; x--) {
          var N = f[x], D = N.instance, q = N.currentTarget;
          if (N = N.listener, D !== b && v.isPropagationStopped()) break e;
          Dc(v, N, q), b = D;
        }
        else for (x = 0; x < f.length; x++) {
          if (N = f[x], D = N.instance, q = N.currentTarget, N = N.listener, D !== b && v.isPropagationStopped()) break e;
          Dc(v, N, q), b = D;
        }
      }
    }
    if (Ys) throw n = Zl, Ys = !1, Zl = null, n;
  }
  function Dt(n, r) {
    var l = r[fu];
    l === void 0 && (l = r[fu] = /* @__PURE__ */ new Set());
    var f = n + "__bubble";
    l.has(f) || (ng(r, n, 2, !1), l.add(f));
  }
  function zc(n, r, l) {
    var f = 0;
    r && (f |= 4), ng(l, n, f, r);
  }
  var Ic = "_reactListening" + Math.random().toString(36).slice(2);
  function il(n) {
    if (!n[Ic]) {
      n[Ic] = !0, d.forEach(function(l) {
        l !== "selectionchange" && (cp.has(l) || zc(l, !1, n), zc(l, !0, n));
      });
      var r = n.nodeType === 9 ? n : n.ownerDocument;
      r === null || r[Ic] || (r[Ic] = !0, zc("selectionchange", !1, r));
    }
  }
  function ng(n, r, l, f) {
    switch (bc(r)) {
      case 1:
        var v = Om;
        break;
      case 4:
        v = Lm;
        break;
      default:
        v = vc;
    }
    l = v.bind(null, r, l, n), v = void 0, !ei || r !== "touchstart" && r !== "touchmove" && r !== "wheel" || (v = !0), f ? v !== void 0 ? n.addEventListener(r, l, { capture: !0, passive: v }) : n.addEventListener(r, l, !0) : v !== void 0 ? n.addEventListener(r, l, { passive: v }) : n.addEventListener(r, l, !1);
  }
  function Ac(n, r, l, f, v) {
    var b = f;
    if (!(r & 1) && !(r & 2) && f !== null) e: for (; ; ) {
      if (f === null) return;
      var x = f.tag;
      if (x === 3 || x === 4) {
        var N = f.stateNode.containerInfo;
        if (N === v || N.nodeType === 8 && N.parentNode === v) break;
        if (x === 4) for (x = f.return; x !== null; ) {
          var D = x.tag;
          if ((D === 3 || D === 4) && (D = x.stateNode.containerInfo, D === v || D.nodeType === 8 && D.parentNode === v)) return;
          x = x.return;
        }
        for (; N !== null; ) {
          if (x = as(N), x === null) return;
          if (D = x.tag, D === 5 || D === 6) {
            f = b = x;
            continue e;
          }
          N = N.parentNode;
        }
      }
      f = f.return;
    }
    Nf(function() {
      var q = b, te = Vn(l), ne = [];
      e: {
        var ee = lp.get(n);
        if (ee !== void 0) {
          var Se = Sc, De = n;
          switch (n) {
            case "keypress":
              if (wc(l) === 0) break e;
            case "keydown":
            case "keyup":
              Se = Jf;
              break;
            case "focusin":
              De = "focus", Se = Ec;
              break;
            case "focusout":
              De = "blur", Se = Ec;
              break;
            case "beforeblur":
            case "afterblur":
              Se = Ec;
              break;
            case "click":
              if (l.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Se = Hf;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Se = tl;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Se = Mm;
              break;
            case Jm:
            case Xm:
            case eg:
              Se = pb;
              break;
            case tg:
              Se = wo;
              break;
            case "scroll":
              Se = cb;
              break;
            case "wheel":
              Se = ko;
              break;
            case "copy":
            case "cut":
            case "paste":
              Se = Dm;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Se = Am;
          }
          var Me = (r & 4) !== 0, dn = !Me && n === "scroll", j = Me ? ee !== null ? ee + "Capture" : null : ee;
          Me = [];
          for (var I = q, F; I !== null; ) {
            F = I;
            var se = F.stateNode;
            if (F.tag === 5 && se !== null && (F = se, j !== null && (se = Bi(I, j), se != null && Me.push(sl(I, se, F)))), dn) break;
            I = I.return;
          }
          0 < Me.length && (ee = new Se(ee, De, null, l, te), ne.push({ event: ee, listeners: Me }));
        }
      }
      if (!(r & 7)) {
        e: {
          if (ee = n === "mouseover" || n === "pointerover", Se = n === "mouseout" || n === "pointerout", ee && l !== Qa && (De = l.relatedTarget || l.fromElement) && (as(De) || De[xo])) break e;
          if ((Se || ee) && (ee = te.window === te ? te : (ee = te.ownerDocument) ? ee.defaultView || ee.parentWindow : window, Se ? (De = l.relatedTarget || l.toElement, Se = q, De = De ? as(De) : null, De !== null && (dn = Ra(De), De !== dn || De.tag !== 5 && De.tag !== 6) && (De = null)) : (Se = null, De = q), Se !== De)) {
            if (Me = Hf, se = "onMouseLeave", j = "onMouseEnter", I = "mouse", (n === "pointerout" || n === "pointerover") && (Me = Am, se = "onPointerLeave", j = "onPointerEnter", I = "pointer"), dn = Se == null ? ee : La(Se), F = De == null ? ee : La(De), ee = new Me(se, I + "leave", Se, l, te), ee.target = dn, ee.relatedTarget = F, se = null, as(te) === q && (Me = new Me(j, I + "enter", De, l, te), Me.target = F, Me.relatedTarget = dn, se = Me), dn = se, Se && De) t: {
              for (Me = Se, j = De, I = 0, F = Me; F; F = oi(F)) I++;
              for (F = 0, se = j; se; se = oi(se)) F++;
              for (; 0 < I - F; ) Me = oi(Me), I--;
              for (; 0 < F - I; ) j = oi(j), F--;
              for (; I--; ) {
                if (Me === j || j !== null && Me === j.alternate) break t;
                Me = oi(Me), j = oi(j);
              }
              Me = null;
            }
            else Me = null;
            Se !== null && rg(ne, ee, Se, Me, !1), De !== null && dn !== null && rg(ne, dn, De, Me, !0);
          }
        }
        e: {
          if (ee = q ? La(q) : window, Se = ee.nodeName && ee.nodeName.toLowerCase(), Se === "select" || Se === "input" && ee.type === "file") var je = yb;
          else if (Bm(ee)) if (qm) je = Ym;
          else {
            je = Km;
            var Ge = bb;
          }
          else (Se = ee.nodeName) && Se.toLowerCase() === "input" && (ee.type === "checkbox" || ee.type === "radio") && (je = _b);
          if (je && (je = je(n, q))) {
            tp(ne, je, l, te);
            break e;
          }
          Ge && Ge(n, ee, q), n === "focusout" && (Ge = ee._wrapperState) && Ge.controlled && ee.type === "number" && W(ee, "number", ee.value);
        }
        switch (Ge = q ? La(q) : window, n) {
          case "focusin":
            (Bm(Ge) || Ge.contentEditable === "true") && (ol = Ge, ap = q, su = null);
            break;
          case "focusout":
            su = ap = ol = null;
            break;
          case "mousedown":
            op = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            op = !1, ip(ne, l, te);
            break;
          case "selectionchange":
            if (kb) break;
          case "keydown":
          case "keyup":
            ip(ne, l, te);
        }
        var Ze;
        if (nl) e: {
          switch (n) {
            case "compositionstart":
              var tt = "onCompositionStart";
              break e;
            case "compositionend":
              tt = "onCompositionEnd";
              break e;
            case "compositionupdate":
              tt = "onCompositionUpdate";
              break e;
          }
          tt = void 0;
        }
        else rl ? jm(n, l) && (tt = "onCompositionEnd") : n === "keydown" && l.keyCode === 229 && (tt = "onCompositionStart");
        tt && (Fm && l.locale !== "ko" && (rl || tt !== "onCompositionStart" ? tt === "onCompositionEnd" && rl && (Ze = Wf()) : (bo = te, _c = "value" in bo ? bo.value : bo.textContent, rl = !0)), Ge = uu(q, tt), 0 < Ge.length && (tt = new Kf(tt, n, null, l, te), ne.push({ event: tt, listeners: Ge }), Ze ? tt.data = Ze : (Ze = Um(l), Ze !== null && (tt.data = Ze)))), (Ze = ru ? Vm(n, l) : gb(n, l)) && (q = uu(q, "onBeforeInput"), 0 < q.length && (te = new Kf("onBeforeInput", "beforeinput", null, l, te), ne.push({ event: te, listeners: q }), te.data = Ze));
      }
      ns(ne, r);
    });
  }
  function sl(n, r, l) {
    return { instance: n, listener: r, currentTarget: l };
  }
  function uu(n, r) {
    for (var l = r + "Capture", f = []; n !== null; ) {
      var v = n, b = v.stateNode;
      v.tag === 5 && b !== null && (v = b, b = Bi(n, l), b != null && f.unshift(sl(n, b, v)), b = Bi(n, r), b != null && f.push(sl(n, b, v))), n = n.return;
    }
    return f;
  }
  function oi(n) {
    if (n === null) return null;
    do
      n = n.return;
    while (n && n.tag !== 5);
    return n || null;
  }
  function rg(n, r, l, f, v) {
    for (var b = r._reactName, x = []; l !== null && l !== f; ) {
      var N = l, D = N.alternate, q = N.stateNode;
      if (D !== null && D === f) break;
      N.tag === 5 && q !== null && (N = q, v ? (D = Bi(l, b), D != null && x.unshift(sl(l, D, N))) : v || (D = Bi(l, b), D != null && x.push(sl(l, D, N)))), l = l.return;
    }
    x.length !== 0 && n.push({ event: r, listeners: x });
  }
  var ag = /\r\n?/g, Eb = /\u0000|\uFFFD/g;
  function og(n) {
    return (typeof n == "string" ? n : "" + n).replace(ag, `
`).replace(Eb, "");
  }
  function Mc(n, r, l) {
    if (r = og(r), og(n) !== r && l) throw Error(s(425));
  }
  function ii() {
  }
  var cu = null, rs = null;
  function Fc(n, r) {
    return n === "textarea" || n === "noscript" || typeof r.children == "string" || typeof r.children == "number" || typeof r.dangerouslySetInnerHTML == "object" && r.dangerouslySetInnerHTML !== null && r.dangerouslySetInnerHTML.__html != null;
  }
  var $c = typeof setTimeout == "function" ? setTimeout : void 0, dp = typeof clearTimeout == "function" ? clearTimeout : void 0, ig = typeof Promise == "function" ? Promise : void 0, ll = typeof queueMicrotask == "function" ? queueMicrotask : typeof ig < "u" ? function(n) {
    return ig.resolve(null).then(n).catch(jc);
  } : $c;
  function jc(n) {
    setTimeout(function() {
      throw n;
    });
  }
  function ul(n, r) {
    var l = r, f = 0;
    do {
      var v = l.nextSibling;
      if (n.removeChild(l), v && v.nodeType === 8) if (l = v.data, l === "/$") {
        if (f === 0) {
          n.removeChild(v), ri(r);
          return;
        }
        f--;
      } else l !== "$" && l !== "$?" && l !== "$!" || f++;
      l = v;
    } while (l);
    ri(r);
  }
  function Ya(n) {
    for (; n != null; n = n.nextSibling) {
      var r = n.nodeType;
      if (r === 1 || r === 3) break;
      if (r === 8) {
        if (r = n.data, r === "$" || r === "$!" || r === "$?") break;
        if (r === "/$") return null;
      }
    }
    return n;
  }
  function sg(n) {
    n = n.previousSibling;
    for (var r = 0; n; ) {
      if (n.nodeType === 8) {
        var l = n.data;
        if (l === "$" || l === "$!" || l === "$?") {
          if (r === 0) return n;
          r--;
        } else l === "/$" && r++;
      }
      n = n.previousSibling;
    }
    return null;
  }
  var si = Math.random().toString(36).slice(2), Ga = "__reactFiber$" + si, du = "__reactProps$" + si, xo = "__reactContainer$" + si, fu = "__reactEvents$" + si, cl = "__reactListeners$" + si, Cb = "__reactHandles$" + si;
  function as(n) {
    var r = n[Ga];
    if (r) return r;
    for (var l = n.parentNode; l; ) {
      if (r = l[xo] || l[Ga]) {
        if (l = r.alternate, r.child !== null || l !== null && l.child !== null) for (n = sg(n); n !== null; ) {
          if (l = n[Ga]) return l;
          n = sg(n);
        }
        return r;
      }
      n = l, l = n.parentNode;
    }
    return null;
  }
  function We(n) {
    return n = n[Ga] || n[xo], !n || n.tag !== 5 && n.tag !== 6 && n.tag !== 13 && n.tag !== 3 ? null : n;
  }
  function La(n) {
    if (n.tag === 5 || n.tag === 6) return n.stateNode;
    throw Error(s(33));
  }
  function sn(n) {
    return n[du] || null;
  }
  var wt = [], da = -1;
  function Da(n) {
    return { current: n };
  }
  function Ht(n) {
    0 > da || (n.current = wt[da], wt[da] = null, da--);
  }
  function Be(n, r) {
    da++, wt[da] = n.current, n.current = r;
  }
  var Tr = {}, an = Da(Tr), Sn = Da(!1), Rr = Tr;
  function fa(n, r) {
    var l = n.type.contextTypes;
    if (!l) return Tr;
    var f = n.stateNode;
    if (f && f.__reactInternalMemoizedUnmaskedChildContext === r) return f.__reactInternalMemoizedMaskedChildContext;
    var v = {}, b;
    for (b in l) v[b] = r[b];
    return f && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = r, n.__reactInternalMemoizedMaskedChildContext = v), v;
  }
  function gn(n) {
    return n = n.childContextTypes, n != null;
  }
  function dl() {
    Ht(Sn), Ht(an);
  }
  function lg(n, r, l) {
    if (an.current !== Tr) throw Error(s(168));
    Be(an, r), Be(Sn, l);
  }
  function pu(n, r, l) {
    var f = n.stateNode;
    if (r = r.childContextTypes, typeof f.getChildContext != "function") return l;
    f = f.getChildContext();
    for (var v in f) if (!(v in r)) throw Error(s(108, $n(n) || "Unknown", v));
    return pe({}, l, f);
  }
  function Pr(n) {
    return n = (n = n.stateNode) && n.__reactInternalMemoizedMergedChildContext || Tr, Rr = an.current, Be(an, n), Be(Sn, Sn.current), !0;
  }
  function Uc(n, r, l) {
    var f = n.stateNode;
    if (!f) throw Error(s(169));
    l ? (n = pu(n, r, Rr), f.__reactInternalMemoizedMergedChildContext = n, Ht(Sn), Ht(an), Be(an, n)) : Ht(Sn), Be(Sn, l);
  }
  var Ja = null, fl = !1, So = !1;
  function Vc(n) {
    Ja === null ? Ja = [n] : Ja.push(n);
  }
  function li(n) {
    fl = !0, Vc(n);
  }
  function Xa() {
    if (!So && Ja !== null) {
      So = !0;
      var n = 0, r = It;
      try {
        var l = Ja;
        for (It = 1; n < l.length; n++) {
          var f = l[n];
          do
            f = f(!0);
          while (f !== null);
        }
        Ja = null, fl = !1;
      } catch (v) {
        throw Ja !== null && (Ja = Ja.slice(n + 1)), Em(qi, Xa), v;
      } finally {
        It = r, So = !1;
      }
    }
    return null;
  }
  var ui = [], ci = 0, di = null, Eo = 0, vn = [], pa = 0, qr = null, eo = 1, to = "";
  function os(n, r) {
    ui[ci++] = Eo, ui[ci++] = di, di = n, Eo = r;
  }
  function ug(n, r, l) {
    vn[pa++] = eo, vn[pa++] = to, vn[pa++] = qr, qr = n;
    var f = eo;
    n = to;
    var v = 32 - sa(f) - 1;
    f &= ~(1 << v), l += 1;
    var b = 32 - sa(r) + v;
    if (30 < b) {
      var x = v - v % 5;
      b = (f & (1 << x) - 1).toString(32), f >>= x, v -= x, eo = 1 << 32 - sa(r) + v | l << v | f, to = b + n;
    } else eo = 1 << b | l << v | f, to = n;
  }
  function Bc(n) {
    n.return !== null && (os(n, 1), ug(n, 1, 0));
  }
  function Wc(n) {
    for (; n === di; ) di = ui[--ci], ui[ci] = null, Eo = ui[--ci], ui[ci] = null;
    for (; n === qr; ) qr = vn[--pa], vn[pa] = null, to = vn[--pa], vn[pa] = null, eo = vn[--pa], vn[pa] = null;
  }
  var Nr = null, Or = null, Gt = !1, ha = null;
  function fp(n, r) {
    var l = ya(5, null, null, 0);
    l.elementType = "DELETED", l.stateNode = r, l.return = n, r = n.deletions, r === null ? (n.deletions = [l], n.flags |= 16) : r.push(l);
  }
  function cg(n, r) {
    switch (n.tag) {
      case 5:
        var l = n.type;
        return r = r.nodeType !== 1 || l.toLowerCase() !== r.nodeName.toLowerCase() ? null : r, r !== null ? (n.stateNode = r, Nr = n, Or = Ya(r.firstChild), !0) : !1;
      case 6:
        return r = n.pendingProps === "" || r.nodeType !== 3 ? null : r, r !== null ? (n.stateNode = r, Nr = n, Or = null, !0) : !1;
      case 13:
        return r = r.nodeType !== 8 ? null : r, r !== null ? (l = qr !== null ? { id: eo, overflow: to } : null, n.memoizedState = { dehydrated: r, treeContext: l, retryLane: 1073741824 }, l = ya(18, null, null, 0), l.stateNode = r, l.return = n, n.child = l, Nr = n, Or = null, !0) : !1;
      default:
        return !1;
    }
  }
  function pp(n) {
    return (n.mode & 1) !== 0 && (n.flags & 128) === 0;
  }
  function hp(n) {
    if (Gt) {
      var r = Or;
      if (r) {
        var l = r;
        if (!cg(n, r)) {
          if (pp(n)) throw Error(s(418));
          r = Ya(l.nextSibling);
          var f = Nr;
          r && cg(n, r) ? fp(f, l) : (n.flags = n.flags & -4097 | 2, Gt = !1, Nr = n);
        }
      } else {
        if (pp(n)) throw Error(s(418));
        n.flags = n.flags & -4097 | 2, Gt = !1, Nr = n;
      }
    }
  }
  function En(n) {
    for (n = n.return; n !== null && n.tag !== 5 && n.tag !== 3 && n.tag !== 13; ) n = n.return;
    Nr = n;
  }
  function qc(n) {
    if (n !== Nr) return !1;
    if (!Gt) return En(n), Gt = !0, !1;
    var r;
    if ((r = n.tag !== 3) && !(r = n.tag !== 5) && (r = n.type, r = r !== "head" && r !== "body" && !Fc(n.type, n.memoizedProps)), r && (r = Or)) {
      if (pp(n)) throw hu(), Error(s(418));
      for (; r; ) fp(n, r), r = Ya(r.nextSibling);
    }
    if (En(n), n.tag === 13) {
      if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n) throw Error(s(317));
      e: {
        for (n = n.nextSibling, r = 0; n; ) {
          if (n.nodeType === 8) {
            var l = n.data;
            if (l === "/$") {
              if (r === 0) {
                Or = Ya(n.nextSibling);
                break e;
              }
              r--;
            } else l !== "$" && l !== "$!" && l !== "$?" || r++;
          }
          n = n.nextSibling;
        }
        Or = null;
      }
    } else Or = Nr ? Ya(n.stateNode.nextSibling) : null;
    return !0;
  }
  function hu() {
    for (var n = Or; n; ) n = Ya(n.nextSibling);
  }
  function fi() {
    Or = Nr = null, Gt = !1;
  }
  function Co(n) {
    ha === null ? ha = [n] : ha.push(n);
  }
  var Tb = qe.ReactCurrentBatchConfig;
  function is(n, r, l) {
    if (n = l.ref, n !== null && typeof n != "function" && typeof n != "object") {
      if (l._owner) {
        if (l = l._owner, l) {
          if (l.tag !== 1) throw Error(s(309));
          var f = l.stateNode;
        }
        if (!f) throw Error(s(147, n));
        var v = f, b = "" + n;
        return r !== null && r.ref !== null && typeof r.ref == "function" && r.ref._stringRef === b ? r.ref : (r = function(x) {
          var N = v.refs;
          x === null ? delete N[b] : N[b] = x;
        }, r._stringRef = b, r);
      }
      if (typeof n != "string") throw Error(s(284));
      if (!l._owner) throw Error(s(290, n));
    }
    return n;
  }
  function Hc(n, r) {
    throw n = Object.prototype.toString.call(r), Error(s(31, n === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : n));
  }
  function dg(n) {
    var r = n._init;
    return r(n._payload);
  }
  function ss(n) {
    function r(j, I) {
      if (n) {
        var F = j.deletions;
        F === null ? (j.deletions = [I], j.flags |= 16) : F.push(I);
      }
    }
    function l(j, I) {
      if (!n) return null;
      for (; I !== null; ) r(j, I), I = I.sibling;
      return null;
    }
    function f(j, I) {
      for (j = /* @__PURE__ */ new Map(); I !== null; ) I.key !== null ? j.set(I.key, I) : j.set(I.index, I), I = I.sibling;
      return j;
    }
    function v(j, I) {
      return j = Io(j, I), j.index = 0, j.sibling = null, j;
    }
    function b(j, I, F) {
      return j.index = F, n ? (F = j.alternate, F !== null ? (F = F.index, F < I ? (j.flags |= 2, I) : F) : (j.flags |= 2, I)) : (j.flags |= 1048576, I);
    }
    function x(j) {
      return n && j.alternate === null && (j.flags |= 2), j;
    }
    function N(j, I, F, se) {
      return I === null || I.tag !== 6 ? (I = Td(F, j.mode, se), I.return = j, I) : (I = v(I, F), I.return = j, I);
    }
    function D(j, I, F, se) {
      var je = F.type;
      return je === Oe ? te(j, I, F.props.children, se, F.key) : I !== null && (I.elementType === je || typeof je == "object" && je !== null && je.$$typeof === _t && dg(je) === I.type) ? (se = v(I, F.props), se.ref = is(j, I, F), se.return = j, se) : (se = bl(F.type, F.key, F.props, null, j.mode, se), se.ref = is(j, I, F), se.return = j, se);
    }
    function q(j, I, F, se) {
      return I === null || I.tag !== 4 || I.stateNode.containerInfo !== F.containerInfo || I.stateNode.implementation !== F.implementation ? (I = Rd(F, j.mode, se), I.return = j, I) : (I = v(I, F.children || []), I.return = j, I);
    }
    function te(j, I, F, se, je) {
      return I === null || I.tag !== 7 ? (I = ja(F, j.mode, se, je), I.return = j, I) : (I = v(I, F), I.return = j, I);
    }
    function ne(j, I, F) {
      if (typeof I == "string" && I !== "" || typeof I == "number") return I = Td("" + I, j.mode, F), I.return = j, I;
      if (typeof I == "object" && I !== null) {
        switch (I.$$typeof) {
          case Re:
            return F = bl(I.type, I.key, I.props, null, j.mode, F), F.ref = is(j, null, I), F.return = j, F;
          case ft:
            return I = Rd(I, j.mode, F), I.return = j, I;
          case _t:
            var se = I._init;
            return ne(j, se(I._payload), F);
        }
        if (Q(I) || ke(I)) return I = ja(I, j.mode, F, null), I.return = j, I;
        Hc(j, I);
      }
      return null;
    }
    function ee(j, I, F, se) {
      var je = I !== null ? I.key : null;
      if (typeof F == "string" && F !== "" || typeof F == "number") return je !== null ? null : N(j, I, "" + F, se);
      if (typeof F == "object" && F !== null) {
        switch (F.$$typeof) {
          case Re:
            return F.key === je ? D(j, I, F, se) : null;
          case ft:
            return F.key === je ? q(j, I, F, se) : null;
          case _t:
            return je = F._init, ee(
              j,
              I,
              je(F._payload),
              se
            );
        }
        if (Q(F) || ke(F)) return je !== null ? null : te(j, I, F, se, null);
        Hc(j, F);
      }
      return null;
    }
    function Se(j, I, F, se, je) {
      if (typeof se == "string" && se !== "" || typeof se == "number") return j = j.get(F) || null, N(I, j, "" + se, je);
      if (typeof se == "object" && se !== null) {
        switch (se.$$typeof) {
          case Re:
            return j = j.get(se.key === null ? F : se.key) || null, D(I, j, se, je);
          case ft:
            return j = j.get(se.key === null ? F : se.key) || null, q(I, j, se, je);
          case _t:
            var Ge = se._init;
            return Se(j, I, F, Ge(se._payload), je);
        }
        if (Q(se) || ke(se)) return j = j.get(F) || null, te(I, j, se, je, null);
        Hc(I, se);
      }
      return null;
    }
    function De(j, I, F, se) {
      for (var je = null, Ge = null, Ze = I, tt = I = 0, An = null; Ze !== null && tt < F.length; tt++) {
        Ze.index > tt ? (An = Ze, Ze = null) : An = Ze.sibling;
        var Pt = ee(j, Ze, F[tt], se);
        if (Pt === null) {
          Ze === null && (Ze = An);
          break;
        }
        n && Ze && Pt.alternate === null && r(j, Ze), I = b(Pt, I, tt), Ge === null ? je = Pt : Ge.sibling = Pt, Ge = Pt, Ze = An;
      }
      if (tt === F.length) return l(j, Ze), Gt && os(j, tt), je;
      if (Ze === null) {
        for (; tt < F.length; tt++) Ze = ne(j, F[tt], se), Ze !== null && (I = b(Ze, I, tt), Ge === null ? je = Ze : Ge.sibling = Ze, Ge = Ze);
        return Gt && os(j, tt), je;
      }
      for (Ze = f(j, Ze); tt < F.length; tt++) An = Se(Ze, j, tt, F[tt], se), An !== null && (n && An.alternate !== null && Ze.delete(An.key === null ? tt : An.key), I = b(An, I, tt), Ge === null ? je = An : Ge.sibling = An, Ge = An);
      return n && Ze.forEach(function(Ao) {
        return r(j, Ao);
      }), Gt && os(j, tt), je;
    }
    function Me(j, I, F, se) {
      var je = ke(F);
      if (typeof je != "function") throw Error(s(150));
      if (F = je.call(F), F == null) throw Error(s(151));
      for (var Ge = je = null, Ze = I, tt = I = 0, An = null, Pt = F.next(); Ze !== null && !Pt.done; tt++, Pt = F.next()) {
        Ze.index > tt ? (An = Ze, Ze = null) : An = Ze.sibling;
        var Ao = ee(j, Ze, Pt.value, se);
        if (Ao === null) {
          Ze === null && (Ze = An);
          break;
        }
        n && Ze && Ao.alternate === null && r(j, Ze), I = b(Ao, I, tt), Ge === null ? je = Ao : Ge.sibling = Ao, Ge = Ao, Ze = An;
      }
      if (Pt.done) return l(
        j,
        Ze
      ), Gt && os(j, tt), je;
      if (Ze === null) {
        for (; !Pt.done; tt++, Pt = F.next()) Pt = ne(j, Pt.value, se), Pt !== null && (I = b(Pt, I, tt), Ge === null ? je = Pt : Ge.sibling = Pt, Ge = Pt);
        return Gt && os(j, tt), je;
      }
      for (Ze = f(j, Ze); !Pt.done; tt++, Pt = F.next()) Pt = Se(Ze, j, tt, Pt.value, se), Pt !== null && (n && Pt.alternate !== null && Ze.delete(Pt.key === null ? tt : Pt.key), I = b(Pt, I, tt), Ge === null ? je = Pt : Ge.sibling = Pt, Ge = Pt);
      return n && Ze.forEach(function(Kg) {
        return r(j, Kg);
      }), Gt && os(j, tt), je;
    }
    function dn(j, I, F, se) {
      if (typeof F == "object" && F !== null && F.type === Oe && F.key === null && (F = F.props.children), typeof F == "object" && F !== null) {
        switch (F.$$typeof) {
          case Re:
            e: {
              for (var je = F.key, Ge = I; Ge !== null; ) {
                if (Ge.key === je) {
                  if (je = F.type, je === Oe) {
                    if (Ge.tag === 7) {
                      l(j, Ge.sibling), I = v(Ge, F.props.children), I.return = j, j = I;
                      break e;
                    }
                  } else if (Ge.elementType === je || typeof je == "object" && je !== null && je.$$typeof === _t && dg(je) === Ge.type) {
                    l(j, Ge.sibling), I = v(Ge, F.props), I.ref = is(j, Ge, F), I.return = j, j = I;
                    break e;
                  }
                  l(j, Ge);
                  break;
                } else r(j, Ge);
                Ge = Ge.sibling;
              }
              F.type === Oe ? (I = ja(F.props.children, j.mode, se, F.key), I.return = j, j = I) : (se = bl(F.type, F.key, F.props, null, j.mode, se), se.ref = is(j, I, F), se.return = j, j = se);
            }
            return x(j);
          case ft:
            e: {
              for (Ge = F.key; I !== null; ) {
                if (I.key === Ge) if (I.tag === 4 && I.stateNode.containerInfo === F.containerInfo && I.stateNode.implementation === F.implementation) {
                  l(j, I.sibling), I = v(I, F.children || []), I.return = j, j = I;
                  break e;
                } else {
                  l(j, I);
                  break;
                }
                else r(j, I);
                I = I.sibling;
              }
              I = Rd(F, j.mode, se), I.return = j, j = I;
            }
            return x(j);
          case _t:
            return Ge = F._init, dn(j, I, Ge(F._payload), se);
        }
        if (Q(F)) return De(j, I, F, se);
        if (ke(F)) return Me(j, I, F, se);
        Hc(j, F);
      }
      return typeof F == "string" && F !== "" || typeof F == "number" ? (F = "" + F, I !== null && I.tag === 6 ? (l(j, I.sibling), I = v(I, F), I.return = j, j = I) : (l(j, I), I = Td(F, j.mode, se), I.return = j, j = I), x(j)) : l(j, I);
    }
    return dn;
  }
  var ln = ss(!0), be = ss(!1), Hr = Da(null), Lr = null, pl = null, mp = null;
  function gp() {
    mp = pl = Lr = null;
  }
  function vp(n) {
    var r = Hr.current;
    Ht(Hr), n._currentValue = r;
  }
  function yp(n, r, l) {
    for (; n !== null; ) {
      var f = n.alternate;
      if ((n.childLanes & r) !== r ? (n.childLanes |= r, f !== null && (f.childLanes |= r)) : f !== null && (f.childLanes & r) !== r && (f.childLanes |= r), n === l) break;
      n = n.return;
    }
  }
  function Jt(n, r) {
    Lr = n, mp = pl = null, n = n.dependencies, n !== null && n.firstContext !== null && (n.lanes & r && (bn = !0), n.firstContext = null);
  }
  function ma(n) {
    var r = n._currentValue;
    if (mp !== n) if (n = { context: n, memoizedValue: r, next: null }, pl === null) {
      if (Lr === null) throw Error(s(308));
      pl = n, Lr.dependencies = { lanes: 0, firstContext: n };
    } else pl = pl.next = n;
    return r;
  }
  var ls = null;
  function bp(n) {
    ls === null ? ls = [n] : ls.push(n);
  }
  function _p(n, r, l, f) {
    var v = r.interleaved;
    return v === null ? (l.next = l, bp(r)) : (l.next = v.next, v.next = l), r.interleaved = l, Zr(n, f);
  }
  function Zr(n, r) {
    n.lanes |= r;
    var l = n.alternate;
    for (l !== null && (l.lanes |= r), l = n, n = n.return; n !== null; ) n.childLanes |= r, l = n.alternate, l !== null && (l.childLanes |= r), l = n, n = n.return;
    return l.tag === 3 ? l.stateNode : null;
  }
  var Qr = !1;
  function wp(n) {
    n.updateQueue = { baseState: n.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function fg(n, r) {
    n = n.updateQueue, r.updateQueue === n && (r.updateQueue = { baseState: n.baseState, firstBaseUpdate: n.firstBaseUpdate, lastBaseUpdate: n.lastBaseUpdate, shared: n.shared, effects: n.effects });
  }
  function To(n, r) {
    return { eventTime: n, lane: r, tag: 0, payload: null, callback: null, next: null };
  }
  function pi(n, r, l) {
    var f = n.updateQueue;
    if (f === null) return null;
    if (f = f.shared, St & 2) {
      var v = f.pending;
      return v === null ? r.next = r : (r.next = v.next, v.next = r), f.pending = r, Zr(n, l);
    }
    return v = f.interleaved, v === null ? (r.next = r, bp(f)) : (r.next = v.next, v.next = r), f.interleaved = r, Zr(n, l);
  }
  function Zc(n, r, l) {
    if (r = r.updateQueue, r !== null && (r = r.shared, (l & 4194240) !== 0)) {
      var f = r.lanes;
      f &= n.pendingLanes, l |= f, r.lanes = l, gc(n, l);
    }
  }
  function pg(n, r) {
    var l = n.updateQueue, f = n.alternate;
    if (f !== null && (f = f.updateQueue, l === f)) {
      var v = null, b = null;
      if (l = l.firstBaseUpdate, l !== null) {
        do {
          var x = { eventTime: l.eventTime, lane: l.lane, tag: l.tag, payload: l.payload, callback: l.callback, next: null };
          b === null ? v = b = x : b = b.next = x, l = l.next;
        } while (l !== null);
        b === null ? v = b = r : b = b.next = r;
      } else v = b = r;
      l = { baseState: f.baseState, firstBaseUpdate: v, lastBaseUpdate: b, shared: f.shared, effects: f.effects }, n.updateQueue = l;
      return;
    }
    n = l.lastBaseUpdate, n === null ? l.firstBaseUpdate = r : n.next = r, l.lastBaseUpdate = r;
  }
  function mu(n, r, l, f) {
    var v = n.updateQueue;
    Qr = !1;
    var b = v.firstBaseUpdate, x = v.lastBaseUpdate, N = v.shared.pending;
    if (N !== null) {
      v.shared.pending = null;
      var D = N, q = D.next;
      D.next = null, x === null ? b = q : x.next = q, x = D;
      var te = n.alternate;
      te !== null && (te = te.updateQueue, N = te.lastBaseUpdate, N !== x && (N === null ? te.firstBaseUpdate = q : N.next = q, te.lastBaseUpdate = D));
    }
    if (b !== null) {
      var ne = v.baseState;
      x = 0, te = q = D = null, N = b;
      do {
        var ee = N.lane, Se = N.eventTime;
        if ((f & ee) === ee) {
          te !== null && (te = te.next = {
            eventTime: Se,
            lane: 0,
            tag: N.tag,
            payload: N.payload,
            callback: N.callback,
            next: null
          });
          e: {
            var De = n, Me = N;
            switch (ee = r, Se = l, Me.tag) {
              case 1:
                if (De = Me.payload, typeof De == "function") {
                  ne = De.call(Se, ne, ee);
                  break e;
                }
                ne = De;
                break e;
              case 3:
                De.flags = De.flags & -65537 | 128;
              case 0:
                if (De = Me.payload, ee = typeof De == "function" ? De.call(Se, ne, ee) : De, ee == null) break e;
                ne = pe({}, ne, ee);
                break e;
              case 2:
                Qr = !0;
            }
          }
          N.callback !== null && N.lane !== 0 && (n.flags |= 64, ee = v.effects, ee === null ? v.effects = [N] : ee.push(N));
        } else Se = { eventTime: Se, lane: ee, tag: N.tag, payload: N.payload, callback: N.callback, next: null }, te === null ? (q = te = Se, D = ne) : te = te.next = Se, x |= ee;
        if (N = N.next, N === null) {
          if (N = v.shared.pending, N === null) break;
          ee = N, N = ee.next, ee.next = null, v.lastBaseUpdate = ee, v.shared.pending = null;
        }
      } while (!0);
      if (te === null && (D = ne), v.baseState = D, v.firstBaseUpdate = q, v.lastBaseUpdate = te, r = v.shared.interleaved, r !== null) {
        v = r;
        do
          x |= v.lane, v = v.next;
        while (v !== r);
      } else b === null && (v.shared.lanes = 0);
      Oo |= x, n.lanes = x, n.memoizedState = ne;
    }
  }
  function kp(n, r, l) {
    if (n = r.effects, r.effects = null, n !== null) for (r = 0; r < n.length; r++) {
      var f = n[r], v = f.callback;
      if (v !== null) {
        if (f.callback = null, f = l, typeof v != "function") throw Error(s(191, v));
        v.call(f);
      }
    }
  }
  var gu = {}, no = Da(gu), vu = Da(gu), yu = Da(gu);
  function us(n) {
    if (n === gu) throw Error(s(174));
    return n;
  }
  function xp(n, r) {
    switch (Be(yu, r), Be(vu, n), Be(no, gu), n = r.nodeType, n) {
      case 9:
      case 11:
        r = (r = r.documentElement) ? r.namespaceURI : Zt(null, "");
        break;
      default:
        n = n === 8 ? r.parentNode : r, r = n.namespaceURI || null, n = n.tagName, r = Zt(r, n);
    }
    Ht(no), Be(no, r);
  }
  function cs() {
    Ht(no), Ht(vu), Ht(yu);
  }
  function hg(n) {
    us(yu.current);
    var r = us(no.current), l = Zt(r, n.type);
    r !== l && (Be(vu, n), Be(no, l));
  }
  function Qc(n) {
    vu.current === n && (Ht(no), Ht(vu));
  }
  var Xt = Da(0);
  function Kc(n) {
    for (var r = n; r !== null; ) {
      if (r.tag === 13) {
        var l = r.memoizedState;
        if (l !== null && (l = l.dehydrated, l === null || l.data === "$?" || l.data === "$!")) return r;
      } else if (r.tag === 19 && r.memoizedProps.revealOrder !== void 0) {
        if (r.flags & 128) return r;
      } else if (r.child !== null) {
        r.child.return = r, r = r.child;
        continue;
      }
      if (r === n) break;
      for (; r.sibling === null; ) {
        if (r.return === null || r.return === n) return null;
        r = r.return;
      }
      r.sibling.return = r.return, r = r.sibling;
    }
    return null;
  }
  var bu = [];
  function He() {
    for (var n = 0; n < bu.length; n++) bu[n]._workInProgressVersionPrimary = null;
    bu.length = 0;
  }
  var pt = qe.ReactCurrentDispatcher, Tt = qe.ReactCurrentBatchConfig, $t = 0, Rt = null, yn = null, Dn = null, Yc = !1, _u = !1, ds = 0, X = 0;
  function Et() {
    throw Error(s(321));
  }
  function Je(n, r) {
    if (r === null) return !1;
    for (var l = 0; l < r.length && l < n.length; l++) if (!Oa(n[l], r[l])) return !1;
    return !0;
  }
  function hi(n, r, l, f, v, b) {
    if ($t = b, Rt = r, r.memoizedState = null, r.updateQueue = null, r.lanes = 0, pt.current = n === null || n.memoizedState === null ? dd : Cu, n = l(f, v), _u) {
      b = 0;
      do {
        if (_u = !1, ds = 0, 25 <= b) throw Error(s(301));
        b += 1, Dn = yn = null, r.updateQueue = null, pt.current = fd, n = l(f, v);
      } while (_u);
    }
    if (pt.current = gs, r = yn !== null && yn.next !== null, $t = 0, Dn = yn = Rt = null, Yc = !1, r) throw Error(s(300));
    return n;
  }
  function za() {
    var n = ds !== 0;
    return ds = 0, n;
  }
  function ur() {
    var n = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return Dn === null ? Rt.memoizedState = Dn = n : Dn = Dn.next = n, Dn;
  }
  function un() {
    if (yn === null) {
      var n = Rt.alternate;
      n = n !== null ? n.memoizedState : null;
    } else n = yn.next;
    var r = Dn === null ? Rt.memoizedState : Dn.next;
    if (r !== null) Dn = r, yn = n;
    else {
      if (n === null) throw Error(s(310));
      yn = n, n = { memoizedState: yn.memoizedState, baseState: yn.baseState, baseQueue: yn.baseQueue, queue: yn.queue, next: null }, Dn === null ? Rt.memoizedState = Dn = n : Dn = Dn.next = n;
    }
    return Dn;
  }
  function Ro(n, r) {
    return typeof r == "function" ? r(n) : r;
  }
  function mi(n) {
    var r = un(), l = r.queue;
    if (l === null) throw Error(s(311));
    l.lastRenderedReducer = n;
    var f = yn, v = f.baseQueue, b = l.pending;
    if (b !== null) {
      if (v !== null) {
        var x = v.next;
        v.next = b.next, b.next = x;
      }
      f.baseQueue = v = b, l.pending = null;
    }
    if (v !== null) {
      b = v.next, f = f.baseState;
      var N = x = null, D = null, q = b;
      do {
        var te = q.lane;
        if (($t & te) === te) D !== null && (D = D.next = { lane: 0, action: q.action, hasEagerState: q.hasEagerState, eagerState: q.eagerState, next: null }), f = q.hasEagerState ? q.eagerState : n(f, q.action);
        else {
          var ne = {
            lane: te,
            action: q.action,
            hasEagerState: q.hasEagerState,
            eagerState: q.eagerState,
            next: null
          };
          D === null ? (N = D = ne, x = f) : D = D.next = ne, Rt.lanes |= te, Oo |= te;
        }
        q = q.next;
      } while (q !== null && q !== b);
      D === null ? x = f : D.next = N, Oa(f, r.memoizedState) || (bn = !0), r.memoizedState = f, r.baseState = x, r.baseQueue = D, l.lastRenderedState = f;
    }
    if (n = l.interleaved, n !== null) {
      v = n;
      do
        b = v.lane, Rt.lanes |= b, Oo |= b, v = v.next;
      while (v !== n);
    } else v === null && (l.lanes = 0);
    return [r.memoizedState, l.dispatch];
  }
  function fs(n) {
    var r = un(), l = r.queue;
    if (l === null) throw Error(s(311));
    l.lastRenderedReducer = n;
    var f = l.dispatch, v = l.pending, b = r.memoizedState;
    if (v !== null) {
      l.pending = null;
      var x = v = v.next;
      do
        b = n(b, x.action), x = x.next;
      while (x !== v);
      Oa(b, r.memoizedState) || (bn = !0), r.memoizedState = b, r.baseQueue === null && (r.baseState = b), l.lastRenderedState = b;
    }
    return [b, f];
  }
  function Gc() {
  }
  function Jc(n, r) {
    var l = Rt, f = un(), v = r(), b = !Oa(f.memoizedState, v);
    if (b && (f.memoizedState = v, bn = !0), f = f.queue, wu(td.bind(null, l, f, n), [n]), f.getSnapshot !== r || b || Dn !== null && Dn.memoizedState.tag & 1) {
      if (l.flags |= 2048, ps(9, ed.bind(null, l, f, v, r), void 0, null), In === null) throw Error(s(349));
      $t & 30 || Xc(l, r, v);
    }
    return v;
  }
  function Xc(n, r, l) {
    n.flags |= 16384, n = { getSnapshot: r, value: l }, r = Rt.updateQueue, r === null ? (r = { lastEffect: null, stores: null }, Rt.updateQueue = r, r.stores = [n]) : (l = r.stores, l === null ? r.stores = [n] : l.push(n));
  }
  function ed(n, r, l, f) {
    r.value = l, r.getSnapshot = f, nd(r) && rd(n);
  }
  function td(n, r, l) {
    return l(function() {
      nd(r) && rd(n);
    });
  }
  function nd(n) {
    var r = n.getSnapshot;
    n = n.value;
    try {
      var l = r();
      return !Oa(n, l);
    } catch {
      return !0;
    }
  }
  function rd(n) {
    var r = Zr(n, 1);
    r !== null && $a(r, n, 1, -1);
  }
  function ad(n) {
    var r = ur();
    return typeof n == "function" && (n = n()), r.memoizedState = r.baseState = n, n = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Ro, lastRenderedState: n }, r.queue = n, n = n.dispatch = ms.bind(null, Rt, n), [r.memoizedState, n];
  }
  function ps(n, r, l, f) {
    return n = { tag: n, create: r, destroy: l, deps: f, next: null }, r = Rt.updateQueue, r === null ? (r = { lastEffect: null, stores: null }, Rt.updateQueue = r, r.lastEffect = n.next = n) : (l = r.lastEffect, l === null ? r.lastEffect = n.next = n : (f = l.next, l.next = n, n.next = f, r.lastEffect = n)), n;
  }
  function od() {
    return un().memoizedState;
  }
  function hl(n, r, l, f) {
    var v = ur();
    Rt.flags |= n, v.memoizedState = ps(1 | r, l, void 0, f === void 0 ? null : f);
  }
  function ml(n, r, l, f) {
    var v = un();
    f = f === void 0 ? null : f;
    var b = void 0;
    if (yn !== null) {
      var x = yn.memoizedState;
      if (b = x.destroy, f !== null && Je(f, x.deps)) {
        v.memoizedState = ps(r, l, b, f);
        return;
      }
    }
    Rt.flags |= n, v.memoizedState = ps(1 | r, l, b, f);
  }
  function id(n, r) {
    return hl(8390656, 8, n, r);
  }
  function wu(n, r) {
    return ml(2048, 8, n, r);
  }
  function sd(n, r) {
    return ml(4, 2, n, r);
  }
  function ku(n, r) {
    return ml(4, 4, n, r);
  }
  function hs(n, r) {
    if (typeof r == "function") return n = n(), r(n), function() {
      r(null);
    };
    if (r != null) return n = n(), r.current = n, function() {
      r.current = null;
    };
  }
  function ld(n, r, l) {
    return l = l != null ? l.concat([n]) : null, ml(4, 4, hs.bind(null, r, n), l);
  }
  function xu() {
  }
  function ud(n, r) {
    var l = un();
    r = r === void 0 ? null : r;
    var f = l.memoizedState;
    return f !== null && r !== null && Je(r, f[1]) ? f[0] : (l.memoizedState = [n, r], n);
  }
  function cd(n, r) {
    var l = un();
    r = r === void 0 ? null : r;
    var f = l.memoizedState;
    return f !== null && r !== null && Je(r, f[1]) ? f[0] : (n = n(), l.memoizedState = [n, r], n);
  }
  function Sp(n, r, l) {
    return $t & 21 ? (Oa(l, r) || (l = mc(), Rt.lanes |= l, Oo |= l, n.baseState = !0), r) : (n.baseState && (n.baseState = !1, bn = !0), n.memoizedState = l);
  }
  function Su(n, r) {
    var l = It;
    It = l !== 0 && 4 > l ? l : 4, n(!0);
    var f = Tt.transition;
    Tt.transition = {};
    try {
      n(!1), r();
    } finally {
      It = l, Tt.transition = f;
    }
  }
  function Ep() {
    return un().memoizedState;
  }
  function Eu(n, r, l) {
    var f = va(n);
    if (l = { lane: f, action: l, hasEagerState: !1, eagerState: null, next: null }, Kr(n)) mg(r, l);
    else if (l = _p(n, r, l, f), l !== null) {
      var v = Kn();
      $a(l, n, f, v), Wt(l, r, f);
    }
  }
  function ms(n, r, l) {
    var f = va(n), v = { lane: f, action: l, hasEagerState: !1, eagerState: null, next: null };
    if (Kr(n)) mg(r, v);
    else {
      var b = n.alternate;
      if (n.lanes === 0 && (b === null || b.lanes === 0) && (b = r.lastRenderedReducer, b !== null)) try {
        var x = r.lastRenderedState, N = b(x, l);
        if (v.hasEagerState = !0, v.eagerState = N, Oa(N, x)) {
          var D = r.interleaved;
          D === null ? (v.next = v, bp(r)) : (v.next = D.next, D.next = v), r.interleaved = v;
          return;
        }
      } catch {
      } finally {
      }
      l = _p(n, r, v, f), l !== null && (v = Kn(), $a(l, n, f, v), Wt(l, r, f));
    }
  }
  function Kr(n) {
    var r = n.alternate;
    return n === Rt || r !== null && r === Rt;
  }
  function mg(n, r) {
    _u = Yc = !0;
    var l = n.pending;
    l === null ? r.next = r : (r.next = l.next, l.next = r), n.pending = r;
  }
  function Wt(n, r, l) {
    if (l & 4194240) {
      var f = r.lanes;
      f &= n.pendingLanes, l |= f, r.lanes = l, gc(n, l);
    }
  }
  var gs = { readContext: ma, useCallback: Et, useContext: Et, useEffect: Et, useImperativeHandle: Et, useInsertionEffect: Et, useLayoutEffect: Et, useMemo: Et, useReducer: Et, useRef: Et, useState: Et, useDebugValue: Et, useDeferredValue: Et, useTransition: Et, useMutableSource: Et, useSyncExternalStore: Et, useId: Et, unstable_isNewReconciler: !1 }, dd = { readContext: ma, useCallback: function(n, r) {
    return ur().memoizedState = [n, r === void 0 ? null : r], n;
  }, useContext: ma, useEffect: id, useImperativeHandle: function(n, r, l) {
    return l = l != null ? l.concat([n]) : null, hl(
      4194308,
      4,
      hs.bind(null, r, n),
      l
    );
  }, useLayoutEffect: function(n, r) {
    return hl(4194308, 4, n, r);
  }, useInsertionEffect: function(n, r) {
    return hl(4, 2, n, r);
  }, useMemo: function(n, r) {
    var l = ur();
    return r = r === void 0 ? null : r, n = n(), l.memoizedState = [n, r], n;
  }, useReducer: function(n, r, l) {
    var f = ur();
    return r = l !== void 0 ? l(r) : r, f.memoizedState = f.baseState = r, n = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: n, lastRenderedState: r }, f.queue = n, n = n.dispatch = Eu.bind(null, Rt, n), [f.memoizedState, n];
  }, useRef: function(n) {
    var r = ur();
    return n = { current: n }, r.memoizedState = n;
  }, useState: ad, useDebugValue: xu, useDeferredValue: function(n) {
    return ur().memoizedState = n;
  }, useTransition: function() {
    var n = ad(!1), r = n[0];
    return n = Su.bind(null, n[1]), ur().memoizedState = n, [r, n];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(n, r, l) {
    var f = Rt, v = ur();
    if (Gt) {
      if (l === void 0) throw Error(s(407));
      l = l();
    } else {
      if (l = r(), In === null) throw Error(s(349));
      $t & 30 || Xc(f, r, l);
    }
    v.memoizedState = l;
    var b = { value: l, getSnapshot: r };
    return v.queue = b, id(td.bind(
      null,
      f,
      b,
      n
    ), [n]), f.flags |= 2048, ps(9, ed.bind(null, f, b, l, r), void 0, null), l;
  }, useId: function() {
    var n = ur(), r = In.identifierPrefix;
    if (Gt) {
      var l = to, f = eo;
      l = (f & ~(1 << 32 - sa(f) - 1)).toString(32) + l, r = ":" + r + "R" + l, l = ds++, 0 < l && (r += "H" + l.toString(32)), r += ":";
    } else l = X++, r = ":" + r + "r" + l.toString(32) + ":";
    return n.memoizedState = r;
  }, unstable_isNewReconciler: !1 }, Cu = {
    readContext: ma,
    useCallback: ud,
    useContext: ma,
    useEffect: wu,
    useImperativeHandle: ld,
    useInsertionEffect: sd,
    useLayoutEffect: ku,
    useMemo: cd,
    useReducer: mi,
    useRef: od,
    useState: function() {
      return mi(Ro);
    },
    useDebugValue: xu,
    useDeferredValue: function(n) {
      var r = un();
      return Sp(r, yn.memoizedState, n);
    },
    useTransition: function() {
      var n = mi(Ro)[0], r = un().memoizedState;
      return [n, r];
    },
    useMutableSource: Gc,
    useSyncExternalStore: Jc,
    useId: Ep,
    unstable_isNewReconciler: !1
  }, fd = { readContext: ma, useCallback: ud, useContext: ma, useEffect: wu, useImperativeHandle: ld, useInsertionEffect: sd, useLayoutEffect: ku, useMemo: cd, useReducer: fs, useRef: od, useState: function() {
    return fs(Ro);
  }, useDebugValue: xu, useDeferredValue: function(n) {
    var r = un();
    return yn === null ? r.memoizedState = n : Sp(r, yn.memoizedState, n);
  }, useTransition: function() {
    var n = fs(Ro)[0], r = un().memoizedState;
    return [n, r];
  }, useMutableSource: Gc, useSyncExternalStore: Jc, useId: Ep, unstable_isNewReconciler: !1 };
  function Ia(n, r) {
    if (n && n.defaultProps) {
      r = pe({}, r), n = n.defaultProps;
      for (var l in n) r[l] === void 0 && (r[l] = n[l]);
      return r;
    }
    return r;
  }
  function Cp(n, r, l, f) {
    r = n.memoizedState, l = l(f, r), l = l == null ? r : pe({}, r, l), n.memoizedState = l, n.lanes === 0 && (n.updateQueue.baseState = l);
  }
  var pd = { isMounted: function(n) {
    return (n = n._reactInternals) ? Ra(n) === n : !1;
  }, enqueueSetState: function(n, r, l) {
    n = n._reactInternals;
    var f = Kn(), v = va(n), b = To(f, v);
    b.payload = r, l != null && (b.callback = l), r = pi(n, b, v), r !== null && ($a(r, n, v, f), Zc(r, n, v));
  }, enqueueReplaceState: function(n, r, l) {
    n = n._reactInternals;
    var f = Kn(), v = va(n), b = To(f, v);
    b.tag = 1, b.payload = r, l != null && (b.callback = l), r = pi(n, b, v), r !== null && ($a(r, n, v, f), Zc(r, n, v));
  }, enqueueForceUpdate: function(n, r) {
    n = n._reactInternals;
    var l = Kn(), f = va(n), v = To(l, f);
    v.tag = 2, r != null && (v.callback = r), r = pi(n, v, f), r !== null && ($a(r, n, f, l), Zc(r, n, f));
  } };
  function gg(n, r, l, f, v, b, x) {
    return n = n.stateNode, typeof n.shouldComponentUpdate == "function" ? n.shouldComponentUpdate(f, b, x) : r.prototype && r.prototype.isPureReactComponent ? !ou(l, f) || !ou(v, b) : !0;
  }
  function hd(n, r, l) {
    var f = !1, v = Tr, b = r.contextType;
    return typeof b == "object" && b !== null ? b = ma(b) : (v = gn(r) ? Rr : an.current, f = r.contextTypes, b = (f = f != null) ? fa(n, v) : Tr), r = new r(l, b), n.memoizedState = r.state !== null && r.state !== void 0 ? r.state : null, r.updater = pd, n.stateNode = r, r._reactInternals = n, f && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = v, n.__reactInternalMemoizedMaskedChildContext = b), r;
  }
  function vg(n, r, l, f) {
    n = r.state, typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps(l, f), typeof r.UNSAFE_componentWillReceiveProps == "function" && r.UNSAFE_componentWillReceiveProps(l, f), r.state !== n && pd.enqueueReplaceState(r, r.state, null);
  }
  function Tu(n, r, l, f) {
    var v = n.stateNode;
    v.props = l, v.state = n.memoizedState, v.refs = {}, wp(n);
    var b = r.contextType;
    typeof b == "object" && b !== null ? v.context = ma(b) : (b = gn(r) ? Rr : an.current, v.context = fa(n, b)), v.state = n.memoizedState, b = r.getDerivedStateFromProps, typeof b == "function" && (Cp(n, r, b, l), v.state = n.memoizedState), typeof r.getDerivedStateFromProps == "function" || typeof v.getSnapshotBeforeUpdate == "function" || typeof v.UNSAFE_componentWillMount != "function" && typeof v.componentWillMount != "function" || (r = v.state, typeof v.componentWillMount == "function" && v.componentWillMount(), typeof v.UNSAFE_componentWillMount == "function" && v.UNSAFE_componentWillMount(), r !== v.state && pd.enqueueReplaceState(v, v.state, null), mu(n, l, v, f), v.state = n.memoizedState), typeof v.componentDidMount == "function" && (n.flags |= 4194308);
  }
  function vs(n, r) {
    try {
      var l = "", f = r;
      do
        l += vo(f), f = f.return;
      while (f);
      var v = l;
    } catch (b) {
      v = `
Error generating stack: ` + b.message + `
` + b.stack;
    }
    return { value: n, source: r, stack: v, digest: null };
  }
  function Tp(n, r, l) {
    return { value: n, source: null, stack: l ?? null, digest: r ?? null };
  }
  function Rp(n, r) {
    try {
      console.error(r.value);
    } catch (l) {
      setTimeout(function() {
        throw l;
      });
    }
  }
  var md = typeof WeakMap == "function" ? WeakMap : Map;
  function yg(n, r, l) {
    l = To(-1, l), l.tag = 3, l.payload = { element: null };
    var f = r.value;
    return l.callback = function() {
      ki || (ki = !0, Up = f), Rp(n, r);
    }, l;
  }
  function Pp(n, r, l) {
    l = To(-1, l), l.tag = 3;
    var f = n.type.getDerivedStateFromError;
    if (typeof f == "function") {
      var v = r.value;
      l.payload = function() {
        return f(v);
      }, l.callback = function() {
        Rp(n, r);
      };
    }
    var b = n.stateNode;
    return b !== null && typeof b.componentDidCatch == "function" && (l.callback = function() {
      Rp(n, r), typeof f != "function" && (xi === null ? xi = /* @__PURE__ */ new Set([this]) : xi.add(this));
      var x = r.stack;
      this.componentDidCatch(r.value, { componentStack: x !== null ? x : "" });
    }), l;
  }
  function Np(n, r, l) {
    var f = n.pingCache;
    if (f === null) {
      f = n.pingCache = new md();
      var v = /* @__PURE__ */ new Set();
      f.set(r, v);
    } else v = f.get(r), v === void 0 && (v = /* @__PURE__ */ new Set(), f.set(r, v));
    v.has(l) || (v.add(l), n = Ob.bind(null, n, r, l), r.then(n, n));
  }
  function bg(n) {
    do {
      var r;
      if ((r = n.tag === 13) && (r = n.memoizedState, r = r !== null ? r.dehydrated !== null : !0), r) return n;
      n = n.return;
    } while (n !== null);
    return null;
  }
  function gi(n, r, l, f, v) {
    return n.mode & 1 ? (n.flags |= 65536, n.lanes = v, n) : (n === r ? n.flags |= 65536 : (n.flags |= 128, l.flags |= 131072, l.flags &= -52805, l.tag === 1 && (l.alternate === null ? l.tag = 17 : (r = To(-1, 1), r.tag = 2, pi(l, r, 1))), l.lanes |= 1), n);
  }
  var Ru = qe.ReactCurrentOwner, bn = !1;
  function Hn(n, r, l, f) {
    r.child = n === null ? be(r, null, l, f) : ln(r, n.child, l, f);
  }
  function Dr(n, r, l, f, v) {
    l = l.render;
    var b = r.ref;
    return Jt(r, v), f = hi(n, r, l, f, b, v), l = za(), n !== null && !bn ? (r.updateQueue = n.updateQueue, r.flags &= -2053, n.lanes &= ~v, Yr(n, r, v)) : (Gt && l && Bc(r), r.flags |= 1, Hn(n, r, f, v), r.child);
  }
  function ys(n, r, l, f, v) {
    if (n === null) {
      var b = l.type;
      return typeof b == "function" && !qp(b) && b.defaultProps === void 0 && l.compare === null && l.defaultProps === void 0 ? (r.tag = 15, r.type = b, ct(n, r, b, f, v)) : (n = bl(l.type, null, f, r, r.mode, v), n.ref = r.ref, n.return = r, r.child = n);
    }
    if (b = n.child, !(n.lanes & v)) {
      var x = b.memoizedProps;
      if (l = l.compare, l = l !== null ? l : ou, l(x, f) && n.ref === r.ref) return Yr(n, r, v);
    }
    return r.flags |= 1, n = Io(b, f), n.ref = r.ref, n.return = r, r.child = n;
  }
  function ct(n, r, l, f, v) {
    if (n !== null) {
      var b = n.memoizedProps;
      if (ou(b, f) && n.ref === r.ref) if (bn = !1, r.pendingProps = f = b, (n.lanes & v) !== 0) n.flags & 131072 && (bn = !0);
      else return r.lanes = n.lanes, Yr(n, r, v);
    }
    return Lp(n, r, l, f, v);
  }
  function Pu(n, r, l) {
    var f = r.pendingProps, v = f.children, b = n !== null ? n.memoizedState : null;
    if (f.mode === "hidden") if (!(r.mode & 1)) r.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Be(_i, Gr), Gr |= l;
    else {
      if (!(l & 1073741824)) return n = b !== null ? b.baseLanes | l : l, r.lanes = r.childLanes = 1073741824, r.memoizedState = { baseLanes: n, cachePool: null, transitions: null }, r.updateQueue = null, Be(_i, Gr), Gr |= n, null;
      r.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, f = b !== null ? b.baseLanes : l, Be(_i, Gr), Gr |= f;
    }
    else b !== null ? (f = b.baseLanes | l, r.memoizedState = null) : f = l, Be(_i, Gr), Gr |= f;
    return Hn(n, r, v, l), r.child;
  }
  function Op(n, r) {
    var l = r.ref;
    (n === null && l !== null || n !== null && n.ref !== l) && (r.flags |= 512, r.flags |= 2097152);
  }
  function Lp(n, r, l, f, v) {
    var b = gn(l) ? Rr : an.current;
    return b = fa(r, b), Jt(r, v), l = hi(n, r, l, f, b, v), f = za(), n !== null && !bn ? (r.updateQueue = n.updateQueue, r.flags &= -2053, n.lanes &= ~v, Yr(n, r, v)) : (Gt && f && Bc(r), r.flags |= 1, Hn(n, r, l, v), r.child);
  }
  function gd(n, r, l, f, v) {
    if (gn(l)) {
      var b = !0;
      Pr(r);
    } else b = !1;
    if (Jt(r, v), r.stateNode === null) _s(n, r), hd(r, l, f), Tu(r, l, f, v), f = !0;
    else if (n === null) {
      var x = r.stateNode, N = r.memoizedProps;
      x.props = N;
      var D = x.context, q = l.contextType;
      typeof q == "object" && q !== null ? q = ma(q) : (q = gn(l) ? Rr : an.current, q = fa(r, q));
      var te = l.getDerivedStateFromProps, ne = typeof te == "function" || typeof x.getSnapshotBeforeUpdate == "function";
      ne || typeof x.UNSAFE_componentWillReceiveProps != "function" && typeof x.componentWillReceiveProps != "function" || (N !== f || D !== q) && vg(r, x, f, q), Qr = !1;
      var ee = r.memoizedState;
      x.state = ee, mu(r, f, x, v), D = r.memoizedState, N !== f || ee !== D || Sn.current || Qr ? (typeof te == "function" && (Cp(r, l, te, f), D = r.memoizedState), (N = Qr || gg(r, l, N, f, ee, D, q)) ? (ne || typeof x.UNSAFE_componentWillMount != "function" && typeof x.componentWillMount != "function" || (typeof x.componentWillMount == "function" && x.componentWillMount(), typeof x.UNSAFE_componentWillMount == "function" && x.UNSAFE_componentWillMount()), typeof x.componentDidMount == "function" && (r.flags |= 4194308)) : (typeof x.componentDidMount == "function" && (r.flags |= 4194308), r.memoizedProps = f, r.memoizedState = D), x.props = f, x.state = D, x.context = q, f = N) : (typeof x.componentDidMount == "function" && (r.flags |= 4194308), f = !1);
    } else {
      x = r.stateNode, fg(n, r), N = r.memoizedProps, q = r.type === r.elementType ? N : Ia(r.type, N), x.props = q, ne = r.pendingProps, ee = x.context, D = l.contextType, typeof D == "object" && D !== null ? D = ma(D) : (D = gn(l) ? Rr : an.current, D = fa(r, D));
      var Se = l.getDerivedStateFromProps;
      (te = typeof Se == "function" || typeof x.getSnapshotBeforeUpdate == "function") || typeof x.UNSAFE_componentWillReceiveProps != "function" && typeof x.componentWillReceiveProps != "function" || (N !== ne || ee !== D) && vg(r, x, f, D), Qr = !1, ee = r.memoizedState, x.state = ee, mu(r, f, x, v);
      var De = r.memoizedState;
      N !== ne || ee !== De || Sn.current || Qr ? (typeof Se == "function" && (Cp(r, l, Se, f), De = r.memoizedState), (q = Qr || gg(r, l, q, f, ee, De, D) || !1) ? (te || typeof x.UNSAFE_componentWillUpdate != "function" && typeof x.componentWillUpdate != "function" || (typeof x.componentWillUpdate == "function" && x.componentWillUpdate(f, De, D), typeof x.UNSAFE_componentWillUpdate == "function" && x.UNSAFE_componentWillUpdate(f, De, D)), typeof x.componentDidUpdate == "function" && (r.flags |= 4), typeof x.getSnapshotBeforeUpdate == "function" && (r.flags |= 1024)) : (typeof x.componentDidUpdate != "function" || N === n.memoizedProps && ee === n.memoizedState || (r.flags |= 4), typeof x.getSnapshotBeforeUpdate != "function" || N === n.memoizedProps && ee === n.memoizedState || (r.flags |= 1024), r.memoizedProps = f, r.memoizedState = De), x.props = f, x.state = De, x.context = D, f = q) : (typeof x.componentDidUpdate != "function" || N === n.memoizedProps && ee === n.memoizedState || (r.flags |= 4), typeof x.getSnapshotBeforeUpdate != "function" || N === n.memoizedProps && ee === n.memoizedState || (r.flags |= 1024), f = !1);
    }
    return bs(n, r, l, f, b, v);
  }
  function bs(n, r, l, f, v, b) {
    Op(n, r);
    var x = (r.flags & 128) !== 0;
    if (!f && !x) return v && Uc(r, l, !1), Yr(n, r, b);
    f = r.stateNode, Ru.current = r;
    var N = x && typeof l.getDerivedStateFromError != "function" ? null : f.render();
    return r.flags |= 1, n !== null && x ? (r.child = ln(r, n.child, null, b), r.child = ln(r, null, N, b)) : Hn(n, r, N, b), r.memoizedState = f.state, v && Uc(r, l, !0), r.child;
  }
  function _g(n) {
    var r = n.stateNode;
    r.pendingContext ? lg(n, r.pendingContext, r.pendingContext !== r.context) : r.context && lg(n, r.context, !1), xp(n, r.containerInfo);
  }
  function Dp(n, r, l, f, v) {
    return fi(), Co(v), r.flags |= 256, Hn(n, r, l, f), r.child;
  }
  var zp = { dehydrated: null, treeContext: null, retryLane: 0 };
  function Nu(n) {
    return { baseLanes: n, cachePool: null, transitions: null };
  }
  function wg(n, r, l) {
    var f = r.pendingProps, v = Xt.current, b = !1, x = (r.flags & 128) !== 0, N;
    if ((N = x) || (N = n !== null && n.memoizedState === null ? !1 : (v & 2) !== 0), N ? (b = !0, r.flags &= -129) : (n === null || n.memoizedState !== null) && (v |= 1), Be(Xt, v & 1), n === null)
      return hp(r), n = r.memoizedState, n !== null && (n = n.dehydrated, n !== null) ? (r.mode & 1 ? n.data === "$!" ? r.lanes = 8 : r.lanes = 1073741824 : r.lanes = 1, null) : (x = f.children, n = f.fallback, b ? (f = r.mode, b = r.child, x = { mode: "hidden", children: x }, !(f & 1) && b !== null ? (b.childLanes = 0, b.pendingProps = x) : b = Cd(x, f, 0, null), n = ja(n, f, l, null), b.return = r, n.return = r, b.sibling = n, r.child = b, r.child.memoizedState = Nu(l), r.memoizedState = zp, n) : vd(r, x));
    if (v = n.memoizedState, v !== null && (N = v.dehydrated, N !== null)) return kg(n, r, x, f, N, v, l);
    if (b) {
      b = f.fallback, x = r.mode, v = n.child, N = v.sibling;
      var D = { mode: "hidden", children: f.children };
      return !(x & 1) && r.child !== v ? (f = r.child, f.childLanes = 0, f.pendingProps = D, r.deletions = null) : (f = Io(v, D), f.subtreeFlags = v.subtreeFlags & 14680064), N !== null ? b = Io(N, b) : (b = ja(b, x, l, null), b.flags |= 2), b.return = r, f.return = r, f.sibling = b, r.child = f, f = b, b = r.child, x = n.child.memoizedState, x = x === null ? Nu(l) : { baseLanes: x.baseLanes | l, cachePool: null, transitions: x.transitions }, b.memoizedState = x, b.childLanes = n.childLanes & ~l, r.memoizedState = zp, f;
    }
    return b = n.child, n = b.sibling, f = Io(b, { mode: "visible", children: f.children }), !(r.mode & 1) && (f.lanes = l), f.return = r, f.sibling = null, n !== null && (l = r.deletions, l === null ? (r.deletions = [n], r.flags |= 16) : l.push(n)), r.child = f, r.memoizedState = null, f;
  }
  function vd(n, r) {
    return r = Cd({ mode: "visible", children: r }, n.mode, 0, null), r.return = n, n.child = r;
  }
  function Ou(n, r, l, f) {
    return f !== null && Co(f), ln(r, n.child, null, l), n = vd(r, r.pendingProps.children), n.flags |= 2, r.memoizedState = null, n;
  }
  function kg(n, r, l, f, v, b, x) {
    if (l)
      return r.flags & 256 ? (r.flags &= -257, f = Tp(Error(s(422))), Ou(n, r, x, f)) : r.memoizedState !== null ? (r.child = n.child, r.flags |= 128, null) : (b = f.fallback, v = r.mode, f = Cd({ mode: "visible", children: f.children }, v, 0, null), b = ja(b, v, x, null), b.flags |= 2, f.return = r, b.return = r, f.sibling = b, r.child = f, r.mode & 1 && ln(r, n.child, null, x), r.child.memoizedState = Nu(x), r.memoizedState = zp, b);
    if (!(r.mode & 1)) return Ou(n, r, x, null);
    if (v.data === "$!") {
      if (f = v.nextSibling && v.nextSibling.dataset, f) var N = f.dgst;
      return f = N, b = Error(s(419)), f = Tp(b, f, void 0), Ou(n, r, x, f);
    }
    if (N = (x & n.childLanes) !== 0, bn || N) {
      if (f = In, f !== null) {
        switch (x & -x) {
          case 4:
            v = 2;
            break;
          case 16:
            v = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            v = 32;
            break;
          case 536870912:
            v = 268435456;
            break;
          default:
            v = 0;
        }
        v = v & (f.suspendedLanes | x) ? 0 : v, v !== 0 && v !== b.retryLane && (b.retryLane = v, Zr(n, v), $a(f, n, v, -1));
      }
      return Wp(), f = Tp(Error(s(421))), Ou(n, r, x, f);
    }
    return v.data === "$?" ? (r.flags |= 128, r.child = n.child, r = $g.bind(null, n), v._reactRetry = r, null) : (n = b.treeContext, Or = Ya(v.nextSibling), Nr = r, Gt = !0, ha = null, n !== null && (vn[pa++] = eo, vn[pa++] = to, vn[pa++] = qr, eo = n.id, to = n.overflow, qr = r), r = vd(r, f.children), r.flags |= 4096, r);
  }
  function zr(n, r, l) {
    n.lanes |= r;
    var f = n.alternate;
    f !== null && (f.lanes |= r), yp(n.return, r, l);
  }
  function Aa(n, r, l, f, v) {
    var b = n.memoizedState;
    b === null ? n.memoizedState = { isBackwards: r, rendering: null, renderingStartTime: 0, last: f, tail: l, tailMode: v } : (b.isBackwards = r, b.rendering = null, b.renderingStartTime = 0, b.last = f, b.tail = l, b.tailMode = v);
  }
  function ro(n, r, l) {
    var f = r.pendingProps, v = f.revealOrder, b = f.tail;
    if (Hn(n, r, f.children, l), f = Xt.current, f & 2) f = f & 1 | 2, r.flags |= 128;
    else {
      if (n !== null && n.flags & 128) e: for (n = r.child; n !== null; ) {
        if (n.tag === 13) n.memoizedState !== null && zr(n, l, r);
        else if (n.tag === 19) zr(n, l, r);
        else if (n.child !== null) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === r) break e;
        for (; n.sibling === null; ) {
          if (n.return === null || n.return === r) break e;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
      f &= 1;
    }
    if (Be(Xt, f), !(r.mode & 1)) r.memoizedState = null;
    else switch (v) {
      case "forwards":
        for (l = r.child, v = null; l !== null; ) n = l.alternate, n !== null && Kc(n) === null && (v = l), l = l.sibling;
        l = v, l === null ? (v = r.child, r.child = null) : (v = l.sibling, l.sibling = null), Aa(r, !1, v, l, b);
        break;
      case "backwards":
        for (l = null, v = r.child, r.child = null; v !== null; ) {
          if (n = v.alternate, n !== null && Kc(n) === null) {
            r.child = v;
            break;
          }
          n = v.sibling, v.sibling = l, l = v, v = n;
        }
        Aa(r, !0, l, null, b);
        break;
      case "together":
        Aa(r, !1, null, null, void 0);
        break;
      default:
        r.memoizedState = null;
    }
    return r.child;
  }
  function _s(n, r) {
    !(r.mode & 1) && n !== null && (n.alternate = null, r.alternate = null, r.flags |= 2);
  }
  function Yr(n, r, l) {
    if (n !== null && (r.dependencies = n.dependencies), Oo |= r.lanes, !(l & r.childLanes)) return null;
    if (n !== null && r.child !== n.child) throw Error(s(153));
    if (r.child !== null) {
      for (n = r.child, l = Io(n, n.pendingProps), r.child = l, l.return = r; n.sibling !== null; ) n = n.sibling, l = l.sibling = Io(n, n.pendingProps), l.return = r;
      l.sibling = null;
    }
    return r.child;
  }
  function Ma(n, r, l) {
    switch (r.tag) {
      case 3:
        _g(r), fi();
        break;
      case 5:
        hg(r);
        break;
      case 1:
        gn(r.type) && Pr(r);
        break;
      case 4:
        xp(r, r.stateNode.containerInfo);
        break;
      case 10:
        var f = r.type._context, v = r.memoizedProps.value;
        Be(Hr, f._currentValue), f._currentValue = v;
        break;
      case 13:
        if (f = r.memoizedState, f !== null)
          return f.dehydrated !== null ? (Be(Xt, Xt.current & 1), r.flags |= 128, null) : l & r.child.childLanes ? wg(n, r, l) : (Be(Xt, Xt.current & 1), n = Yr(n, r, l), n !== null ? n.sibling : null);
        Be(Xt, Xt.current & 1);
        break;
      case 19:
        if (f = (l & r.childLanes) !== 0, n.flags & 128) {
          if (f) return ro(n, r, l);
          r.flags |= 128;
        }
        if (v = r.memoizedState, v !== null && (v.rendering = null, v.tail = null, v.lastEffect = null), Be(Xt, Xt.current), f) break;
        return null;
      case 22:
      case 23:
        return r.lanes = 0, Pu(n, r, l);
    }
    return Yr(n, r, l);
  }
  var Cn, Ip, xg, Sg;
  Cn = function(n, r) {
    for (var l = r.child; l !== null; ) {
      if (l.tag === 5 || l.tag === 6) n.appendChild(l.stateNode);
      else if (l.tag !== 4 && l.child !== null) {
        l.child.return = l, l = l.child;
        continue;
      }
      if (l === r) break;
      for (; l.sibling === null; ) {
        if (l.return === null || l.return === r) return;
        l = l.return;
      }
      l.sibling.return = l.return, l = l.sibling;
    }
  }, Ip = function() {
  }, xg = function(n, r, l, f) {
    var v = n.memoizedProps;
    if (v !== f) {
      n = r.stateNode, us(no.current);
      var b = null;
      switch (l) {
        case "input":
          v = hr(n, v), f = hr(n, f), b = [];
          break;
        case "select":
          v = pe({}, v, { value: void 0 }), f = pe({}, f, { value: void 0 }), b = [];
          break;
        case "textarea":
          v = de(n, v), f = de(n, f), b = [];
          break;
        default:
          typeof v.onClick != "function" && typeof f.onClick == "function" && (n.onclick = ii);
      }
      ia(l, f);
      var x;
      l = null;
      for (q in v) if (!f.hasOwnProperty(q) && v.hasOwnProperty(q) && v[q] != null) if (q === "style") {
        var N = v[q];
        for (x in N) N.hasOwnProperty(x) && (l || (l = {}), l[x] = "");
      } else q !== "dangerouslySetInnerHTML" && q !== "children" && q !== "suppressContentEditableWarning" && q !== "suppressHydrationWarning" && q !== "autoFocus" && (h.hasOwnProperty(q) ? b || (b = []) : (b = b || []).push(q, null));
      for (q in f) {
        var D = f[q];
        if (N = v != null ? v[q] : void 0, f.hasOwnProperty(q) && D !== N && (D != null || N != null)) if (q === "style") if (N) {
          for (x in N) !N.hasOwnProperty(x) || D && D.hasOwnProperty(x) || (l || (l = {}), l[x] = "");
          for (x in D) D.hasOwnProperty(x) && N[x] !== D[x] && (l || (l = {}), l[x] = D[x]);
        } else l || (b || (b = []), b.push(
          q,
          l
        )), l = D;
        else q === "dangerouslySetInnerHTML" ? (D = D ? D.__html : void 0, N = N ? N.__html : void 0, D != null && N !== D && (b = b || []).push(q, D)) : q === "children" ? typeof D != "string" && typeof D != "number" || (b = b || []).push(q, "" + D) : q !== "suppressContentEditableWarning" && q !== "suppressHydrationWarning" && (h.hasOwnProperty(q) ? (D != null && q === "onScroll" && Dt("scroll", n), b || N === D || (b = [])) : (b = b || []).push(q, D));
      }
      l && (b = b || []).push("style", l);
      var q = b;
      (r.updateQueue = q) && (r.flags |= 4);
    }
  }, Sg = function(n, r, l, f) {
    l !== f && (r.flags |= 4);
  };
  function ws(n, r) {
    if (!Gt) switch (n.tailMode) {
      case "hidden":
        r = n.tail;
        for (var l = null; r !== null; ) r.alternate !== null && (l = r), r = r.sibling;
        l === null ? n.tail = null : l.sibling = null;
        break;
      case "collapsed":
        l = n.tail;
        for (var f = null; l !== null; ) l.alternate !== null && (f = l), l = l.sibling;
        f === null ? r || n.tail === null ? n.tail = null : n.tail.sibling = null : f.sibling = null;
    }
  }
  function Zn(n) {
    var r = n.alternate !== null && n.alternate.child === n.child, l = 0, f = 0;
    if (r) for (var v = n.child; v !== null; ) l |= v.lanes | v.childLanes, f |= v.subtreeFlags & 14680064, f |= v.flags & 14680064, v.return = n, v = v.sibling;
    else for (v = n.child; v !== null; ) l |= v.lanes | v.childLanes, f |= v.subtreeFlags, f |= v.flags, v.return = n, v = v.sibling;
    return n.subtreeFlags |= f, n.childLanes = l, r;
  }
  function yd(n, r, l) {
    var f = r.pendingProps;
    switch (Wc(r), r.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Zn(r), null;
      case 1:
        return gn(r.type) && dl(), Zn(r), null;
      case 3:
        return f = r.stateNode, cs(), Ht(Sn), Ht(an), He(), f.pendingContext && (f.context = f.pendingContext, f.pendingContext = null), (n === null || n.child === null) && (qc(r) ? r.flags |= 4 : n === null || n.memoizedState.isDehydrated && !(r.flags & 256) || (r.flags |= 1024, ha !== null && (Vp(ha), ha = null))), Ip(n, r), Zn(r), null;
      case 5:
        Qc(r);
        var v = us(yu.current);
        if (l = r.type, n !== null && r.stateNode != null) xg(n, r, l, f, v), n.ref !== r.ref && (r.flags |= 512, r.flags |= 2097152);
        else {
          if (!f) {
            if (r.stateNode === null) throw Error(s(166));
            return Zn(r), null;
          }
          if (n = us(no.current), qc(r)) {
            f = r.stateNode, l = r.type;
            var b = r.memoizedProps;
            switch (f[Ga] = r, f[du] = b, n = (r.mode & 1) !== 0, l) {
              case "dialog":
                Dt("cancel", f), Dt("close", f);
                break;
              case "iframe":
              case "object":
              case "embed":
                Dt("load", f);
                break;
              case "video":
              case "audio":
                for (v = 0; v < lu.length; v++) Dt(lu[v], f);
                break;
              case "source":
                Dt("error", f);
                break;
              case "img":
              case "image":
              case "link":
                Dt(
                  "error",
                  f
                ), Dt("load", f);
                break;
              case "details":
                Dt("toggle", f);
                break;
              case "input":
                Wr(f, b), Dt("invalid", f);
                break;
              case "select":
                f._wrapperState = { wasMultiple: !!b.multiple }, Dt("invalid", f);
                break;
              case "textarea":
                ae(f, b), Dt("invalid", f);
            }
            ia(l, b), v = null;
            for (var x in b) if (b.hasOwnProperty(x)) {
              var N = b[x];
              x === "children" ? typeof N == "string" ? f.textContent !== N && (b.suppressHydrationWarning !== !0 && Mc(f.textContent, N, n), v = ["children", N]) : typeof N == "number" && f.textContent !== "" + N && (b.suppressHydrationWarning !== !0 && Mc(
                f.textContent,
                N,
                n
              ), v = ["children", "" + N]) : h.hasOwnProperty(x) && N != null && x === "onScroll" && Dt("scroll", f);
            }
            switch (l) {
              case "input":
                kn(f), L(f, b, !0);
                break;
              case "textarea":
                kn(f), Ye(f);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof b.onClick == "function" && (f.onclick = ii);
            }
            f = v, r.updateQueue = f, f !== null && (r.flags |= 4);
          } else {
            x = v.nodeType === 9 ? v : v.ownerDocument, n === "http://www.w3.org/1999/xhtml" && (n = Mt(l)), n === "http://www.w3.org/1999/xhtml" ? l === "script" ? (n = x.createElement("div"), n.innerHTML = "<script><\/script>", n = n.removeChild(n.firstChild)) : typeof f.is == "string" ? n = x.createElement(l, { is: f.is }) : (n = x.createElement(l), l === "select" && (x = n, f.multiple ? x.multiple = !0 : f.size && (x.size = f.size))) : n = x.createElementNS(n, l), n[Ga] = r, n[du] = f, Cn(n, r, !1, !1), r.stateNode = n;
            e: {
              switch (x = nn(l, f), l) {
                case "dialog":
                  Dt("cancel", n), Dt("close", n), v = f;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  Dt("load", n), v = f;
                  break;
                case "video":
                case "audio":
                  for (v = 0; v < lu.length; v++) Dt(lu[v], n);
                  v = f;
                  break;
                case "source":
                  Dt("error", n), v = f;
                  break;
                case "img":
                case "image":
                case "link":
                  Dt(
                    "error",
                    n
                  ), Dt("load", n), v = f;
                  break;
                case "details":
                  Dt("toggle", n), v = f;
                  break;
                case "input":
                  Wr(n, f), v = hr(n, f), Dt("invalid", n);
                  break;
                case "option":
                  v = f;
                  break;
                case "select":
                  n._wrapperState = { wasMultiple: !!f.multiple }, v = pe({}, f, { value: void 0 }), Dt("invalid", n);
                  break;
                case "textarea":
                  ae(n, f), v = de(n, f), Dt("invalid", n);
                  break;
                default:
                  v = f;
              }
              ia(l, v), N = v;
              for (b in N) if (N.hasOwnProperty(b)) {
                var D = N[b];
                b === "style" ? Un(n, D) : b === "dangerouslySetInnerHTML" ? (D = D ? D.__html : void 0, D != null && xe(n, D)) : b === "children" ? typeof D == "string" ? (l !== "textarea" || D !== "") && $e(n, D) : typeof D == "number" && $e(n, "" + D) : b !== "suppressContentEditableWarning" && b !== "suppressHydrationWarning" && b !== "autoFocus" && (h.hasOwnProperty(b) ? D != null && b === "onScroll" && Dt("scroll", n) : D != null && ve(n, b, D, x));
              }
              switch (l) {
                case "input":
                  kn(n), L(n, f, !1);
                  break;
                case "textarea":
                  kn(n), Ye(n);
                  break;
                case "option":
                  f.value != null && n.setAttribute("value", "" + ir(f.value));
                  break;
                case "select":
                  n.multiple = !!f.multiple, b = f.value, b != null ? ce(n, !!f.multiple, b, !1) : f.defaultValue != null && ce(
                    n,
                    !!f.multiple,
                    f.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof v.onClick == "function" && (n.onclick = ii);
              }
              switch (l) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  f = !!f.autoFocus;
                  break e;
                case "img":
                  f = !0;
                  break e;
                default:
                  f = !1;
              }
            }
            f && (r.flags |= 4);
          }
          r.ref !== null && (r.flags |= 512, r.flags |= 2097152);
        }
        return Zn(r), null;
      case 6:
        if (n && r.stateNode != null) Sg(n, r, n.memoizedProps, f);
        else {
          if (typeof f != "string" && r.stateNode === null) throw Error(s(166));
          if (l = us(yu.current), us(no.current), qc(r)) {
            if (f = r.stateNode, l = r.memoizedProps, f[Ga] = r, (b = f.nodeValue !== l) && (n = Nr, n !== null)) switch (n.tag) {
              case 3:
                Mc(f.nodeValue, l, (n.mode & 1) !== 0);
                break;
              case 5:
                n.memoizedProps.suppressHydrationWarning !== !0 && Mc(f.nodeValue, l, (n.mode & 1) !== 0);
            }
            b && (r.flags |= 4);
          } else f = (l.nodeType === 9 ? l : l.ownerDocument).createTextNode(f), f[Ga] = r, r.stateNode = f;
        }
        return Zn(r), null;
      case 13:
        if (Ht(Xt), f = r.memoizedState, n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
          if (Gt && Or !== null && r.mode & 1 && !(r.flags & 128)) hu(), fi(), r.flags |= 98560, b = !1;
          else if (b = qc(r), f !== null && f.dehydrated !== null) {
            if (n === null) {
              if (!b) throw Error(s(318));
              if (b = r.memoizedState, b = b !== null ? b.dehydrated : null, !b) throw Error(s(317));
              b[Ga] = r;
            } else fi(), !(r.flags & 128) && (r.memoizedState = null), r.flags |= 4;
            Zn(r), b = !1;
          } else ha !== null && (Vp(ha), ha = null), b = !0;
          if (!b) return r.flags & 65536 ? r : null;
        }
        return r.flags & 128 ? (r.lanes = l, r) : (f = f !== null, f !== (n !== null && n.memoizedState !== null) && f && (r.child.flags |= 8192, r.mode & 1 && (n === null || Xt.current & 1 ? Tn === 0 && (Tn = 3) : Wp())), r.updateQueue !== null && (r.flags |= 4), Zn(r), null);
      case 4:
        return cs(), Ip(n, r), n === null && il(r.stateNode.containerInfo), Zn(r), null;
      case 10:
        return vp(r.type._context), Zn(r), null;
      case 17:
        return gn(r.type) && dl(), Zn(r), null;
      case 19:
        if (Ht(Xt), b = r.memoizedState, b === null) return Zn(r), null;
        if (f = (r.flags & 128) !== 0, x = b.rendering, x === null) if (f) ws(b, !1);
        else {
          if (Tn !== 0 || n !== null && n.flags & 128) for (n = r.child; n !== null; ) {
            if (x = Kc(n), x !== null) {
              for (r.flags |= 128, ws(b, !1), f = x.updateQueue, f !== null && (r.updateQueue = f, r.flags |= 4), r.subtreeFlags = 0, f = l, l = r.child; l !== null; ) b = l, n = f, b.flags &= 14680066, x = b.alternate, x === null ? (b.childLanes = 0, b.lanes = n, b.child = null, b.subtreeFlags = 0, b.memoizedProps = null, b.memoizedState = null, b.updateQueue = null, b.dependencies = null, b.stateNode = null) : (b.childLanes = x.childLanes, b.lanes = x.lanes, b.child = x.child, b.subtreeFlags = 0, b.deletions = null, b.memoizedProps = x.memoizedProps, b.memoizedState = x.memoizedState, b.updateQueue = x.updateQueue, b.type = x.type, n = x.dependencies, b.dependencies = n === null ? null : { lanes: n.lanes, firstContext: n.firstContext }), l = l.sibling;
              return Be(Xt, Xt.current & 1 | 2), r.child;
            }
            n = n.sibling;
          }
          b.tail !== null && Bt() > io && (r.flags |= 128, f = !0, ws(b, !1), r.lanes = 4194304);
        }
        else {
          if (!f) if (n = Kc(x), n !== null) {
            if (r.flags |= 128, f = !0, l = n.updateQueue, l !== null && (r.updateQueue = l, r.flags |= 4), ws(b, !0), b.tail === null && b.tailMode === "hidden" && !x.alternate && !Gt) return Zn(r), null;
          } else 2 * Bt() - b.renderingStartTime > io && l !== 1073741824 && (r.flags |= 128, f = !0, ws(b, !1), r.lanes = 4194304);
          b.isBackwards ? (x.sibling = r.child, r.child = x) : (l = b.last, l !== null ? l.sibling = x : r.child = x, b.last = x);
        }
        return b.tail !== null ? (r = b.tail, b.rendering = r, b.tail = r.sibling, b.renderingStartTime = Bt(), r.sibling = null, l = Xt.current, Be(Xt, f ? l & 1 | 2 : l & 1), r) : (Zn(r), null);
      case 22:
      case 23:
        return $u(), f = r.memoizedState !== null, n !== null && n.memoizedState !== null !== f && (r.flags |= 8192), f && r.mode & 1 ? Gr & 1073741824 && (Zn(r), r.subtreeFlags & 6 && (r.flags |= 8192)) : Zn(r), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(s(156, r.tag));
  }
  function Eg(n, r) {
    switch (Wc(r), r.tag) {
      case 1:
        return gn(r.type) && dl(), n = r.flags, n & 65536 ? (r.flags = n & -65537 | 128, r) : null;
      case 3:
        return cs(), Ht(Sn), Ht(an), He(), n = r.flags, n & 65536 && !(n & 128) ? (r.flags = n & -65537 | 128, r) : null;
      case 5:
        return Qc(r), null;
      case 13:
        if (Ht(Xt), n = r.memoizedState, n !== null && n.dehydrated !== null) {
          if (r.alternate === null) throw Error(s(340));
          fi();
        }
        return n = r.flags, n & 65536 ? (r.flags = n & -65537 | 128, r) : null;
      case 19:
        return Ht(Xt), null;
      case 4:
        return cs(), null;
      case 10:
        return vp(r.type._context), null;
      case 22:
      case 23:
        return $u(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var bd = !1, cr = !1, Ap = typeof WeakSet == "function" ? WeakSet : Set, Le = null;
  function ks(n, r) {
    var l = n.ref;
    if (l !== null) if (typeof l == "function") try {
      l(null);
    } catch (f) {
      on(n, r, f);
    }
    else l.current = null;
  }
  function Cg(n, r, l) {
    try {
      l();
    } catch (f) {
      on(n, r, f);
    }
  }
  var Mp = !1;
  function Rb(n, r) {
    if (cu = Yi, n = iu(), Pc(n)) {
      if ("selectionStart" in n) var l = { start: n.selectionStart, end: n.selectionEnd };
      else e: {
        l = (l = n.ownerDocument) && l.defaultView || window;
        var f = l.getSelection && l.getSelection();
        if (f && f.rangeCount !== 0) {
          l = f.anchorNode;
          var v = f.anchorOffset, b = f.focusNode;
          f = f.focusOffset;
          try {
            l.nodeType, b.nodeType;
          } catch {
            l = null;
            break e;
          }
          var x = 0, N = -1, D = -1, q = 0, te = 0, ne = n, ee = null;
          t: for (; ; ) {
            for (var Se; ne !== l || v !== 0 && ne.nodeType !== 3 || (N = x + v), ne !== b || f !== 0 && ne.nodeType !== 3 || (D = x + f), ne.nodeType === 3 && (x += ne.nodeValue.length), (Se = ne.firstChild) !== null; )
              ee = ne, ne = Se;
            for (; ; ) {
              if (ne === n) break t;
              if (ee === l && ++q === v && (N = x), ee === b && ++te === f && (D = x), (Se = ne.nextSibling) !== null) break;
              ne = ee, ee = ne.parentNode;
            }
            ne = Se;
          }
          l = N === -1 || D === -1 ? null : { start: N, end: D };
        } else l = null;
      }
      l = l || { start: 0, end: 0 };
    } else l = null;
    for (rs = { focusedElem: n, selectionRange: l }, Yi = !1, Le = r; Le !== null; ) if (r = Le, n = r.child, (r.subtreeFlags & 1028) !== 0 && n !== null) n.return = r, Le = n;
    else for (; Le !== null; ) {
      r = Le;
      try {
        var De = r.alternate;
        if (r.flags & 1024) switch (r.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (De !== null) {
              var Me = De.memoizedProps, dn = De.memoizedState, j = r.stateNode, I = j.getSnapshotBeforeUpdate(r.elementType === r.type ? Me : Ia(r.type, Me), dn);
              j.__reactInternalSnapshotBeforeUpdate = I;
            }
            break;
          case 3:
            var F = r.stateNode.containerInfo;
            F.nodeType === 1 ? F.textContent = "" : F.nodeType === 9 && F.documentElement && F.removeChild(F.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(s(163));
        }
      } catch (se) {
        on(r, r.return, se);
      }
      if (n = r.sibling, n !== null) {
        n.return = r.return, Le = n;
        break;
      }
      Le = r.return;
    }
    return De = Mp, Mp = !1, De;
  }
  function gl(n, r, l) {
    var f = r.updateQueue;
    if (f = f !== null ? f.lastEffect : null, f !== null) {
      var v = f = f.next;
      do {
        if ((v.tag & n) === n) {
          var b = v.destroy;
          v.destroy = void 0, b !== void 0 && Cg(r, l, b);
        }
        v = v.next;
      } while (v !== f);
    }
  }
  function _d(n, r) {
    if (r = r.updateQueue, r = r !== null ? r.lastEffect : null, r !== null) {
      var l = r = r.next;
      do {
        if ((l.tag & n) === n) {
          var f = l.create;
          l.destroy = f();
        }
        l = l.next;
      } while (l !== r);
    }
  }
  function Lu(n) {
    var r = n.ref;
    if (r !== null) {
      var l = n.stateNode;
      switch (n.tag) {
        case 5:
          n = l;
          break;
        default:
          n = l;
      }
      typeof r == "function" ? r(n) : r.current = n;
    }
  }
  function Du(n) {
    var r = n.alternate;
    r !== null && (n.alternate = null, Du(r)), n.child = null, n.deletions = null, n.sibling = null, n.tag === 5 && (r = n.stateNode, r !== null && (delete r[Ga], delete r[du], delete r[fu], delete r[cl], delete r[Cb])), n.stateNode = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
  }
  function Po(n) {
    return n.tag === 5 || n.tag === 3 || n.tag === 4;
  }
  function No(n) {
    e: for (; ; ) {
      for (; n.sibling === null; ) {
        if (n.return === null || Po(n.return)) return null;
        n = n.return;
      }
      for (n.sibling.return = n.return, n = n.sibling; n.tag !== 5 && n.tag !== 6 && n.tag !== 18; ) {
        if (n.flags & 2 || n.child === null || n.tag === 4) continue e;
        n.child.return = n, n = n.child;
      }
      if (!(n.flags & 2)) return n.stateNode;
    }
  }
  function ao(n, r, l) {
    var f = n.tag;
    if (f === 5 || f === 6) n = n.stateNode, r ? l.nodeType === 8 ? l.parentNode.insertBefore(n, r) : l.insertBefore(n, r) : (l.nodeType === 8 ? (r = l.parentNode, r.insertBefore(n, l)) : (r = l, r.appendChild(n)), l = l._reactRootContainer, l != null || r.onclick !== null || (r.onclick = ii));
    else if (f !== 4 && (n = n.child, n !== null)) for (ao(n, r, l), n = n.sibling; n !== null; ) ao(n, r, l), n = n.sibling;
  }
  function xs(n, r, l) {
    var f = n.tag;
    if (f === 5 || f === 6) n = n.stateNode, r ? l.insertBefore(n, r) : l.appendChild(n);
    else if (f !== 4 && (n = n.child, n !== null)) for (xs(n, r, l), n = n.sibling; n !== null; ) xs(n, r, l), n = n.sibling;
  }
  var cn = null, zn = !1;
  function vi(n, r, l) {
    for (l = l.child; l !== null; ) Tg(n, r, l), l = l.sibling;
  }
  function Tg(n, r, l) {
    if (Pa && typeof Pa.onCommitFiberUnmount == "function") try {
      Pa.onCommitFiberUnmount(Kl, l);
    } catch {
    }
    switch (l.tag) {
      case 5:
        cr || ks(l, r);
      case 6:
        var f = cn, v = zn;
        cn = null, vi(n, r, l), cn = f, zn = v, cn !== null && (zn ? (n = cn, l = l.stateNode, n.nodeType === 8 ? n.parentNode.removeChild(l) : n.removeChild(l)) : cn.removeChild(l.stateNode));
        break;
      case 18:
        cn !== null && (zn ? (n = cn, l = l.stateNode, n.nodeType === 8 ? ul(n.parentNode, l) : n.nodeType === 1 && ul(n, l), ri(n)) : ul(cn, l.stateNode));
        break;
      case 4:
        f = cn, v = zn, cn = l.stateNode.containerInfo, zn = !0, vi(n, r, l), cn = f, zn = v;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!cr && (f = l.updateQueue, f !== null && (f = f.lastEffect, f !== null))) {
          v = f = f.next;
          do {
            var b = v, x = b.destroy;
            b = b.tag, x !== void 0 && (b & 2 || b & 4) && Cg(l, r, x), v = v.next;
          } while (v !== f);
        }
        vi(n, r, l);
        break;
      case 1:
        if (!cr && (ks(l, r), f = l.stateNode, typeof f.componentWillUnmount == "function")) try {
          f.props = l.memoizedProps, f.state = l.memoizedState, f.componentWillUnmount();
        } catch (N) {
          on(l, r, N);
        }
        vi(n, r, l);
        break;
      case 21:
        vi(n, r, l);
        break;
      case 22:
        l.mode & 1 ? (cr = (f = cr) || l.memoizedState !== null, vi(n, r, l), cr = f) : vi(n, r, l);
        break;
      default:
        vi(n, r, l);
    }
  }
  function Rg(n) {
    var r = n.updateQueue;
    if (r !== null) {
      n.updateQueue = null;
      var l = n.stateNode;
      l === null && (l = n.stateNode = new Ap()), r.forEach(function(f) {
        var v = Lb.bind(null, n, f);
        l.has(f) || (l.add(f), f.then(v, v));
      });
    }
  }
  function ga(n, r) {
    var l = r.deletions;
    if (l !== null) for (var f = 0; f < l.length; f++) {
      var v = l[f];
      try {
        var b = n, x = r, N = x;
        e: for (; N !== null; ) {
          switch (N.tag) {
            case 5:
              cn = N.stateNode, zn = !1;
              break e;
            case 3:
              cn = N.stateNode.containerInfo, zn = !0;
              break e;
            case 4:
              cn = N.stateNode.containerInfo, zn = !0;
              break e;
          }
          N = N.return;
        }
        if (cn === null) throw Error(s(160));
        Tg(b, x, v), cn = null, zn = !1;
        var D = v.alternate;
        D !== null && (D.return = null), v.return = null;
      } catch (q) {
        on(v, r, q);
      }
    }
    if (r.subtreeFlags & 12854) for (r = r.child; r !== null; ) vl(r, n), r = r.sibling;
  }
  function vl(n, r) {
    var l = n.alternate, f = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (ga(r, n), oo(n), f & 4) {
          try {
            gl(3, n, n.return), _d(3, n);
          } catch (Me) {
            on(n, n.return, Me);
          }
          try {
            gl(5, n, n.return);
          } catch (Me) {
            on(n, n.return, Me);
          }
        }
        break;
      case 1:
        ga(r, n), oo(n), f & 512 && l !== null && ks(l, l.return);
        break;
      case 5:
        if (ga(r, n), oo(n), f & 512 && l !== null && ks(l, l.return), n.flags & 32) {
          var v = n.stateNode;
          try {
            $e(v, "");
          } catch (Me) {
            on(n, n.return, Me);
          }
        }
        if (f & 4 && (v = n.stateNode, v != null)) {
          var b = n.memoizedProps, x = l !== null ? l.memoizedProps : b, N = n.type, D = n.updateQueue;
          if (n.updateQueue = null, D !== null) try {
            N === "input" && b.type === "radio" && b.name != null && Za(v, b), nn(N, x);
            var q = nn(N, b);
            for (x = 0; x < D.length; x += 2) {
              var te = D[x], ne = D[x + 1];
              te === "style" ? Un(v, ne) : te === "dangerouslySetInnerHTML" ? xe(v, ne) : te === "children" ? $e(v, ne) : ve(v, te, ne, q);
            }
            switch (N) {
              case "input":
                Vi(v, b);
                break;
              case "textarea":
                Fe(v, b);
                break;
              case "select":
                var ee = v._wrapperState.wasMultiple;
                v._wrapperState.wasMultiple = !!b.multiple;
                var Se = b.value;
                Se != null ? ce(v, !!b.multiple, Se, !1) : ee !== !!b.multiple && (b.defaultValue != null ? ce(
                  v,
                  !!b.multiple,
                  b.defaultValue,
                  !0
                ) : ce(v, !!b.multiple, b.multiple ? [] : "", !1));
            }
            v[du] = b;
          } catch (Me) {
            on(n, n.return, Me);
          }
        }
        break;
      case 6:
        if (ga(r, n), oo(n), f & 4) {
          if (n.stateNode === null) throw Error(s(162));
          v = n.stateNode, b = n.memoizedProps;
          try {
            v.nodeValue = b;
          } catch (Me) {
            on(n, n.return, Me);
          }
        }
        break;
      case 3:
        if (ga(r, n), oo(n), f & 4 && l !== null && l.memoizedState.isDehydrated) try {
          ri(r.containerInfo);
        } catch (Me) {
          on(n, n.return, Me);
        }
        break;
      case 4:
        ga(r, n), oo(n);
        break;
      case 13:
        ga(r, n), oo(n), v = n.child, v.flags & 8192 && (b = v.memoizedState !== null, v.stateNode.isHidden = b, !b || v.alternate !== null && v.alternate.memoizedState !== null || (jp = Bt())), f & 4 && Rg(n);
        break;
      case 22:
        if (te = l !== null && l.memoizedState !== null, n.mode & 1 ? (cr = (q = cr) || te, ga(r, n), cr = q) : ga(r, n), oo(n), f & 8192) {
          if (q = n.memoizedState !== null, (n.stateNode.isHidden = q) && !te && n.mode & 1) for (Le = n, te = n.child; te !== null; ) {
            for (ne = Le = te; Le !== null; ) {
              switch (ee = Le, Se = ee.child, ee.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  gl(4, ee, ee.return);
                  break;
                case 1:
                  ks(ee, ee.return);
                  var De = ee.stateNode;
                  if (typeof De.componentWillUnmount == "function") {
                    f = ee, l = ee.return;
                    try {
                      r = f, De.props = r.memoizedProps, De.state = r.memoizedState, De.componentWillUnmount();
                    } catch (Me) {
                      on(f, l, Me);
                    }
                  }
                  break;
                case 5:
                  ks(ee, ee.return);
                  break;
                case 22:
                  if (ee.memoizedState !== null) {
                    Fp(ne);
                    continue;
                  }
              }
              Se !== null ? (Se.return = ee, Le = Se) : Fp(ne);
            }
            te = te.sibling;
          }
          e: for (te = null, ne = n; ; ) {
            if (ne.tag === 5) {
              if (te === null) {
                te = ne;
                try {
                  v = ne.stateNode, q ? (b = v.style, typeof b.setProperty == "function" ? b.setProperty("display", "none", "important") : b.display = "none") : (N = ne.stateNode, D = ne.memoizedProps.style, x = D != null && D.hasOwnProperty("display") ? D.display : null, N.style.display = Qt("display", x));
                } catch (Me) {
                  on(n, n.return, Me);
                }
              }
            } else if (ne.tag === 6) {
              if (te === null) try {
                ne.stateNode.nodeValue = q ? "" : ne.memoizedProps;
              } catch (Me) {
                on(n, n.return, Me);
              }
            } else if ((ne.tag !== 22 && ne.tag !== 23 || ne.memoizedState === null || ne === n) && ne.child !== null) {
              ne.child.return = ne, ne = ne.child;
              continue;
            }
            if (ne === n) break e;
            for (; ne.sibling === null; ) {
              if (ne.return === null || ne.return === n) break e;
              te === ne && (te = null), ne = ne.return;
            }
            te === ne && (te = null), ne.sibling.return = ne.return, ne = ne.sibling;
          }
        }
        break;
      case 19:
        ga(r, n), oo(n), f & 4 && Rg(n);
        break;
      case 21:
        break;
      default:
        ga(
          r,
          n
        ), oo(n);
    }
  }
  function oo(n) {
    var r = n.flags;
    if (r & 2) {
      try {
        e: {
          for (var l = n.return; l !== null; ) {
            if (Po(l)) {
              var f = l;
              break e;
            }
            l = l.return;
          }
          throw Error(s(160));
        }
        switch (f.tag) {
          case 5:
            var v = f.stateNode;
            f.flags & 32 && ($e(v, ""), f.flags &= -33);
            var b = No(n);
            xs(n, b, v);
            break;
          case 3:
          case 4:
            var x = f.stateNode.containerInfo, N = No(n);
            ao(n, N, x);
            break;
          default:
            throw Error(s(161));
        }
      } catch (D) {
        on(n, n.return, D);
      }
      n.flags &= -3;
    }
    r & 4096 && (n.flags &= -4097);
  }
  function Pg(n, r, l) {
    Le = n, Ng(n);
  }
  function Ng(n, r, l) {
    for (var f = (n.mode & 1) !== 0; Le !== null; ) {
      var v = Le, b = v.child;
      if (v.tag === 22 && f) {
        var x = v.memoizedState !== null || bd;
        if (!x) {
          var N = v.alternate, D = N !== null && N.memoizedState !== null || cr;
          N = bd;
          var q = cr;
          if (bd = x, (cr = D) && !q) for (Le = v; Le !== null; ) x = Le, D = x.child, x.tag === 22 && x.memoizedState !== null ? Og(v) : D !== null ? (D.return = x, Le = D) : Og(v);
          for (; b !== null; ) Le = b, Ng(b), b = b.sibling;
          Le = v, bd = N, cr = q;
        }
        zu(n);
      } else v.subtreeFlags & 8772 && b !== null ? (b.return = v, Le = b) : zu(n);
    }
  }
  function zu(n) {
    for (; Le !== null; ) {
      var r = Le;
      if (r.flags & 8772) {
        var l = r.alternate;
        try {
          if (r.flags & 8772) switch (r.tag) {
            case 0:
            case 11:
            case 15:
              cr || _d(5, r);
              break;
            case 1:
              var f = r.stateNode;
              if (r.flags & 4 && !cr) if (l === null) f.componentDidMount();
              else {
                var v = r.elementType === r.type ? l.memoizedProps : Ia(r.type, l.memoizedProps);
                f.componentDidUpdate(v, l.memoizedState, f.__reactInternalSnapshotBeforeUpdate);
              }
              var b = r.updateQueue;
              b !== null && kp(r, b, f);
              break;
            case 3:
              var x = r.updateQueue;
              if (x !== null) {
                if (l = null, r.child !== null) switch (r.child.tag) {
                  case 5:
                    l = r.child.stateNode;
                    break;
                  case 1:
                    l = r.child.stateNode;
                }
                kp(r, x, l);
              }
              break;
            case 5:
              var N = r.stateNode;
              if (l === null && r.flags & 4) {
                l = N;
                var D = r.memoizedProps;
                switch (r.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    D.autoFocus && l.focus();
                    break;
                  case "img":
                    D.src && (l.src = D.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (r.memoizedState === null) {
                var q = r.alternate;
                if (q !== null) {
                  var te = q.memoizedState;
                  if (te !== null) {
                    var ne = te.dehydrated;
                    ne !== null && ri(ne);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(s(163));
          }
          cr || r.flags & 512 && Lu(r);
        } catch (ee) {
          on(r, r.return, ee);
        }
      }
      if (r === n) {
        Le = null;
        break;
      }
      if (l = r.sibling, l !== null) {
        l.return = r.return, Le = l;
        break;
      }
      Le = r.return;
    }
  }
  function Fp(n) {
    for (; Le !== null; ) {
      var r = Le;
      if (r === n) {
        Le = null;
        break;
      }
      var l = r.sibling;
      if (l !== null) {
        l.return = r.return, Le = l;
        break;
      }
      Le = r.return;
    }
  }
  function Og(n) {
    for (; Le !== null; ) {
      var r = Le;
      try {
        switch (r.tag) {
          case 0:
          case 11:
          case 15:
            var l = r.return;
            try {
              _d(4, r);
            } catch (D) {
              on(r, l, D);
            }
            break;
          case 1:
            var f = r.stateNode;
            if (typeof f.componentDidMount == "function") {
              var v = r.return;
              try {
                f.componentDidMount();
              } catch (D) {
                on(r, v, D);
              }
            }
            var b = r.return;
            try {
              Lu(r);
            } catch (D) {
              on(r, b, D);
            }
            break;
          case 5:
            var x = r.return;
            try {
              Lu(r);
            } catch (D) {
              on(r, x, D);
            }
        }
      } catch (D) {
        on(r, r.return, D);
      }
      if (r === n) {
        Le = null;
        break;
      }
      var N = r.sibling;
      if (N !== null) {
        N.return = r.return, Le = N;
        break;
      }
      Le = r.return;
    }
  }
  var Iu = Math.ceil, yi = qe.ReactCurrentDispatcher, bi = qe.ReactCurrentOwner, Ir = qe.ReactCurrentBatchConfig, St = 0, In = null, _n = null, Qn = 0, Gr = 0, _i = Da(0), Tn = 0, wi = null, Oo = 0, Au = 0, $p = 0, Mu = null, Ar = null, jp = 0, io = 1 / 0, Fa = null, ki = !1, Up = null, xi = null, Fu = !1, Lo = null, Ss = 0, Si = 0, wd = null, dr = -1, Do = 0;
  function Kn() {
    return St & 6 ? Bt() : dr !== -1 ? dr : dr = Bt();
  }
  function va(n) {
    return n.mode & 1 ? St & 2 && Qn !== 0 ? Qn & -Qn : Tb.transition !== null ? (Do === 0 && (Do = mc()), Do) : (n = It, n !== 0 || (n = window.event, n = n === void 0 ? 16 : bc(n.type)), n) : 1;
  }
  function $a(n, r, l, f) {
    if (50 < Si) throw Si = 0, wd = null, Error(s(185));
    Qi(n, l, f), (!(St & 2) || n !== In) && (n === In && (!(St & 2) && (Au |= l), Tn === 4 && zo(n, Qn)), fr(n, f), l === 1 && St === 0 && !(r.mode & 1) && (io = Bt() + 500, fl && Xa()));
  }
  function fr(n, r) {
    var l = n.callbackNode;
    If(n, r);
    var f = Zi(n, n === In ? Qn : 0);
    if (f === 0) l !== null && Cm(l), n.callbackNode = null, n.callbackPriority = 0;
    else if (r = f & -f, n.callbackPriority !== r) {
      if (l != null && Cm(l), r === 1) n.tag === 0 ? li(Lg.bind(null, n)) : Vc(Lg.bind(null, n)), ll(function() {
        !(St & 6) && Xa();
      }), l = null;
      else {
        switch (Ff(f)) {
          case 1:
            l = qi;
            break;
          case 4:
            l = Lf;
            break;
          case 16:
            l = Ql;
            break;
          case 536870912:
            l = Df;
            break;
          default:
            l = Ql;
        }
        l = Ug(l, kd.bind(null, n));
      }
      n.callbackPriority = r, n.callbackNode = l;
    }
  }
  function kd(n, r) {
    if (dr = -1, Do = 0, St & 6) throw Error(s(327));
    var l = n.callbackNode;
    if (yl() && n.callbackNode !== l) return null;
    var f = Zi(n, n === In ? Qn : 0);
    if (f === 0) return null;
    if (f & 30 || f & n.expiredLanes || r) r = Sd(n, f);
    else {
      r = f;
      var v = St;
      St |= 2;
      var b = zg();
      (In !== n || Qn !== r) && (Fa = null, io = Bt() + 500, Ts(n, r));
      do
        try {
          Pb();
          break;
        } catch (N) {
          Dg(n, N);
        }
      while (!0);
      gp(), yi.current = b, St = v, _n !== null ? r = 0 : (In = null, Qn = 0, r = Tn);
    }
    if (r !== 0) {
      if (r === 2 && (v = Af(n), v !== 0 && (f = v, r = Es(n, v))), r === 1) throw l = wi, Ts(n, 0), zo(n, f), fr(n, Bt()), l;
      if (r === 6) zo(n, f);
      else {
        if (v = n.current.alternate, !(f & 30) && !xd(v) && (r = Sd(n, f), r === 2 && (b = Af(n), b !== 0 && (f = b, r = Es(n, b))), r === 1)) throw l = wi, Ts(n, 0), zo(n, f), fr(n, Bt()), l;
        switch (n.finishedWork = v, n.finishedLanes = f, r) {
          case 0:
          case 1:
            throw Error(s(345));
          case 2:
            Rs(n, Ar, Fa);
            break;
          case 3:
            if (zo(n, f), (f & 130023424) === f && (r = jp + 500 - Bt(), 10 < r)) {
              if (Zi(n, 0) !== 0) break;
              if (v = n.suspendedLanes, (v & f) !== f) {
                Kn(), n.pingedLanes |= n.suspendedLanes & v;
                break;
              }
              n.timeoutHandle = $c(Rs.bind(null, n, Ar, Fa), r);
              break;
            }
            Rs(n, Ar, Fa);
            break;
          case 4:
            if (zo(n, f), (f & 4194240) === f) break;
            for (r = n.eventTimes, v = -1; 0 < f; ) {
              var x = 31 - sa(f);
              b = 1 << x, x = r[x], x > v && (v = x), f &= ~b;
            }
            if (f = v, f = Bt() - f, f = (120 > f ? 120 : 480 > f ? 480 : 1080 > f ? 1080 : 1920 > f ? 1920 : 3e3 > f ? 3e3 : 4320 > f ? 4320 : 1960 * Iu(f / 1960)) - f, 10 < f) {
              n.timeoutHandle = $c(Rs.bind(null, n, Ar, Fa), f);
              break;
            }
            Rs(n, Ar, Fa);
            break;
          case 5:
            Rs(n, Ar, Fa);
            break;
          default:
            throw Error(s(329));
        }
      }
    }
    return fr(n, Bt()), n.callbackNode === l ? kd.bind(null, n) : null;
  }
  function Es(n, r) {
    var l = Mu;
    return n.current.memoizedState.isDehydrated && (Ts(n, r).flags |= 256), n = Sd(n, r), n !== 2 && (r = Ar, Ar = l, r !== null && Vp(r)), n;
  }
  function Vp(n) {
    Ar === null ? Ar = n : Ar.push.apply(Ar, n);
  }
  function xd(n) {
    for (var r = n; ; ) {
      if (r.flags & 16384) {
        var l = r.updateQueue;
        if (l !== null && (l = l.stores, l !== null)) for (var f = 0; f < l.length; f++) {
          var v = l[f], b = v.getSnapshot;
          v = v.value;
          try {
            if (!Oa(b(), v)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (l = r.child, r.subtreeFlags & 16384 && l !== null) l.return = r, r = l;
      else {
        if (r === n) break;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === n) return !0;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
    }
    return !0;
  }
  function zo(n, r) {
    for (r &= ~$p, r &= ~Au, n.suspendedLanes |= r, n.pingedLanes &= ~r, n = n.expirationTimes; 0 < r; ) {
      var l = 31 - sa(r), f = 1 << l;
      n[l] = -1, r &= ~f;
    }
  }
  function Lg(n) {
    if (St & 6) throw Error(s(327));
    yl();
    var r = Zi(n, 0);
    if (!(r & 1)) return fr(n, Bt()), null;
    var l = Sd(n, r);
    if (n.tag !== 0 && l === 2) {
      var f = Af(n);
      f !== 0 && (r = f, l = Es(n, f));
    }
    if (l === 1) throw l = wi, Ts(n, 0), zo(n, r), fr(n, Bt()), l;
    if (l === 6) throw Error(s(345));
    return n.finishedWork = n.current.alternate, n.finishedLanes = r, Rs(n, Ar, Fa), fr(n, Bt()), null;
  }
  function Bp(n, r) {
    var l = St;
    St |= 1;
    try {
      return n(r);
    } finally {
      St = l, St === 0 && (io = Bt() + 500, fl && Xa());
    }
  }
  function Cs(n) {
    Lo !== null && Lo.tag === 0 && !(St & 6) && yl();
    var r = St;
    St |= 1;
    var l = Ir.transition, f = It;
    try {
      if (Ir.transition = null, It = 1, n) return n();
    } finally {
      It = f, Ir.transition = l, St = r, !(St & 6) && Xa();
    }
  }
  function $u() {
    Gr = _i.current, Ht(_i);
  }
  function Ts(n, r) {
    n.finishedWork = null, n.finishedLanes = 0;
    var l = n.timeoutHandle;
    if (l !== -1 && (n.timeoutHandle = -1, dp(l)), _n !== null) for (l = _n.return; l !== null; ) {
      var f = l;
      switch (Wc(f), f.tag) {
        case 1:
          f = f.type.childContextTypes, f != null && dl();
          break;
        case 3:
          cs(), Ht(Sn), Ht(an), He();
          break;
        case 5:
          Qc(f);
          break;
        case 4:
          cs();
          break;
        case 13:
          Ht(Xt);
          break;
        case 19:
          Ht(Xt);
          break;
        case 10:
          vp(f.type._context);
          break;
        case 22:
        case 23:
          $u();
      }
      l = l.return;
    }
    if (In = n, _n = n = Io(n.current, null), Qn = Gr = r, Tn = 0, wi = null, $p = Au = Oo = 0, Ar = Mu = null, ls !== null) {
      for (r = 0; r < ls.length; r++) if (l = ls[r], f = l.interleaved, f !== null) {
        l.interleaved = null;
        var v = f.next, b = l.pending;
        if (b !== null) {
          var x = b.next;
          b.next = v, f.next = x;
        }
        l.pending = f;
      }
      ls = null;
    }
    return n;
  }
  function Dg(n, r) {
    do {
      var l = _n;
      try {
        if (gp(), pt.current = gs, Yc) {
          for (var f = Rt.memoizedState; f !== null; ) {
            var v = f.queue;
            v !== null && (v.pending = null), f = f.next;
          }
          Yc = !1;
        }
        if ($t = 0, Dn = yn = Rt = null, _u = !1, ds = 0, bi.current = null, l === null || l.return === null) {
          Tn = 1, wi = r, _n = null;
          break;
        }
        e: {
          var b = n, x = l.return, N = l, D = r;
          if (r = Qn, N.flags |= 32768, D !== null && typeof D == "object" && typeof D.then == "function") {
            var q = D, te = N, ne = te.tag;
            if (!(te.mode & 1) && (ne === 0 || ne === 11 || ne === 15)) {
              var ee = te.alternate;
              ee ? (te.updateQueue = ee.updateQueue, te.memoizedState = ee.memoizedState, te.lanes = ee.lanes) : (te.updateQueue = null, te.memoizedState = null);
            }
            var Se = bg(x);
            if (Se !== null) {
              Se.flags &= -257, gi(Se, x, N, b, r), Se.mode & 1 && Np(b, q, r), r = Se, D = q;
              var De = r.updateQueue;
              if (De === null) {
                var Me = /* @__PURE__ */ new Set();
                Me.add(D), r.updateQueue = Me;
              } else De.add(D);
              break e;
            } else {
              if (!(r & 1)) {
                Np(b, q, r), Wp();
                break e;
              }
              D = Error(s(426));
            }
          } else if (Gt && N.mode & 1) {
            var dn = bg(x);
            if (dn !== null) {
              !(dn.flags & 65536) && (dn.flags |= 256), gi(dn, x, N, b, r), Co(vs(D, N));
              break e;
            }
          }
          b = D = vs(D, N), Tn !== 4 && (Tn = 2), Mu === null ? Mu = [b] : Mu.push(b), b = x;
          do {
            switch (b.tag) {
              case 3:
                b.flags |= 65536, r &= -r, b.lanes |= r;
                var j = yg(b, D, r);
                pg(b, j);
                break e;
              case 1:
                N = D;
                var I = b.type, F = b.stateNode;
                if (!(b.flags & 128) && (typeof I.getDerivedStateFromError == "function" || F !== null && typeof F.componentDidCatch == "function" && (xi === null || !xi.has(F)))) {
                  b.flags |= 65536, r &= -r, b.lanes |= r;
                  var se = Pp(b, N, r);
                  pg(b, se);
                  break e;
                }
            }
            b = b.return;
          } while (b !== null);
        }
        Mg(l);
      } catch (je) {
        r = je, _n === l && l !== null && (_n = l = l.return);
        continue;
      }
      break;
    } while (!0);
  }
  function zg() {
    var n = yi.current;
    return yi.current = gs, n === null ? gs : n;
  }
  function Wp() {
    (Tn === 0 || Tn === 3 || Tn === 2) && (Tn = 4), In === null || !(Oo & 268435455) && !(Au & 268435455) || zo(In, Qn);
  }
  function Sd(n, r) {
    var l = St;
    St |= 2;
    var f = zg();
    (In !== n || Qn !== r) && (Fa = null, Ts(n, r));
    do
      try {
        Ig();
        break;
      } catch (v) {
        Dg(n, v);
      }
    while (!0);
    if (gp(), St = l, yi.current = f, _n !== null) throw Error(s(261));
    return In = null, Qn = 0, Tn;
  }
  function Ig() {
    for (; _n !== null; ) Ag(_n);
  }
  function Pb() {
    for (; _n !== null && !Tm(); ) Ag(_n);
  }
  function Ag(n) {
    var r = jg(n.alternate, n, Gr);
    n.memoizedProps = n.pendingProps, r === null ? Mg(n) : _n = r, bi.current = null;
  }
  function Mg(n) {
    var r = n;
    do {
      var l = r.alternate;
      if (n = r.return, r.flags & 32768) {
        if (l = Eg(l, r), l !== null) {
          l.flags &= 32767, _n = l;
          return;
        }
        if (n !== null) n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null;
        else {
          Tn = 6, _n = null;
          return;
        }
      } else if (l = yd(l, r, Gr), l !== null) {
        _n = l;
        return;
      }
      if (r = r.sibling, r !== null) {
        _n = r;
        return;
      }
      _n = r = n;
    } while (r !== null);
    Tn === 0 && (Tn = 5);
  }
  function Rs(n, r, l) {
    var f = It, v = Ir.transition;
    try {
      Ir.transition = null, It = 1, Nb(n, r, l, f);
    } finally {
      Ir.transition = v, It = f;
    }
    return null;
  }
  function Nb(n, r, l, f) {
    do
      yl();
    while (Lo !== null);
    if (St & 6) throw Error(s(327));
    l = n.finishedWork;
    var v = n.finishedLanes;
    if (l === null) return null;
    if (n.finishedWork = null, n.finishedLanes = 0, l === n.current) throw Error(s(177));
    n.callbackNode = null, n.callbackPriority = 0;
    var b = l.lanes | l.childLanes;
    if (lb(n, b), n === In && (_n = In = null, Qn = 0), !(l.subtreeFlags & 2064) && !(l.flags & 2064) || Fu || (Fu = !0, Ug(Ql, function() {
      return yl(), null;
    })), b = (l.flags & 15990) !== 0, l.subtreeFlags & 15990 || b) {
      b = Ir.transition, Ir.transition = null;
      var x = It;
      It = 1;
      var N = St;
      St |= 4, bi.current = null, Rb(n, l), vl(l, n), al(rs), Yi = !!cu, rs = cu = null, n.current = l, Pg(l), ab(), St = N, It = x, Ir.transition = b;
    } else n.current = l;
    if (Fu && (Fu = !1, Lo = n, Ss = v), b = n.pendingLanes, b === 0 && (xi = null), Pm(l.stateNode), fr(n, Bt()), r !== null) for (f = n.onRecoverableError, l = 0; l < r.length; l++) v = r[l], f(v.value, { componentStack: v.stack, digest: v.digest });
    if (ki) throw ki = !1, n = Up, Up = null, n;
    return Ss & 1 && n.tag !== 0 && yl(), b = n.pendingLanes, b & 1 ? n === wd ? Si++ : (Si = 0, wd = n) : Si = 0, Xa(), null;
  }
  function yl() {
    if (Lo !== null) {
      var n = Ff(Ss), r = Ir.transition, l = It;
      try {
        if (Ir.transition = null, It = 16 > n ? 16 : n, Lo === null) var f = !1;
        else {
          if (n = Lo, Lo = null, Ss = 0, St & 6) throw Error(s(331));
          var v = St;
          for (St |= 4, Le = n.current; Le !== null; ) {
            var b = Le, x = b.child;
            if (Le.flags & 16) {
              var N = b.deletions;
              if (N !== null) {
                for (var D = 0; D < N.length; D++) {
                  var q = N[D];
                  for (Le = q; Le !== null; ) {
                    var te = Le;
                    switch (te.tag) {
                      case 0:
                      case 11:
                      case 15:
                        gl(8, te, b);
                    }
                    var ne = te.child;
                    if (ne !== null) ne.return = te, Le = ne;
                    else for (; Le !== null; ) {
                      te = Le;
                      var ee = te.sibling, Se = te.return;
                      if (Du(te), te === q) {
                        Le = null;
                        break;
                      }
                      if (ee !== null) {
                        ee.return = Se, Le = ee;
                        break;
                      }
                      Le = Se;
                    }
                  }
                }
                var De = b.alternate;
                if (De !== null) {
                  var Me = De.child;
                  if (Me !== null) {
                    De.child = null;
                    do {
                      var dn = Me.sibling;
                      Me.sibling = null, Me = dn;
                    } while (Me !== null);
                  }
                }
                Le = b;
              }
            }
            if (b.subtreeFlags & 2064 && x !== null) x.return = b, Le = x;
            else e: for (; Le !== null; ) {
              if (b = Le, b.flags & 2048) switch (b.tag) {
                case 0:
                case 11:
                case 15:
                  gl(9, b, b.return);
              }
              var j = b.sibling;
              if (j !== null) {
                j.return = b.return, Le = j;
                break e;
              }
              Le = b.return;
            }
          }
          var I = n.current;
          for (Le = I; Le !== null; ) {
            x = Le;
            var F = x.child;
            if (x.subtreeFlags & 2064 && F !== null) F.return = x, Le = F;
            else e: for (x = I; Le !== null; ) {
              if (N = Le, N.flags & 2048) try {
                switch (N.tag) {
                  case 0:
                  case 11:
                  case 15:
                    _d(9, N);
                }
              } catch (je) {
                on(N, N.return, je);
              }
              if (N === x) {
                Le = null;
                break e;
              }
              var se = N.sibling;
              if (se !== null) {
                se.return = N.return, Le = se;
                break e;
              }
              Le = N.return;
            }
          }
          if (St = v, Xa(), Pa && typeof Pa.onPostCommitFiberRoot == "function") try {
            Pa.onPostCommitFiberRoot(Kl, n);
          } catch {
          }
          f = !0;
        }
        return f;
      } finally {
        It = l, Ir.transition = r;
      }
    }
    return !1;
  }
  function Ed(n, r, l) {
    r = vs(l, r), r = yg(n, r, 1), n = pi(n, r, 1), r = Kn(), n !== null && (Qi(n, 1, r), fr(n, r));
  }
  function on(n, r, l) {
    if (n.tag === 3) Ed(n, n, l);
    else for (; r !== null; ) {
      if (r.tag === 3) {
        Ed(r, n, l);
        break;
      } else if (r.tag === 1) {
        var f = r.stateNode;
        if (typeof r.type.getDerivedStateFromError == "function" || typeof f.componentDidCatch == "function" && (xi === null || !xi.has(f))) {
          n = vs(l, n), n = Pp(r, n, 1), r = pi(r, n, 1), n = Kn(), r !== null && (Qi(r, 1, n), fr(r, n));
          break;
        }
      }
      r = r.return;
    }
  }
  function Ob(n, r, l) {
    var f = n.pingCache;
    f !== null && f.delete(r), r = Kn(), n.pingedLanes |= n.suspendedLanes & l, In === n && (Qn & l) === l && (Tn === 4 || Tn === 3 && (Qn & 130023424) === Qn && 500 > Bt() - jp ? Ts(n, 0) : $p |= l), fr(n, r);
  }
  function Fg(n, r) {
    r === 0 && (n.mode & 1 ? (r = Na, Na <<= 1, !(Na & 130023424) && (Na = 4194304)) : r = 1);
    var l = Kn();
    n = Zr(n, r), n !== null && (Qi(n, r, l), fr(n, l));
  }
  function $g(n) {
    var r = n.memoizedState, l = 0;
    r !== null && (l = r.retryLane), Fg(n, l);
  }
  function Lb(n, r) {
    var l = 0;
    switch (n.tag) {
      case 13:
        var f = n.stateNode, v = n.memoizedState;
        v !== null && (l = v.retryLane);
        break;
      case 19:
        f = n.stateNode;
        break;
      default:
        throw Error(s(314));
    }
    f !== null && f.delete(r), Fg(n, l);
  }
  var jg;
  jg = function(n, r, l) {
    if (n !== null) if (n.memoizedProps !== r.pendingProps || Sn.current) bn = !0;
    else {
      if (!(n.lanes & l) && !(r.flags & 128)) return bn = !1, Ma(n, r, l);
      bn = !!(n.flags & 131072);
    }
    else bn = !1, Gt && r.flags & 1048576 && ug(r, Eo, r.index);
    switch (r.lanes = 0, r.tag) {
      case 2:
        var f = r.type;
        _s(n, r), n = r.pendingProps;
        var v = fa(r, an.current);
        Jt(r, l), v = hi(null, r, f, n, v, l);
        var b = za();
        return r.flags |= 1, typeof v == "object" && v !== null && typeof v.render == "function" && v.$$typeof === void 0 ? (r.tag = 1, r.memoizedState = null, r.updateQueue = null, gn(f) ? (b = !0, Pr(r)) : b = !1, r.memoizedState = v.state !== null && v.state !== void 0 ? v.state : null, wp(r), v.updater = pd, r.stateNode = v, v._reactInternals = r, Tu(r, f, n, l), r = bs(null, r, f, !0, b, l)) : (r.tag = 0, Gt && b && Bc(r), Hn(null, r, v, l), r = r.child), r;
      case 16:
        f = r.elementType;
        e: {
          switch (_s(n, r), n = r.pendingProps, v = f._init, f = v(f._payload), r.type = f, v = r.tag = zb(f), n = Ia(f, n), v) {
            case 0:
              r = Lp(null, r, f, n, l);
              break e;
            case 1:
              r = gd(null, r, f, n, l);
              break e;
            case 11:
              r = Dr(null, r, f, n, l);
              break e;
            case 14:
              r = ys(null, r, f, Ia(f.type, n), l);
              break e;
          }
          throw Error(s(
            306,
            f,
            ""
          ));
        }
        return r;
      case 0:
        return f = r.type, v = r.pendingProps, v = r.elementType === f ? v : Ia(f, v), Lp(n, r, f, v, l);
      case 1:
        return f = r.type, v = r.pendingProps, v = r.elementType === f ? v : Ia(f, v), gd(n, r, f, v, l);
      case 3:
        e: {
          if (_g(r), n === null) throw Error(s(387));
          f = r.pendingProps, b = r.memoizedState, v = b.element, fg(n, r), mu(r, f, null, l);
          var x = r.memoizedState;
          if (f = x.element, b.isDehydrated) if (b = { element: f, isDehydrated: !1, cache: x.cache, pendingSuspenseBoundaries: x.pendingSuspenseBoundaries, transitions: x.transitions }, r.updateQueue.baseState = b, r.memoizedState = b, r.flags & 256) {
            v = vs(Error(s(423)), r), r = Dp(n, r, f, l, v);
            break e;
          } else if (f !== v) {
            v = vs(Error(s(424)), r), r = Dp(n, r, f, l, v);
            break e;
          } else for (Or = Ya(r.stateNode.containerInfo.firstChild), Nr = r, Gt = !0, ha = null, l = be(r, null, f, l), r.child = l; l; ) l.flags = l.flags & -3 | 4096, l = l.sibling;
          else {
            if (fi(), f === v) {
              r = Yr(n, r, l);
              break e;
            }
            Hn(n, r, f, l);
          }
          r = r.child;
        }
        return r;
      case 5:
        return hg(r), n === null && hp(r), f = r.type, v = r.pendingProps, b = n !== null ? n.memoizedProps : null, x = v.children, Fc(f, v) ? x = null : b !== null && Fc(f, b) && (r.flags |= 32), Op(n, r), Hn(n, r, x, l), r.child;
      case 6:
        return n === null && hp(r), null;
      case 13:
        return wg(n, r, l);
      case 4:
        return xp(r, r.stateNode.containerInfo), f = r.pendingProps, n === null ? r.child = ln(r, null, f, l) : Hn(n, r, f, l), r.child;
      case 11:
        return f = r.type, v = r.pendingProps, v = r.elementType === f ? v : Ia(f, v), Dr(n, r, f, v, l);
      case 7:
        return Hn(n, r, r.pendingProps, l), r.child;
      case 8:
        return Hn(n, r, r.pendingProps.children, l), r.child;
      case 12:
        return Hn(n, r, r.pendingProps.children, l), r.child;
      case 10:
        e: {
          if (f = r.type._context, v = r.pendingProps, b = r.memoizedProps, x = v.value, Be(Hr, f._currentValue), f._currentValue = x, b !== null) if (Oa(b.value, x)) {
            if (b.children === v.children && !Sn.current) {
              r = Yr(n, r, l);
              break e;
            }
          } else for (b = r.child, b !== null && (b.return = r); b !== null; ) {
            var N = b.dependencies;
            if (N !== null) {
              x = b.child;
              for (var D = N.firstContext; D !== null; ) {
                if (D.context === f) {
                  if (b.tag === 1) {
                    D = To(-1, l & -l), D.tag = 2;
                    var q = b.updateQueue;
                    if (q !== null) {
                      q = q.shared;
                      var te = q.pending;
                      te === null ? D.next = D : (D.next = te.next, te.next = D), q.pending = D;
                    }
                  }
                  b.lanes |= l, D = b.alternate, D !== null && (D.lanes |= l), yp(
                    b.return,
                    l,
                    r
                  ), N.lanes |= l;
                  break;
                }
                D = D.next;
              }
            } else if (b.tag === 10) x = b.type === r.type ? null : b.child;
            else if (b.tag === 18) {
              if (x = b.return, x === null) throw Error(s(341));
              x.lanes |= l, N = x.alternate, N !== null && (N.lanes |= l), yp(x, l, r), x = b.sibling;
            } else x = b.child;
            if (x !== null) x.return = b;
            else for (x = b; x !== null; ) {
              if (x === r) {
                x = null;
                break;
              }
              if (b = x.sibling, b !== null) {
                b.return = x.return, x = b;
                break;
              }
              x = x.return;
            }
            b = x;
          }
          Hn(n, r, v.children, l), r = r.child;
        }
        return r;
      case 9:
        return v = r.type, f = r.pendingProps.children, Jt(r, l), v = ma(v), f = f(v), r.flags |= 1, Hn(n, r, f, l), r.child;
      case 14:
        return f = r.type, v = Ia(f, r.pendingProps), v = Ia(f.type, v), ys(n, r, f, v, l);
      case 15:
        return ct(n, r, r.type, r.pendingProps, l);
      case 17:
        return f = r.type, v = r.pendingProps, v = r.elementType === f ? v : Ia(f, v), _s(n, r), r.tag = 1, gn(f) ? (n = !0, Pr(r)) : n = !1, Jt(r, l), hd(r, f, v), Tu(r, f, v, l), bs(null, r, f, !0, n, l);
      case 19:
        return ro(n, r, l);
      case 22:
        return Pu(n, r, l);
    }
    throw Error(s(156, r.tag));
  };
  function Ug(n, r) {
    return Em(n, r);
  }
  function Db(n, r, l, f) {
    this.tag = n, this.key = l, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = r, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = f, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function ya(n, r, l, f) {
    return new Db(n, r, l, f);
  }
  function qp(n) {
    return n = n.prototype, !(!n || !n.isReactComponent);
  }
  function zb(n) {
    if (typeof n == "function") return qp(n) ? 1 : 0;
    if (n != null) {
      if (n = n.$$typeof, n === fe) return 11;
      if (n === et) return 14;
    }
    return 2;
  }
  function Io(n, r) {
    var l = n.alternate;
    return l === null ? (l = ya(n.tag, r, n.key, n.mode), l.elementType = n.elementType, l.type = n.type, l.stateNode = n.stateNode, l.alternate = n, n.alternate = l) : (l.pendingProps = r, l.type = n.type, l.flags = 0, l.subtreeFlags = 0, l.deletions = null), l.flags = n.flags & 14680064, l.childLanes = n.childLanes, l.lanes = n.lanes, l.child = n.child, l.memoizedProps = n.memoizedProps, l.memoizedState = n.memoizedState, l.updateQueue = n.updateQueue, r = n.dependencies, l.dependencies = r === null ? null : { lanes: r.lanes, firstContext: r.firstContext }, l.sibling = n.sibling, l.index = n.index, l.ref = n.ref, l;
  }
  function bl(n, r, l, f, v, b) {
    var x = 2;
    if (f = n, typeof n == "function") qp(n) && (x = 1);
    else if (typeof n == "string") x = 5;
    else e: switch (n) {
      case Oe:
        return ja(l.children, v, b, r);
      case ye:
        x = 8, v |= 8;
        break;
      case rt:
        return n = ya(12, l, r, v | 2), n.elementType = rt, n.lanes = b, n;
      case Ae:
        return n = ya(13, l, r, v), n.elementType = Ae, n.lanes = b, n;
      case Ke:
        return n = ya(19, l, r, v), n.elementType = Ke, n.lanes = b, n;
      case qt:
        return Cd(l, v, b, r);
      default:
        if (typeof n == "object" && n !== null) switch (n.$$typeof) {
          case st:
            x = 10;
            break e;
          case Ie:
            x = 9;
            break e;
          case fe:
            x = 11;
            break e;
          case et:
            x = 14;
            break e;
          case _t:
            x = 16, f = null;
            break e;
        }
        throw Error(s(130, n == null ? n : typeof n, ""));
    }
    return r = ya(x, l, r, v), r.elementType = n, r.type = f, r.lanes = b, r;
  }
  function ja(n, r, l, f) {
    return n = ya(7, n, f, r), n.lanes = l, n;
  }
  function Cd(n, r, l, f) {
    return n = ya(22, n, f, r), n.elementType = qt, n.lanes = l, n.stateNode = { isHidden: !1 }, n;
  }
  function Td(n, r, l) {
    return n = ya(6, n, null, r), n.lanes = l, n;
  }
  function Rd(n, r, l) {
    return r = ya(4, n.children !== null ? n.children : [], n.key, r), r.lanes = l, r.stateNode = { containerInfo: n.containerInfo, pendingChildren: null, implementation: n.implementation }, r;
  }
  function Vg(n, r, l, f, v) {
    this.tag = r, this.containerInfo = n, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Mf(0), this.expirationTimes = Mf(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Mf(0), this.identifierPrefix = f, this.onRecoverableError = v, this.mutableSourceEagerHydrationData = null;
  }
  function Hp(n, r, l, f, v, b, x, N, D) {
    return n = new Vg(n, r, l, N, D), r === 1 ? (r = 1, b === !0 && (r |= 8)) : r = 0, b = ya(3, null, null, r), n.current = b, b.stateNode = n, b.memoizedState = { element: f, isDehydrated: l, cache: null, transitions: null, pendingSuspenseBoundaries: null }, wp(b), n;
  }
  function Bg(n, r, l) {
    var f = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: ft, key: f == null ? null : "" + f, children: n, containerInfo: r, implementation: l };
  }
  function Wg(n) {
    if (!n) return Tr;
    n = n._reactInternals;
    e: {
      if (Ra(n) !== n || n.tag !== 1) throw Error(s(170));
      var r = n;
      do {
        switch (r.tag) {
          case 3:
            r = r.stateNode.context;
            break e;
          case 1:
            if (gn(r.type)) {
              r = r.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        r = r.return;
      } while (r !== null);
      throw Error(s(171));
    }
    if (n.tag === 1) {
      var l = n.type;
      if (gn(l)) return pu(n, l, r);
    }
    return r;
  }
  function qg(n, r, l, f, v, b, x, N, D) {
    return n = Hp(l, f, !0, n, v, b, x, N, D), n.context = Wg(null), l = n.current, f = Kn(), v = va(l), b = To(f, v), b.callback = r ?? null, pi(l, b, v), n.current.lanes = v, Qi(n, v, f), fr(n, f), n;
  }
  function Pd(n, r, l, f) {
    var v = r.current, b = Kn(), x = va(v);
    return l = Wg(l), r.context === null ? r.context = l : r.pendingContext = l, r = To(b, x), r.payload = { element: n }, f = f === void 0 ? null : f, f !== null && (r.callback = f), n = pi(v, r, x), n !== null && ($a(n, v, x, b), Zc(n, v, x)), x;
  }
  function ju(n) {
    if (n = n.current, !n.child) return null;
    switch (n.child.tag) {
      case 5:
        return n.child.stateNode;
      default:
        return n.child.stateNode;
    }
  }
  function Zp(n, r) {
    if (n = n.memoizedState, n !== null && n.dehydrated !== null) {
      var l = n.retryLane;
      n.retryLane = l !== 0 && l < r ? l : r;
    }
  }
  function Nd(n, r) {
    Zp(n, r), (n = n.alternate) && Zp(n, r);
  }
  function _l() {
    return null;
  }
  var Hg = typeof reportError == "function" ? reportError : function(n) {
    console.error(n);
  };
  function Qp(n) {
    this._internalRoot = n;
  }
  Od.prototype.render = Qp.prototype.render = function(n) {
    var r = this._internalRoot;
    if (r === null) throw Error(s(409));
    Pd(n, r, null, null);
  }, Od.prototype.unmount = Qp.prototype.unmount = function() {
    var n = this._internalRoot;
    if (n !== null) {
      this._internalRoot = null;
      var r = n.containerInfo;
      Cs(function() {
        Pd(null, n, null, null);
      }), r[xo] = null;
    }
  };
  function Od(n) {
    this._internalRoot = n;
  }
  Od.prototype.unstable_scheduleHydration = function(n) {
    if (n) {
      var r = ut();
      n = { blockedOn: null, target: n, priority: r };
      for (var l = 0; l < Bn.length && r !== 0 && r < Bn[l].priority; l++) ;
      Bn.splice(l, 0, n), l === 0 && Bf(n);
    }
  };
  function Kp(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11);
  }
  function Ld(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11 && (n.nodeType !== 8 || n.nodeValue !== " react-mount-point-unstable "));
  }
  function Zg() {
  }
  function Qg(n, r, l, f, v) {
    if (v) {
      if (typeof f == "function") {
        var b = f;
        f = function() {
          var q = ju(x);
          b.call(q);
        };
      }
      var x = qg(r, f, n, 0, null, !1, !1, "", Zg);
      return n._reactRootContainer = x, n[xo] = x.current, il(n.nodeType === 8 ? n.parentNode : n), Cs(), x;
    }
    for (; v = n.lastChild; ) n.removeChild(v);
    if (typeof f == "function") {
      var N = f;
      f = function() {
        var q = ju(D);
        N.call(q);
      };
    }
    var D = Hp(n, 0, !1, null, null, !1, !1, "", Zg);
    return n._reactRootContainer = D, n[xo] = D.current, il(n.nodeType === 8 ? n.parentNode : n), Cs(function() {
      Pd(r, D, l, f);
    }), D;
  }
  function Dd(n, r, l, f, v) {
    var b = l._reactRootContainer;
    if (b) {
      var x = b;
      if (typeof v == "function") {
        var N = v;
        v = function() {
          var D = ju(x);
          N.call(D);
        };
      }
      Pd(r, x, n, v);
    } else x = Qg(l, r, n, v, f);
    return ju(x);
  }
  At = function(n) {
    switch (n.tag) {
      case 3:
        var r = n.stateNode;
        if (r.current.memoizedState.isDehydrated) {
          var l = Hi(r.pendingLanes);
          l !== 0 && (gc(r, l | 1), fr(r, Bt()), !(St & 6) && (io = Bt() + 500, Xa()));
        }
        break;
      case 13:
        Cs(function() {
          var f = Zr(n, 1);
          if (f !== null) {
            var v = Kn();
            $a(f, n, 1, v);
          }
        }), Nd(n, 1);
    }
  }, $f = function(n) {
    if (n.tag === 13) {
      var r = Zr(n, 134217728);
      if (r !== null) {
        var l = Kn();
        $a(r, n, 134217728, l);
      }
      Nd(n, 134217728);
    }
  }, jf = function(n) {
    if (n.tag === 13) {
      var r = va(n), l = Zr(n, r);
      if (l !== null) {
        var f = Kn();
        $a(l, n, r, f);
      }
      Nd(n, r);
    }
  }, ut = function() {
    return It;
  }, Uf = function(n, r) {
    var l = It;
    try {
      return It = n, r();
    } finally {
      It = l;
    }
  }, xn = function(n, r, l) {
    switch (r) {
      case "input":
        if (Vi(n, l), r = l.name, l.type === "radio" && r != null) {
          for (l = n; l.parentNode; ) l = l.parentNode;
          for (l = l.querySelectorAll("input[name=" + JSON.stringify("" + r) + '][type="radio"]'), r = 0; r < l.length; r++) {
            var f = l[r];
            if (f !== n && f.form === n.form) {
              var v = sn(f);
              if (!v) throw Error(s(90));
              pr(f), Vi(f, v);
            }
          }
        }
        break;
      case "textarea":
        Fe(n, l);
        break;
      case "select":
        r = l.value, r != null && ce(n, !!l.multiple, r, !1);
    }
  }, Tf = Bp, Rf = Cs;
  var Ib = { usingClientEntryPoint: !1, Events: [We, La, sn, wm, km, Bp] }, wl = { findFiberByHostInstance: as, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, Uu = { bundleType: wl.bundleType, version: wl.version, rendererPackageName: wl.rendererPackageName, rendererConfig: wl.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: qe.ReactCurrentDispatcher, findHostInstanceByFiber: function(n) {
    return n = Of(n), n === null ? null : n.stateNode;
  }, findFiberByHostInstance: wl.findFiberByHostInstance || _l, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Ei = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Ei.isDisabled && Ei.supportsFiber) try {
      Kl = Ei.inject(Uu), Pa = Ei;
    } catch {
    }
  }
  return Sa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Ib, Sa.createPortal = function(n, r) {
    var l = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Kp(r)) throw Error(s(200));
    return Bg(n, r, null, l);
  }, Sa.createRoot = function(n, r) {
    if (!Kp(n)) throw Error(s(299));
    var l = !1, f = "", v = Hg;
    return r != null && (r.unstable_strictMode === !0 && (l = !0), r.identifierPrefix !== void 0 && (f = r.identifierPrefix), r.onRecoverableError !== void 0 && (v = r.onRecoverableError)), r = Hp(n, 1, !1, null, null, l, !1, f, v), n[xo] = r.current, il(n.nodeType === 8 ? n.parentNode : n), new Qp(r);
  }, Sa.findDOMNode = function(n) {
    if (n == null) return null;
    if (n.nodeType === 1) return n;
    var r = n._reactInternals;
    if (r === void 0)
      throw typeof n.render == "function" ? Error(s(188)) : (n = Object.keys(n).join(","), Error(s(268, n)));
    return n = Of(r), n = n === null ? null : n.stateNode, n;
  }, Sa.flushSync = function(n) {
    return Cs(n);
  }, Sa.hydrate = function(n, r, l) {
    if (!Ld(r)) throw Error(s(200));
    return Dd(null, n, r, !0, l);
  }, Sa.hydrateRoot = function(n, r, l) {
    if (!Kp(n)) throw Error(s(405));
    var f = l != null && l.hydratedSources || null, v = !1, b = "", x = Hg;
    if (l != null && (l.unstable_strictMode === !0 && (v = !0), l.identifierPrefix !== void 0 && (b = l.identifierPrefix), l.onRecoverableError !== void 0 && (x = l.onRecoverableError)), r = qg(r, null, n, 1, l ?? null, v, !1, b, x), n[xo] = r.current, il(n), f) for (n = 0; n < f.length; n++) l = f[n], v = l._getVersion, v = v(l._source), r.mutableSourceEagerHydrationData == null ? r.mutableSourceEagerHydrationData = [l, v] : r.mutableSourceEagerHydrationData.push(
      l,
      v
    );
    return new Od(r);
  }, Sa.render = function(n, r, l) {
    if (!Ld(r)) throw Error(s(200));
    return Dd(null, n, r, !1, l);
  }, Sa.unmountComponentAtNode = function(n) {
    if (!Ld(n)) throw Error(s(40));
    return n._reactRootContainer ? (Cs(function() {
      Dd(null, null, n, !1, function() {
        n._reactRootContainer = null, n[xo] = null;
      });
    }), !0) : !1;
  }, Sa.unstable_batchedUpdates = Bp, Sa.unstable_renderSubtreeIntoContainer = function(n, r, l, f) {
    if (!Ld(l)) throw Error(s(200));
    if (n == null || n._reactInternals === void 0) throw Error(s(38));
    return Dd(n, r, l, !1, f);
  }, Sa.version = "18.3.1-next-f1338f8080-20240426", Sa;
}
var Wa = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var iE;
function ID() {
  return iE || (iE = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var u = xt, o = nC(), s = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, d = !1;
    function h(e) {
      d = e;
    }
    function m(e) {
      if (!d) {
        for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
          a[i - 1] = arguments[i];
        k("warn", e, a);
      }
    }
    function g(e) {
      if (!d) {
        for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
          a[i - 1] = arguments[i];
        k("error", e, a);
      }
    }
    function k(e, t, a) {
      {
        var i = s.ReactDebugCurrentFrame, c = i.getStackAddendum();
        c !== "" && (t += "%s", a = a.concat([c]));
        var p = a.map(function(y) {
          return String(y);
        });
        p.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, p);
      }
    }
    var S = 0, E = 1, R = 2, P = 3, O = 4, M = 5, $ = 6, Z = 7, G = 8, Pe = 9, re = 10, ve = 11, qe = 12, Re = 13, ft = 14, Oe = 15, ye = 16, rt = 17, st = 18, Ie = 19, fe = 21, Ae = 22, Ke = 23, et = 24, _t = 25, qt = !0, ue = !1, ke = !1, pe = !1, gt = !1, Ct = !0, or = !0, On = !0, vo = !0, Ln = /* @__PURE__ */ new Set(), $n = {}, ir = {};
    function Br(e, t) {
      Ha(e, t), Ha(e + "Capture", t);
    }
    function Ha(e, t) {
      $n[e] && g("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", e), $n[e] = t;
      {
        var a = e.toLowerCase();
        ir[a] = e, e === "onDoubleClick" && (ir.ondblclick = e);
      }
      for (var i = 0; i < t.length; i++)
        Ln.add(t[i]);
    }
    var kn = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", pr = Object.prototype.hasOwnProperty;
    function jn(e) {
      {
        var t = typeof Symbol == "function" && Symbol.toStringTag, a = t && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return a;
      }
    }
    function hr(e) {
      try {
        return Wr(e), !1;
      } catch {
        return !0;
      }
    }
    function Wr(e) {
      return "" + e;
    }
    function Za(e, t) {
      if (hr(e))
        return g("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", t, jn(e)), Wr(e);
    }
    function Vi(e) {
      if (hr(e))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", jn(e)), Wr(e);
    }
    function L(e, t) {
      if (hr(e))
        return g("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", t, jn(e)), Wr(e);
    }
    function W(e, t) {
      if (hr(e))
        return g("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", t, jn(e)), Wr(e);
    }
    function Q(e) {
      if (hr(e))
        return g("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", jn(e)), Wr(e);
    }
    function ce(e) {
      if (hr(e))
        return g("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", jn(e)), Wr(e);
    }
    var de = 0, ae = 1, Fe = 2, Ye = 3, Mt = 4, Zt = 5, sr = 6, xe = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", $e = xe + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", lt = new RegExp("^[" + xe + "][" + $e + "]*$"), Ft = {}, Qt = {};
    function Un(e) {
      return pr.call(Qt, e) ? !0 : pr.call(Ft, e) ? !1 : lt.test(e) ? (Qt[e] = !0, !0) : (Ft[e] = !0, g("Invalid attribute name: `%s`", e), !1);
    }
    function hn(e, t, a) {
      return t !== null ? t.type === de : a ? !1 : e.length > 2 && (e[0] === "o" || e[0] === "O") && (e[1] === "n" || e[1] === "N");
    }
    function ia(e, t, a, i) {
      if (a !== null && a.type === de)
        return !1;
      switch (typeof t) {
        case "function":
        // $FlowIssue symbol is perfectly valid here
        case "symbol":
          return !0;
        case "boolean": {
          if (i)
            return !1;
          if (a !== null)
            return !a.acceptsBooleans;
          var c = e.toLowerCase().slice(0, 5);
          return c !== "data-" && c !== "aria-";
        }
        default:
          return !1;
      }
    }
    function nn(e, t, a, i) {
      if (t === null || typeof t > "u" || ia(e, t, a, i))
        return !0;
      if (i)
        return !1;
      if (a !== null)
        switch (a.type) {
          case Ye:
            return !t;
          case Mt:
            return t === !1;
          case Zt:
            return isNaN(t);
          case sr:
            return isNaN(t) || t < 1;
        }
      return !1;
    }
    function Qa(e) {
      return xn.hasOwnProperty(e) ? xn[e] : null;
    }
    function Vn(e, t, a, i, c, p, y) {
      this.acceptsBooleans = t === Fe || t === Ye || t === Mt, this.attributeName = i, this.attributeNamespace = c, this.mustUseProperty = a, this.propertyName = e, this.type = t, this.sanitizeURL = p, this.removeEmptyString = y;
    }
    var xn = {}, Zs = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    Zs.forEach(function(e) {
      xn[e] = new Vn(
        e,
        de,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
      var t = e[0], a = e[1];
      xn[t] = new Vn(
        t,
        ae,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
      xn[e] = new Vn(
        e,
        Fe,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
      xn[e] = new Vn(
        e,
        Fe,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(e) {
      xn[e] = new Vn(
        e,
        Ye,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      xn[e] = new Vn(
        e,
        Ye,
        !0,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      xn[e] = new Vn(
        e,
        Mt,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      xn[e] = new Vn(
        e,
        sr,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(e) {
      xn[e] = new Vn(
        e,
        Zt,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Xo = /[\-\:]([a-z])/g, fc = function(e) {
      return e[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(Xo, fc);
      xn[t] = new Vn(
        t,
        ae,
        !1,
        // mustUseProperty
        e,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(Xo, fc);
      xn[t] = new Vn(
        t,
        ae,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(Xo, fc);
      xn[t] = new Vn(
        t,
        ae,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(e) {
      xn[e] = new Vn(
        e,
        ae,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var wm = "xlinkHref";
    xn[wm] = new Vn(
      "xlinkHref",
      ae,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(e) {
      xn[e] = new Vn(
        e,
        ae,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var km = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Tf = !1;
    function Rf(e) {
      !Tf && km.test(e) && (Tf = !0, g("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(e)));
    }
    function Pf(e, t, a, i) {
      if (i.mustUseProperty) {
        var c = i.propertyName;
        return e[c];
      } else {
        Za(a, t), i.sanitizeURL && Rf("" + a);
        var p = i.attributeName, y = null;
        if (i.type === Mt) {
          if (e.hasAttribute(p)) {
            var _ = e.getAttribute(p);
            return _ === "" ? !0 : nn(t, a, i, !1) ? _ : _ === "" + a ? a : _;
          }
        } else if (e.hasAttribute(p)) {
          if (nn(t, a, i, !1))
            return e.getAttribute(p);
          if (i.type === Ye)
            return a;
          y = e.getAttribute(p);
        }
        return nn(t, a, i, !1) ? y === null ? a : y : y === "" + a ? a : y;
      }
    }
    function Nf(e, t, a, i) {
      {
        if (!Un(t))
          return;
        if (!e.hasAttribute(t))
          return a === void 0 ? void 0 : null;
        var c = e.getAttribute(t);
        return Za(a, t), c === "" + a ? a : c;
      }
    }
    function Bi(e, t, a, i) {
      var c = Qa(t);
      if (!hn(t, c, i)) {
        if (nn(t, a, c, i) && (a = null), i || c === null) {
          if (Un(t)) {
            var p = t;
            a === null ? e.removeAttribute(p) : (Za(a, t), e.setAttribute(p, "" + a));
          }
          return;
        }
        var y = c.mustUseProperty;
        if (y) {
          var _ = c.propertyName;
          if (a === null) {
            var w = c.type;
            e[_] = w === Ye ? !1 : "";
          } else
            e[_] = a;
          return;
        }
        var C = c.attributeName, T = c.attributeNamespace;
        if (a === null)
          e.removeAttribute(C);
        else {
          var A = c.type, z;
          A === Ye || A === Mt && a === !0 ? z = "" : (Za(a, C), z = "" + a, c.sanitizeURL && Rf(z.toString())), T ? e.setAttributeNS(T, C, z) : e.setAttribute(C, z);
        }
      }
    }
    var ei = Symbol.for("react.element"), Ta = Symbol.for("react.portal"), Qs = Symbol.for("react.fragment"), Wi = Symbol.for("react.strict_mode"), Ks = Symbol.for("react.profiler"), Ys = Symbol.for("react.provider"), Zl = Symbol.for("react.context"), Gs = Symbol.for("react.forward_ref"), pc = Symbol.for("react.suspense"), hc = Symbol.for("react.suspense_list"), Ra = Symbol.for("react.memo"), lr = Symbol.for("react.lazy"), xm = Symbol.for("react.scope"), rb = Symbol.for("react.debug_trace_mode"), Of = Symbol.for("react.offscreen"), Sm = Symbol.for("react.legacy_hidden"), Em = Symbol.for("react.cache"), Cm = Symbol.for("react.tracing_marker"), Tm = Symbol.iterator, ab = "@@iterator";
    function Bt(e) {
      if (e === null || typeof e != "object")
        return null;
      var t = Tm && e[Tm] || e[ab];
      return typeof t == "function" ? t : null;
    }
    var bt = Object.assign, qi = 0, Lf, Ql, Rm, Df, Kl, Pa, Pm;
    function sa() {
    }
    sa.__reactDisabledLog = !0;
    function ob() {
      {
        if (qi === 0) {
          Lf = console.log, Ql = console.info, Rm = console.warn, Df = console.error, Kl = console.group, Pa = console.groupCollapsed, Pm = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: sa,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        qi++;
      }
    }
    function ib() {
      {
        if (qi--, qi === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: bt({}, e, {
              value: Lf
            }),
            info: bt({}, e, {
              value: Ql
            }),
            warn: bt({}, e, {
              value: Rm
            }),
            error: bt({}, e, {
              value: Df
            }),
            group: bt({}, e, {
              value: Kl
            }),
            groupCollapsed: bt({}, e, {
              value: Pa
            }),
            groupEnd: bt({}, e, {
              value: Pm
            })
          });
        }
        qi < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var zf = s.ReactCurrentDispatcher, Js;
    function Na(e, t, a) {
      {
        if (Js === void 0)
          try {
            throw Error();
          } catch (c) {
            var i = c.stack.trim().match(/\n( *(at )?)/);
            Js = i && i[1] || "";
          }
        return `
` + Js + e;
      }
    }
    var Hi = !1, Zi;
    {
      var sb = typeof WeakMap == "function" ? WeakMap : Map;
      Zi = new sb();
    }
    function If(e, t) {
      if (!e || Hi)
        return "";
      {
        var a = Zi.get(e);
        if (a !== void 0)
          return a;
      }
      var i;
      Hi = !0;
      var c = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var p;
      p = zf.current, zf.current = null, ob();
      try {
        if (t) {
          var y = function() {
            throw Error();
          };
          if (Object.defineProperty(y.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(y, []);
            } catch (H) {
              i = H;
            }
            Reflect.construct(e, [], y);
          } else {
            try {
              y.call();
            } catch (H) {
              i = H;
            }
            e.call(y.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (H) {
            i = H;
          }
          e();
        }
      } catch (H) {
        if (H && i && typeof H.stack == "string") {
          for (var _ = H.stack.split(`
`), w = i.stack.split(`
`), C = _.length - 1, T = w.length - 1; C >= 1 && T >= 0 && _[C] !== w[T]; )
            T--;
          for (; C >= 1 && T >= 0; C--, T--)
            if (_[C] !== w[T]) {
              if (C !== 1 || T !== 1)
                do
                  if (C--, T--, T < 0 || _[C] !== w[T]) {
                    var A = `
` + _[C].replace(" at new ", " at ");
                    return e.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", e.displayName)), typeof e == "function" && Zi.set(e, A), A;
                  }
                while (C >= 1 && T >= 0);
              break;
            }
        }
      } finally {
        Hi = !1, zf.current = p, ib(), Error.prepareStackTrace = c;
      }
      var z = e ? e.displayName || e.name : "", B = z ? Na(z) : "";
      return typeof e == "function" && Zi.set(e, B), B;
    }
    function Af(e, t, a) {
      return If(e, !0);
    }
    function mc(e, t, a) {
      return If(e, !1);
    }
    function Mf(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function Qi(e, t, a) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return If(e, Mf(e));
      if (typeof e == "string")
        return Na(e);
      switch (e) {
        case pc:
          return Na("Suspense");
        case hc:
          return Na("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case Gs:
            return mc(e.render);
          case Ra:
            return Qi(e.type, t, a);
          case lr: {
            var i = e, c = i._payload, p = i._init;
            try {
              return Qi(p(c), t, a);
            } catch {
            }
          }
        }
      return "";
    }
    function lb(e) {
      switch (e._debugOwner && e._debugOwner.type, e._debugSource, e.tag) {
        case M:
          return Na(e.type);
        case ye:
          return Na("Lazy");
        case Re:
          return Na("Suspense");
        case Ie:
          return Na("SuspenseList");
        case S:
        case R:
        case Oe:
          return mc(e.type);
        case ve:
          return mc(e.type.render);
        case E:
          return Af(e.type);
        default:
          return "";
      }
    }
    function gc(e) {
      try {
        var t = "", a = e;
        do
          t += lb(a), a = a.return;
        while (a);
        return t;
      } catch (i) {
        return `
Error generating stack: ` + i.message + `
` + i.stack;
      }
    }
    function It(e, t, a) {
      var i = e.displayName;
      if (i)
        return i;
      var c = t.displayName || t.name || "";
      return c !== "" ? a + "(" + c + ")" : a;
    }
    function Ff(e) {
      return e.displayName || "Context";
    }
    function At(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case Qs:
          return "Fragment";
        case Ta:
          return "Portal";
        case Ks:
          return "Profiler";
        case Wi:
          return "StrictMode";
        case pc:
          return "Suspense";
        case hc:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case Zl:
            var t = e;
            return Ff(t) + ".Consumer";
          case Ys:
            var a = e;
            return Ff(a._context) + ".Provider";
          case Gs:
            return It(e, e.render, "ForwardRef");
          case Ra:
            var i = e.displayName || null;
            return i !== null ? i : At(e.type) || "Memo";
          case lr: {
            var c = e, p = c._payload, y = c._init;
            try {
              return At(y(p));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function $f(e, t, a) {
      var i = t.displayName || t.name || "";
      return e.displayName || (i !== "" ? a + "(" + i + ")" : a);
    }
    function jf(e) {
      return e.displayName || "Context";
    }
    function ut(e) {
      var t = e.tag, a = e.type;
      switch (t) {
        case et:
          return "Cache";
        case Pe:
          var i = a;
          return jf(i) + ".Consumer";
        case re:
          var c = a;
          return jf(c._context) + ".Provider";
        case st:
          return "DehydratedFragment";
        case ve:
          return $f(a, a.render, "ForwardRef");
        case Z:
          return "Fragment";
        case M:
          return a;
        case O:
          return "Portal";
        case P:
          return "Root";
        case $:
          return "Text";
        case ye:
          return At(a);
        case G:
          return a === Wi ? "StrictMode" : "Mode";
        case Ae:
          return "Offscreen";
        case qe:
          return "Profiler";
        case fe:
          return "Scope";
        case Re:
          return "Suspense";
        case Ie:
          return "SuspenseList";
        case _t:
          return "TracingMarker";
        // The display name for this tags come from the user-provided type:
        case E:
        case S:
        case rt:
        case R:
        case ft:
        case Oe:
          if (typeof a == "function")
            return a.displayName || a.name || null;
          if (typeof a == "string")
            return a;
          break;
      }
      return null;
    }
    var Uf = s.ReactDebugCurrentFrame, mr = null, ti = !1;
    function la() {
      {
        if (mr === null)
          return null;
        var e = mr._debugOwner;
        if (e !== null && typeof e < "u")
          return ut(e);
      }
      return null;
    }
    function ni() {
      return mr === null ? "" : gc(mr);
    }
    function rn() {
      Uf.getCurrentStack = null, mr = null, ti = !1;
    }
    function Kt(e) {
      Uf.getCurrentStack = e === null ? null : ni, mr = e, ti = !1;
    }
    function Yl() {
      return mr;
    }
    function Bn(e) {
      ti = e;
    }
    function ua(e) {
      return "" + e;
    }
    function yo(e) {
      switch (typeof e) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return e;
        case "object":
          return ce(e), e;
        default:
          return "";
      }
    }
    var Gl = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Vf(e, t) {
      Gl[t.type] || t.onChange || t.onInput || t.readOnly || t.disabled || t.value == null || g("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), t.onChange || t.readOnly || t.disabled || t.checked == null || g("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function Bf(e) {
      var t = e.type, a = e.nodeName;
      return a && a.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
    }
    function Jl(e) {
      return e._valueTracker;
    }
    function Nm(e) {
      e._valueTracker = null;
    }
    function ub(e) {
      var t = "";
      return e && (Bf(e) ? t = e.checked ? "true" : "false" : t = e.value), t;
    }
    function Xl(e) {
      var t = Bf(e) ? "checked" : "value", a = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
      ce(e[t]);
      var i = "" + e[t];
      if (!(e.hasOwnProperty(t) || typeof a > "u" || typeof a.get != "function" || typeof a.set != "function")) {
        var c = a.get, p = a.set;
        Object.defineProperty(e, t, {
          configurable: !0,
          get: function() {
            return c.call(this);
          },
          set: function(_) {
            ce(_), i = "" + _, p.call(this, _);
          }
        }), Object.defineProperty(e, t, {
          enumerable: a.enumerable
        });
        var y = {
          getValue: function() {
            return i;
          },
          setValue: function(_) {
            ce(_), i = "" + _;
          },
          stopTracking: function() {
            Nm(e), delete e[t];
          }
        };
        return y;
      }
    }
    function ri(e) {
      Jl(e) || (e._valueTracker = Xl(e));
    }
    function Ki(e) {
      if (!e)
        return !1;
      var t = Jl(e);
      if (!t)
        return !0;
      var a = t.getValue(), i = ub(e);
      return i !== a ? (t.setValue(i), !0) : !1;
    }
    function Yi(e) {
      if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
        return null;
      try {
        return e.activeElement || e.body;
      } catch {
        return e.body;
      }
    }
    var Om = !1, Lm = !1, vc = !1, eu = !1;
    function yc(e) {
      var t = e.type === "checkbox" || e.type === "radio";
      return t ? e.checked != null : e.value != null;
    }
    function bc(e, t) {
      var a = e, i = t.checked, c = bt({}, t, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: i ?? a._wrapperState.initialChecked
      });
      return c;
    }
    function bo(e, t) {
      Vf("input", t), t.checked !== void 0 && t.defaultChecked !== void 0 && !Lm && (g("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", la() || "A component", t.type), Lm = !0), t.value !== void 0 && t.defaultValue !== void 0 && !Om && (g("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", la() || "A component", t.type), Om = !0);
      var a = e, i = t.defaultValue == null ? "" : t.defaultValue;
      a._wrapperState = {
        initialChecked: t.checked != null ? t.checked : t.defaultChecked,
        initialValue: yo(t.value != null ? t.value : i),
        controlled: yc(t)
      };
    }
    function _c(e, t) {
      var a = e, i = t.checked;
      i != null && Bi(a, "checked", i, !1);
    }
    function Xs(e, t) {
      var a = e;
      {
        var i = yc(t);
        !a._wrapperState.controlled && i && !eu && (g("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), eu = !0), a._wrapperState.controlled && !i && !vc && (g("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), vc = !0);
      }
      _c(e, t);
      var c = yo(t.value), p = t.type;
      if (c != null)
        p === "number" ? (c === 0 && a.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        a.value != c) && (a.value = ua(c)) : a.value !== ua(c) && (a.value = ua(c));
      else if (p === "submit" || p === "reset") {
        a.removeAttribute("value");
        return;
      }
      t.hasOwnProperty("value") ? xc(a, t.type, c) : t.hasOwnProperty("defaultValue") && xc(a, t.type, yo(t.defaultValue)), t.checked == null && t.defaultChecked != null && (a.defaultChecked = !!t.defaultChecked);
    }
    function Wf(e, t, a) {
      var i = e;
      if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
        var c = t.type, p = c === "submit" || c === "reset";
        if (p && (t.value === void 0 || t.value === null))
          return;
        var y = ua(i._wrapperState.initialValue);
        a || y !== i.value && (i.value = y), i.defaultValue = y;
      }
      var _ = i.name;
      _ !== "" && (i.name = ""), i.defaultChecked = !i.defaultChecked, i.defaultChecked = !!i._wrapperState.initialChecked, _ !== "" && (i.name = _);
    }
    function wc(e, t) {
      var a = e;
      Xs(a, t), kc(a, t);
    }
    function kc(e, t) {
      var a = t.name;
      if (t.type === "radio" && a != null) {
        for (var i = e; i.parentNode; )
          i = i.parentNode;
        Za(a, "name");
        for (var c = i.querySelectorAll("input[name=" + JSON.stringify("" + a) + '][type="radio"]'), p = 0; p < c.length; p++) {
          var y = c[p];
          if (!(y === e || y.form !== e.form)) {
            var _ = fv(y);
            if (!_)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            Ki(y), Xs(y, _);
          }
        }
      }
    }
    function xc(e, t, a) {
      (t !== "number" || Yi(e.ownerDocument) !== e) && (a == null ? e.defaultValue = ua(e._wrapperState.initialValue) : e.defaultValue !== ua(a) && (e.defaultValue = ua(a)));
    }
    var Er = !1, Gi = !1, Sc = !1;
    function el(e, t) {
      t.value == null && (typeof t.children == "object" && t.children !== null ? u.Children.forEach(t.children, function(a) {
        a != null && (typeof a == "string" || typeof a == "number" || Gi || (Gi = !0, g("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : t.dangerouslySetInnerHTML != null && (Sc || (Sc = !0, g("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), t.selected != null && !Er && (g("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Er = !0);
    }
    function cb(e, t) {
      t.value != null && e.setAttribute("value", ua(yo(t.value)));
    }
    var qf = Array.isArray;
    function Wn(e) {
      return qf(e);
    }
    var Ji;
    Ji = !1;
    function tu() {
      var e = la();
      return e ? `

Check the render method of \`` + e + "`." : "";
    }
    var Hf = ["value", "defaultValue"];
    function db(e) {
      {
        Vf("select", e);
        for (var t = 0; t < Hf.length; t++) {
          var a = Hf[t];
          if (e[a] != null) {
            var i = Wn(e[a]);
            e.multiple && !i ? g("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", a, tu()) : !e.multiple && i && g("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", a, tu());
          }
        }
      }
    }
    function tl(e, t, a, i) {
      var c = e.options;
      if (t) {
        for (var p = a, y = {}, _ = 0; _ < p.length; _++)
          y["$" + p[_]] = !0;
        for (var w = 0; w < c.length; w++) {
          var C = y.hasOwnProperty("$" + c[w].value);
          c[w].selected !== C && (c[w].selected = C), C && i && (c[w].defaultSelected = !0);
        }
      } else {
        for (var T = ua(yo(a)), A = null, z = 0; z < c.length; z++) {
          if (c[z].value === T) {
            c[z].selected = !0, i && (c[z].defaultSelected = !0);
            return;
          }
          A === null && !c[z].disabled && (A = c[z]);
        }
        A !== null && (A.selected = !0);
      }
    }
    function Zf(e, t) {
      return bt({}, t, {
        value: void 0
      });
    }
    function Ec(e, t) {
      var a = e;
      db(t), a._wrapperState = {
        wasMultiple: !!t.multiple
      }, t.value !== void 0 && t.defaultValue !== void 0 && !Ji && (g("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Ji = !0);
    }
    function fb(e, t) {
      var a = e;
      a.multiple = !!t.multiple;
      var i = t.value;
      i != null ? tl(a, !!t.multiple, i, !1) : t.defaultValue != null && tl(a, !!t.multiple, t.defaultValue, !0);
    }
    function pb(e, t) {
      var a = e, i = a._wrapperState.wasMultiple;
      a._wrapperState.wasMultiple = !!t.multiple;
      var c = t.value;
      c != null ? tl(a, !!t.multiple, c, !1) : i !== !!t.multiple && (t.defaultValue != null ? tl(a, !!t.multiple, t.defaultValue, !0) : tl(a, !!t.multiple, t.multiple ? [] : "", !1));
    }
    function hb(e, t) {
      var a = e, i = t.value;
      i != null && tl(a, !!t.multiple, i, !1);
    }
    var Dm = !1;
    function Qf(e, t) {
      var a = e;
      if (t.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var i = bt({}, t, {
        value: void 0,
        defaultValue: void 0,
        children: ua(a._wrapperState.initialValue)
      });
      return i;
    }
    function Kf(e, t) {
      var a = e;
      Vf("textarea", t), t.value !== void 0 && t.defaultValue !== void 0 && !Dm && (g("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", la() || "A component"), Dm = !0);
      var i = t.value;
      if (i == null) {
        var c = t.children, p = t.defaultValue;
        if (c != null) {
          g("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (p != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (Wn(c)) {
              if (c.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              c = c[0];
            }
            p = c;
          }
        }
        p == null && (p = ""), i = p;
      }
      a._wrapperState = {
        initialValue: yo(i)
      };
    }
    function zm(e, t) {
      var a = e, i = yo(t.value), c = yo(t.defaultValue);
      if (i != null) {
        var p = ua(i);
        p !== a.value && (a.value = p), t.defaultValue == null && a.defaultValue !== p && (a.defaultValue = p);
      }
      c != null && (a.defaultValue = ua(c));
    }
    function Im(e, t) {
      var a = e, i = a.textContent;
      i === a._wrapperState.initialValue && i !== "" && i !== null && (a.value = i);
    }
    function mb(e, t) {
      zm(e, t);
    }
    var _o = "http://www.w3.org/1999/xhtml", Yf = "http://www.w3.org/1998/Math/MathML", Gf = "http://www.w3.org/2000/svg";
    function Jf(e) {
      switch (e) {
        case "svg":
          return Gf;
        case "math":
          return Yf;
        default:
          return _o;
      }
    }
    function Xf(e, t) {
      return e == null || e === _o ? Jf(t) : e === Gf && t === "foreignObject" ? _o : e;
    }
    var Am = function(e) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, a, i, c) {
        MSApp.execUnsafeLocalFunction(function() {
          return e(t, a, i, c);
        });
      } : e;
    }, Cc, Mm = Am(function(e, t) {
      if (e.namespaceURI === Gf && !("innerHTML" in e)) {
        Cc = Cc || document.createElement("div"), Cc.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>";
        for (var a = Cc.firstChild; e.firstChild; )
          e.removeChild(e.firstChild);
        for (; a.firstChild; )
          e.appendChild(a.firstChild);
        return;
      }
      e.innerHTML = t;
    }), Cr = 1, wo = 3, mn = 8, ko = 9, ep = 11, nl = function(e, t) {
      if (t) {
        var a = e.firstChild;
        if (a && a === e.lastChild && a.nodeType === wo) {
          a.nodeValue = t;
          return;
        }
      }
      e.textContent = t;
    }, nu = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, ru = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function Fm(e, t) {
      return e + t.charAt(0).toUpperCase() + t.substring(1);
    }
    var $m = ["Webkit", "ms", "Moz", "O"];
    Object.keys(ru).forEach(function(e) {
      $m.forEach(function(t) {
        ru[Fm(t, e)] = ru[e];
      });
    });
    function Tc(e, t, a) {
      var i = t == null || typeof t == "boolean" || t === "";
      return i ? "" : !a && typeof t == "number" && t !== 0 && !(ru.hasOwnProperty(e) && ru[e]) ? t + "px" : (W(t, e), ("" + t).trim());
    }
    var jm = /([A-Z])/g, Um = /^ms-/;
    function rl(e) {
      return e.replace(jm, "-$1").toLowerCase().replace(Um, "-ms-");
    }
    var Vm = function() {
    };
    {
      var gb = /^(?:webkit|moz|o)[A-Z]/, vb = /^-ms-/, Bm = /-(.)/g, tp = /;\s*$/, Ka = {}, Xi = {}, Wm = !1, au = !1, yb = function(e) {
        return e.replace(Bm, function(t, a) {
          return a.toUpperCase();
        });
      }, qm = function(e) {
        Ka.hasOwnProperty(e) && Ka[e] || (Ka[e] = !0, g(
          "Unsupported style property %s. Did you mean %s?",
          e,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          yb(e.replace(vb, "ms-"))
        ));
      }, np = function(e) {
        Ka.hasOwnProperty(e) && Ka[e] || (Ka[e] = !0, g("Unsupported vendor-prefixed style property %s. Did you mean %s?", e, e.charAt(0).toUpperCase() + e.slice(1)));
      }, rp = function(e, t) {
        Xi.hasOwnProperty(t) && Xi[t] || (Xi[t] = !0, g(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, e, t.replace(tp, "")));
      }, Hm = function(e, t) {
        Wm || (Wm = !0, g("`NaN` is an invalid value for the `%s` css style property.", e));
      }, Zm = function(e, t) {
        au || (au = !0, g("`Infinity` is an invalid value for the `%s` css style property.", e));
      };
      Vm = function(e, t) {
        e.indexOf("-") > -1 ? qm(e) : gb.test(e) ? np(e) : tp.test(t) && rp(e, t), typeof t == "number" && (isNaN(t) ? Hm(e, t) : isFinite(t) || Zm(e, t));
      };
    }
    var Qm = Vm;
    function bb(e) {
      {
        var t = "", a = "";
        for (var i in e)
          if (e.hasOwnProperty(i)) {
            var c = e[i];
            if (c != null) {
              var p = i.indexOf("--") === 0;
              t += a + (p ? i : rl(i)) + ":", t += Tc(i, c, p), a = ";";
            }
          }
        return t || null;
      }
    }
    function Km(e, t) {
      var a = e.style;
      for (var i in t)
        if (t.hasOwnProperty(i)) {
          var c = i.indexOf("--") === 0;
          c || Qm(i, t[i]);
          var p = Tc(i, t[i], c);
          i === "float" && (i = "cssFloat"), c ? a.setProperty(i, p) : a[i] = p;
        }
    }
    function _b(e) {
      return e == null || typeof e == "boolean" || e === "";
    }
    function Ym(e) {
      var t = {};
      for (var a in e)
        for (var i = nu[a] || [a], c = 0; c < i.length; c++)
          t[i[c]] = a;
      return t;
    }
    function wb(e, t) {
      {
        if (!t)
          return;
        var a = Ym(e), i = Ym(t), c = {};
        for (var p in a) {
          var y = a[p], _ = i[p];
          if (_ && y !== _) {
            var w = y + "," + _;
            if (c[w])
              continue;
            c[w] = !0, g("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", _b(e[y]) ? "Removing" : "Updating", y, _);
          }
        }
      }
    }
    var Oa = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, ou = bt({
      menuitem: !0
    }, Oa), Gm = "__html";
    function Rc(e, t) {
      if (t) {
        if (ou[e] && (t.children != null || t.dangerouslySetInnerHTML != null))
          throw new Error(e + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (t.dangerouslySetInnerHTML != null) {
          if (t.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof t.dangerouslySetInnerHTML != "object" || !(Gm in t.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!t.suppressContentEditableWarning && t.contentEditable && t.children != null && g("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), t.style != null && typeof t.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function ai(e, t) {
      if (e.indexOf("-") === -1)
        return typeof t.is == "string";
      switch (e) {
        // These are reserved SVG and MathML elements.
        // We don't mind this list too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var iu = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Pc = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, al = {}, kb = new RegExp("^(aria)-[" + $e + "]*$"), ol = new RegExp("^(aria)[A-Z][" + $e + "]*$");
    function ap(e, t) {
      {
        if (pr.call(al, t) && al[t])
          return !0;
        if (ol.test(t)) {
          var a = "aria-" + t.slice(4).toLowerCase(), i = Pc.hasOwnProperty(a) ? a : null;
          if (i == null)
            return g("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", t), al[t] = !0, !0;
          if (t !== i)
            return g("Invalid ARIA attribute `%s`. Did you mean `%s`?", t, i), al[t] = !0, !0;
        }
        if (kb.test(t)) {
          var c = t.toLowerCase(), p = Pc.hasOwnProperty(c) ? c : null;
          if (p == null)
            return al[t] = !0, !1;
          if (t !== p)
            return g("Unknown ARIA attribute `%s`. Did you mean `%s`?", t, p), al[t] = !0, !0;
        }
      }
      return !0;
    }
    function su(e, t) {
      {
        var a = [];
        for (var i in t) {
          var c = ap(e, i);
          c || a.push(i);
        }
        var p = a.map(function(y) {
          return "`" + y + "`";
        }).join(", ");
        a.length === 1 ? g("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", p, e) : a.length > 1 && g("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", p, e);
      }
    }
    function op(e, t) {
      ai(e, t) || su(e, t);
    }
    var ip = !1;
    function Nc(e, t) {
      {
        if (e !== "input" && e !== "textarea" && e !== "select")
          return;
        t != null && t.value === null && !ip && (ip = !0, e === "select" && t.multiple ? g("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", e) : g("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", e));
      }
    }
    var es = function() {
    };
    {
      var qn = {}, sp = /^on./, Oc = /^on[^A-Z]/, Jm = new RegExp("^(aria)-[" + $e + "]*$"), Xm = new RegExp("^(aria)[A-Z][" + $e + "]*$");
      es = function(e, t, a, i) {
        if (pr.call(qn, t) && qn[t])
          return !0;
        var c = t.toLowerCase();
        if (c === "onfocusin" || c === "onfocusout")
          return g("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), qn[t] = !0, !0;
        if (i != null) {
          var p = i.registrationNameDependencies, y = i.possibleRegistrationNames;
          if (p.hasOwnProperty(t))
            return !0;
          var _ = y.hasOwnProperty(c) ? y[c] : null;
          if (_ != null)
            return g("Invalid event handler property `%s`. Did you mean `%s`?", t, _), qn[t] = !0, !0;
          if (sp.test(t))
            return g("Unknown event handler property `%s`. It will be ignored.", t), qn[t] = !0, !0;
        } else if (sp.test(t))
          return Oc.test(t) && g("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", t), qn[t] = !0, !0;
        if (Jm.test(t) || Xm.test(t))
          return !0;
        if (c === "innerhtml")
          return g("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), qn[t] = !0, !0;
        if (c === "aria")
          return g("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), qn[t] = !0, !0;
        if (c === "is" && a !== null && a !== void 0 && typeof a != "string")
          return g("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof a), qn[t] = !0, !0;
        if (typeof a == "number" && isNaN(a))
          return g("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", t), qn[t] = !0, !0;
        var w = Qa(t), C = w !== null && w.type === de;
        if (iu.hasOwnProperty(c)) {
          var T = iu[c];
          if (T !== t)
            return g("Invalid DOM property `%s`. Did you mean `%s`?", t, T), qn[t] = !0, !0;
        } else if (!C && t !== c)
          return g("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", t, c), qn[t] = !0, !0;
        return typeof a == "boolean" && ia(t, a, w, !1) ? (a ? g('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', a, t, t, a, t) : g('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', a, t, t, a, t, t, t), qn[t] = !0, !0) : C ? !0 : ia(t, a, w, !1) ? (qn[t] = !0, !1) : ((a === "false" || a === "true") && w !== null && w.type === Ye && (g("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", a, t, a === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', t, a), qn[t] = !0), !0);
      };
    }
    var eg = function(e, t, a) {
      {
        var i = [];
        for (var c in t) {
          var p = es(e, c, t[c], a);
          p || i.push(c);
        }
        var y = i.map(function(_) {
          return "`" + _ + "`";
        }).join(", ");
        i.length === 1 ? g("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", y, e) : i.length > 1 && g("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", y, e);
      }
    };
    function tg(e, t, a) {
      ai(e, t) || eg(e, t, a);
    }
    var lp = 1, Lc = 2, ca = 4, up = lp | Lc | ca, ts = null;
    function xb(e) {
      ts !== null && g("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), ts = e;
    }
    function Sb() {
      ts === null && g("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), ts = null;
    }
    function lu(e) {
      return e === ts;
    }
    function cp(e) {
      var t = e.target || e.srcElement || window;
      return t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === wo ? t.parentNode : t;
    }
    var Dc = null, ns = null, Dt = null;
    function zc(e) {
      var t = Sl(e);
      if (t) {
        if (typeof Dc != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var a = t.stateNode;
        if (a) {
          var i = fv(a);
          Dc(t.stateNode, t.type, i);
        }
      }
    }
    function Ic(e) {
      Dc = e;
    }
    function il(e) {
      ns ? Dt ? Dt.push(e) : Dt = [e] : ns = e;
    }
    function ng() {
      return ns !== null || Dt !== null;
    }
    function Ac() {
      if (ns) {
        var e = ns, t = Dt;
        if (ns = null, Dt = null, zc(e), t)
          for (var a = 0; a < t.length; a++)
            zc(t[a]);
      }
    }
    var sl = function(e, t) {
      return e(t);
    }, uu = function() {
    }, oi = !1;
    function rg() {
      var e = ng();
      e && (uu(), Ac());
    }
    function ag(e, t, a) {
      if (oi)
        return e(t, a);
      oi = !0;
      try {
        return sl(e, t, a);
      } finally {
        oi = !1, rg();
      }
    }
    function Eb(e, t, a) {
      sl = e, uu = a;
    }
    function og(e) {
      return e === "button" || e === "input" || e === "select" || e === "textarea";
    }
    function Mc(e, t, a) {
      switch (e) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(a.disabled && og(t));
        default:
          return !1;
      }
    }
    function ii(e, t) {
      var a = e.stateNode;
      if (a === null)
        return null;
      var i = fv(a);
      if (i === null)
        return null;
      var c = i[t];
      if (Mc(t, e.type, i))
        return null;
      if (c && typeof c != "function")
        throw new Error("Expected `" + t + "` listener to be a function, instead got a value of `" + typeof c + "` type.");
      return c;
    }
    var cu = !1;
    if (kn)
      try {
        var rs = {};
        Object.defineProperty(rs, "passive", {
          get: function() {
            cu = !0;
          }
        }), window.addEventListener("test", rs, rs), window.removeEventListener("test", rs, rs);
      } catch {
        cu = !1;
      }
    function Fc(e, t, a, i, c, p, y, _, w) {
      var C = Array.prototype.slice.call(arguments, 3);
      try {
        t.apply(a, C);
      } catch (T) {
        this.onError(T);
      }
    }
    var $c = Fc;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var dp = document.createElement("react");
      $c = function(e, t, a, i, c, p, y, _, w) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var C = document.createEvent("Event"), T = !1, A = !0, z = window.event, B = Object.getOwnPropertyDescriptor(window, "event");
        function H() {
          dp.removeEventListener(U, me, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = z);
        }
        var Y = Array.prototype.slice.call(arguments, 3);
        function me() {
          T = !0, H(), t.apply(a, Y), A = !1;
        }
        var Ue, Qe = !1, vt = !1;
        function ht(K) {
          if (Ue = K.error, Qe = !0, Ue === null && K.colno === 0 && K.lineno === 0 && (vt = !0), K.defaultPrevented && Ue != null && typeof Ue == "object")
            try {
              Ue._suppressLogging = !0;
            } catch {
            }
        }
        var U = "react-" + (e || "invokeguardedcallback");
        if (window.addEventListener("error", ht), dp.addEventListener(U, me, !1), C.initEvent(U, !1, !1), dp.dispatchEvent(C), B && Object.defineProperty(window, "event", B), T && A && (Qe ? vt && (Ue = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Ue = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Ue)), window.removeEventListener("error", ht), !T)
          return H(), Fc.apply(this, arguments);
      };
    }
    var ig = $c, ll = !1, jc = null, ul = !1, Ya = null, sg = {
      onError: function(e) {
        ll = !0, jc = e;
      }
    };
    function si(e, t, a, i, c, p, y, _, w) {
      ll = !1, jc = null, ig.apply(sg, arguments);
    }
    function Ga(e, t, a, i, c, p, y, _, w) {
      if (si.apply(this, arguments), ll) {
        var C = fu();
        ul || (ul = !0, Ya = C);
      }
    }
    function du() {
      if (ul) {
        var e = Ya;
        throw ul = !1, Ya = null, e;
      }
    }
    function xo() {
      return ll;
    }
    function fu() {
      if (ll) {
        var e = jc;
        return ll = !1, jc = null, e;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function cl(e) {
      return e._reactInternals;
    }
    function Cb(e) {
      return e._reactInternals !== void 0;
    }
    function as(e, t) {
      e._reactInternals = t;
    }
    var We = (
      /*                      */
      0
    ), La = (
      /*                */
      1
    ), sn = (
      /*                    */
      2
    ), wt = (
      /*                       */
      4
    ), da = (
      /*                */
      16
    ), Da = (
      /*                 */
      32
    ), Ht = (
      /*                     */
      64
    ), Be = (
      /*                   */
      128
    ), Tr = (
      /*            */
      256
    ), an = (
      /*                          */
      512
    ), Sn = (
      /*                     */
      1024
    ), Rr = (
      /*                      */
      2048
    ), fa = (
      /*                    */
      4096
    ), gn = (
      /*                   */
      8192
    ), dl = (
      /*             */
      16384
    ), lg = (
      /*               */
      32767
    ), pu = (
      /*                   */
      32768
    ), Pr = (
      /*                */
      65536
    ), Uc = (
      /* */
      131072
    ), Ja = (
      /*                       */
      1048576
    ), fl = (
      /*                    */
      2097152
    ), So = (
      /*                 */
      4194304
    ), Vc = (
      /*                */
      8388608
    ), li = (
      /*               */
      16777216
    ), Xa = (
      /*              */
      33554432
    ), ui = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      wt | Sn | 0
    ), ci = sn | wt | da | Da | an | fa | gn, di = wt | Ht | an | gn, Eo = Rr | da, vn = So | Vc | fl, pa = s.ReactCurrentOwner;
    function qr(e) {
      var t = e, a = e;
      if (e.alternate)
        for (; t.return; )
          t = t.return;
      else {
        var i = t;
        do
          t = i, (t.flags & (sn | fa)) !== We && (a = t.return), i = t.return;
        while (i);
      }
      return t.tag === P ? a : null;
    }
    function eo(e) {
      if (e.tag === Re) {
        var t = e.memoizedState;
        if (t === null) {
          var a = e.alternate;
          a !== null && (t = a.memoizedState);
        }
        if (t !== null)
          return t.dehydrated;
      }
      return null;
    }
    function to(e) {
      return e.tag === P ? e.stateNode.containerInfo : null;
    }
    function os(e) {
      return qr(e) === e;
    }
    function ug(e) {
      {
        var t = pa.current;
        if (t !== null && t.tag === E) {
          var a = t, i = a.stateNode;
          i._warnedAboutRefsInRender || g("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", ut(a) || "A component"), i._warnedAboutRefsInRender = !0;
        }
      }
      var c = cl(e);
      return c ? qr(c) === c : !1;
    }
    function Bc(e) {
      if (qr(e) !== e)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function Wc(e) {
      var t = e.alternate;
      if (!t) {
        var a = qr(e);
        if (a === null)
          throw new Error("Unable to find node on an unmounted component.");
        return a !== e ? null : e;
      }
      for (var i = e, c = t; ; ) {
        var p = i.return;
        if (p === null)
          break;
        var y = p.alternate;
        if (y === null) {
          var _ = p.return;
          if (_ !== null) {
            i = c = _;
            continue;
          }
          break;
        }
        if (p.child === y.child) {
          for (var w = p.child; w; ) {
            if (w === i)
              return Bc(p), e;
            if (w === c)
              return Bc(p), t;
            w = w.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (i.return !== c.return)
          i = p, c = y;
        else {
          for (var C = !1, T = p.child; T; ) {
            if (T === i) {
              C = !0, i = p, c = y;
              break;
            }
            if (T === c) {
              C = !0, c = p, i = y;
              break;
            }
            T = T.sibling;
          }
          if (!C) {
            for (T = y.child; T; ) {
              if (T === i) {
                C = !0, i = y, c = p;
                break;
              }
              if (T === c) {
                C = !0, c = y, i = p;
                break;
              }
              T = T.sibling;
            }
            if (!C)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (i.alternate !== c)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (i.tag !== P)
        throw new Error("Unable to find node on an unmounted component.");
      return i.stateNode.current === i ? e : t;
    }
    function Nr(e) {
      var t = Wc(e);
      return t !== null ? Or(t) : null;
    }
    function Or(e) {
      if (e.tag === M || e.tag === $)
        return e;
      for (var t = e.child; t !== null; ) {
        var a = Or(t);
        if (a !== null)
          return a;
        t = t.sibling;
      }
      return null;
    }
    function Gt(e) {
      var t = Wc(e);
      return t !== null ? ha(t) : null;
    }
    function ha(e) {
      if (e.tag === M || e.tag === $)
        return e;
      for (var t = e.child; t !== null; ) {
        if (t.tag !== O) {
          var a = ha(t);
          if (a !== null)
            return a;
        }
        t = t.sibling;
      }
      return null;
    }
    var fp = o.unstable_scheduleCallback, cg = o.unstable_cancelCallback, pp = o.unstable_shouldYield, hp = o.unstable_requestPaint, En = o.unstable_now, qc = o.unstable_getCurrentPriorityLevel, hu = o.unstable_ImmediatePriority, fi = o.unstable_UserBlockingPriority, Co = o.unstable_NormalPriority, Tb = o.unstable_LowPriority, is = o.unstable_IdlePriority, Hc = o.unstable_yieldValue, dg = o.unstable_setDisableYieldValue, ss = null, ln = null, be = null, Hr = !1, Lr = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function pl(e) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (t.isDisabled)
        return !0;
      if (!t.supportsFiber)
        return g("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        or && (e = bt({}, e, {
          getLaneLabelMap: ls,
          injectProfilingHooks: ma
        })), ss = t.inject(e), ln = t;
      } catch (a) {
        g("React instrumentation encountered an error: %s.", a);
      }
      return !!t.checkDCE;
    }
    function mp(e, t) {
      if (ln && typeof ln.onScheduleFiberRoot == "function")
        try {
          ln.onScheduleFiberRoot(ss, e, t);
        } catch (a) {
          Hr || (Hr = !0, g("React instrumentation encountered an error: %s", a));
        }
    }
    function gp(e, t) {
      if (ln && typeof ln.onCommitFiberRoot == "function")
        try {
          var a = (e.current.flags & Be) === Be;
          if (On) {
            var i;
            switch (t) {
              case zr:
                i = hu;
                break;
              case Aa:
                i = fi;
                break;
              case ro:
                i = Co;
                break;
              case _s:
                i = is;
                break;
              default:
                i = Co;
                break;
            }
            ln.onCommitFiberRoot(ss, e, i, a);
          }
        } catch (c) {
          Hr || (Hr = !0, g("React instrumentation encountered an error: %s", c));
        }
    }
    function vp(e) {
      if (ln && typeof ln.onPostCommitFiberRoot == "function")
        try {
          ln.onPostCommitFiberRoot(ss, e);
        } catch (t) {
          Hr || (Hr = !0, g("React instrumentation encountered an error: %s", t));
        }
    }
    function yp(e) {
      if (ln && typeof ln.onCommitFiberUnmount == "function")
        try {
          ln.onCommitFiberUnmount(ss, e);
        } catch (t) {
          Hr || (Hr = !0, g("React instrumentation encountered an error: %s", t));
        }
    }
    function Jt(e) {
      if (typeof Hc == "function" && (dg(e), h(e)), ln && typeof ln.setStrictMode == "function")
        try {
          ln.setStrictMode(ss, e);
        } catch (t) {
          Hr || (Hr = !0, g("React instrumentation encountered an error: %s", t));
        }
    }
    function ma(e) {
      be = e;
    }
    function ls() {
      {
        for (var e = /* @__PURE__ */ new Map(), t = 1, a = 0; a < ds; a++) {
          var i = mg(t);
          e.set(t, i), t *= 2;
        }
        return e;
      }
    }
    function bp(e) {
      be !== null && typeof be.markCommitStarted == "function" && be.markCommitStarted(e);
    }
    function _p() {
      be !== null && typeof be.markCommitStopped == "function" && be.markCommitStopped();
    }
    function Zr(e) {
      be !== null && typeof be.markComponentRenderStarted == "function" && be.markComponentRenderStarted(e);
    }
    function Qr() {
      be !== null && typeof be.markComponentRenderStopped == "function" && be.markComponentRenderStopped();
    }
    function wp(e) {
      be !== null && typeof be.markComponentPassiveEffectMountStarted == "function" && be.markComponentPassiveEffectMountStarted(e);
    }
    function fg() {
      be !== null && typeof be.markComponentPassiveEffectMountStopped == "function" && be.markComponentPassiveEffectMountStopped();
    }
    function To(e) {
      be !== null && typeof be.markComponentPassiveEffectUnmountStarted == "function" && be.markComponentPassiveEffectUnmountStarted(e);
    }
    function pi() {
      be !== null && typeof be.markComponentPassiveEffectUnmountStopped == "function" && be.markComponentPassiveEffectUnmountStopped();
    }
    function Zc(e) {
      be !== null && typeof be.markComponentLayoutEffectMountStarted == "function" && be.markComponentLayoutEffectMountStarted(e);
    }
    function pg() {
      be !== null && typeof be.markComponentLayoutEffectMountStopped == "function" && be.markComponentLayoutEffectMountStopped();
    }
    function mu(e) {
      be !== null && typeof be.markComponentLayoutEffectUnmountStarted == "function" && be.markComponentLayoutEffectUnmountStarted(e);
    }
    function kp() {
      be !== null && typeof be.markComponentLayoutEffectUnmountStopped == "function" && be.markComponentLayoutEffectUnmountStopped();
    }
    function gu(e, t, a) {
      be !== null && typeof be.markComponentErrored == "function" && be.markComponentErrored(e, t, a);
    }
    function no(e, t, a) {
      be !== null && typeof be.markComponentSuspended == "function" && be.markComponentSuspended(e, t, a);
    }
    function vu(e) {
      be !== null && typeof be.markLayoutEffectsStarted == "function" && be.markLayoutEffectsStarted(e);
    }
    function yu() {
      be !== null && typeof be.markLayoutEffectsStopped == "function" && be.markLayoutEffectsStopped();
    }
    function us(e) {
      be !== null && typeof be.markPassiveEffectsStarted == "function" && be.markPassiveEffectsStarted(e);
    }
    function xp() {
      be !== null && typeof be.markPassiveEffectsStopped == "function" && be.markPassiveEffectsStopped();
    }
    function cs(e) {
      be !== null && typeof be.markRenderStarted == "function" && be.markRenderStarted(e);
    }
    function hg() {
      be !== null && typeof be.markRenderYielded == "function" && be.markRenderYielded();
    }
    function Qc() {
      be !== null && typeof be.markRenderStopped == "function" && be.markRenderStopped();
    }
    function Xt(e) {
      be !== null && typeof be.markRenderScheduled == "function" && be.markRenderScheduled(e);
    }
    function Kc(e, t) {
      be !== null && typeof be.markForceUpdateScheduled == "function" && be.markForceUpdateScheduled(e, t);
    }
    function bu(e, t) {
      be !== null && typeof be.markStateUpdateScheduled == "function" && be.markStateUpdateScheduled(e, t);
    }
    var He = (
      /*                         */
      0
    ), pt = (
      /*                 */
      1
    ), Tt = (
      /*                    */
      2
    ), $t = (
      /*               */
      8
    ), Rt = (
      /*              */
      16
    ), yn = Math.clz32 ? Math.clz32 : _u, Dn = Math.log, Yc = Math.LN2;
    function _u(e) {
      var t = e >>> 0;
      return t === 0 ? 32 : 31 - (Dn(t) / Yc | 0) | 0;
    }
    var ds = 31, X = (
      /*                        */
      0
    ), Et = (
      /*                          */
      0
    ), Je = (
      /*                        */
      1
    ), hi = (
      /*    */
      2
    ), za = (
      /*             */
      4
    ), ur = (
      /*            */
      8
    ), un = (
      /*                     */
      16
    ), Ro = (
      /*                */
      32
    ), mi = (
      /*                       */
      4194240
    ), fs = (
      /*                        */
      64
    ), Gc = (
      /*                        */
      128
    ), Jc = (
      /*                        */
      256
    ), Xc = (
      /*                        */
      512
    ), ed = (
      /*                        */
      1024
    ), td = (
      /*                        */
      2048
    ), nd = (
      /*                        */
      4096
    ), rd = (
      /*                        */
      8192
    ), ad = (
      /*                        */
      16384
    ), ps = (
      /*                       */
      32768
    ), od = (
      /*                       */
      65536
    ), hl = (
      /*                       */
      131072
    ), ml = (
      /*                       */
      262144
    ), id = (
      /*                       */
      524288
    ), wu = (
      /*                       */
      1048576
    ), sd = (
      /*                       */
      2097152
    ), ku = (
      /*                            */
      130023424
    ), hs = (
      /*                             */
      4194304
    ), ld = (
      /*                             */
      8388608
    ), xu = (
      /*                             */
      16777216
    ), ud = (
      /*                             */
      33554432
    ), cd = (
      /*                             */
      67108864
    ), Sp = hs, Su = (
      /*          */
      134217728
    ), Ep = (
      /*                          */
      268435455
    ), Eu = (
      /*               */
      268435456
    ), ms = (
      /*                        */
      536870912
    ), Kr = (
      /*                   */
      1073741824
    );
    function mg(e) {
      {
        if (e & Je)
          return "Sync";
        if (e & hi)
          return "InputContinuousHydration";
        if (e & za)
          return "InputContinuous";
        if (e & ur)
          return "DefaultHydration";
        if (e & un)
          return "Default";
        if (e & Ro)
          return "TransitionHydration";
        if (e & mi)
          return "Transition";
        if (e & ku)
          return "Retry";
        if (e & Su)
          return "SelectiveHydration";
        if (e & Eu)
          return "IdleHydration";
        if (e & ms)
          return "Idle";
        if (e & Kr)
          return "Offscreen";
      }
    }
    var Wt = -1, gs = fs, dd = hs;
    function Cu(e) {
      switch (gi(e)) {
        case Je:
          return Je;
        case hi:
          return hi;
        case za:
          return za;
        case ur:
          return ur;
        case un:
          return un;
        case Ro:
          return Ro;
        case fs:
        case Gc:
        case Jc:
        case Xc:
        case ed:
        case td:
        case nd:
        case rd:
        case ad:
        case ps:
        case od:
        case hl:
        case ml:
        case id:
        case wu:
        case sd:
          return e & mi;
        case hs:
        case ld:
        case xu:
        case ud:
        case cd:
          return e & ku;
        case Su:
          return Su;
        case Eu:
          return Eu;
        case ms:
          return ms;
        case Kr:
          return Kr;
        default:
          return g("Should have found matching lanes. This is a bug in React."), e;
      }
    }
    function fd(e, t) {
      var a = e.pendingLanes;
      if (a === X)
        return X;
      var i = X, c = e.suspendedLanes, p = e.pingedLanes, y = a & Ep;
      if (y !== X) {
        var _ = y & ~c;
        if (_ !== X)
          i = Cu(_);
        else {
          var w = y & p;
          w !== X && (i = Cu(w));
        }
      } else {
        var C = a & ~c;
        C !== X ? i = Cu(C) : p !== X && (i = Cu(p));
      }
      if (i === X)
        return X;
      if (t !== X && t !== i && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (t & c) === X) {
        var T = gi(i), A = gi(t);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          T >= A || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          T === un && (A & mi) !== X
        )
          return t;
      }
      (i & za) !== X && (i |= a & un);
      var z = e.entangledLanes;
      if (z !== X)
        for (var B = e.entanglements, H = i & z; H > 0; ) {
          var Y = bn(H), me = 1 << Y;
          i |= B[Y], H &= ~me;
        }
      return i;
    }
    function Ia(e, t) {
      for (var a = e.eventTimes, i = Wt; t > 0; ) {
        var c = bn(t), p = 1 << c, y = a[c];
        y > i && (i = y), t &= ~p;
      }
      return i;
    }
    function Cp(e, t) {
      switch (e) {
        case Je:
        case hi:
        case za:
          return t + 250;
        case ur:
        case un:
        case Ro:
        case fs:
        case Gc:
        case Jc:
        case Xc:
        case ed:
        case td:
        case nd:
        case rd:
        case ad:
        case ps:
        case od:
        case hl:
        case ml:
        case id:
        case wu:
        case sd:
          return t + 5e3;
        case hs:
        case ld:
        case xu:
        case ud:
        case cd:
          return Wt;
        case Su:
        case Eu:
        case ms:
        case Kr:
          return Wt;
        default:
          return g("Should have found matching lanes. This is a bug in React."), Wt;
      }
    }
    function pd(e, t) {
      for (var a = e.pendingLanes, i = e.suspendedLanes, c = e.pingedLanes, p = e.expirationTimes, y = a; y > 0; ) {
        var _ = bn(y), w = 1 << _, C = p[_];
        C === Wt ? ((w & i) === X || (w & c) !== X) && (p[_] = Cp(w, t)) : C <= t && (e.expiredLanes |= w), y &= ~w;
      }
    }
    function gg(e) {
      return Cu(e.pendingLanes);
    }
    function hd(e) {
      var t = e.pendingLanes & -1073741825;
      return t !== X ? t : t & Kr ? Kr : X;
    }
    function vg(e) {
      return (e & Je) !== X;
    }
    function Tu(e) {
      return (e & Ep) !== X;
    }
    function vs(e) {
      return (e & ku) === e;
    }
    function Tp(e) {
      var t = Je | za | un;
      return (e & t) === X;
    }
    function Rp(e) {
      return (e & mi) === e;
    }
    function md(e, t) {
      var a = hi | za | ur | un;
      return (t & a) !== X;
    }
    function yg(e, t) {
      return (t & e.expiredLanes) !== X;
    }
    function Pp(e) {
      return (e & mi) !== X;
    }
    function Np() {
      var e = gs;
      return gs <<= 1, (gs & mi) === X && (gs = fs), e;
    }
    function bg() {
      var e = dd;
      return dd <<= 1, (dd & ku) === X && (dd = hs), e;
    }
    function gi(e) {
      return e & -e;
    }
    function Ru(e) {
      return gi(e);
    }
    function bn(e) {
      return 31 - yn(e);
    }
    function Hn(e) {
      return bn(e);
    }
    function Dr(e, t) {
      return (e & t) !== X;
    }
    function ys(e, t) {
      return (e & t) === t;
    }
    function ct(e, t) {
      return e | t;
    }
    function Pu(e, t) {
      return e & ~t;
    }
    function Op(e, t) {
      return e & t;
    }
    function Lp(e, t) {
      return e !== Et && e < t ? e : t;
    }
    function gd(e) {
      for (var t = [], a = 0; a < ds; a++)
        t.push(e);
      return t;
    }
    function bs(e, t, a) {
      e.pendingLanes |= t, t !== ms && (e.suspendedLanes = X, e.pingedLanes = X);
      var i = e.eventTimes, c = Hn(t);
      i[c] = a;
    }
    function _g(e, t) {
      e.suspendedLanes |= t, e.pingedLanes &= ~t;
      for (var a = e.expirationTimes, i = t; i > 0; ) {
        var c = bn(i), p = 1 << c;
        a[c] = Wt, i &= ~p;
      }
    }
    function Dp(e, t, a) {
      e.pingedLanes |= e.suspendedLanes & t;
    }
    function zp(e, t) {
      var a = e.pendingLanes & ~t;
      e.pendingLanes = t, e.suspendedLanes = X, e.pingedLanes = X, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t;
      for (var i = e.entanglements, c = e.eventTimes, p = e.expirationTimes, y = a; y > 0; ) {
        var _ = bn(y), w = 1 << _;
        i[_] = X, c[_] = Wt, p[_] = Wt, y &= ~w;
      }
    }
    function Nu(e, t) {
      for (var a = e.entangledLanes |= t, i = e.entanglements, c = a; c; ) {
        var p = bn(c), y = 1 << p;
        y & t | // Is this lane transitively entangled with the newly entangled lanes?
        i[p] & t && (i[p] |= t), c &= ~y;
      }
    }
    function wg(e, t) {
      var a = gi(t), i;
      switch (a) {
        case za:
          i = hi;
          break;
        case un:
          i = ur;
          break;
        case fs:
        case Gc:
        case Jc:
        case Xc:
        case ed:
        case td:
        case nd:
        case rd:
        case ad:
        case ps:
        case od:
        case hl:
        case ml:
        case id:
        case wu:
        case sd:
        case hs:
        case ld:
        case xu:
        case ud:
        case cd:
          i = Ro;
          break;
        case ms:
          i = Eu;
          break;
        default:
          i = Et;
          break;
      }
      return (i & (e.suspendedLanes | t)) !== Et ? Et : i;
    }
    function vd(e, t, a) {
      if (Lr)
        for (var i = e.pendingUpdatersLaneMap; a > 0; ) {
          var c = Hn(a), p = 1 << c, y = i[c];
          y.add(t), a &= ~p;
        }
    }
    function Ou(e, t) {
      if (Lr)
        for (var a = e.pendingUpdatersLaneMap, i = e.memoizedUpdaters; t > 0; ) {
          var c = Hn(t), p = 1 << c, y = a[c];
          y.size > 0 && (y.forEach(function(_) {
            var w = _.alternate;
            (w === null || !i.has(w)) && i.add(_);
          }), y.clear()), t &= ~p;
        }
    }
    function kg(e, t) {
      return null;
    }
    var zr = Je, Aa = za, ro = un, _s = ms, Yr = Et;
    function Ma() {
      return Yr;
    }
    function Cn(e) {
      Yr = e;
    }
    function Ip(e, t) {
      var a = Yr;
      try {
        return Yr = e, t();
      } finally {
        Yr = a;
      }
    }
    function xg(e, t) {
      return e !== 0 && e < t ? e : t;
    }
    function Sg(e, t) {
      return e > t ? e : t;
    }
    function ws(e, t) {
      return e !== 0 && e < t;
    }
    function Zn(e) {
      var t = gi(e);
      return ws(zr, t) ? ws(Aa, t) ? Tu(t) ? ro : _s : Aa : zr;
    }
    function yd(e) {
      var t = e.current.memoizedState;
      return t.isDehydrated;
    }
    var Eg;
    function bd(e) {
      Eg = e;
    }
    function cr(e) {
      Eg(e);
    }
    var Ap;
    function Le(e) {
      Ap = e;
    }
    var ks;
    function Cg(e) {
      ks = e;
    }
    var Mp;
    function Rb(e) {
      Mp = e;
    }
    var gl;
    function _d(e) {
      gl = e;
    }
    var Lu = !1, Du = [], Po = null, No = null, ao = null, xs = /* @__PURE__ */ new Map(), cn = /* @__PURE__ */ new Map(), zn = [], vi = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function Tg(e) {
      return vi.indexOf(e) > -1;
    }
    function Rg(e, t, a, i, c) {
      return {
        blockedOn: e,
        domEventName: t,
        eventSystemFlags: a,
        nativeEvent: c,
        targetContainers: [i]
      };
    }
    function ga(e, t) {
      switch (e) {
        case "focusin":
        case "focusout":
          Po = null;
          break;
        case "dragenter":
        case "dragleave":
          No = null;
          break;
        case "mouseover":
        case "mouseout":
          ao = null;
          break;
        case "pointerover":
        case "pointerout": {
          var a = t.pointerId;
          xs.delete(a);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var i = t.pointerId;
          cn.delete(i);
          break;
        }
      }
    }
    function vl(e, t, a, i, c, p) {
      if (e === null || e.nativeEvent !== p) {
        var y = Rg(t, a, i, c, p);
        if (t !== null) {
          var _ = Sl(t);
          _ !== null && Ap(_);
        }
        return y;
      }
      e.eventSystemFlags |= i;
      var w = e.targetContainers;
      return c !== null && w.indexOf(c) === -1 && w.push(c), e;
    }
    function oo(e, t, a, i, c) {
      switch (t) {
        case "focusin": {
          var p = c;
          return Po = vl(Po, e, t, a, i, p), !0;
        }
        case "dragenter": {
          var y = c;
          return No = vl(No, e, t, a, i, y), !0;
        }
        case "mouseover": {
          var _ = c;
          return ao = vl(ao, e, t, a, i, _), !0;
        }
        case "pointerover": {
          var w = c, C = w.pointerId;
          return xs.set(C, vl(xs.get(C) || null, e, t, a, i, w)), !0;
        }
        case "gotpointercapture": {
          var T = c, A = T.pointerId;
          return cn.set(A, vl(cn.get(A) || null, e, t, a, i, T)), !0;
        }
      }
      return !1;
    }
    function Pg(e) {
      var t = Wu(e.target);
      if (t !== null) {
        var a = qr(t);
        if (a !== null) {
          var i = a.tag;
          if (i === Re) {
            var c = eo(a);
            if (c !== null) {
              e.blockedOn = c, gl(e.priority, function() {
                ks(a);
              });
              return;
            }
          } else if (i === P) {
            var p = a.stateNode;
            if (yd(p)) {
              e.blockedOn = to(a);
              return;
            }
          }
        }
      }
      e.blockedOn = null;
    }
    function Ng(e) {
      for (var t = Mp(), a = {
        blockedOn: null,
        target: e,
        priority: t
      }, i = 0; i < zn.length && ws(t, zn[i].priority); i++)
        ;
      zn.splice(i, 0, a), i === 0 && Pg(a);
    }
    function zu(e) {
      if (e.blockedOn !== null)
        return !1;
      for (var t = e.targetContainers; t.length > 0; ) {
        var a = t[0], i = Oo(e.domEventName, e.eventSystemFlags, a, e.nativeEvent);
        if (i === null) {
          var c = e.nativeEvent, p = new c.constructor(c.type, c);
          xb(p), c.target.dispatchEvent(p), Sb();
        } else {
          var y = Sl(i);
          return y !== null && Ap(y), e.blockedOn = i, !1;
        }
        t.shift();
      }
      return !0;
    }
    function Fp(e, t, a) {
      zu(e) && a.delete(t);
    }
    function Og() {
      Lu = !1, Po !== null && zu(Po) && (Po = null), No !== null && zu(No) && (No = null), ao !== null && zu(ao) && (ao = null), xs.forEach(Fp), cn.forEach(Fp);
    }
    function Iu(e, t) {
      e.blockedOn === t && (e.blockedOn = null, Lu || (Lu = !0, o.unstable_scheduleCallback(o.unstable_NormalPriority, Og)));
    }
    function yi(e) {
      if (Du.length > 0) {
        Iu(Du[0], e);
        for (var t = 1; t < Du.length; t++) {
          var a = Du[t];
          a.blockedOn === e && (a.blockedOn = null);
        }
      }
      Po !== null && Iu(Po, e), No !== null && Iu(No, e), ao !== null && Iu(ao, e);
      var i = function(_) {
        return Iu(_, e);
      };
      xs.forEach(i), cn.forEach(i);
      for (var c = 0; c < zn.length; c++) {
        var p = zn[c];
        p.blockedOn === e && (p.blockedOn = null);
      }
      for (; zn.length > 0; ) {
        var y = zn[0];
        if (y.blockedOn !== null)
          break;
        Pg(y), y.blockedOn === null && zn.shift();
      }
    }
    var bi = s.ReactCurrentBatchConfig, Ir = !0;
    function St(e) {
      Ir = !!e;
    }
    function In() {
      return Ir;
    }
    function _n(e, t, a) {
      var i = Au(t), c;
      switch (i) {
        case zr:
          c = Qn;
          break;
        case Aa:
          c = Gr;
          break;
        case ro:
        default:
          c = _i;
          break;
      }
      return c.bind(null, t, a, e);
    }
    function Qn(e, t, a, i) {
      var c = Ma(), p = bi.transition;
      bi.transition = null;
      try {
        Cn(zr), _i(e, t, a, i);
      } finally {
        Cn(c), bi.transition = p;
      }
    }
    function Gr(e, t, a, i) {
      var c = Ma(), p = bi.transition;
      bi.transition = null;
      try {
        Cn(Aa), _i(e, t, a, i);
      } finally {
        Cn(c), bi.transition = p;
      }
    }
    function _i(e, t, a, i) {
      Ir && Tn(e, t, a, i);
    }
    function Tn(e, t, a, i) {
      var c = Oo(e, t, a, i);
      if (c === null) {
        Vb(e, t, i, wi, a), ga(e, i);
        return;
      }
      if (oo(c, e, t, a, i)) {
        i.stopPropagation();
        return;
      }
      if (ga(e, i), t & ca && Tg(e)) {
        for (; c !== null; ) {
          var p = Sl(c);
          p !== null && cr(p);
          var y = Oo(e, t, a, i);
          if (y === null && Vb(e, t, i, wi, a), y === c)
            break;
          c = y;
        }
        c !== null && i.stopPropagation();
        return;
      }
      Vb(e, t, i, null, a);
    }
    var wi = null;
    function Oo(e, t, a, i) {
      wi = null;
      var c = cp(i), p = Wu(c);
      if (p !== null) {
        var y = qr(p);
        if (y === null)
          p = null;
        else {
          var _ = y.tag;
          if (_ === Re) {
            var w = eo(y);
            if (w !== null)
              return w;
            p = null;
          } else if (_ === P) {
            var C = y.stateNode;
            if (yd(C))
              return to(y);
            p = null;
          } else y !== p && (p = null);
        }
      }
      return wi = p, null;
    }
    function Au(e) {
      switch (e) {
        // Used by SimpleEventPlugin:
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        // Used by polyfills:
        // eslint-disable-next-line no-fallthrough
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        // Only enableCreateEventHandleAPI:
        // eslint-disable-next-line no-fallthrough
        case "beforeblur":
        case "afterblur":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return zr;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Aa;
        case "message": {
          var t = qc();
          switch (t) {
            case hu:
              return zr;
            case fi:
              return Aa;
            case Co:
            case Tb:
              return ro;
            case is:
              return _s;
            default:
              return ro;
          }
        }
        default:
          return ro;
      }
    }
    function $p(e, t, a) {
      return e.addEventListener(t, a, !1), a;
    }
    function Mu(e, t, a) {
      return e.addEventListener(t, a, !0), a;
    }
    function Ar(e, t, a, i) {
      return e.addEventListener(t, a, {
        capture: !0,
        passive: i
      }), a;
    }
    function jp(e, t, a, i) {
      return e.addEventListener(t, a, {
        passive: i
      }), a;
    }
    var io = null, Fa = null, ki = null;
    function Up(e) {
      return io = e, Fa = Lo(), !0;
    }
    function xi() {
      io = null, Fa = null, ki = null;
    }
    function Fu() {
      if (ki)
        return ki;
      var e, t = Fa, a = t.length, i, c = Lo(), p = c.length;
      for (e = 0; e < a && t[e] === c[e]; e++)
        ;
      var y = a - e;
      for (i = 1; i <= y && t[a - i] === c[p - i]; i++)
        ;
      var _ = i > 1 ? 1 - i : void 0;
      return ki = c.slice(e, _), ki;
    }
    function Lo() {
      return "value" in io ? io.value : io.textContent;
    }
    function Ss(e) {
      var t, a = e.keyCode;
      return "charCode" in e ? (t = e.charCode, t === 0 && a === 13 && (t = 13)) : t = a, t === 10 && (t = 13), t >= 32 || t === 13 ? t : 0;
    }
    function Si() {
      return !0;
    }
    function wd() {
      return !1;
    }
    function dr(e) {
      function t(a, i, c, p, y) {
        this._reactName = a, this._targetInst = c, this.type = i, this.nativeEvent = p, this.target = y, this.currentTarget = null;
        for (var _ in e)
          if (e.hasOwnProperty(_)) {
            var w = e[_];
            w ? this[_] = w(p) : this[_] = p[_];
          }
        var C = p.defaultPrevented != null ? p.defaultPrevented : p.returnValue === !1;
        return C ? this.isDefaultPrevented = Si : this.isDefaultPrevented = wd, this.isPropagationStopped = wd, this;
      }
      return bt(t.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var a = this.nativeEvent;
          a && (a.preventDefault ? a.preventDefault() : typeof a.returnValue != "unknown" && (a.returnValue = !1), this.isDefaultPrevented = Si);
        },
        stopPropagation: function() {
          var a = this.nativeEvent;
          a && (a.stopPropagation ? a.stopPropagation() : typeof a.cancelBubble != "unknown" && (a.cancelBubble = !0), this.isPropagationStopped = Si);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: Si
      }), t;
    }
    var Do = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, Kn = dr(Do), va = bt({}, Do, {
      view: 0,
      detail: 0
    }), $a = dr(va), fr, kd, Es;
    function Vp(e) {
      e !== Es && (Es && e.type === "mousemove" ? (fr = e.screenX - Es.screenX, kd = e.screenY - Es.screenY) : (fr = 0, kd = 0), Es = e);
    }
    var xd = bt({}, va, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Ed,
      button: 0,
      buttons: 0,
      relatedTarget: function(e) {
        return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
      },
      movementX: function(e) {
        return "movementX" in e ? e.movementX : (Vp(e), fr);
      },
      movementY: function(e) {
        return "movementY" in e ? e.movementY : kd;
      }
    }), zo = dr(xd), Lg = bt({}, xd, {
      dataTransfer: 0
    }), Bp = dr(Lg), Cs = bt({}, va, {
      relatedTarget: 0
    }), $u = dr(Cs), Ts = bt({}, Do, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Dg = dr(Ts), zg = bt({}, Do, {
      clipboardData: function(e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      }
    }), Wp = dr(zg), Sd = bt({}, Do, {
      data: 0
    }), Ig = dr(Sd), Pb = Ig, Ag = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, Mg = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function Rs(e) {
      if (e.key) {
        var t = Ag[e.key] || e.key;
        if (t !== "Unidentified")
          return t;
      }
      if (e.type === "keypress") {
        var a = Ss(e);
        return a === 13 ? "Enter" : String.fromCharCode(a);
      }
      return e.type === "keydown" || e.type === "keyup" ? Mg[e.keyCode] || "Unidentified" : "";
    }
    var Nb = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function yl(e) {
      var t = this, a = t.nativeEvent;
      if (a.getModifierState)
        return a.getModifierState(e);
      var i = Nb[e];
      return i ? !!a[i] : !1;
    }
    function Ed(e) {
      return yl;
    }
    var on = bt({}, va, {
      key: Rs,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Ed,
      // Legacy Interface
      charCode: function(e) {
        return e.type === "keypress" ? Ss(e) : 0;
      },
      keyCode: function(e) {
        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      },
      which: function(e) {
        return e.type === "keypress" ? Ss(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      }
    }), Ob = dr(on), Fg = bt({}, xd, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), $g = dr(Fg), Lb = bt({}, va, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Ed
    }), jg = dr(Lb), Ug = bt({}, Do, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Db = dr(Ug), ya = bt({}, xd, {
      deltaX: function(e) {
        return "deltaX" in e ? e.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in e ? -e.wheelDeltaX : 0
        );
      },
      deltaY: function(e) {
        return "deltaY" in e ? e.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in e ? -e.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in e ? -e.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), qp = dr(ya), zb = [9, 13, 27, 32], Io = 229, bl = kn && "CompositionEvent" in window, ja = null;
    kn && "documentMode" in document && (ja = document.documentMode);
    var Cd = kn && "TextEvent" in window && !ja, Td = kn && (!bl || ja && ja > 8 && ja <= 11), Rd = 32, Vg = String.fromCharCode(Rd);
    function Hp() {
      Br("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), Br("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Br("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), Br("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Bg = !1;
    function Wg(e) {
      return (e.ctrlKey || e.altKey || e.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(e.ctrlKey && e.altKey);
    }
    function qg(e) {
      switch (e) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function Pd(e, t) {
      return e === "keydown" && t.keyCode === Io;
    }
    function ju(e, t) {
      switch (e) {
        case "keyup":
          return zb.indexOf(t.keyCode) !== -1;
        case "keydown":
          return t.keyCode !== Io;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Zp(e) {
      var t = e.detail;
      return typeof t == "object" && "data" in t ? t.data : null;
    }
    function Nd(e) {
      return e.locale === "ko";
    }
    var _l = !1;
    function Hg(e, t, a, i, c) {
      var p, y;
      if (bl ? p = qg(t) : _l ? ju(t, i) && (p = "onCompositionEnd") : Pd(t, i) && (p = "onCompositionStart"), !p)
        return null;
      Td && !Nd(i) && (!_l && p === "onCompositionStart" ? _l = Up(c) : p === "onCompositionEnd" && _l && (y = Fu()));
      var _ = Xg(a, p);
      if (_.length > 0) {
        var w = new Ig(p, t, null, i, c);
        if (e.push({
          event: w,
          listeners: _
        }), y)
          w.data = y;
        else {
          var C = Zp(i);
          C !== null && (w.data = C);
        }
      }
    }
    function Qp(e, t) {
      switch (e) {
        case "compositionend":
          return Zp(t);
        case "keypress":
          var a = t.which;
          return a !== Rd ? null : (Bg = !0, Vg);
        case "textInput":
          var i = t.data;
          return i === Vg && Bg ? null : i;
        default:
          return null;
      }
    }
    function Od(e, t) {
      if (_l) {
        if (e === "compositionend" || !bl && ju(e, t)) {
          var a = Fu();
          return xi(), _l = !1, a;
        }
        return null;
      }
      switch (e) {
        case "paste":
          return null;
        case "keypress":
          if (!Wg(t)) {
            if (t.char && t.char.length > 1)
              return t.char;
            if (t.which)
              return String.fromCharCode(t.which);
          }
          return null;
        case "compositionend":
          return Td && !Nd(t) ? null : t.data;
        default:
          return null;
      }
    }
    function Kp(e, t, a, i, c) {
      var p;
      if (Cd ? p = Qp(t, i) : p = Od(t, i), !p)
        return null;
      var y = Xg(a, "onBeforeInput");
      if (y.length > 0) {
        var _ = new Pb("onBeforeInput", "beforeinput", null, i, c);
        e.push({
          event: _,
          listeners: y
        }), _.data = p;
      }
    }
    function Ld(e, t, a, i, c, p, y) {
      Hg(e, t, a, i, c), Kp(e, t, a, i, c);
    }
    var Zg = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function Qg(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t === "input" ? !!Zg[e.type] : t === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function Dd(e) {
      if (!kn)
        return !1;
      var t = "on" + e, a = t in document;
      if (!a) {
        var i = document.createElement("div");
        i.setAttribute(t, "return;"), a = typeof i[t] == "function";
      }
      return a;
    }
    function Ib() {
      Br("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function wl(e, t, a, i) {
      il(i);
      var c = Xg(t, "onChange");
      if (c.length > 0) {
        var p = new Kn("onChange", "change", null, a, i);
        e.push({
          event: p,
          listeners: c
        });
      }
    }
    var Uu = null, Ei = null;
    function n(e) {
      var t = e.nodeName && e.nodeName.toLowerCase();
      return t === "select" || t === "input" && e.type === "file";
    }
    function r(e) {
      var t = [];
      wl(t, Ei, e, cp(e)), ag(l, t);
    }
    function l(e) {
      vx(e, 0);
    }
    function f(e) {
      var t = $d(e);
      if (Ki(t))
        return e;
    }
    function v(e, t) {
      if (e === "change")
        return t;
    }
    var b = !1;
    kn && (b = Dd("input") && (!document.documentMode || document.documentMode > 9));
    function x(e, t) {
      Uu = e, Ei = t, Uu.attachEvent("onpropertychange", D);
    }
    function N() {
      Uu && (Uu.detachEvent("onpropertychange", D), Uu = null, Ei = null);
    }
    function D(e) {
      e.propertyName === "value" && f(Ei) && r(e);
    }
    function q(e, t, a) {
      e === "focusin" ? (N(), x(t, a)) : e === "focusout" && N();
    }
    function te(e, t) {
      if (e === "selectionchange" || e === "keyup" || e === "keydown")
        return f(Ei);
    }
    function ne(e) {
      var t = e.nodeName;
      return t && t.toLowerCase() === "input" && (e.type === "checkbox" || e.type === "radio");
    }
    function ee(e, t) {
      if (e === "click")
        return f(t);
    }
    function Se(e, t) {
      if (e === "input" || e === "change")
        return f(t);
    }
    function De(e) {
      var t = e._wrapperState;
      !t || !t.controlled || e.type !== "number" || xc(e, "number", e.value);
    }
    function Me(e, t, a, i, c, p, y) {
      var _ = a ? $d(a) : window, w, C;
      if (n(_) ? w = v : Qg(_) ? b ? w = Se : (w = te, C = q) : ne(_) && (w = ee), w) {
        var T = w(t, a);
        if (T) {
          wl(e, T, i, c);
          return;
        }
      }
      C && C(t, _, a), t === "focusout" && De(_);
    }
    function dn() {
      Ha("onMouseEnter", ["mouseout", "mouseover"]), Ha("onMouseLeave", ["mouseout", "mouseover"]), Ha("onPointerEnter", ["pointerout", "pointerover"]), Ha("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function j(e, t, a, i, c, p, y) {
      var _ = t === "mouseover" || t === "pointerover", w = t === "mouseout" || t === "pointerout";
      if (_ && !lu(i)) {
        var C = i.relatedTarget || i.fromElement;
        if (C && (Wu(C) || uh(C)))
          return;
      }
      if (!(!w && !_)) {
        var T;
        if (c.window === c)
          T = c;
        else {
          var A = c.ownerDocument;
          A ? T = A.defaultView || A.parentWindow : T = window;
        }
        var z, B;
        if (w) {
          var H = i.relatedTarget || i.toElement;
          if (z = a, B = H ? Wu(H) : null, B !== null) {
            var Y = qr(B);
            (B !== Y || B.tag !== M && B.tag !== $) && (B = null);
          }
        } else
          z = null, B = a;
        if (z !== B) {
          var me = zo, Ue = "onMouseLeave", Qe = "onMouseEnter", vt = "mouse";
          (t === "pointerout" || t === "pointerover") && (me = $g, Ue = "onPointerLeave", Qe = "onPointerEnter", vt = "pointer");
          var ht = z == null ? T : $d(z), U = B == null ? T : $d(B), K = new me(Ue, vt + "leave", z, i, c);
          K.target = ht, K.relatedTarget = U;
          var V = null, oe = Wu(c);
          if (oe === a) {
            var Ce = new me(Qe, vt + "enter", B, i, c);
            Ce.target = U, Ce.relatedTarget = ht, V = Ce;
          }
          lT(e, K, V, z, B);
        }
      }
    }
    function I(e, t) {
      return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
    }
    var F = typeof Object.is == "function" ? Object.is : I;
    function se(e, t) {
      if (F(e, t))
        return !0;
      if (typeof e != "object" || e === null || typeof t != "object" || t === null)
        return !1;
      var a = Object.keys(e), i = Object.keys(t);
      if (a.length !== i.length)
        return !1;
      for (var c = 0; c < a.length; c++) {
        var p = a[c];
        if (!pr.call(t, p) || !F(e[p], t[p]))
          return !1;
      }
      return !0;
    }
    function je(e) {
      for (; e && e.firstChild; )
        e = e.firstChild;
      return e;
    }
    function Ge(e) {
      for (; e; ) {
        if (e.nextSibling)
          return e.nextSibling;
        e = e.parentNode;
      }
    }
    function Ze(e, t) {
      for (var a = je(e), i = 0, c = 0; a; ) {
        if (a.nodeType === wo) {
          if (c = i + a.textContent.length, i <= t && c >= t)
            return {
              node: a,
              offset: t - i
            };
          i = c;
        }
        a = je(Ge(a));
      }
    }
    function tt(e) {
      var t = e.ownerDocument, a = t && t.defaultView || window, i = a.getSelection && a.getSelection();
      if (!i || i.rangeCount === 0)
        return null;
      var c = i.anchorNode, p = i.anchorOffset, y = i.focusNode, _ = i.focusOffset;
      try {
        c.nodeType, y.nodeType;
      } catch {
        return null;
      }
      return An(e, c, p, y, _);
    }
    function An(e, t, a, i, c) {
      var p = 0, y = -1, _ = -1, w = 0, C = 0, T = e, A = null;
      e: for (; ; ) {
        for (var z = null; T === t && (a === 0 || T.nodeType === wo) && (y = p + a), T === i && (c === 0 || T.nodeType === wo) && (_ = p + c), T.nodeType === wo && (p += T.nodeValue.length), (z = T.firstChild) !== null; )
          A = T, T = z;
        for (; ; ) {
          if (T === e)
            break e;
          if (A === t && ++w === a && (y = p), A === i && ++C === c && (_ = p), (z = T.nextSibling) !== null)
            break;
          T = A, A = T.parentNode;
        }
        T = z;
      }
      return y === -1 || _ === -1 ? null : {
        start: y,
        end: _
      };
    }
    function Pt(e, t) {
      var a = e.ownerDocument || document, i = a && a.defaultView || window;
      if (i.getSelection) {
        var c = i.getSelection(), p = e.textContent.length, y = Math.min(t.start, p), _ = t.end === void 0 ? y : Math.min(t.end, p);
        if (!c.extend && y > _) {
          var w = _;
          _ = y, y = w;
        }
        var C = Ze(e, y), T = Ze(e, _);
        if (C && T) {
          if (c.rangeCount === 1 && c.anchorNode === C.node && c.anchorOffset === C.offset && c.focusNode === T.node && c.focusOffset === T.offset)
            return;
          var A = a.createRange();
          A.setStart(C.node, C.offset), c.removeAllRanges(), y > _ ? (c.addRange(A), c.extend(T.node, T.offset)) : (A.setEnd(T.node, T.offset), c.addRange(A));
        }
      }
    }
    function Ao(e) {
      return e && e.nodeType === wo;
    }
    function Kg(e, t) {
      return !e || !t ? !1 : e === t ? !0 : Ao(e) ? !1 : Ao(t) ? Kg(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1;
    }
    function WC(e) {
      return e && e.ownerDocument && Kg(e.ownerDocument.documentElement, e);
    }
    function qC(e) {
      try {
        return typeof e.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function sx() {
      for (var e = window, t = Yi(); t instanceof e.HTMLIFrameElement; ) {
        if (qC(t))
          e = t.contentWindow;
        else
          return t;
        t = Yi(e.document);
      }
      return t;
    }
    function Ab(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
    }
    function HC() {
      var e = sx();
      return {
        focusedElem: e,
        selectionRange: Ab(e) ? QC(e) : null
      };
    }
    function ZC(e) {
      var t = sx(), a = e.focusedElem, i = e.selectionRange;
      if (t !== a && WC(a)) {
        i !== null && Ab(a) && KC(a, i);
        for (var c = [], p = a; p = p.parentNode; )
          p.nodeType === Cr && c.push({
            element: p,
            left: p.scrollLeft,
            top: p.scrollTop
          });
        typeof a.focus == "function" && a.focus();
        for (var y = 0; y < c.length; y++) {
          var _ = c[y];
          _.element.scrollLeft = _.left, _.element.scrollTop = _.top;
        }
      }
    }
    function QC(e) {
      var t;
      return "selectionStart" in e ? t = {
        start: e.selectionStart,
        end: e.selectionEnd
      } : t = tt(e), t || {
        start: 0,
        end: 0
      };
    }
    function KC(e, t) {
      var a = t.start, i = t.end;
      i === void 0 && (i = a), "selectionStart" in e ? (e.selectionStart = a, e.selectionEnd = Math.min(i, e.value.length)) : Pt(e, t);
    }
    var YC = kn && "documentMode" in document && document.documentMode <= 11;
    function GC() {
      Br("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var zd = null, Mb = null, Yp = null, Fb = !1;
    function JC(e) {
      if ("selectionStart" in e && Ab(e))
        return {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      var t = e.ownerDocument && e.ownerDocument.defaultView || window, a = t.getSelection();
      return {
        anchorNode: a.anchorNode,
        anchorOffset: a.anchorOffset,
        focusNode: a.focusNode,
        focusOffset: a.focusOffset
      };
    }
    function XC(e) {
      return e.window === e ? e.document : e.nodeType === ko ? e : e.ownerDocument;
    }
    function lx(e, t, a) {
      var i = XC(a);
      if (!(Fb || zd == null || zd !== Yi(i))) {
        var c = JC(zd);
        if (!Yp || !se(Yp, c)) {
          Yp = c;
          var p = Xg(Mb, "onSelect");
          if (p.length > 0) {
            var y = new Kn("onSelect", "select", null, t, a);
            e.push({
              event: y,
              listeners: p
            }), y.target = zd;
          }
        }
      }
    }
    function eT(e, t, a, i, c, p, y) {
      var _ = a ? $d(a) : window;
      switch (t) {
        // Track the input node that has focus.
        case "focusin":
          (Qg(_) || _.contentEditable === "true") && (zd = _, Mb = a, Yp = null);
          break;
        case "focusout":
          zd = null, Mb = null, Yp = null;
          break;
        // Don't fire the event while the user is dragging. This matches the
        // semantics of the native select event.
        case "mousedown":
          Fb = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Fb = !1, lx(e, i, c);
          break;
        // Chrome and IE fire non-standard event when selection is changed (and
        // sometimes when it hasn't). IE's event fires out of order with respect
        // to key and input events on deletion, so we discard it.
        //
        // Firefox doesn't support selectionchange, so check selection status
        // after each key entry. The selection changes after keydown and before
        // keyup, but we check on keydown as well in the case of holding down a
        // key, when multiple keydown events are fired but only one keyup is.
        // This is also our approach for IE handling, for the reason above.
        case "selectionchange":
          if (YC)
            break;
        // falls through
        case "keydown":
        case "keyup":
          lx(e, i, c);
      }
    }
    function Yg(e, t) {
      var a = {};
      return a[e.toLowerCase()] = t.toLowerCase(), a["Webkit" + e] = "webkit" + t, a["Moz" + e] = "moz" + t, a;
    }
    var Id = {
      animationend: Yg("Animation", "AnimationEnd"),
      animationiteration: Yg("Animation", "AnimationIteration"),
      animationstart: Yg("Animation", "AnimationStart"),
      transitionend: Yg("Transition", "TransitionEnd")
    }, $b = {}, ux = {};
    kn && (ux = document.createElement("div").style, "AnimationEvent" in window || (delete Id.animationend.animation, delete Id.animationiteration.animation, delete Id.animationstart.animation), "TransitionEvent" in window || delete Id.transitionend.transition);
    function Gg(e) {
      if ($b[e])
        return $b[e];
      if (!Id[e])
        return e;
      var t = Id[e];
      for (var a in t)
        if (t.hasOwnProperty(a) && a in ux)
          return $b[e] = t[a];
      return e;
    }
    var cx = Gg("animationend"), dx = Gg("animationiteration"), fx = Gg("animationstart"), px = Gg("transitionend"), hx = /* @__PURE__ */ new Map(), mx = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function kl(e, t) {
      hx.set(e, t), Br(t, [e]);
    }
    function tT() {
      for (var e = 0; e < mx.length; e++) {
        var t = mx[e], a = t.toLowerCase(), i = t[0].toUpperCase() + t.slice(1);
        kl(a, "on" + i);
      }
      kl(cx, "onAnimationEnd"), kl(dx, "onAnimationIteration"), kl(fx, "onAnimationStart"), kl("dblclick", "onDoubleClick"), kl("focusin", "onFocus"), kl("focusout", "onBlur"), kl(px, "onTransitionEnd");
    }
    function nT(e, t, a, i, c, p, y) {
      var _ = hx.get(t);
      if (_ !== void 0) {
        var w = Kn, C = t;
        switch (t) {
          case "keypress":
            if (Ss(i) === 0)
              return;
          /* falls through */
          case "keydown":
          case "keyup":
            w = Ob;
            break;
          case "focusin":
            C = "focus", w = $u;
            break;
          case "focusout":
            C = "blur", w = $u;
            break;
          case "beforeblur":
          case "afterblur":
            w = $u;
            break;
          case "click":
            if (i.button === 2)
              return;
          /* falls through */
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          // TODO: Disabled elements should not respond to mouse events
          /* falls through */
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            w = zo;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            w = Bp;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            w = jg;
            break;
          case cx:
          case dx:
          case fx:
            w = Dg;
            break;
          case px:
            w = Db;
            break;
          case "scroll":
            w = $a;
            break;
          case "wheel":
            w = qp;
            break;
          case "copy":
          case "cut":
          case "paste":
            w = Wp;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            w = $g;
            break;
        }
        var T = (p & ca) !== 0;
        {
          var A = !T && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          t === "scroll", z = iT(a, _, i.type, T, A);
          if (z.length > 0) {
            var B = new w(_, C, null, i, c);
            e.push({
              event: B,
              listeners: z
            });
          }
        }
      }
    }
    tT(), dn(), Ib(), GC(), Hp();
    function rT(e, t, a, i, c, p, y) {
      nT(e, t, a, i, c, p);
      var _ = (p & up) === 0;
      _ && (j(e, t, a, i, c), Me(e, t, a, i, c), eT(e, t, a, i, c), Ld(e, t, a, i, c));
    }
    var Gp = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], jb = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Gp));
    function gx(e, t, a) {
      var i = e.type || "unknown-event";
      e.currentTarget = a, Ga(i, t, void 0, e), e.currentTarget = null;
    }
    function aT(e, t, a) {
      var i;
      if (a)
        for (var c = t.length - 1; c >= 0; c--) {
          var p = t[c], y = p.instance, _ = p.currentTarget, w = p.listener;
          if (y !== i && e.isPropagationStopped())
            return;
          gx(e, w, _), i = y;
        }
      else
        for (var C = 0; C < t.length; C++) {
          var T = t[C], A = T.instance, z = T.currentTarget, B = T.listener;
          if (A !== i && e.isPropagationStopped())
            return;
          gx(e, B, z), i = A;
        }
    }
    function vx(e, t) {
      for (var a = (t & ca) !== 0, i = 0; i < e.length; i++) {
        var c = e[i], p = c.event, y = c.listeners;
        aT(p, y, a);
      }
      du();
    }
    function oT(e, t, a, i, c) {
      var p = cp(a), y = [];
      rT(y, e, i, a, p, t), vx(y, t);
    }
    function en(e, t) {
      jb.has(e) || g('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', e);
      var a = !1, i = IR(t), c = uT(e);
      i.has(c) || (yx(t, e, Lc, a), i.add(c));
    }
    function Ub(e, t, a) {
      jb.has(e) && !t && g('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', e);
      var i = 0;
      t && (i |= ca), yx(a, e, i, t);
    }
    var Jg = "_reactListening" + Math.random().toString(36).slice(2);
    function Jp(e) {
      if (!e[Jg]) {
        e[Jg] = !0, Ln.forEach(function(a) {
          a !== "selectionchange" && (jb.has(a) || Ub(a, !1, e), Ub(a, !0, e));
        });
        var t = e.nodeType === ko ? e : e.ownerDocument;
        t !== null && (t[Jg] || (t[Jg] = !0, Ub("selectionchange", !1, t)));
      }
    }
    function yx(e, t, a, i, c) {
      var p = _n(e, t, a), y = void 0;
      cu && (t === "touchstart" || t === "touchmove" || t === "wheel") && (y = !0), e = e, i ? y !== void 0 ? Ar(e, t, p, y) : Mu(e, t, p) : y !== void 0 ? jp(e, t, p, y) : $p(e, t, p);
    }
    function bx(e, t) {
      return e === t || e.nodeType === mn && e.parentNode === t;
    }
    function Vb(e, t, a, i, c) {
      var p = i;
      if (!(t & lp) && !(t & Lc)) {
        var y = c;
        if (i !== null) {
          var _ = i;
          e: for (; ; ) {
            if (_ === null)
              return;
            var w = _.tag;
            if (w === P || w === O) {
              var C = _.stateNode.containerInfo;
              if (bx(C, y))
                break;
              if (w === O)
                for (var T = _.return; T !== null; ) {
                  var A = T.tag;
                  if (A === P || A === O) {
                    var z = T.stateNode.containerInfo;
                    if (bx(z, y))
                      return;
                  }
                  T = T.return;
                }
              for (; C !== null; ) {
                var B = Wu(C);
                if (B === null)
                  return;
                var H = B.tag;
                if (H === M || H === $) {
                  _ = p = B;
                  continue e;
                }
                C = C.parentNode;
              }
            }
            _ = _.return;
          }
        }
      }
      ag(function() {
        return oT(e, t, a, p);
      });
    }
    function Xp(e, t, a) {
      return {
        instance: e,
        listener: t,
        currentTarget: a
      };
    }
    function iT(e, t, a, i, c, p) {
      for (var y = t !== null ? t + "Capture" : null, _ = i ? y : t, w = [], C = e, T = null; C !== null; ) {
        var A = C, z = A.stateNode, B = A.tag;
        if (B === M && z !== null && (T = z, _ !== null)) {
          var H = ii(C, _);
          H != null && w.push(Xp(C, H, T));
        }
        if (c)
          break;
        C = C.return;
      }
      return w;
    }
    function Xg(e, t) {
      for (var a = t + "Capture", i = [], c = e; c !== null; ) {
        var p = c, y = p.stateNode, _ = p.tag;
        if (_ === M && y !== null) {
          var w = y, C = ii(c, a);
          C != null && i.unshift(Xp(c, C, w));
          var T = ii(c, t);
          T != null && i.push(Xp(c, T, w));
        }
        c = c.return;
      }
      return i;
    }
    function Ad(e) {
      if (e === null)
        return null;
      do
        e = e.return;
      while (e && e.tag !== M);
      return e || null;
    }
    function sT(e, t) {
      for (var a = e, i = t, c = 0, p = a; p; p = Ad(p))
        c++;
      for (var y = 0, _ = i; _; _ = Ad(_))
        y++;
      for (; c - y > 0; )
        a = Ad(a), c--;
      for (; y - c > 0; )
        i = Ad(i), y--;
      for (var w = c; w--; ) {
        if (a === i || i !== null && a === i.alternate)
          return a;
        a = Ad(a), i = Ad(i);
      }
      return null;
    }
    function _x(e, t, a, i, c) {
      for (var p = t._reactName, y = [], _ = a; _ !== null && _ !== i; ) {
        var w = _, C = w.alternate, T = w.stateNode, A = w.tag;
        if (C !== null && C === i)
          break;
        if (A === M && T !== null) {
          var z = T;
          if (c) {
            var B = ii(_, p);
            B != null && y.unshift(Xp(_, B, z));
          } else if (!c) {
            var H = ii(_, p);
            H != null && y.push(Xp(_, H, z));
          }
        }
        _ = _.return;
      }
      y.length !== 0 && e.push({
        event: t,
        listeners: y
      });
    }
    function lT(e, t, a, i, c) {
      var p = i && c ? sT(i, c) : null;
      i !== null && _x(e, t, i, p, !1), c !== null && a !== null && _x(e, a, c, p, !0);
    }
    function uT(e, t) {
      return e + "__bubble";
    }
    var ba = !1, eh = "dangerouslySetInnerHTML", ev = "suppressContentEditableWarning", xl = "suppressHydrationWarning", wx = "autoFocus", Vu = "children", Bu = "style", tv = "__html", Bb, nv, th, kx, rv, xx, Sx;
    Bb = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, nv = function(e, t) {
      op(e, t), Nc(e, t), tg(e, t, {
        registrationNameDependencies: $n,
        possibleRegistrationNames: ir
      });
    }, xx = kn && !document.documentMode, th = function(e, t, a) {
      if (!ba) {
        var i = av(a), c = av(t);
        c !== i && (ba = !0, g("Prop `%s` did not match. Server: %s Client: %s", e, JSON.stringify(c), JSON.stringify(i)));
      }
    }, kx = function(e) {
      if (!ba) {
        ba = !0;
        var t = [];
        e.forEach(function(a) {
          t.push(a);
        }), g("Extra attributes from the server: %s", t);
      }
    }, rv = function(e, t) {
      t === !1 ? g("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", e, e, e) : g("Expected `%s` listener to be a function, instead got a value of `%s` type.", e, typeof t);
    }, Sx = function(e, t) {
      var a = e.namespaceURI === _o ? e.ownerDocument.createElement(e.tagName) : e.ownerDocument.createElementNS(e.namespaceURI, e.tagName);
      return a.innerHTML = t, a.innerHTML;
    };
    var cT = /\r\n?/g, dT = /\u0000|\uFFFD/g;
    function av(e) {
      Q(e);
      var t = typeof e == "string" ? e : "" + e;
      return t.replace(cT, `
`).replace(dT, "");
    }
    function ov(e, t, a, i) {
      var c = av(t), p = av(e);
      if (p !== c && (i && (ba || (ba = !0, g('Text content did not match. Server: "%s" Client: "%s"', p, c))), a && qt))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function Ex(e) {
      return e.nodeType === ko ? e : e.ownerDocument;
    }
    function fT() {
    }
    function iv(e) {
      e.onclick = fT;
    }
    function pT(e, t, a, i, c) {
      for (var p in i)
        if (i.hasOwnProperty(p)) {
          var y = i[p];
          if (p === Bu)
            y && Object.freeze(y), Km(t, y);
          else if (p === eh) {
            var _ = y ? y[tv] : void 0;
            _ != null && Mm(t, _);
          } else if (p === Vu)
            if (typeof y == "string") {
              var w = e !== "textarea" || y !== "";
              w && nl(t, y);
            } else typeof y == "number" && nl(t, "" + y);
          else p === ev || p === xl || p === wx || ($n.hasOwnProperty(p) ? y != null && (typeof y != "function" && rv(p, y), p === "onScroll" && en("scroll", t)) : y != null && Bi(t, p, y, c));
        }
    }
    function hT(e, t, a, i) {
      for (var c = 0; c < t.length; c += 2) {
        var p = t[c], y = t[c + 1];
        p === Bu ? Km(e, y) : p === eh ? Mm(e, y) : p === Vu ? nl(e, y) : Bi(e, p, y, i);
      }
    }
    function mT(e, t, a, i) {
      var c, p = Ex(a), y, _ = i;
      if (_ === _o && (_ = Jf(e)), _ === _o) {
        if (c = ai(e, t), !c && e !== e.toLowerCase() && g("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", e), e === "script") {
          var w = p.createElement("div");
          w.innerHTML = "<script><\/script>";
          var C = w.firstChild;
          y = w.removeChild(C);
        } else if (typeof t.is == "string")
          y = p.createElement(e, {
            is: t.is
          });
        else if (y = p.createElement(e), e === "select") {
          var T = y;
          t.multiple ? T.multiple = !0 : t.size && (T.size = t.size);
        }
      } else
        y = p.createElementNS(_, e);
      return _ === _o && !c && Object.prototype.toString.call(y) === "[object HTMLUnknownElement]" && !pr.call(Bb, e) && (Bb[e] = !0, g("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", e)), y;
    }
    function gT(e, t) {
      return Ex(t).createTextNode(e);
    }
    function vT(e, t, a, i) {
      var c = ai(t, a);
      nv(t, a);
      var p;
      switch (t) {
        case "dialog":
          en("cancel", e), en("close", e), p = a;
          break;
        case "iframe":
        case "object":
        case "embed":
          en("load", e), p = a;
          break;
        case "video":
        case "audio":
          for (var y = 0; y < Gp.length; y++)
            en(Gp[y], e);
          p = a;
          break;
        case "source":
          en("error", e), p = a;
          break;
        case "img":
        case "image":
        case "link":
          en("error", e), en("load", e), p = a;
          break;
        case "details":
          en("toggle", e), p = a;
          break;
        case "input":
          bo(e, a), p = bc(e, a), en("invalid", e);
          break;
        case "option":
          el(e, a), p = a;
          break;
        case "select":
          Ec(e, a), p = Zf(e, a), en("invalid", e);
          break;
        case "textarea":
          Kf(e, a), p = Qf(e, a), en("invalid", e);
          break;
        default:
          p = a;
      }
      switch (Rc(t, p), pT(t, e, i, p, c), t) {
        case "input":
          ri(e), Wf(e, a, !1);
          break;
        case "textarea":
          ri(e), Im(e);
          break;
        case "option":
          cb(e, a);
          break;
        case "select":
          fb(e, a);
          break;
        default:
          typeof p.onClick == "function" && iv(e);
          break;
      }
    }
    function yT(e, t, a, i, c) {
      nv(t, i);
      var p = null, y, _;
      switch (t) {
        case "input":
          y = bc(e, a), _ = bc(e, i), p = [];
          break;
        case "select":
          y = Zf(e, a), _ = Zf(e, i), p = [];
          break;
        case "textarea":
          y = Qf(e, a), _ = Qf(e, i), p = [];
          break;
        default:
          y = a, _ = i, typeof y.onClick != "function" && typeof _.onClick == "function" && iv(e);
          break;
      }
      Rc(t, _);
      var w, C, T = null;
      for (w in y)
        if (!(_.hasOwnProperty(w) || !y.hasOwnProperty(w) || y[w] == null))
          if (w === Bu) {
            var A = y[w];
            for (C in A)
              A.hasOwnProperty(C) && (T || (T = {}), T[C] = "");
          } else w === eh || w === Vu || w === ev || w === xl || w === wx || ($n.hasOwnProperty(w) ? p || (p = []) : (p = p || []).push(w, null));
      for (w in _) {
        var z = _[w], B = y != null ? y[w] : void 0;
        if (!(!_.hasOwnProperty(w) || z === B || z == null && B == null))
          if (w === Bu)
            if (z && Object.freeze(z), B) {
              for (C in B)
                B.hasOwnProperty(C) && (!z || !z.hasOwnProperty(C)) && (T || (T = {}), T[C] = "");
              for (C in z)
                z.hasOwnProperty(C) && B[C] !== z[C] && (T || (T = {}), T[C] = z[C]);
            } else
              T || (p || (p = []), p.push(w, T)), T = z;
          else if (w === eh) {
            var H = z ? z[tv] : void 0, Y = B ? B[tv] : void 0;
            H != null && Y !== H && (p = p || []).push(w, H);
          } else w === Vu ? (typeof z == "string" || typeof z == "number") && (p = p || []).push(w, "" + z) : w === ev || w === xl || ($n.hasOwnProperty(w) ? (z != null && (typeof z != "function" && rv(w, z), w === "onScroll" && en("scroll", e)), !p && B !== z && (p = [])) : (p = p || []).push(w, z));
      }
      return T && (wb(T, _[Bu]), (p = p || []).push(Bu, T)), p;
    }
    function bT(e, t, a, i, c) {
      a === "input" && c.type === "radio" && c.name != null && _c(e, c);
      var p = ai(a, i), y = ai(a, c);
      switch (hT(e, t, p, y), a) {
        case "input":
          Xs(e, c);
          break;
        case "textarea":
          zm(e, c);
          break;
        case "select":
          pb(e, c);
          break;
      }
    }
    function _T(e) {
      {
        var t = e.toLowerCase();
        return iu.hasOwnProperty(t) && iu[t] || null;
      }
    }
    function wT(e, t, a, i, c, p, y) {
      var _, w;
      switch (_ = ai(t, a), nv(t, a), t) {
        case "dialog":
          en("cancel", e), en("close", e);
          break;
        case "iframe":
        case "object":
        case "embed":
          en("load", e);
          break;
        case "video":
        case "audio":
          for (var C = 0; C < Gp.length; C++)
            en(Gp[C], e);
          break;
        case "source":
          en("error", e);
          break;
        case "img":
        case "image":
        case "link":
          en("error", e), en("load", e);
          break;
        case "details":
          en("toggle", e);
          break;
        case "input":
          bo(e, a), en("invalid", e);
          break;
        case "option":
          el(e, a);
          break;
        case "select":
          Ec(e, a), en("invalid", e);
          break;
        case "textarea":
          Kf(e, a), en("invalid", e);
          break;
      }
      Rc(t, a);
      {
        w = /* @__PURE__ */ new Set();
        for (var T = e.attributes, A = 0; A < T.length; A++) {
          var z = T[A].name.toLowerCase();
          switch (z) {
            // Controlled attributes are not validated
            // TODO: Only ignore them on controlled tags.
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              w.add(T[A].name);
          }
        }
      }
      var B = null;
      for (var H in a)
        if (a.hasOwnProperty(H)) {
          var Y = a[H];
          if (H === Vu)
            typeof Y == "string" ? e.textContent !== Y && (a[xl] !== !0 && ov(e.textContent, Y, p, y), B = [Vu, Y]) : typeof Y == "number" && e.textContent !== "" + Y && (a[xl] !== !0 && ov(e.textContent, Y, p, y), B = [Vu, "" + Y]);
          else if ($n.hasOwnProperty(H))
            Y != null && (typeof Y != "function" && rv(H, Y), H === "onScroll" && en("scroll", e));
          else if (y && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof _ == "boolean") {
            var me = void 0, Ue = Qa(H);
            if (a[xl] !== !0 && !(H === ev || H === xl || // Controlled attributes are not validated
            // TODO: Only ignore them on controlled tags.
            H === "value" || H === "checked" || H === "selected")) {
              if (H === eh) {
                var Qe = e.innerHTML, vt = Y ? Y[tv] : void 0;
                if (vt != null) {
                  var ht = Sx(e, vt);
                  ht !== Qe && th(H, Qe, ht);
                }
              } else if (H === Bu) {
                if (w.delete(H), xx) {
                  var U = bb(Y);
                  me = e.getAttribute("style"), U !== me && th(H, me, U);
                }
              } else if (_)
                w.delete(H.toLowerCase()), me = Nf(e, H, Y), Y !== me && th(H, me, Y);
              else if (!hn(H, Ue, _) && !nn(H, Y, Ue, _)) {
                var K = !1;
                if (Ue !== null)
                  w.delete(Ue.attributeName), me = Pf(e, H, Y, Ue);
                else {
                  var V = i;
                  if (V === _o && (V = Jf(t)), V === _o)
                    w.delete(H.toLowerCase());
                  else {
                    var oe = _T(H);
                    oe !== null && oe !== H && (K = !0, w.delete(oe)), w.delete(H);
                  }
                  me = Nf(e, H, Y);
                }
                var Ce = gt;
                !Ce && Y !== me && !K && th(H, me, Y);
              }
            }
          }
        }
      switch (y && // $FlowFixMe - Should be inferred as not undefined.
      w.size > 0 && a[xl] !== !0 && kx(w), t) {
        case "input":
          ri(e), Wf(e, a, !0);
          break;
        case "textarea":
          ri(e), Im(e);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof a.onClick == "function" && iv(e);
          break;
      }
      return B;
    }
    function kT(e, t, a) {
      var i = e.nodeValue !== t;
      return i;
    }
    function Wb(e, t) {
      {
        if (ba)
          return;
        ba = !0, g("Did not expect server HTML to contain a <%s> in <%s>.", t.nodeName.toLowerCase(), e.nodeName.toLowerCase());
      }
    }
    function qb(e, t) {
      {
        if (ba)
          return;
        ba = !0, g('Did not expect server HTML to contain the text node "%s" in <%s>.', t.nodeValue, e.nodeName.toLowerCase());
      }
    }
    function Hb(e, t, a) {
      {
        if (ba)
          return;
        ba = !0, g("Expected server HTML to contain a matching <%s> in <%s>.", t, e.nodeName.toLowerCase());
      }
    }
    function Zb(e, t) {
      {
        if (t === "" || ba)
          return;
        ba = !0, g('Expected server HTML to contain a matching text node for "%s" in <%s>.', t, e.nodeName.toLowerCase());
      }
    }
    function xT(e, t, a) {
      switch (t) {
        case "input":
          wc(e, a);
          return;
        case "textarea":
          mb(e, a);
          return;
        case "select":
          hb(e, a);
          return;
      }
    }
    var nh = function() {
    }, rh = function() {
    };
    {
      var ST = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], Cx = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], ET = Cx.concat(["button"]), CT = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], Tx = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      rh = function(e, t) {
        var a = bt({}, e || Tx), i = {
          tag: t
        };
        return Cx.indexOf(t) !== -1 && (a.aTagInScope = null, a.buttonTagInScope = null, a.nobrTagInScope = null), ET.indexOf(t) !== -1 && (a.pTagInButtonScope = null), ST.indexOf(t) !== -1 && t !== "address" && t !== "div" && t !== "p" && (a.listItemTagAutoclosing = null, a.dlItemTagAutoclosing = null), a.current = i, t === "form" && (a.formTag = i), t === "a" && (a.aTagInScope = i), t === "button" && (a.buttonTagInScope = i), t === "nobr" && (a.nobrTagInScope = i), t === "p" && (a.pTagInButtonScope = i), t === "li" && (a.listItemTagAutoclosing = i), (t === "dd" || t === "dt") && (a.dlItemTagAutoclosing = i), a;
      };
      var TT = function(e, t) {
        switch (t) {
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
          case "select":
            return e === "option" || e === "optgroup" || e === "#text";
          case "optgroup":
            return e === "option" || e === "#text";
          // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
          // but
          case "option":
            return e === "#text";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
          // No special behavior since these rules fall back to "in body" mode for
          // all except special table nodes which cause bad parsing behavior anyway.
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
          case "tr":
            return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
          case "tbody":
          case "thead":
          case "tfoot":
            return e === "tr" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
          case "colgroup":
            return e === "col" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
          case "table":
            return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
          case "head":
            return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
          case "html":
            return e === "head" || e === "body" || e === "frameset";
          case "frameset":
            return e === "frame";
          case "#document":
            return e === "html";
        }
        switch (e) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return t !== "h1" && t !== "h2" && t !== "h3" && t !== "h4" && t !== "h5" && t !== "h6";
          case "rp":
          case "rt":
            return CT.indexOf(t) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return t == null;
        }
        return !0;
      }, RT = function(e, t) {
        switch (e) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return t.pTagInButtonScope;
          case "form":
            return t.formTag || t.pTagInButtonScope;
          case "li":
            return t.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return t.dlItemTagAutoclosing;
          case "button":
            return t.buttonTagInScope;
          case "a":
            return t.aTagInScope;
          case "nobr":
            return t.nobrTagInScope;
        }
        return null;
      }, Rx = {};
      nh = function(e, t, a) {
        a = a || Tx;
        var i = a.current, c = i && i.tag;
        t != null && (e != null && g("validateDOMNesting: when childText is passed, childTag should be null"), e = "#text");
        var p = TT(e, c) ? null : i, y = p ? null : RT(e, a), _ = p || y;
        if (_) {
          var w = _.tag, C = !!p + "|" + e + "|" + w;
          if (!Rx[C]) {
            Rx[C] = !0;
            var T = e, A = "";
            if (e === "#text" ? /\S/.test(t) ? T = "Text nodes" : (T = "Whitespace text nodes", A = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : T = "<" + e + ">", p) {
              var z = "";
              w === "table" && e === "tr" && (z += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), g("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", T, w, A, z);
            } else
              g("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", T, w);
          }
        }
      };
    }
    var sv = "suppressHydrationWarning", lv = "$", uv = "/$", ah = "$?", oh = "$!", PT = "style", Qb = null, Kb = null;
    function NT(e) {
      var t, a, i = e.nodeType;
      switch (i) {
        case ko:
        case ep: {
          t = i === ko ? "#document" : "#fragment";
          var c = e.documentElement;
          a = c ? c.namespaceURI : Xf(null, "");
          break;
        }
        default: {
          var p = i === mn ? e.parentNode : e, y = p.namespaceURI || null;
          t = p.tagName, a = Xf(y, t);
          break;
        }
      }
      {
        var _ = t.toLowerCase(), w = rh(null, _);
        return {
          namespace: a,
          ancestorInfo: w
        };
      }
    }
    function OT(e, t, a) {
      {
        var i = e, c = Xf(i.namespace, t), p = rh(i.ancestorInfo, t);
        return {
          namespace: c,
          ancestorInfo: p
        };
      }
    }
    function LT(e) {
      Qb = In(), Kb = HC();
      var t = null;
      return St(!1), t;
    }
    function DT(e) {
      ZC(Kb), St(Qb), Qb = null, Kb = null;
    }
    function zT(e, t, a, i, c) {
      var p;
      {
        var y = i;
        if (nh(e, null, y.ancestorInfo), typeof t.children == "string" || typeof t.children == "number") {
          var _ = "" + t.children, w = rh(y.ancestorInfo, e);
          nh(null, _, w);
        }
        p = y.namespace;
      }
      var C = mT(e, t, a, p);
      return lh(c, C), r_(C, t), C;
    }
    function IT(e, t) {
      e.appendChild(t);
    }
    function AT(e, t, a, i, c) {
      switch (vT(e, t, a, i), t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!a.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function MT(e, t, a, i, c, p) {
      {
        var y = p;
        if (typeof i.children != typeof a.children && (typeof i.children == "string" || typeof i.children == "number")) {
          var _ = "" + i.children, w = rh(y.ancestorInfo, t);
          nh(null, _, w);
        }
      }
      return yT(e, t, a, i);
    }
    function Yb(e, t) {
      return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
    }
    function FT(e, t, a, i) {
      {
        var c = a;
        nh(null, e, c.ancestorInfo);
      }
      var p = gT(e, t);
      return lh(i, p), p;
    }
    function $T() {
      var e = window.event;
      return e === void 0 ? ro : Au(e.type);
    }
    var Gb = typeof setTimeout == "function" ? setTimeout : void 0, jT = typeof clearTimeout == "function" ? clearTimeout : void 0, Jb = -1, Px = typeof Promise == "function" ? Promise : void 0, UT = typeof queueMicrotask == "function" ? queueMicrotask : typeof Px < "u" ? function(e) {
      return Px.resolve(null).then(e).catch(VT);
    } : Gb;
    function VT(e) {
      setTimeout(function() {
        throw e;
      });
    }
    function BT(e, t, a, i) {
      switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          a.autoFocus && e.focus();
          return;
        case "img": {
          a.src && (e.src = a.src);
          return;
        }
      }
    }
    function WT(e, t, a, i, c, p) {
      bT(e, t, a, i, c), r_(e, c);
    }
    function Nx(e) {
      nl(e, "");
    }
    function qT(e, t, a) {
      e.nodeValue = a;
    }
    function HT(e, t) {
      e.appendChild(t);
    }
    function ZT(e, t) {
      var a;
      e.nodeType === mn ? (a = e.parentNode, a.insertBefore(t, e)) : (a = e, a.appendChild(t));
      var i = e._reactRootContainer;
      i == null && a.onclick === null && iv(a);
    }
    function QT(e, t, a) {
      e.insertBefore(t, a);
    }
    function KT(e, t, a) {
      e.nodeType === mn ? e.parentNode.insertBefore(t, a) : e.insertBefore(t, a);
    }
    function YT(e, t) {
      e.removeChild(t);
    }
    function GT(e, t) {
      e.nodeType === mn ? e.parentNode.removeChild(t) : e.removeChild(t);
    }
    function Xb(e, t) {
      var a = t, i = 0;
      do {
        var c = a.nextSibling;
        if (e.removeChild(a), c && c.nodeType === mn) {
          var p = c.data;
          if (p === uv)
            if (i === 0) {
              e.removeChild(c), yi(t);
              return;
            } else
              i--;
          else (p === lv || p === ah || p === oh) && i++;
        }
        a = c;
      } while (a);
      yi(t);
    }
    function JT(e, t) {
      e.nodeType === mn ? Xb(e.parentNode, t) : e.nodeType === Cr && Xb(e, t), yi(e);
    }
    function XT(e) {
      e = e;
      var t = e.style;
      typeof t.setProperty == "function" ? t.setProperty("display", "none", "important") : t.display = "none";
    }
    function eR(e) {
      e.nodeValue = "";
    }
    function tR(e, t) {
      e = e;
      var a = t[PT], i = a != null && a.hasOwnProperty("display") ? a.display : null;
      e.style.display = Tc("display", i);
    }
    function nR(e, t) {
      e.nodeValue = t;
    }
    function rR(e) {
      e.nodeType === Cr ? e.textContent = "" : e.nodeType === ko && e.documentElement && e.removeChild(e.documentElement);
    }
    function aR(e, t, a) {
      return e.nodeType !== Cr || t.toLowerCase() !== e.nodeName.toLowerCase() ? null : e;
    }
    function oR(e, t) {
      return t === "" || e.nodeType !== wo ? null : e;
    }
    function iR(e) {
      return e.nodeType !== mn ? null : e;
    }
    function Ox(e) {
      return e.data === ah;
    }
    function e_(e) {
      return e.data === oh;
    }
    function sR(e) {
      var t = e.nextSibling && e.nextSibling.dataset, a, i, c;
      return t && (a = t.dgst, i = t.msg, c = t.stck), {
        message: i,
        digest: a,
        stack: c
      };
    }
    function lR(e, t) {
      e._reactRetry = t;
    }
    function cv(e) {
      for (; e != null; e = e.nextSibling) {
        var t = e.nodeType;
        if (t === Cr || t === wo)
          break;
        if (t === mn) {
          var a = e.data;
          if (a === lv || a === oh || a === ah)
            break;
          if (a === uv)
            return null;
        }
      }
      return e;
    }
    function ih(e) {
      return cv(e.nextSibling);
    }
    function uR(e) {
      return cv(e.firstChild);
    }
    function cR(e) {
      return cv(e.firstChild);
    }
    function dR(e) {
      return cv(e.nextSibling);
    }
    function fR(e, t, a, i, c, p, y) {
      lh(p, e), r_(e, a);
      var _;
      {
        var w = c;
        _ = w.namespace;
      }
      var C = (p.mode & pt) !== He;
      return wT(e, t, a, _, i, C, y);
    }
    function pR(e, t, a, i) {
      return lh(a, e), a.mode & pt, kT(e, t);
    }
    function hR(e, t) {
      lh(t, e);
    }
    function mR(e) {
      for (var t = e.nextSibling, a = 0; t; ) {
        if (t.nodeType === mn) {
          var i = t.data;
          if (i === uv) {
            if (a === 0)
              return ih(t);
            a--;
          } else (i === lv || i === oh || i === ah) && a++;
        }
        t = t.nextSibling;
      }
      return null;
    }
    function Lx(e) {
      for (var t = e.previousSibling, a = 0; t; ) {
        if (t.nodeType === mn) {
          var i = t.data;
          if (i === lv || i === oh || i === ah) {
            if (a === 0)
              return t;
            a--;
          } else i === uv && a++;
        }
        t = t.previousSibling;
      }
      return null;
    }
    function gR(e) {
      yi(e);
    }
    function vR(e) {
      yi(e);
    }
    function yR(e) {
      return e !== "head" && e !== "body";
    }
    function bR(e, t, a, i) {
      var c = !0;
      ov(t.nodeValue, a, i, c);
    }
    function _R(e, t, a, i, c, p) {
      if (t[sv] !== !0) {
        var y = !0;
        ov(i.nodeValue, c, p, y);
      }
    }
    function wR(e, t) {
      t.nodeType === Cr ? Wb(e, t) : t.nodeType === mn || qb(e, t);
    }
    function kR(e, t) {
      {
        var a = e.parentNode;
        a !== null && (t.nodeType === Cr ? Wb(a, t) : t.nodeType === mn || qb(a, t));
      }
    }
    function xR(e, t, a, i, c) {
      (c || t[sv] !== !0) && (i.nodeType === Cr ? Wb(a, i) : i.nodeType === mn || qb(a, i));
    }
    function SR(e, t, a) {
      Hb(e, t);
    }
    function ER(e, t) {
      Zb(e, t);
    }
    function CR(e, t, a) {
      {
        var i = e.parentNode;
        i !== null && Hb(i, t);
      }
    }
    function TR(e, t) {
      {
        var a = e.parentNode;
        a !== null && Zb(a, t);
      }
    }
    function RR(e, t, a, i, c, p) {
      (p || t[sv] !== !0) && Hb(a, i);
    }
    function PR(e, t, a, i, c) {
      (c || t[sv] !== !0) && Zb(a, i);
    }
    function NR(e) {
      g("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", e.nodeName.toLowerCase());
    }
    function OR(e) {
      Jp(e);
    }
    var Md = Math.random().toString(36).slice(2), Fd = "__reactFiber$" + Md, t_ = "__reactProps$" + Md, sh = "__reactContainer$" + Md, n_ = "__reactEvents$" + Md, LR = "__reactListeners$" + Md, DR = "__reactHandles$" + Md;
    function zR(e) {
      delete e[Fd], delete e[t_], delete e[n_], delete e[LR], delete e[DR];
    }
    function lh(e, t) {
      t[Fd] = e;
    }
    function dv(e, t) {
      t[sh] = e;
    }
    function Dx(e) {
      e[sh] = null;
    }
    function uh(e) {
      return !!e[sh];
    }
    function Wu(e) {
      var t = e[Fd];
      if (t)
        return t;
      for (var a = e.parentNode; a; ) {
        if (t = a[sh] || a[Fd], t) {
          var i = t.alternate;
          if (t.child !== null || i !== null && i.child !== null)
            for (var c = Lx(e); c !== null; ) {
              var p = c[Fd];
              if (p)
                return p;
              c = Lx(c);
            }
          return t;
        }
        e = a, a = e.parentNode;
      }
      return null;
    }
    function Sl(e) {
      var t = e[Fd] || e[sh];
      return t && (t.tag === M || t.tag === $ || t.tag === Re || t.tag === P) ? t : null;
    }
    function $d(e) {
      if (e.tag === M || e.tag === $)
        return e.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function fv(e) {
      return e[t_] || null;
    }
    function r_(e, t) {
      e[t_] = t;
    }
    function IR(e) {
      var t = e[n_];
      return t === void 0 && (t = e[n_] = /* @__PURE__ */ new Set()), t;
    }
    var zx = {}, Ix = s.ReactDebugCurrentFrame;
    function pv(e) {
      if (e) {
        var t = e._owner, a = Qi(e.type, e._source, t ? t.type : null);
        Ix.setExtraStackFrame(a);
      } else
        Ix.setExtraStackFrame(null);
    }
    function Mo(e, t, a, i, c) {
      {
        var p = Function.call.bind(pr);
        for (var y in e)
          if (p(e, y)) {
            var _ = void 0;
            try {
              if (typeof e[y] != "function") {
                var w = Error((i || "React class") + ": " + a + " type `" + y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[y] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw w.name = "Invariant Violation", w;
              }
              _ = e[y](t, y, i, a, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (C) {
              _ = C;
            }
            _ && !(_ instanceof Error) && (pv(c), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", i || "React class", a, y, typeof _), pv(null)), _ instanceof Error && !(_.message in zx) && (zx[_.message] = !0, pv(c), g("Failed %s type: %s", a, _.message), pv(null));
          }
      }
    }
    var a_ = [], hv;
    hv = [];
    var Ps = -1;
    function El(e) {
      return {
        current: e
      };
    }
    function Mr(e, t) {
      if (Ps < 0) {
        g("Unexpected pop.");
        return;
      }
      t !== hv[Ps] && g("Unexpected Fiber popped."), e.current = a_[Ps], a_[Ps] = null, hv[Ps] = null, Ps--;
    }
    function Fr(e, t, a) {
      Ps++, a_[Ps] = e.current, hv[Ps] = a, e.current = t;
    }
    var o_;
    o_ = {};
    var Ua = {};
    Object.freeze(Ua);
    var Ns = El(Ua), Ci = El(!1), i_ = Ua;
    function jd(e, t, a) {
      return a && Ti(t) ? i_ : Ns.current;
    }
    function Ax(e, t, a) {
      {
        var i = e.stateNode;
        i.__reactInternalMemoizedUnmaskedChildContext = t, i.__reactInternalMemoizedMaskedChildContext = a;
      }
    }
    function Ud(e, t) {
      {
        var a = e.type, i = a.contextTypes;
        if (!i)
          return Ua;
        var c = e.stateNode;
        if (c && c.__reactInternalMemoizedUnmaskedChildContext === t)
          return c.__reactInternalMemoizedMaskedChildContext;
        var p = {};
        for (var y in i)
          p[y] = t[y];
        {
          var _ = ut(e) || "Unknown";
          Mo(i, p, "context", _);
        }
        return c && Ax(e, t, p), p;
      }
    }
    function mv() {
      return Ci.current;
    }
    function Ti(e) {
      {
        var t = e.childContextTypes;
        return t != null;
      }
    }
    function gv(e) {
      Mr(Ci, e), Mr(Ns, e);
    }
    function s_(e) {
      Mr(Ci, e), Mr(Ns, e);
    }
    function Mx(e, t, a) {
      {
        if (Ns.current !== Ua)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        Fr(Ns, t, e), Fr(Ci, a, e);
      }
    }
    function Fx(e, t, a) {
      {
        var i = e.stateNode, c = t.childContextTypes;
        if (typeof i.getChildContext != "function") {
          {
            var p = ut(e) || "Unknown";
            o_[p] || (o_[p] = !0, g("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", p, p));
          }
          return a;
        }
        var y = i.getChildContext();
        for (var _ in y)
          if (!(_ in c))
            throw new Error((ut(e) || "Unknown") + '.getChildContext(): key "' + _ + '" is not defined in childContextTypes.');
        {
          var w = ut(e) || "Unknown";
          Mo(c, y, "child context", w);
        }
        return bt({}, a, y);
      }
    }
    function vv(e) {
      {
        var t = e.stateNode, a = t && t.__reactInternalMemoizedMergedChildContext || Ua;
        return i_ = Ns.current, Fr(Ns, a, e), Fr(Ci, Ci.current, e), !0;
      }
    }
    function $x(e, t, a) {
      {
        var i = e.stateNode;
        if (!i)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (a) {
          var c = Fx(e, t, i_);
          i.__reactInternalMemoizedMergedChildContext = c, Mr(Ci, e), Mr(Ns, e), Fr(Ns, c, e), Fr(Ci, a, e);
        } else
          Mr(Ci, e), Fr(Ci, a, e);
      }
    }
    function AR(e) {
      {
        if (!os(e) || e.tag !== E)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var t = e;
        do {
          switch (t.tag) {
            case P:
              return t.stateNode.context;
            case E: {
              var a = t.type;
              if (Ti(a))
                return t.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          t = t.return;
        } while (t !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Cl = 0, yv = 1, Os = null, l_ = !1, u_ = !1;
    function jx(e) {
      Os === null ? Os = [e] : Os.push(e);
    }
    function MR(e) {
      l_ = !0, jx(e);
    }
    function Ux() {
      l_ && Tl();
    }
    function Tl() {
      if (!u_ && Os !== null) {
        u_ = !0;
        var e = 0, t = Ma();
        try {
          var a = !0, i = Os;
          for (Cn(zr); e < i.length; e++) {
            var c = i[e];
            do
              c = c(a);
            while (c !== null);
          }
          Os = null, l_ = !1;
        } catch (p) {
          throw Os !== null && (Os = Os.slice(e + 1)), fp(hu, Tl), p;
        } finally {
          Cn(t), u_ = !1;
        }
      }
      return null;
    }
    var Vd = [], Bd = 0, bv = null, _v = 0, so = [], lo = 0, qu = null, Ls = 1, Ds = "";
    function FR(e) {
      return Zu(), (e.flags & Ja) !== We;
    }
    function $R(e) {
      return Zu(), _v;
    }
    function jR() {
      var e = Ds, t = Ls, a = t & ~UR(t);
      return a.toString(32) + e;
    }
    function Hu(e, t) {
      Zu(), Vd[Bd++] = _v, Vd[Bd++] = bv, bv = e, _v = t;
    }
    function Vx(e, t, a) {
      Zu(), so[lo++] = Ls, so[lo++] = Ds, so[lo++] = qu, qu = e;
      var i = Ls, c = Ds, p = wv(i) - 1, y = i & ~(1 << p), _ = a + 1, w = wv(t) + p;
      if (w > 30) {
        var C = p - p % 5, T = (1 << C) - 1, A = (y & T).toString(32), z = y >> C, B = p - C, H = wv(t) + B, Y = _ << B, me = Y | z, Ue = A + c;
        Ls = 1 << H | me, Ds = Ue;
      } else {
        var Qe = _ << p, vt = Qe | y, ht = c;
        Ls = 1 << w | vt, Ds = ht;
      }
    }
    function c_(e) {
      Zu();
      var t = e.return;
      if (t !== null) {
        var a = 1, i = 0;
        Hu(e, a), Vx(e, a, i);
      }
    }
    function wv(e) {
      return 32 - yn(e);
    }
    function UR(e) {
      return 1 << wv(e) - 1;
    }
    function d_(e) {
      for (; e === bv; )
        bv = Vd[--Bd], Vd[Bd] = null, _v = Vd[--Bd], Vd[Bd] = null;
      for (; e === qu; )
        qu = so[--lo], so[lo] = null, Ds = so[--lo], so[lo] = null, Ls = so[--lo], so[lo] = null;
    }
    function VR() {
      return Zu(), qu !== null ? {
        id: Ls,
        overflow: Ds
      } : null;
    }
    function BR(e, t) {
      Zu(), so[lo++] = Ls, so[lo++] = Ds, so[lo++] = qu, Ls = t.id, Ds = t.overflow, qu = e;
    }
    function Zu() {
      vr() || g("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var gr = null, uo = null, Fo = !1, Qu = !1, Rl = null;
    function WR() {
      Fo && g("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function Bx() {
      Qu = !0;
    }
    function qR() {
      return Qu;
    }
    function HR(e) {
      var t = e.stateNode.containerInfo;
      return uo = cR(t), gr = e, Fo = !0, Rl = null, Qu = !1, !0;
    }
    function ZR(e, t, a) {
      return uo = dR(t), gr = e, Fo = !0, Rl = null, Qu = !1, a !== null && BR(e, a), !0;
    }
    function Wx(e, t) {
      switch (e.tag) {
        case P: {
          wR(e.stateNode.containerInfo, t);
          break;
        }
        case M: {
          var a = (e.mode & pt) !== He;
          xR(
            e.type,
            e.memoizedProps,
            e.stateNode,
            t,
            // TODO: Delete this argument when we remove the legacy root API.
            a
          );
          break;
        }
        case Re: {
          var i = e.memoizedState;
          i.dehydrated !== null && kR(i.dehydrated, t);
          break;
        }
      }
    }
    function qx(e, t) {
      Wx(e, t);
      var a = GO();
      a.stateNode = t, a.return = e;
      var i = e.deletions;
      i === null ? (e.deletions = [a], e.flags |= da) : i.push(a);
    }
    function f_(e, t) {
      {
        if (Qu)
          return;
        switch (e.tag) {
          case P: {
            var a = e.stateNode.containerInfo;
            switch (t.tag) {
              case M:
                var i = t.type;
                t.pendingProps, SR(a, i);
                break;
              case $:
                var c = t.pendingProps;
                ER(a, c);
                break;
            }
            break;
          }
          case M: {
            var p = e.type, y = e.memoizedProps, _ = e.stateNode;
            switch (t.tag) {
              case M: {
                var w = t.type, C = t.pendingProps, T = (e.mode & pt) !== He;
                RR(
                  p,
                  y,
                  _,
                  w,
                  C,
                  // TODO: Delete this argument when we remove the legacy root API.
                  T
                );
                break;
              }
              case $: {
                var A = t.pendingProps, z = (e.mode & pt) !== He;
                PR(
                  p,
                  y,
                  _,
                  A,
                  // TODO: Delete this argument when we remove the legacy root API.
                  z
                );
                break;
              }
            }
            break;
          }
          case Re: {
            var B = e.memoizedState, H = B.dehydrated;
            if (H !== null) switch (t.tag) {
              case M:
                var Y = t.type;
                t.pendingProps, CR(H, Y);
                break;
              case $:
                var me = t.pendingProps;
                TR(H, me);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function Hx(e, t) {
      t.flags = t.flags & -4097 | sn, f_(e, t);
    }
    function Zx(e, t) {
      switch (e.tag) {
        case M: {
          var a = e.type;
          e.pendingProps;
          var i = aR(t, a);
          return i !== null ? (e.stateNode = i, gr = e, uo = uR(i), !0) : !1;
        }
        case $: {
          var c = e.pendingProps, p = oR(t, c);
          return p !== null ? (e.stateNode = p, gr = e, uo = null, !0) : !1;
        }
        case Re: {
          var y = iR(t);
          if (y !== null) {
            var _ = {
              dehydrated: y,
              treeContext: VR(),
              retryLane: Kr
            };
            e.memoizedState = _;
            var w = JO(y);
            return w.return = e, e.child = w, gr = e, uo = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function p_(e) {
      return (e.mode & pt) !== He && (e.flags & Be) === We;
    }
    function h_(e) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function m_(e) {
      if (Fo) {
        var t = uo;
        if (!t) {
          p_(e) && (f_(gr, e), h_()), Hx(gr, e), Fo = !1, gr = e;
          return;
        }
        var a = t;
        if (!Zx(e, t)) {
          p_(e) && (f_(gr, e), h_()), t = ih(a);
          var i = gr;
          if (!t || !Zx(e, t)) {
            Hx(gr, e), Fo = !1, gr = e;
            return;
          }
          qx(i, a);
        }
      }
    }
    function QR(e, t, a) {
      var i = e.stateNode, c = !Qu, p = fR(i, e.type, e.memoizedProps, t, a, e, c);
      return e.updateQueue = p, p !== null;
    }
    function KR(e) {
      var t = e.stateNode, a = e.memoizedProps, i = pR(t, a, e);
      if (i) {
        var c = gr;
        if (c !== null)
          switch (c.tag) {
            case P: {
              var p = c.stateNode.containerInfo, y = (c.mode & pt) !== He;
              bR(
                p,
                t,
                a,
                // TODO: Delete this argument when we remove the legacy root API.
                y
              );
              break;
            }
            case M: {
              var _ = c.type, w = c.memoizedProps, C = c.stateNode, T = (c.mode & pt) !== He;
              _R(
                _,
                w,
                C,
                t,
                a,
                // TODO: Delete this argument when we remove the legacy root API.
                T
              );
              break;
            }
          }
      }
      return i;
    }
    function YR(e) {
      var t = e.memoizedState, a = t !== null ? t.dehydrated : null;
      if (!a)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      hR(a, e);
    }
    function GR(e) {
      var t = e.memoizedState, a = t !== null ? t.dehydrated : null;
      if (!a)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return mR(a);
    }
    function Qx(e) {
      for (var t = e.return; t !== null && t.tag !== M && t.tag !== P && t.tag !== Re; )
        t = t.return;
      gr = t;
    }
    function kv(e) {
      if (e !== gr)
        return !1;
      if (!Fo)
        return Qx(e), Fo = !0, !1;
      if (e.tag !== P && (e.tag !== M || yR(e.type) && !Yb(e.type, e.memoizedProps))) {
        var t = uo;
        if (t)
          if (p_(e))
            Kx(e), h_();
          else
            for (; t; )
              qx(e, t), t = ih(t);
      }
      return Qx(e), e.tag === Re ? uo = GR(e) : uo = gr ? ih(e.stateNode) : null, !0;
    }
    function JR() {
      return Fo && uo !== null;
    }
    function Kx(e) {
      for (var t = uo; t; )
        Wx(e, t), t = ih(t);
    }
    function Wd() {
      gr = null, uo = null, Fo = !1, Qu = !1;
    }
    function Yx() {
      Rl !== null && (B1(Rl), Rl = null);
    }
    function vr() {
      return Fo;
    }
    function g_(e) {
      Rl === null ? Rl = [e] : Rl.push(e);
    }
    var XR = s.ReactCurrentBatchConfig, eP = null;
    function tP() {
      return XR.transition;
    }
    var $o = {
      recordUnsafeLifecycleWarnings: function(e, t) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(e, t) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var nP = function(e) {
        for (var t = null, a = e; a !== null; )
          a.mode & $t && (t = a), a = a.return;
        return t;
      }, Ku = function(e) {
        var t = [];
        return e.forEach(function(a) {
          t.push(a);
        }), t.sort().join(", ");
      }, ch = [], dh = [], fh = [], ph = [], hh = [], mh = [], Yu = /* @__PURE__ */ new Set();
      $o.recordUnsafeLifecycleWarnings = function(e, t) {
        Yu.has(e.type) || (typeof t.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        t.componentWillMount.__suppressDeprecationWarning !== !0 && ch.push(e), e.mode & $t && typeof t.UNSAFE_componentWillMount == "function" && dh.push(e), typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && fh.push(e), e.mode & $t && typeof t.UNSAFE_componentWillReceiveProps == "function" && ph.push(e), typeof t.componentWillUpdate == "function" && t.componentWillUpdate.__suppressDeprecationWarning !== !0 && hh.push(e), e.mode & $t && typeof t.UNSAFE_componentWillUpdate == "function" && mh.push(e));
      }, $o.flushPendingUnsafeLifecycleWarnings = function() {
        var e = /* @__PURE__ */ new Set();
        ch.length > 0 && (ch.forEach(function(z) {
          e.add(ut(z) || "Component"), Yu.add(z.type);
        }), ch = []);
        var t = /* @__PURE__ */ new Set();
        dh.length > 0 && (dh.forEach(function(z) {
          t.add(ut(z) || "Component"), Yu.add(z.type);
        }), dh = []);
        var a = /* @__PURE__ */ new Set();
        fh.length > 0 && (fh.forEach(function(z) {
          a.add(ut(z) || "Component"), Yu.add(z.type);
        }), fh = []);
        var i = /* @__PURE__ */ new Set();
        ph.length > 0 && (ph.forEach(function(z) {
          i.add(ut(z) || "Component"), Yu.add(z.type);
        }), ph = []);
        var c = /* @__PURE__ */ new Set();
        hh.length > 0 && (hh.forEach(function(z) {
          c.add(ut(z) || "Component"), Yu.add(z.type);
        }), hh = []);
        var p = /* @__PURE__ */ new Set();
        if (mh.length > 0 && (mh.forEach(function(z) {
          p.add(ut(z) || "Component"), Yu.add(z.type);
        }), mh = []), t.size > 0) {
          var y = Ku(t);
          g(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, y);
        }
        if (i.size > 0) {
          var _ = Ku(i);
          g(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, _);
        }
        if (p.size > 0) {
          var w = Ku(p);
          g(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, w);
        }
        if (e.size > 0) {
          var C = Ku(e);
          m(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, C);
        }
        if (a.size > 0) {
          var T = Ku(a);
          m(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, T);
        }
        if (c.size > 0) {
          var A = Ku(c);
          m(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, A);
        }
      };
      var xv = /* @__PURE__ */ new Map(), Gx = /* @__PURE__ */ new Set();
      $o.recordLegacyContextWarning = function(e, t) {
        var a = nP(e);
        if (a === null) {
          g("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!Gx.has(e.type)) {
          var i = xv.get(a);
          (e.type.contextTypes != null || e.type.childContextTypes != null || t !== null && typeof t.getChildContext == "function") && (i === void 0 && (i = [], xv.set(a, i)), i.push(e));
        }
      }, $o.flushLegacyContextWarning = function() {
        xv.forEach(function(e, t) {
          if (e.length !== 0) {
            var a = e[0], i = /* @__PURE__ */ new Set();
            e.forEach(function(p) {
              i.add(ut(p) || "Component"), Gx.add(p.type);
            });
            var c = Ku(i);
            try {
              Kt(a), g(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, c);
            } finally {
              rn();
            }
          }
        });
      }, $o.discardPendingWarnings = function() {
        ch = [], dh = [], fh = [], ph = [], hh = [], mh = [], xv = /* @__PURE__ */ new Map();
      };
    }
    var v_, y_, b_, __, w_, Jx = function(e, t) {
    };
    v_ = !1, y_ = !1, b_ = {}, __ = {}, w_ = {}, Jx = function(e, t) {
      if (!(e === null || typeof e != "object") && !(!e._store || e._store.validated || e.key != null)) {
        if (typeof e._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        e._store.validated = !0;
        var a = ut(t) || "Component";
        __[a] || (__[a] = !0, g('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function rP(e) {
      return e.prototype && e.prototype.isReactComponent;
    }
    function gh(e, t, a) {
      var i = a.ref;
      if (i !== null && typeof i != "function" && typeof i != "object") {
        if ((e.mode & $t || Ct) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(a._owner && a._self && a._owner.stateNode !== a._self) && // Will already throw with "Function components cannot have string refs"
        !(a._owner && a._owner.tag !== E) && // Will already warn with "Function components cannot be given refs"
        !(typeof a.type == "function" && !rP(a.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        a._owner) {
          var c = ut(e) || "Component";
          b_[c] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', c, i), b_[c] = !0);
        }
        if (a._owner) {
          var p = a._owner, y;
          if (p) {
            var _ = p;
            if (_.tag !== E)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            y = _.stateNode;
          }
          if (!y)
            throw new Error("Missing owner for string ref " + i + ". This error is likely caused by a bug in React. Please file an issue.");
          var w = y;
          L(i, "ref");
          var C = "" + i;
          if (t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === C)
            return t.ref;
          var T = function(A) {
            var z = w.refs;
            A === null ? delete z[C] : z[C] = A;
          };
          return T._stringRef = C, T;
        } else {
          if (typeof i != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!a._owner)
            throw new Error("Element ref was specified as a string (" + i + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return i;
    }
    function Sv(e, t) {
      var a = Object.prototype.toString.call(t);
      throw new Error("Objects are not valid as a React child (found: " + (a === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : a) + "). If you meant to render a collection of children, use an array instead.");
    }
    function Ev(e) {
      {
        var t = ut(e) || "Component";
        if (w_[t])
          return;
        w_[t] = !0, g("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function Xx(e) {
      var t = e._payload, a = e._init;
      return a(t);
    }
    function e0(e) {
      function t(U, K) {
        if (e) {
          var V = U.deletions;
          V === null ? (U.deletions = [K], U.flags |= da) : V.push(K);
        }
      }
      function a(U, K) {
        if (!e)
          return null;
        for (var V = K; V !== null; )
          t(U, V), V = V.sibling;
        return null;
      }
      function i(U, K) {
        for (var V = /* @__PURE__ */ new Map(), oe = K; oe !== null; )
          oe.key !== null ? V.set(oe.key, oe) : V.set(oe.index, oe), oe = oe.sibling;
        return V;
      }
      function c(U, K) {
        var V = oc(U, K);
        return V.index = 0, V.sibling = null, V;
      }
      function p(U, K, V) {
        if (U.index = V, !e)
          return U.flags |= Ja, K;
        var oe = U.alternate;
        if (oe !== null) {
          var Ce = oe.index;
          return Ce < K ? (U.flags |= sn, K) : Ce;
        } else
          return U.flags |= sn, K;
      }
      function y(U) {
        return e && U.alternate === null && (U.flags |= sn), U;
      }
      function _(U, K, V, oe) {
        if (K === null || K.tag !== $) {
          var Ce = gk(V, U.mode, oe);
          return Ce.return = U, Ce;
        } else {
          var we = c(K, V);
          return we.return = U, we;
        }
      }
      function w(U, K, V, oe) {
        var Ce = V.type;
        if (Ce === Qs)
          return T(U, K, V.props.children, oe, V.key);
        if (K !== null && (K.elementType === Ce || // Keep this check inline so it only runs on the false path:
        oS(K, V) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof Ce == "object" && Ce !== null && Ce.$$typeof === lr && Xx(Ce) === K.type)) {
          var we = c(K, V.props);
          return we.ref = gh(U, K, V), we.return = U, we._debugSource = V._source, we._debugOwner = V._owner, we;
        }
        var Xe = mk(V, U.mode, oe);
        return Xe.ref = gh(U, K, V), Xe.return = U, Xe;
      }
      function C(U, K, V, oe) {
        if (K === null || K.tag !== O || K.stateNode.containerInfo !== V.containerInfo || K.stateNode.implementation !== V.implementation) {
          var Ce = vk(V, U.mode, oe);
          return Ce.return = U, Ce;
        } else {
          var we = c(K, V.children || []);
          return we.return = U, we;
        }
      }
      function T(U, K, V, oe, Ce) {
        if (K === null || K.tag !== Z) {
          var we = $l(V, U.mode, oe, Ce);
          return we.return = U, we;
        } else {
          var Xe = c(K, V);
          return Xe.return = U, Xe;
        }
      }
      function A(U, K, V) {
        if (typeof K == "string" && K !== "" || typeof K == "number") {
          var oe = gk("" + K, U.mode, V);
          return oe.return = U, oe;
        }
        if (typeof K == "object" && K !== null) {
          switch (K.$$typeof) {
            case ei: {
              var Ce = mk(K, U.mode, V);
              return Ce.ref = gh(U, null, K), Ce.return = U, Ce;
            }
            case Ta: {
              var we = vk(K, U.mode, V);
              return we.return = U, we;
            }
            case lr: {
              var Xe = K._payload, it = K._init;
              return A(U, it(Xe), V);
            }
          }
          if (Wn(K) || Bt(K)) {
            var Ut = $l(K, U.mode, V, null);
            return Ut.return = U, Ut;
          }
          Sv(U, K);
        }
        return typeof K == "function" && Ev(U), null;
      }
      function z(U, K, V, oe) {
        var Ce = K !== null ? K.key : null;
        if (typeof V == "string" && V !== "" || typeof V == "number")
          return Ce !== null ? null : _(U, K, "" + V, oe);
        if (typeof V == "object" && V !== null) {
          switch (V.$$typeof) {
            case ei:
              return V.key === Ce ? w(U, K, V, oe) : null;
            case Ta:
              return V.key === Ce ? C(U, K, V, oe) : null;
            case lr: {
              var we = V._payload, Xe = V._init;
              return z(U, K, Xe(we), oe);
            }
          }
          if (Wn(V) || Bt(V))
            return Ce !== null ? null : T(U, K, V, oe, null);
          Sv(U, V);
        }
        return typeof V == "function" && Ev(U), null;
      }
      function B(U, K, V, oe, Ce) {
        if (typeof oe == "string" && oe !== "" || typeof oe == "number") {
          var we = U.get(V) || null;
          return _(K, we, "" + oe, Ce);
        }
        if (typeof oe == "object" && oe !== null) {
          switch (oe.$$typeof) {
            case ei: {
              var Xe = U.get(oe.key === null ? V : oe.key) || null;
              return w(K, Xe, oe, Ce);
            }
            case Ta: {
              var it = U.get(oe.key === null ? V : oe.key) || null;
              return C(K, it, oe, Ce);
            }
            case lr:
              var Ut = oe._payload, Nt = oe._init;
              return B(U, K, V, Nt(Ut), Ce);
          }
          if (Wn(oe) || Bt(oe)) {
            var Rn = U.get(V) || null;
            return T(K, Rn, oe, Ce, null);
          }
          Sv(K, oe);
        }
        return typeof oe == "function" && Ev(K), null;
      }
      function H(U, K, V) {
        {
          if (typeof U != "object" || U === null)
            return K;
          switch (U.$$typeof) {
            case ei:
            case Ta:
              Jx(U, V);
              var oe = U.key;
              if (typeof oe != "string")
                break;
              if (K === null) {
                K = /* @__PURE__ */ new Set(), K.add(oe);
                break;
              }
              if (!K.has(oe)) {
                K.add(oe);
                break;
              }
              g("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", oe);
              break;
            case lr:
              var Ce = U._payload, we = U._init;
              H(we(Ce), K, V);
              break;
          }
        }
        return K;
      }
      function Y(U, K, V, oe) {
        for (var Ce = null, we = 0; we < V.length; we++) {
          var Xe = V[we];
          Ce = H(Xe, Ce, U);
        }
        for (var it = null, Ut = null, Nt = K, Rn = 0, Ot = 0, wn = null; Nt !== null && Ot < V.length; Ot++) {
          Nt.index > Ot ? (wn = Nt, Nt = null) : wn = Nt.sibling;
          var jr = z(U, Nt, V[Ot], oe);
          if (jr === null) {
            Nt === null && (Nt = wn);
            break;
          }
          e && Nt && jr.alternate === null && t(U, Nt), Rn = p(jr, Rn, Ot), Ut === null ? it = jr : Ut.sibling = jr, Ut = jr, Nt = wn;
        }
        if (Ot === V.length) {
          if (a(U, Nt), vr()) {
            var Sr = Ot;
            Hu(U, Sr);
          }
          return it;
        }
        if (Nt === null) {
          for (; Ot < V.length; Ot++) {
            var Ba = A(U, V[Ot], oe);
            Ba !== null && (Rn = p(Ba, Rn, Ot), Ut === null ? it = Ba : Ut.sibling = Ba, Ut = Ba);
          }
          if (vr()) {
            var ta = Ot;
            Hu(U, ta);
          }
          return it;
        }
        for (var na = i(U, Nt); Ot < V.length; Ot++) {
          var Ur = B(na, U, Ot, V[Ot], oe);
          Ur !== null && (e && Ur.alternate !== null && na.delete(Ur.key === null ? Ot : Ur.key), Rn = p(Ur, Rn, Ot), Ut === null ? it = Ur : Ut.sibling = Ur, Ut = Ur);
        }
        if (e && na.forEach(function(cf) {
          return t(U, cf);
        }), vr()) {
          var js = Ot;
          Hu(U, js);
        }
        return it;
      }
      function me(U, K, V, oe) {
        var Ce = Bt(V);
        if (typeof Ce != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          V[Symbol.toStringTag] === "Generator" && (y_ || g("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), y_ = !0), V.entries === Ce && (v_ || g("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), v_ = !0);
          var we = Ce.call(V);
          if (we)
            for (var Xe = null, it = we.next(); !it.done; it = we.next()) {
              var Ut = it.value;
              Xe = H(Ut, Xe, U);
            }
        }
        var Nt = Ce.call(V);
        if (Nt == null)
          throw new Error("An iterable object provided no iterator.");
        for (var Rn = null, Ot = null, wn = K, jr = 0, Sr = 0, Ba = null, ta = Nt.next(); wn !== null && !ta.done; Sr++, ta = Nt.next()) {
          wn.index > Sr ? (Ba = wn, wn = null) : Ba = wn.sibling;
          var na = z(U, wn, ta.value, oe);
          if (na === null) {
            wn === null && (wn = Ba);
            break;
          }
          e && wn && na.alternate === null && t(U, wn), jr = p(na, jr, Sr), Ot === null ? Rn = na : Ot.sibling = na, Ot = na, wn = Ba;
        }
        if (ta.done) {
          if (a(U, wn), vr()) {
            var Ur = Sr;
            Hu(U, Ur);
          }
          return Rn;
        }
        if (wn === null) {
          for (; !ta.done; Sr++, ta = Nt.next()) {
            var js = A(U, ta.value, oe);
            js !== null && (jr = p(js, jr, Sr), Ot === null ? Rn = js : Ot.sibling = js, Ot = js);
          }
          if (vr()) {
            var cf = Sr;
            Hu(U, cf);
          }
          return Rn;
        }
        for (var Zh = i(U, wn); !ta.done; Sr++, ta = Nt.next()) {
          var Ii = B(Zh, U, Sr, ta.value, oe);
          Ii !== null && (e && Ii.alternate !== null && Zh.delete(Ii.key === null ? Sr : Ii.key), jr = p(Ii, jr, Sr), Ot === null ? Rn = Ii : Ot.sibling = Ii, Ot = Ii);
        }
        if (e && Zh.forEach(function(PL) {
          return t(U, PL);
        }), vr()) {
          var RL = Sr;
          Hu(U, RL);
        }
        return Rn;
      }
      function Ue(U, K, V, oe) {
        if (K !== null && K.tag === $) {
          a(U, K.sibling);
          var Ce = c(K, V);
          return Ce.return = U, Ce;
        }
        a(U, K);
        var we = gk(V, U.mode, oe);
        return we.return = U, we;
      }
      function Qe(U, K, V, oe) {
        for (var Ce = V.key, we = K; we !== null; ) {
          if (we.key === Ce) {
            var Xe = V.type;
            if (Xe === Qs) {
              if (we.tag === Z) {
                a(U, we.sibling);
                var it = c(we, V.props.children);
                return it.return = U, it._debugSource = V._source, it._debugOwner = V._owner, it;
              }
            } else if (we.elementType === Xe || // Keep this check inline so it only runs on the false path:
            oS(we, V) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof Xe == "object" && Xe !== null && Xe.$$typeof === lr && Xx(Xe) === we.type) {
              a(U, we.sibling);
              var Ut = c(we, V.props);
              return Ut.ref = gh(U, we, V), Ut.return = U, Ut._debugSource = V._source, Ut._debugOwner = V._owner, Ut;
            }
            a(U, we);
            break;
          } else
            t(U, we);
          we = we.sibling;
        }
        if (V.type === Qs) {
          var Nt = $l(V.props.children, U.mode, oe, V.key);
          return Nt.return = U, Nt;
        } else {
          var Rn = mk(V, U.mode, oe);
          return Rn.ref = gh(U, K, V), Rn.return = U, Rn;
        }
      }
      function vt(U, K, V, oe) {
        for (var Ce = V.key, we = K; we !== null; ) {
          if (we.key === Ce)
            if (we.tag === O && we.stateNode.containerInfo === V.containerInfo && we.stateNode.implementation === V.implementation) {
              a(U, we.sibling);
              var Xe = c(we, V.children || []);
              return Xe.return = U, Xe;
            } else {
              a(U, we);
              break;
            }
          else
            t(U, we);
          we = we.sibling;
        }
        var it = vk(V, U.mode, oe);
        return it.return = U, it;
      }
      function ht(U, K, V, oe) {
        var Ce = typeof V == "object" && V !== null && V.type === Qs && V.key === null;
        if (Ce && (V = V.props.children), typeof V == "object" && V !== null) {
          switch (V.$$typeof) {
            case ei:
              return y(Qe(U, K, V, oe));
            case Ta:
              return y(vt(U, K, V, oe));
            case lr:
              var we = V._payload, Xe = V._init;
              return ht(U, K, Xe(we), oe);
          }
          if (Wn(V))
            return Y(U, K, V, oe);
          if (Bt(V))
            return me(U, K, V, oe);
          Sv(U, V);
        }
        return typeof V == "string" && V !== "" || typeof V == "number" ? y(Ue(U, K, "" + V, oe)) : (typeof V == "function" && Ev(U), a(U, K));
      }
      return ht;
    }
    var qd = e0(!0), t0 = e0(!1);
    function aP(e, t) {
      if (e !== null && t.child !== e.child)
        throw new Error("Resuming work not yet implemented.");
      if (t.child !== null) {
        var a = t.child, i = oc(a, a.pendingProps);
        for (t.child = i, i.return = t; a.sibling !== null; )
          a = a.sibling, i = i.sibling = oc(a, a.pendingProps), i.return = t;
        i.sibling = null;
      }
    }
    function oP(e, t) {
      for (var a = e.child; a !== null; )
        HO(a, t), a = a.sibling;
    }
    var k_ = El(null), x_;
    x_ = {};
    var Cv = null, Hd = null, S_ = null, Tv = !1;
    function Rv() {
      Cv = null, Hd = null, S_ = null, Tv = !1;
    }
    function n0() {
      Tv = !0;
    }
    function r0() {
      Tv = !1;
    }
    function a0(e, t, a) {
      Fr(k_, t._currentValue, e), t._currentValue = a, t._currentRenderer !== void 0 && t._currentRenderer !== null && t._currentRenderer !== x_ && g("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), t._currentRenderer = x_;
    }
    function E_(e, t) {
      var a = k_.current;
      Mr(k_, t), e._currentValue = a;
    }
    function C_(e, t, a) {
      for (var i = e; i !== null; ) {
        var c = i.alternate;
        if (ys(i.childLanes, t) ? c !== null && !ys(c.childLanes, t) && (c.childLanes = ct(c.childLanes, t)) : (i.childLanes = ct(i.childLanes, t), c !== null && (c.childLanes = ct(c.childLanes, t))), i === a)
          break;
        i = i.return;
      }
      i !== a && g("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function iP(e, t, a) {
      sP(e, t, a);
    }
    function sP(e, t, a) {
      var i = e.child;
      for (i !== null && (i.return = e); i !== null; ) {
        var c = void 0, p = i.dependencies;
        if (p !== null) {
          c = i.child;
          for (var y = p.firstContext; y !== null; ) {
            if (y.context === t) {
              if (i.tag === E) {
                var _ = Ru(a), w = zs(Wt, _);
                w.tag = Nv;
                var C = i.updateQueue;
                if (C !== null) {
                  var T = C.shared, A = T.pending;
                  A === null ? w.next = w : (w.next = A.next, A.next = w), T.pending = w;
                }
              }
              i.lanes = ct(i.lanes, a);
              var z = i.alternate;
              z !== null && (z.lanes = ct(z.lanes, a)), C_(i.return, a, e), p.lanes = ct(p.lanes, a);
              break;
            }
            y = y.next;
          }
        } else if (i.tag === re)
          c = i.type === e.type ? null : i.child;
        else if (i.tag === st) {
          var B = i.return;
          if (B === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          B.lanes = ct(B.lanes, a);
          var H = B.alternate;
          H !== null && (H.lanes = ct(H.lanes, a)), C_(B, a, e), c = i.sibling;
        } else
          c = i.child;
        if (c !== null)
          c.return = i;
        else
          for (c = i; c !== null; ) {
            if (c === e) {
              c = null;
              break;
            }
            var Y = c.sibling;
            if (Y !== null) {
              Y.return = c.return, c = Y;
              break;
            }
            c = c.return;
          }
        i = c;
      }
    }
    function Zd(e, t) {
      Cv = e, Hd = null, S_ = null;
      var a = e.dependencies;
      if (a !== null) {
        var i = a.firstContext;
        i !== null && (Dr(a.lanes, t) && Oh(), a.firstContext = null);
      }
    }
    function Mn(e) {
      Tv && g("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var t = e._currentValue;
      if (S_ !== e) {
        var a = {
          context: e,
          memoizedValue: t,
          next: null
        };
        if (Hd === null) {
          if (Cv === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          Hd = a, Cv.dependencies = {
            lanes: X,
            firstContext: a
          };
        } else
          Hd = Hd.next = a;
      }
      return t;
    }
    var Gu = null;
    function T_(e) {
      Gu === null ? Gu = [e] : Gu.push(e);
    }
    function lP() {
      if (Gu !== null) {
        for (var e = 0; e < Gu.length; e++) {
          var t = Gu[e], a = t.interleaved;
          if (a !== null) {
            t.interleaved = null;
            var i = a.next, c = t.pending;
            if (c !== null) {
              var p = c.next;
              c.next = i, a.next = p;
            }
            t.pending = a;
          }
        }
        Gu = null;
      }
    }
    function o0(e, t, a, i) {
      var c = t.interleaved;
      return c === null ? (a.next = a, T_(t)) : (a.next = c.next, c.next = a), t.interleaved = a, Pv(e, i);
    }
    function uP(e, t, a, i) {
      var c = t.interleaved;
      c === null ? (a.next = a, T_(t)) : (a.next = c.next, c.next = a), t.interleaved = a;
    }
    function cP(e, t, a, i) {
      var c = t.interleaved;
      return c === null ? (a.next = a, T_(t)) : (a.next = c.next, c.next = a), t.interleaved = a, Pv(e, i);
    }
    function _a(e, t) {
      return Pv(e, t);
    }
    var dP = Pv;
    function Pv(e, t) {
      e.lanes = ct(e.lanes, t);
      var a = e.alternate;
      a !== null && (a.lanes = ct(a.lanes, t)), a === null && (e.flags & (sn | fa)) !== We && tS(e);
      for (var i = e, c = e.return; c !== null; )
        c.childLanes = ct(c.childLanes, t), a = c.alternate, a !== null ? a.childLanes = ct(a.childLanes, t) : (c.flags & (sn | fa)) !== We && tS(e), i = c, c = c.return;
      if (i.tag === P) {
        var p = i.stateNode;
        return p;
      } else
        return null;
    }
    var i0 = 0, s0 = 1, Nv = 2, R_ = 3, Ov = !1, P_, Lv;
    P_ = !1, Lv = null;
    function N_(e) {
      var t = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: X
        },
        effects: null
      };
      e.updateQueue = t;
    }
    function l0(e, t) {
      var a = t.updateQueue, i = e.updateQueue;
      if (a === i) {
        var c = {
          baseState: i.baseState,
          firstBaseUpdate: i.firstBaseUpdate,
          lastBaseUpdate: i.lastBaseUpdate,
          shared: i.shared,
          effects: i.effects
        };
        t.updateQueue = c;
      }
    }
    function zs(e, t) {
      var a = {
        eventTime: e,
        lane: t,
        tag: i0,
        payload: null,
        callback: null,
        next: null
      };
      return a;
    }
    function Pl(e, t, a) {
      var i = e.updateQueue;
      if (i === null)
        return null;
      var c = i.shared;
      if (Lv === c && !P_ && (g("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), P_ = !0), uO()) {
        var p = c.pending;
        return p === null ? t.next = t : (t.next = p.next, p.next = t), c.pending = t, dP(e, a);
      } else
        return cP(e, c, t, a);
    }
    function Dv(e, t, a) {
      var i = t.updateQueue;
      if (i !== null) {
        var c = i.shared;
        if (Pp(a)) {
          var p = c.lanes;
          p = Op(p, e.pendingLanes);
          var y = ct(p, a);
          c.lanes = y, Nu(e, y);
        }
      }
    }
    function O_(e, t) {
      var a = e.updateQueue, i = e.alternate;
      if (i !== null) {
        var c = i.updateQueue;
        if (a === c) {
          var p = null, y = null, _ = a.firstBaseUpdate;
          if (_ !== null) {
            var w = _;
            do {
              var C = {
                eventTime: w.eventTime,
                lane: w.lane,
                tag: w.tag,
                payload: w.payload,
                callback: w.callback,
                next: null
              };
              y === null ? p = y = C : (y.next = C, y = C), w = w.next;
            } while (w !== null);
            y === null ? p = y = t : (y.next = t, y = t);
          } else
            p = y = t;
          a = {
            baseState: c.baseState,
            firstBaseUpdate: p,
            lastBaseUpdate: y,
            shared: c.shared,
            effects: c.effects
          }, e.updateQueue = a;
          return;
        }
      }
      var T = a.lastBaseUpdate;
      T === null ? a.firstBaseUpdate = t : T.next = t, a.lastBaseUpdate = t;
    }
    function fP(e, t, a, i, c, p) {
      switch (a.tag) {
        case s0: {
          var y = a.payload;
          if (typeof y == "function") {
            n0();
            var _ = y.call(p, i, c);
            {
              if (e.mode & $t) {
                Jt(!0);
                try {
                  y.call(p, i, c);
                } finally {
                  Jt(!1);
                }
              }
              r0();
            }
            return _;
          }
          return y;
        }
        case R_:
          e.flags = e.flags & -65537 | Be;
        // Intentional fallthrough
        case i0: {
          var w = a.payload, C;
          if (typeof w == "function") {
            n0(), C = w.call(p, i, c);
            {
              if (e.mode & $t) {
                Jt(!0);
                try {
                  w.call(p, i, c);
                } finally {
                  Jt(!1);
                }
              }
              r0();
            }
          } else
            C = w;
          return C == null ? i : bt({}, i, C);
        }
        case Nv:
          return Ov = !0, i;
      }
      return i;
    }
    function zv(e, t, a, i) {
      var c = e.updateQueue;
      Ov = !1, Lv = c.shared;
      var p = c.firstBaseUpdate, y = c.lastBaseUpdate, _ = c.shared.pending;
      if (_ !== null) {
        c.shared.pending = null;
        var w = _, C = w.next;
        w.next = null, y === null ? p = C : y.next = C, y = w;
        var T = e.alternate;
        if (T !== null) {
          var A = T.updateQueue, z = A.lastBaseUpdate;
          z !== y && (z === null ? A.firstBaseUpdate = C : z.next = C, A.lastBaseUpdate = w);
        }
      }
      if (p !== null) {
        var B = c.baseState, H = X, Y = null, me = null, Ue = null, Qe = p;
        do {
          var vt = Qe.lane, ht = Qe.eventTime;
          if (ys(i, vt)) {
            if (Ue !== null) {
              var U = {
                eventTime: ht,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Et,
                tag: Qe.tag,
                payload: Qe.payload,
                callback: Qe.callback,
                next: null
              };
              Ue = Ue.next = U;
            }
            B = fP(e, c, Qe, B, t, a);
            var K = Qe.callback;
            if (K !== null && // If the update was already committed, we should not queue its
            // callback again.
            Qe.lane !== Et) {
              e.flags |= Ht;
              var V = c.effects;
              V === null ? c.effects = [Qe] : V.push(Qe);
            }
          } else {
            var oe = {
              eventTime: ht,
              lane: vt,
              tag: Qe.tag,
              payload: Qe.payload,
              callback: Qe.callback,
              next: null
            };
            Ue === null ? (me = Ue = oe, Y = B) : Ue = Ue.next = oe, H = ct(H, vt);
          }
          if (Qe = Qe.next, Qe === null) {
            if (_ = c.shared.pending, _ === null)
              break;
            var Ce = _, we = Ce.next;
            Ce.next = null, Qe = we, c.lastBaseUpdate = Ce, c.shared.pending = null;
          }
        } while (!0);
        Ue === null && (Y = B), c.baseState = Y, c.firstBaseUpdate = me, c.lastBaseUpdate = Ue;
        var Xe = c.shared.interleaved;
        if (Xe !== null) {
          var it = Xe;
          do
            H = ct(H, it.lane), it = it.next;
          while (it !== Xe);
        } else p === null && (c.shared.lanes = X);
        Vh(H), e.lanes = H, e.memoizedState = B;
      }
      Lv = null;
    }
    function pP(e, t) {
      if (typeof e != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + e));
      e.call(t);
    }
    function u0() {
      Ov = !1;
    }
    function Iv() {
      return Ov;
    }
    function c0(e, t, a) {
      var i = t.effects;
      if (t.effects = null, i !== null)
        for (var c = 0; c < i.length; c++) {
          var p = i[c], y = p.callback;
          y !== null && (p.callback = null, pP(y, a));
        }
    }
    var vh = {}, Nl = El(vh), yh = El(vh), Av = El(vh);
    function Mv(e) {
      if (e === vh)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return e;
    }
    function d0() {
      var e = Mv(Av.current);
      return e;
    }
    function L_(e, t) {
      Fr(Av, t, e), Fr(yh, e, e), Fr(Nl, vh, e);
      var a = NT(t);
      Mr(Nl, e), Fr(Nl, a, e);
    }
    function Qd(e) {
      Mr(Nl, e), Mr(yh, e), Mr(Av, e);
    }
    function D_() {
      var e = Mv(Nl.current);
      return e;
    }
    function f0(e) {
      Mv(Av.current);
      var t = Mv(Nl.current), a = OT(t, e.type);
      t !== a && (Fr(yh, e, e), Fr(Nl, a, e));
    }
    function z_(e) {
      yh.current === e && (Mr(Nl, e), Mr(yh, e));
    }
    var hP = 0, p0 = 1, h0 = 1, bh = 2, jo = El(hP);
    function I_(e, t) {
      return (e & t) !== 0;
    }
    function Kd(e) {
      return e & p0;
    }
    function A_(e, t) {
      return e & p0 | t;
    }
    function mP(e, t) {
      return e | t;
    }
    function Ol(e, t) {
      Fr(jo, t, e);
    }
    function Yd(e) {
      Mr(jo, e);
    }
    function gP(e, t) {
      var a = e.memoizedState;
      return a !== null ? a.dehydrated !== null : (e.memoizedProps, !0);
    }
    function Fv(e) {
      for (var t = e; t !== null; ) {
        if (t.tag === Re) {
          var a = t.memoizedState;
          if (a !== null) {
            var i = a.dehydrated;
            if (i === null || Ox(i) || e_(i))
              return t;
          }
        } else if (t.tag === Ie && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        t.memoizedProps.revealOrder !== void 0) {
          var c = (t.flags & Be) !== We;
          if (c)
            return t;
        } else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e)
          return null;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            return null;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return null;
    }
    var wa = (
      /*   */
      0
    ), Yn = (
      /* */
      1
    ), Ri = (
      /*  */
      2
    ), Gn = (
      /*    */
      4
    ), yr = (
      /*   */
      8
    ), M_ = [];
    function F_() {
      for (var e = 0; e < M_.length; e++) {
        var t = M_[e];
        t._workInProgressVersionPrimary = null;
      }
      M_.length = 0;
    }
    function vP(e, t) {
      var a = t._getVersion, i = a(t._source);
      e.mutableSourceEagerHydrationData == null ? e.mutableSourceEagerHydrationData = [t, i] : e.mutableSourceEagerHydrationData.push(t, i);
    }
    var Ee = s.ReactCurrentDispatcher, _h = s.ReactCurrentBatchConfig, $_, Gd;
    $_ = /* @__PURE__ */ new Set();
    var Ju = X, jt = null, Jn = null, Xn = null, $v = !1, wh = !1, kh = 0, yP = 0, bP = 25, J = null, co = null, Ll = -1, j_ = !1;
    function zt() {
      {
        var e = J;
        co === null ? co = [e] : co.push(e);
      }
    }
    function he() {
      {
        var e = J;
        co !== null && (Ll++, co[Ll] !== e && _P(e));
      }
    }
    function Jd(e) {
      e != null && !Wn(e) && g("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", J, typeof e);
    }
    function _P(e) {
      {
        var t = ut(jt);
        if (!$_.has(t) && ($_.add(t), co !== null)) {
          for (var a = "", i = 30, c = 0; c <= Ll; c++) {
            for (var p = co[c], y = c === Ll ? e : p, _ = c + 1 + ". " + p; _.length < i; )
              _ += " ";
            _ += y + `
`, a += _;
          }
          g(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, t, a);
        }
      }
    }
    function $r() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function U_(e, t) {
      if (j_)
        return !1;
      if (t === null)
        return g("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", J), !1;
      e.length !== t.length && g(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, J, "[" + t.join(", ") + "]", "[" + e.join(", ") + "]");
      for (var a = 0; a < t.length && a < e.length; a++)
        if (!F(e[a], t[a]))
          return !1;
      return !0;
    }
    function Xd(e, t, a, i, c, p) {
      Ju = p, jt = t, co = e !== null ? e._debugHookTypes : null, Ll = -1, j_ = e !== null && e.type !== t.type, t.memoizedState = null, t.updateQueue = null, t.lanes = X, e !== null && e.memoizedState !== null ? Ee.current = A0 : co !== null ? Ee.current = I0 : Ee.current = z0;
      var y = a(i, c);
      if (wh) {
        var _ = 0;
        do {
          if (wh = !1, kh = 0, _ >= bP)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          _ += 1, j_ = !1, Jn = null, Xn = null, t.updateQueue = null, Ll = -1, Ee.current = M0, y = a(i, c);
        } while (wh);
      }
      Ee.current = Jv, t._debugHookTypes = co;
      var w = Jn !== null && Jn.next !== null;
      if (Ju = X, jt = null, Jn = null, Xn = null, J = null, co = null, Ll = -1, e !== null && (e.flags & vn) !== (t.flags & vn) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (e.mode & pt) !== He && g("Internal React error: Expected static flag was missing. Please notify the React team."), $v = !1, w)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return y;
    }
    function ef() {
      var e = kh !== 0;
      return kh = 0, e;
    }
    function m0(e, t, a) {
      t.updateQueue = e.updateQueue, (t.mode & Rt) !== He ? t.flags &= -50333701 : t.flags &= -2053, e.lanes = Pu(e.lanes, a);
    }
    function g0() {
      if (Ee.current = Jv, $v) {
        for (var e = jt.memoizedState; e !== null; ) {
          var t = e.queue;
          t !== null && (t.pending = null), e = e.next;
        }
        $v = !1;
      }
      Ju = X, jt = null, Jn = null, Xn = null, co = null, Ll = -1, J = null, P0 = !1, wh = !1, kh = 0;
    }
    function Pi() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Xn === null ? jt.memoizedState = Xn = e : Xn = Xn.next = e, Xn;
    }
    function fo() {
      var e;
      if (Jn === null) {
        var t = jt.alternate;
        t !== null ? e = t.memoizedState : e = null;
      } else
        e = Jn.next;
      var a;
      if (Xn === null ? a = jt.memoizedState : a = Xn.next, a !== null)
        Xn = a, a = Xn.next, Jn = e;
      else {
        if (e === null)
          throw new Error("Rendered more hooks than during the previous render.");
        Jn = e;
        var i = {
          memoizedState: Jn.memoizedState,
          baseState: Jn.baseState,
          baseQueue: Jn.baseQueue,
          queue: Jn.queue,
          next: null
        };
        Xn === null ? jt.memoizedState = Xn = i : Xn = Xn.next = i;
      }
      return Xn;
    }
    function v0() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function V_(e, t) {
      return typeof t == "function" ? t(e) : t;
    }
    function B_(e, t, a) {
      var i = Pi(), c;
      a !== void 0 ? c = a(t) : c = t, i.memoizedState = i.baseState = c;
      var p = {
        pending: null,
        interleaved: null,
        lanes: X,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: c
      };
      i.queue = p;
      var y = p.dispatch = SP.bind(null, jt, p);
      return [i.memoizedState, y];
    }
    function W_(e, t, a) {
      var i = fo(), c = i.queue;
      if (c === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      c.lastRenderedReducer = e;
      var p = Jn, y = p.baseQueue, _ = c.pending;
      if (_ !== null) {
        if (y !== null) {
          var w = y.next, C = _.next;
          y.next = C, _.next = w;
        }
        p.baseQueue !== y && g("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), p.baseQueue = y = _, c.pending = null;
      }
      if (y !== null) {
        var T = y.next, A = p.baseState, z = null, B = null, H = null, Y = T;
        do {
          var me = Y.lane;
          if (ys(Ju, me)) {
            if (H !== null) {
              var Ue = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Et,
                action: Y.action,
                hasEagerState: Y.hasEagerState,
                eagerState: Y.eagerState,
                next: null
              };
              H = H.next = Ue;
            }
            if (Y.hasEagerState)
              A = Y.eagerState;
            else {
              var Qe = Y.action;
              A = e(A, Qe);
            }
          } else {
            var vt = {
              lane: me,
              action: Y.action,
              hasEagerState: Y.hasEagerState,
              eagerState: Y.eagerState,
              next: null
            };
            H === null ? (B = H = vt, z = A) : H = H.next = vt, jt.lanes = ct(jt.lanes, me), Vh(me);
          }
          Y = Y.next;
        } while (Y !== null && Y !== T);
        H === null ? z = A : H.next = B, F(A, i.memoizedState) || Oh(), i.memoizedState = A, i.baseState = z, i.baseQueue = H, c.lastRenderedState = A;
      }
      var ht = c.interleaved;
      if (ht !== null) {
        var U = ht;
        do {
          var K = U.lane;
          jt.lanes = ct(jt.lanes, K), Vh(K), U = U.next;
        } while (U !== ht);
      } else y === null && (c.lanes = X);
      var V = c.dispatch;
      return [i.memoizedState, V];
    }
    function q_(e, t, a) {
      var i = fo(), c = i.queue;
      if (c === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      c.lastRenderedReducer = e;
      var p = c.dispatch, y = c.pending, _ = i.memoizedState;
      if (y !== null) {
        c.pending = null;
        var w = y.next, C = w;
        do {
          var T = C.action;
          _ = e(_, T), C = C.next;
        } while (C !== w);
        F(_, i.memoizedState) || Oh(), i.memoizedState = _, i.baseQueue === null && (i.baseState = _), c.lastRenderedState = _;
      }
      return [_, p];
    }
    function H_(e, t, a) {
      var i = jt, c = Pi(), p, y = vr();
      if (y) {
        if (a === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        p = a(), Gd || p !== a() && (g("The result of getServerSnapshot should be cached to avoid an infinite loop"), Gd = !0);
      } else {
        if (p = t(), !Gd) {
          var _ = t();
          F(p, _) || (g("The result of getSnapshot should be cached to avoid an infinite loop"), Gd = !0);
        }
        var w = yy();
        if (w === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        md(w, Ju) || y0(i, t, p);
      }
      c.memoizedState = p;
      var C = {
        value: p,
        getSnapshot: t
      };
      return c.queue = C, Wv(_0.bind(null, i, C, e), [e]), i.flags |= Rr, xh(Yn | yr, b0.bind(null, i, C, p, t), void 0, null), p;
    }
    function jv(e, t, a) {
      var i = jt, c = fo(), p = t();
      if (!Gd) {
        var y = t();
        F(p, y) || (g("The result of getSnapshot should be cached to avoid an infinite loop"), Gd = !0);
      }
      var _ = c.memoizedState, w = !F(_, p);
      w && (c.memoizedState = p, Oh());
      var C = c.queue;
      if (Eh(_0.bind(null, i, C, e), [e]), C.getSnapshot !== t || w || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Xn !== null && Xn.memoizedState.tag & Yn) {
        i.flags |= Rr, xh(Yn | yr, b0.bind(null, i, C, p, t), void 0, null);
        var T = yy();
        if (T === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        md(T, Ju) || y0(i, t, p);
      }
      return p;
    }
    function y0(e, t, a) {
      e.flags |= dl;
      var i = {
        getSnapshot: t,
        value: a
      }, c = jt.updateQueue;
      if (c === null)
        c = v0(), jt.updateQueue = c, c.stores = [i];
      else {
        var p = c.stores;
        p === null ? c.stores = [i] : p.push(i);
      }
    }
    function b0(e, t, a, i) {
      t.value = a, t.getSnapshot = i, w0(t) && k0(e);
    }
    function _0(e, t, a) {
      var i = function() {
        w0(t) && k0(e);
      };
      return a(i);
    }
    function w0(e) {
      var t = e.getSnapshot, a = e.value;
      try {
        var i = t();
        return !F(a, i);
      } catch {
        return !0;
      }
    }
    function k0(e) {
      var t = _a(e, Je);
      t !== null && rr(t, e, Je, Wt);
    }
    function Uv(e) {
      var t = Pi();
      typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e;
      var a = {
        pending: null,
        interleaved: null,
        lanes: X,
        dispatch: null,
        lastRenderedReducer: V_,
        lastRenderedState: e
      };
      t.queue = a;
      var i = a.dispatch = EP.bind(null, jt, a);
      return [t.memoizedState, i];
    }
    function Z_(e) {
      return W_(V_);
    }
    function Q_(e) {
      return q_(V_);
    }
    function xh(e, t, a, i) {
      var c = {
        tag: e,
        create: t,
        destroy: a,
        deps: i,
        // Circular
        next: null
      }, p = jt.updateQueue;
      if (p === null)
        p = v0(), jt.updateQueue = p, p.lastEffect = c.next = c;
      else {
        var y = p.lastEffect;
        if (y === null)
          p.lastEffect = c.next = c;
        else {
          var _ = y.next;
          y.next = c, c.next = _, p.lastEffect = c;
        }
      }
      return c;
    }
    function K_(e) {
      var t = Pi();
      {
        var a = {
          current: e
        };
        return t.memoizedState = a, a;
      }
    }
    function Vv(e) {
      var t = fo();
      return t.memoizedState;
    }
    function Sh(e, t, a, i) {
      var c = Pi(), p = i === void 0 ? null : i;
      jt.flags |= e, c.memoizedState = xh(Yn | t, a, void 0, p);
    }
    function Bv(e, t, a, i) {
      var c = fo(), p = i === void 0 ? null : i, y = void 0;
      if (Jn !== null) {
        var _ = Jn.memoizedState;
        if (y = _.destroy, p !== null) {
          var w = _.deps;
          if (U_(p, w)) {
            c.memoizedState = xh(t, a, y, p);
            return;
          }
        }
      }
      jt.flags |= e, c.memoizedState = xh(Yn | t, a, y, p);
    }
    function Wv(e, t) {
      return (jt.mode & Rt) !== He ? Sh(Xa | Rr | Vc, yr, e, t) : Sh(Rr | Vc, yr, e, t);
    }
    function Eh(e, t) {
      return Bv(Rr, yr, e, t);
    }
    function Y_(e, t) {
      return Sh(wt, Ri, e, t);
    }
    function qv(e, t) {
      return Bv(wt, Ri, e, t);
    }
    function G_(e, t) {
      var a = wt;
      return a |= So, (jt.mode & Rt) !== He && (a |= li), Sh(a, Gn, e, t);
    }
    function Hv(e, t) {
      return Bv(wt, Gn, e, t);
    }
    function x0(e, t) {
      if (typeof t == "function") {
        var a = t, i = e();
        return a(i), function() {
          a(null);
        };
      } else if (t != null) {
        var c = t;
        c.hasOwnProperty("current") || g("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(c).join(", ") + "}");
        var p = e();
        return c.current = p, function() {
          c.current = null;
        };
      }
    }
    function J_(e, t, a) {
      typeof t != "function" && g("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
      var i = a != null ? a.concat([e]) : null, c = wt;
      return c |= So, (jt.mode & Rt) !== He && (c |= li), Sh(c, Gn, x0.bind(null, t, e), i);
    }
    function Zv(e, t, a) {
      typeof t != "function" && g("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
      var i = a != null ? a.concat([e]) : null;
      return Bv(wt, Gn, x0.bind(null, t, e), i);
    }
    function wP(e, t) {
    }
    var Qv = wP;
    function X_(e, t) {
      var a = Pi(), i = t === void 0 ? null : t;
      return a.memoizedState = [e, i], e;
    }
    function Kv(e, t) {
      var a = fo(), i = t === void 0 ? null : t, c = a.memoizedState;
      if (c !== null && i !== null) {
        var p = c[1];
        if (U_(i, p))
          return c[0];
      }
      return a.memoizedState = [e, i], e;
    }
    function ew(e, t) {
      var a = Pi(), i = t === void 0 ? null : t, c = e();
      return a.memoizedState = [c, i], c;
    }
    function Yv(e, t) {
      var a = fo(), i = t === void 0 ? null : t, c = a.memoizedState;
      if (c !== null && i !== null) {
        var p = c[1];
        if (U_(i, p))
          return c[0];
      }
      var y = e();
      return a.memoizedState = [y, i], y;
    }
    function tw(e) {
      var t = Pi();
      return t.memoizedState = e, e;
    }
    function S0(e) {
      var t = fo(), a = Jn, i = a.memoizedState;
      return C0(t, i, e);
    }
    function E0(e) {
      var t = fo();
      if (Jn === null)
        return t.memoizedState = e, e;
      var a = Jn.memoizedState;
      return C0(t, a, e);
    }
    function C0(e, t, a) {
      var i = !Tp(Ju);
      if (i) {
        if (!F(a, t)) {
          var c = Np();
          jt.lanes = ct(jt.lanes, c), Vh(c), e.baseState = !0;
        }
        return t;
      } else
        return e.baseState && (e.baseState = !1, Oh()), e.memoizedState = a, a;
    }
    function kP(e, t, a) {
      var i = Ma();
      Cn(xg(i, Aa)), e(!0);
      var c = _h.transition;
      _h.transition = {};
      var p = _h.transition;
      _h.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        e(!1), t();
      } finally {
        if (Cn(i), _h.transition = c, c === null && p._updatedFibers) {
          var y = p._updatedFibers.size;
          y > 10 && m("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), p._updatedFibers.clear();
        }
      }
    }
    function nw() {
      var e = Uv(!1), t = e[0], a = e[1], i = kP.bind(null, a), c = Pi();
      return c.memoizedState = i, [t, i];
    }
    function T0() {
      var e = Z_(), t = e[0], a = fo(), i = a.memoizedState;
      return [t, i];
    }
    function R0() {
      var e = Q_(), t = e[0], a = fo(), i = a.memoizedState;
      return [t, i];
    }
    var P0 = !1;
    function xP() {
      return P0;
    }
    function rw() {
      var e = Pi(), t = yy(), a = t.identifierPrefix, i;
      if (vr()) {
        var c = jR();
        i = ":" + a + "R" + c;
        var p = kh++;
        p > 0 && (i += "H" + p.toString(32)), i += ":";
      } else {
        var y = yP++;
        i = ":" + a + "r" + y.toString(32) + ":";
      }
      return e.memoizedState = i, i;
    }
    function Gv() {
      var e = fo(), t = e.memoizedState;
      return t;
    }
    function SP(e, t, a) {
      typeof arguments[3] == "function" && g("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var i = Ml(e), c = {
        lane: i,
        action: a,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (N0(e))
        O0(t, c);
      else {
        var p = o0(e, t, c, i);
        if (p !== null) {
          var y = ea();
          rr(p, e, i, y), L0(p, t, i);
        }
      }
      D0(e, i);
    }
    function EP(e, t, a) {
      typeof arguments[3] == "function" && g("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var i = Ml(e), c = {
        lane: i,
        action: a,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (N0(e))
        O0(t, c);
      else {
        var p = e.alternate;
        if (e.lanes === X && (p === null || p.lanes === X)) {
          var y = t.lastRenderedReducer;
          if (y !== null) {
            var _;
            _ = Ee.current, Ee.current = Uo;
            try {
              var w = t.lastRenderedState, C = y(w, a);
              if (c.hasEagerState = !0, c.eagerState = C, F(C, w)) {
                uP(e, t, c, i);
                return;
              }
            } catch {
            } finally {
              Ee.current = _;
            }
          }
        }
        var T = o0(e, t, c, i);
        if (T !== null) {
          var A = ea();
          rr(T, e, i, A), L0(T, t, i);
        }
      }
      D0(e, i);
    }
    function N0(e) {
      var t = e.alternate;
      return e === jt || t !== null && t === jt;
    }
    function O0(e, t) {
      wh = $v = !0;
      var a = e.pending;
      a === null ? t.next = t : (t.next = a.next, a.next = t), e.pending = t;
    }
    function L0(e, t, a) {
      if (Pp(a)) {
        var i = t.lanes;
        i = Op(i, e.pendingLanes);
        var c = ct(i, a);
        t.lanes = c, Nu(e, c);
      }
    }
    function D0(e, t, a) {
      bu(e, t);
    }
    var Jv = {
      readContext: Mn,
      useCallback: $r,
      useContext: $r,
      useEffect: $r,
      useImperativeHandle: $r,
      useInsertionEffect: $r,
      useLayoutEffect: $r,
      useMemo: $r,
      useReducer: $r,
      useRef: $r,
      useState: $r,
      useDebugValue: $r,
      useDeferredValue: $r,
      useTransition: $r,
      useMutableSource: $r,
      useSyncExternalStore: $r,
      useId: $r,
      unstable_isNewReconciler: ue
    }, z0 = null, I0 = null, A0 = null, M0 = null, Ni = null, Uo = null, Xv = null;
    {
      var aw = function() {
        g("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, at = function() {
        g("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      z0 = {
        readContext: function(e) {
          return Mn(e);
        },
        useCallback: function(e, t) {
          return J = "useCallback", zt(), Jd(t), X_(e, t);
        },
        useContext: function(e) {
          return J = "useContext", zt(), Mn(e);
        },
        useEffect: function(e, t) {
          return J = "useEffect", zt(), Jd(t), Wv(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return J = "useImperativeHandle", zt(), Jd(a), J_(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return J = "useInsertionEffect", zt(), Jd(t), Y_(e, t);
        },
        useLayoutEffect: function(e, t) {
          return J = "useLayoutEffect", zt(), Jd(t), G_(e, t);
        },
        useMemo: function(e, t) {
          J = "useMemo", zt(), Jd(t);
          var a = Ee.current;
          Ee.current = Ni;
          try {
            return ew(e, t);
          } finally {
            Ee.current = a;
          }
        },
        useReducer: function(e, t, a) {
          J = "useReducer", zt();
          var i = Ee.current;
          Ee.current = Ni;
          try {
            return B_(e, t, a);
          } finally {
            Ee.current = i;
          }
        },
        useRef: function(e) {
          return J = "useRef", zt(), K_(e);
        },
        useState: function(e) {
          J = "useState", zt();
          var t = Ee.current;
          Ee.current = Ni;
          try {
            return Uv(e);
          } finally {
            Ee.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return J = "useDebugValue", zt(), void 0;
        },
        useDeferredValue: function(e) {
          return J = "useDeferredValue", zt(), tw(e);
        },
        useTransition: function() {
          return J = "useTransition", zt(), nw();
        },
        useMutableSource: function(e, t, a) {
          return J = "useMutableSource", zt(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return J = "useSyncExternalStore", zt(), H_(e, t, a);
        },
        useId: function() {
          return J = "useId", zt(), rw();
        },
        unstable_isNewReconciler: ue
      }, I0 = {
        readContext: function(e) {
          return Mn(e);
        },
        useCallback: function(e, t) {
          return J = "useCallback", he(), X_(e, t);
        },
        useContext: function(e) {
          return J = "useContext", he(), Mn(e);
        },
        useEffect: function(e, t) {
          return J = "useEffect", he(), Wv(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return J = "useImperativeHandle", he(), J_(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return J = "useInsertionEffect", he(), Y_(e, t);
        },
        useLayoutEffect: function(e, t) {
          return J = "useLayoutEffect", he(), G_(e, t);
        },
        useMemo: function(e, t) {
          J = "useMemo", he();
          var a = Ee.current;
          Ee.current = Ni;
          try {
            return ew(e, t);
          } finally {
            Ee.current = a;
          }
        },
        useReducer: function(e, t, a) {
          J = "useReducer", he();
          var i = Ee.current;
          Ee.current = Ni;
          try {
            return B_(e, t, a);
          } finally {
            Ee.current = i;
          }
        },
        useRef: function(e) {
          return J = "useRef", he(), K_(e);
        },
        useState: function(e) {
          J = "useState", he();
          var t = Ee.current;
          Ee.current = Ni;
          try {
            return Uv(e);
          } finally {
            Ee.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return J = "useDebugValue", he(), void 0;
        },
        useDeferredValue: function(e) {
          return J = "useDeferredValue", he(), tw(e);
        },
        useTransition: function() {
          return J = "useTransition", he(), nw();
        },
        useMutableSource: function(e, t, a) {
          return J = "useMutableSource", he(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return J = "useSyncExternalStore", he(), H_(e, t, a);
        },
        useId: function() {
          return J = "useId", he(), rw();
        },
        unstable_isNewReconciler: ue
      }, A0 = {
        readContext: function(e) {
          return Mn(e);
        },
        useCallback: function(e, t) {
          return J = "useCallback", he(), Kv(e, t);
        },
        useContext: function(e) {
          return J = "useContext", he(), Mn(e);
        },
        useEffect: function(e, t) {
          return J = "useEffect", he(), Eh(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return J = "useImperativeHandle", he(), Zv(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return J = "useInsertionEffect", he(), qv(e, t);
        },
        useLayoutEffect: function(e, t) {
          return J = "useLayoutEffect", he(), Hv(e, t);
        },
        useMemo: function(e, t) {
          J = "useMemo", he();
          var a = Ee.current;
          Ee.current = Uo;
          try {
            return Yv(e, t);
          } finally {
            Ee.current = a;
          }
        },
        useReducer: function(e, t, a) {
          J = "useReducer", he();
          var i = Ee.current;
          Ee.current = Uo;
          try {
            return W_(e, t, a);
          } finally {
            Ee.current = i;
          }
        },
        useRef: function(e) {
          return J = "useRef", he(), Vv();
        },
        useState: function(e) {
          J = "useState", he();
          var t = Ee.current;
          Ee.current = Uo;
          try {
            return Z_(e);
          } finally {
            Ee.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return J = "useDebugValue", he(), Qv();
        },
        useDeferredValue: function(e) {
          return J = "useDeferredValue", he(), S0(e);
        },
        useTransition: function() {
          return J = "useTransition", he(), T0();
        },
        useMutableSource: function(e, t, a) {
          return J = "useMutableSource", he(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return J = "useSyncExternalStore", he(), jv(e, t);
        },
        useId: function() {
          return J = "useId", he(), Gv();
        },
        unstable_isNewReconciler: ue
      }, M0 = {
        readContext: function(e) {
          return Mn(e);
        },
        useCallback: function(e, t) {
          return J = "useCallback", he(), Kv(e, t);
        },
        useContext: function(e) {
          return J = "useContext", he(), Mn(e);
        },
        useEffect: function(e, t) {
          return J = "useEffect", he(), Eh(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return J = "useImperativeHandle", he(), Zv(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return J = "useInsertionEffect", he(), qv(e, t);
        },
        useLayoutEffect: function(e, t) {
          return J = "useLayoutEffect", he(), Hv(e, t);
        },
        useMemo: function(e, t) {
          J = "useMemo", he();
          var a = Ee.current;
          Ee.current = Xv;
          try {
            return Yv(e, t);
          } finally {
            Ee.current = a;
          }
        },
        useReducer: function(e, t, a) {
          J = "useReducer", he();
          var i = Ee.current;
          Ee.current = Xv;
          try {
            return q_(e, t, a);
          } finally {
            Ee.current = i;
          }
        },
        useRef: function(e) {
          return J = "useRef", he(), Vv();
        },
        useState: function(e) {
          J = "useState", he();
          var t = Ee.current;
          Ee.current = Xv;
          try {
            return Q_(e);
          } finally {
            Ee.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return J = "useDebugValue", he(), Qv();
        },
        useDeferredValue: function(e) {
          return J = "useDeferredValue", he(), E0(e);
        },
        useTransition: function() {
          return J = "useTransition", he(), R0();
        },
        useMutableSource: function(e, t, a) {
          return J = "useMutableSource", he(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return J = "useSyncExternalStore", he(), jv(e, t);
        },
        useId: function() {
          return J = "useId", he(), Gv();
        },
        unstable_isNewReconciler: ue
      }, Ni = {
        readContext: function(e) {
          return aw(), Mn(e);
        },
        useCallback: function(e, t) {
          return J = "useCallback", at(), zt(), X_(e, t);
        },
        useContext: function(e) {
          return J = "useContext", at(), zt(), Mn(e);
        },
        useEffect: function(e, t) {
          return J = "useEffect", at(), zt(), Wv(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return J = "useImperativeHandle", at(), zt(), J_(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return J = "useInsertionEffect", at(), zt(), Y_(e, t);
        },
        useLayoutEffect: function(e, t) {
          return J = "useLayoutEffect", at(), zt(), G_(e, t);
        },
        useMemo: function(e, t) {
          J = "useMemo", at(), zt();
          var a = Ee.current;
          Ee.current = Ni;
          try {
            return ew(e, t);
          } finally {
            Ee.current = a;
          }
        },
        useReducer: function(e, t, a) {
          J = "useReducer", at(), zt();
          var i = Ee.current;
          Ee.current = Ni;
          try {
            return B_(e, t, a);
          } finally {
            Ee.current = i;
          }
        },
        useRef: function(e) {
          return J = "useRef", at(), zt(), K_(e);
        },
        useState: function(e) {
          J = "useState", at(), zt();
          var t = Ee.current;
          Ee.current = Ni;
          try {
            return Uv(e);
          } finally {
            Ee.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return J = "useDebugValue", at(), zt(), void 0;
        },
        useDeferredValue: function(e) {
          return J = "useDeferredValue", at(), zt(), tw(e);
        },
        useTransition: function() {
          return J = "useTransition", at(), zt(), nw();
        },
        useMutableSource: function(e, t, a) {
          return J = "useMutableSource", at(), zt(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return J = "useSyncExternalStore", at(), zt(), H_(e, t, a);
        },
        useId: function() {
          return J = "useId", at(), zt(), rw();
        },
        unstable_isNewReconciler: ue
      }, Uo = {
        readContext: function(e) {
          return aw(), Mn(e);
        },
        useCallback: function(e, t) {
          return J = "useCallback", at(), he(), Kv(e, t);
        },
        useContext: function(e) {
          return J = "useContext", at(), he(), Mn(e);
        },
        useEffect: function(e, t) {
          return J = "useEffect", at(), he(), Eh(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return J = "useImperativeHandle", at(), he(), Zv(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return J = "useInsertionEffect", at(), he(), qv(e, t);
        },
        useLayoutEffect: function(e, t) {
          return J = "useLayoutEffect", at(), he(), Hv(e, t);
        },
        useMemo: function(e, t) {
          J = "useMemo", at(), he();
          var a = Ee.current;
          Ee.current = Uo;
          try {
            return Yv(e, t);
          } finally {
            Ee.current = a;
          }
        },
        useReducer: function(e, t, a) {
          J = "useReducer", at(), he();
          var i = Ee.current;
          Ee.current = Uo;
          try {
            return W_(e, t, a);
          } finally {
            Ee.current = i;
          }
        },
        useRef: function(e) {
          return J = "useRef", at(), he(), Vv();
        },
        useState: function(e) {
          J = "useState", at(), he();
          var t = Ee.current;
          Ee.current = Uo;
          try {
            return Z_(e);
          } finally {
            Ee.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return J = "useDebugValue", at(), he(), Qv();
        },
        useDeferredValue: function(e) {
          return J = "useDeferredValue", at(), he(), S0(e);
        },
        useTransition: function() {
          return J = "useTransition", at(), he(), T0();
        },
        useMutableSource: function(e, t, a) {
          return J = "useMutableSource", at(), he(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return J = "useSyncExternalStore", at(), he(), jv(e, t);
        },
        useId: function() {
          return J = "useId", at(), he(), Gv();
        },
        unstable_isNewReconciler: ue
      }, Xv = {
        readContext: function(e) {
          return aw(), Mn(e);
        },
        useCallback: function(e, t) {
          return J = "useCallback", at(), he(), Kv(e, t);
        },
        useContext: function(e) {
          return J = "useContext", at(), he(), Mn(e);
        },
        useEffect: function(e, t) {
          return J = "useEffect", at(), he(), Eh(e, t);
        },
        useImperativeHandle: function(e, t, a) {
          return J = "useImperativeHandle", at(), he(), Zv(e, t, a);
        },
        useInsertionEffect: function(e, t) {
          return J = "useInsertionEffect", at(), he(), qv(e, t);
        },
        useLayoutEffect: function(e, t) {
          return J = "useLayoutEffect", at(), he(), Hv(e, t);
        },
        useMemo: function(e, t) {
          J = "useMemo", at(), he();
          var a = Ee.current;
          Ee.current = Uo;
          try {
            return Yv(e, t);
          } finally {
            Ee.current = a;
          }
        },
        useReducer: function(e, t, a) {
          J = "useReducer", at(), he();
          var i = Ee.current;
          Ee.current = Uo;
          try {
            return q_(e, t, a);
          } finally {
            Ee.current = i;
          }
        },
        useRef: function(e) {
          return J = "useRef", at(), he(), Vv();
        },
        useState: function(e) {
          J = "useState", at(), he();
          var t = Ee.current;
          Ee.current = Uo;
          try {
            return Q_(e);
          } finally {
            Ee.current = t;
          }
        },
        useDebugValue: function(e, t) {
          return J = "useDebugValue", at(), he(), Qv();
        },
        useDeferredValue: function(e) {
          return J = "useDeferredValue", at(), he(), E0(e);
        },
        useTransition: function() {
          return J = "useTransition", at(), he(), R0();
        },
        useMutableSource: function(e, t, a) {
          return J = "useMutableSource", at(), he(), void 0;
        },
        useSyncExternalStore: function(e, t, a) {
          return J = "useSyncExternalStore", at(), he(), jv(e, t);
        },
        useId: function() {
          return J = "useId", at(), he(), Gv();
        },
        unstable_isNewReconciler: ue
      };
    }
    var Dl = o.unstable_now, F0 = 0, ey = -1, Ch = -1, ty = -1, ow = !1, ny = !1;
    function $0() {
      return ow;
    }
    function CP() {
      ny = !0;
    }
    function TP() {
      ow = !1, ny = !1;
    }
    function RP() {
      ow = ny, ny = !1;
    }
    function j0() {
      return F0;
    }
    function U0() {
      F0 = Dl();
    }
    function iw(e) {
      Ch = Dl(), e.actualStartTime < 0 && (e.actualStartTime = Dl());
    }
    function V0(e) {
      Ch = -1;
    }
    function ry(e, t) {
      if (Ch >= 0) {
        var a = Dl() - Ch;
        e.actualDuration += a, t && (e.selfBaseDuration = a), Ch = -1;
      }
    }
    function Oi(e) {
      if (ey >= 0) {
        var t = Dl() - ey;
        ey = -1;
        for (var a = e.return; a !== null; ) {
          switch (a.tag) {
            case P:
              var i = a.stateNode;
              i.effectDuration += t;
              return;
            case qe:
              var c = a.stateNode;
              c.effectDuration += t;
              return;
          }
          a = a.return;
        }
      }
    }
    function sw(e) {
      if (ty >= 0) {
        var t = Dl() - ty;
        ty = -1;
        for (var a = e.return; a !== null; ) {
          switch (a.tag) {
            case P:
              var i = a.stateNode;
              i !== null && (i.passiveEffectDuration += t);
              return;
            case qe:
              var c = a.stateNode;
              c !== null && (c.passiveEffectDuration += t);
              return;
          }
          a = a.return;
        }
      }
    }
    function Li() {
      ey = Dl();
    }
    function lw() {
      ty = Dl();
    }
    function uw(e) {
      for (var t = e.child; t; )
        e.actualDuration += t.actualDuration, t = t.sibling;
    }
    function Vo(e, t) {
      if (e && e.defaultProps) {
        var a = bt({}, t), i = e.defaultProps;
        for (var c in i)
          a[c] === void 0 && (a[c] = i[c]);
        return a;
      }
      return t;
    }
    var cw = {}, dw, fw, pw, hw, mw, B0, ay, gw, vw, yw, Th;
    {
      dw = /* @__PURE__ */ new Set(), fw = /* @__PURE__ */ new Set(), pw = /* @__PURE__ */ new Set(), hw = /* @__PURE__ */ new Set(), gw = /* @__PURE__ */ new Set(), mw = /* @__PURE__ */ new Set(), vw = /* @__PURE__ */ new Set(), yw = /* @__PURE__ */ new Set(), Th = /* @__PURE__ */ new Set();
      var W0 = /* @__PURE__ */ new Set();
      ay = function(e, t) {
        if (!(e === null || typeof e == "function")) {
          var a = t + "_" + e;
          W0.has(a) || (W0.add(a), g("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e));
        }
      }, B0 = function(e, t) {
        if (t === void 0) {
          var a = At(e) || "Component";
          mw.has(a) || (mw.add(a), g("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", a));
        }
      }, Object.defineProperty(cw, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(cw);
    }
    function bw(e, t, a, i) {
      var c = e.memoizedState, p = a(i, c);
      {
        if (e.mode & $t) {
          Jt(!0);
          try {
            p = a(i, c);
          } finally {
            Jt(!1);
          }
        }
        B0(t, p);
      }
      var y = p == null ? c : bt({}, c, p);
      if (e.memoizedState = y, e.lanes === X) {
        var _ = e.updateQueue;
        _.baseState = y;
      }
    }
    var _w = {
      isMounted: ug,
      enqueueSetState: function(e, t, a) {
        var i = cl(e), c = ea(), p = Ml(i), y = zs(c, p);
        y.payload = t, a != null && (ay(a, "setState"), y.callback = a);
        var _ = Pl(i, y, p);
        _ !== null && (rr(_, i, p, c), Dv(_, i, p)), bu(i, p);
      },
      enqueueReplaceState: function(e, t, a) {
        var i = cl(e), c = ea(), p = Ml(i), y = zs(c, p);
        y.tag = s0, y.payload = t, a != null && (ay(a, "replaceState"), y.callback = a);
        var _ = Pl(i, y, p);
        _ !== null && (rr(_, i, p, c), Dv(_, i, p)), bu(i, p);
      },
      enqueueForceUpdate: function(e, t) {
        var a = cl(e), i = ea(), c = Ml(a), p = zs(i, c);
        p.tag = Nv, t != null && (ay(t, "forceUpdate"), p.callback = t);
        var y = Pl(a, p, c);
        y !== null && (rr(y, a, c, i), Dv(y, a, c)), Kc(a, c);
      }
    };
    function q0(e, t, a, i, c, p, y) {
      var _ = e.stateNode;
      if (typeof _.shouldComponentUpdate == "function") {
        var w = _.shouldComponentUpdate(i, p, y);
        {
          if (e.mode & $t) {
            Jt(!0);
            try {
              w = _.shouldComponentUpdate(i, p, y);
            } finally {
              Jt(!1);
            }
          }
          w === void 0 && g("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", At(t) || "Component");
        }
        return w;
      }
      return t.prototype && t.prototype.isPureReactComponent ? !se(a, i) || !se(c, p) : !0;
    }
    function PP(e, t, a) {
      var i = e.stateNode;
      {
        var c = At(t) || "Component", p = i.render;
        p || (t.prototype && typeof t.prototype.render == "function" ? g("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", c) : g("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", c)), i.getInitialState && !i.getInitialState.isReactClassApproved && !i.state && g("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", c), i.getDefaultProps && !i.getDefaultProps.isReactClassApproved && g("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", c), i.propTypes && g("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", c), i.contextType && g("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", c), t.childContextTypes && !Th.has(t) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & $t) === He && (Th.add(t), g(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, c)), t.contextTypes && !Th.has(t) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & $t) === He && (Th.add(t), g(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, c)), i.contextTypes && g("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", c), t.contextType && t.contextTypes && !vw.has(t) && (vw.add(t), g("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", c)), typeof i.componentShouldUpdate == "function" && g("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", c), t.prototype && t.prototype.isPureReactComponent && typeof i.shouldComponentUpdate < "u" && g("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", At(t) || "A pure component"), typeof i.componentDidUnmount == "function" && g("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", c), typeof i.componentDidReceiveProps == "function" && g("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", c), typeof i.componentWillRecieveProps == "function" && g("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", c), typeof i.UNSAFE_componentWillRecieveProps == "function" && g("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", c);
        var y = i.props !== a;
        i.props !== void 0 && y && g("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", c, c), i.defaultProps && g("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", c, c), typeof i.getSnapshotBeforeUpdate == "function" && typeof i.componentDidUpdate != "function" && !pw.has(t) && (pw.add(t), g("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", At(t))), typeof i.getDerivedStateFromProps == "function" && g("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", c), typeof i.getDerivedStateFromError == "function" && g("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", c), typeof t.getSnapshotBeforeUpdate == "function" && g("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", c);
        var _ = i.state;
        _ && (typeof _ != "object" || Wn(_)) && g("%s.state: must be set to an object or null", c), typeof i.getChildContext == "function" && typeof t.childContextTypes != "object" && g("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", c);
      }
    }
    function H0(e, t) {
      t.updater = _w, e.stateNode = t, as(t, e), t._reactInternalInstance = cw;
    }
    function Z0(e, t, a) {
      var i = !1, c = Ua, p = Ua, y = t.contextType;
      if ("contextType" in t) {
        var _ = (
          // Allow null for conditional declaration
          y === null || y !== void 0 && y.$$typeof === Zl && y._context === void 0
        );
        if (!_ && !yw.has(t)) {
          yw.add(t);
          var w = "";
          y === void 0 ? w = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof y != "object" ? w = " However, it is set to a " + typeof y + "." : y.$$typeof === Ys ? w = " Did you accidentally pass the Context.Provider instead?" : y._context !== void 0 ? w = " Did you accidentally pass the Context.Consumer instead?" : w = " However, it is set to an object with keys {" + Object.keys(y).join(", ") + "}.", g("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", At(t) || "Component", w);
        }
      }
      if (typeof y == "object" && y !== null)
        p = Mn(y);
      else {
        c = jd(e, t, !0);
        var C = t.contextTypes;
        i = C != null, p = i ? Ud(e, c) : Ua;
      }
      var T = new t(a, p);
      if (e.mode & $t) {
        Jt(!0);
        try {
          T = new t(a, p);
        } finally {
          Jt(!1);
        }
      }
      var A = e.memoizedState = T.state !== null && T.state !== void 0 ? T.state : null;
      H0(e, T);
      {
        if (typeof t.getDerivedStateFromProps == "function" && A === null) {
          var z = At(t) || "Component";
          fw.has(z) || (fw.add(z), g("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", z, T.state === null ? "null" : "undefined", z));
        }
        if (typeof t.getDerivedStateFromProps == "function" || typeof T.getSnapshotBeforeUpdate == "function") {
          var B = null, H = null, Y = null;
          if (typeof T.componentWillMount == "function" && T.componentWillMount.__suppressDeprecationWarning !== !0 ? B = "componentWillMount" : typeof T.UNSAFE_componentWillMount == "function" && (B = "UNSAFE_componentWillMount"), typeof T.componentWillReceiveProps == "function" && T.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? H = "componentWillReceiveProps" : typeof T.UNSAFE_componentWillReceiveProps == "function" && (H = "UNSAFE_componentWillReceiveProps"), typeof T.componentWillUpdate == "function" && T.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Y = "componentWillUpdate" : typeof T.UNSAFE_componentWillUpdate == "function" && (Y = "UNSAFE_componentWillUpdate"), B !== null || H !== null || Y !== null) {
            var me = At(t) || "Component", Ue = typeof t.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            hw.has(me) || (hw.add(me), g(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, me, Ue, B !== null ? `
  ` + B : "", H !== null ? `
  ` + H : "", Y !== null ? `
  ` + Y : ""));
          }
        }
      }
      return i && Ax(e, c, p), T;
    }
    function NP(e, t) {
      var a = t.state;
      typeof t.componentWillMount == "function" && t.componentWillMount(), typeof t.UNSAFE_componentWillMount == "function" && t.UNSAFE_componentWillMount(), a !== t.state && (g("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", ut(e) || "Component"), _w.enqueueReplaceState(t, t.state, null));
    }
    function Q0(e, t, a, i) {
      var c = t.state;
      if (typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(a, i), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(a, i), t.state !== c) {
        {
          var p = ut(e) || "Component";
          dw.has(p) || (dw.add(p), g("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", p));
        }
        _w.enqueueReplaceState(t, t.state, null);
      }
    }
    function ww(e, t, a, i) {
      PP(e, t, a);
      var c = e.stateNode;
      c.props = a, c.state = e.memoizedState, c.refs = {}, N_(e);
      var p = t.contextType;
      if (typeof p == "object" && p !== null)
        c.context = Mn(p);
      else {
        var y = jd(e, t, !0);
        c.context = Ud(e, y);
      }
      {
        if (c.state === a) {
          var _ = At(t) || "Component";
          gw.has(_) || (gw.add(_), g("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", _));
        }
        e.mode & $t && $o.recordLegacyContextWarning(e, c), $o.recordUnsafeLifecycleWarnings(e, c);
      }
      c.state = e.memoizedState;
      var w = t.getDerivedStateFromProps;
      if (typeof w == "function" && (bw(e, t, w, a), c.state = e.memoizedState), typeof t.getDerivedStateFromProps != "function" && typeof c.getSnapshotBeforeUpdate != "function" && (typeof c.UNSAFE_componentWillMount == "function" || typeof c.componentWillMount == "function") && (NP(e, c), zv(e, a, c, i), c.state = e.memoizedState), typeof c.componentDidMount == "function") {
        var C = wt;
        C |= So, (e.mode & Rt) !== He && (C |= li), e.flags |= C;
      }
    }
    function OP(e, t, a, i) {
      var c = e.stateNode, p = e.memoizedProps;
      c.props = p;
      var y = c.context, _ = t.contextType, w = Ua;
      if (typeof _ == "object" && _ !== null)
        w = Mn(_);
      else {
        var C = jd(e, t, !0);
        w = Ud(e, C);
      }
      var T = t.getDerivedStateFromProps, A = typeof T == "function" || typeof c.getSnapshotBeforeUpdate == "function";
      !A && (typeof c.UNSAFE_componentWillReceiveProps == "function" || typeof c.componentWillReceiveProps == "function") && (p !== a || y !== w) && Q0(e, c, a, w), u0();
      var z = e.memoizedState, B = c.state = z;
      if (zv(e, a, c, i), B = e.memoizedState, p === a && z === B && !mv() && !Iv()) {
        if (typeof c.componentDidMount == "function") {
          var H = wt;
          H |= So, (e.mode & Rt) !== He && (H |= li), e.flags |= H;
        }
        return !1;
      }
      typeof T == "function" && (bw(e, t, T, a), B = e.memoizedState);
      var Y = Iv() || q0(e, t, p, a, z, B, w);
      if (Y) {
        if (!A && (typeof c.UNSAFE_componentWillMount == "function" || typeof c.componentWillMount == "function") && (typeof c.componentWillMount == "function" && c.componentWillMount(), typeof c.UNSAFE_componentWillMount == "function" && c.UNSAFE_componentWillMount()), typeof c.componentDidMount == "function") {
          var me = wt;
          me |= So, (e.mode & Rt) !== He && (me |= li), e.flags |= me;
        }
      } else {
        if (typeof c.componentDidMount == "function") {
          var Ue = wt;
          Ue |= So, (e.mode & Rt) !== He && (Ue |= li), e.flags |= Ue;
        }
        e.memoizedProps = a, e.memoizedState = B;
      }
      return c.props = a, c.state = B, c.context = w, Y;
    }
    function LP(e, t, a, i, c) {
      var p = t.stateNode;
      l0(e, t);
      var y = t.memoizedProps, _ = t.type === t.elementType ? y : Vo(t.type, y);
      p.props = _;
      var w = t.pendingProps, C = p.context, T = a.contextType, A = Ua;
      if (typeof T == "object" && T !== null)
        A = Mn(T);
      else {
        var z = jd(t, a, !0);
        A = Ud(t, z);
      }
      var B = a.getDerivedStateFromProps, H = typeof B == "function" || typeof p.getSnapshotBeforeUpdate == "function";
      !H && (typeof p.UNSAFE_componentWillReceiveProps == "function" || typeof p.componentWillReceiveProps == "function") && (y !== w || C !== A) && Q0(t, p, i, A), u0();
      var Y = t.memoizedState, me = p.state = Y;
      if (zv(t, i, p, c), me = t.memoizedState, y === w && Y === me && !mv() && !Iv())
        return typeof p.componentDidUpdate == "function" && (y !== e.memoizedProps || Y !== e.memoizedState) && (t.flags |= wt), typeof p.getSnapshotBeforeUpdate == "function" && (y !== e.memoizedProps || Y !== e.memoizedState) && (t.flags |= Sn), !1;
      typeof B == "function" && (bw(t, a, B, i), me = t.memoizedState);
      var Ue = Iv() || q0(t, a, _, i, Y, me, A) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      ke;
      return Ue ? (!H && (typeof p.UNSAFE_componentWillUpdate == "function" || typeof p.componentWillUpdate == "function") && (typeof p.componentWillUpdate == "function" && p.componentWillUpdate(i, me, A), typeof p.UNSAFE_componentWillUpdate == "function" && p.UNSAFE_componentWillUpdate(i, me, A)), typeof p.componentDidUpdate == "function" && (t.flags |= wt), typeof p.getSnapshotBeforeUpdate == "function" && (t.flags |= Sn)) : (typeof p.componentDidUpdate == "function" && (y !== e.memoizedProps || Y !== e.memoizedState) && (t.flags |= wt), typeof p.getSnapshotBeforeUpdate == "function" && (y !== e.memoizedProps || Y !== e.memoizedState) && (t.flags |= Sn), t.memoizedProps = i, t.memoizedState = me), p.props = i, p.state = me, p.context = A, Ue;
    }
    function Xu(e, t) {
      return {
        value: e,
        source: t,
        stack: gc(t),
        digest: null
      };
    }
    function kw(e, t, a) {
      return {
        value: e,
        source: null,
        stack: a ?? null,
        digest: t ?? null
      };
    }
    function DP(e, t) {
      return !0;
    }
    function xw(e, t) {
      try {
        var a = DP(e, t);
        if (a === !1)
          return;
        var i = t.value, c = t.source, p = t.stack, y = p !== null ? p : "";
        if (i != null && i._suppressLogging) {
          if (e.tag === E)
            return;
          console.error(i);
        }
        var _ = c ? ut(c) : null, w = _ ? "The above error occurred in the <" + _ + "> component:" : "The above error occurred in one of your React components:", C;
        if (e.tag === P)
          C = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var T = ut(e) || "Anonymous";
          C = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + T + ".");
        }
        var A = w + `
` + y + `

` + ("" + C);
        console.error(A);
      } catch (z) {
        setTimeout(function() {
          throw z;
        });
      }
    }
    var zP = typeof WeakMap == "function" ? WeakMap : Map;
    function K0(e, t, a) {
      var i = zs(Wt, a);
      i.tag = R_, i.payload = {
        element: null
      };
      var c = t.value;
      return i.callback = function() {
        CO(c), xw(e, t);
      }, i;
    }
    function Sw(e, t, a) {
      var i = zs(Wt, a);
      i.tag = R_;
      var c = e.type.getDerivedStateFromError;
      if (typeof c == "function") {
        var p = t.value;
        i.payload = function() {
          return c(p);
        }, i.callback = function() {
          iS(e), xw(e, t);
        };
      }
      var y = e.stateNode;
      return y !== null && typeof y.componentDidCatch == "function" && (i.callback = function() {
        iS(e), xw(e, t), typeof c != "function" && SO(this);
        var _ = t.value, w = t.stack;
        this.componentDidCatch(_, {
          componentStack: w !== null ? w : ""
        }), typeof c != "function" && (Dr(e.lanes, Je) || g("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", ut(e) || "Unknown"));
      }), i;
    }
    function Y0(e, t, a) {
      var i = e.pingCache, c;
      if (i === null ? (i = e.pingCache = new zP(), c = /* @__PURE__ */ new Set(), i.set(t, c)) : (c = i.get(t), c === void 0 && (c = /* @__PURE__ */ new Set(), i.set(t, c))), !c.has(a)) {
        c.add(a);
        var p = TO.bind(null, e, t, a);
        Lr && Bh(e, a), t.then(p, p);
      }
    }
    function IP(e, t, a, i) {
      var c = e.updateQueue;
      if (c === null) {
        var p = /* @__PURE__ */ new Set();
        p.add(a), e.updateQueue = p;
      } else
        c.add(a);
    }
    function AP(e, t) {
      var a = e.tag;
      if ((e.mode & pt) === He && (a === S || a === ve || a === Oe)) {
        var i = e.alternate;
        i ? (e.updateQueue = i.updateQueue, e.memoizedState = i.memoizedState, e.lanes = i.lanes) : (e.updateQueue = null, e.memoizedState = null);
      }
    }
    function G0(e) {
      var t = e;
      do {
        if (t.tag === Re && gP(t))
          return t;
        t = t.return;
      } while (t !== null);
      return null;
    }
    function J0(e, t, a, i, c) {
      if ((e.mode & pt) === He) {
        if (e === t)
          e.flags |= Pr;
        else {
          if (e.flags |= Be, a.flags |= Uc, a.flags &= -52805, a.tag === E) {
            var p = a.alternate;
            if (p === null)
              a.tag = rt;
            else {
              var y = zs(Wt, Je);
              y.tag = Nv, Pl(a, y, Je);
            }
          }
          a.lanes = ct(a.lanes, Je);
        }
        return e;
      }
      return e.flags |= Pr, e.lanes = c, e;
    }
    function MP(e, t, a, i, c) {
      if (a.flags |= pu, Lr && Bh(e, c), i !== null && typeof i == "object" && typeof i.then == "function") {
        var p = i;
        AP(a), vr() && a.mode & pt && Bx();
        var y = G0(t);
        if (y !== null) {
          y.flags &= -257, J0(y, t, a, e, c), y.mode & pt && Y0(e, p, c), IP(y, e, p);
          return;
        } else {
          if (!vg(c)) {
            Y0(e, p, c), rk();
            return;
          }
          var _ = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          i = _;
        }
      } else if (vr() && a.mode & pt) {
        Bx();
        var w = G0(t);
        if (w !== null) {
          (w.flags & Pr) === We && (w.flags |= Tr), J0(w, t, a, e, c), g_(Xu(i, a));
          return;
        }
      }
      i = Xu(i, a), gO(i);
      var C = t;
      do {
        switch (C.tag) {
          case P: {
            var T = i;
            C.flags |= Pr;
            var A = Ru(c);
            C.lanes = ct(C.lanes, A);
            var z = K0(C, T, A);
            O_(C, z);
            return;
          }
          case E:
            var B = i, H = C.type, Y = C.stateNode;
            if ((C.flags & Be) === We && (typeof H.getDerivedStateFromError == "function" || Y !== null && typeof Y.componentDidCatch == "function" && !G1(Y))) {
              C.flags |= Pr;
              var me = Ru(c);
              C.lanes = ct(C.lanes, me);
              var Ue = Sw(C, B, me);
              O_(C, Ue);
              return;
            }
            break;
        }
        C = C.return;
      } while (C !== null);
    }
    function FP() {
      return null;
    }
    var Rh = s.ReactCurrentOwner, Bo = !1, Ew, Ph, Cw, Tw, Rw, ec, Pw, oy, Nh;
    Ew = {}, Ph = {}, Cw = {}, Tw = {}, Rw = {}, ec = !1, Pw = {}, oy = {}, Nh = {};
    function Jr(e, t, a, i) {
      e === null ? t.child = t0(t, null, a, i) : t.child = qd(t, e.child, a, i);
    }
    function $P(e, t, a, i) {
      t.child = qd(t, e.child, null, i), t.child = qd(t, null, a, i);
    }
    function X0(e, t, a, i, c) {
      if (t.type !== t.elementType) {
        var p = a.propTypes;
        p && Mo(
          p,
          i,
          // Resolved props
          "prop",
          At(a)
        );
      }
      var y = a.render, _ = t.ref, w, C;
      Zd(t, c), Zr(t);
      {
        if (Rh.current = t, Bn(!0), w = Xd(e, t, y, i, _, c), C = ef(), t.mode & $t) {
          Jt(!0);
          try {
            w = Xd(e, t, y, i, _, c), C = ef();
          } finally {
            Jt(!1);
          }
        }
        Bn(!1);
      }
      return Qr(), e !== null && !Bo ? (m0(e, t, c), Is(e, t, c)) : (vr() && C && c_(t), t.flags |= La, Jr(e, t, w, c), t.child);
    }
    function e1(e, t, a, i, c) {
      if (e === null) {
        var p = a.type;
        if (WO(p) && a.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        a.defaultProps === void 0) {
          var y = p;
          return y = uf(p), t.tag = Oe, t.type = y, Lw(t, p), t1(e, t, y, i, c);
        }
        {
          var _ = p.propTypes;
          if (_ && Mo(
            _,
            i,
            // Resolved props
            "prop",
            At(p)
          ), a.defaultProps !== void 0) {
            var w = At(p) || "Unknown";
            Nh[w] || (g("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", w), Nh[w] = !0);
          }
        }
        var C = hk(a.type, null, i, t, t.mode, c);
        return C.ref = t.ref, C.return = t, t.child = C, C;
      }
      {
        var T = a.type, A = T.propTypes;
        A && Mo(
          A,
          i,
          // Resolved props
          "prop",
          At(T)
        );
      }
      var z = e.child, B = Fw(e, c);
      if (!B) {
        var H = z.memoizedProps, Y = a.compare;
        if (Y = Y !== null ? Y : se, Y(H, i) && e.ref === t.ref)
          return Is(e, t, c);
      }
      t.flags |= La;
      var me = oc(z, i);
      return me.ref = t.ref, me.return = t, t.child = me, me;
    }
    function t1(e, t, a, i, c) {
      if (t.type !== t.elementType) {
        var p = t.elementType;
        if (p.$$typeof === lr) {
          var y = p, _ = y._payload, w = y._init;
          try {
            p = w(_);
          } catch {
            p = null;
          }
          var C = p && p.propTypes;
          C && Mo(
            C,
            i,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            At(p)
          );
        }
      }
      if (e !== null) {
        var T = e.memoizedProps;
        if (se(T, i) && e.ref === t.ref && // Prevent bailout if the implementation changed due to hot reload.
        t.type === e.type)
          if (Bo = !1, t.pendingProps = i = T, Fw(e, c))
            (e.flags & Uc) !== We && (Bo = !0);
          else return t.lanes = e.lanes, Is(e, t, c);
      }
      return Nw(e, t, a, i, c);
    }
    function n1(e, t, a) {
      var i = t.pendingProps, c = i.children, p = e !== null ? e.memoizedState : null;
      if (i.mode === "hidden" || pe)
        if ((t.mode & pt) === He) {
          var y = {
            baseLanes: X,
            cachePool: null,
            transitions: null
          };
          t.memoizedState = y, by(t, a);
        } else if (Dr(a, Kr)) {
          var _ = {
            baseLanes: X,
            cachePool: null,
            transitions: null
          };
          t.memoizedState = _;
          var w = p !== null ? p.baseLanes : a;
          by(t, w);
        } else {
          var C = null, T;
          if (p !== null) {
            var A = p.baseLanes;
            T = ct(A, a);
          } else
            T = a;
          t.lanes = t.childLanes = Kr;
          var z = {
            baseLanes: T,
            cachePool: C,
            transitions: null
          };
          return t.memoizedState = z, t.updateQueue = null, by(t, T), null;
        }
      else {
        var B;
        p !== null ? (B = ct(p.baseLanes, a), t.memoizedState = null) : B = a, by(t, B);
      }
      return Jr(e, t, c, a), t.child;
    }
    function jP(e, t, a) {
      var i = t.pendingProps;
      return Jr(e, t, i, a), t.child;
    }
    function UP(e, t, a) {
      var i = t.pendingProps.children;
      return Jr(e, t, i, a), t.child;
    }
    function VP(e, t, a) {
      {
        t.flags |= wt;
        {
          var i = t.stateNode;
          i.effectDuration = 0, i.passiveEffectDuration = 0;
        }
      }
      var c = t.pendingProps, p = c.children;
      return Jr(e, t, p, a), t.child;
    }
    function r1(e, t) {
      var a = t.ref;
      (e === null && a !== null || e !== null && e.ref !== a) && (t.flags |= an, t.flags |= fl);
    }
    function Nw(e, t, a, i, c) {
      if (t.type !== t.elementType) {
        var p = a.propTypes;
        p && Mo(
          p,
          i,
          // Resolved props
          "prop",
          At(a)
        );
      }
      var y;
      {
        var _ = jd(t, a, !0);
        y = Ud(t, _);
      }
      var w, C;
      Zd(t, c), Zr(t);
      {
        if (Rh.current = t, Bn(!0), w = Xd(e, t, a, i, y, c), C = ef(), t.mode & $t) {
          Jt(!0);
          try {
            w = Xd(e, t, a, i, y, c), C = ef();
          } finally {
            Jt(!1);
          }
        }
        Bn(!1);
      }
      return Qr(), e !== null && !Bo ? (m0(e, t, c), Is(e, t, c)) : (vr() && C && c_(t), t.flags |= La, Jr(e, t, w, c), t.child);
    }
    function a1(e, t, a, i, c) {
      {
        switch (oL(t)) {
          case !1: {
            var p = t.stateNode, y = t.type, _ = new y(t.memoizedProps, p.context), w = _.state;
            p.updater.enqueueSetState(p, w, null);
            break;
          }
          case !0: {
            t.flags |= Be, t.flags |= Pr;
            var C = new Error("Simulated error coming from DevTools"), T = Ru(c);
            t.lanes = ct(t.lanes, T);
            var A = Sw(t, Xu(C, t), T);
            O_(t, A);
            break;
          }
        }
        if (t.type !== t.elementType) {
          var z = a.propTypes;
          z && Mo(
            z,
            i,
            // Resolved props
            "prop",
            At(a)
          );
        }
      }
      var B;
      Ti(a) ? (B = !0, vv(t)) : B = !1, Zd(t, c);
      var H = t.stateNode, Y;
      H === null ? (sy(e, t), Z0(t, a, i), ww(t, a, i, c), Y = !0) : e === null ? Y = OP(t, a, i, c) : Y = LP(e, t, a, i, c);
      var me = Ow(e, t, a, Y, B, c);
      {
        var Ue = t.stateNode;
        Y && Ue.props !== i && (ec || g("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", ut(t) || "a component"), ec = !0);
      }
      return me;
    }
    function Ow(e, t, a, i, c, p) {
      r1(e, t);
      var y = (t.flags & Be) !== We;
      if (!i && !y)
        return c && $x(t, a, !1), Is(e, t, p);
      var _ = t.stateNode;
      Rh.current = t;
      var w;
      if (y && typeof a.getDerivedStateFromError != "function")
        w = null, V0();
      else {
        Zr(t);
        {
          if (Bn(!0), w = _.render(), t.mode & $t) {
            Jt(!0);
            try {
              _.render();
            } finally {
              Jt(!1);
            }
          }
          Bn(!1);
        }
        Qr();
      }
      return t.flags |= La, e !== null && y ? $P(e, t, w, p) : Jr(e, t, w, p), t.memoizedState = _.state, c && $x(t, a, !0), t.child;
    }
    function o1(e) {
      var t = e.stateNode;
      t.pendingContext ? Mx(e, t.pendingContext, t.pendingContext !== t.context) : t.context && Mx(e, t.context, !1), L_(e, t.containerInfo);
    }
    function BP(e, t, a) {
      if (o1(t), e === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var i = t.pendingProps, c = t.memoizedState, p = c.element;
      l0(e, t), zv(t, i, null, a);
      var y = t.memoizedState;
      t.stateNode;
      var _ = y.element;
      if (c.isDehydrated) {
        var w = {
          element: _,
          isDehydrated: !1,
          cache: y.cache,
          pendingSuspenseBoundaries: y.pendingSuspenseBoundaries,
          transitions: y.transitions
        }, C = t.updateQueue;
        if (C.baseState = w, t.memoizedState = w, t.flags & Tr) {
          var T = Xu(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), t);
          return i1(e, t, _, a, T);
        } else if (_ !== p) {
          var A = Xu(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), t);
          return i1(e, t, _, a, A);
        } else {
          HR(t);
          var z = t0(t, null, _, a);
          t.child = z;
          for (var B = z; B; )
            B.flags = B.flags & -3 | fa, B = B.sibling;
        }
      } else {
        if (Wd(), _ === p)
          return Is(e, t, a);
        Jr(e, t, _, a);
      }
      return t.child;
    }
    function i1(e, t, a, i, c) {
      return Wd(), g_(c), t.flags |= Tr, Jr(e, t, a, i), t.child;
    }
    function WP(e, t, a) {
      f0(t), e === null && m_(t);
      var i = t.type, c = t.pendingProps, p = e !== null ? e.memoizedProps : null, y = c.children, _ = Yb(i, c);
      return _ ? y = null : p !== null && Yb(i, p) && (t.flags |= Da), r1(e, t), Jr(e, t, y, a), t.child;
    }
    function qP(e, t) {
      return e === null && m_(t), null;
    }
    function HP(e, t, a, i) {
      sy(e, t);
      var c = t.pendingProps, p = a, y = p._payload, _ = p._init, w = _(y);
      t.type = w;
      var C = t.tag = qO(w), T = Vo(w, c), A;
      switch (C) {
        case S:
          return Lw(t, w), t.type = w = uf(w), A = Nw(null, t, w, T, i), A;
        case E:
          return t.type = w = lk(w), A = a1(null, t, w, T, i), A;
        case ve:
          return t.type = w = uk(w), A = X0(null, t, w, T, i), A;
        case ft: {
          if (t.type !== t.elementType) {
            var z = w.propTypes;
            z && Mo(
              z,
              T,
              // Resolved for outer only
              "prop",
              At(w)
            );
          }
          return A = e1(
            null,
            t,
            w,
            Vo(w.type, T),
            // The inner type can have defaults too
            i
          ), A;
        }
      }
      var B = "";
      throw w !== null && typeof w == "object" && w.$$typeof === lr && (B = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + w + ". " + ("Lazy element type must resolve to a class or function." + B));
    }
    function ZP(e, t, a, i, c) {
      sy(e, t), t.tag = E;
      var p;
      return Ti(a) ? (p = !0, vv(t)) : p = !1, Zd(t, c), Z0(t, a, i), ww(t, a, i, c), Ow(null, t, a, !0, p, c);
    }
    function QP(e, t, a, i) {
      sy(e, t);
      var c = t.pendingProps, p;
      {
        var y = jd(t, a, !1);
        p = Ud(t, y);
      }
      Zd(t, i);
      var _, w;
      Zr(t);
      {
        if (a.prototype && typeof a.prototype.render == "function") {
          var C = At(a) || "Unknown";
          Ew[C] || (g("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", C, C), Ew[C] = !0);
        }
        t.mode & $t && $o.recordLegacyContextWarning(t, null), Bn(!0), Rh.current = t, _ = Xd(null, t, a, c, p, i), w = ef(), Bn(!1);
      }
      if (Qr(), t.flags |= La, typeof _ == "object" && _ !== null && typeof _.render == "function" && _.$$typeof === void 0) {
        var T = At(a) || "Unknown";
        Ph[T] || (g("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", T, T, T), Ph[T] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof _ == "object" && _ !== null && typeof _.render == "function" && _.$$typeof === void 0
      ) {
        {
          var A = At(a) || "Unknown";
          Ph[A] || (g("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", A, A, A), Ph[A] = !0);
        }
        t.tag = E, t.memoizedState = null, t.updateQueue = null;
        var z = !1;
        return Ti(a) ? (z = !0, vv(t)) : z = !1, t.memoizedState = _.state !== null && _.state !== void 0 ? _.state : null, N_(t), H0(t, _), ww(t, a, c, i), Ow(null, t, a, !0, z, i);
      } else {
        if (t.tag = S, t.mode & $t) {
          Jt(!0);
          try {
            _ = Xd(null, t, a, c, p, i), w = ef();
          } finally {
            Jt(!1);
          }
        }
        return vr() && w && c_(t), Jr(null, t, _, i), Lw(t, a), t.child;
      }
    }
    function Lw(e, t) {
      {
        if (t && t.childContextTypes && g("%s(...): childContextTypes cannot be defined on a function component.", t.displayName || t.name || "Component"), e.ref !== null) {
          var a = "", i = la();
          i && (a += `

Check the render method of \`` + i + "`.");
          var c = i || "", p = e._debugSource;
          p && (c = p.fileName + ":" + p.lineNumber), Rw[c] || (Rw[c] = !0, g("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", a));
        }
        if (t.defaultProps !== void 0) {
          var y = At(t) || "Unknown";
          Nh[y] || (g("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", y), Nh[y] = !0);
        }
        if (typeof t.getDerivedStateFromProps == "function") {
          var _ = At(t) || "Unknown";
          Tw[_] || (g("%s: Function components do not support getDerivedStateFromProps.", _), Tw[_] = !0);
        }
        if (typeof t.contextType == "object" && t.contextType !== null) {
          var w = At(t) || "Unknown";
          Cw[w] || (g("%s: Function components do not support contextType.", w), Cw[w] = !0);
        }
      }
    }
    var Dw = {
      dehydrated: null,
      treeContext: null,
      retryLane: Et
    };
    function zw(e) {
      return {
        baseLanes: e,
        cachePool: FP(),
        transitions: null
      };
    }
    function KP(e, t) {
      var a = null;
      return {
        baseLanes: ct(e.baseLanes, t),
        cachePool: a,
        transitions: e.transitions
      };
    }
    function YP(e, t, a, i) {
      if (t !== null) {
        var c = t.memoizedState;
        if (c === null)
          return !1;
      }
      return I_(e, bh);
    }
    function GP(e, t) {
      return Pu(e.childLanes, t);
    }
    function s1(e, t, a) {
      var i = t.pendingProps;
      iL(t) && (t.flags |= Be);
      var c = jo.current, p = !1, y = (t.flags & Be) !== We;
      if (y || YP(c, e) ? (p = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (c = mP(c, h0)), c = Kd(c), Ol(t, c), e === null) {
        m_(t);
        var _ = t.memoizedState;
        if (_ !== null) {
          var w = _.dehydrated;
          if (w !== null)
            return nN(t, w);
        }
        var C = i.children, T = i.fallback;
        if (p) {
          var A = JP(t, C, T, a), z = t.child;
          return z.memoizedState = zw(a), t.memoizedState = Dw, A;
        } else
          return Iw(t, C);
      } else {
        var B = e.memoizedState;
        if (B !== null) {
          var H = B.dehydrated;
          if (H !== null)
            return rN(e, t, y, i, H, B, a);
        }
        if (p) {
          var Y = i.fallback, me = i.children, Ue = eN(e, t, me, Y, a), Qe = t.child, vt = e.child.memoizedState;
          return Qe.memoizedState = vt === null ? zw(a) : KP(vt, a), Qe.childLanes = GP(e, a), t.memoizedState = Dw, Ue;
        } else {
          var ht = i.children, U = XP(e, t, ht, a);
          return t.memoizedState = null, U;
        }
      }
    }
    function Iw(e, t, a) {
      var i = e.mode, c = {
        mode: "visible",
        children: t
      }, p = Aw(c, i);
      return p.return = e, e.child = p, p;
    }
    function JP(e, t, a, i) {
      var c = e.mode, p = e.child, y = {
        mode: "hidden",
        children: t
      }, _, w;
      return (c & pt) === He && p !== null ? (_ = p, _.childLanes = X, _.pendingProps = y, e.mode & Tt && (_.actualDuration = 0, _.actualStartTime = -1, _.selfBaseDuration = 0, _.treeBaseDuration = 0), w = $l(a, c, i, null)) : (_ = Aw(y, c), w = $l(a, c, i, null)), _.return = e, w.return = e, _.sibling = w, e.child = _, w;
    }
    function Aw(e, t, a) {
      return sS(e, t, X, null);
    }
    function l1(e, t) {
      return oc(e, t);
    }
    function XP(e, t, a, i) {
      var c = e.child, p = c.sibling, y = l1(c, {
        mode: "visible",
        children: a
      });
      if ((t.mode & pt) === He && (y.lanes = i), y.return = t, y.sibling = null, p !== null) {
        var _ = t.deletions;
        _ === null ? (t.deletions = [p], t.flags |= da) : _.push(p);
      }
      return t.child = y, y;
    }
    function eN(e, t, a, i, c) {
      var p = t.mode, y = e.child, _ = y.sibling, w = {
        mode: "hidden",
        children: a
      }, C;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (p & pt) === He && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        t.child !== y
      ) {
        var T = t.child;
        C = T, C.childLanes = X, C.pendingProps = w, t.mode & Tt && (C.actualDuration = 0, C.actualStartTime = -1, C.selfBaseDuration = y.selfBaseDuration, C.treeBaseDuration = y.treeBaseDuration), t.deletions = null;
      } else
        C = l1(y, w), C.subtreeFlags = y.subtreeFlags & vn;
      var A;
      return _ !== null ? A = oc(_, i) : (A = $l(i, p, c, null), A.flags |= sn), A.return = t, C.return = t, C.sibling = A, t.child = C, A;
    }
    function iy(e, t, a, i) {
      i !== null && g_(i), qd(t, e.child, null, a);
      var c = t.pendingProps, p = c.children, y = Iw(t, p);
      return y.flags |= sn, t.memoizedState = null, y;
    }
    function tN(e, t, a, i, c) {
      var p = t.mode, y = {
        mode: "visible",
        children: a
      }, _ = Aw(y, p), w = $l(i, p, c, null);
      return w.flags |= sn, _.return = t, w.return = t, _.sibling = w, t.child = _, (t.mode & pt) !== He && qd(t, e.child, null, c), w;
    }
    function nN(e, t, a) {
      return (e.mode & pt) === He ? (g("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), e.lanes = Je) : e_(t) ? e.lanes = ur : e.lanes = Kr, null;
    }
    function rN(e, t, a, i, c, p, y) {
      if (a)
        if (t.flags & Tr) {
          t.flags &= -257;
          var _ = kw(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return iy(e, t, y, _);
        } else {
          if (t.memoizedState !== null)
            return t.child = e.child, t.flags |= Be, null;
          var w = i.children, C = i.fallback, T = tN(e, t, w, C, y), A = t.child;
          return A.memoizedState = zw(y), t.memoizedState = Dw, T;
        }
      else {
        if (WR(), (t.mode & pt) === He)
          return iy(
            e,
            t,
            y,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (e_(c)) {
          var z, B, H;
          {
            var Y = sR(c);
            z = Y.digest, B = Y.message, H = Y.stack;
          }
          var me;
          B ? me = new Error(B) : me = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var Ue = kw(me, z, H);
          return iy(e, t, y, Ue);
        }
        var Qe = Dr(y, e.childLanes);
        if (Bo || Qe) {
          var vt = yy();
          if (vt !== null) {
            var ht = wg(vt, y);
            if (ht !== Et && ht !== p.retryLane) {
              p.retryLane = ht;
              var U = Wt;
              _a(e, ht), rr(vt, e, ht, U);
            }
          }
          rk();
          var K = kw(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return iy(e, t, y, K);
        } else if (Ox(c)) {
          t.flags |= Be, t.child = e.child;
          var V = RO.bind(null, e);
          return lR(c, V), null;
        } else {
          ZR(t, c, p.treeContext);
          var oe = i.children, Ce = Iw(t, oe);
          return Ce.flags |= fa, Ce;
        }
      }
    }
    function u1(e, t, a) {
      e.lanes = ct(e.lanes, t);
      var i = e.alternate;
      i !== null && (i.lanes = ct(i.lanes, t)), C_(e.return, t, a);
    }
    function aN(e, t, a) {
      for (var i = t; i !== null; ) {
        if (i.tag === Re) {
          var c = i.memoizedState;
          c !== null && u1(i, a, e);
        } else if (i.tag === Ie)
          u1(i, a, e);
        else if (i.child !== null) {
          i.child.return = i, i = i.child;
          continue;
        }
        if (i === e)
          return;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === e)
            return;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
    }
    function oN(e) {
      for (var t = e, a = null; t !== null; ) {
        var i = t.alternate;
        i !== null && Fv(i) === null && (a = t), t = t.sibling;
      }
      return a;
    }
    function iN(e) {
      if (e !== void 0 && e !== "forwards" && e !== "backwards" && e !== "together" && !Pw[e])
        if (Pw[e] = !0, typeof e == "string")
          switch (e.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              g('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', e, e.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              g('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', e, e.toLowerCase());
              break;
            }
            default:
              g('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
              break;
          }
        else
          g('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
    }
    function sN(e, t) {
      e !== void 0 && !oy[e] && (e !== "collapsed" && e !== "hidden" ? (oy[e] = !0, g('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', e)) : t !== "forwards" && t !== "backwards" && (oy[e] = !0, g('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', e)));
    }
    function c1(e, t) {
      {
        var a = Wn(e), i = !a && typeof Bt(e) == "function";
        if (a || i) {
          var c = a ? "array" : "iterable";
          return g("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", c, t, c), !1;
        }
      }
      return !0;
    }
    function lN(e, t) {
      if ((t === "forwards" || t === "backwards") && e !== void 0 && e !== null && e !== !1)
        if (Wn(e)) {
          for (var a = 0; a < e.length; a++)
            if (!c1(e[a], a))
              return;
        } else {
          var i = Bt(e);
          if (typeof i == "function") {
            var c = i.call(e);
            if (c)
              for (var p = c.next(), y = 0; !p.done; p = c.next()) {
                if (!c1(p.value, y))
                  return;
                y++;
              }
          } else
            g('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', t);
        }
    }
    function Mw(e, t, a, i, c) {
      var p = e.memoizedState;
      p === null ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: i,
        tail: a,
        tailMode: c
      } : (p.isBackwards = t, p.rendering = null, p.renderingStartTime = 0, p.last = i, p.tail = a, p.tailMode = c);
    }
    function d1(e, t, a) {
      var i = t.pendingProps, c = i.revealOrder, p = i.tail, y = i.children;
      iN(c), sN(p, c), lN(y, c), Jr(e, t, y, a);
      var _ = jo.current, w = I_(_, bh);
      if (w)
        _ = A_(_, bh), t.flags |= Be;
      else {
        var C = e !== null && (e.flags & Be) !== We;
        C && aN(t, t.child, a), _ = Kd(_);
      }
      if (Ol(t, _), (t.mode & pt) === He)
        t.memoizedState = null;
      else
        switch (c) {
          case "forwards": {
            var T = oN(t.child), A;
            T === null ? (A = t.child, t.child = null) : (A = T.sibling, T.sibling = null), Mw(
              t,
              !1,
              // isBackwards
              A,
              T,
              p
            );
            break;
          }
          case "backwards": {
            var z = null, B = t.child;
            for (t.child = null; B !== null; ) {
              var H = B.alternate;
              if (H !== null && Fv(H) === null) {
                t.child = B;
                break;
              }
              var Y = B.sibling;
              B.sibling = z, z = B, B = Y;
            }
            Mw(
              t,
              !0,
              // isBackwards
              z,
              null,
              // last
              p
            );
            break;
          }
          case "together": {
            Mw(
              t,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            t.memoizedState = null;
        }
      return t.child;
    }
    function uN(e, t, a) {
      L_(t, t.stateNode.containerInfo);
      var i = t.pendingProps;
      return e === null ? t.child = qd(t, null, i, a) : Jr(e, t, i, a), t.child;
    }
    var f1 = !1;
    function cN(e, t, a) {
      var i = t.type, c = i._context, p = t.pendingProps, y = t.memoizedProps, _ = p.value;
      {
        "value" in p || f1 || (f1 = !0, g("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var w = t.type.propTypes;
        w && Mo(w, p, "prop", "Context.Provider");
      }
      if (a0(t, c, _), y !== null) {
        var C = y.value;
        if (F(C, _)) {
          if (y.children === p.children && !mv())
            return Is(e, t, a);
        } else
          iP(t, c, a);
      }
      var T = p.children;
      return Jr(e, t, T, a), t.child;
    }
    var p1 = !1;
    function dN(e, t, a) {
      var i = t.type;
      i._context === void 0 ? i !== i.Consumer && (p1 || (p1 = !0, g("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : i = i._context;
      var c = t.pendingProps, p = c.children;
      typeof p != "function" && g("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Zd(t, a);
      var y = Mn(i);
      Zr(t);
      var _;
      return Rh.current = t, Bn(!0), _ = p(y), Bn(!1), Qr(), t.flags |= La, Jr(e, t, _, a), t.child;
    }
    function Oh() {
      Bo = !0;
    }
    function sy(e, t) {
      (t.mode & pt) === He && e !== null && (e.alternate = null, t.alternate = null, t.flags |= sn);
    }
    function Is(e, t, a) {
      return e !== null && (t.dependencies = e.dependencies), V0(), Vh(t.lanes), Dr(a, t.childLanes) ? (aP(e, t), t.child) : null;
    }
    function fN(e, t, a) {
      {
        var i = t.return;
        if (i === null)
          throw new Error("Cannot swap the root fiber.");
        if (e.alternate = null, t.alternate = null, a.index = t.index, a.sibling = t.sibling, a.return = t.return, a.ref = t.ref, t === i.child)
          i.child = a;
        else {
          var c = i.child;
          if (c === null)
            throw new Error("Expected parent to have a child.");
          for (; c.sibling !== t; )
            if (c = c.sibling, c === null)
              throw new Error("Expected to find the previous sibling.");
          c.sibling = a;
        }
        var p = i.deletions;
        return p === null ? (i.deletions = [e], i.flags |= da) : p.push(e), a.flags |= sn, a;
      }
    }
    function Fw(e, t) {
      var a = e.lanes;
      return !!Dr(a, t);
    }
    function pN(e, t, a) {
      switch (t.tag) {
        case P:
          o1(t), t.stateNode, Wd();
          break;
        case M:
          f0(t);
          break;
        case E: {
          var i = t.type;
          Ti(i) && vv(t);
          break;
        }
        case O:
          L_(t, t.stateNode.containerInfo);
          break;
        case re: {
          var c = t.memoizedProps.value, p = t.type._context;
          a0(t, p, c);
          break;
        }
        case qe:
          {
            var y = Dr(a, t.childLanes);
            y && (t.flags |= wt);
            {
              var _ = t.stateNode;
              _.effectDuration = 0, _.passiveEffectDuration = 0;
            }
          }
          break;
        case Re: {
          var w = t.memoizedState;
          if (w !== null) {
            if (w.dehydrated !== null)
              return Ol(t, Kd(jo.current)), t.flags |= Be, null;
            var C = t.child, T = C.childLanes;
            if (Dr(a, T))
              return s1(e, t, a);
            Ol(t, Kd(jo.current));
            var A = Is(e, t, a);
            return A !== null ? A.sibling : null;
          } else
            Ol(t, Kd(jo.current));
          break;
        }
        case Ie: {
          var z = (e.flags & Be) !== We, B = Dr(a, t.childLanes);
          if (z) {
            if (B)
              return d1(e, t, a);
            t.flags |= Be;
          }
          var H = t.memoizedState;
          if (H !== null && (H.rendering = null, H.tail = null, H.lastEffect = null), Ol(t, jo.current), B)
            break;
          return null;
        }
        case Ae:
        case Ke:
          return t.lanes = X, n1(e, t, a);
      }
      return Is(e, t, a);
    }
    function h1(e, t, a) {
      if (t._debugNeedsRemount && e !== null)
        return fN(e, t, hk(t.type, t.key, t.pendingProps, t._debugOwner || null, t.mode, t.lanes));
      if (e !== null) {
        var i = e.memoizedProps, c = t.pendingProps;
        if (i !== c || mv() || // Force a re-render if the implementation changed due to hot reload:
        t.type !== e.type)
          Bo = !0;
        else {
          var p = Fw(e, a);
          if (!p && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (t.flags & Be) === We)
            return Bo = !1, pN(e, t, a);
          (e.flags & Uc) !== We ? Bo = !0 : Bo = !1;
        }
      } else if (Bo = !1, vr() && FR(t)) {
        var y = t.index, _ = $R();
        Vx(t, _, y);
      }
      switch (t.lanes = X, t.tag) {
        case R:
          return QP(e, t, t.type, a);
        case ye: {
          var w = t.elementType;
          return HP(e, t, w, a);
        }
        case S: {
          var C = t.type, T = t.pendingProps, A = t.elementType === C ? T : Vo(C, T);
          return Nw(e, t, C, A, a);
        }
        case E: {
          var z = t.type, B = t.pendingProps, H = t.elementType === z ? B : Vo(z, B);
          return a1(e, t, z, H, a);
        }
        case P:
          return BP(e, t, a);
        case M:
          return WP(e, t, a);
        case $:
          return qP(e, t);
        case Re:
          return s1(e, t, a);
        case O:
          return uN(e, t, a);
        case ve: {
          var Y = t.type, me = t.pendingProps, Ue = t.elementType === Y ? me : Vo(Y, me);
          return X0(e, t, Y, Ue, a);
        }
        case Z:
          return jP(e, t, a);
        case G:
          return UP(e, t, a);
        case qe:
          return VP(e, t, a);
        case re:
          return cN(e, t, a);
        case Pe:
          return dN(e, t, a);
        case ft: {
          var Qe = t.type, vt = t.pendingProps, ht = Vo(Qe, vt);
          if (t.type !== t.elementType) {
            var U = Qe.propTypes;
            U && Mo(
              U,
              ht,
              // Resolved for outer only
              "prop",
              At(Qe)
            );
          }
          return ht = Vo(Qe.type, ht), e1(e, t, Qe, ht, a);
        }
        case Oe:
          return t1(e, t, t.type, t.pendingProps, a);
        case rt: {
          var K = t.type, V = t.pendingProps, oe = t.elementType === K ? V : Vo(K, V);
          return ZP(e, t, K, oe, a);
        }
        case Ie:
          return d1(e, t, a);
        case fe:
          break;
        case Ae:
          return n1(e, t, a);
      }
      throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function tf(e) {
      e.flags |= wt;
    }
    function m1(e) {
      e.flags |= an, e.flags |= fl;
    }
    var g1, $w, v1, y1;
    g1 = function(e, t, a, i) {
      for (var c = t.child; c !== null; ) {
        if (c.tag === M || c.tag === $)
          IT(e, c.stateNode);
        else if (c.tag !== O && c.child !== null) {
          c.child.return = c, c = c.child;
          continue;
        }
        if (c === t)
          return;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === t)
            return;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
    }, $w = function(e, t) {
    }, v1 = function(e, t, a, i, c) {
      var p = e.memoizedProps;
      if (p !== i) {
        var y = t.stateNode, _ = D_(), w = MT(y, a, p, i, c, _);
        t.updateQueue = w, w && tf(t);
      }
    }, y1 = function(e, t, a, i) {
      a !== i && tf(t);
    };
    function Lh(e, t) {
      if (!vr())
        switch (e.tailMode) {
          case "hidden": {
            for (var a = e.tail, i = null; a !== null; )
              a.alternate !== null && (i = a), a = a.sibling;
            i === null ? e.tail = null : i.sibling = null;
            break;
          }
          case "collapsed": {
            for (var c = e.tail, p = null; c !== null; )
              c.alternate !== null && (p = c), c = c.sibling;
            p === null ? !t && e.tail !== null ? e.tail.sibling = null : e.tail = null : p.sibling = null;
            break;
          }
        }
    }
    function br(e) {
      var t = e.alternate !== null && e.alternate.child === e.child, a = X, i = We;
      if (t) {
        if ((e.mode & Tt) !== He) {
          for (var c = e.selfBaseDuration, p = e.child; p !== null; )
            a = ct(a, ct(p.lanes, p.childLanes)), i |= p.subtreeFlags & vn, i |= p.flags & vn, c += p.treeBaseDuration, p = p.sibling;
          e.treeBaseDuration = c;
        } else
          for (var y = e.child; y !== null; )
            a = ct(a, ct(y.lanes, y.childLanes)), i |= y.subtreeFlags & vn, i |= y.flags & vn, y.return = e, y = y.sibling;
        e.subtreeFlags |= i;
      } else {
        if ((e.mode & Tt) !== He) {
          for (var _ = e.actualDuration, w = e.selfBaseDuration, C = e.child; C !== null; )
            a = ct(a, ct(C.lanes, C.childLanes)), i |= C.subtreeFlags, i |= C.flags, _ += C.actualDuration, w += C.treeBaseDuration, C = C.sibling;
          e.actualDuration = _, e.treeBaseDuration = w;
        } else
          for (var T = e.child; T !== null; )
            a = ct(a, ct(T.lanes, T.childLanes)), i |= T.subtreeFlags, i |= T.flags, T.return = e, T = T.sibling;
        e.subtreeFlags |= i;
      }
      return e.childLanes = a, t;
    }
    function hN(e, t, a) {
      if (JR() && (t.mode & pt) !== He && (t.flags & Be) === We)
        return Kx(t), Wd(), t.flags |= Tr | pu | Pr, !1;
      var i = kv(t);
      if (a !== null && a.dehydrated !== null)
        if (e === null) {
          if (!i)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (YR(t), br(t), (t.mode & Tt) !== He) {
            var c = a !== null;
            if (c) {
              var p = t.child;
              p !== null && (t.treeBaseDuration -= p.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Wd(), (t.flags & Be) === We && (t.memoizedState = null), t.flags |= wt, br(t), (t.mode & Tt) !== He) {
            var y = a !== null;
            if (y) {
              var _ = t.child;
              _ !== null && (t.treeBaseDuration -= _.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return Yx(), !0;
    }
    function b1(e, t, a) {
      var i = t.pendingProps;
      switch (d_(t), t.tag) {
        case R:
        case ye:
        case Oe:
        case S:
        case ve:
        case Z:
        case G:
        case qe:
        case Pe:
        case ft:
          return br(t), null;
        case E: {
          var c = t.type;
          return Ti(c) && gv(t), br(t), null;
        }
        case P: {
          var p = t.stateNode;
          if (Qd(t), s_(t), F_(), p.pendingContext && (p.context = p.pendingContext, p.pendingContext = null), e === null || e.child === null) {
            var y = kv(t);
            if (y)
              tf(t);
            else if (e !== null) {
              var _ = e.memoizedState;
              (!_.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (t.flags & Tr) !== We) && (t.flags |= Sn, Yx());
            }
          }
          return $w(e, t), br(t), null;
        }
        case M: {
          z_(t);
          var w = d0(), C = t.type;
          if (e !== null && t.stateNode != null)
            v1(e, t, C, i, w), e.ref !== t.ref && m1(t);
          else {
            if (!i) {
              if (t.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return br(t), null;
            }
            var T = D_(), A = kv(t);
            if (A)
              QR(t, w, T) && tf(t);
            else {
              var z = zT(C, i, w, T, t);
              g1(z, t, !1, !1), t.stateNode = z, AT(z, C, i, w) && tf(t);
            }
            t.ref !== null && m1(t);
          }
          return br(t), null;
        }
        case $: {
          var B = i;
          if (e && t.stateNode != null) {
            var H = e.memoizedProps;
            y1(e, t, H, B);
          } else {
            if (typeof B != "string" && t.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var Y = d0(), me = D_(), Ue = kv(t);
            Ue ? KR(t) && tf(t) : t.stateNode = FT(B, Y, me, t);
          }
          return br(t), null;
        }
        case Re: {
          Yd(t);
          var Qe = t.memoizedState;
          if (e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
            var vt = hN(e, t, Qe);
            if (!vt)
              return t.flags & Pr ? t : null;
          }
          if ((t.flags & Be) !== We)
            return t.lanes = a, (t.mode & Tt) !== He && uw(t), t;
          var ht = Qe !== null, U = e !== null && e.memoizedState !== null;
          if (ht !== U && ht) {
            var K = t.child;
            if (K.flags |= gn, (t.mode & pt) !== He) {
              var V = e === null && (t.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
              V || I_(jo.current, h0) ? mO() : rk();
            }
          }
          var oe = t.updateQueue;
          if (oe !== null && (t.flags |= wt), br(t), (t.mode & Tt) !== He && ht) {
            var Ce = t.child;
            Ce !== null && (t.treeBaseDuration -= Ce.treeBaseDuration);
          }
          return null;
        }
        case O:
          return Qd(t), $w(e, t), e === null && OR(t.stateNode.containerInfo), br(t), null;
        case re:
          var we = t.type._context;
          return E_(we, t), br(t), null;
        case rt: {
          var Xe = t.type;
          return Ti(Xe) && gv(t), br(t), null;
        }
        case Ie: {
          Yd(t);
          var it = t.memoizedState;
          if (it === null)
            return br(t), null;
          var Ut = (t.flags & Be) !== We, Nt = it.rendering;
          if (Nt === null)
            if (Ut)
              Lh(it, !1);
            else {
              var Rn = vO() && (e === null || (e.flags & Be) === We);
              if (!Rn)
                for (var Ot = t.child; Ot !== null; ) {
                  var wn = Fv(Ot);
                  if (wn !== null) {
                    Ut = !0, t.flags |= Be, Lh(it, !1);
                    var jr = wn.updateQueue;
                    return jr !== null && (t.updateQueue = jr, t.flags |= wt), t.subtreeFlags = We, oP(t, a), Ol(t, A_(jo.current, bh)), t.child;
                  }
                  Ot = Ot.sibling;
                }
              it.tail !== null && En() > j1() && (t.flags |= Be, Ut = !0, Lh(it, !1), t.lanes = Sp);
            }
          else {
            if (!Ut) {
              var Sr = Fv(Nt);
              if (Sr !== null) {
                t.flags |= Be, Ut = !0;
                var Ba = Sr.updateQueue;
                if (Ba !== null && (t.updateQueue = Ba, t.flags |= wt), Lh(it, !0), it.tail === null && it.tailMode === "hidden" && !Nt.alternate && !vr())
                  return br(t), null;
              } else
                En() * 2 - it.renderingStartTime > j1() && a !== Kr && (t.flags |= Be, Ut = !0, Lh(it, !1), t.lanes = Sp);
            }
            if (it.isBackwards)
              Nt.sibling = t.child, t.child = Nt;
            else {
              var ta = it.last;
              ta !== null ? ta.sibling = Nt : t.child = Nt, it.last = Nt;
            }
          }
          if (it.tail !== null) {
            var na = it.tail;
            it.rendering = na, it.tail = na.sibling, it.renderingStartTime = En(), na.sibling = null;
            var Ur = jo.current;
            return Ut ? Ur = A_(Ur, bh) : Ur = Kd(Ur), Ol(t, Ur), na;
          }
          return br(t), null;
        }
        case fe:
          break;
        case Ae:
        case Ke: {
          nk(t);
          var js = t.memoizedState, cf = js !== null;
          if (e !== null) {
            var Zh = e.memoizedState, Ii = Zh !== null;
            Ii !== cf && (t.flags |= gn);
          }
          return !cf || (t.mode & pt) === He ? br(t) : Dr(zi, Kr) && (br(t), t.subtreeFlags & (sn | wt) && (t.flags |= gn)), null;
        }
        case et:
          return null;
        case _t:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function mN(e, t, a) {
      switch (d_(t), t.tag) {
        case E: {
          var i = t.type;
          Ti(i) && gv(t);
          var c = t.flags;
          return c & Pr ? (t.flags = c & -65537 | Be, (t.mode & Tt) !== He && uw(t), t) : null;
        }
        case P: {
          t.stateNode, Qd(t), s_(t), F_();
          var p = t.flags;
          return (p & Pr) !== We && (p & Be) === We ? (t.flags = p & -65537 | Be, t) : null;
        }
        case M:
          return z_(t), null;
        case Re: {
          Yd(t);
          var y = t.memoizedState;
          if (y !== null && y.dehydrated !== null) {
            if (t.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            Wd();
          }
          var _ = t.flags;
          return _ & Pr ? (t.flags = _ & -65537 | Be, (t.mode & Tt) !== He && uw(t), t) : null;
        }
        case Ie:
          return Yd(t), null;
        case O:
          return Qd(t), null;
        case re:
          var w = t.type._context;
          return E_(w, t), null;
        case Ae:
        case Ke:
          return nk(t), null;
        case et:
          return null;
        default:
          return null;
      }
    }
    function _1(e, t, a) {
      switch (d_(t), t.tag) {
        case E: {
          var i = t.type.childContextTypes;
          i != null && gv(t);
          break;
        }
        case P: {
          t.stateNode, Qd(t), s_(t), F_();
          break;
        }
        case M: {
          z_(t);
          break;
        }
        case O:
          Qd(t);
          break;
        case Re:
          Yd(t);
          break;
        case Ie:
          Yd(t);
          break;
        case re:
          var c = t.type._context;
          E_(c, t);
          break;
        case Ae:
        case Ke:
          nk(t);
          break;
      }
    }
    var w1 = null;
    w1 = /* @__PURE__ */ new Set();
    var ly = !1, _r = !1, gN = typeof WeakSet == "function" ? WeakSet : Set, ze = null, nf = null, rf = null;
    function vN(e) {
      si(null, function() {
        throw e;
      }), fu();
    }
    var yN = function(e, t) {
      if (t.props = e.memoizedProps, t.state = e.memoizedState, e.mode & Tt)
        try {
          Li(), t.componentWillUnmount();
        } finally {
          Oi(e);
        }
      else
        t.componentWillUnmount();
    };
    function k1(e, t) {
      try {
        zl(Gn, e);
      } catch (a) {
        Yt(e, t, a);
      }
    }
    function jw(e, t, a) {
      try {
        yN(e, a);
      } catch (i) {
        Yt(e, t, i);
      }
    }
    function bN(e, t, a) {
      try {
        a.componentDidMount();
      } catch (i) {
        Yt(e, t, i);
      }
    }
    function x1(e, t) {
      try {
        E1(e);
      } catch (a) {
        Yt(e, t, a);
      }
    }
    function af(e, t) {
      var a = e.ref;
      if (a !== null)
        if (typeof a == "function") {
          var i;
          try {
            if (On && vo && e.mode & Tt)
              try {
                Li(), i = a(null);
              } finally {
                Oi(e);
              }
            else
              i = a(null);
          } catch (c) {
            Yt(e, t, c);
          }
          typeof i == "function" && g("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", ut(e));
        } else
          a.current = null;
    }
    function uy(e, t, a) {
      try {
        a();
      } catch (i) {
        Yt(e, t, i);
      }
    }
    var S1 = !1;
    function _N(e, t) {
      LT(e.containerInfo), ze = t, wN();
      var a = S1;
      return S1 = !1, a;
    }
    function wN() {
      for (; ze !== null; ) {
        var e = ze, t = e.child;
        (e.subtreeFlags & ui) !== We && t !== null ? (t.return = e, ze = t) : kN();
      }
    }
    function kN() {
      for (; ze !== null; ) {
        var e = ze;
        Kt(e);
        try {
          xN(e);
        } catch (a) {
          Yt(e, e.return, a);
        }
        rn();
        var t = e.sibling;
        if (t !== null) {
          t.return = e.return, ze = t;
          return;
        }
        ze = e.return;
      }
    }
    function xN(e) {
      var t = e.alternate, a = e.flags;
      if ((a & Sn) !== We) {
        switch (Kt(e), e.tag) {
          case S:
          case ve:
          case Oe:
            break;
          case E: {
            if (t !== null) {
              var i = t.memoizedProps, c = t.memoizedState, p = e.stateNode;
              e.type === e.elementType && !ec && (p.props !== e.memoizedProps && g("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", ut(e) || "instance"), p.state !== e.memoizedState && g("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", ut(e) || "instance"));
              var y = p.getSnapshotBeforeUpdate(e.elementType === e.type ? i : Vo(e.type, i), c);
              {
                var _ = w1;
                y === void 0 && !_.has(e.type) && (_.add(e.type), g("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", ut(e)));
              }
              p.__reactInternalSnapshotBeforeUpdate = y;
            }
            break;
          }
          case P: {
            {
              var w = e.stateNode;
              rR(w.containerInfo);
            }
            break;
          }
          case M:
          case $:
          case O:
          case rt:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        rn();
      }
    }
    function Wo(e, t, a) {
      var i = t.updateQueue, c = i !== null ? i.lastEffect : null;
      if (c !== null) {
        var p = c.next, y = p;
        do {
          if ((y.tag & e) === e) {
            var _ = y.destroy;
            y.destroy = void 0, _ !== void 0 && ((e & yr) !== wa ? To(t) : (e & Gn) !== wa && mu(t), (e & Ri) !== wa && Wh(!0), uy(t, a, _), (e & Ri) !== wa && Wh(!1), (e & yr) !== wa ? pi() : (e & Gn) !== wa && kp());
          }
          y = y.next;
        } while (y !== p);
      }
    }
    function zl(e, t) {
      var a = t.updateQueue, i = a !== null ? a.lastEffect : null;
      if (i !== null) {
        var c = i.next, p = c;
        do {
          if ((p.tag & e) === e) {
            (e & yr) !== wa ? wp(t) : (e & Gn) !== wa && Zc(t);
            var y = p.create;
            (e & Ri) !== wa && Wh(!0), p.destroy = y(), (e & Ri) !== wa && Wh(!1), (e & yr) !== wa ? fg() : (e & Gn) !== wa && pg();
            {
              var _ = p.destroy;
              if (_ !== void 0 && typeof _ != "function") {
                var w = void 0;
                (p.tag & Gn) !== We ? w = "useLayoutEffect" : (p.tag & Ri) !== We ? w = "useInsertionEffect" : w = "useEffect";
                var C = void 0;
                _ === null ? C = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof _.then == "function" ? C = `

It looks like you wrote ` + w + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + w + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : C = " You returned: " + _, g("%s must not return anything besides a function, which is used for clean-up.%s", w, C);
              }
            }
          }
          p = p.next;
        } while (p !== c);
      }
    }
    function SN(e, t) {
      if ((t.flags & wt) !== We)
        switch (t.tag) {
          case qe: {
            var a = t.stateNode.passiveEffectDuration, i = t.memoizedProps, c = i.id, p = i.onPostCommit, y = j0(), _ = t.alternate === null ? "mount" : "update";
            $0() && (_ = "nested-update"), typeof p == "function" && p(c, _, a, y);
            var w = t.return;
            e: for (; w !== null; ) {
              switch (w.tag) {
                case P:
                  var C = w.stateNode;
                  C.passiveEffectDuration += a;
                  break e;
                case qe:
                  var T = w.stateNode;
                  T.passiveEffectDuration += a;
                  break e;
              }
              w = w.return;
            }
            break;
          }
        }
    }
    function EN(e, t, a, i) {
      if ((a.flags & di) !== We)
        switch (a.tag) {
          case S:
          case ve:
          case Oe: {
            if (!_r)
              if (a.mode & Tt)
                try {
                  Li(), zl(Gn | Yn, a);
                } finally {
                  Oi(a);
                }
              else
                zl(Gn | Yn, a);
            break;
          }
          case E: {
            var c = a.stateNode;
            if (a.flags & wt && !_r)
              if (t === null)
                if (a.type === a.elementType && !ec && (c.props !== a.memoizedProps && g("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", ut(a) || "instance"), c.state !== a.memoizedState && g("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", ut(a) || "instance")), a.mode & Tt)
                  try {
                    Li(), c.componentDidMount();
                  } finally {
                    Oi(a);
                  }
                else
                  c.componentDidMount();
              else {
                var p = a.elementType === a.type ? t.memoizedProps : Vo(a.type, t.memoizedProps), y = t.memoizedState;
                if (a.type === a.elementType && !ec && (c.props !== a.memoizedProps && g("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", ut(a) || "instance"), c.state !== a.memoizedState && g("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", ut(a) || "instance")), a.mode & Tt)
                  try {
                    Li(), c.componentDidUpdate(p, y, c.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    Oi(a);
                  }
                else
                  c.componentDidUpdate(p, y, c.__reactInternalSnapshotBeforeUpdate);
              }
            var _ = a.updateQueue;
            _ !== null && (a.type === a.elementType && !ec && (c.props !== a.memoizedProps && g("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", ut(a) || "instance"), c.state !== a.memoizedState && g("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", ut(a) || "instance")), c0(a, _, c));
            break;
          }
          case P: {
            var w = a.updateQueue;
            if (w !== null) {
              var C = null;
              if (a.child !== null)
                switch (a.child.tag) {
                  case M:
                    C = a.child.stateNode;
                    break;
                  case E:
                    C = a.child.stateNode;
                    break;
                }
              c0(a, w, C);
            }
            break;
          }
          case M: {
            var T = a.stateNode;
            if (t === null && a.flags & wt) {
              var A = a.type, z = a.memoizedProps;
              BT(T, A, z);
            }
            break;
          }
          case $:
            break;
          case O:
            break;
          case qe: {
            {
              var B = a.memoizedProps, H = B.onCommit, Y = B.onRender, me = a.stateNode.effectDuration, Ue = j0(), Qe = t === null ? "mount" : "update";
              $0() && (Qe = "nested-update"), typeof Y == "function" && Y(a.memoizedProps.id, Qe, a.actualDuration, a.treeBaseDuration, a.actualStartTime, Ue);
              {
                typeof H == "function" && H(a.memoizedProps.id, Qe, me, Ue), kO(a);
                var vt = a.return;
                e: for (; vt !== null; ) {
                  switch (vt.tag) {
                    case P:
                      var ht = vt.stateNode;
                      ht.effectDuration += me;
                      break e;
                    case qe:
                      var U = vt.stateNode;
                      U.effectDuration += me;
                      break e;
                  }
                  vt = vt.return;
                }
              }
            }
            break;
          }
          case Re: {
            DN(e, a);
            break;
          }
          case Ie:
          case rt:
          case fe:
          case Ae:
          case Ke:
          case _t:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      _r || a.flags & an && E1(a);
    }
    function CN(e) {
      switch (e.tag) {
        case S:
        case ve:
        case Oe: {
          if (e.mode & Tt)
            try {
              Li(), k1(e, e.return);
            } finally {
              Oi(e);
            }
          else
            k1(e, e.return);
          break;
        }
        case E: {
          var t = e.stateNode;
          typeof t.componentDidMount == "function" && bN(e, e.return, t), x1(e, e.return);
          break;
        }
        case M: {
          x1(e, e.return);
          break;
        }
      }
    }
    function TN(e, t) {
      for (var a = null, i = e; ; ) {
        if (i.tag === M) {
          if (a === null) {
            a = i;
            try {
              var c = i.stateNode;
              t ? XT(c) : tR(i.stateNode, i.memoizedProps);
            } catch (y) {
              Yt(e, e.return, y);
            }
          }
        } else if (i.tag === $) {
          if (a === null)
            try {
              var p = i.stateNode;
              t ? eR(p) : nR(p, i.memoizedProps);
            } catch (y) {
              Yt(e, e.return, y);
            }
        } else if (!((i.tag === Ae || i.tag === Ke) && i.memoizedState !== null && i !== e) && i.child !== null) {
          i.child.return = i, i = i.child;
          continue;
        }
        if (i === e)
          return;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === e)
            return;
          a === i && (a = null), i = i.return;
        }
        a === i && (a = null), i.sibling.return = i.return, i = i.sibling;
      }
    }
    function E1(e) {
      var t = e.ref;
      if (t !== null) {
        var a = e.stateNode, i;
        switch (e.tag) {
          case M:
            i = a;
            break;
          default:
            i = a;
        }
        if (typeof t == "function") {
          var c;
          if (e.mode & Tt)
            try {
              Li(), c = t(i);
            } finally {
              Oi(e);
            }
          else
            c = t(i);
          typeof c == "function" && g("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", ut(e));
        } else
          t.hasOwnProperty("current") || g("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", ut(e)), t.current = i;
      }
    }
    function RN(e) {
      var t = e.alternate;
      t !== null && (t.return = null), e.return = null;
    }
    function C1(e) {
      var t = e.alternate;
      t !== null && (e.alternate = null, C1(t));
      {
        if (e.child = null, e.deletions = null, e.sibling = null, e.tag === M) {
          var a = e.stateNode;
          a !== null && zR(a);
        }
        e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
      }
    }
    function PN(e) {
      for (var t = e.return; t !== null; ) {
        if (T1(t))
          return t;
        t = t.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function T1(e) {
      return e.tag === M || e.tag === P || e.tag === O;
    }
    function R1(e) {
      var t = e;
      e: for (; ; ) {
        for (; t.sibling === null; ) {
          if (t.return === null || T1(t.return))
            return null;
          t = t.return;
        }
        for (t.sibling.return = t.return, t = t.sibling; t.tag !== M && t.tag !== $ && t.tag !== st; ) {
          if (t.flags & sn || t.child === null || t.tag === O)
            continue e;
          t.child.return = t, t = t.child;
        }
        if (!(t.flags & sn))
          return t.stateNode;
      }
    }
    function NN(e) {
      var t = PN(e);
      switch (t.tag) {
        case M: {
          var a = t.stateNode;
          t.flags & Da && (Nx(a), t.flags &= -33);
          var i = R1(e);
          Vw(e, i, a);
          break;
        }
        case P:
        case O: {
          var c = t.stateNode.containerInfo, p = R1(e);
          Uw(e, p, c);
          break;
        }
        // eslint-disable-next-line-no-fallthrough
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function Uw(e, t, a) {
      var i = e.tag, c = i === M || i === $;
      if (c) {
        var p = e.stateNode;
        t ? KT(a, p, t) : ZT(a, p);
      } else if (i !== O) {
        var y = e.child;
        if (y !== null) {
          Uw(y, t, a);
          for (var _ = y.sibling; _ !== null; )
            Uw(_, t, a), _ = _.sibling;
        }
      }
    }
    function Vw(e, t, a) {
      var i = e.tag, c = i === M || i === $;
      if (c) {
        var p = e.stateNode;
        t ? QT(a, p, t) : HT(a, p);
      } else if (i !== O) {
        var y = e.child;
        if (y !== null) {
          Vw(y, t, a);
          for (var _ = y.sibling; _ !== null; )
            Vw(_, t, a), _ = _.sibling;
        }
      }
    }
    var wr = null, qo = !1;
    function ON(e, t, a) {
      {
        var i = t;
        e: for (; i !== null; ) {
          switch (i.tag) {
            case M: {
              wr = i.stateNode, qo = !1;
              break e;
            }
            case P: {
              wr = i.stateNode.containerInfo, qo = !0;
              break e;
            }
            case O: {
              wr = i.stateNode.containerInfo, qo = !0;
              break e;
            }
          }
          i = i.return;
        }
        if (wr === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        P1(e, t, a), wr = null, qo = !1;
      }
      RN(a);
    }
    function Il(e, t, a) {
      for (var i = a.child; i !== null; )
        P1(e, t, i), i = i.sibling;
    }
    function P1(e, t, a) {
      switch (yp(a), a.tag) {
        case M:
          _r || af(a, t);
        // eslint-disable-next-line-no-fallthrough
        case $: {
          {
            var i = wr, c = qo;
            wr = null, Il(e, t, a), wr = i, qo = c, wr !== null && (qo ? GT(wr, a.stateNode) : YT(wr, a.stateNode));
          }
          return;
        }
        case st: {
          wr !== null && (qo ? JT(wr, a.stateNode) : Xb(wr, a.stateNode));
          return;
        }
        case O: {
          {
            var p = wr, y = qo;
            wr = a.stateNode.containerInfo, qo = !0, Il(e, t, a), wr = p, qo = y;
          }
          return;
        }
        case S:
        case ve:
        case ft:
        case Oe: {
          if (!_r) {
            var _ = a.updateQueue;
            if (_ !== null) {
              var w = _.lastEffect;
              if (w !== null) {
                var C = w.next, T = C;
                do {
                  var A = T, z = A.destroy, B = A.tag;
                  z !== void 0 && ((B & Ri) !== wa ? uy(a, t, z) : (B & Gn) !== wa && (mu(a), a.mode & Tt ? (Li(), uy(a, t, z), Oi(a)) : uy(a, t, z), kp())), T = T.next;
                } while (T !== C);
              }
            }
          }
          Il(e, t, a);
          return;
        }
        case E: {
          if (!_r) {
            af(a, t);
            var H = a.stateNode;
            typeof H.componentWillUnmount == "function" && jw(a, t, H);
          }
          Il(e, t, a);
          return;
        }
        case fe: {
          Il(e, t, a);
          return;
        }
        case Ae: {
          if (
            // TODO: Remove this dead flag
            a.mode & pt
          ) {
            var Y = _r;
            _r = Y || a.memoizedState !== null, Il(e, t, a), _r = Y;
          } else
            Il(e, t, a);
          break;
        }
        default: {
          Il(e, t, a);
          return;
        }
      }
    }
    function LN(e) {
      e.memoizedState;
    }
    function DN(e, t) {
      var a = t.memoizedState;
      if (a === null) {
        var i = t.alternate;
        if (i !== null) {
          var c = i.memoizedState;
          if (c !== null) {
            var p = c.dehydrated;
            p !== null && vR(p);
          }
        }
      }
    }
    function N1(e) {
      var t = e.updateQueue;
      if (t !== null) {
        e.updateQueue = null;
        var a = e.stateNode;
        a === null && (a = e.stateNode = new gN()), t.forEach(function(i) {
          var c = PO.bind(null, e, i);
          if (!a.has(i)) {
            if (a.add(i), Lr)
              if (nf !== null && rf !== null)
                Bh(rf, nf);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            i.then(c, c);
          }
        });
      }
    }
    function zN(e, t, a) {
      nf = a, rf = e, Kt(t), O1(t, e), Kt(t), nf = null, rf = null;
    }
    function Ho(e, t, a) {
      var i = t.deletions;
      if (i !== null)
        for (var c = 0; c < i.length; c++) {
          var p = i[c];
          try {
            ON(e, t, p);
          } catch (w) {
            Yt(p, t, w);
          }
        }
      var y = Yl();
      if (t.subtreeFlags & ci)
        for (var _ = t.child; _ !== null; )
          Kt(_), O1(_, e), _ = _.sibling;
      Kt(y);
    }
    function O1(e, t, a) {
      var i = e.alternate, c = e.flags;
      switch (e.tag) {
        case S:
        case ve:
        case ft:
        case Oe: {
          if (Ho(t, e), Di(e), c & wt) {
            try {
              Wo(Ri | Yn, e, e.return), zl(Ri | Yn, e);
            } catch (Xe) {
              Yt(e, e.return, Xe);
            }
            if (e.mode & Tt) {
              try {
                Li(), Wo(Gn | Yn, e, e.return);
              } catch (Xe) {
                Yt(e, e.return, Xe);
              }
              Oi(e);
            } else
              try {
                Wo(Gn | Yn, e, e.return);
              } catch (Xe) {
                Yt(e, e.return, Xe);
              }
          }
          return;
        }
        case E: {
          Ho(t, e), Di(e), c & an && i !== null && af(i, i.return);
          return;
        }
        case M: {
          Ho(t, e), Di(e), c & an && i !== null && af(i, i.return);
          {
            if (e.flags & Da) {
              var p = e.stateNode;
              try {
                Nx(p);
              } catch (Xe) {
                Yt(e, e.return, Xe);
              }
            }
            if (c & wt) {
              var y = e.stateNode;
              if (y != null) {
                var _ = e.memoizedProps, w = i !== null ? i.memoizedProps : _, C = e.type, T = e.updateQueue;
                if (e.updateQueue = null, T !== null)
                  try {
                    WT(y, T, C, w, _, e);
                  } catch (Xe) {
                    Yt(e, e.return, Xe);
                  }
              }
            }
          }
          return;
        }
        case $: {
          if (Ho(t, e), Di(e), c & wt) {
            if (e.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var A = e.stateNode, z = e.memoizedProps, B = i !== null ? i.memoizedProps : z;
            try {
              qT(A, B, z);
            } catch (Xe) {
              Yt(e, e.return, Xe);
            }
          }
          return;
        }
        case P: {
          if (Ho(t, e), Di(e), c & wt && i !== null) {
            var H = i.memoizedState;
            if (H.isDehydrated)
              try {
                gR(t.containerInfo);
              } catch (Xe) {
                Yt(e, e.return, Xe);
              }
          }
          return;
        }
        case O: {
          Ho(t, e), Di(e);
          return;
        }
        case Re: {
          Ho(t, e), Di(e);
          var Y = e.child;
          if (Y.flags & gn) {
            var me = Y.stateNode, Ue = Y.memoizedState, Qe = Ue !== null;
            if (me.isHidden = Qe, Qe) {
              var vt = Y.alternate !== null && Y.alternate.memoizedState !== null;
              vt || hO();
            }
          }
          if (c & wt) {
            try {
              LN(e);
            } catch (Xe) {
              Yt(e, e.return, Xe);
            }
            N1(e);
          }
          return;
        }
        case Ae: {
          var ht = i !== null && i.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            e.mode & pt
          ) {
            var U = _r;
            _r = U || ht, Ho(t, e), _r = U;
          } else
            Ho(t, e);
          if (Di(e), c & gn) {
            var K = e.stateNode, V = e.memoizedState, oe = V !== null, Ce = e;
            if (K.isHidden = oe, oe && !ht && (Ce.mode & pt) !== He) {
              ze = Ce;
              for (var we = Ce.child; we !== null; )
                ze = we, AN(we), we = we.sibling;
            }
            TN(Ce, oe);
          }
          return;
        }
        case Ie: {
          Ho(t, e), Di(e), c & wt && N1(e);
          return;
        }
        case fe:
          return;
        default: {
          Ho(t, e), Di(e);
          return;
        }
      }
    }
    function Di(e) {
      var t = e.flags;
      if (t & sn) {
        try {
          NN(e);
        } catch (a) {
          Yt(e, e.return, a);
        }
        e.flags &= -3;
      }
      t & fa && (e.flags &= -4097);
    }
    function IN(e, t, a) {
      nf = a, rf = t, ze = e, L1(e, t, a), nf = null, rf = null;
    }
    function L1(e, t, a) {
      for (var i = (e.mode & pt) !== He; ze !== null; ) {
        var c = ze, p = c.child;
        if (c.tag === Ae && i) {
          var y = c.memoizedState !== null, _ = y || ly;
          if (_) {
            Bw(e, t, a);
            continue;
          } else {
            var w = c.alternate, C = w !== null && w.memoizedState !== null, T = C || _r, A = ly, z = _r;
            ly = _, _r = T, _r && !z && (ze = c, MN(c));
            for (var B = p; B !== null; )
              ze = B, L1(
                B,
                // New root; bubble back up to here and stop.
                t,
                a
              ), B = B.sibling;
            ze = c, ly = A, _r = z, Bw(e, t, a);
            continue;
          }
        }
        (c.subtreeFlags & di) !== We && p !== null ? (p.return = c, ze = p) : Bw(e, t, a);
      }
    }
    function Bw(e, t, a) {
      for (; ze !== null; ) {
        var i = ze;
        if ((i.flags & di) !== We) {
          var c = i.alternate;
          Kt(i);
          try {
            EN(t, c, i, a);
          } catch (y) {
            Yt(i, i.return, y);
          }
          rn();
        }
        if (i === e) {
          ze = null;
          return;
        }
        var p = i.sibling;
        if (p !== null) {
          p.return = i.return, ze = p;
          return;
        }
        ze = i.return;
      }
    }
    function AN(e) {
      for (; ze !== null; ) {
        var t = ze, a = t.child;
        switch (t.tag) {
          case S:
          case ve:
          case ft:
          case Oe: {
            if (t.mode & Tt)
              try {
                Li(), Wo(Gn, t, t.return);
              } finally {
                Oi(t);
              }
            else
              Wo(Gn, t, t.return);
            break;
          }
          case E: {
            af(t, t.return);
            var i = t.stateNode;
            typeof i.componentWillUnmount == "function" && jw(t, t.return, i);
            break;
          }
          case M: {
            af(t, t.return);
            break;
          }
          case Ae: {
            var c = t.memoizedState !== null;
            if (c) {
              D1(e);
              continue;
            }
            break;
          }
        }
        a !== null ? (a.return = t, ze = a) : D1(e);
      }
    }
    function D1(e) {
      for (; ze !== null; ) {
        var t = ze;
        if (t === e) {
          ze = null;
          return;
        }
        var a = t.sibling;
        if (a !== null) {
          a.return = t.return, ze = a;
          return;
        }
        ze = t.return;
      }
    }
    function MN(e) {
      for (; ze !== null; ) {
        var t = ze, a = t.child;
        if (t.tag === Ae) {
          var i = t.memoizedState !== null;
          if (i) {
            z1(e);
            continue;
          }
        }
        a !== null ? (a.return = t, ze = a) : z1(e);
      }
    }
    function z1(e) {
      for (; ze !== null; ) {
        var t = ze;
        Kt(t);
        try {
          CN(t);
        } catch (i) {
          Yt(t, t.return, i);
        }
        if (rn(), t === e) {
          ze = null;
          return;
        }
        var a = t.sibling;
        if (a !== null) {
          a.return = t.return, ze = a;
          return;
        }
        ze = t.return;
      }
    }
    function FN(e, t, a, i) {
      ze = t, $N(t, e, a, i);
    }
    function $N(e, t, a, i) {
      for (; ze !== null; ) {
        var c = ze, p = c.child;
        (c.subtreeFlags & Eo) !== We && p !== null ? (p.return = c, ze = p) : jN(e, t, a, i);
      }
    }
    function jN(e, t, a, i) {
      for (; ze !== null; ) {
        var c = ze;
        if ((c.flags & Rr) !== We) {
          Kt(c);
          try {
            UN(t, c, a, i);
          } catch (y) {
            Yt(c, c.return, y);
          }
          rn();
        }
        if (c === e) {
          ze = null;
          return;
        }
        var p = c.sibling;
        if (p !== null) {
          p.return = c.return, ze = p;
          return;
        }
        ze = c.return;
      }
    }
    function UN(e, t, a, i) {
      switch (t.tag) {
        case S:
        case ve:
        case Oe: {
          if (t.mode & Tt) {
            lw();
            try {
              zl(yr | Yn, t);
            } finally {
              sw(t);
            }
          } else
            zl(yr | Yn, t);
          break;
        }
      }
    }
    function VN(e) {
      ze = e, BN();
    }
    function BN() {
      for (; ze !== null; ) {
        var e = ze, t = e.child;
        if ((ze.flags & da) !== We) {
          var a = e.deletions;
          if (a !== null) {
            for (var i = 0; i < a.length; i++) {
              var c = a[i];
              ze = c, HN(c, e);
            }
            {
              var p = e.alternate;
              if (p !== null) {
                var y = p.child;
                if (y !== null) {
                  p.child = null;
                  do {
                    var _ = y.sibling;
                    y.sibling = null, y = _;
                  } while (y !== null);
                }
              }
            }
            ze = e;
          }
        }
        (e.subtreeFlags & Eo) !== We && t !== null ? (t.return = e, ze = t) : WN();
      }
    }
    function WN() {
      for (; ze !== null; ) {
        var e = ze;
        (e.flags & Rr) !== We && (Kt(e), qN(e), rn());
        var t = e.sibling;
        if (t !== null) {
          t.return = e.return, ze = t;
          return;
        }
        ze = e.return;
      }
    }
    function qN(e) {
      switch (e.tag) {
        case S:
        case ve:
        case Oe: {
          e.mode & Tt ? (lw(), Wo(yr | Yn, e, e.return), sw(e)) : Wo(yr | Yn, e, e.return);
          break;
        }
      }
    }
    function HN(e, t) {
      for (; ze !== null; ) {
        var a = ze;
        Kt(a), QN(a, t), rn();
        var i = a.child;
        i !== null ? (i.return = a, ze = i) : ZN(e);
      }
    }
    function ZN(e) {
      for (; ze !== null; ) {
        var t = ze, a = t.sibling, i = t.return;
        if (C1(t), t === e) {
          ze = null;
          return;
        }
        if (a !== null) {
          a.return = i, ze = a;
          return;
        }
        ze = i;
      }
    }
    function QN(e, t) {
      switch (e.tag) {
        case S:
        case ve:
        case Oe: {
          e.mode & Tt ? (lw(), Wo(yr, e, t), sw(e)) : Wo(yr, e, t);
          break;
        }
      }
    }
    function KN(e) {
      switch (e.tag) {
        case S:
        case ve:
        case Oe: {
          try {
            zl(Gn | Yn, e);
          } catch (a) {
            Yt(e, e.return, a);
          }
          break;
        }
        case E: {
          var t = e.stateNode;
          try {
            t.componentDidMount();
          } catch (a) {
            Yt(e, e.return, a);
          }
          break;
        }
      }
    }
    function YN(e) {
      switch (e.tag) {
        case S:
        case ve:
        case Oe: {
          try {
            zl(yr | Yn, e);
          } catch (t) {
            Yt(e, e.return, t);
          }
          break;
        }
      }
    }
    function GN(e) {
      switch (e.tag) {
        case S:
        case ve:
        case Oe: {
          try {
            Wo(Gn | Yn, e, e.return);
          } catch (a) {
            Yt(e, e.return, a);
          }
          break;
        }
        case E: {
          var t = e.stateNode;
          typeof t.componentWillUnmount == "function" && jw(e, e.return, t);
          break;
        }
      }
    }
    function JN(e) {
      switch (e.tag) {
        case S:
        case ve:
        case Oe:
          try {
            Wo(yr | Yn, e, e.return);
          } catch (t) {
            Yt(e, e.return, t);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var Dh = Symbol.for;
      Dh("selector.component"), Dh("selector.has_pseudo_class"), Dh("selector.role"), Dh("selector.test_id"), Dh("selector.text");
    }
    var XN = [];
    function eO() {
      XN.forEach(function(e) {
        return e();
      });
    }
    var tO = s.ReactCurrentActQueue;
    function nO(e) {
      {
        var t = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), a = typeof jest < "u";
        return a && t !== !1;
      }
    }
    function I1() {
      {
        var e = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !e && tO.current !== null && g("The current testing environment is not configured to support act(...)"), e;
      }
    }
    var rO = Math.ceil, Ww = s.ReactCurrentDispatcher, qw = s.ReactCurrentOwner, kr = s.ReactCurrentBatchConfig, Zo = s.ReactCurrentActQueue, er = (
      /*             */
      0
    ), A1 = (
      /*               */
      1
    ), xr = (
      /*                */
      2
    ), po = (
      /*                */
      4
    ), As = 0, zh = 1, tc = 2, cy = 3, Ih = 4, M1 = 5, Hw = 6, kt = er, Xr = null, fn = null, tr = X, zi = X, Zw = El(X), nr = As, Ah = null, dy = X, Mh = X, fy = X, Fh = null, ka = null, Qw = 0, F1 = 500, $1 = 1 / 0, aO = 500, Ms = null;
    function $h() {
      $1 = En() + aO;
    }
    function j1() {
      return $1;
    }
    var py = !1, Kw = null, of = null, nc = !1, Al = null, jh = X, Yw = [], Gw = null, oO = 50, Uh = 0, Jw = null, Xw = !1, hy = !1, iO = 50, sf = 0, my = null, gy = Wt, vy = X, U1 = !1;
    function yy() {
      return Xr;
    }
    function ea() {
      return (kt & (xr | po)) !== er ? En() : (gy !== Wt || (gy = En()), gy);
    }
    function Ml(e) {
      var t = e.mode;
      if ((t & pt) === He)
        return Je;
      if ((kt & xr) !== er && tr !== X)
        return Ru(tr);
      var a = tP() !== eP;
      if (a) {
        if (kr.transition !== null) {
          var i = kr.transition;
          i._updatedFibers || (i._updatedFibers = /* @__PURE__ */ new Set()), i._updatedFibers.add(e);
        }
        return vy === Et && (vy = Np()), vy;
      }
      var c = Ma();
      if (c !== Et)
        return c;
      var p = $T();
      return p;
    }
    function sO(e) {
      var t = e.mode;
      return (t & pt) === He ? Je : bg();
    }
    function rr(e, t, a, i) {
      OO(), U1 && g("useInsertionEffect must not schedule updates."), Xw && (hy = !0), bs(e, a, i), (kt & xr) !== X && e === Xr ? zO(t) : (Lr && vd(e, t, a), IO(t), e === Xr && ((kt & xr) === er && (Mh = ct(Mh, a)), nr === Ih && Fl(e, tr)), xa(e, i), a === Je && kt === er && (t.mode & pt) === He && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !Zo.isBatchingLegacy && ($h(), Ux()));
    }
    function lO(e, t, a) {
      var i = e.current;
      i.lanes = t, bs(e, t, a), xa(e, a);
    }
    function uO(e) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (kt & xr) !== er
      );
    }
    function xa(e, t) {
      var a = e.callbackNode;
      pd(e, t);
      var i = fd(e, e === Xr ? tr : X);
      if (i === X) {
        a !== null && rS(a), e.callbackNode = null, e.callbackPriority = Et;
        return;
      }
      var c = gi(i), p = e.callbackPriority;
      if (p === c && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(Zo.current !== null && a !== ik)) {
        a == null && p !== Je && g("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      a != null && rS(a);
      var y;
      if (c === Je)
        e.tag === Cl ? (Zo.isBatchingLegacy !== null && (Zo.didScheduleLegacyUpdate = !0), MR(W1.bind(null, e))) : jx(W1.bind(null, e)), Zo.current !== null ? Zo.current.push(Tl) : UT(function() {
          (kt & (xr | po)) === er && Tl();
        }), y = null;
      else {
        var _;
        switch (Zn(i)) {
          case zr:
            _ = hu;
            break;
          case Aa:
            _ = fi;
            break;
          case ro:
            _ = Co;
            break;
          case _s:
            _ = is;
            break;
          default:
            _ = Co;
            break;
        }
        y = sk(_, V1.bind(null, e));
      }
      e.callbackPriority = c, e.callbackNode = y;
    }
    function V1(e, t) {
      if (TP(), gy = Wt, vy = X, (kt & (xr | po)) !== er)
        throw new Error("Should not already be working.");
      var a = e.callbackNode, i = $s();
      if (i && e.callbackNode !== a)
        return null;
      var c = fd(e, e === Xr ? tr : X);
      if (c === X)
        return null;
      var p = !md(e, c) && !yg(e, c) && !t, y = p ? bO(e, c) : _y(e, c);
      if (y !== As) {
        if (y === tc) {
          var _ = hd(e);
          _ !== X && (c = _, y = ek(e, _));
        }
        if (y === zh) {
          var w = Ah;
          throw rc(e, X), Fl(e, c), xa(e, En()), w;
        }
        if (y === Hw)
          Fl(e, c);
        else {
          var C = !md(e, c), T = e.current.alternate;
          if (C && !dO(T)) {
            if (y = _y(e, c), y === tc) {
              var A = hd(e);
              A !== X && (c = A, y = ek(e, A));
            }
            if (y === zh) {
              var z = Ah;
              throw rc(e, X), Fl(e, c), xa(e, En()), z;
            }
          }
          e.finishedWork = T, e.finishedLanes = c, cO(e, y, c);
        }
      }
      return xa(e, En()), e.callbackNode === a ? V1.bind(null, e) : null;
    }
    function ek(e, t) {
      var a = Fh;
      if (yd(e)) {
        var i = rc(e, t);
        i.flags |= Tr, NR(e.containerInfo);
      }
      var c = _y(e, t);
      if (c !== tc) {
        var p = ka;
        ka = a, p !== null && B1(p);
      }
      return c;
    }
    function B1(e) {
      ka === null ? ka = e : ka.push.apply(ka, e);
    }
    function cO(e, t, a) {
      switch (t) {
        case As:
        case zh:
          throw new Error("Root did not complete. This is a bug in React.");
        // Flow knows about invariant, so it complains if I add a break
        // statement, but eslint doesn't know about invariant, so it complains
        // if I do. eslint-disable-next-line no-fallthrough
        case tc: {
          ac(e, ka, Ms);
          break;
        }
        case cy: {
          if (Fl(e, a), vs(a) && // do not delay if we're inside an act() scope
          !aS()) {
            var i = Qw + F1 - En();
            if (i > 10) {
              var c = fd(e, X);
              if (c !== X)
                break;
              var p = e.suspendedLanes;
              if (!ys(p, a)) {
                ea(), Dp(e, p);
                break;
              }
              e.timeoutHandle = Gb(ac.bind(null, e, ka, Ms), i);
              break;
            }
          }
          ac(e, ka, Ms);
          break;
        }
        case Ih: {
          if (Fl(e, a), Rp(a))
            break;
          if (!aS()) {
            var y = Ia(e, a), _ = y, w = En() - _, C = NO(w) - w;
            if (C > 10) {
              e.timeoutHandle = Gb(ac.bind(null, e, ka, Ms), C);
              break;
            }
          }
          ac(e, ka, Ms);
          break;
        }
        case M1: {
          ac(e, ka, Ms);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function dO(e) {
      for (var t = e; ; ) {
        if (t.flags & dl) {
          var a = t.updateQueue;
          if (a !== null) {
            var i = a.stores;
            if (i !== null)
              for (var c = 0; c < i.length; c++) {
                var p = i[c], y = p.getSnapshot, _ = p.value;
                try {
                  if (!F(y(), _))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var w = t.child;
        if (t.subtreeFlags & dl && w !== null) {
          w.return = t, t = w;
          continue;
        }
        if (t === e)
          return !0;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return !0;
    }
    function Fl(e, t) {
      t = Pu(t, fy), t = Pu(t, Mh), _g(e, t);
    }
    function W1(e) {
      if (RP(), (kt & (xr | po)) !== er)
        throw new Error("Should not already be working.");
      $s();
      var t = fd(e, X);
      if (!Dr(t, Je))
        return xa(e, En()), null;
      var a = _y(e, t);
      if (e.tag !== Cl && a === tc) {
        var i = hd(e);
        i !== X && (t = i, a = ek(e, i));
      }
      if (a === zh) {
        var c = Ah;
        throw rc(e, X), Fl(e, t), xa(e, En()), c;
      }
      if (a === Hw)
        throw new Error("Root did not complete. This is a bug in React.");
      var p = e.current.alternate;
      return e.finishedWork = p, e.finishedLanes = t, ac(e, ka, Ms), xa(e, En()), null;
    }
    function fO(e, t) {
      t !== X && (Nu(e, ct(t, Je)), xa(e, En()), (kt & (xr | po)) === er && ($h(), Tl()));
    }
    function tk(e, t) {
      var a = kt;
      kt |= A1;
      try {
        return e(t);
      } finally {
        kt = a, kt === er && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !Zo.isBatchingLegacy && ($h(), Ux());
      }
    }
    function pO(e, t, a, i, c) {
      var p = Ma(), y = kr.transition;
      try {
        return kr.transition = null, Cn(zr), e(t, a, i, c);
      } finally {
        Cn(p), kr.transition = y, kt === er && $h();
      }
    }
    function Fs(e) {
      Al !== null && Al.tag === Cl && (kt & (xr | po)) === er && $s();
      var t = kt;
      kt |= A1;
      var a = kr.transition, i = Ma();
      try {
        return kr.transition = null, Cn(zr), e ? e() : void 0;
      } finally {
        Cn(i), kr.transition = a, kt = t, (kt & (xr | po)) === er && Tl();
      }
    }
    function q1() {
      return (kt & (xr | po)) !== er;
    }
    function by(e, t) {
      Fr(Zw, zi, e), zi = ct(zi, t);
    }
    function nk(e) {
      zi = Zw.current, Mr(Zw, e);
    }
    function rc(e, t) {
      e.finishedWork = null, e.finishedLanes = X;
      var a = e.timeoutHandle;
      if (a !== Jb && (e.timeoutHandle = Jb, jT(a)), fn !== null)
        for (var i = fn.return; i !== null; ) {
          var c = i.alternate;
          _1(c, i), i = i.return;
        }
      Xr = e;
      var p = oc(e.current, null);
      return fn = p, tr = zi = t, nr = As, Ah = null, dy = X, Mh = X, fy = X, Fh = null, ka = null, lP(), $o.discardPendingWarnings(), p;
    }
    function H1(e, t) {
      do {
        var a = fn;
        try {
          if (Rv(), g0(), rn(), qw.current = null, a === null || a.return === null) {
            nr = zh, Ah = t, fn = null;
            return;
          }
          if (On && a.mode & Tt && ry(a, !0), or)
            if (Qr(), t !== null && typeof t == "object" && typeof t.then == "function") {
              var i = t;
              no(a, i, tr);
            } else
              gu(a, t, tr);
          MP(e, a.return, a, t, tr), Y1(a);
        } catch (c) {
          t = c, fn === a && a !== null ? (a = a.return, fn = a) : a = fn;
          continue;
        }
        return;
      } while (!0);
    }
    function Z1() {
      var e = Ww.current;
      return Ww.current = Jv, e === null ? Jv : e;
    }
    function Q1(e) {
      Ww.current = e;
    }
    function hO() {
      Qw = En();
    }
    function Vh(e) {
      dy = ct(e, dy);
    }
    function mO() {
      nr === As && (nr = cy);
    }
    function rk() {
      (nr === As || nr === cy || nr === tc) && (nr = Ih), Xr !== null && (Tu(dy) || Tu(Mh)) && Fl(Xr, tr);
    }
    function gO(e) {
      nr !== Ih && (nr = tc), Fh === null ? Fh = [e] : Fh.push(e);
    }
    function vO() {
      return nr === As;
    }
    function _y(e, t) {
      var a = kt;
      kt |= xr;
      var i = Z1();
      if (Xr !== e || tr !== t) {
        if (Lr) {
          var c = e.memoizedUpdaters;
          c.size > 0 && (Bh(e, tr), c.clear()), Ou(e, t);
        }
        Ms = kg(), rc(e, t);
      }
      cs(t);
      do
        try {
          yO();
          break;
        } catch (p) {
          H1(e, p);
        }
      while (!0);
      if (Rv(), kt = a, Q1(i), fn !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return Qc(), Xr = null, tr = X, nr;
    }
    function yO() {
      for (; fn !== null; )
        K1(fn);
    }
    function bO(e, t) {
      var a = kt;
      kt |= xr;
      var i = Z1();
      if (Xr !== e || tr !== t) {
        if (Lr) {
          var c = e.memoizedUpdaters;
          c.size > 0 && (Bh(e, tr), c.clear()), Ou(e, t);
        }
        Ms = kg(), $h(), rc(e, t);
      }
      cs(t);
      do
        try {
          _O();
          break;
        } catch (p) {
          H1(e, p);
        }
      while (!0);
      return Rv(), Q1(i), kt = a, fn !== null ? (hg(), As) : (Qc(), Xr = null, tr = X, nr);
    }
    function _O() {
      for (; fn !== null && !pp(); )
        K1(fn);
    }
    function K1(e) {
      var t = e.alternate;
      Kt(e);
      var a;
      (e.mode & Tt) !== He ? (iw(e), a = ak(t, e, zi), ry(e, !0)) : a = ak(t, e, zi), rn(), e.memoizedProps = e.pendingProps, a === null ? Y1(e) : fn = a, qw.current = null;
    }
    function Y1(e) {
      var t = e;
      do {
        var a = t.alternate, i = t.return;
        if ((t.flags & pu) === We) {
          Kt(t);
          var c = void 0;
          if ((t.mode & Tt) === He ? c = b1(a, t, zi) : (iw(t), c = b1(a, t, zi), ry(t, !1)), rn(), c !== null) {
            fn = c;
            return;
          }
        } else {
          var p = mN(a, t);
          if (p !== null) {
            p.flags &= lg, fn = p;
            return;
          }
          if ((t.mode & Tt) !== He) {
            ry(t, !1);
            for (var y = t.actualDuration, _ = t.child; _ !== null; )
              y += _.actualDuration, _ = _.sibling;
            t.actualDuration = y;
          }
          if (i !== null)
            i.flags |= pu, i.subtreeFlags = We, i.deletions = null;
          else {
            nr = Hw, fn = null;
            return;
          }
        }
        var w = t.sibling;
        if (w !== null) {
          fn = w;
          return;
        }
        t = i, fn = t;
      } while (t !== null);
      nr === As && (nr = M1);
    }
    function ac(e, t, a) {
      var i = Ma(), c = kr.transition;
      try {
        kr.transition = null, Cn(zr), wO(e, t, a, i);
      } finally {
        kr.transition = c, Cn(i);
      }
      return null;
    }
    function wO(e, t, a, i) {
      do
        $s();
      while (Al !== null);
      if (LO(), (kt & (xr | po)) !== er)
        throw new Error("Should not already be working.");
      var c = e.finishedWork, p = e.finishedLanes;
      if (bp(p), c === null)
        return _p(), null;
      if (p === X && g("root.finishedLanes should not be empty during a commit. This is a bug in React."), e.finishedWork = null, e.finishedLanes = X, c === e.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      e.callbackNode = null, e.callbackPriority = Et;
      var y = ct(c.lanes, c.childLanes);
      zp(e, y), e === Xr && (Xr = null, fn = null, tr = X), ((c.subtreeFlags & Eo) !== We || (c.flags & Eo) !== We) && (nc || (nc = !0, Gw = a, sk(Co, function() {
        return $s(), null;
      })));
      var _ = (c.subtreeFlags & (ui | ci | di | Eo)) !== We, w = (c.flags & (ui | ci | di | Eo)) !== We;
      if (_ || w) {
        var C = kr.transition;
        kr.transition = null;
        var T = Ma();
        Cn(zr);
        var A = kt;
        kt |= po, qw.current = null, _N(e, c), U0(), zN(e, c, p), DT(e.containerInfo), e.current = c, vu(p), IN(c, e, p), yu(), hp(), kt = A, Cn(T), kr.transition = C;
      } else
        e.current = c, U0();
      var z = nc;
      if (nc ? (nc = !1, Al = e, jh = p) : (sf = 0, my = null), y = e.pendingLanes, y === X && (of = null), z || eS(e.current, !1), gp(c.stateNode, i), Lr && e.memoizedUpdaters.clear(), eO(), xa(e, En()), t !== null)
        for (var B = e.onRecoverableError, H = 0; H < t.length; H++) {
          var Y = t[H], me = Y.stack, Ue = Y.digest;
          B(Y.value, {
            componentStack: me,
            digest: Ue
          });
        }
      if (py) {
        py = !1;
        var Qe = Kw;
        throw Kw = null, Qe;
      }
      return Dr(jh, Je) && e.tag !== Cl && $s(), y = e.pendingLanes, Dr(y, Je) ? (CP(), e === Jw ? Uh++ : (Uh = 0, Jw = e)) : Uh = 0, Tl(), _p(), null;
    }
    function $s() {
      if (Al !== null) {
        var e = Zn(jh), t = Sg(ro, e), a = kr.transition, i = Ma();
        try {
          return kr.transition = null, Cn(t), xO();
        } finally {
          Cn(i), kr.transition = a;
        }
      }
      return !1;
    }
    function kO(e) {
      Yw.push(e), nc || (nc = !0, sk(Co, function() {
        return $s(), null;
      }));
    }
    function xO() {
      if (Al === null)
        return !1;
      var e = Gw;
      Gw = null;
      var t = Al, a = jh;
      if (Al = null, jh = X, (kt & (xr | po)) !== er)
        throw new Error("Cannot flush passive effects while already rendering.");
      Xw = !0, hy = !1, us(a);
      var i = kt;
      kt |= po, VN(t.current), FN(t, t.current, a, e);
      {
        var c = Yw;
        Yw = [];
        for (var p = 0; p < c.length; p++) {
          var y = c[p];
          SN(t, y);
        }
      }
      xp(), eS(t.current, !0), kt = i, Tl(), hy ? t === my ? sf++ : (sf = 0, my = t) : sf = 0, Xw = !1, hy = !1, vp(t);
      {
        var _ = t.current.stateNode;
        _.effectDuration = 0, _.passiveEffectDuration = 0;
      }
      return !0;
    }
    function G1(e) {
      return of !== null && of.has(e);
    }
    function SO(e) {
      of === null ? of = /* @__PURE__ */ new Set([e]) : of.add(e);
    }
    function EO(e) {
      py || (py = !0, Kw = e);
    }
    var CO = EO;
    function J1(e, t, a) {
      var i = Xu(a, t), c = K0(e, i, Je), p = Pl(e, c, Je), y = ea();
      p !== null && (bs(p, Je, y), xa(p, y));
    }
    function Yt(e, t, a) {
      if (vN(a), Wh(!1), e.tag === P) {
        J1(e, e, a);
        return;
      }
      var i = null;
      for (i = t; i !== null; ) {
        if (i.tag === P) {
          J1(i, e, a);
          return;
        } else if (i.tag === E) {
          var c = i.type, p = i.stateNode;
          if (typeof c.getDerivedStateFromError == "function" || typeof p.componentDidCatch == "function" && !G1(p)) {
            var y = Xu(a, e), _ = Sw(i, y, Je), w = Pl(i, _, Je), C = ea();
            w !== null && (bs(w, Je, C), xa(w, C));
            return;
          }
        }
        i = i.return;
      }
      g(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, a);
    }
    function TO(e, t, a) {
      var i = e.pingCache;
      i !== null && i.delete(t);
      var c = ea();
      Dp(e, a), AO(e), Xr === e && ys(tr, a) && (nr === Ih || nr === cy && vs(tr) && En() - Qw < F1 ? rc(e, X) : fy = ct(fy, a)), xa(e, c);
    }
    function X1(e, t) {
      t === Et && (t = sO(e));
      var a = ea(), i = _a(e, t);
      i !== null && (bs(i, t, a), xa(i, a));
    }
    function RO(e) {
      var t = e.memoizedState, a = Et;
      t !== null && (a = t.retryLane), X1(e, a);
    }
    function PO(e, t) {
      var a = Et, i;
      switch (e.tag) {
        case Re:
          i = e.stateNode;
          var c = e.memoizedState;
          c !== null && (a = c.retryLane);
          break;
        case Ie:
          i = e.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      i !== null && i.delete(t), X1(e, a);
    }
    function NO(e) {
      return e < 120 ? 120 : e < 480 ? 480 : e < 1080 ? 1080 : e < 1920 ? 1920 : e < 3e3 ? 3e3 : e < 4320 ? 4320 : rO(e / 1960) * 1960;
    }
    function OO() {
      if (Uh > oO)
        throw Uh = 0, Jw = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      sf > iO && (sf = 0, my = null, g("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function LO() {
      $o.flushLegacyContextWarning(), $o.flushPendingUnsafeLifecycleWarnings();
    }
    function eS(e, t) {
      Kt(e), wy(e, li, GN), t && wy(e, Xa, JN), wy(e, li, KN), t && wy(e, Xa, YN), rn();
    }
    function wy(e, t, a) {
      for (var i = e, c = null; i !== null; ) {
        var p = i.subtreeFlags & t;
        i !== c && i.child !== null && p !== We ? i = i.child : ((i.flags & t) !== We && a(i), i.sibling !== null ? i = i.sibling : i = c = i.return);
      }
    }
    var ky = null;
    function tS(e) {
      {
        if ((kt & xr) !== er || !(e.mode & pt))
          return;
        var t = e.tag;
        if (t !== R && t !== P && t !== E && t !== S && t !== ve && t !== ft && t !== Oe)
          return;
        var a = ut(e) || "ReactComponent";
        if (ky !== null) {
          if (ky.has(a))
            return;
          ky.add(a);
        } else
          ky = /* @__PURE__ */ new Set([a]);
        var i = mr;
        try {
          Kt(e), g("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          i ? Kt(e) : rn();
        }
      }
    }
    var ak;
    {
      var DO = null;
      ak = function(e, t, a) {
        var i = lS(DO, t);
        try {
          return h1(e, t, a);
        } catch (p) {
          if (qR() || p !== null && typeof p == "object" && typeof p.then == "function")
            throw p;
          if (Rv(), g0(), _1(e, t), lS(t, i), t.mode & Tt && iw(t), si(null, h1, null, e, t, a), xo()) {
            var c = fu();
            typeof c == "object" && c !== null && c._suppressLogging && typeof p == "object" && p !== null && !p._suppressLogging && (p._suppressLogging = !0);
          }
          throw p;
        }
      };
    }
    var nS = !1, ok;
    ok = /* @__PURE__ */ new Set();
    function zO(e) {
      if (ti && !xP())
        switch (e.tag) {
          case S:
          case ve:
          case Oe: {
            var t = fn && ut(fn) || "Unknown", a = t;
            if (!ok.has(a)) {
              ok.add(a);
              var i = ut(e) || "Unknown";
              g("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", i, t, t);
            }
            break;
          }
          case E: {
            nS || (g("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), nS = !0);
            break;
          }
        }
    }
    function Bh(e, t) {
      if (Lr) {
        var a = e.memoizedUpdaters;
        a.forEach(function(i) {
          vd(e, i, t);
        });
      }
    }
    var ik = {};
    function sk(e, t) {
      {
        var a = Zo.current;
        return a !== null ? (a.push(t), ik) : fp(e, t);
      }
    }
    function rS(e) {
      if (e !== ik)
        return cg(e);
    }
    function aS() {
      return Zo.current !== null;
    }
    function IO(e) {
      {
        if (e.mode & pt) {
          if (!I1())
            return;
        } else if (!nO() || kt !== er || e.tag !== S && e.tag !== ve && e.tag !== Oe)
          return;
        if (Zo.current === null) {
          var t = mr;
          try {
            Kt(e), g(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, ut(e));
          } finally {
            t ? Kt(e) : rn();
          }
        }
      }
    }
    function AO(e) {
      e.tag !== Cl && I1() && Zo.current === null && g(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function Wh(e) {
      U1 = e;
    }
    var ho = null, lf = null, MO = function(e) {
      ho = e;
    };
    function uf(e) {
      {
        if (ho === null)
          return e;
        var t = ho(e);
        return t === void 0 ? e : t.current;
      }
    }
    function lk(e) {
      return uf(e);
    }
    function uk(e) {
      {
        if (ho === null)
          return e;
        var t = ho(e);
        if (t === void 0) {
          if (e != null && typeof e.render == "function") {
            var a = uf(e.render);
            if (e.render !== a) {
              var i = {
                $$typeof: Gs,
                render: a
              };
              return e.displayName !== void 0 && (i.displayName = e.displayName), i;
            }
          }
          return e;
        }
        return t.current;
      }
    }
    function oS(e, t) {
      {
        if (ho === null)
          return !1;
        var a = e.elementType, i = t.type, c = !1, p = typeof i == "object" && i !== null ? i.$$typeof : null;
        switch (e.tag) {
          case E: {
            typeof i == "function" && (c = !0);
            break;
          }
          case S: {
            (typeof i == "function" || p === lr) && (c = !0);
            break;
          }
          case ve: {
            (p === Gs || p === lr) && (c = !0);
            break;
          }
          case ft:
          case Oe: {
            (p === Ra || p === lr) && (c = !0);
            break;
          }
          default:
            return !1;
        }
        if (c) {
          var y = ho(a);
          if (y !== void 0 && y === ho(i))
            return !0;
        }
        return !1;
      }
    }
    function iS(e) {
      {
        if (ho === null || typeof WeakSet != "function")
          return;
        lf === null && (lf = /* @__PURE__ */ new WeakSet()), lf.add(e);
      }
    }
    var FO = function(e, t) {
      {
        if (ho === null)
          return;
        var a = t.staleFamilies, i = t.updatedFamilies;
        $s(), Fs(function() {
          ck(e.current, i, a);
        });
      }
    }, $O = function(e, t) {
      {
        if (e.context !== Ua)
          return;
        $s(), Fs(function() {
          qh(t, e, null, null);
        });
      }
    };
    function ck(e, t, a) {
      {
        var i = e.alternate, c = e.child, p = e.sibling, y = e.tag, _ = e.type, w = null;
        switch (y) {
          case S:
          case Oe:
          case E:
            w = _;
            break;
          case ve:
            w = _.render;
            break;
        }
        if (ho === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var C = !1, T = !1;
        if (w !== null) {
          var A = ho(w);
          A !== void 0 && (a.has(A) ? T = !0 : t.has(A) && (y === E ? T = !0 : C = !0));
        }
        if (lf !== null && (lf.has(e) || i !== null && lf.has(i)) && (T = !0), T && (e._debugNeedsRemount = !0), T || C) {
          var z = _a(e, Je);
          z !== null && rr(z, e, Je, Wt);
        }
        c !== null && !T && ck(c, t, a), p !== null && ck(p, t, a);
      }
    }
    var jO = function(e, t) {
      {
        var a = /* @__PURE__ */ new Set(), i = new Set(t.map(function(c) {
          return c.current;
        }));
        return dk(e.current, i, a), a;
      }
    };
    function dk(e, t, a) {
      {
        var i = e.child, c = e.sibling, p = e.tag, y = e.type, _ = null;
        switch (p) {
          case S:
          case Oe:
          case E:
            _ = y;
            break;
          case ve:
            _ = y.render;
            break;
        }
        var w = !1;
        _ !== null && t.has(_) && (w = !0), w ? UO(e, a) : i !== null && dk(i, t, a), c !== null && dk(c, t, a);
      }
    }
    function UO(e, t) {
      {
        var a = VO(e, t);
        if (a)
          return;
        for (var i = e; ; ) {
          switch (i.tag) {
            case M:
              t.add(i.stateNode);
              return;
            case O:
              t.add(i.stateNode.containerInfo);
              return;
            case P:
              t.add(i.stateNode.containerInfo);
              return;
          }
          if (i.return === null)
            throw new Error("Expected to reach root first.");
          i = i.return;
        }
      }
    }
    function VO(e, t) {
      for (var a = e, i = !1; ; ) {
        if (a.tag === M)
          i = !0, t.add(a.stateNode);
        else if (a.child !== null) {
          a.child.return = a, a = a.child;
          continue;
        }
        if (a === e)
          return i;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === e)
            return i;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return !1;
    }
    var fk;
    {
      fk = !1;
      try {
        var x3 = Object.preventExtensions({});
      } catch {
        fk = !0;
      }
    }
    function BO(e, t, a, i) {
      this.tag = e, this.key = a, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = t, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = i, this.flags = We, this.subtreeFlags = We, this.deletions = null, this.lanes = X, this.childLanes = X, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !fk && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var Va = function(e, t, a, i) {
      return new BO(e, t, a, i);
    };
    function pk(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function WO(e) {
      return typeof e == "function" && !pk(e) && e.defaultProps === void 0;
    }
    function qO(e) {
      if (typeof e == "function")
        return pk(e) ? E : S;
      if (e != null) {
        var t = e.$$typeof;
        if (t === Gs)
          return ve;
        if (t === Ra)
          return ft;
      }
      return R;
    }
    function oc(e, t) {
      var a = e.alternate;
      a === null ? (a = Va(e.tag, t, e.key, e.mode), a.elementType = e.elementType, a.type = e.type, a.stateNode = e.stateNode, a._debugSource = e._debugSource, a._debugOwner = e._debugOwner, a._debugHookTypes = e._debugHookTypes, a.alternate = e, e.alternate = a) : (a.pendingProps = t, a.type = e.type, a.flags = We, a.subtreeFlags = We, a.deletions = null, a.actualDuration = 0, a.actualStartTime = -1), a.flags = e.flags & vn, a.childLanes = e.childLanes, a.lanes = e.lanes, a.child = e.child, a.memoizedProps = e.memoizedProps, a.memoizedState = e.memoizedState, a.updateQueue = e.updateQueue;
      var i = e.dependencies;
      switch (a.dependencies = i === null ? null : {
        lanes: i.lanes,
        firstContext: i.firstContext
      }, a.sibling = e.sibling, a.index = e.index, a.ref = e.ref, a.selfBaseDuration = e.selfBaseDuration, a.treeBaseDuration = e.treeBaseDuration, a._debugNeedsRemount = e._debugNeedsRemount, a.tag) {
        case R:
        case S:
        case Oe:
          a.type = uf(e.type);
          break;
        case E:
          a.type = lk(e.type);
          break;
        case ve:
          a.type = uk(e.type);
          break;
      }
      return a;
    }
    function HO(e, t) {
      e.flags &= vn | sn;
      var a = e.alternate;
      if (a === null)
        e.childLanes = X, e.lanes = t, e.child = null, e.subtreeFlags = We, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0;
      else {
        e.childLanes = a.childLanes, e.lanes = a.lanes, e.child = a.child, e.subtreeFlags = We, e.deletions = null, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, e.type = a.type;
        var i = a.dependencies;
        e.dependencies = i === null ? null : {
          lanes: i.lanes,
          firstContext: i.firstContext
        }, e.selfBaseDuration = a.selfBaseDuration, e.treeBaseDuration = a.treeBaseDuration;
      }
      return e;
    }
    function ZO(e, t, a) {
      var i;
      return e === yv ? (i = pt, t === !0 && (i |= $t, i |= Rt)) : i = He, Lr && (i |= Tt), Va(P, null, null, i);
    }
    function hk(e, t, a, i, c, p) {
      var y = R, _ = e;
      if (typeof e == "function")
        pk(e) ? (y = E, _ = lk(_)) : _ = uf(_);
      else if (typeof e == "string")
        y = M;
      else
        e: switch (e) {
          case Qs:
            return $l(a.children, c, p, t);
          case Wi:
            y = G, c |= $t, (c & pt) !== He && (c |= Rt);
            break;
          case Ks:
            return QO(a, c, p, t);
          case pc:
            return KO(a, c, p, t);
          case hc:
            return YO(a, c, p, t);
          case Of:
            return sS(a, c, p, t);
          case Sm:
          // eslint-disable-next-line no-fallthrough
          case xm:
          // eslint-disable-next-line no-fallthrough
          case Em:
          // eslint-disable-next-line no-fallthrough
          case Cm:
          // eslint-disable-next-line no-fallthrough
          case rb:
          // eslint-disable-next-line no-fallthrough
          default: {
            if (typeof e == "object" && e !== null)
              switch (e.$$typeof) {
                case Ys:
                  y = re;
                  break e;
                case Zl:
                  y = Pe;
                  break e;
                case Gs:
                  y = ve, _ = uk(_);
                  break e;
                case Ra:
                  y = ft;
                  break e;
                case lr:
                  y = ye, _ = null;
                  break e;
              }
            var w = "";
            {
              (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var C = i ? ut(i) : null;
              C && (w += `

Check the render method of \`` + C + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (e == null ? e : typeof e) + "." + w));
          }
        }
      var T = Va(y, a, t, c);
      return T.elementType = e, T.type = _, T.lanes = p, T._debugOwner = i, T;
    }
    function mk(e, t, a) {
      var i = null;
      i = e._owner;
      var c = e.type, p = e.key, y = e.props, _ = hk(c, p, y, i, t, a);
      return _._debugSource = e._source, _._debugOwner = e._owner, _;
    }
    function $l(e, t, a, i) {
      var c = Va(Z, e, i, t);
      return c.lanes = a, c;
    }
    function QO(e, t, a, i) {
      typeof e.id != "string" && g('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof e.id);
      var c = Va(qe, e, i, t | Tt);
      return c.elementType = Ks, c.lanes = a, c.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, c;
    }
    function KO(e, t, a, i) {
      var c = Va(Re, e, i, t);
      return c.elementType = pc, c.lanes = a, c;
    }
    function YO(e, t, a, i) {
      var c = Va(Ie, e, i, t);
      return c.elementType = hc, c.lanes = a, c;
    }
    function sS(e, t, a, i) {
      var c = Va(Ae, e, i, t);
      c.elementType = Of, c.lanes = a;
      var p = {
        isHidden: !1
      };
      return c.stateNode = p, c;
    }
    function gk(e, t, a) {
      var i = Va($, e, null, t);
      return i.lanes = a, i;
    }
    function GO() {
      var e = Va(M, null, null, He);
      return e.elementType = "DELETED", e;
    }
    function JO(e) {
      var t = Va(st, null, null, He);
      return t.stateNode = e, t;
    }
    function vk(e, t, a) {
      var i = e.children !== null ? e.children : [], c = Va(O, i, e.key, t);
      return c.lanes = a, c.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: e.implementation
      }, c;
    }
    function lS(e, t) {
      return e === null && (e = Va(R, null, null, He)), e.tag = t.tag, e.key = t.key, e.elementType = t.elementType, e.type = t.type, e.stateNode = t.stateNode, e.return = t.return, e.child = t.child, e.sibling = t.sibling, e.index = t.index, e.ref = t.ref, e.pendingProps = t.pendingProps, e.memoizedProps = t.memoizedProps, e.updateQueue = t.updateQueue, e.memoizedState = t.memoizedState, e.dependencies = t.dependencies, e.mode = t.mode, e.flags = t.flags, e.subtreeFlags = t.subtreeFlags, e.deletions = t.deletions, e.lanes = t.lanes, e.childLanes = t.childLanes, e.alternate = t.alternate, e.actualDuration = t.actualDuration, e.actualStartTime = t.actualStartTime, e.selfBaseDuration = t.selfBaseDuration, e.treeBaseDuration = t.treeBaseDuration, e._debugSource = t._debugSource, e._debugOwner = t._debugOwner, e._debugNeedsRemount = t._debugNeedsRemount, e._debugHookTypes = t._debugHookTypes, e;
    }
    function XO(e, t, a, i, c) {
      this.tag = t, this.containerInfo = e, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = Jb, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Et, this.eventTimes = gd(X), this.expirationTimes = gd(Wt), this.pendingLanes = X, this.suspendedLanes = X, this.pingedLanes = X, this.expiredLanes = X, this.mutableReadLanes = X, this.finishedLanes = X, this.entangledLanes = X, this.entanglements = gd(X), this.identifierPrefix = i, this.onRecoverableError = c, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var p = this.pendingUpdatersLaneMap = [], y = 0; y < ds; y++)
          p.push(/* @__PURE__ */ new Set());
      }
      switch (t) {
        case yv:
          this._debugRootType = a ? "hydrateRoot()" : "createRoot()";
          break;
        case Cl:
          this._debugRootType = a ? "hydrate()" : "render()";
          break;
      }
    }
    function uS(e, t, a, i, c, p, y, _, w, C) {
      var T = new XO(e, t, a, _, w), A = ZO(t, p);
      T.current = A, A.stateNode = T;
      {
        var z = {
          element: i,
          isDehydrated: a,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        A.memoizedState = z;
      }
      return N_(A), T;
    }
    var yk = "18.3.1";
    function eL(e, t, a) {
      var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return Vi(i), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: Ta,
        key: i == null ? null : "" + i,
        children: e,
        containerInfo: t,
        implementation: a
      };
    }
    var bk, _k;
    bk = !1, _k = {};
    function cS(e) {
      if (!e)
        return Ua;
      var t = cl(e), a = AR(t);
      if (t.tag === E) {
        var i = t.type;
        if (Ti(i))
          return Fx(t, i, a);
      }
      return a;
    }
    function tL(e, t) {
      {
        var a = cl(e);
        if (a === void 0) {
          if (typeof e.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var i = Object.keys(e).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + i);
        }
        var c = Nr(a);
        if (c === null)
          return null;
        if (c.mode & $t) {
          var p = ut(a) || "Component";
          if (!_k[p]) {
            _k[p] = !0;
            var y = mr;
            try {
              Kt(c), a.mode & $t ? g("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, p) : g("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, p);
            } finally {
              y ? Kt(y) : rn();
            }
          }
        }
        return c.stateNode;
      }
    }
    function dS(e, t, a, i, c, p, y, _) {
      var w = !1, C = null;
      return uS(e, t, w, C, a, i, c, p, y);
    }
    function fS(e, t, a, i, c, p, y, _, w, C) {
      var T = !0, A = uS(a, i, T, e, c, p, y, _, w);
      A.context = cS(null);
      var z = A.current, B = ea(), H = Ml(z), Y = zs(B, H);
      return Y.callback = t ?? null, Pl(z, Y, H), lO(A, H, B), A;
    }
    function qh(e, t, a, i) {
      mp(t, e);
      var c = t.current, p = ea(), y = Ml(c);
      Xt(y);
      var _ = cS(a);
      t.context === null ? t.context = _ : t.pendingContext = _, ti && mr !== null && !bk && (bk = !0, g(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, ut(mr) || "Unknown"));
      var w = zs(p, y);
      w.payload = {
        element: e
      }, i = i === void 0 ? null : i, i !== null && (typeof i != "function" && g("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", i), w.callback = i);
      var C = Pl(c, w, y);
      return C !== null && (rr(C, c, y, p), Dv(C, c, y)), y;
    }
    function xy(e) {
      var t = e.current;
      if (!t.child)
        return null;
      switch (t.child.tag) {
        case M:
          return t.child.stateNode;
        default:
          return t.child.stateNode;
      }
    }
    function nL(e) {
      switch (e.tag) {
        case P: {
          var t = e.stateNode;
          if (yd(t)) {
            var a = gg(t);
            fO(t, a);
          }
          break;
        }
        case Re: {
          Fs(function() {
            var c = _a(e, Je);
            if (c !== null) {
              var p = ea();
              rr(c, e, Je, p);
            }
          });
          var i = Je;
          wk(e, i);
          break;
        }
      }
    }
    function pS(e, t) {
      var a = e.memoizedState;
      a !== null && a.dehydrated !== null && (a.retryLane = Lp(a.retryLane, t));
    }
    function wk(e, t) {
      pS(e, t);
      var a = e.alternate;
      a && pS(a, t);
    }
    function rL(e) {
      if (e.tag === Re) {
        var t = Su, a = _a(e, t);
        if (a !== null) {
          var i = ea();
          rr(a, e, t, i);
        }
        wk(e, t);
      }
    }
    function aL(e) {
      if (e.tag === Re) {
        var t = Ml(e), a = _a(e, t);
        if (a !== null) {
          var i = ea();
          rr(a, e, t, i);
        }
        wk(e, t);
      }
    }
    function hS(e) {
      var t = Gt(e);
      return t === null ? null : t.stateNode;
    }
    var mS = function(e) {
      return null;
    };
    function oL(e) {
      return mS(e);
    }
    var gS = function(e) {
      return !1;
    };
    function iL(e) {
      return gS(e);
    }
    var vS = null, yS = null, bS = null, _S = null, wS = null, kS = null, xS = null, SS = null, ES = null;
    {
      var CS = function(e, t, a) {
        var i = t[a], c = Wn(e) ? e.slice() : bt({}, e);
        return a + 1 === t.length ? (Wn(c) ? c.splice(i, 1) : delete c[i], c) : (c[i] = CS(e[i], t, a + 1), c);
      }, TS = function(e, t) {
        return CS(e, t, 0);
      }, RS = function(e, t, a, i) {
        var c = t[i], p = Wn(e) ? e.slice() : bt({}, e);
        if (i + 1 === t.length) {
          var y = a[i];
          p[y] = p[c], Wn(p) ? p.splice(c, 1) : delete p[c];
        } else
          p[c] = RS(
            // $FlowFixMe number or string is fine here
            e[c],
            t,
            a,
            i + 1
          );
        return p;
      }, PS = function(e, t, a) {
        if (t.length !== a.length) {
          m("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var i = 0; i < a.length - 1; i++)
            if (t[i] !== a[i]) {
              m("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return RS(e, t, a, 0);
      }, NS = function(e, t, a, i) {
        if (a >= t.length)
          return i;
        var c = t[a], p = Wn(e) ? e.slice() : bt({}, e);
        return p[c] = NS(e[c], t, a + 1, i), p;
      }, OS = function(e, t, a) {
        return NS(e, t, 0, a);
      }, kk = function(e, t) {
        for (var a = e.memoizedState; a !== null && t > 0; )
          a = a.next, t--;
        return a;
      };
      vS = function(e, t, a, i) {
        var c = kk(e, t);
        if (c !== null) {
          var p = OS(c.memoizedState, a, i);
          c.memoizedState = p, c.baseState = p, e.memoizedProps = bt({}, e.memoizedProps);
          var y = _a(e, Je);
          y !== null && rr(y, e, Je, Wt);
        }
      }, yS = function(e, t, a) {
        var i = kk(e, t);
        if (i !== null) {
          var c = TS(i.memoizedState, a);
          i.memoizedState = c, i.baseState = c, e.memoizedProps = bt({}, e.memoizedProps);
          var p = _a(e, Je);
          p !== null && rr(p, e, Je, Wt);
        }
      }, bS = function(e, t, a, i) {
        var c = kk(e, t);
        if (c !== null) {
          var p = PS(c.memoizedState, a, i);
          c.memoizedState = p, c.baseState = p, e.memoizedProps = bt({}, e.memoizedProps);
          var y = _a(e, Je);
          y !== null && rr(y, e, Je, Wt);
        }
      }, _S = function(e, t, a) {
        e.pendingProps = OS(e.memoizedProps, t, a), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var i = _a(e, Je);
        i !== null && rr(i, e, Je, Wt);
      }, wS = function(e, t) {
        e.pendingProps = TS(e.memoizedProps, t), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var a = _a(e, Je);
        a !== null && rr(a, e, Je, Wt);
      }, kS = function(e, t, a) {
        e.pendingProps = PS(e.memoizedProps, t, a), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var i = _a(e, Je);
        i !== null && rr(i, e, Je, Wt);
      }, xS = function(e) {
        var t = _a(e, Je);
        t !== null && rr(t, e, Je, Wt);
      }, SS = function(e) {
        mS = e;
      }, ES = function(e) {
        gS = e;
      };
    }
    function sL(e) {
      var t = Nr(e);
      return t === null ? null : t.stateNode;
    }
    function lL(e) {
      return null;
    }
    function uL() {
      return mr;
    }
    function cL(e) {
      var t = e.findFiberByHostInstance, a = s.ReactCurrentDispatcher;
      return pl({
        bundleType: e.bundleType,
        version: e.version,
        rendererPackageName: e.rendererPackageName,
        rendererConfig: e.rendererConfig,
        overrideHookState: vS,
        overrideHookStateDeletePath: yS,
        overrideHookStateRenamePath: bS,
        overrideProps: _S,
        overridePropsDeletePath: wS,
        overridePropsRenamePath: kS,
        setErrorHandler: SS,
        setSuspenseHandler: ES,
        scheduleUpdate: xS,
        currentDispatcherRef: a,
        findHostInstanceByFiber: sL,
        findFiberByHostInstance: t || lL,
        // React Refresh
        findHostInstancesForRefresh: jO,
        scheduleRefresh: FO,
        scheduleRoot: $O,
        setRefreshHandler: MO,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: uL,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: yk
      });
    }
    var LS = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(e) {
      console.error(e);
    };
    function xk(e) {
      this._internalRoot = e;
    }
    Sy.prototype.render = xk.prototype.render = function(e) {
      var t = this._internalRoot;
      if (t === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? g("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : Ey(arguments[1]) ? g("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && g("You passed a second argument to root.render(...) but it only accepts one argument.");
        var a = t.containerInfo;
        if (a.nodeType !== mn) {
          var i = hS(t.current);
          i && i.parentNode !== a && g("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      qh(e, t, null, null);
    }, Sy.prototype.unmount = xk.prototype.unmount = function() {
      typeof arguments[0] == "function" && g("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var e = this._internalRoot;
      if (e !== null) {
        this._internalRoot = null;
        var t = e.containerInfo;
        q1() && g("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), Fs(function() {
          qh(null, e, null, null);
        }), Dx(t);
      }
    };
    function dL(e, t) {
      if (!Ey(e))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      DS(e);
      var a = !1, i = !1, c = "", p = LS;
      t != null && (t.hydrate ? m("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof t == "object" && t !== null && t.$$typeof === ei && g(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), t.unstable_strictMode === !0 && (a = !0), t.identifierPrefix !== void 0 && (c = t.identifierPrefix), t.onRecoverableError !== void 0 && (p = t.onRecoverableError), t.transitionCallbacks !== void 0 && t.transitionCallbacks);
      var y = dS(e, yv, null, a, i, c, p);
      dv(y.current, e);
      var _ = e.nodeType === mn ? e.parentNode : e;
      return Jp(_), new xk(y);
    }
    function Sy(e) {
      this._internalRoot = e;
    }
    function fL(e) {
      e && Ng(e);
    }
    Sy.prototype.unstable_scheduleHydration = fL;
    function pL(e, t, a) {
      if (!Ey(e))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      DS(e), t === void 0 && g("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var i = a ?? null, c = a != null && a.hydratedSources || null, p = !1, y = !1, _ = "", w = LS;
      a != null && (a.unstable_strictMode === !0 && (p = !0), a.identifierPrefix !== void 0 && (_ = a.identifierPrefix), a.onRecoverableError !== void 0 && (w = a.onRecoverableError));
      var C = fS(t, null, e, yv, i, p, y, _, w);
      if (dv(C.current, e), Jp(e), c)
        for (var T = 0; T < c.length; T++) {
          var A = c[T];
          vP(C, A);
        }
      return new Sy(C);
    }
    function Ey(e) {
      return !!(e && (e.nodeType === Cr || e.nodeType === ko || e.nodeType === ep));
    }
    function Hh(e) {
      return !!(e && (e.nodeType === Cr || e.nodeType === ko || e.nodeType === ep || e.nodeType === mn && e.nodeValue === " react-mount-point-unstable "));
    }
    function DS(e) {
      e.nodeType === Cr && e.tagName && e.tagName.toUpperCase() === "BODY" && g("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), uh(e) && (e._reactRootContainer ? g("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : g("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var hL = s.ReactCurrentOwner, zS;
    zS = function(e) {
      if (e._reactRootContainer && e.nodeType !== mn) {
        var t = hS(e._reactRootContainer.current);
        t && t.parentNode !== e && g("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var a = !!e._reactRootContainer, i = Sk(e), c = !!(i && Sl(i));
      c && !a && g("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), e.nodeType === Cr && e.tagName && e.tagName.toUpperCase() === "BODY" && g("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function Sk(e) {
      return e ? e.nodeType === ko ? e.documentElement : e.firstChild : null;
    }
    function IS() {
    }
    function mL(e, t, a, i, c) {
      if (c) {
        if (typeof i == "function") {
          var p = i;
          i = function() {
            var z = xy(y);
            p.call(z);
          };
        }
        var y = fS(
          t,
          i,
          e,
          Cl,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          IS
        );
        e._reactRootContainer = y, dv(y.current, e);
        var _ = e.nodeType === mn ? e.parentNode : e;
        return Jp(_), Fs(), y;
      } else {
        for (var w; w = e.lastChild; )
          e.removeChild(w);
        if (typeof i == "function") {
          var C = i;
          i = function() {
            var z = xy(T);
            C.call(z);
          };
        }
        var T = dS(
          e,
          Cl,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          IS
        );
        e._reactRootContainer = T, dv(T.current, e);
        var A = e.nodeType === mn ? e.parentNode : e;
        return Jp(A), Fs(function() {
          qh(t, T, a, i);
        }), T;
      }
    }
    function gL(e, t) {
      e !== null && typeof e != "function" && g("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e);
    }
    function Cy(e, t, a, i, c) {
      zS(a), gL(c === void 0 ? null : c, "render");
      var p = a._reactRootContainer, y;
      if (!p)
        y = mL(a, t, e, c, i);
      else {
        if (y = p, typeof c == "function") {
          var _ = c;
          c = function() {
            var w = xy(y);
            _.call(w);
          };
        }
        qh(t, y, e, c);
      }
      return xy(y);
    }
    var AS = !1;
    function vL(e) {
      {
        AS || (AS = !0, g("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var t = hL.current;
        if (t !== null && t.stateNode !== null) {
          var a = t.stateNode._warnedAboutRefsInRender;
          a || g("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", At(t.type) || "A component"), t.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return e == null ? null : e.nodeType === Cr ? e : tL(e, "findDOMNode");
    }
    function yL(e, t, a) {
      if (g("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Hh(t))
        throw new Error("Target container is not a DOM element.");
      {
        var i = uh(t) && t._reactRootContainer === void 0;
        i && g("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return Cy(null, e, t, !0, a);
    }
    function bL(e, t, a) {
      if (g("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Hh(t))
        throw new Error("Target container is not a DOM element.");
      {
        var i = uh(t) && t._reactRootContainer === void 0;
        i && g("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return Cy(null, e, t, !1, a);
    }
    function _L(e, t, a, i) {
      if (g("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Hh(a))
        throw new Error("Target container is not a DOM element.");
      if (e == null || !Cb(e))
        throw new Error("parentComponent must be a valid React Component");
      return Cy(e, t, a, !1, i);
    }
    var MS = !1;
    function wL(e) {
      if (MS || (MS = !0, g("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !Hh(e))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var t = uh(e) && e._reactRootContainer === void 0;
        t && g("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (e._reactRootContainer) {
        {
          var a = Sk(e), i = a && !Sl(a);
          i && g("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return Fs(function() {
          Cy(null, null, e, !1, function() {
            e._reactRootContainer = null, Dx(e);
          });
        }), !0;
      } else {
        {
          var c = Sk(e), p = !!(c && Sl(c)), y = e.nodeType === Cr && Hh(e.parentNode) && !!e.parentNode._reactRootContainer;
          p && g("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", y ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    bd(nL), Le(rL), Cg(aL), Rb(Ma), _d(Ip), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && g("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), Ic(xT), Eb(tk, pO, Fs);
    function kL(e, t) {
      var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!Ey(t))
        throw new Error("Target container is not a DOM element.");
      return eL(e, t, null, a);
    }
    function xL(e, t, a, i) {
      return _L(e, t, a, i);
    }
    var Ek = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Sl, $d, fv, il, Ac, tk]
    };
    function SL(e, t) {
      return Ek.usingClientEntryPoint || g('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), dL(e, t);
    }
    function EL(e, t, a) {
      return Ek.usingClientEntryPoint || g('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), pL(e, t, a);
    }
    function CL(e) {
      return q1() && g("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), Fs(e);
    }
    var TL = cL({
      findFiberByHostInstance: Wu,
      bundleType: 1,
      version: yk,
      rendererPackageName: "react-dom"
    });
    if (!TL && kn && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var FS = window.location.protocol;
      /^(https?|file):$/.test(FS) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (FS === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    Wa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Ek, Wa.createPortal = kL, Wa.createRoot = SL, Wa.findDOMNode = vL, Wa.flushSync = CL, Wa.hydrate = yL, Wa.hydrateRoot = EL, Wa.render = bL, Wa.unmountComponentAtNode = wL, Wa.unstable_batchedUpdates = tk, Wa.unstable_renderSubtreeIntoContainer = xL, Wa.version = yk, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Wa;
}
var sE;
function AD() {
  if (sE) return Ty.exports;
  sE = 1;
  function u() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(u);
      } catch (o) {
        console.error(o);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (u(), Ty.exports = zD()) : Ty.exports = ID(), Ty.exports;
}
AD();
var Fy = Te.forwardRef((u, o) => {
  const { children: s, ...d } = u, h = Te.Children.toArray(s), m = h.find(FD);
  if (m) {
    const g = m.props.children, k = h.map((S) => S === m ? Te.Children.count(g) > 1 ? Te.Children.only(null) : Te.isValidElement(g) ? g.props.children : null : S);
    return /* @__PURE__ */ le($k, { ...d, ref: o, children: Te.isValidElement(g) ? Te.cloneElement(g, void 0, k) : null });
  }
  return /* @__PURE__ */ le($k, { ...d, ref: o, children: s });
});
Fy.displayName = "Slot";
var $k = Te.forwardRef((u, o) => {
  const { children: s, ...d } = u;
  if (Te.isValidElement(s)) {
    const h = jD(s), m = $D(d, s.props);
    return s.type !== Te.Fragment && (m.ref = o ? tC(o, h) : h), Te.cloneElement(s, m);
  }
  return Te.Children.count(s) > 1 ? Te.Children.only(null) : null;
});
$k.displayName = "SlotClone";
var MD = ({ children: u }) => /* @__PURE__ */ le(RE, { children: u });
function FD(u) {
  return Te.isValidElement(u) && u.type === MD;
}
function $D(u, o) {
  const s = { ...o };
  for (const d in o) {
    const h = u[d], m = o[d];
    /^on[A-Z]/.test(d) ? h && m ? s[d] = (...g) => {
      m(...g), h(...g);
    } : h && (s[d] = h) : d === "style" ? s[d] = { ...h, ...m } : d === "className" && (s[d] = [h, m].filter(Boolean).join(" "));
  }
  return { ...u, ...s };
}
function jD(u) {
  var o, s;
  let d = (o = Object.getOwnPropertyDescriptor(u.props, "ref")) == null ? void 0 : o.get, h = d && "isReactWarning" in d && d.isReactWarning;
  return h ? u.ref : (d = (s = Object.getOwnPropertyDescriptor(u, "ref")) == null ? void 0 : s.get, h = d && "isReactWarning" in d && d.isReactWarning, h ? u.props.ref : u.props.ref || u.ref);
}
var UD = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], bm = UD.reduce((u, o) => {
  const s = Te.forwardRef((d, h) => {
    const { asChild: m, ...g } = d, k = m ? Fy : o;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ le(k, { ...g, ref: h });
  });
  return s.displayName = `Primitive.${o}`, { ...u, [o]: s };
}, {}), VD = Te.createContext(void 0);
function rC(u) {
  const o = Te.useContext(VD);
  return u || o || "ltr";
}
function BD(u) {
  const o = u + "CollectionProvider", [s, d] = Xy(o), [h, m] = s(
    o,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), g = (M) => {
    const { scope: $, children: Z } = M, G = xt.useRef(null), Pe = xt.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ le(h, { scope: $, itemMap: Pe, collectionRef: G, children: Z });
  };
  g.displayName = o;
  const k = u + "CollectionSlot", S = xt.forwardRef(
    (M, $) => {
      const { scope: Z, children: G } = M, Pe = m(k, Z), re = xf($, Pe.collectionRef);
      return /* @__PURE__ */ le(Fy, { ref: re, children: G });
    }
  );
  S.displayName = k;
  const E = u + "CollectionItemSlot", R = "data-radix-collection-item", P = xt.forwardRef(
    (M, $) => {
      const { scope: Z, children: G, ...Pe } = M, re = xt.useRef(null), ve = xf($, re), qe = m(E, Z);
      return xt.useEffect(() => (qe.itemMap.set(re, { ref: re, ...Pe }), () => void qe.itemMap.delete(re))), /* @__PURE__ */ le(Fy, { [R]: "", ref: ve, children: G });
    }
  );
  P.displayName = E;
  function O(M) {
    const $ = m(u + "CollectionConsumer", M);
    return xt.useCallback(() => {
      const Z = $.collectionRef.current;
      if (!Z) return [];
      const G = Array.from(Z.querySelectorAll(`[${R}]`));
      return Array.from($.itemMap.values()).sort(
        (Pe, re) => G.indexOf(Pe.ref.current) - G.indexOf(re.ref.current)
      );
    }, [$.collectionRef, $.itemMap]);
  }
  return [
    { Provider: g, Slot: S, ItemSlot: P },
    O,
    d
  ];
}
var WD = Te.useId || (() => {
}), qD = 0;
function HD(u) {
  const [o, s] = Te.useState(WD());
  return My(() => {
    s((d) => d ?? String(qD++));
  }, [u]), o ? `radix-${o}` : "";
}
var Nk = "rovingFocusGroup.onEntryFocus", ZD = { bubbles: !1, cancelable: !0 }, eb = "RovingFocusGroup", [jk, aC, QD] = BD(eb), [KD, oC] = Xy(
  eb,
  [QD]
), [YD, GD] = KD(eb), iC = Te.forwardRef(
  (u, o) => /* @__PURE__ */ le(jk.Provider, { scope: u.__scopeRovingFocusGroup, children: /* @__PURE__ */ le(jk.Slot, { scope: u.__scopeRovingFocusGroup, children: /* @__PURE__ */ le(JD, { ...u, ref: o }) }) })
);
iC.displayName = eb;
var JD = Te.forwardRef((u, o) => {
  const {
    __scopeRovingFocusGroup: s,
    orientation: d,
    loop: h = !1,
    dir: m,
    currentTabStopId: g,
    defaultCurrentTabStopId: k,
    onCurrentTabStopIdChange: S,
    onEntryFocus: E,
    preventScrollOnEntryFocus: R = !1,
    ...P
  } = u, O = Te.useRef(null), M = xf(o, O), $ = rC(m), [Z = null, G] = eC({
    prop: g,
    defaultProp: k,
    onChange: S
  }), [Pe, re] = Te.useState(!1), ve = nx(E), qe = aC(s), Re = Te.useRef(!1), [ft, Oe] = Te.useState(0);
  return Te.useEffect(() => {
    const ye = O.current;
    if (ye)
      return ye.addEventListener(Nk, ve), () => ye.removeEventListener(Nk, ve);
  }, [ve]), /* @__PURE__ */ le(
    YD,
    {
      scope: s,
      orientation: d,
      dir: $,
      loop: h,
      currentTabStopId: Z,
      onItemFocus: Te.useCallback(
        (ye) => G(ye),
        [G]
      ),
      onItemShiftTab: Te.useCallback(() => re(!0), []),
      onFocusableItemAdd: Te.useCallback(
        () => Oe((ye) => ye + 1),
        []
      ),
      onFocusableItemRemove: Te.useCallback(
        () => Oe((ye) => ye - 1),
        []
      ),
      children: /* @__PURE__ */ le(
        bm.div,
        {
          tabIndex: Pe || ft === 0 ? -1 : 0,
          "data-orientation": d,
          ...P,
          ref: M,
          style: { outline: "none", ...u.style },
          onMouseDown: qs(u.onMouseDown, () => {
            Re.current = !0;
          }),
          onFocus: qs(u.onFocus, (ye) => {
            const rt = !Re.current;
            if (ye.target === ye.currentTarget && rt && !Pe) {
              const st = new CustomEvent(Nk, ZD);
              if (ye.currentTarget.dispatchEvent(st), !st.defaultPrevented) {
                const Ie = qe().filter((et) => et.focusable), fe = Ie.find((et) => et.active), Ae = Ie.find((et) => et.id === Z), Ke = [fe, Ae, ...Ie].filter(
                  Boolean
                ).map((et) => et.ref.current);
                uC(Ke, R);
              }
            }
            Re.current = !1;
          }),
          onBlur: qs(u.onBlur, () => re(!1))
        }
      )
    }
  );
}), sC = "RovingFocusGroupItem", lC = Te.forwardRef(
  (u, o) => {
    const {
      __scopeRovingFocusGroup: s,
      focusable: d = !0,
      active: h = !1,
      tabStopId: m,
      ...g
    } = u, k = HD(), S = m || k, E = GD(sC, s), R = E.currentTabStopId === S, P = aC(s), { onFocusableItemAdd: O, onFocusableItemRemove: M } = E;
    return Te.useEffect(() => {
      if (d)
        return O(), () => M();
    }, [d, O, M]), /* @__PURE__ */ le(
      jk.ItemSlot,
      {
        scope: s,
        id: S,
        focusable: d,
        active: h,
        children: /* @__PURE__ */ le(
          bm.span,
          {
            tabIndex: R ? 0 : -1,
            "data-orientation": E.orientation,
            ...g,
            ref: o,
            onMouseDown: qs(u.onMouseDown, ($) => {
              d ? E.onItemFocus(S) : $.preventDefault();
            }),
            onFocus: qs(u.onFocus, () => E.onItemFocus(S)),
            onKeyDown: qs(u.onKeyDown, ($) => {
              if ($.key === "Tab" && $.shiftKey) {
                E.onItemShiftTab();
                return;
              }
              if ($.target !== $.currentTarget) return;
              const Z = tz($, E.orientation, E.dir);
              if (Z !== void 0) {
                if ($.metaKey || $.ctrlKey || $.altKey || $.shiftKey) return;
                $.preventDefault();
                let G = P().filter((Pe) => Pe.focusable).map((Pe) => Pe.ref.current);
                if (Z === "last") G.reverse();
                else if (Z === "prev" || Z === "next") {
                  Z === "prev" && G.reverse();
                  const Pe = G.indexOf($.currentTarget);
                  G = E.loop ? nz(G, Pe + 1) : G.slice(Pe + 1);
                }
                setTimeout(() => uC(G));
              }
            })
          }
        )
      }
    );
  }
);
lC.displayName = sC;
var XD = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function ez(u, o) {
  return o !== "rtl" ? u : u === "ArrowLeft" ? "ArrowRight" : u === "ArrowRight" ? "ArrowLeft" : u;
}
function tz(u, o, s) {
  const d = ez(u.key, s);
  if (!(o === "vertical" && ["ArrowLeft", "ArrowRight"].includes(d)) && !(o === "horizontal" && ["ArrowUp", "ArrowDown"].includes(d)))
    return XD[d];
}
function uC(u, o = !1) {
  const s = document.activeElement;
  for (const d of u)
    if (d === s || (d.focus({ preventScroll: o }), document.activeElement !== s)) return;
}
function nz(u, o) {
  return u.map((s, d) => u[(o + d) % u.length]);
}
var rz = iC, az = lC;
function oz(u) {
  const [o, s] = Te.useState(void 0);
  return My(() => {
    if (u) {
      s({ width: u.offsetWidth, height: u.offsetHeight });
      const d = new ResizeObserver((h) => {
        if (!Array.isArray(h) || !h.length)
          return;
        const m = h[0];
        let g, k;
        if ("borderBoxSize" in m) {
          const S = m.borderBoxSize, E = Array.isArray(S) ? S[0] : S;
          g = E.inlineSize, k = E.blockSize;
        } else
          g = u.offsetWidth, k = u.offsetHeight;
        s({ width: g, height: k });
      });
      return d.observe(u, { box: "border-box" }), () => d.unobserve(u);
    } else
      s(void 0);
  }, [u]), o;
}
function iz(u) {
  const o = Te.useRef({ value: u, previous: u });
  return Te.useMemo(() => (o.current.value !== u && (o.current.previous = o.current.value, o.current.value = u), o.current.previous), [u]);
}
function sz(u, o) {
  return Te.useReducer((s, d) => o[s][d] ?? s, u);
}
var cC = (u) => {
  const { present: o, children: s } = u, d = lz(o), h = typeof s == "function" ? s({ present: d.isPresent }) : Te.Children.only(s), m = xf(d.ref, uz(h));
  return typeof s == "function" || d.isPresent ? Te.cloneElement(h, { ref: m }) : null;
};
cC.displayName = "Presence";
function lz(u) {
  const [o, s] = Te.useState(), d = Te.useRef({}), h = Te.useRef(u), m = Te.useRef("none"), g = u ? "mounted" : "unmounted", [k, S] = sz(g, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Te.useEffect(() => {
    const E = Ry(d.current);
    m.current = k === "mounted" ? E : "none";
  }, [k]), My(() => {
    const E = d.current, R = h.current;
    if (R !== u) {
      const P = m.current, O = Ry(E);
      u ? S("MOUNT") : O === "none" || (E == null ? void 0 : E.display) === "none" ? S("UNMOUNT") : S(R && P !== O ? "ANIMATION_OUT" : "UNMOUNT"), h.current = u;
    }
  }, [u, S]), My(() => {
    if (o) {
      let E;
      const R = o.ownerDocument.defaultView ?? window, P = (M) => {
        const $ = Ry(d.current).includes(M.animationName);
        if (M.target === o && $ && (S("ANIMATION_END"), !h.current)) {
          const Z = o.style.animationFillMode;
          o.style.animationFillMode = "forwards", E = R.setTimeout(() => {
            o.style.animationFillMode === "forwards" && (o.style.animationFillMode = Z);
          });
        }
      }, O = (M) => {
        M.target === o && (m.current = Ry(d.current));
      };
      return o.addEventListener("animationstart", O), o.addEventListener("animationcancel", P), o.addEventListener("animationend", P), () => {
        R.clearTimeout(E), o.removeEventListener("animationstart", O), o.removeEventListener("animationcancel", P), o.removeEventListener("animationend", P);
      };
    } else
      S("ANIMATION_END");
  }, [o, S]), {
    isPresent: ["mounted", "unmountSuspended"].includes(k),
    ref: Te.useCallback((E) => {
      E && (d.current = getComputedStyle(E)), s(E);
    }, [])
  };
}
function Ry(u) {
  return (u == null ? void 0 : u.animationName) || "none";
}
function uz(u) {
  var o, s;
  let d = (o = Object.getOwnPropertyDescriptor(u.props, "ref")) == null ? void 0 : o.get, h = d && "isReactWarning" in d && d.isReactWarning;
  return h ? u.ref : (d = (s = Object.getOwnPropertyDescriptor(u, "ref")) == null ? void 0 : s.get, h = d && "isReactWarning" in d && d.isReactWarning, h ? u.props.ref : u.props.ref || u.ref);
}
var rx = "Radio", [cz, dC] = Xy(rx), [dz, fz] = cz(rx), fC = Te.forwardRef(
  (u, o) => {
    const {
      __scopeRadio: s,
      name: d,
      checked: h = !1,
      required: m,
      disabled: g,
      value: k = "on",
      onCheck: S,
      form: E,
      ...R
    } = u, [P, O] = Te.useState(null), M = xf(o, (G) => O(G)), $ = Te.useRef(!1), Z = P ? E || !!P.closest("form") : !0;
    return /* @__PURE__ */ tn(dz, { scope: s, checked: h, disabled: g, children: [
      /* @__PURE__ */ le(
        bm.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": h,
          "data-state": mC(h),
          "data-disabled": g ? "" : void 0,
          disabled: g,
          value: k,
          ...R,
          ref: M,
          onClick: qs(u.onClick, (G) => {
            h || S == null || S(), Z && ($.current = G.isPropagationStopped(), $.current || G.stopPropagation());
          })
        }
      ),
      Z && /* @__PURE__ */ le(
        pz,
        {
          control: P,
          bubbles: !$.current,
          name: d,
          value: k,
          checked: h,
          required: m,
          disabled: g,
          form: E,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
fC.displayName = rx;
var pC = "RadioIndicator", hC = Te.forwardRef(
  (u, o) => {
    const { __scopeRadio: s, forceMount: d, ...h } = u, m = fz(pC, s);
    return /* @__PURE__ */ le(cC, { present: d || m.checked, children: /* @__PURE__ */ le(
      bm.span,
      {
        "data-state": mC(m.checked),
        "data-disabled": m.disabled ? "" : void 0,
        ...h,
        ref: o
      }
    ) });
  }
);
hC.displayName = pC;
var pz = (u) => {
  const { control: o, checked: s, bubbles: d = !0, ...h } = u, m = Te.useRef(null), g = iz(s), k = oz(o);
  return Te.useEffect(() => {
    const S = m.current, E = window.HTMLInputElement.prototype, R = Object.getOwnPropertyDescriptor(E, "checked").set;
    if (g !== s && R) {
      const P = new Event("click", { bubbles: d });
      R.call(S, s), S.dispatchEvent(P);
    }
  }, [g, s, d]), /* @__PURE__ */ le(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: s,
      ...h,
      tabIndex: -1,
      ref: m,
      style: {
        ...u.style,
        ...k,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function mC(u) {
  return u ? "checked" : "unchecked";
}
var hz = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], ax = "RadioGroup", [mz, T3] = Xy(ax, [
  oC,
  dC
]), gC = oC(), vC = dC(), [gz, vz] = mz(ax), yC = Te.forwardRef(
  (u, o) => {
    const {
      __scopeRadioGroup: s,
      name: d,
      defaultValue: h,
      value: m,
      required: g = !1,
      disabled: k = !1,
      orientation: S,
      dir: E,
      loop: R = !0,
      onValueChange: P,
      ...O
    } = u, M = gC(s), $ = rC(E), [Z, G] = eC({
      prop: m,
      defaultProp: h,
      onChange: P
    });
    return /* @__PURE__ */ le(
      gz,
      {
        scope: s,
        name: d,
        required: g,
        disabled: k,
        value: Z,
        onValueChange: G,
        children: /* @__PURE__ */ le(
          rz,
          {
            asChild: !0,
            ...M,
            orientation: S,
            dir: $,
            loop: R,
            children: /* @__PURE__ */ le(
              bm.div,
              {
                role: "radiogroup",
                "aria-required": g,
                "aria-orientation": S,
                "data-disabled": k ? "" : void 0,
                dir: $,
                ...O,
                ref: o
              }
            )
          }
        )
      }
    );
  }
);
yC.displayName = ax;
var bC = "RadioGroupItem", _C = Te.forwardRef(
  (u, o) => {
    const { __scopeRadioGroup: s, disabled: d, ...h } = u, m = vz(bC, s), g = m.disabled || d, k = gC(s), S = vC(s), E = Te.useRef(null), R = xf(o, E), P = m.value === h.value, O = Te.useRef(!1);
    return Te.useEffect(() => {
      const M = (Z) => {
        hz.includes(Z.key) && (O.current = !0);
      }, $ = () => O.current = !1;
      return document.addEventListener("keydown", M), document.addEventListener("keyup", $), () => {
        document.removeEventListener("keydown", M), document.removeEventListener("keyup", $);
      };
    }, []), /* @__PURE__ */ le(
      az,
      {
        asChild: !0,
        ...k,
        focusable: !g,
        active: P,
        children: /* @__PURE__ */ le(
          fC,
          {
            disabled: g,
            required: m.required,
            checked: P,
            ...S,
            ...h,
            name: m.name,
            ref: R,
            onCheck: () => m.onValueChange(h.value),
            onKeyDown: qs((M) => {
              M.key === "Enter" && M.preventDefault();
            }),
            onFocus: qs(h.onFocus, () => {
              var M;
              O.current && ((M = E.current) == null || M.click());
            })
          }
        )
      }
    );
  }
);
_C.displayName = bC;
var yz = "RadioGroupIndicator", wC = Te.forwardRef(
  (u, o) => {
    const { __scopeRadioGroup: s, ...d } = u, h = vC(s);
    return /* @__PURE__ */ le(hC, { ...h, ...d, ref: o });
  }
);
wC.displayName = yz;
var bz = yC, _z = _C, wz = wC;
const kz = "_indicator_o29me_51", xz = "_label_o29me_66", Py = {
  "radio-item": "_radio-item_o29me_29",
  "radio-button": "_radio-button_o29me_33",
  indicator: kz,
  label: xz
};
function Sz({ value: u, id: o, label: s, description: d }) {
  return /* @__PURE__ */ tn("div", { className: Py["radio-item"], children: [
    /* @__PURE__ */ le(_z, { value: u, id: o, className: Py["radio-button"], "aria-label": s, children: /* @__PURE__ */ le(wz, { className: Py.indicator }) }),
    /* @__PURE__ */ tn("label", { htmlFor: o, className: Py.label, children: [
      s,
      d && /* @__PURE__ */ le("p", { children: d })
    ] })
  ] });
}
const Ez = "_title_ej2xw_37", Cz = "_text_ej2xw_41", hf = {
  "radio-group": "_radio-group_ej2xw_29",
  "group-label": "_group-label_ej2xw_34",
  title: Ez,
  text: Cz,
  "has-error": "_has-error_ej2xw_48",
  "error-message": "_error-message_ej2xw_51"
};
function Uk({
  children: u,
  defaultValue: o,
  label: s,
  helperContent: d,
  errorMessage: h,
  disabled: m,
  onChange: g,
  onBlur: k,
  value: S,
  name: E
}) {
  const R = !!h, P = !!(s ?? d);
  return /* @__PURE__ */ tn(
    bz,
    {
      name: E,
      onValueChange: g,
      defaultValue: o,
      className: Fn(hf["radio-group"], h && hf["has-error"]),
      disabled: m,
      onBlur: k,
      value: S,
      children: [
        P && /* @__PURE__ */ tn("div", { className: hf["group-label"], children: [
          s && /* @__PURE__ */ le("label", { className: hf.title, children: s }),
          d && /* @__PURE__ */ le("p", { className: hf.text, children: d })
        ] }),
        u,
        R && /* @__PURE__ */ tn("p", { className: hf["error-message"], children: [
          /* @__PURE__ */ le(kf, { name: "error-warning-fill", color: "error" }),
          h
        ] })
      ]
    }
  );
}
Uk.Item = Sz;
const Tz = "_flex_11xqi_29", Rz = "_wrap_11xqi_67", Pz = "_nowrap_11xqi_70", Qo = {
  flex: Tz,
  "flex-row": "_flex-row_11xqi_34",
  "flex-column": "_flex-column_11xqi_37",
  "justify-start": "_justify-start_11xqi_40",
  "justify-end": "_justify-end_11xqi_43",
  "justify-center": "_justify-center_11xqi_46",
  "justify-space-between": "_justify-space-between_11xqi_49",
  "justify-space-around": "_justify-space-around_11xqi_52",
  "align-start": "_align-start_11xqi_55",
  "align-end": "_align-end_11xqi_58",
  "align-center": "_align-center_11xqi_61",
  "align-stretch": "_align-stretch_11xqi_64",
  wrap: Rz,
  nowrap: Pz,
  "wrap-reverse": "_wrap-reverse_11xqi_73",
  "is-full-width": "_is-full-width_11xqi_79",
  "is-full-height": "_is-full-height_11xqi_82",
  "flex-grow": "_flex-grow_11xqi_85",
  "hide-on-mobile": "_hide-on-mobile_11xqi_88",
  "gap-0": "_gap-0_11xqi_96",
  "gap-1": "_gap-1_11xqi_99",
  "gap-2": "_gap-2_11xqi_102",
  "gap-3": "_gap-3_11xqi_105",
  "gap-4": "_gap-4_11xqi_108",
  "gap-5": "_gap-5_11xqi_111",
  "gap-6": "_gap-6_11xqi_114",
  "gap-7": "_gap-7_11xqi_117",
  "gap-8": "_gap-8_11xqi_120",
  "gap-9": "_gap-9_11xqi_123",
  "gap-10": "_gap-10_11xqi_126",
  "gap-11": "_gap-11_11xqi_129",
  "gap-12": "_gap-12_11xqi_132",
  "gap-14": "_gap-14_11xqi_135",
  "gap-16": "_gap-16_11xqi_138",
  "gap-18": "_gap-18_11xqi_141",
  "gap-20": "_gap-20_11xqi_144",
  "gap-24": "_gap-24_11xqi_147",
  "gap-28": "_gap-28_11xqi_150",
  "gap-32": "_gap-32_11xqi_153",
  "gap-36": "_gap-36_11xqi_156",
  "gap-40": "_gap-40_11xqi_159",
  "gap-44": "_gap-44_11xqi_162",
  "gap-48": "_gap-48_11xqi_165",
  "gap-52": "_gap-52_11xqi_168",
  "gap-56": "_gap-56_11xqi_171",
  "gap-60": "_gap-60_11xqi_174",
  "gap-64": "_gap-64_11xqi_177",
  "gap-72": "_gap-72_11xqi_180",
  "gap-80": "_gap-80_11xqi_183",
  "gap-96": "_gap-96_11xqi_186",
  "no-margin": "_no-margin_11xqi_189",
  "dialog-overlay-show": "_dialog-overlay-show_11xqi_1",
  "dialog-content-show": "_dialog-content-show_11xqi_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_11xqi_1"
};
function Nz({
  children: u,
  direction: o = "row",
  justifyContent: s = "start",
  alignItems: d = "start",
  flexWrap: h = "wrap",
  className: m = "",
  isFullWidth: g = !1,
  isFullHeight: k = !1,
  gap: S,
  style: E,
  noMargin: R = !1,
  flexGrow: P = !1,
  hideOnMobile: O = !1,
  ...M
}) {
  const $ = Fn(
    Qo.flex,
    Qo[`flex-${o}`],
    Qo[`justify-${s}`],
    Qo[`align-${d}`],
    Qo[h],
    g && Qo["is-full-width"],
    k && Qo["is-full-height"],
    S && Qo[`gap-${S}`],
    R && Qo["no-margin"],
    P && Qo["flex-grow"],
    O && Qo["hide-on-mobile"],
    m
  );
  return /* @__PURE__ */ le("div", { className: $, ...M, style: E, children: u });
}
const Oz = "_title_15qtu_29", Lz = "_subtitle_15qtu_92", mf = {
  "title-container": "_title-container_15qtu_29",
  "color-inverted": "_color-inverted_15qtu_29",
  "is-primary": "_is-primary_15qtu_32",
  "is-secondary": "_is-secondary_15qtu_35",
  "is-tertiary": "_is-tertiary_15qtu_38",
  "is-success": "_is-success_15qtu_41",
  "is-error": "_is-error_15qtu_44",
  "is-eco-green": "_is-eco-green_15qtu_47",
  title: Oz,
  "is-1": "_is-1_15qtu_59",
  "is-impact": "_is-impact_15qtu_68",
  "is-2": "_is-2_15qtu_72",
  "is-3": "_is-3_15qtu_82",
  subtitle: Lz,
  "dialog-overlay-show": "_dialog-overlay-show_15qtu_1",
  "dialog-content-show": "_dialog-content-show_15qtu_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_15qtu_1"
}, Dz = {
  default: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "color-inverted"
};
function kC({
  color: u = "default",
  children: o,
  level: s = 3,
  hasHeaderTag: d = !1,
  isImpact: h,
  subtitle: m,
  className: g = "",
  ...k
}) {
  const S = `h${s}`, E = `${d ? S : "p"}`, R = Fn(mf.title, mf[`is-${s}`], h && mf["is-impact"], g);
  return /* @__PURE__ */ tn("div", { className: Fn(mf["title-container"], mf[Dz[u]]), children: [
    /* @__PURE__ */ le(E, { className: R, ...k, children: o }),
    m && /* @__PURE__ */ le("p", { className: Fn(mf.subtitle), children: m })
  ] });
}
const zz = 0;
function Iz(u, o, s, d, h, m) {
  const [g, k] = Vl(!1), S = g ? s : d, [E, R] = Vl(S ? S.length : zz), [P, O] = Vl(!1);
  return {
    valueCounter: E,
    isOnBlur: P,
    hasLabelOrHelperText: !!(u ?? o),
    handleBlur: () => {
      O(!0), m == null || m();
    },
    handleChange: (M) => {
      k(!0), R(M.target.value.length), h && h(M), O(!1);
    }
  };
}
const Az = "_container_1d1wd_29", Mz = "_filled_1d1wd_43", Fz = "_error_1d1wd_46", $z = "_success_1d1wd_49", jz = "_counter_1d1wd_126", mo = {
  container: Az,
  "group-label": "_group-label_1d1wd_34",
  filled: Mz,
  error: Fz,
  success: $z,
  "helper-text": "_helper-text_1d1wd_52",
  "container-counter-icon": "_container-counter-icon_1d1wd_105",
  "container-icon": "_container-icon_1d1wd_112",
  "icon-error-warning-fill": "_icon-error-warning-fill_1d1wd_117",
  counter: jz,
  "dialog-overlay-show": "_dialog-overlay-show_1d1wd_1",
  "dialog-content-show": "_dialog-content-show_1d1wd_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1d1wd_1"
};
function Uz({
  id: u,
  disabled: o = !1,
  status: s,
  title: d,
  helperText: h,
  placeholder: m,
  maxLength: g,
  onChange: k,
  onBlur: S,
  message: E,
  value: R,
  defaultValue: P,
  name: O
}) {
  const {
    valueCounter: M,
    isOnBlur: $,
    handleBlur: Z,
    handleChange: G,
    hasLabelOrHelperText: Pe
  } = Iz(d, h, R, P, k, S);
  return /* @__PURE__ */ tn("div", { className: mo.container, children: [
    Pe && /* @__PURE__ */ tn("div", { className: mo["group-label"], children: [
      d && /* @__PURE__ */ le(
        "label",
        {
          htmlFor: u,
          className: Fn(s && mo[s], (M > 0 && $ || o) && mo.filled),
          children: d
        }
      ),
      h && /* @__PURE__ */ le("div", { className: mo["helper-text"], children: h })
    ] }),
    /* @__PURE__ */ le(
      "textarea",
      {
        id: u,
        name: O,
        "aria-label": "textarea",
        placeholder: m,
        onChange: G,
        className: Fn(s && mo[s]),
        value: R,
        defaultValue: P,
        disabled: o,
        onBlur: Z
      }
    ),
    /* @__PURE__ */ tn("div", { className: mo["container-counter-icon"], children: [
      E && s && /* @__PURE__ */ tn("div", { className: mo["container-icon"], children: [
        /* @__PURE__ */ le(
          kf,
          {
            name: `${s === "error" ? "error-warning-fill" : "checkbox-fill"}`,
            size: "medium",
            className: Fn(mo[s])
          }
        ),
        /* @__PURE__ */ le("span", { className: mo[s], children: E })
      ] }),
      g && /* @__PURE__ */ tn("div", { className: Fn(mo.counter, M > g && mo.error), children: [
        M,
        "/",
        g
      ] })
    ] })
  ] });
}
const Ok = {
  "is-extra-small": "_is-extra-small_17143_29",
  "is-small": "_is-small_17143_32",
  "is-medium": "_is-medium_17143_35",
  "is-large": "_is-large_17143_38",
  "is-extra-large": "_is-extra-large_17143_41",
  "is-auto": "_is-auto_17143_44",
  "is-full-width": "_is-full-width_17143_47",
  "no-border": "_no-border_17143_50",
  "has-sm-border": "_has-sm-border_17143_53",
  "has-full-border": "_has-full-border_17143_56",
  "dialog-overlay-show": "_dialog-overlay-show_17143_1",
  "dialog-content-show": "_dialog-content-show_17143_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_17143_1"
};
function xC({
  src: u,
  alt: o,
  width: s = "auto",
  borderRadius: d = "none",
  className: h = "",
  ...m
}) {
  const g = Fn(Ok.img, h, Ok[Vz[s]], Ok[Bz[d]]);
  return /* @__PURE__ */ le("img", { ...m, className: g, alt: o, src: u });
}
const Vz = {
  xsmall: "is-extra-small",
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  xlarge: "is-extra-large",
  auto: "is-auto",
  full: "is-full-width"
}, Bz = {
  none: "no-border",
  small: "has-sm-border",
  full: "has-full-border"
}, Wz = "_callout_5p9zs_29", qz = "_link_5p9zs_49", Ny = {
  callout: Wz,
  "is-small": "_is-small_5p9zs_44",
  link: qz,
  "is-medium": "_is-medium_5p9zs_52",
  "is-info": "_is-info_5p9zs_55",
  "is-warning": "_is-warning_5p9zs_58",
  "is-success": "_is-success_5p9zs_61",
  "is-error": "_is-error_5p9zs_64",
  "is-neutral": "_is-neutral_5p9zs_67",
  "is-collection": "_is-collection_5p9zs_70",
  "content-container": "_content-container_5p9zs_76",
  "dialog-overlay-show": "_dialog-overlay-show_5p9zs_1",
  "dialog-content-show": "_dialog-content-show_5p9zs_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_5p9zs_1"
}, lE = {
  info: {
    name: "information-circle",
    color: "secondary"
  },
  warning: {
    name: "warning",
    color: "warning"
  },
  success: {
    name: "verification-check",
    color: "success"
  },
  error: {
    name: "notification",
    color: "error"
  },
  neutral: {
    name: "information-circle",
    color: "secondary"
  },
  collection: {
    name: "information-circle",
    color: "primary"
  }
}, Hz = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error",
  neutral: "is-neutral",
  collection: "is-collection"
}, Zz = {
  small: "is-small",
  medium: "is-medium"
};
function Qz({
  status: u = "info",
  size: o = "medium",
  children: s,
  hasIcon: d = !1,
  backgroundImage: h
}) {
  const m = Fn(Ny.callout, Ny[Hz[u]], Ny[Zz[o]]);
  return /* @__PURE__ */ tn("div", { className: m, children: [
    d && /* @__PURE__ */ le(kf, { name: lE[u].name, color: lE[u].color, size: "2xl" }),
    /* @__PURE__ */ le("div", { className: Ny["content-container"], children: s }),
    h && /* @__PURE__ */ le("img", { src: h, alt: "background" })
  ] });
}
const Kz = "_columns_1t95q_29", Yz = "_column_1t95q_29", jl = {
  columns: Kz,
  "reverse-on-mobile": "_reverse-on-mobile_1t95q_48",
  column: Yz,
  "center-content": "_center-content_1t95q_59",
  "hidden-content-on-mobile": "_hidden-content-on-mobile_1t95q_64",
  "is-1": "_is-1_1t95q_83",
  "is-2": "_is-2_1t95q_87",
  "is-3": "_is-3_1t95q_91",
  "is-4": "_is-4_1t95q_95",
  "is-5": "_is-5_1t95q_99",
  "is-6": "_is-6_1t95q_103",
  "is-7": "_is-7_1t95q_107",
  "is-8": "_is-8_1t95q_111",
  "is-9": "_is-9_1t95q_115",
  "is-10": "_is-10_1t95q_119",
  "is-11": "_is-11_1t95q_123",
  "is-12": "_is-12_1t95q_127",
  "is-offset-1": "_is-offset-1_1t95q_131",
  "is-offset-2": "_is-offset-2_1t95q_134",
  "is-offset-3": "_is-offset-3_1t95q_137",
  "is-offset-4": "_is-offset-4_1t95q_140",
  "is-offset-5": "_is-offset-5_1t95q_143",
  "is-offset-6": "_is-offset-6_1t95q_146",
  "is-offset-7": "_is-offset-7_1t95q_149",
  "is-offset-8": "_is-offset-8_1t95q_152",
  "is-offset-9": "_is-offset-9_1t95q_155",
  "is-offset-10": "_is-offset-10_1t95q_158",
  "is-offset-11": "_is-offset-11_1t95q_161",
  "is-narrow": "_is-narrow_1t95q_164",
  "dialog-overlay-show": "_dialog-overlay-show_1t95q_1",
  "dialog-content-show": "_dialog-content-show_1t95q_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1t95q_1"
};
function SC({ children: u, className: o = "", reverseOnMobile: s = !1, ...d }) {
  const h = Fn(jl.columns, s && jl["reverse-on-mobile"], o);
  return /* @__PURE__ */ le("div", { className: h, ...d, children: u });
}
const Gz = {
  auto: "",
  1: "is-1",
  2: "is-2",
  3: "is-3",
  4: "is-4",
  5: "is-5",
  6: "is-6",
  7: "is-7",
  8: "is-8",
  9: "is-9",
  10: "is-10",
  11: "is-11",
  12: "is-12"
}, Jz = {
  auto: "",
  1: "is-offset-1",
  2: "is-offset-2",
  3: "is-offset-3",
  4: "is-offset-4",
  5: "is-offset-5",
  6: "is-offset-6",
  7: "is-offset-7",
  8: "is-offset-8",
  9: "is-offset-9",
  10: "is-offset-10",
  11: "is-offset-11",
  12: "is-offset-12"
};
function $y({
  size: u = "auto",
  offset: o = "auto",
  isNarrow: s = !1,
  centerContent: d,
  className: h = "",
  children: m,
  hiddenContentOnMobile: g = !1,
  ...k
}) {
  const S = Fn(
    jl.column,
    jl[Gz[u]],
    jl[Jz[o]],
    s && jl["is-narrow"],
    d && jl["center-content"],
    g && jl["hidden-content-on-mobile"],
    h
  );
  return /* @__PURE__ */ le("div", { className: S, ...k, children: m });
}
const Xz = "_container_1617y_29", uE = {
  container: Xz,
  "is-fluid": "_is-fluid_1617y_45"
};
function eI({ isFluid: u = !1, children: o, className: s = "", ...d }) {
  const h = Fn(uE.container, u && uE["is-fluid"], s);
  return /* @__PURE__ */ le("div", { className: h, ...d, children: o });
}
const tI = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary"
}, nI = "_section_xlbst_29", gf = {
  section: nI,
  "reverse-bg-color": "_reverse-bg-color_xlbst_42",
  "is-primary": "_is-primary_xlbst_48",
  "is-secondary": "_is-secondary_xlbst_52",
  "is-tertiary": "_is-tertiary_xlbst_56",
  "is-full-height": "_is-full-height_xlbst_60",
  "center-content": "_center-content_xlbst_63",
  "is-small-padding": "_is-small-padding_xlbst_67",
  "dialog-overlay-show": "_dialog-overlay-show_xlbst_1",
  "dialog-content-show": "_dialog-content-show_xlbst_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_xlbst_1"
};
function rI({
  children: u,
  className: o = "",
  reverseBGColor: s,
  isFullHeight: d,
  centerContent: h,
  isSmallPadding: m,
  color: g,
  ...k
}) {
  const S = Fn(
    gf.section,
    o,
    s && gf["reverse-bg-color"],
    d && gf["is-full-height"],
    h && gf["center-content"],
    m && gf["is-small-padding"],
    g && gf[tI[g]]
  );
  return /* @__PURE__ */ le("section", { ...k, className: S, children: u });
}
function EC(u) {
  var o, s, d = "";
  if (typeof u == "string" || typeof u == "number") d += u;
  else if (typeof u == "object") if (Array.isArray(u)) {
    var h = u.length;
    for (o = 0; o < h; o++) u[o] && (s = EC(u[o])) && (d && (d += " "), d += s);
  } else for (s in u) u[s] && (d && (d += " "), d += s);
  return d;
}
function aI() {
  for (var u, o, s = 0, d = "", h = arguments.length; s < h; s++) (u = arguments[s]) && (o = EC(u)) && (d && (d += " "), d += o);
  return d;
}
const oI = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook-path1",
  "icon_facebook-path2",
  "icon_gmail-path1",
  "icon_gmail-path2",
  "icon_gmail-path3",
  "icon_gmail-path4",
  "icon_gmail-path5",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], iI = oI.map((u) => ({
  name: u,
  class: `icon-${u}`
})), sI = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, lI = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl"
};
function uI(u = 0) {
  const o = [];
  for (let s = 0; s < u; s++)
    o[s] = `path${s + 1}`;
  return o.map((s) => /* @__PURE__ */ le("span", { className: s }, s));
}
const cI = Qk(
  ({ name: u, size: o = "medium", color: s = "base", className: d = "", ...h }, m) => {
    const g = iI.find((S) => S.name === u), k = aI("icon", `ds-${g == null ? void 0 : g.class}`, lI[o], sI[s], d);
    return /* @__PURE__ */ le("i", { className: k, ...h, ref: m, children: uI(g == null ? void 0 : g.transform) });
  }
);
cI.displayName = "Icon";
const dI = ["en", "fr", "it"], CC = PE({
  locale: "en"
});
function fI({ children: u, ...o }) {
  return /* @__PURE__ */ le(CC.Provider, { value: o, children: u });
}
const pI = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
function hI(u) {
  return dI.includes(u) && !0;
}
function mI(u, o) {
  const s = pI.test(o);
  let d;
  return hI(u) || s ? d = `${o}` : d = `/${u}${o}`, { url: d };
}
function ox(u) {
  const { locale: o } = NE(CC);
  return mI(o, u);
}
function gI() {
  const [u, o] = Vl({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return nm(() => {
    function s() {
      o({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", s), s(), () => window.removeEventListener("resize", s);
  }, []), u;
}
function TC() {
  const { width: u } = gI();
  let o = "desktop";
  return u && u <= $S.MOBILE ? o = "mobile" : u && u <= $S.TABLET && (o = "tablet"), {
    currentDevice: o,
    isMobile: o === "mobile",
    isTablet: o === "tablet",
    isDesktop: o === "desktop"
  };
}
const cE = (u, o, s) => {
  if (u && "reportValidity" in u) {
    const d = ge(s, o);
    u.setCustomValidity(d && d.message || ""), u.reportValidity();
  }
}, RC = (u, o) => {
  for (const s in o.fields) {
    const d = o.fields[s];
    d && d.ref && "reportValidity" in d.ref ? cE(d.ref, s, u) : d.refs && d.refs.forEach((h) => cE(h, s, u));
  }
}, vI = (u, o) => {
  o.shouldUseNativeValidation && RC(u, o);
  const s = {};
  for (const d in u) {
    const h = ge(o.fields, d), m = Object.assign(u[d] || {}, { ref: h && h.ref });
    if (yI(o.names || Object.keys(u), d)) {
      const g = Object.assign({}, ge(s, d));
      Vt(g, "root", m), Vt(s, d, g);
    } else Vt(s, d, m);
  }
  return s;
}, yI = (u, o) => u.some((s) => s.startsWith(o + "."));
var bI = function(u, o) {
  for (var s = {}; u.length; ) {
    var d = u[0], h = d.code, m = d.message, g = d.path.join(".");
    if (!s[g]) if ("unionErrors" in d) {
      var k = d.unionErrors[0].errors[0];
      s[g] = { message: k.message, type: k.code };
    } else s[g] = { message: m, type: h };
    if ("unionErrors" in d && d.unionErrors.forEach(function(R) {
      return R.errors.forEach(function(P) {
        return u.push(P);
      });
    }), o) {
      var S = s[g].types, E = S && S[d.code];
      s[g] = VE(g, o, s, h, E ? [].concat(E, d.message) : d.message);
    }
    u.shift();
  }
  return s;
}, _I = function(u, o, s) {
  return s === void 0 && (s = {}), function(d, h, m) {
    try {
      return Promise.resolve(function(g, k) {
        try {
          var S = Promise.resolve(u[s.mode === "sync" ? "parse" : "parseAsync"](d, o)).then(function(E) {
            return m.shouldUseNativeValidation && RC({}, m), { errors: {}, values: s.raw ? d : E };
          });
        } catch (E) {
          return k(E);
        }
        return S && S.then ? S.then(void 0, k) : S;
      }(0, function(g) {
        if (function(k) {
          return Array.isArray(k == null ? void 0 : k.errors);
        }(g)) return { values: {}, errors: vI(bI(g.errors, !m.shouldUseNativeValidation && m.criteriaMode === "all"), m) };
        throw g;
      }));
    } catch (g) {
      return Promise.reject(g);
    }
  };
}, Lt;
(function(u) {
  u.assertEqual = (h) => h;
  function o(h) {
  }
  u.assertIs = o;
  function s(h) {
    throw new Error();
  }
  u.assertNever = s, u.arrayToEnum = (h) => {
    const m = {};
    for (const g of h)
      m[g] = g;
    return m;
  }, u.getValidEnumValues = (h) => {
    const m = u.objectKeys(h).filter((k) => typeof h[h[k]] != "number"), g = {};
    for (const k of m)
      g[k] = h[k];
    return u.objectValues(g);
  }, u.objectValues = (h) => u.objectKeys(h).map(function(m) {
    return h[m];
  }), u.objectKeys = typeof Object.keys == "function" ? (h) => Object.keys(h) : (h) => {
    const m = [];
    for (const g in h)
      Object.prototype.hasOwnProperty.call(h, g) && m.push(g);
    return m;
  }, u.find = (h, m) => {
    for (const g of h)
      if (m(g))
        return g;
  }, u.isInteger = typeof Number.isInteger == "function" ? (h) => Number.isInteger(h) : (h) => typeof h == "number" && isFinite(h) && Math.floor(h) === h;
  function d(h, m = " | ") {
    return h.map((g) => typeof g == "string" ? `'${g}'` : g).join(m);
  }
  u.joinValues = d, u.jsonStringifyReplacer = (h, m) => typeof m == "bigint" ? m.toString() : m;
})(Lt || (Lt = {}));
var Vk;
(function(u) {
  u.mergeShapes = (o, s) => ({
    ...o,
    ...s
    // second overwrites first
  });
})(Vk || (Vk = {}));
const Ne = Lt.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Ws = (u) => {
  switch (typeof u) {
    case "undefined":
      return Ne.undefined;
    case "string":
      return Ne.string;
    case "number":
      return isNaN(u) ? Ne.nan : Ne.number;
    case "boolean":
      return Ne.boolean;
    case "function":
      return Ne.function;
    case "bigint":
      return Ne.bigint;
    case "symbol":
      return Ne.symbol;
    case "object":
      return Array.isArray(u) ? Ne.array : u === null ? Ne.null : u.then && typeof u.then == "function" && u.catch && typeof u.catch == "function" ? Ne.promise : typeof Map < "u" && u instanceof Map ? Ne.map : typeof Set < "u" && u instanceof Set ? Ne.set : typeof Date < "u" && u instanceof Date ? Ne.date : Ne.object;
    default:
      return Ne.unknown;
  }
}, ie = Lt.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), wI = (u) => JSON.stringify(u, null, 2).replace(/"([^"]+)":/g, "$1:");
class qa extends Error {
  get errors() {
    return this.issues;
  }
  constructor(o) {
    super(), this.issues = [], this.addIssue = (d) => {
      this.issues = [...this.issues, d];
    }, this.addIssues = (d = []) => {
      this.issues = [...this.issues, ...d];
    };
    const s = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, s) : this.__proto__ = s, this.name = "ZodError", this.issues = o;
  }
  format(o) {
    const s = o || function(m) {
      return m.message;
    }, d = { _errors: [] }, h = (m) => {
      for (const g of m.issues)
        if (g.code === "invalid_union")
          g.unionErrors.map(h);
        else if (g.code === "invalid_return_type")
          h(g.returnTypeError);
        else if (g.code === "invalid_arguments")
          h(g.argumentsError);
        else if (g.path.length === 0)
          d._errors.push(s(g));
        else {
          let k = d, S = 0;
          for (; S < g.path.length; ) {
            const E = g.path[S];
            S === g.path.length - 1 ? (k[E] = k[E] || { _errors: [] }, k[E]._errors.push(s(g))) : k[E] = k[E] || { _errors: [] }, k = k[E], S++;
          }
        }
    };
    return h(this), d;
  }
  static assert(o) {
    if (!(o instanceof qa))
      throw new Error(`Not a ZodError: ${o}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Lt.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(o = (s) => s.message) {
    const s = {}, d = [];
    for (const h of this.issues)
      h.path.length > 0 ? (s[h.path[0]] = s[h.path[0]] || [], s[h.path[0]].push(o(h))) : d.push(o(h));
    return { formErrors: d, fieldErrors: s };
  }
  get formErrors() {
    return this.flatten();
  }
}
qa.create = (u) => new qa(u);
const Sf = (u, o) => {
  let s;
  switch (u.code) {
    case ie.invalid_type:
      u.received === Ne.undefined ? s = "Required" : s = `Expected ${u.expected}, received ${u.received}`;
      break;
    case ie.invalid_literal:
      s = `Invalid literal value, expected ${JSON.stringify(u.expected, Lt.jsonStringifyReplacer)}`;
      break;
    case ie.unrecognized_keys:
      s = `Unrecognized key(s) in object: ${Lt.joinValues(u.keys, ", ")}`;
      break;
    case ie.invalid_union:
      s = "Invalid input";
      break;
    case ie.invalid_union_discriminator:
      s = `Invalid discriminator value. Expected ${Lt.joinValues(u.options)}`;
      break;
    case ie.invalid_enum_value:
      s = `Invalid enum value. Expected ${Lt.joinValues(u.options)}, received '${u.received}'`;
      break;
    case ie.invalid_arguments:
      s = "Invalid function arguments";
      break;
    case ie.invalid_return_type:
      s = "Invalid function return type";
      break;
    case ie.invalid_date:
      s = "Invalid date";
      break;
    case ie.invalid_string:
      typeof u.validation == "object" ? "includes" in u.validation ? (s = `Invalid input: must include "${u.validation.includes}"`, typeof u.validation.position == "number" && (s = `${s} at one or more positions greater than or equal to ${u.validation.position}`)) : "startsWith" in u.validation ? s = `Invalid input: must start with "${u.validation.startsWith}"` : "endsWith" in u.validation ? s = `Invalid input: must end with "${u.validation.endsWith}"` : Lt.assertNever(u.validation) : u.validation !== "regex" ? s = `Invalid ${u.validation}` : s = "Invalid";
      break;
    case ie.too_small:
      u.type === "array" ? s = `Array must contain ${u.exact ? "exactly" : u.inclusive ? "at least" : "more than"} ${u.minimum} element(s)` : u.type === "string" ? s = `String must contain ${u.exact ? "exactly" : u.inclusive ? "at least" : "over"} ${u.minimum} character(s)` : u.type === "number" ? s = `Number must be ${u.exact ? "exactly equal to " : u.inclusive ? "greater than or equal to " : "greater than "}${u.minimum}` : u.type === "date" ? s = `Date must be ${u.exact ? "exactly equal to " : u.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(u.minimum))}` : s = "Invalid input";
      break;
    case ie.too_big:
      u.type === "array" ? s = `Array must contain ${u.exact ? "exactly" : u.inclusive ? "at most" : "less than"} ${u.maximum} element(s)` : u.type === "string" ? s = `String must contain ${u.exact ? "exactly" : u.inclusive ? "at most" : "under"} ${u.maximum} character(s)` : u.type === "number" ? s = `Number must be ${u.exact ? "exactly" : u.inclusive ? "less than or equal to" : "less than"} ${u.maximum}` : u.type === "bigint" ? s = `BigInt must be ${u.exact ? "exactly" : u.inclusive ? "less than or equal to" : "less than"} ${u.maximum}` : u.type === "date" ? s = `Date must be ${u.exact ? "exactly" : u.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(u.maximum))}` : s = "Invalid input";
      break;
    case ie.custom:
      s = "Invalid input";
      break;
    case ie.invalid_intersection_types:
      s = "Intersection results could not be merged";
      break;
    case ie.not_multiple_of:
      s = `Number must be a multiple of ${u.multipleOf}`;
      break;
    case ie.not_finite:
      s = "Number must be finite";
      break;
    default:
      s = o.defaultError, Lt.assertNever(u);
  }
  return { message: s };
};
let PC = Sf;
function kI(u) {
  PC = u;
}
function jy() {
  return PC;
}
const Uy = (u) => {
  const { data: o, path: s, errorMaps: d, issueData: h } = u, m = [...s, ...h.path || []], g = {
    ...h,
    path: m
  };
  if (h.message !== void 0)
    return {
      ...h,
      path: m,
      message: h.message
    };
  let k = "";
  const S = d.filter((E) => !!E).slice().reverse();
  for (const E of S)
    k = E(g, { data: o, defaultError: k }).message;
  return {
    ...h,
    path: m,
    message: k
  };
}, xI = [];
function _e(u, o) {
  const s = jy(), d = Uy({
    issueData: o,
    data: u.data,
    path: u.path,
    errorMaps: [
      u.common.contextualErrorMap,
      // contextual error map is first priority
      u.schemaErrorMap,
      // then schema-bound map if available
      s,
      // then global override map
      s === Sf ? void 0 : Sf
      // then global default map
    ].filter((h) => !!h)
  });
  u.common.issues.push(d);
}
class Vr {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(o, s) {
    const d = [];
    for (const h of s) {
      if (h.status === "aborted")
        return ot;
      h.status === "dirty" && o.dirty(), d.push(h.value);
    }
    return { status: o.value, value: d };
  }
  static async mergeObjectAsync(o, s) {
    const d = [];
    for (const h of s) {
      const m = await h.key, g = await h.value;
      d.push({
        key: m,
        value: g
      });
    }
    return Vr.mergeObjectSync(o, d);
  }
  static mergeObjectSync(o, s) {
    const d = {};
    for (const h of s) {
      const { key: m, value: g } = h;
      if (m.status === "aborted" || g.status === "aborted")
        return ot;
      m.status === "dirty" && o.dirty(), g.status === "dirty" && o.dirty(), m.value !== "__proto__" && (typeof g.value < "u" || h.alwaysSet) && (d[m.value] = g.value);
    }
    return { status: o.value, value: d };
  }
}
const ot = Object.freeze({
  status: "aborted"
}), _f = (u) => ({ status: "dirty", value: u }), aa = (u) => ({ status: "valid", value: u }), Bk = (u) => u.status === "aborted", Wk = (u) => u.status === "dirty", uc = (u) => u.status === "valid", am = (u) => typeof Promise < "u" && u instanceof Promise;
function Vy(u, o, s, d) {
  if (typeof o == "function" ? u !== o || !0 : !o.has(u)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return o.get(u);
}
function NC(u, o, s, d, h) {
  if (typeof o == "function" ? u !== o || !0 : !o.has(u)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return o.set(u, s), s;
}
var Ve;
(function(u) {
  u.errToObj = (o) => typeof o == "string" ? { message: o } : o || {}, u.toString = (o) => typeof o == "string" ? o : o == null ? void 0 : o.message;
})(Ve || (Ve = {}));
var Gh, Jh;
class ji {
  constructor(o, s, d, h) {
    this._cachedPath = [], this.parent = o, this.data = s, this._path = d, this._key = h;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const dE = (u, o) => {
  if (uc(o))
    return { success: !0, data: o.value };
  if (!u.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const s = new qa(u.common.issues);
      return this._error = s, this._error;
    }
  };
};
function mt(u) {
  if (!u)
    return {};
  const { errorMap: o, invalid_type_error: s, required_error: d, description: h } = u;
  if (o && (s || d))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return o ? { errorMap: o, description: h } : { errorMap: (g, k) => {
    var S, E;
    const { message: R } = u;
    return g.code === "invalid_enum_value" ? { message: R ?? k.defaultError } : typeof k.data > "u" ? { message: (S = R ?? d) !== null && S !== void 0 ? S : k.defaultError } : g.code !== "invalid_type" ? { message: k.defaultError } : { message: (E = R ?? s) !== null && E !== void 0 ? E : k.defaultError };
  }, description: h };
}
class yt {
  get description() {
    return this._def.description;
  }
  _getType(o) {
    return Ws(o.data);
  }
  _getOrReturnCtx(o, s) {
    return s || {
      common: o.parent.common,
      data: o.data,
      parsedType: Ws(o.data),
      schemaErrorMap: this._def.errorMap,
      path: o.path,
      parent: o.parent
    };
  }
  _processInputParams(o) {
    return {
      status: new Vr(),
      ctx: {
        common: o.parent.common,
        data: o.data,
        parsedType: Ws(o.data),
        schemaErrorMap: this._def.errorMap,
        path: o.path,
        parent: o.parent
      }
    };
  }
  _parseSync(o) {
    const s = this._parse(o);
    if (am(s))
      throw new Error("Synchronous parse encountered promise.");
    return s;
  }
  _parseAsync(o) {
    const s = this._parse(o);
    return Promise.resolve(s);
  }
  parse(o, s) {
    const d = this.safeParse(o, s);
    if (d.success)
      return d.data;
    throw d.error;
  }
  safeParse(o, s) {
    var d;
    const h = {
      common: {
        issues: [],
        async: (d = s == null ? void 0 : s.async) !== null && d !== void 0 ? d : !1,
        contextualErrorMap: s == null ? void 0 : s.errorMap
      },
      path: (s == null ? void 0 : s.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: o,
      parsedType: Ws(o)
    }, m = this._parseSync({ data: o, path: h.path, parent: h });
    return dE(h, m);
  }
  "~validate"(o) {
    var s, d;
    const h = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: o,
      parsedType: Ws(o)
    };
    if (!this["~standard"].async)
      try {
        const m = this._parseSync({ data: o, path: [], parent: h });
        return uc(m) ? {
          value: m.value
        } : {
          issues: h.common.issues
        };
      } catch (m) {
        !((d = (s = m == null ? void 0 : m.message) === null || s === void 0 ? void 0 : s.toLowerCase()) === null || d === void 0) && d.includes("encountered") && (this["~standard"].async = !0), h.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: o, path: [], parent: h }).then((m) => uc(m) ? {
      value: m.value
    } : {
      issues: h.common.issues
    });
  }
  async parseAsync(o, s) {
    const d = await this.safeParseAsync(o, s);
    if (d.success)
      return d.data;
    throw d.error;
  }
  async safeParseAsync(o, s) {
    const d = {
      common: {
        issues: [],
        contextualErrorMap: s == null ? void 0 : s.errorMap,
        async: !0
      },
      path: (s == null ? void 0 : s.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: o,
      parsedType: Ws(o)
    }, h = this._parse({ data: o, path: d.path, parent: d }), m = await (am(h) ? h : Promise.resolve(h));
    return dE(d, m);
  }
  refine(o, s) {
    const d = (h) => typeof s == "string" || typeof s > "u" ? { message: s } : typeof s == "function" ? s(h) : s;
    return this._refinement((h, m) => {
      const g = o(h), k = () => m.addIssue({
        code: ie.custom,
        ...d(h)
      });
      return typeof Promise < "u" && g instanceof Promise ? g.then((S) => S ? !0 : (k(), !1)) : g ? !0 : (k(), !1);
    });
  }
  refinement(o, s) {
    return this._refinement((d, h) => o(d) ? !0 : (h.addIssue(typeof s == "function" ? s(d, h) : s), !1));
  }
  _refinement(o) {
    return new Jo({
      schema: this,
      typeName: nt.ZodEffects,
      effect: { type: "refinement", refinement: o }
    });
  }
  superRefine(o) {
    return this._refinement(o);
  }
  constructor(o) {
    this.spa = this.safeParseAsync, this._def = o, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (s) => this["~validate"](s)
    };
  }
  optional() {
    return $i.create(this, this._def);
  }
  nullable() {
    return Hl.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Go.create(this);
  }
  promise() {
    return Cf.create(this, this._def);
  }
  or(o) {
    return lm.create([this, o], this._def);
  }
  and(o) {
    return um.create(this, o, this._def);
  }
  transform(o) {
    return new Jo({
      ...mt(this._def),
      schema: this,
      typeName: nt.ZodEffects,
      effect: { type: "transform", transform: o }
    });
  }
  default(o) {
    const s = typeof o == "function" ? o : () => o;
    return new hm({
      ...mt(this._def),
      innerType: this,
      defaultValue: s,
      typeName: nt.ZodDefault
    });
  }
  brand() {
    return new ix({
      typeName: nt.ZodBranded,
      type: this,
      ...mt(this._def)
    });
  }
  catch(o) {
    const s = typeof o == "function" ? o : () => o;
    return new mm({
      ...mt(this._def),
      innerType: this,
      catchValue: s,
      typeName: nt.ZodCatch
    });
  }
  describe(o) {
    const s = this.constructor;
    return new s({
      ...this._def,
      description: o
    });
  }
  pipe(o) {
    return _m.create(this, o);
  }
  readonly() {
    return gm.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const SI = /^c[^\s-]{8,}$/i, EI = /^[0-9a-z]+$/, CI = /^[0-9A-HJKMNP-TV-Z]{26}$/i, TI = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, RI = /^[a-z0-9_-]{21}$/i, PI = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, NI = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, OI = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, LI = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Lk;
const DI = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, zI = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, II = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, AI = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, MI = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, FI = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, OC = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", $I = new RegExp(`^${OC}$`);
function LC(u) {
  let o = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return u.precision ? o = `${o}\\.\\d{${u.precision}}` : u.precision == null && (o = `${o}(\\.\\d+)?`), o;
}
function jI(u) {
  return new RegExp(`^${LC(u)}$`);
}
function DC(u) {
  let o = `${OC}T${LC(u)}`;
  const s = [];
  return s.push(u.local ? "Z?" : "Z"), u.offset && s.push("([+-]\\d{2}:?\\d{2})"), o = `${o}(${s.join("|")})`, new RegExp(`^${o}$`);
}
function UI(u, o) {
  return !!((o === "v4" || !o) && DI.test(u) || (o === "v6" || !o) && II.test(u));
}
function VI(u, o) {
  if (!PI.test(u))
    return !1;
  try {
    const [s] = u.split("."), d = s.replace(/-/g, "+").replace(/_/g, "/").padEnd(s.length + (4 - s.length % 4) % 4, "="), h = JSON.parse(atob(d));
    return !(typeof h != "object" || h === null || !h.typ || !h.alg || o && h.alg !== o);
  } catch {
    return !1;
  }
}
function BI(u, o) {
  return !!((o === "v4" || !o) && zI.test(u) || (o === "v6" || !o) && AI.test(u));
}
class Yo extends yt {
  _parse(o) {
    if (this._def.coerce && (o.data = String(o.data)), this._getType(o) !== Ne.string) {
      const m = this._getOrReturnCtx(o);
      return _e(m, {
        code: ie.invalid_type,
        expected: Ne.string,
        received: m.parsedType
      }), ot;
    }
    const d = new Vr();
    let h;
    for (const m of this._def.checks)
      if (m.kind === "min")
        o.data.length < m.value && (h = this._getOrReturnCtx(o, h), _e(h, {
          code: ie.too_small,
          minimum: m.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: m.message
        }), d.dirty());
      else if (m.kind === "max")
        o.data.length > m.value && (h = this._getOrReturnCtx(o, h), _e(h, {
          code: ie.too_big,
          maximum: m.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: m.message
        }), d.dirty());
      else if (m.kind === "length") {
        const g = o.data.length > m.value, k = o.data.length < m.value;
        (g || k) && (h = this._getOrReturnCtx(o, h), g ? _e(h, {
          code: ie.too_big,
          maximum: m.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: m.message
        }) : k && _e(h, {
          code: ie.too_small,
          minimum: m.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: m.message
        }), d.dirty());
      } else if (m.kind === "email")
        OI.test(o.data) || (h = this._getOrReturnCtx(o, h), _e(h, {
          validation: "email",
          code: ie.invalid_string,
          message: m.message
        }), d.dirty());
      else if (m.kind === "emoji")
        Lk || (Lk = new RegExp(LI, "u")), Lk.test(o.data) || (h = this._getOrReturnCtx(o, h), _e(h, {
          validation: "emoji",
          code: ie.invalid_string,
          message: m.message
        }), d.dirty());
      else if (m.kind === "uuid")
        TI.test(o.data) || (h = this._getOrReturnCtx(o, h), _e(h, {
          validation: "uuid",
          code: ie.invalid_string,
          message: m.message
        }), d.dirty());
      else if (m.kind === "nanoid")
        RI.test(o.data) || (h = this._getOrReturnCtx(o, h), _e(h, {
          validation: "nanoid",
          code: ie.invalid_string,
          message: m.message
        }), d.dirty());
      else if (m.kind === "cuid")
        SI.test(o.data) || (h = this._getOrReturnCtx(o, h), _e(h, {
          validation: "cuid",
          code: ie.invalid_string,
          message: m.message
        }), d.dirty());
      else if (m.kind === "cuid2")
        EI.test(o.data) || (h = this._getOrReturnCtx(o, h), _e(h, {
          validation: "cuid2",
          code: ie.invalid_string,
          message: m.message
        }), d.dirty());
      else if (m.kind === "ulid")
        CI.test(o.data) || (h = this._getOrReturnCtx(o, h), _e(h, {
          validation: "ulid",
          code: ie.invalid_string,
          message: m.message
        }), d.dirty());
      else if (m.kind === "url")
        try {
          new URL(o.data);
        } catch {
          h = this._getOrReturnCtx(o, h), _e(h, {
            validation: "url",
            code: ie.invalid_string,
            message: m.message
          }), d.dirty();
        }
      else m.kind === "regex" ? (m.regex.lastIndex = 0, m.regex.test(o.data) || (h = this._getOrReturnCtx(o, h), _e(h, {
        validation: "regex",
        code: ie.invalid_string,
        message: m.message
      }), d.dirty())) : m.kind === "trim" ? o.data = o.data.trim() : m.kind === "includes" ? o.data.includes(m.value, m.position) || (h = this._getOrReturnCtx(o, h), _e(h, {
        code: ie.invalid_string,
        validation: { includes: m.value, position: m.position },
        message: m.message
      }), d.dirty()) : m.kind === "toLowerCase" ? o.data = o.data.toLowerCase() : m.kind === "toUpperCase" ? o.data = o.data.toUpperCase() : m.kind === "startsWith" ? o.data.startsWith(m.value) || (h = this._getOrReturnCtx(o, h), _e(h, {
        code: ie.invalid_string,
        validation: { startsWith: m.value },
        message: m.message
      }), d.dirty()) : m.kind === "endsWith" ? o.data.endsWith(m.value) || (h = this._getOrReturnCtx(o, h), _e(h, {
        code: ie.invalid_string,
        validation: { endsWith: m.value },
        message: m.message
      }), d.dirty()) : m.kind === "datetime" ? DC(m).test(o.data) || (h = this._getOrReturnCtx(o, h), _e(h, {
        code: ie.invalid_string,
        validation: "datetime",
        message: m.message
      }), d.dirty()) : m.kind === "date" ? $I.test(o.data) || (h = this._getOrReturnCtx(o, h), _e(h, {
        code: ie.invalid_string,
        validation: "date",
        message: m.message
      }), d.dirty()) : m.kind === "time" ? jI(m).test(o.data) || (h = this._getOrReturnCtx(o, h), _e(h, {
        code: ie.invalid_string,
        validation: "time",
        message: m.message
      }), d.dirty()) : m.kind === "duration" ? NI.test(o.data) || (h = this._getOrReturnCtx(o, h), _e(h, {
        validation: "duration",
        code: ie.invalid_string,
        message: m.message
      }), d.dirty()) : m.kind === "ip" ? UI(o.data, m.version) || (h = this._getOrReturnCtx(o, h), _e(h, {
        validation: "ip",
        code: ie.invalid_string,
        message: m.message
      }), d.dirty()) : m.kind === "jwt" ? VI(o.data, m.alg) || (h = this._getOrReturnCtx(o, h), _e(h, {
        validation: "jwt",
        code: ie.invalid_string,
        message: m.message
      }), d.dirty()) : m.kind === "cidr" ? BI(o.data, m.version) || (h = this._getOrReturnCtx(o, h), _e(h, {
        validation: "cidr",
        code: ie.invalid_string,
        message: m.message
      }), d.dirty()) : m.kind === "base64" ? MI.test(o.data) || (h = this._getOrReturnCtx(o, h), _e(h, {
        validation: "base64",
        code: ie.invalid_string,
        message: m.message
      }), d.dirty()) : m.kind === "base64url" ? FI.test(o.data) || (h = this._getOrReturnCtx(o, h), _e(h, {
        validation: "base64url",
        code: ie.invalid_string,
        message: m.message
      }), d.dirty()) : Lt.assertNever(m);
    return { status: d.value, value: o.data };
  }
  _regex(o, s, d) {
    return this.refinement((h) => o.test(h), {
      validation: s,
      code: ie.invalid_string,
      ...Ve.errToObj(d)
    });
  }
  _addCheck(o) {
    return new Yo({
      ...this._def,
      checks: [...this._def.checks, o]
    });
  }
  email(o) {
    return this._addCheck({ kind: "email", ...Ve.errToObj(o) });
  }
  url(o) {
    return this._addCheck({ kind: "url", ...Ve.errToObj(o) });
  }
  emoji(o) {
    return this._addCheck({ kind: "emoji", ...Ve.errToObj(o) });
  }
  uuid(o) {
    return this._addCheck({ kind: "uuid", ...Ve.errToObj(o) });
  }
  nanoid(o) {
    return this._addCheck({ kind: "nanoid", ...Ve.errToObj(o) });
  }
  cuid(o) {
    return this._addCheck({ kind: "cuid", ...Ve.errToObj(o) });
  }
  cuid2(o) {
    return this._addCheck({ kind: "cuid2", ...Ve.errToObj(o) });
  }
  ulid(o) {
    return this._addCheck({ kind: "ulid", ...Ve.errToObj(o) });
  }
  base64(o) {
    return this._addCheck({ kind: "base64", ...Ve.errToObj(o) });
  }
  base64url(o) {
    return this._addCheck({
      kind: "base64url",
      ...Ve.errToObj(o)
    });
  }
  jwt(o) {
    return this._addCheck({ kind: "jwt", ...Ve.errToObj(o) });
  }
  ip(o) {
    return this._addCheck({ kind: "ip", ...Ve.errToObj(o) });
  }
  cidr(o) {
    return this._addCheck({ kind: "cidr", ...Ve.errToObj(o) });
  }
  datetime(o) {
    var s, d;
    return typeof o == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: o
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (o == null ? void 0 : o.precision) > "u" ? null : o == null ? void 0 : o.precision,
      offset: (s = o == null ? void 0 : o.offset) !== null && s !== void 0 ? s : !1,
      local: (d = o == null ? void 0 : o.local) !== null && d !== void 0 ? d : !1,
      ...Ve.errToObj(o == null ? void 0 : o.message)
    });
  }
  date(o) {
    return this._addCheck({ kind: "date", message: o });
  }
  time(o) {
    return typeof o == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: o
    }) : this._addCheck({
      kind: "time",
      precision: typeof (o == null ? void 0 : o.precision) > "u" ? null : o == null ? void 0 : o.precision,
      ...Ve.errToObj(o == null ? void 0 : o.message)
    });
  }
  duration(o) {
    return this._addCheck({ kind: "duration", ...Ve.errToObj(o) });
  }
  regex(o, s) {
    return this._addCheck({
      kind: "regex",
      regex: o,
      ...Ve.errToObj(s)
    });
  }
  includes(o, s) {
    return this._addCheck({
      kind: "includes",
      value: o,
      position: s == null ? void 0 : s.position,
      ...Ve.errToObj(s == null ? void 0 : s.message)
    });
  }
  startsWith(o, s) {
    return this._addCheck({
      kind: "startsWith",
      value: o,
      ...Ve.errToObj(s)
    });
  }
  endsWith(o, s) {
    return this._addCheck({
      kind: "endsWith",
      value: o,
      ...Ve.errToObj(s)
    });
  }
  min(o, s) {
    return this._addCheck({
      kind: "min",
      value: o,
      ...Ve.errToObj(s)
    });
  }
  max(o, s) {
    return this._addCheck({
      kind: "max",
      value: o,
      ...Ve.errToObj(s)
    });
  }
  length(o, s) {
    return this._addCheck({
      kind: "length",
      value: o,
      ...Ve.errToObj(s)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(o) {
    return this.min(1, Ve.errToObj(o));
  }
  trim() {
    return new Yo({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Yo({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Yo({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((o) => o.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((o) => o.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((o) => o.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((o) => o.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((o) => o.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((o) => o.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((o) => o.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((o) => o.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((o) => o.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((o) => o.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((o) => o.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((o) => o.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((o) => o.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((o) => o.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((o) => o.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((o) => o.kind === "base64url");
  }
  get minLength() {
    let o = null;
    for (const s of this._def.checks)
      s.kind === "min" && (o === null || s.value > o) && (o = s.value);
    return o;
  }
  get maxLength() {
    let o = null;
    for (const s of this._def.checks)
      s.kind === "max" && (o === null || s.value < o) && (o = s.value);
    return o;
  }
}
Yo.create = (u) => {
  var o;
  return new Yo({
    checks: [],
    typeName: nt.ZodString,
    coerce: (o = u == null ? void 0 : u.coerce) !== null && o !== void 0 ? o : !1,
    ...mt(u)
  });
};
function WI(u, o) {
  const s = (u.toString().split(".")[1] || "").length, d = (o.toString().split(".")[1] || "").length, h = s > d ? s : d, m = parseInt(u.toFixed(h).replace(".", "")), g = parseInt(o.toFixed(h).replace(".", ""));
  return m % g / Math.pow(10, h);
}
class Bl extends yt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(o) {
    if (this._def.coerce && (o.data = Number(o.data)), this._getType(o) !== Ne.number) {
      const m = this._getOrReturnCtx(o);
      return _e(m, {
        code: ie.invalid_type,
        expected: Ne.number,
        received: m.parsedType
      }), ot;
    }
    let d;
    const h = new Vr();
    for (const m of this._def.checks)
      m.kind === "int" ? Lt.isInteger(o.data) || (d = this._getOrReturnCtx(o, d), _e(d, {
        code: ie.invalid_type,
        expected: "integer",
        received: "float",
        message: m.message
      }), h.dirty()) : m.kind === "min" ? (m.inclusive ? o.data < m.value : o.data <= m.value) && (d = this._getOrReturnCtx(o, d), _e(d, {
        code: ie.too_small,
        minimum: m.value,
        type: "number",
        inclusive: m.inclusive,
        exact: !1,
        message: m.message
      }), h.dirty()) : m.kind === "max" ? (m.inclusive ? o.data > m.value : o.data >= m.value) && (d = this._getOrReturnCtx(o, d), _e(d, {
        code: ie.too_big,
        maximum: m.value,
        type: "number",
        inclusive: m.inclusive,
        exact: !1,
        message: m.message
      }), h.dirty()) : m.kind === "multipleOf" ? WI(o.data, m.value) !== 0 && (d = this._getOrReturnCtx(o, d), _e(d, {
        code: ie.not_multiple_of,
        multipleOf: m.value,
        message: m.message
      }), h.dirty()) : m.kind === "finite" ? Number.isFinite(o.data) || (d = this._getOrReturnCtx(o, d), _e(d, {
        code: ie.not_finite,
        message: m.message
      }), h.dirty()) : Lt.assertNever(m);
    return { status: h.value, value: o.data };
  }
  gte(o, s) {
    return this.setLimit("min", o, !0, Ve.toString(s));
  }
  gt(o, s) {
    return this.setLimit("min", o, !1, Ve.toString(s));
  }
  lte(o, s) {
    return this.setLimit("max", o, !0, Ve.toString(s));
  }
  lt(o, s) {
    return this.setLimit("max", o, !1, Ve.toString(s));
  }
  setLimit(o, s, d, h) {
    return new Bl({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: o,
          value: s,
          inclusive: d,
          message: Ve.toString(h)
        }
      ]
    });
  }
  _addCheck(o) {
    return new Bl({
      ...this._def,
      checks: [...this._def.checks, o]
    });
  }
  int(o) {
    return this._addCheck({
      kind: "int",
      message: Ve.toString(o)
    });
  }
  positive(o) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Ve.toString(o)
    });
  }
  negative(o) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Ve.toString(o)
    });
  }
  nonpositive(o) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Ve.toString(o)
    });
  }
  nonnegative(o) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Ve.toString(o)
    });
  }
  multipleOf(o, s) {
    return this._addCheck({
      kind: "multipleOf",
      value: o,
      message: Ve.toString(s)
    });
  }
  finite(o) {
    return this._addCheck({
      kind: "finite",
      message: Ve.toString(o)
    });
  }
  safe(o) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Ve.toString(o)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Ve.toString(o)
    });
  }
  get minValue() {
    let o = null;
    for (const s of this._def.checks)
      s.kind === "min" && (o === null || s.value > o) && (o = s.value);
    return o;
  }
  get maxValue() {
    let o = null;
    for (const s of this._def.checks)
      s.kind === "max" && (o === null || s.value < o) && (o = s.value);
    return o;
  }
  get isInt() {
    return !!this._def.checks.find((o) => o.kind === "int" || o.kind === "multipleOf" && Lt.isInteger(o.value));
  }
  get isFinite() {
    let o = null, s = null;
    for (const d of this._def.checks) {
      if (d.kind === "finite" || d.kind === "int" || d.kind === "multipleOf")
        return !0;
      d.kind === "min" ? (s === null || d.value > s) && (s = d.value) : d.kind === "max" && (o === null || d.value < o) && (o = d.value);
    }
    return Number.isFinite(s) && Number.isFinite(o);
  }
}
Bl.create = (u) => new Bl({
  checks: [],
  typeName: nt.ZodNumber,
  coerce: (u == null ? void 0 : u.coerce) || !1,
  ...mt(u)
});
class Wl extends yt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(o) {
    if (this._def.coerce)
      try {
        o.data = BigInt(o.data);
      } catch {
        return this._getInvalidInput(o);
      }
    if (this._getType(o) !== Ne.bigint)
      return this._getInvalidInput(o);
    let d;
    const h = new Vr();
    for (const m of this._def.checks)
      m.kind === "min" ? (m.inclusive ? o.data < m.value : o.data <= m.value) && (d = this._getOrReturnCtx(o, d), _e(d, {
        code: ie.too_small,
        type: "bigint",
        minimum: m.value,
        inclusive: m.inclusive,
        message: m.message
      }), h.dirty()) : m.kind === "max" ? (m.inclusive ? o.data > m.value : o.data >= m.value) && (d = this._getOrReturnCtx(o, d), _e(d, {
        code: ie.too_big,
        type: "bigint",
        maximum: m.value,
        inclusive: m.inclusive,
        message: m.message
      }), h.dirty()) : m.kind === "multipleOf" ? o.data % m.value !== BigInt(0) && (d = this._getOrReturnCtx(o, d), _e(d, {
        code: ie.not_multiple_of,
        multipleOf: m.value,
        message: m.message
      }), h.dirty()) : Lt.assertNever(m);
    return { status: h.value, value: o.data };
  }
  _getInvalidInput(o) {
    const s = this._getOrReturnCtx(o);
    return _e(s, {
      code: ie.invalid_type,
      expected: Ne.bigint,
      received: s.parsedType
    }), ot;
  }
  gte(o, s) {
    return this.setLimit("min", o, !0, Ve.toString(s));
  }
  gt(o, s) {
    return this.setLimit("min", o, !1, Ve.toString(s));
  }
  lte(o, s) {
    return this.setLimit("max", o, !0, Ve.toString(s));
  }
  lt(o, s) {
    return this.setLimit("max", o, !1, Ve.toString(s));
  }
  setLimit(o, s, d, h) {
    return new Wl({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: o,
          value: s,
          inclusive: d,
          message: Ve.toString(h)
        }
      ]
    });
  }
  _addCheck(o) {
    return new Wl({
      ...this._def,
      checks: [...this._def.checks, o]
    });
  }
  positive(o) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Ve.toString(o)
    });
  }
  negative(o) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Ve.toString(o)
    });
  }
  nonpositive(o) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Ve.toString(o)
    });
  }
  nonnegative(o) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Ve.toString(o)
    });
  }
  multipleOf(o, s) {
    return this._addCheck({
      kind: "multipleOf",
      value: o,
      message: Ve.toString(s)
    });
  }
  get minValue() {
    let o = null;
    for (const s of this._def.checks)
      s.kind === "min" && (o === null || s.value > o) && (o = s.value);
    return o;
  }
  get maxValue() {
    let o = null;
    for (const s of this._def.checks)
      s.kind === "max" && (o === null || s.value < o) && (o = s.value);
    return o;
  }
}
Wl.create = (u) => {
  var o;
  return new Wl({
    checks: [],
    typeName: nt.ZodBigInt,
    coerce: (o = u == null ? void 0 : u.coerce) !== null && o !== void 0 ? o : !1,
    ...mt(u)
  });
};
class om extends yt {
  _parse(o) {
    if (this._def.coerce && (o.data = !!o.data), this._getType(o) !== Ne.boolean) {
      const d = this._getOrReturnCtx(o);
      return _e(d, {
        code: ie.invalid_type,
        expected: Ne.boolean,
        received: d.parsedType
      }), ot;
    }
    return aa(o.data);
  }
}
om.create = (u) => new om({
  typeName: nt.ZodBoolean,
  coerce: (u == null ? void 0 : u.coerce) || !1,
  ...mt(u)
});
class cc extends yt {
  _parse(o) {
    if (this._def.coerce && (o.data = new Date(o.data)), this._getType(o) !== Ne.date) {
      const m = this._getOrReturnCtx(o);
      return _e(m, {
        code: ie.invalid_type,
        expected: Ne.date,
        received: m.parsedType
      }), ot;
    }
    if (isNaN(o.data.getTime())) {
      const m = this._getOrReturnCtx(o);
      return _e(m, {
        code: ie.invalid_date
      }), ot;
    }
    const d = new Vr();
    let h;
    for (const m of this._def.checks)
      m.kind === "min" ? o.data.getTime() < m.value && (h = this._getOrReturnCtx(o, h), _e(h, {
        code: ie.too_small,
        message: m.message,
        inclusive: !0,
        exact: !1,
        minimum: m.value,
        type: "date"
      }), d.dirty()) : m.kind === "max" ? o.data.getTime() > m.value && (h = this._getOrReturnCtx(o, h), _e(h, {
        code: ie.too_big,
        message: m.message,
        inclusive: !0,
        exact: !1,
        maximum: m.value,
        type: "date"
      }), d.dirty()) : Lt.assertNever(m);
    return {
      status: d.value,
      value: new Date(o.data.getTime())
    };
  }
  _addCheck(o) {
    return new cc({
      ...this._def,
      checks: [...this._def.checks, o]
    });
  }
  min(o, s) {
    return this._addCheck({
      kind: "min",
      value: o.getTime(),
      message: Ve.toString(s)
    });
  }
  max(o, s) {
    return this._addCheck({
      kind: "max",
      value: o.getTime(),
      message: Ve.toString(s)
    });
  }
  get minDate() {
    let o = null;
    for (const s of this._def.checks)
      s.kind === "min" && (o === null || s.value > o) && (o = s.value);
    return o != null ? new Date(o) : null;
  }
  get maxDate() {
    let o = null;
    for (const s of this._def.checks)
      s.kind === "max" && (o === null || s.value < o) && (o = s.value);
    return o != null ? new Date(o) : null;
  }
}
cc.create = (u) => new cc({
  checks: [],
  coerce: (u == null ? void 0 : u.coerce) || !1,
  typeName: nt.ZodDate,
  ...mt(u)
});
class By extends yt {
  _parse(o) {
    if (this._getType(o) !== Ne.symbol) {
      const d = this._getOrReturnCtx(o);
      return _e(d, {
        code: ie.invalid_type,
        expected: Ne.symbol,
        received: d.parsedType
      }), ot;
    }
    return aa(o.data);
  }
}
By.create = (u) => new By({
  typeName: nt.ZodSymbol,
  ...mt(u)
});
class im extends yt {
  _parse(o) {
    if (this._getType(o) !== Ne.undefined) {
      const d = this._getOrReturnCtx(o);
      return _e(d, {
        code: ie.invalid_type,
        expected: Ne.undefined,
        received: d.parsedType
      }), ot;
    }
    return aa(o.data);
  }
}
im.create = (u) => new im({
  typeName: nt.ZodUndefined,
  ...mt(u)
});
class sm extends yt {
  _parse(o) {
    if (this._getType(o) !== Ne.null) {
      const d = this._getOrReturnCtx(o);
      return _e(d, {
        code: ie.invalid_type,
        expected: Ne.null,
        received: d.parsedType
      }), ot;
    }
    return aa(o.data);
  }
}
sm.create = (u) => new sm({
  typeName: nt.ZodNull,
  ...mt(u)
});
class Ef extends yt {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(o) {
    return aa(o.data);
  }
}
Ef.create = (u) => new Ef({
  typeName: nt.ZodAny,
  ...mt(u)
});
class lc extends yt {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(o) {
    return aa(o.data);
  }
}
lc.create = (u) => new lc({
  typeName: nt.ZodUnknown,
  ...mt(u)
});
class Hs extends yt {
  _parse(o) {
    const s = this._getOrReturnCtx(o);
    return _e(s, {
      code: ie.invalid_type,
      expected: Ne.never,
      received: s.parsedType
    }), ot;
  }
}
Hs.create = (u) => new Hs({
  typeName: nt.ZodNever,
  ...mt(u)
});
class Wy extends yt {
  _parse(o) {
    if (this._getType(o) !== Ne.undefined) {
      const d = this._getOrReturnCtx(o);
      return _e(d, {
        code: ie.invalid_type,
        expected: Ne.void,
        received: d.parsedType
      }), ot;
    }
    return aa(o.data);
  }
}
Wy.create = (u) => new Wy({
  typeName: nt.ZodVoid,
  ...mt(u)
});
class Go extends yt {
  _parse(o) {
    const { ctx: s, status: d } = this._processInputParams(o), h = this._def;
    if (s.parsedType !== Ne.array)
      return _e(s, {
        code: ie.invalid_type,
        expected: Ne.array,
        received: s.parsedType
      }), ot;
    if (h.exactLength !== null) {
      const g = s.data.length > h.exactLength.value, k = s.data.length < h.exactLength.value;
      (g || k) && (_e(s, {
        code: g ? ie.too_big : ie.too_small,
        minimum: k ? h.exactLength.value : void 0,
        maximum: g ? h.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: h.exactLength.message
      }), d.dirty());
    }
    if (h.minLength !== null && s.data.length < h.minLength.value && (_e(s, {
      code: ie.too_small,
      minimum: h.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: h.minLength.message
    }), d.dirty()), h.maxLength !== null && s.data.length > h.maxLength.value && (_e(s, {
      code: ie.too_big,
      maximum: h.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: h.maxLength.message
    }), d.dirty()), s.common.async)
      return Promise.all([...s.data].map((g, k) => h.type._parseAsync(new ji(s, g, s.path, k)))).then((g) => Vr.mergeArray(d, g));
    const m = [...s.data].map((g, k) => h.type._parseSync(new ji(s, g, s.path, k)));
    return Vr.mergeArray(d, m);
  }
  get element() {
    return this._def.type;
  }
  min(o, s) {
    return new Go({
      ...this._def,
      minLength: { value: o, message: Ve.toString(s) }
    });
  }
  max(o, s) {
    return new Go({
      ...this._def,
      maxLength: { value: o, message: Ve.toString(s) }
    });
  }
  length(o, s) {
    return new Go({
      ...this._def,
      exactLength: { value: o, message: Ve.toString(s) }
    });
  }
  nonempty(o) {
    return this.min(1, o);
  }
}
Go.create = (u, o) => new Go({
  type: u,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: nt.ZodArray,
  ...mt(o)
});
function bf(u) {
  if (u instanceof pn) {
    const o = {};
    for (const s in u.shape) {
      const d = u.shape[s];
      o[s] = $i.create(bf(d));
    }
    return new pn({
      ...u._def,
      shape: () => o
    });
  } else return u instanceof Go ? new Go({
    ...u._def,
    type: bf(u.element)
  }) : u instanceof $i ? $i.create(bf(u.unwrap())) : u instanceof Hl ? Hl.create(bf(u.unwrap())) : u instanceof Ui ? Ui.create(u.items.map((o) => bf(o))) : u;
}
class pn extends yt {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const o = this._def.shape(), s = Lt.objectKeys(o);
    return this._cached = { shape: o, keys: s };
  }
  _parse(o) {
    if (this._getType(o) !== Ne.object) {
      const E = this._getOrReturnCtx(o);
      return _e(E, {
        code: ie.invalid_type,
        expected: Ne.object,
        received: E.parsedType
      }), ot;
    }
    const { status: d, ctx: h } = this._processInputParams(o), { shape: m, keys: g } = this._getCached(), k = [];
    if (!(this._def.catchall instanceof Hs && this._def.unknownKeys === "strip"))
      for (const E in h.data)
        g.includes(E) || k.push(E);
    const S = [];
    for (const E of g) {
      const R = m[E], P = h.data[E];
      S.push({
        key: { status: "valid", value: E },
        value: R._parse(new ji(h, P, h.path, E)),
        alwaysSet: E in h.data
      });
    }
    if (this._def.catchall instanceof Hs) {
      const E = this._def.unknownKeys;
      if (E === "passthrough")
        for (const R of k)
          S.push({
            key: { status: "valid", value: R },
            value: { status: "valid", value: h.data[R] }
          });
      else if (E === "strict")
        k.length > 0 && (_e(h, {
          code: ie.unrecognized_keys,
          keys: k
        }), d.dirty());
      else if (E !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const E = this._def.catchall;
      for (const R of k) {
        const P = h.data[R];
        S.push({
          key: { status: "valid", value: R },
          value: E._parse(
            new ji(h, P, h.path, R)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: R in h.data
        });
      }
    }
    return h.common.async ? Promise.resolve().then(async () => {
      const E = [];
      for (const R of S) {
        const P = await R.key, O = await R.value;
        E.push({
          key: P,
          value: O,
          alwaysSet: R.alwaysSet
        });
      }
      return E;
    }).then((E) => Vr.mergeObjectSync(d, E)) : Vr.mergeObjectSync(d, S);
  }
  get shape() {
    return this._def.shape();
  }
  strict(o) {
    return Ve.errToObj, new pn({
      ...this._def,
      unknownKeys: "strict",
      ...o !== void 0 ? {
        errorMap: (s, d) => {
          var h, m, g, k;
          const S = (g = (m = (h = this._def).errorMap) === null || m === void 0 ? void 0 : m.call(h, s, d).message) !== null && g !== void 0 ? g : d.defaultError;
          return s.code === "unrecognized_keys" ? {
            message: (k = Ve.errToObj(o).message) !== null && k !== void 0 ? k : S
          } : {
            message: S
          };
        }
      } : {}
    });
  }
  strip() {
    return new pn({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new pn({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(o) {
    return new pn({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...o
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(o) {
    return new pn({
      unknownKeys: o._def.unknownKeys,
      catchall: o._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...o._def.shape()
      }),
      typeName: nt.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(o, s) {
    return this.augment({ [o]: s });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(o) {
    return new pn({
      ...this._def,
      catchall: o
    });
  }
  pick(o) {
    const s = {};
    return Lt.objectKeys(o).forEach((d) => {
      o[d] && this.shape[d] && (s[d] = this.shape[d]);
    }), new pn({
      ...this._def,
      shape: () => s
    });
  }
  omit(o) {
    const s = {};
    return Lt.objectKeys(this.shape).forEach((d) => {
      o[d] || (s[d] = this.shape[d]);
    }), new pn({
      ...this._def,
      shape: () => s
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return bf(this);
  }
  partial(o) {
    const s = {};
    return Lt.objectKeys(this.shape).forEach((d) => {
      const h = this.shape[d];
      o && !o[d] ? s[d] = h : s[d] = h.optional();
    }), new pn({
      ...this._def,
      shape: () => s
    });
  }
  required(o) {
    const s = {};
    return Lt.objectKeys(this.shape).forEach((d) => {
      if (o && !o[d])
        s[d] = this.shape[d];
      else {
        let m = this.shape[d];
        for (; m instanceof $i; )
          m = m._def.innerType;
        s[d] = m;
      }
    }), new pn({
      ...this._def,
      shape: () => s
    });
  }
  keyof() {
    return zC(Lt.objectKeys(this.shape));
  }
}
pn.create = (u, o) => new pn({
  shape: () => u,
  unknownKeys: "strip",
  catchall: Hs.create(),
  typeName: nt.ZodObject,
  ...mt(o)
});
pn.strictCreate = (u, o) => new pn({
  shape: () => u,
  unknownKeys: "strict",
  catchall: Hs.create(),
  typeName: nt.ZodObject,
  ...mt(o)
});
pn.lazycreate = (u, o) => new pn({
  shape: u,
  unknownKeys: "strip",
  catchall: Hs.create(),
  typeName: nt.ZodObject,
  ...mt(o)
});
class lm extends yt {
  _parse(o) {
    const { ctx: s } = this._processInputParams(o), d = this._def.options;
    function h(m) {
      for (const k of m)
        if (k.result.status === "valid")
          return k.result;
      for (const k of m)
        if (k.result.status === "dirty")
          return s.common.issues.push(...k.ctx.common.issues), k.result;
      const g = m.map((k) => new qa(k.ctx.common.issues));
      return _e(s, {
        code: ie.invalid_union,
        unionErrors: g
      }), ot;
    }
    if (s.common.async)
      return Promise.all(d.map(async (m) => {
        const g = {
          ...s,
          common: {
            ...s.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await m._parseAsync({
            data: s.data,
            path: s.path,
            parent: g
          }),
          ctx: g
        };
      })).then(h);
    {
      let m;
      const g = [];
      for (const S of d) {
        const E = {
          ...s,
          common: {
            ...s.common,
            issues: []
          },
          parent: null
        }, R = S._parseSync({
          data: s.data,
          path: s.path,
          parent: E
        });
        if (R.status === "valid")
          return R;
        R.status === "dirty" && !m && (m = { result: R, ctx: E }), E.common.issues.length && g.push(E.common.issues);
      }
      if (m)
        return s.common.issues.push(...m.ctx.common.issues), m.result;
      const k = g.map((S) => new qa(S));
      return _e(s, {
        code: ie.invalid_union,
        unionErrors: k
      }), ot;
    }
  }
  get options() {
    return this._def.options;
  }
}
lm.create = (u, o) => new lm({
  options: u,
  typeName: nt.ZodUnion,
  ...mt(o)
});
const Bs = (u) => u instanceof dm ? Bs(u.schema) : u instanceof Jo ? Bs(u.innerType()) : u instanceof fm ? [u.value] : u instanceof ql ? u.options : u instanceof pm ? Lt.objectValues(u.enum) : u instanceof hm ? Bs(u._def.innerType) : u instanceof im ? [void 0] : u instanceof sm ? [null] : u instanceof $i ? [void 0, ...Bs(u.unwrap())] : u instanceof Hl ? [null, ...Bs(u.unwrap())] : u instanceof ix || u instanceof gm ? Bs(u.unwrap()) : u instanceof mm ? Bs(u._def.innerType) : [];
class tb extends yt {
  _parse(o) {
    const { ctx: s } = this._processInputParams(o);
    if (s.parsedType !== Ne.object)
      return _e(s, {
        code: ie.invalid_type,
        expected: Ne.object,
        received: s.parsedType
      }), ot;
    const d = this.discriminator, h = s.data[d], m = this.optionsMap.get(h);
    return m ? s.common.async ? m._parseAsync({
      data: s.data,
      path: s.path,
      parent: s
    }) : m._parseSync({
      data: s.data,
      path: s.path,
      parent: s
    }) : (_e(s, {
      code: ie.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [d]
    }), ot);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(o, s, d) {
    const h = /* @__PURE__ */ new Map();
    for (const m of s) {
      const g = Bs(m.shape[o]);
      if (!g.length)
        throw new Error(`A discriminator value for key \`${o}\` could not be extracted from all schema options`);
      for (const k of g) {
        if (h.has(k))
          throw new Error(`Discriminator property ${String(o)} has duplicate value ${String(k)}`);
        h.set(k, m);
      }
    }
    return new tb({
      typeName: nt.ZodDiscriminatedUnion,
      discriminator: o,
      options: s,
      optionsMap: h,
      ...mt(d)
    });
  }
}
function qk(u, o) {
  const s = Ws(u), d = Ws(o);
  if (u === o)
    return { valid: !0, data: u };
  if (s === Ne.object && d === Ne.object) {
    const h = Lt.objectKeys(o), m = Lt.objectKeys(u).filter((k) => h.indexOf(k) !== -1), g = { ...u, ...o };
    for (const k of m) {
      const S = qk(u[k], o[k]);
      if (!S.valid)
        return { valid: !1 };
      g[k] = S.data;
    }
    return { valid: !0, data: g };
  } else if (s === Ne.array && d === Ne.array) {
    if (u.length !== o.length)
      return { valid: !1 };
    const h = [];
    for (let m = 0; m < u.length; m++) {
      const g = u[m], k = o[m], S = qk(g, k);
      if (!S.valid)
        return { valid: !1 };
      h.push(S.data);
    }
    return { valid: !0, data: h };
  } else return s === Ne.date && d === Ne.date && +u == +o ? { valid: !0, data: u } : { valid: !1 };
}
class um extends yt {
  _parse(o) {
    const { status: s, ctx: d } = this._processInputParams(o), h = (m, g) => {
      if (Bk(m) || Bk(g))
        return ot;
      const k = qk(m.value, g.value);
      return k.valid ? ((Wk(m) || Wk(g)) && s.dirty(), { status: s.value, value: k.data }) : (_e(d, {
        code: ie.invalid_intersection_types
      }), ot);
    };
    return d.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: d.data,
        path: d.path,
        parent: d
      }),
      this._def.right._parseAsync({
        data: d.data,
        path: d.path,
        parent: d
      })
    ]).then(([m, g]) => h(m, g)) : h(this._def.left._parseSync({
      data: d.data,
      path: d.path,
      parent: d
    }), this._def.right._parseSync({
      data: d.data,
      path: d.path,
      parent: d
    }));
  }
}
um.create = (u, o, s) => new um({
  left: u,
  right: o,
  typeName: nt.ZodIntersection,
  ...mt(s)
});
class Ui extends yt {
  _parse(o) {
    const { status: s, ctx: d } = this._processInputParams(o);
    if (d.parsedType !== Ne.array)
      return _e(d, {
        code: ie.invalid_type,
        expected: Ne.array,
        received: d.parsedType
      }), ot;
    if (d.data.length < this._def.items.length)
      return _e(d, {
        code: ie.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), ot;
    !this._def.rest && d.data.length > this._def.items.length && (_e(d, {
      code: ie.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), s.dirty());
    const m = [...d.data].map((g, k) => {
      const S = this._def.items[k] || this._def.rest;
      return S ? S._parse(new ji(d, g, d.path, k)) : null;
    }).filter((g) => !!g);
    return d.common.async ? Promise.all(m).then((g) => Vr.mergeArray(s, g)) : Vr.mergeArray(s, m);
  }
  get items() {
    return this._def.items;
  }
  rest(o) {
    return new Ui({
      ...this._def,
      rest: o
    });
  }
}
Ui.create = (u, o) => {
  if (!Array.isArray(u))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Ui({
    items: u,
    typeName: nt.ZodTuple,
    rest: null,
    ...mt(o)
  });
};
class cm extends yt {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(o) {
    const { status: s, ctx: d } = this._processInputParams(o);
    if (d.parsedType !== Ne.object)
      return _e(d, {
        code: ie.invalid_type,
        expected: Ne.object,
        received: d.parsedType
      }), ot;
    const h = [], m = this._def.keyType, g = this._def.valueType;
    for (const k in d.data)
      h.push({
        key: m._parse(new ji(d, k, d.path, k)),
        value: g._parse(new ji(d, d.data[k], d.path, k)),
        alwaysSet: k in d.data
      });
    return d.common.async ? Vr.mergeObjectAsync(s, h) : Vr.mergeObjectSync(s, h);
  }
  get element() {
    return this._def.valueType;
  }
  static create(o, s, d) {
    return s instanceof yt ? new cm({
      keyType: o,
      valueType: s,
      typeName: nt.ZodRecord,
      ...mt(d)
    }) : new cm({
      keyType: Yo.create(),
      valueType: o,
      typeName: nt.ZodRecord,
      ...mt(s)
    });
  }
}
class qy extends yt {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(o) {
    const { status: s, ctx: d } = this._processInputParams(o);
    if (d.parsedType !== Ne.map)
      return _e(d, {
        code: ie.invalid_type,
        expected: Ne.map,
        received: d.parsedType
      }), ot;
    const h = this._def.keyType, m = this._def.valueType, g = [...d.data.entries()].map(([k, S], E) => ({
      key: h._parse(new ji(d, k, d.path, [E, "key"])),
      value: m._parse(new ji(d, S, d.path, [E, "value"]))
    }));
    if (d.common.async) {
      const k = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const S of g) {
          const E = await S.key, R = await S.value;
          if (E.status === "aborted" || R.status === "aborted")
            return ot;
          (E.status === "dirty" || R.status === "dirty") && s.dirty(), k.set(E.value, R.value);
        }
        return { status: s.value, value: k };
      });
    } else {
      const k = /* @__PURE__ */ new Map();
      for (const S of g) {
        const E = S.key, R = S.value;
        if (E.status === "aborted" || R.status === "aborted")
          return ot;
        (E.status === "dirty" || R.status === "dirty") && s.dirty(), k.set(E.value, R.value);
      }
      return { status: s.value, value: k };
    }
  }
}
qy.create = (u, o, s) => new qy({
  valueType: o,
  keyType: u,
  typeName: nt.ZodMap,
  ...mt(s)
});
class dc extends yt {
  _parse(o) {
    const { status: s, ctx: d } = this._processInputParams(o);
    if (d.parsedType !== Ne.set)
      return _e(d, {
        code: ie.invalid_type,
        expected: Ne.set,
        received: d.parsedType
      }), ot;
    const h = this._def;
    h.minSize !== null && d.data.size < h.minSize.value && (_e(d, {
      code: ie.too_small,
      minimum: h.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: h.minSize.message
    }), s.dirty()), h.maxSize !== null && d.data.size > h.maxSize.value && (_e(d, {
      code: ie.too_big,
      maximum: h.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: h.maxSize.message
    }), s.dirty());
    const m = this._def.valueType;
    function g(S) {
      const E = /* @__PURE__ */ new Set();
      for (const R of S) {
        if (R.status === "aborted")
          return ot;
        R.status === "dirty" && s.dirty(), E.add(R.value);
      }
      return { status: s.value, value: E };
    }
    const k = [...d.data.values()].map((S, E) => m._parse(new ji(d, S, d.path, E)));
    return d.common.async ? Promise.all(k).then((S) => g(S)) : g(k);
  }
  min(o, s) {
    return new dc({
      ...this._def,
      minSize: { value: o, message: Ve.toString(s) }
    });
  }
  max(o, s) {
    return new dc({
      ...this._def,
      maxSize: { value: o, message: Ve.toString(s) }
    });
  }
  size(o, s) {
    return this.min(o, s).max(o, s);
  }
  nonempty(o) {
    return this.min(1, o);
  }
}
dc.create = (u, o) => new dc({
  valueType: u,
  minSize: null,
  maxSize: null,
  typeName: nt.ZodSet,
  ...mt(o)
});
class wf extends yt {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(o) {
    const { ctx: s } = this._processInputParams(o);
    if (s.parsedType !== Ne.function)
      return _e(s, {
        code: ie.invalid_type,
        expected: Ne.function,
        received: s.parsedType
      }), ot;
    function d(k, S) {
      return Uy({
        data: k,
        path: s.path,
        errorMaps: [
          s.common.contextualErrorMap,
          s.schemaErrorMap,
          jy(),
          Sf
        ].filter((E) => !!E),
        issueData: {
          code: ie.invalid_arguments,
          argumentsError: S
        }
      });
    }
    function h(k, S) {
      return Uy({
        data: k,
        path: s.path,
        errorMaps: [
          s.common.contextualErrorMap,
          s.schemaErrorMap,
          jy(),
          Sf
        ].filter((E) => !!E),
        issueData: {
          code: ie.invalid_return_type,
          returnTypeError: S
        }
      });
    }
    const m = { errorMap: s.common.contextualErrorMap }, g = s.data;
    if (this._def.returns instanceof Cf) {
      const k = this;
      return aa(async function(...S) {
        const E = new qa([]), R = await k._def.args.parseAsync(S, m).catch((M) => {
          throw E.addIssue(d(S, M)), E;
        }), P = await Reflect.apply(g, this, R);
        return await k._def.returns._def.type.parseAsync(P, m).catch((M) => {
          throw E.addIssue(h(P, M)), E;
        });
      });
    } else {
      const k = this;
      return aa(function(...S) {
        const E = k._def.args.safeParse(S, m);
        if (!E.success)
          throw new qa([d(S, E.error)]);
        const R = Reflect.apply(g, this, E.data), P = k._def.returns.safeParse(R, m);
        if (!P.success)
          throw new qa([h(R, P.error)]);
        return P.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...o) {
    return new wf({
      ...this._def,
      args: Ui.create(o).rest(lc.create())
    });
  }
  returns(o) {
    return new wf({
      ...this._def,
      returns: o
    });
  }
  implement(o) {
    return this.parse(o);
  }
  strictImplement(o) {
    return this.parse(o);
  }
  static create(o, s, d) {
    return new wf({
      args: o || Ui.create([]).rest(lc.create()),
      returns: s || lc.create(),
      typeName: nt.ZodFunction,
      ...mt(d)
    });
  }
}
class dm extends yt {
  get schema() {
    return this._def.getter();
  }
  _parse(o) {
    const { ctx: s } = this._processInputParams(o);
    return this._def.getter()._parse({ data: s.data, path: s.path, parent: s });
  }
}
dm.create = (u, o) => new dm({
  getter: u,
  typeName: nt.ZodLazy,
  ...mt(o)
});
class fm extends yt {
  _parse(o) {
    if (o.data !== this._def.value) {
      const s = this._getOrReturnCtx(o);
      return _e(s, {
        received: s.data,
        code: ie.invalid_literal,
        expected: this._def.value
      }), ot;
    }
    return { status: "valid", value: o.data };
  }
  get value() {
    return this._def.value;
  }
}
fm.create = (u, o) => new fm({
  value: u,
  typeName: nt.ZodLiteral,
  ...mt(o)
});
function zC(u, o) {
  return new ql({
    values: u,
    typeName: nt.ZodEnum,
    ...mt(o)
  });
}
class ql extends yt {
  constructor() {
    super(...arguments), Gh.set(this, void 0);
  }
  _parse(o) {
    if (typeof o.data != "string") {
      const s = this._getOrReturnCtx(o), d = this._def.values;
      return _e(s, {
        expected: Lt.joinValues(d),
        received: s.parsedType,
        code: ie.invalid_type
      }), ot;
    }
    if (Vy(this, Gh) || NC(this, Gh, new Set(this._def.values)), !Vy(this, Gh).has(o.data)) {
      const s = this._getOrReturnCtx(o), d = this._def.values;
      return _e(s, {
        received: s.data,
        code: ie.invalid_enum_value,
        options: d
      }), ot;
    }
    return aa(o.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const o = {};
    for (const s of this._def.values)
      o[s] = s;
    return o;
  }
  get Values() {
    const o = {};
    for (const s of this._def.values)
      o[s] = s;
    return o;
  }
  get Enum() {
    const o = {};
    for (const s of this._def.values)
      o[s] = s;
    return o;
  }
  extract(o, s = this._def) {
    return ql.create(o, {
      ...this._def,
      ...s
    });
  }
  exclude(o, s = this._def) {
    return ql.create(this.options.filter((d) => !o.includes(d)), {
      ...this._def,
      ...s
    });
  }
}
Gh = /* @__PURE__ */ new WeakMap();
ql.create = zC;
class pm extends yt {
  constructor() {
    super(...arguments), Jh.set(this, void 0);
  }
  _parse(o) {
    const s = Lt.getValidEnumValues(this._def.values), d = this._getOrReturnCtx(o);
    if (d.parsedType !== Ne.string && d.parsedType !== Ne.number) {
      const h = Lt.objectValues(s);
      return _e(d, {
        expected: Lt.joinValues(h),
        received: d.parsedType,
        code: ie.invalid_type
      }), ot;
    }
    if (Vy(this, Jh) || NC(this, Jh, new Set(Lt.getValidEnumValues(this._def.values))), !Vy(this, Jh).has(o.data)) {
      const h = Lt.objectValues(s);
      return _e(d, {
        received: d.data,
        code: ie.invalid_enum_value,
        options: h
      }), ot;
    }
    return aa(o.data);
  }
  get enum() {
    return this._def.values;
  }
}
Jh = /* @__PURE__ */ new WeakMap();
pm.create = (u, o) => new pm({
  values: u,
  typeName: nt.ZodNativeEnum,
  ...mt(o)
});
class Cf extends yt {
  unwrap() {
    return this._def.type;
  }
  _parse(o) {
    const { ctx: s } = this._processInputParams(o);
    if (s.parsedType !== Ne.promise && s.common.async === !1)
      return _e(s, {
        code: ie.invalid_type,
        expected: Ne.promise,
        received: s.parsedType
      }), ot;
    const d = s.parsedType === Ne.promise ? s.data : Promise.resolve(s.data);
    return aa(d.then((h) => this._def.type.parseAsync(h, {
      path: s.path,
      errorMap: s.common.contextualErrorMap
    })));
  }
}
Cf.create = (u, o) => new Cf({
  type: u,
  typeName: nt.ZodPromise,
  ...mt(o)
});
class Jo extends yt {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === nt.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(o) {
    const { status: s, ctx: d } = this._processInputParams(o), h = this._def.effect || null, m = {
      addIssue: (g) => {
        _e(d, g), g.fatal ? s.abort() : s.dirty();
      },
      get path() {
        return d.path;
      }
    };
    if (m.addIssue = m.addIssue.bind(m), h.type === "preprocess") {
      const g = h.transform(d.data, m);
      if (d.common.async)
        return Promise.resolve(g).then(async (k) => {
          if (s.value === "aborted")
            return ot;
          const S = await this._def.schema._parseAsync({
            data: k,
            path: d.path,
            parent: d
          });
          return S.status === "aborted" ? ot : S.status === "dirty" || s.value === "dirty" ? _f(S.value) : S;
        });
      {
        if (s.value === "aborted")
          return ot;
        const k = this._def.schema._parseSync({
          data: g,
          path: d.path,
          parent: d
        });
        return k.status === "aborted" ? ot : k.status === "dirty" || s.value === "dirty" ? _f(k.value) : k;
      }
    }
    if (h.type === "refinement") {
      const g = (k) => {
        const S = h.refinement(k, m);
        if (d.common.async)
          return Promise.resolve(S);
        if (S instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return k;
      };
      if (d.common.async === !1) {
        const k = this._def.schema._parseSync({
          data: d.data,
          path: d.path,
          parent: d
        });
        return k.status === "aborted" ? ot : (k.status === "dirty" && s.dirty(), g(k.value), { status: s.value, value: k.value });
      } else
        return this._def.schema._parseAsync({ data: d.data, path: d.path, parent: d }).then((k) => k.status === "aborted" ? ot : (k.status === "dirty" && s.dirty(), g(k.value).then(() => ({ status: s.value, value: k.value }))));
    }
    if (h.type === "transform")
      if (d.common.async === !1) {
        const g = this._def.schema._parseSync({
          data: d.data,
          path: d.path,
          parent: d
        });
        if (!uc(g))
          return g;
        const k = h.transform(g.value, m);
        if (k instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: s.value, value: k };
      } else
        return this._def.schema._parseAsync({ data: d.data, path: d.path, parent: d }).then((g) => uc(g) ? Promise.resolve(h.transform(g.value, m)).then((k) => ({ status: s.value, value: k })) : g);
    Lt.assertNever(h);
  }
}
Jo.create = (u, o, s) => new Jo({
  schema: u,
  typeName: nt.ZodEffects,
  effect: o,
  ...mt(s)
});
Jo.createWithPreprocess = (u, o, s) => new Jo({
  schema: o,
  effect: { type: "preprocess", transform: u },
  typeName: nt.ZodEffects,
  ...mt(s)
});
class $i extends yt {
  _parse(o) {
    return this._getType(o) === Ne.undefined ? aa(void 0) : this._def.innerType._parse(o);
  }
  unwrap() {
    return this._def.innerType;
  }
}
$i.create = (u, o) => new $i({
  innerType: u,
  typeName: nt.ZodOptional,
  ...mt(o)
});
class Hl extends yt {
  _parse(o) {
    return this._getType(o) === Ne.null ? aa(null) : this._def.innerType._parse(o);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Hl.create = (u, o) => new Hl({
  innerType: u,
  typeName: nt.ZodNullable,
  ...mt(o)
});
class hm extends yt {
  _parse(o) {
    const { ctx: s } = this._processInputParams(o);
    let d = s.data;
    return s.parsedType === Ne.undefined && (d = this._def.defaultValue()), this._def.innerType._parse({
      data: d,
      path: s.path,
      parent: s
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
hm.create = (u, o) => new hm({
  innerType: u,
  typeName: nt.ZodDefault,
  defaultValue: typeof o.default == "function" ? o.default : () => o.default,
  ...mt(o)
});
class mm extends yt {
  _parse(o) {
    const { ctx: s } = this._processInputParams(o), d = {
      ...s,
      common: {
        ...s.common,
        issues: []
      }
    }, h = this._def.innerType._parse({
      data: d.data,
      path: d.path,
      parent: {
        ...d
      }
    });
    return am(h) ? h.then((m) => ({
      status: "valid",
      value: m.status === "valid" ? m.value : this._def.catchValue({
        get error() {
          return new qa(d.common.issues);
        },
        input: d.data
      })
    })) : {
      status: "valid",
      value: h.status === "valid" ? h.value : this._def.catchValue({
        get error() {
          return new qa(d.common.issues);
        },
        input: d.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
mm.create = (u, o) => new mm({
  innerType: u,
  typeName: nt.ZodCatch,
  catchValue: typeof o.catch == "function" ? o.catch : () => o.catch,
  ...mt(o)
});
class Hy extends yt {
  _parse(o) {
    if (this._getType(o) !== Ne.nan) {
      const d = this._getOrReturnCtx(o);
      return _e(d, {
        code: ie.invalid_type,
        expected: Ne.nan,
        received: d.parsedType
      }), ot;
    }
    return { status: "valid", value: o.data };
  }
}
Hy.create = (u) => new Hy({
  typeName: nt.ZodNaN,
  ...mt(u)
});
const qI = Symbol("zod_brand");
class ix extends yt {
  _parse(o) {
    const { ctx: s } = this._processInputParams(o), d = s.data;
    return this._def.type._parse({
      data: d,
      path: s.path,
      parent: s
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class _m extends yt {
  _parse(o) {
    const { status: s, ctx: d } = this._processInputParams(o);
    if (d.common.async)
      return (async () => {
        const m = await this._def.in._parseAsync({
          data: d.data,
          path: d.path,
          parent: d
        });
        return m.status === "aborted" ? ot : m.status === "dirty" ? (s.dirty(), _f(m.value)) : this._def.out._parseAsync({
          data: m.value,
          path: d.path,
          parent: d
        });
      })();
    {
      const h = this._def.in._parseSync({
        data: d.data,
        path: d.path,
        parent: d
      });
      return h.status === "aborted" ? ot : h.status === "dirty" ? (s.dirty(), {
        status: "dirty",
        value: h.value
      }) : this._def.out._parseSync({
        data: h.value,
        path: d.path,
        parent: d
      });
    }
  }
  static create(o, s) {
    return new _m({
      in: o,
      out: s,
      typeName: nt.ZodPipeline
    });
  }
}
class gm extends yt {
  _parse(o) {
    const s = this._def.innerType._parse(o), d = (h) => (uc(h) && (h.value = Object.freeze(h.value)), h);
    return am(s) ? s.then((h) => d(h)) : d(s);
  }
  unwrap() {
    return this._def.innerType;
  }
}
gm.create = (u, o) => new gm({
  innerType: u,
  typeName: nt.ZodReadonly,
  ...mt(o)
});
function fE(u, o) {
  const s = typeof u == "function" ? u(o) : typeof u == "string" ? { message: u } : u;
  return typeof s == "string" ? { message: s } : s;
}
function IC(u, o = {}, s) {
  return u ? Ef.create().superRefine((d, h) => {
    var m, g;
    const k = u(d);
    if (k instanceof Promise)
      return k.then((S) => {
        var E, R;
        if (!S) {
          const P = fE(o, d), O = (R = (E = P.fatal) !== null && E !== void 0 ? E : s) !== null && R !== void 0 ? R : !0;
          h.addIssue({ code: "custom", ...P, fatal: O });
        }
      });
    if (!k) {
      const S = fE(o, d), E = (g = (m = S.fatal) !== null && m !== void 0 ? m : s) !== null && g !== void 0 ? g : !0;
      h.addIssue({ code: "custom", ...S, fatal: E });
    }
  }) : Ef.create();
}
const HI = {
  object: pn.lazycreate
};
var nt;
(function(u) {
  u.ZodString = "ZodString", u.ZodNumber = "ZodNumber", u.ZodNaN = "ZodNaN", u.ZodBigInt = "ZodBigInt", u.ZodBoolean = "ZodBoolean", u.ZodDate = "ZodDate", u.ZodSymbol = "ZodSymbol", u.ZodUndefined = "ZodUndefined", u.ZodNull = "ZodNull", u.ZodAny = "ZodAny", u.ZodUnknown = "ZodUnknown", u.ZodNever = "ZodNever", u.ZodVoid = "ZodVoid", u.ZodArray = "ZodArray", u.ZodObject = "ZodObject", u.ZodUnion = "ZodUnion", u.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", u.ZodIntersection = "ZodIntersection", u.ZodTuple = "ZodTuple", u.ZodRecord = "ZodRecord", u.ZodMap = "ZodMap", u.ZodSet = "ZodSet", u.ZodFunction = "ZodFunction", u.ZodLazy = "ZodLazy", u.ZodLiteral = "ZodLiteral", u.ZodEnum = "ZodEnum", u.ZodEffects = "ZodEffects", u.ZodNativeEnum = "ZodNativeEnum", u.ZodOptional = "ZodOptional", u.ZodNullable = "ZodNullable", u.ZodDefault = "ZodDefault", u.ZodCatch = "ZodCatch", u.ZodPromise = "ZodPromise", u.ZodBranded = "ZodBranded", u.ZodPipeline = "ZodPipeline", u.ZodReadonly = "ZodReadonly";
})(nt || (nt = {}));
const ZI = (u, o = {
  message: `Input not instance of ${u.name}`
}) => IC((s) => s instanceof u, o), AC = Yo.create, MC = Bl.create, QI = Hy.create, KI = Wl.create, FC = om.create, YI = cc.create, GI = By.create, JI = im.create, XI = sm.create, e2 = Ef.create, t2 = lc.create, n2 = Hs.create, r2 = Wy.create, a2 = Go.create, o2 = pn.create, i2 = pn.strictCreate, s2 = lm.create, l2 = tb.create, u2 = um.create, c2 = Ui.create, d2 = cm.create, f2 = qy.create, p2 = dc.create, h2 = wf.create, m2 = dm.create, g2 = fm.create, v2 = ql.create, y2 = pm.create, b2 = Cf.create, pE = Jo.create, _2 = $i.create, w2 = Hl.create, k2 = Jo.createWithPreprocess, x2 = _m.create, S2 = () => AC().optional(), E2 = () => MC().optional(), C2 = () => FC().optional(), T2 = {
  string: (u) => Yo.create({ ...u, coerce: !0 }),
  number: (u) => Bl.create({ ...u, coerce: !0 }),
  boolean: (u) => om.create({
    ...u,
    coerce: !0
  }),
  bigint: (u) => Wl.create({ ...u, coerce: !0 }),
  date: (u) => cc.create({ ...u, coerce: !0 })
}, R2 = ot;
var Dk = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Sf,
  setErrorMap: kI,
  getErrorMap: jy,
  makeIssue: Uy,
  EMPTY_PATH: xI,
  addIssueToContext: _e,
  ParseStatus: Vr,
  INVALID: ot,
  DIRTY: _f,
  OK: aa,
  isAborted: Bk,
  isDirty: Wk,
  isValid: uc,
  isAsync: am,
  get util() {
    return Lt;
  },
  get objectUtil() {
    return Vk;
  },
  ZodParsedType: Ne,
  getParsedType: Ws,
  ZodType: yt,
  datetimeRegex: DC,
  ZodString: Yo,
  ZodNumber: Bl,
  ZodBigInt: Wl,
  ZodBoolean: om,
  ZodDate: cc,
  ZodSymbol: By,
  ZodUndefined: im,
  ZodNull: sm,
  ZodAny: Ef,
  ZodUnknown: lc,
  ZodNever: Hs,
  ZodVoid: Wy,
  ZodArray: Go,
  ZodObject: pn,
  ZodUnion: lm,
  ZodDiscriminatedUnion: tb,
  ZodIntersection: um,
  ZodTuple: Ui,
  ZodRecord: cm,
  ZodMap: qy,
  ZodSet: dc,
  ZodFunction: wf,
  ZodLazy: dm,
  ZodLiteral: fm,
  ZodEnum: ql,
  ZodNativeEnum: pm,
  ZodPromise: Cf,
  ZodEffects: Jo,
  ZodTransformer: Jo,
  ZodOptional: $i,
  ZodNullable: Hl,
  ZodDefault: hm,
  ZodCatch: mm,
  ZodNaN: Hy,
  BRAND: qI,
  ZodBranded: ix,
  ZodPipeline: _m,
  ZodReadonly: gm,
  custom: IC,
  Schema: yt,
  ZodSchema: yt,
  late: HI,
  get ZodFirstPartyTypeKind() {
    return nt;
  },
  coerce: T2,
  any: e2,
  array: a2,
  bigint: KI,
  boolean: FC,
  date: YI,
  discriminatedUnion: l2,
  effect: pE,
  enum: v2,
  function: h2,
  instanceof: ZI,
  intersection: u2,
  lazy: m2,
  literal: g2,
  map: f2,
  nan: QI,
  nativeEnum: y2,
  never: n2,
  null: XI,
  nullable: w2,
  number: MC,
  object: o2,
  oboolean: C2,
  onumber: E2,
  optional: _2,
  ostring: S2,
  pipeline: x2,
  preprocess: k2,
  promise: b2,
  record: d2,
  set: p2,
  strictObject: i2,
  string: AC,
  symbol: GI,
  transformer: pE,
  tuple: c2,
  undefined: JI,
  union: s2,
  unknown: t2,
  void: r2,
  NEVER: R2,
  ZodIssueCode: ie,
  quotelessJson: wI,
  ZodError: qa
});
const Zy = "9", P2 = Dk.object({
  reasonId: Dk.string({ required_error: "reasons_for_cancellation_needed" }),
  comment: Dk.string().optional()
}).refine((u) => !(u.reasonId === Zy && !u.comment), {
  message: "reasons_other_comment_needed",
  path: ["comment"]
}).refine((u) => !(u.reasonId === Zy && u.comment && u.comment.length > 255), {
  message: "common:error.characters_max_limit",
  path: ["comment"]
});
function N2({ onClickContinue: u, cancellationReasons: o, conversation: s, user: d }) {
  const { t: h } = tx(["conversations", "common"]), [m, g] = Vl(!1), [k, S] = Vl(!1), E = async ($) => {
    try {
      g(!0), await LL(s.id, $.reasonId, $.comment);
      const Z = o.find((G) => G.id.toString() === $.reasonId);
      _3(
        {
          exchange_status: "cancelled",
          cancellation_reason: Z == null ? void 0 : Z.name,
          exchange_type: s.exchanges.length === 1 ? "guest_point_exchange" : "reciprocal_exchange",
          collection: d.is_he_collection
        },
        { eventCallback: () => u(), eventTimeout: 2e3 }
      );
    } catch {
      S(!0);
    } finally {
      g(!1);
    }
  }, R = GL({
    resolver: _I(P2)
  }), { watch: P } = R, O = LE(
    () => o.map(($) => ({
      id: $.id.toString(),
      name: h(`reasons_for_cancellation_${$.name}`)
    })),
    [o, h]
  ), M = P("reasonId") === Zy;
  return {
    isLoading: m,
    requestHasError: k,
    onSubmitCancellationForm: E,
    cancellationReasonsRadioItems: O,
    displayCommentTextarea: M,
    cancellationForm: R
  };
}
function O2({ onClickContinue: u, cancellationReasons: o, conversation: s, user: d }) {
  const { url: h } = ox(`/conversations/${s.id}`), { t: m } = tx(["conversations", "common"]), { isDesktop: g } = TC(), {
    isLoading: k,
    requestHasError: S,
    onSubmitCancellationForm: E,
    cancellationReasonsRadioItems: R,
    displayCommentTextarea: P,
    cancellationForm: {
      control: O,
      handleSubmit: M,
      setValue: $,
      formState: { errors: Z }
    }
  } = N2({ onClickContinue: u, cancellationReasons: o, conversation: s, user: d });
  return /* @__PURE__ */ tn(SC, { children: [
    /* @__PURE__ */ tn($y, { size: 6, centerContent: !0, children: [
      /* @__PURE__ */ le(kC, { level: 2, children: m("cancellation-page.reason_step.title") }),
      /* @__PURE__ */ le("form", { onSubmit: M(E), children: /* @__PURE__ */ tn(Nz, { isFullWidth: !0, flexGrow: !0, alignItems: "stretch", direction: "column", children: [
        /* @__PURE__ */ le(
          jS,
          {
            name: "reasonId",
            control: O,
            render: ({ field: G }) => {
              var Pe;
              return /* @__PURE__ */ le(
                Uk,
                {
                  ...G,
                  errorMessage: (Pe = Z.reasonId) != null && Pe.message ? m(Z.reasonId.message) : void 0,
                  onChange: (re) => {
                    re !== Zy && P && $("comment", ""), G.onChange(re);
                  },
                  label: m("cancellation-page.reason_step.checboxes_label"),
                  children: R.map((re) => /* @__PURE__ */ le(Uk.Item, { value: re.id, id: re.id, label: re.name }, re.id))
                }
              );
            }
          }
        ),
        P && /* @__PURE__ */ le(
          jS,
          {
            name: "comment",
            control: O,
            render: ({ field: G }) => {
              var Pe, re, ve;
              return /* @__PURE__ */ le(
                Uz,
                {
                  placeholder: m("cancellation-page.reason_step.comment_placeholder"),
                  id: "reason-comment",
                  status: (Pe = Z.comment) != null && Pe.message ? "error" : void 0,
                  message: (re = Z.comment) != null && re.message ? m((ve = Z.comment) == null ? void 0 : ve.message, { limit: 255 }) : void 0,
                  maxLength: 255,
                  ...G
                }
              );
            }
          }
        ),
        S && !k && /* @__PURE__ */ tn(Qz, { status: "error", hasIcon: !0, children: [
          /* @__PURE__ */ le("span", { style: { fontWeight: "bold" }, children: m("common:errors.unable_to_submit.title") }),
          /* @__PURE__ */ le(Fk, { children: m("common:errors.unable_to_submit.subtitle") })
        ] }),
        /* @__PURE__ */ tn(XE, { flexGrowButtons: !0, children: [
          /* @__PURE__ */ le(rm, { isLoading: k, disabled: k, color: "destructive", type: "submit", children: m("cancellation-page.cancel-exchange") }),
          /* @__PURE__ */ le(rm, { disabled: k, color: "tertiary", href: h, children: m("cancellation-page.keep-exchange") })
        ] })
      ] }) })
    ] }),
    g && /* @__PURE__ */ le($y, { size: 6, centerContent: !0, children: /* @__PURE__ */ le(
      xC,
      {
        width: "full",
        src: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/cancellation/cancellation-regular-desktop.svg",
        alt: "cancellation-warning"
      }
    ) })
  ] });
}
function L2({ onClickContinue: u, conversation: o }) {
  const { t: s } = tx("conversations"), { isTablet: d, isMobile: h, isDesktop: m } = TC(), { url: g } = ox(`/conversations/${o.id}`), k = /* @__PURE__ */ tn(XE, { flexGrowButtons: !0, children: [
    /* @__PURE__ */ le(rm, { onClick: u, children: s("cancellation-page.continue-cancellation") }),
    /* @__PURE__ */ le(rm, { color: "tertiary", href: g, children: s("cancellation-page.keep-exchange") })
  ] });
  return /* @__PURE__ */ tn(SC, { children: [
    /* @__PURE__ */ tn($y, { size: 6, centerContent: !0, children: [
      /* @__PURE__ */ le(kC, { level: 2, children: s("cancellation-page.cancel-exchange") }),
      /* @__PURE__ */ le(Fk, { children: s("cancellation-page.warning-step.first-warning") }),
      /* @__PURE__ */ le(Fk, { isBold: !0, children: s("cancellation-page.warning-step.second-warning") }),
      m && k
    ] }),
    /* @__PURE__ */ tn($y, { size: 6, centerContent: !0, children: [
      /* @__PURE__ */ le(
        xC,
        {
          width: "full",
          src: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/cancellation/cancellation-regular-desktop.svg",
          alt: "cancellation-warning"
        }
      ),
      (d || h) && k
    ] })
  ] });
}
const D2 = (u, o, s, d) => {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push({ event_data: null, page_data: null, user_data: null });
  const { eventCallback: h, ...m } = {}, g = (k) => {
    h && typeof h == "function" && k.startsWith("GTM-") && h(k);
  };
  window.dataLayer.push({
    event: "page_view",
    event_data: {
      collection: s,
      method: null,
      text: null
    },
    page_data: {
      location: location.href,
      referrer: document.referrer,
      title: document.title,
      language: navigator.language
    },
    user_data: {
      login_status: "logged",
      uid: u,
      profile: o
    },
    eventCallback: g,
    ...m
  });
}, $C = (u, o, s) => {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push({ event_data: null });
  const { eventCallback: d, ...h } = s || {}, m = (g) => {
    d && typeof d == "function" && g.startsWith("GTM-") && d(g);
  };
  window.dataLayer.push({
    event: u,
    event_data: o,
    ...h,
    eventCallback: m
  }), !window.google_tag_manager && s != null && s.eventCallback && typeof s.eventCallback == "function" && s.eventCallback();
}, z2 = (u, o, s) => {
  $C("funnel_progress", {
    funnel_name: u,
    funnel_step: o,
    ...s
  });
}, I2 = (u) => u.subscriptionEndOn ? u.isHeCollection ? "member_collection" : new Date(u.subscriptionEndOn) < /* @__PURE__ */ new Date() ? "expired" : "member_regular" : "lead", dt = (u) => typeof u == "string", Yh = () => {
  let u, o;
  const s = new Promise((d, h) => {
    u = d, o = h;
  });
  return s.resolve = u, s.reject = o, s;
}, hE = (u) => u == null ? "" : "" + u, A2 = (u, o, s) => {
  u.forEach((d) => {
    o[d] && (s[d] = o[d]);
  });
}, M2 = /###/g, mE = (u) => u && u.indexOf("###") > -1 ? u.replace(M2, ".") : u, gE = (u) => !u || dt(u), tm = (u, o, s) => {
  const d = dt(o) ? o.split(".") : o;
  let h = 0;
  for (; h < d.length - 1; ) {
    if (gE(u)) return {};
    const m = mE(d[h]);
    !u[m] && s && (u[m] = new s()), Object.prototype.hasOwnProperty.call(u, m) ? u = u[m] : u = {}, ++h;
  }
  return gE(u) ? {} : {
    obj: u,
    k: mE(d[h])
  };
}, vE = (u, o, s) => {
  const {
    obj: d,
    k: h
  } = tm(u, o, Object);
  if (d !== void 0 || o.length === 1) {
    d[h] = s;
    return;
  }
  let m = o[o.length - 1], g = o.slice(0, o.length - 1), k = tm(u, g, Object);
  for (; k.obj === void 0 && g.length; )
    m = `${g[g.length - 1]}.${m}`, g = g.slice(0, g.length - 1), k = tm(u, g, Object), k != null && k.obj && typeof k.obj[`${k.k}.${m}`] < "u" && (k.obj = void 0);
  k.obj[`${k.k}.${m}`] = s;
}, F2 = (u, o, s, d) => {
  const {
    obj: h,
    k: m
  } = tm(u, o, Object);
  h[m] = h[m] || [], h[m].push(s);
}, Qy = (u, o) => {
  const {
    obj: s,
    k: d
  } = tm(u, o);
  if (s && Object.prototype.hasOwnProperty.call(s, d))
    return s[d];
}, $2 = (u, o, s) => {
  const d = Qy(u, s);
  return d !== void 0 ? d : Qy(o, s);
}, jC = (u, o, s) => {
  for (const d in o)
    d !== "__proto__" && d !== "constructor" && (d in u ? dt(u[d]) || u[d] instanceof String || dt(o[d]) || o[d] instanceof String ? s && (u[d] = o[d]) : jC(u[d], o[d], s) : u[d] = o[d]);
  return u;
}, vf = (u) => u.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var j2 = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const U2 = (u) => dt(u) ? u.replace(/[&<>"'\/]/g, (o) => j2[o]) : u;
class V2 {
  constructor(o) {
    this.capacity = o, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(o) {
    const s = this.regExpMap.get(o);
    if (s !== void 0)
      return s;
    const d = new RegExp(o);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(o, d), this.regExpQueue.push(o), d;
  }
}
const B2 = [" ", ",", "?", "!", ";"], W2 = new V2(20), q2 = (u, o, s) => {
  o = o || "", s = s || "";
  const d = B2.filter((g) => o.indexOf(g) < 0 && s.indexOf(g) < 0);
  if (d.length === 0) return !0;
  const h = W2.getRegExp(`(${d.map((g) => g === "?" ? "\\?" : g).join("|")})`);
  let m = !h.test(u);
  if (!m) {
    const g = u.indexOf(s);
    g > 0 && !h.test(u.substring(0, g)) && (m = !0);
  }
  return m;
}, Hk = function(u, o) {
  let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!u) return;
  if (u[o])
    return Object.prototype.hasOwnProperty.call(u, o) ? u[o] : void 0;
  const d = o.split(s);
  let h = u;
  for (let m = 0; m < d.length; ) {
    if (!h || typeof h != "object")
      return;
    let g, k = "";
    for (let S = m; S < d.length; ++S)
      if (S !== m && (k += s), k += d[S], g = h[k], g !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof g) > -1 && S < d.length - 1)
          continue;
        m += S - m + 1;
        break;
      }
    h = g;
  }
  return h;
}, Ky = (u) => u == null ? void 0 : u.replace("_", "-"), H2 = {
  type: "logger",
  log(u) {
    this.output("log", u);
  },
  warn(u) {
    this.output("warn", u);
  },
  error(u) {
    this.output("error", u);
  },
  output(u, o) {
    var s, d;
    (d = (s = console == null ? void 0 : console[u]) == null ? void 0 : s.apply) == null || d.call(s, console, o);
  }
};
class Yy {
  constructor(o) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(o, s);
  }
  init(o) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = s.prefix || "i18next:", this.logger = o || H2, this.options = s, this.debug = s.debug;
  }
  log() {
    for (var o = arguments.length, s = new Array(o), d = 0; d < o; d++)
      s[d] = arguments[d];
    return this.forward(s, "log", "", !0);
  }
  warn() {
    for (var o = arguments.length, s = new Array(o), d = 0; d < o; d++)
      s[d] = arguments[d];
    return this.forward(s, "warn", "", !0);
  }
  error() {
    for (var o = arguments.length, s = new Array(o), d = 0; d < o; d++)
      s[d] = arguments[d];
    return this.forward(s, "error", "");
  }
  deprecate() {
    for (var o = arguments.length, s = new Array(o), d = 0; d < o; d++)
      s[d] = arguments[d];
    return this.forward(s, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(o, s, d, h) {
    return h && !this.debug ? null : (dt(o[0]) && (o[0] = `${d}${this.prefix} ${o[0]}`), this.logger[s](o));
  }
  create(o) {
    return new Yy(this.logger, {
      prefix: `${this.prefix}:${o}:`,
      ...this.options
    });
  }
  clone(o) {
    return o = o || this.options, o.prefix = o.prefix || this.prefix, new Yy(this.logger, o);
  }
}
var Fi = new Yy();
class nb {
  constructor() {
    this.observers = {};
  }
  on(o, s) {
    return o.split(" ").forEach((d) => {
      this.observers[d] || (this.observers[d] = /* @__PURE__ */ new Map());
      const h = this.observers[d].get(s) || 0;
      this.observers[d].set(s, h + 1);
    }), this;
  }
  off(o, s) {
    if (this.observers[o]) {
      if (!s) {
        delete this.observers[o];
        return;
      }
      this.observers[o].delete(s);
    }
  }
  emit(o) {
    for (var s = arguments.length, d = new Array(s > 1 ? s - 1 : 0), h = 1; h < s; h++)
      d[h - 1] = arguments[h];
    this.observers[o] && Array.from(this.observers[o].entries()).forEach((g) => {
      let [k, S] = g;
      for (let E = 0; E < S; E++)
        k(...d);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((g) => {
      let [k, S] = g;
      for (let E = 0; E < S; E++)
        k.apply(k, [o, ...d]);
    });
  }
}
class yE extends nb {
  constructor(o) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = o || {}, this.options = s, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(o) {
    this.options.ns.indexOf(o) < 0 && this.options.ns.push(o);
  }
  removeNamespaces(o) {
    const s = this.options.ns.indexOf(o);
    s > -1 && this.options.ns.splice(s, 1);
  }
  getResource(o, s, d) {
    var E, R;
    let h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const m = h.keySeparator !== void 0 ? h.keySeparator : this.options.keySeparator, g = h.ignoreJSONStructure !== void 0 ? h.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let k;
    o.indexOf(".") > -1 ? k = o.split(".") : (k = [o, s], d && (Array.isArray(d) ? k.push(...d) : dt(d) && m ? k.push(...d.split(m)) : k.push(d)));
    const S = Qy(this.data, k);
    return !S && !s && !d && o.indexOf(".") > -1 && (o = k[0], s = k[1], d = k.slice(2).join(".")), S || !g || !dt(d) ? S : Hk((R = (E = this.data) == null ? void 0 : E[o]) == null ? void 0 : R[s], d, m);
  }
  addResource(o, s, d, h) {
    let m = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const g = m.keySeparator !== void 0 ? m.keySeparator : this.options.keySeparator;
    let k = [o, s];
    d && (k = k.concat(g ? d.split(g) : d)), o.indexOf(".") > -1 && (k = o.split("."), h = s, s = k[1]), this.addNamespaces(s), vE(this.data, k, h), m.silent || this.emit("added", o, s, d, h);
  }
  addResources(o, s, d) {
    let h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const m in d)
      (dt(d[m]) || Array.isArray(d[m])) && this.addResource(o, s, m, d[m], {
        silent: !0
      });
    h.silent || this.emit("added", o, s, d);
  }
  addResourceBundle(o, s, d, h, m) {
    let g = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, k = [o, s];
    o.indexOf(".") > -1 && (k = o.split("."), h = d, d = s, s = k[1]), this.addNamespaces(s);
    let S = Qy(this.data, k) || {};
    g.skipCopy || (d = JSON.parse(JSON.stringify(d))), h ? jC(S, d, m) : S = {
      ...S,
      ...d
    }, vE(this.data, k, S), g.silent || this.emit("added", o, s, d);
  }
  removeResourceBundle(o, s) {
    this.hasResourceBundle(o, s) && delete this.data[o][s], this.removeNamespaces(s), this.emit("removed", o, s);
  }
  hasResourceBundle(o, s) {
    return this.getResource(o, s) !== void 0;
  }
  getResourceBundle(o, s) {
    return s || (s = this.options.defaultNS), this.getResource(o, s);
  }
  getDataByLanguage(o) {
    return this.data[o];
  }
  hasLanguageSomeTranslations(o) {
    const s = this.getDataByLanguage(o);
    return !!(s && Object.keys(s) || []).find((h) => s[h] && Object.keys(s[h]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var UC = {
  processors: {},
  addPostProcessor(u) {
    this.processors[u.name] = u;
  },
  handle(u, o, s, d, h) {
    return u.forEach((m) => {
      var g;
      o = ((g = this.processors[m]) == null ? void 0 : g.process(o, s, d, h)) ?? o;
    }), o;
  }
};
const bE = {}, _E = (u) => !dt(u) && typeof u != "boolean" && typeof u != "number";
class Gy extends nb {
  constructor(o) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), A2(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], o, this), this.options = s, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Fi.create("translator");
  }
  changeLanguage(o) {
    o && (this.language = o);
  }
  exists(o) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (o == null)
      return !1;
    const d = this.resolve(o, s);
    return (d == null ? void 0 : d.res) !== void 0;
  }
  extractFromKey(o, s) {
    let d = s.nsSeparator !== void 0 ? s.nsSeparator : this.options.nsSeparator;
    d === void 0 && (d = ":");
    const h = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator;
    let m = s.ns || this.options.defaultNS || [];
    const g = d && o.indexOf(d) > -1, k = !this.options.userDefinedKeySeparator && !s.keySeparator && !this.options.userDefinedNsSeparator && !s.nsSeparator && !q2(o, d, h);
    if (g && !k) {
      const S = o.match(this.interpolator.nestingRegexp);
      if (S && S.length > 0)
        return {
          key: o,
          namespaces: dt(m) ? [m] : m
        };
      const E = o.split(d);
      (d !== h || d === h && this.options.ns.indexOf(E[0]) > -1) && (m = E.shift()), o = E.join(h);
    }
    return {
      key: o,
      namespaces: dt(m) ? [m] : m
    };
  }
  translate(o, s, d) {
    if (typeof s != "object" && this.options.overloadTranslationOptionHandler && (s = this.options.overloadTranslationOptionHandler(arguments)), typeof s == "object" && (s = {
      ...s
    }), s || (s = {}), o == null) return "";
    Array.isArray(o) || (o = [String(o)]);
    const h = s.returnDetails !== void 0 ? s.returnDetails : this.options.returnDetails, m = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, {
      key: g,
      namespaces: k
    } = this.extractFromKey(o[o.length - 1], s), S = k[k.length - 1], E = s.lng || this.language, R = s.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if ((E == null ? void 0 : E.toLowerCase()) === "cimode") {
      if (R) {
        const Ie = s.nsSeparator || this.options.nsSeparator;
        return h ? {
          res: `${S}${Ie}${g}`,
          usedKey: g,
          exactUsedKey: g,
          usedLng: E,
          usedNS: S,
          usedParams: this.getUsedParamsDetails(s)
        } : `${S}${Ie}${g}`;
      }
      return h ? {
        res: g,
        usedKey: g,
        exactUsedKey: g,
        usedLng: E,
        usedNS: S,
        usedParams: this.getUsedParamsDetails(s)
      } : g;
    }
    const P = this.resolve(o, s);
    let O = P == null ? void 0 : P.res;
    const M = (P == null ? void 0 : P.usedKey) || g, $ = (P == null ? void 0 : P.exactUsedKey) || g, Z = ["[object Number]", "[object Function]", "[object RegExp]"], G = s.joinArrays !== void 0 ? s.joinArrays : this.options.joinArrays, Pe = !this.i18nFormat || this.i18nFormat.handleAsObject, re = s.count !== void 0 && !dt(s.count), ve = Gy.hasDefaultValue(s), qe = re ? this.pluralResolver.getSuffix(E, s.count, s) : "", Re = s.ordinal && re ? this.pluralResolver.getSuffix(E, s.count, {
      ordinal: !1
    }) : "", ft = re && !s.ordinal && s.count === 0, Oe = ft && s[`defaultValue${this.options.pluralSeparator}zero`] || s[`defaultValue${qe}`] || s[`defaultValue${Re}`] || s.defaultValue;
    let ye = O;
    Pe && !O && ve && (ye = Oe);
    const rt = _E(ye), st = Object.prototype.toString.apply(ye);
    if (Pe && ye && rt && Z.indexOf(st) < 0 && !(dt(G) && Array.isArray(ye))) {
      if (!s.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const Ie = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(M, ye, {
          ...s,
          ns: k
        }) : `key '${g} (${this.language})' returned an object instead of string.`;
        return h ? (P.res = Ie, P.usedParams = this.getUsedParamsDetails(s), P) : Ie;
      }
      if (m) {
        const Ie = Array.isArray(ye), fe = Ie ? [] : {}, Ae = Ie ? $ : M;
        for (const Ke in ye)
          if (Object.prototype.hasOwnProperty.call(ye, Ke)) {
            const et = `${Ae}${m}${Ke}`;
            ve && !O ? fe[Ke] = this.translate(et, {
              ...s,
              defaultValue: _E(Oe) ? Oe[Ke] : void 0,
              joinArrays: !1,
              ns: k
            }) : fe[Ke] = this.translate(et, {
              ...s,
              joinArrays: !1,
              ns: k
            }), fe[Ke] === et && (fe[Ke] = ye[Ke]);
          }
        O = fe;
      }
    } else if (Pe && dt(G) && Array.isArray(O))
      O = O.join(G), O && (O = this.extendTranslation(O, o, s, d));
    else {
      let Ie = !1, fe = !1;
      !this.isValidLookup(O) && ve && (Ie = !0, O = Oe), this.isValidLookup(O) || (fe = !0, O = g);
      const Ke = (s.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && fe ? void 0 : O, et = ve && Oe !== O && this.options.updateMissing;
      if (fe || Ie || et) {
        if (this.logger.log(et ? "updateKey" : "missingKey", E, S, g, et ? Oe : O), m) {
          const ke = this.resolve(g, {
            ...s,
            keySeparator: !1
          });
          ke && ke.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let _t = [];
        const qt = this.languageUtils.getFallbackCodes(this.options.fallbackLng, s.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && qt && qt[0])
          for (let ke = 0; ke < qt.length; ke++)
            _t.push(qt[ke]);
        else this.options.saveMissingTo === "all" ? _t = this.languageUtils.toResolveHierarchy(s.lng || this.language) : _t.push(s.lng || this.language);
        const ue = (ke, pe, gt) => {
          var or;
          const Ct = ve && gt !== O ? gt : Ke;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(ke, S, pe, Ct, et, s) : (or = this.backendConnector) != null && or.saveMissing && this.backendConnector.saveMissing(ke, S, pe, Ct, et, s), this.emit("missingKey", ke, S, pe, O);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && re ? _t.forEach((ke) => {
          const pe = this.pluralResolver.getSuffixes(ke, s);
          ft && s[`defaultValue${this.options.pluralSeparator}zero`] && pe.indexOf(`${this.options.pluralSeparator}zero`) < 0 && pe.push(`${this.options.pluralSeparator}zero`), pe.forEach((gt) => {
            ue([ke], g + gt, s[`defaultValue${gt}`] || Oe);
          });
        }) : ue(_t, g, Oe));
      }
      O = this.extendTranslation(O, o, s, P, d), fe && O === g && this.options.appendNamespaceToMissingKey && (O = `${S}:${g}`), (fe || Ie) && this.options.parseMissingKeyHandler && (O = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${S}:${g}` : g, Ie ? O : void 0));
    }
    return h ? (P.res = O, P.usedParams = this.getUsedParamsDetails(s), P) : O;
  }
  extendTranslation(o, s, d, h, m) {
    var E, R;
    var g = this;
    if ((E = this.i18nFormat) != null && E.parse)
      o = this.i18nFormat.parse(o, {
        ...this.options.interpolation.defaultVariables,
        ...d
      }, d.lng || this.language || h.usedLng, h.usedNS, h.usedKey, {
        resolved: h
      });
    else if (!d.skipInterpolation) {
      d.interpolation && this.interpolator.init({
        ...d,
        interpolation: {
          ...this.options.interpolation,
          ...d.interpolation
        }
      });
      const P = dt(o) && (((R = d == null ? void 0 : d.interpolation) == null ? void 0 : R.skipOnVariables) !== void 0 ? d.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let O;
      if (P) {
        const $ = o.match(this.interpolator.nestingRegexp);
        O = $ && $.length;
      }
      let M = d.replace && !dt(d.replace) ? d.replace : d;
      if (this.options.interpolation.defaultVariables && (M = {
        ...this.options.interpolation.defaultVariables,
        ...M
      }), o = this.interpolator.interpolate(o, M, d.lng || this.language || h.usedLng, d), P) {
        const $ = o.match(this.interpolator.nestingRegexp), Z = $ && $.length;
        O < Z && (d.nest = !1);
      }
      !d.lng && h && h.res && (d.lng = this.language || h.usedLng), d.nest !== !1 && (o = this.interpolator.nest(o, function() {
        for (var $ = arguments.length, Z = new Array($), G = 0; G < $; G++)
          Z[G] = arguments[G];
        return (m == null ? void 0 : m[0]) === Z[0] && !d.context ? (g.logger.warn(`It seems you are nesting recursively key: ${Z[0]} in key: ${s[0]}`), null) : g.translate(...Z, s);
      }, d)), d.interpolation && this.interpolator.reset();
    }
    const k = d.postProcess || this.options.postProcess, S = dt(k) ? [k] : k;
    return o != null && (S != null && S.length) && d.applyPostProcessor !== !1 && (o = UC.handle(S, o, s, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...h,
        usedParams: this.getUsedParamsDetails(d)
      },
      ...d
    } : d, this)), o;
  }
  resolve(o) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, d, h, m, g, k;
    return dt(o) && (o = [o]), o.forEach((S) => {
      if (this.isValidLookup(d)) return;
      const E = this.extractFromKey(S, s), R = E.key;
      h = R;
      let P = E.namespaces;
      this.options.fallbackNS && (P = P.concat(this.options.fallbackNS));
      const O = s.count !== void 0 && !dt(s.count), M = O && !s.ordinal && s.count === 0, $ = s.context !== void 0 && (dt(s.context) || typeof s.context == "number") && s.context !== "", Z = s.lngs ? s.lngs : this.languageUtils.toResolveHierarchy(s.lng || this.language, s.fallbackLng);
      P.forEach((G) => {
        var Pe, re;
        this.isValidLookup(d) || (k = G, !bE[`${Z[0]}-${G}`] && ((Pe = this.utils) != null && Pe.hasLoadedNamespace) && !((re = this.utils) != null && re.hasLoadedNamespace(k)) && (bE[`${Z[0]}-${G}`] = !0, this.logger.warn(`key "${h}" for languages "${Z.join(", ")}" won't get resolved as namespace "${k}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), Z.forEach((ve) => {
          var ft;
          if (this.isValidLookup(d)) return;
          g = ve;
          const qe = [R];
          if ((ft = this.i18nFormat) != null && ft.addLookupKeys)
            this.i18nFormat.addLookupKeys(qe, R, ve, G, s);
          else {
            let Oe;
            O && (Oe = this.pluralResolver.getSuffix(ve, s.count, s));
            const ye = `${this.options.pluralSeparator}zero`, rt = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (O && (qe.push(R + Oe), s.ordinal && Oe.indexOf(rt) === 0 && qe.push(R + Oe.replace(rt, this.options.pluralSeparator)), M && qe.push(R + ye)), $) {
              const st = `${R}${this.options.contextSeparator}${s.context}`;
              qe.push(st), O && (qe.push(st + Oe), s.ordinal && Oe.indexOf(rt) === 0 && qe.push(st + Oe.replace(rt, this.options.pluralSeparator)), M && qe.push(st + ye));
            }
          }
          let Re;
          for (; Re = qe.pop(); )
            this.isValidLookup(d) || (m = Re, d = this.getResource(ve, G, Re, s));
        }));
      });
    }), {
      res: d,
      usedKey: h,
      exactUsedKey: m,
      usedLng: g,
      usedNS: k
    };
  }
  isValidLookup(o) {
    return o !== void 0 && !(!this.options.returnNull && o === null) && !(!this.options.returnEmptyString && o === "");
  }
  getResource(o, s, d) {
    var m;
    let h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return (m = this.i18nFormat) != null && m.getResource ? this.i18nFormat.getResource(o, s, d, h) : this.resourceStore.getResource(o, s, d, h);
  }
  getUsedParamsDetails() {
    let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const s = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], d = o.replace && !dt(o.replace);
    let h = d ? o.replace : o;
    if (d && typeof o.count < "u" && (h.count = o.count), this.options.interpolation.defaultVariables && (h = {
      ...this.options.interpolation.defaultVariables,
      ...h
    }), !d) {
      h = {
        ...h
      };
      for (const m of s)
        delete h[m];
    }
    return h;
  }
  static hasDefaultValue(o) {
    const s = "defaultValue";
    for (const d in o)
      if (Object.prototype.hasOwnProperty.call(o, d) && s === d.substring(0, s.length) && o[d] !== void 0)
        return !0;
    return !1;
  }
}
class wE {
  constructor(o) {
    this.options = o, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Fi.create("languageUtils");
  }
  getScriptPartFromCode(o) {
    if (o = Ky(o), !o || o.indexOf("-") < 0) return null;
    const s = o.split("-");
    return s.length === 2 || (s.pop(), s[s.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(s.join("-"));
  }
  getLanguagePartFromCode(o) {
    if (o = Ky(o), !o || o.indexOf("-") < 0) return o;
    const s = o.split("-");
    return this.formatLanguageCode(s[0]);
  }
  formatLanguageCode(o) {
    if (dt(o) && o.indexOf("-") > -1) {
      let s;
      try {
        s = Intl.getCanonicalLocales(o)[0];
      } catch {
      }
      return s && this.options.lowerCaseLng && (s = s.toLowerCase()), s || (this.options.lowerCaseLng ? o.toLowerCase() : o);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? o.toLowerCase() : o;
  }
  isSupportedCode(o) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (o = this.getLanguagePartFromCode(o)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(o) > -1;
  }
  getBestMatchFromCodes(o) {
    if (!o) return null;
    let s;
    return o.forEach((d) => {
      if (s) return;
      const h = this.formatLanguageCode(d);
      (!this.options.supportedLngs || this.isSupportedCode(h)) && (s = h);
    }), !s && this.options.supportedLngs && o.forEach((d) => {
      if (s) return;
      const h = this.getLanguagePartFromCode(d);
      if (this.isSupportedCode(h)) return s = h;
      s = this.options.supportedLngs.find((m) => {
        if (m === h) return m;
        if (!(m.indexOf("-") < 0 && h.indexOf("-") < 0) && (m.indexOf("-") > 0 && h.indexOf("-") < 0 && m.substring(0, m.indexOf("-")) === h || m.indexOf(h) === 0 && h.length > 1))
          return m;
      });
    }), s || (s = this.getFallbackCodes(this.options.fallbackLng)[0]), s;
  }
  getFallbackCodes(o, s) {
    if (!o) return [];
    if (typeof o == "function" && (o = o(s)), dt(o) && (o = [o]), Array.isArray(o)) return o;
    if (!s) return o.default || [];
    let d = o[s];
    return d || (d = o[this.getScriptPartFromCode(s)]), d || (d = o[this.formatLanguageCode(s)]), d || (d = o[this.getLanguagePartFromCode(s)]), d || (d = o.default), d || [];
  }
  toResolveHierarchy(o, s) {
    const d = this.getFallbackCodes(s || this.options.fallbackLng || [], o), h = [], m = (g) => {
      g && (this.isSupportedCode(g) ? h.push(g) : this.logger.warn(`rejecting language code not found in supportedLngs: ${g}`));
    };
    return dt(o) && (o.indexOf("-") > -1 || o.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && m(this.formatLanguageCode(o)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && m(this.getScriptPartFromCode(o)), this.options.load !== "currentOnly" && m(this.getLanguagePartFromCode(o))) : dt(o) && m(this.formatLanguageCode(o)), d.forEach((g) => {
      h.indexOf(g) < 0 && m(this.formatLanguageCode(g));
    }), h;
  }
}
const kE = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, xE = {
  select: (u) => u === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class Z2 {
  constructor(o) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = o, this.options = s, this.logger = Fi.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(o, s) {
    this.rules[o] = s;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(o) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const d = Ky(o === "dev" ? "en" : o), h = s.ordinal ? "ordinal" : "cardinal", m = JSON.stringify({
      cleanedCode: d,
      type: h
    });
    if (m in this.pluralRulesCache)
      return this.pluralRulesCache[m];
    let g;
    try {
      g = new Intl.PluralRules(d, {
        type: h
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), xE;
      if (!o.match(/-|_/)) return xE;
      const S = this.languageUtils.getLanguagePartFromCode(o);
      g = this.getRule(S, s);
    }
    return this.pluralRulesCache[m] = g, g;
  }
  needsPlural(o) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, d = this.getRule(o, s);
    return d || (d = this.getRule("dev", s)), (d == null ? void 0 : d.resolvedOptions().pluralCategories.length) > 1;
  }
  getPluralFormsOfKey(o, s) {
    let d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(o, d).map((h) => `${s}${h}`);
  }
  getSuffixes(o) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, d = this.getRule(o, s);
    return d || (d = this.getRule("dev", s)), d ? d.resolvedOptions().pluralCategories.sort((h, m) => kE[h] - kE[m]).map((h) => `${this.options.prepend}${s.ordinal ? `ordinal${this.options.prepend}` : ""}${h}`) : [];
  }
  getSuffix(o, s) {
    let d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const h = this.getRule(o, d);
    return h ? `${this.options.prepend}${d.ordinal ? `ordinal${this.options.prepend}` : ""}${h.select(s)}` : (this.logger.warn(`no plural rule found for: ${o}`), this.getSuffix("dev", s, d));
  }
}
const SE = function(u, o, s) {
  let d = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, m = $2(u, o, s);
  return !m && h && dt(s) && (m = Hk(u, s, d), m === void 0 && (m = Hk(o, s, d))), m;
}, zk = (u) => u.replace(/\$/g, "$$$$");
class Q2 {
  constructor() {
    var s;
    let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Fi.create("interpolator"), this.options = o, this.format = ((s = o == null ? void 0 : o.interpolation) == null ? void 0 : s.format) || ((d) => d), this.init(o);
  }
  init() {
    let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    o.interpolation || (o.interpolation = {
      escapeValue: !0
    });
    const {
      escape: s,
      escapeValue: d,
      useRawValueToEscape: h,
      prefix: m,
      prefixEscaped: g,
      suffix: k,
      suffixEscaped: S,
      formatSeparator: E,
      unescapeSuffix: R,
      unescapePrefix: P,
      nestingPrefix: O,
      nestingPrefixEscaped: M,
      nestingSuffix: $,
      nestingSuffixEscaped: Z,
      nestingOptionsSeparator: G,
      maxReplaces: Pe,
      alwaysFormat: re
    } = o.interpolation;
    this.escape = s !== void 0 ? s : U2, this.escapeValue = d !== void 0 ? d : !0, this.useRawValueToEscape = h !== void 0 ? h : !1, this.prefix = m ? vf(m) : g || "{{", this.suffix = k ? vf(k) : S || "}}", this.formatSeparator = E || ",", this.unescapePrefix = R ? "" : P || "-", this.unescapeSuffix = this.unescapePrefix ? "" : R || "", this.nestingPrefix = O ? vf(O) : M || vf("$t("), this.nestingSuffix = $ ? vf($) : Z || vf(")"), this.nestingOptionsSeparator = G || ",", this.maxReplaces = Pe || 1e3, this.alwaysFormat = re !== void 0 ? re : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const o = (s, d) => (s == null ? void 0 : s.source) === d ? (s.lastIndex = 0, s) : new RegExp(d, "g");
    this.regexp = o(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = o(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = o(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(o, s, d, h) {
    var M;
    let m, g, k;
    const S = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, E = ($) => {
      if ($.indexOf(this.formatSeparator) < 0) {
        const re = SE(s, S, $, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(re, void 0, d, {
          ...h,
          ...s,
          interpolationkey: $
        }) : re;
      }
      const Z = $.split(this.formatSeparator), G = Z.shift().trim(), Pe = Z.join(this.formatSeparator).trim();
      return this.format(SE(s, S, G, this.options.keySeparator, this.options.ignoreJSONStructure), Pe, d, {
        ...h,
        ...s,
        interpolationkey: G
      });
    };
    this.resetRegExp();
    const R = (h == null ? void 0 : h.missingInterpolationHandler) || this.options.missingInterpolationHandler, P = ((M = h == null ? void 0 : h.interpolation) == null ? void 0 : M.skipOnVariables) !== void 0 ? h.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: ($) => zk($)
    }, {
      regex: this.regexp,
      safeValue: ($) => this.escapeValue ? zk(this.escape($)) : zk($)
    }].forEach(($) => {
      for (k = 0; m = $.regex.exec(o); ) {
        const Z = m[1].trim();
        if (g = E(Z), g === void 0)
          if (typeof R == "function") {
            const Pe = R(o, m, h);
            g = dt(Pe) ? Pe : "";
          } else if (h && Object.prototype.hasOwnProperty.call(h, Z))
            g = "";
          else if (P) {
            g = m[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${Z} for interpolating ${o}`), g = "";
        else !dt(g) && !this.useRawValueToEscape && (g = hE(g));
        const G = $.safeValue(g);
        if (o = o.replace(m[0], G), P ? ($.regex.lastIndex += g.length, $.regex.lastIndex -= m[0].length) : $.regex.lastIndex = 0, k++, k >= this.maxReplaces)
          break;
      }
    }), o;
  }
  nest(o, s) {
    let d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, h, m, g;
    const k = (S, E) => {
      const R = this.nestingOptionsSeparator;
      if (S.indexOf(R) < 0) return S;
      const P = S.split(new RegExp(`${R}[ ]*{`));
      let O = `{${P[1]}`;
      S = P[0], O = this.interpolate(O, g);
      const M = O.match(/'/g), $ = O.match(/"/g);
      (((M == null ? void 0 : M.length) ?? 0) % 2 === 0 && !$ || $.length % 2 !== 0) && (O = O.replace(/'/g, '"'));
      try {
        g = JSON.parse(O), E && (g = {
          ...E,
          ...g
        });
      } catch (Z) {
        return this.logger.warn(`failed parsing options string in nesting for key ${S}`, Z), `${S}${R}${O}`;
      }
      return g.defaultValue && g.defaultValue.indexOf(this.prefix) > -1 && delete g.defaultValue, S;
    };
    for (; h = this.nestingRegexp.exec(o); ) {
      let S = [];
      g = {
        ...d
      }, g = g.replace && !dt(g.replace) ? g.replace : g, g.applyPostProcessor = !1, delete g.defaultValue;
      let E = !1;
      if (h[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(h[1])) {
        const R = h[1].split(this.formatSeparator).map((P) => P.trim());
        h[1] = R.shift(), S = R, E = !0;
      }
      if (m = s(k.call(this, h[1].trim(), g), g), m && h[0] === o && !dt(m)) return m;
      dt(m) || (m = hE(m)), m || (this.logger.warn(`missed to resolve ${h[1]} for nesting ${o}`), m = ""), E && (m = S.reduce((R, P) => this.format(R, P, d.lng, {
        ...d,
        interpolationkey: h[1].trim()
      }), m.trim())), o = o.replace(h[0], m), this.regexp.lastIndex = 0;
    }
    return o;
  }
}
const K2 = (u) => {
  let o = u.toLowerCase().trim();
  const s = {};
  if (u.indexOf("(") > -1) {
    const d = u.split("(");
    o = d[0].toLowerCase().trim();
    const h = d[1].substring(0, d[1].length - 1);
    o === "currency" && h.indexOf(":") < 0 ? s.currency || (s.currency = h.trim()) : o === "relativetime" && h.indexOf(":") < 0 ? s.range || (s.range = h.trim()) : h.split(";").forEach((g) => {
      if (g) {
        const [k, ...S] = g.split(":"), E = S.join(":").trim().replace(/^'+|'+$/g, ""), R = k.trim();
        s[R] || (s[R] = E), E === "false" && (s[R] = !1), E === "true" && (s[R] = !0), isNaN(E) || (s[R] = parseInt(E, 10));
      }
    });
  }
  return {
    formatName: o,
    formatOptions: s
  };
}, yf = (u) => {
  const o = {};
  return (s, d, h) => {
    let m = h;
    h && h.interpolationkey && h.formatParams && h.formatParams[h.interpolationkey] && h[h.interpolationkey] && (m = {
      ...m,
      [h.interpolationkey]: void 0
    });
    const g = d + JSON.stringify(m);
    let k = o[g];
    return k || (k = u(Ky(d), h), o[g] = k), k(s);
  };
};
class Y2 {
  constructor() {
    let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Fi.create("formatter"), this.options = o, this.formats = {
      number: yf((s, d) => {
        const h = new Intl.NumberFormat(s, {
          ...d
        });
        return (m) => h.format(m);
      }),
      currency: yf((s, d) => {
        const h = new Intl.NumberFormat(s, {
          ...d,
          style: "currency"
        });
        return (m) => h.format(m);
      }),
      datetime: yf((s, d) => {
        const h = new Intl.DateTimeFormat(s, {
          ...d
        });
        return (m) => h.format(m);
      }),
      relativetime: yf((s, d) => {
        const h = new Intl.RelativeTimeFormat(s, {
          ...d
        });
        return (m) => h.format(m, d.range || "day");
      }),
      list: yf((s, d) => {
        const h = new Intl.ListFormat(s, {
          ...d
        });
        return (m) => h.format(m);
      })
    }, this.init(o);
  }
  init(o) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = s.interpolation.formatSeparator || ",";
  }
  add(o, s) {
    this.formats[o.toLowerCase().trim()] = s;
  }
  addCached(o, s) {
    this.formats[o.toLowerCase().trim()] = yf(s);
  }
  format(o, s, d) {
    let h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const m = s.split(this.formatSeparator);
    if (m.length > 1 && m[0].indexOf("(") > 1 && m[0].indexOf(")") < 0 && m.find((k) => k.indexOf(")") > -1)) {
      const k = m.findIndex((S) => S.indexOf(")") > -1);
      m[0] = [m[0], ...m.splice(1, k)].join(this.formatSeparator);
    }
    return m.reduce((k, S) => {
      var P;
      const {
        formatName: E,
        formatOptions: R
      } = K2(S);
      if (this.formats[E]) {
        let O = k;
        try {
          const M = ((P = h == null ? void 0 : h.formatParams) == null ? void 0 : P[h.interpolationkey]) || {}, $ = M.locale || M.lng || h.locale || h.lng || d;
          O = this.formats[E](k, $, {
            ...R,
            ...h,
            ...M
          });
        } catch (M) {
          this.logger.warn(M);
        }
        return O;
      } else
        this.logger.warn(`there was no format function for ${E}`);
      return k;
    }, o);
  }
}
const G2 = (u, o) => {
  u.pending[o] !== void 0 && (delete u.pending[o], u.pendingCount--);
};
class J2 extends nb {
  constructor(o, s, d) {
    var m, g;
    let h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = o, this.store = s, this.services = d, this.languageUtils = d.languageUtils, this.options = h, this.logger = Fi.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = h.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = h.maxRetries >= 0 ? h.maxRetries : 5, this.retryTimeout = h.retryTimeout >= 1 ? h.retryTimeout : 350, this.state = {}, this.queue = [], (g = (m = this.backend) == null ? void 0 : m.init) == null || g.call(m, d, h.backend, h);
  }
  queueLoad(o, s, d, h) {
    const m = {}, g = {}, k = {}, S = {};
    return o.forEach((E) => {
      let R = !0;
      s.forEach((P) => {
        const O = `${E}|${P}`;
        !d.reload && this.store.hasResourceBundle(E, P) ? this.state[O] = 2 : this.state[O] < 0 || (this.state[O] === 1 ? g[O] === void 0 && (g[O] = !0) : (this.state[O] = 1, R = !1, g[O] === void 0 && (g[O] = !0), m[O] === void 0 && (m[O] = !0), S[P] === void 0 && (S[P] = !0)));
      }), R || (k[E] = !0);
    }), (Object.keys(m).length || Object.keys(g).length) && this.queue.push({
      pending: g,
      pendingCount: Object.keys(g).length,
      loaded: {},
      errors: [],
      callback: h
    }), {
      toLoad: Object.keys(m),
      pending: Object.keys(g),
      toLoadLanguages: Object.keys(k),
      toLoadNamespaces: Object.keys(S)
    };
  }
  loaded(o, s, d) {
    const h = o.split("|"), m = h[0], g = h[1];
    s && this.emit("failedLoading", m, g, s), !s && d && this.store.addResourceBundle(m, g, d, void 0, void 0, {
      skipCopy: !0
    }), this.state[o] = s ? -1 : 2, s && d && (this.state[o] = 0);
    const k = {};
    this.queue.forEach((S) => {
      F2(S.loaded, [m], g), G2(S, o), s && S.errors.push(s), S.pendingCount === 0 && !S.done && (Object.keys(S.loaded).forEach((E) => {
        k[E] || (k[E] = {});
        const R = S.loaded[E];
        R.length && R.forEach((P) => {
          k[E][P] === void 0 && (k[E][P] = !0);
        });
      }), S.done = !0, S.errors.length ? S.callback(S.errors) : S.callback());
    }), this.emit("loaded", k), this.queue = this.queue.filter((S) => !S.done);
  }
  read(o, s, d) {
    let h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, m = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, g = arguments.length > 5 ? arguments[5] : void 0;
    if (!o.length) return g(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: o,
        ns: s,
        fcName: d,
        tried: h,
        wait: m,
        callback: g
      });
      return;
    }
    this.readingCalls++;
    const k = (E, R) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const P = this.waitingReads.shift();
        this.read(P.lng, P.ns, P.fcName, P.tried, P.wait, P.callback);
      }
      if (E && R && h < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, o, s, d, h + 1, m * 2, g);
        }, m);
        return;
      }
      g(E, R);
    }, S = this.backend[d].bind(this.backend);
    if (S.length === 2) {
      try {
        const E = S(o, s);
        E && typeof E.then == "function" ? E.then((R) => k(null, R)).catch(k) : k(null, E);
      } catch (E) {
        k(E);
      }
      return;
    }
    return S(o, s, k);
  }
  prepareLoading(o, s) {
    let d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, h = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), h && h();
    dt(o) && (o = this.languageUtils.toResolveHierarchy(o)), dt(s) && (s = [s]);
    const m = this.queueLoad(o, s, d, h);
    if (!m.toLoad.length)
      return m.pending.length || h(), null;
    m.toLoad.forEach((g) => {
      this.loadOne(g);
    });
  }
  load(o, s, d) {
    this.prepareLoading(o, s, {}, d);
  }
  reload(o, s, d) {
    this.prepareLoading(o, s, {
      reload: !0
    }, d);
  }
  loadOne(o) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const d = o.split("|"), h = d[0], m = d[1];
    this.read(h, m, "read", void 0, void 0, (g, k) => {
      g && this.logger.warn(`${s}loading namespace ${m} for language ${h} failed`, g), !g && k && this.logger.log(`${s}loaded namespace ${m} for language ${h}`, k), this.loaded(o, g, k);
    });
  }
  saveMissing(o, s, d, h, m) {
    var S, E, R, P, O;
    let g = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, k = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if ((E = (S = this.services) == null ? void 0 : S.utils) != null && E.hasLoadedNamespace && !((P = (R = this.services) == null ? void 0 : R.utils) != null && P.hasLoadedNamespace(s))) {
      this.logger.warn(`did not save key "${d}" as the namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(d == null || d === "")) {
      if ((O = this.backend) != null && O.create) {
        const M = {
          ...g,
          isUpdate: m
        }, $ = this.backend.create.bind(this.backend);
        if ($.length < 6)
          try {
            let Z;
            $.length === 5 ? Z = $(o, s, d, h, M) : Z = $(o, s, d, h), Z && typeof Z.then == "function" ? Z.then((G) => k(null, G)).catch(k) : k(null, Z);
          } catch (Z) {
            k(Z);
          }
        else
          $(o, s, d, h, k, M);
      }
      !o || !o[0] || this.store.addResource(o[0], s, d, h);
    }
  }
}
const EE = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (u) => {
    let o = {};
    if (typeof u[1] == "object" && (o = u[1]), dt(u[1]) && (o.defaultValue = u[1]), dt(u[2]) && (o.tDescription = u[2]), typeof u[2] == "object" || typeof u[3] == "object") {
      const s = u[3] || u[2];
      Object.keys(s).forEach((d) => {
        o[d] = s[d];
      });
    }
    return o;
  },
  interpolation: {
    escapeValue: !0,
    format: (u) => u,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), CE = (u) => {
  var o, s;
  return dt(u.ns) && (u.ns = [u.ns]), dt(u.fallbackLng) && (u.fallbackLng = [u.fallbackLng]), dt(u.fallbackNS) && (u.fallbackNS = [u.fallbackNS]), ((s = (o = u.supportedLngs) == null ? void 0 : o.indexOf) == null ? void 0 : s.call(o, "cimode")) < 0 && (u.supportedLngs = u.supportedLngs.concat(["cimode"])), typeof u.initImmediate == "boolean" && (u.initAsync = u.initImmediate), u;
}, Oy = () => {
}, X2 = (u) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(u)).forEach((s) => {
    typeof u[s] == "function" && (u[s] = u[s].bind(u));
  });
};
class vm extends nb {
  constructor() {
    let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = CE(o), this.services = {}, this.logger = Fi, this.modules = {
      external: []
    }, X2(this), s && !this.isInitialized && !o.isClone) {
      if (!this.options.initAsync)
        return this.init(o, s), this;
      setTimeout(() => {
        this.init(o, s);
      }, 0);
    }
  }
  init() {
    var o = this;
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, d = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof s == "function" && (d = s, s = {}), s.defaultNS == null && s.ns && (dt(s.ns) ? s.defaultNS = s.ns : s.ns.indexOf("translation") < 0 && (s.defaultNS = s.ns[0]));
    const h = EE();
    this.options = {
      ...h,
      ...this.options,
      ...CE(s)
    }, this.options.interpolation = {
      ...h.interpolation,
      ...this.options.interpolation
    }, s.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = s.keySeparator), s.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = s.nsSeparator);
    const m = (R) => R ? typeof R == "function" ? new R() : R : null;
    if (!this.options.isClone) {
      this.modules.logger ? Fi.init(m(this.modules.logger), this.options) : Fi.init(null, this.options);
      let R;
      this.modules.formatter ? R = this.modules.formatter : R = Y2;
      const P = new wE(this.options);
      this.store = new yE(this.options.resources, this.options);
      const O = this.services;
      O.logger = Fi, O.resourceStore = this.store, O.languageUtils = P, O.pluralResolver = new Z2(P, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), R && (!this.options.interpolation.format || this.options.interpolation.format === h.interpolation.format) && (O.formatter = m(R), O.formatter.init(O, this.options), this.options.interpolation.format = O.formatter.format.bind(O.formatter)), O.interpolator = new Q2(this.options), O.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, O.backendConnector = new J2(m(this.modules.backend), O.resourceStore, O, this.options), O.backendConnector.on("*", function(M) {
        for (var $ = arguments.length, Z = new Array($ > 1 ? $ - 1 : 0), G = 1; G < $; G++)
          Z[G - 1] = arguments[G];
        o.emit(M, ...Z);
      }), this.modules.languageDetector && (O.languageDetector = m(this.modules.languageDetector), O.languageDetector.init && O.languageDetector.init(O, this.options.detection, this.options)), this.modules.i18nFormat && (O.i18nFormat = m(this.modules.i18nFormat), O.i18nFormat.init && O.i18nFormat.init(this)), this.translator = new Gy(this.services, this.options), this.translator.on("*", function(M) {
        for (var $ = arguments.length, Z = new Array($ > 1 ? $ - 1 : 0), G = 1; G < $; G++)
          Z[G - 1] = arguments[G];
        o.emit(M, ...Z);
      }), this.modules.external.forEach((M) => {
        M.init && M.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, d || (d = Oy), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const R = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      R.length > 0 && R[0] !== "dev" && (this.options.lng = R[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((R) => {
      this[R] = function() {
        return o.store[R](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((R) => {
      this[R] = function() {
        return o.store[R](...arguments), o;
      };
    });
    const S = Yh(), E = () => {
      const R = (P, O) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), S.resolve(O), d(P, O);
      };
      if (this.languages && !this.isInitialized) return R(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, R);
    };
    return this.options.resources || !this.options.initAsync ? E() : setTimeout(E, 0), S;
  }
  loadResources(o) {
    var m, g;
    let d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Oy;
    const h = dt(o) ? o : this.language;
    if (typeof o == "function" && (d = o), !this.options.resources || this.options.partialBundledLanguages) {
      if ((h == null ? void 0 : h.toLowerCase()) === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return d();
      const k = [], S = (E) => {
        if (!E || E === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(E).forEach((P) => {
          P !== "cimode" && k.indexOf(P) < 0 && k.push(P);
        });
      };
      h ? S(h) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((R) => S(R)), (g = (m = this.options.preload) == null ? void 0 : m.forEach) == null || g.call(m, (E) => S(E)), this.services.backendConnector.load(k, this.options.ns, (E) => {
        !E && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), d(E);
      });
    } else
      d(null);
  }
  reloadResources(o, s, d) {
    const h = Yh();
    return typeof o == "function" && (d = o, o = void 0), typeof s == "function" && (d = s, s = void 0), o || (o = this.languages), s || (s = this.options.ns), d || (d = Oy), this.services.backendConnector.reload(o, s, (m) => {
      h.resolve(), d(m);
    }), h;
  }
  use(o) {
    if (!o) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!o.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return o.type === "backend" && (this.modules.backend = o), (o.type === "logger" || o.log && o.warn && o.error) && (this.modules.logger = o), o.type === "languageDetector" && (this.modules.languageDetector = o), o.type === "i18nFormat" && (this.modules.i18nFormat = o), o.type === "postProcessor" && UC.addPostProcessor(o), o.type === "formatter" && (this.modules.formatter = o), o.type === "3rdParty" && this.modules.external.push(o), this;
  }
  setResolvedLanguage(o) {
    if (!(!o || !this.languages) && !(["cimode", "dev"].indexOf(o) > -1))
      for (let s = 0; s < this.languages.length; s++) {
        const d = this.languages[s];
        if (!(["cimode", "dev"].indexOf(d) > -1) && this.store.hasLanguageSomeTranslations(d)) {
          this.resolvedLanguage = d;
          break;
        }
      }
  }
  changeLanguage(o, s) {
    var d = this;
    this.isLanguageChangingTo = o;
    const h = Yh();
    this.emit("languageChanging", o);
    const m = (S) => {
      this.language = S, this.languages = this.services.languageUtils.toResolveHierarchy(S), this.resolvedLanguage = void 0, this.setResolvedLanguage(S);
    }, g = (S, E) => {
      E ? (m(E), this.translator.changeLanguage(E), this.isLanguageChangingTo = void 0, this.emit("languageChanged", E), this.logger.log("languageChanged", E)) : this.isLanguageChangingTo = void 0, h.resolve(function() {
        return d.t(...arguments);
      }), s && s(S, function() {
        return d.t(...arguments);
      });
    }, k = (S) => {
      var R, P;
      !o && !S && this.services.languageDetector && (S = []);
      const E = dt(S) ? S : this.services.languageUtils.getBestMatchFromCodes(S);
      E && (this.language || m(E), this.translator.language || this.translator.changeLanguage(E), (P = (R = this.services.languageDetector) == null ? void 0 : R.cacheUserLanguage) == null || P.call(R, E)), this.loadResources(E, (O) => {
        g(O, E);
      });
    };
    return !o && this.services.languageDetector && !this.services.languageDetector.async ? k(this.services.languageDetector.detect()) : !o && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(k) : this.services.languageDetector.detect(k) : k(o), h;
  }
  getFixedT(o, s, d) {
    var h = this;
    const m = function(g, k) {
      let S;
      if (typeof k != "object") {
        for (var E = arguments.length, R = new Array(E > 2 ? E - 2 : 0), P = 2; P < E; P++)
          R[P - 2] = arguments[P];
        S = h.options.overloadTranslationOptionHandler([g, k].concat(R));
      } else
        S = {
          ...k
        };
      S.lng = S.lng || m.lng, S.lngs = S.lngs || m.lngs, S.ns = S.ns || m.ns, S.keyPrefix !== "" && (S.keyPrefix = S.keyPrefix || d || m.keyPrefix);
      const O = h.options.keySeparator || ".";
      let M;
      return S.keyPrefix && Array.isArray(g) ? M = g.map(($) => `${S.keyPrefix}${O}${$}`) : M = S.keyPrefix ? `${S.keyPrefix}${O}${g}` : g, h.t(M, S);
    };
    return dt(o) ? m.lng = o : m.lngs = o, m.ns = s, m.keyPrefix = d, m;
  }
  t() {
    var h;
    for (var o = arguments.length, s = new Array(o), d = 0; d < o; d++)
      s[d] = arguments[d];
    return (h = this.translator) == null ? void 0 : h.translate(...s);
  }
  exists() {
    var h;
    for (var o = arguments.length, s = new Array(o), d = 0; d < o; d++)
      s[d] = arguments[d];
    return (h = this.translator) == null ? void 0 : h.exists(...s);
  }
  setDefaultNamespace(o) {
    this.options.defaultNS = o;
  }
  hasLoadedNamespace(o) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const d = s.lng || this.resolvedLanguage || this.languages[0], h = this.options ? this.options.fallbackLng : !1, m = this.languages[this.languages.length - 1];
    if (d.toLowerCase() === "cimode") return !0;
    const g = (k, S) => {
      const E = this.services.backendConnector.state[`${k}|${S}`];
      return E === -1 || E === 0 || E === 2;
    };
    if (s.precheck) {
      const k = s.precheck(this, g);
      if (k !== void 0) return k;
    }
    return !!(this.hasResourceBundle(d, o) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || g(d, o) && (!h || g(m, o)));
  }
  loadNamespaces(o, s) {
    const d = Yh();
    return this.options.ns ? (dt(o) && (o = [o]), o.forEach((h) => {
      this.options.ns.indexOf(h) < 0 && this.options.ns.push(h);
    }), this.loadResources((h) => {
      d.resolve(), s && s(h);
    }), d) : (s && s(), Promise.resolve());
  }
  loadLanguages(o, s) {
    const d = Yh();
    dt(o) && (o = [o]);
    const h = this.options.preload || [], m = o.filter((g) => h.indexOf(g) < 0 && this.services.languageUtils.isSupportedCode(g));
    return m.length ? (this.options.preload = h.concat(m), this.loadResources((g) => {
      d.resolve(), s && s(g);
    }), d) : (s && s(), Promise.resolve());
  }
  dir(o) {
    var h, m;
    if (o || (o = this.resolvedLanguage || (((h = this.languages) == null ? void 0 : h.length) > 0 ? this.languages[0] : this.language)), !o) return "rtl";
    const s = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], d = ((m = this.services) == null ? void 0 : m.languageUtils) || new wE(EE());
    return s.indexOf(d.getLanguagePartFromCode(o)) > -1 || o.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = arguments.length > 1 ? arguments[1] : void 0;
    return new vm(o, s);
  }
  cloneInstance() {
    let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Oy;
    const d = o.forkResourceStore;
    d && delete o.forkResourceStore;
    const h = {
      ...this.options,
      ...o,
      isClone: !0
    }, m = new vm(h);
    if ((o.debug !== void 0 || o.prefix !== void 0) && (m.logger = m.logger.clone(o)), ["store", "services", "language"].forEach((k) => {
      m[k] = this[k];
    }), m.services = {
      ...this.services
    }, m.services.utils = {
      hasLoadedNamespace: m.hasLoadedNamespace.bind(m)
    }, d) {
      const k = Object.keys(this.store.data).reduce((S, E) => (S[E] = {
        ...this.store.data[E]
      }, Object.keys(S[E]).reduce((R, P) => (R[P] = {
        ...S[E][P]
      }, R), {})), {});
      m.store = new yE(k, h), m.services.resourceStore = m.store;
    }
    return m.translator = new Gy(m.services, h), m.translator.on("*", function(k) {
      for (var S = arguments.length, E = new Array(S > 1 ? S - 1 : 0), R = 1; R < S; R++)
        E[R - 1] = arguments[R];
      m.emit(k, ...E);
    }), m.init(h, s), m.translator.options = h, m.translator.backendConnector.services.utils = {
      hasLoadedNamespace: m.hasLoadedNamespace.bind(m)
    }, m;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const oa = vm.createInstance();
oa.createInstance = vm.createInstance;
const eA = oa.createInstance;
oa.dir;
oa.init;
oa.loadResources;
oa.reloadResources;
oa.use;
oa.changeLanguage;
oa.getFixedT;
oa.t;
oa.exists;
oa.setDefaultNamespace;
oa.hasLoadedNamespace;
oa.loadNamespaces;
oa.loadLanguages;
const tA = "", nA = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  no_result: tA
}, rA = "Når du har forhåndsgodkendt  dette boligbytte, skal din byttepartner bekræfte det. Byttepartneren har {nbDays} dage til at bekræfte boligbyttet (indtil {date}). Ellers vil din forhåndsgodkendelse udløbe, og du bliver nødt til at forhåndsgodkende boligbyttet igen.", aA = "Dobbelt booking (via en anden platform)", oA = "Familieproblemer", iA = "Helbredsproblemer", sA = "Skader i hjemmet", lA = "Flytning", uA = "Du skal angive årsagerne til, at du vil annullere boligbyttet.", cA = "Andre", dA = "Transportproblemer", fA = "Tillidsproblem", pA = "Arbejdsrelateret", hA = "Du er nødt til at indtaste en årsag", mA = {
  "cancellation-page.cancel-exchange": "Annuller boligbyttet",
  "cancellation-page.continue-cancellation": "Fortsæt annulleringen",
  "cancellation-page.keep-exchange": "Behold mit boligbytte",
  "cancellation-page.reason_step.checboxes_label": "Vælg hovedårsagen til din annullering:",
  "cancellation-page.reason_step.comment_placeholder": "Skriv årsagen til din annullering her.",
  "cancellation-page.reason_step.error": "Du er nødt til at indtaste en årsag",
  "cancellation-page.reason_step.title": "Hvorfor er du nødt til at annullere?",
  "cancellation-page.warning-step.first-warning": "Husk, at annullering af dit boligbytte kan have en negativ indvirkning på din byttepartner, som måske allerede har lavet rejseplaner!",
  "cancellation-page.warning-step.second-warning": "Vigtigt: I tilfælde af for mange uberettigede aflysninger som vært, kan din konto blive taget offline. Og som gæst får du muligvis ikke alle dine GuestPoints tilbage.",
  pre_approval_modal_expiration_description: rA,
  reasons_for_cancellation_double_booking_rental: aA,
  reasons_for_cancellation_family_issues: oA,
  reasons_for_cancellation_health_issues: iA,
  reasons_for_cancellation_home_damage: sA,
  reasons_for_cancellation_moving: lA,
  reasons_for_cancellation_needed: uA,
  reasons_for_cancellation_other: cA,
  reasons_for_cancellation_transportation_issues: dA,
  reasons_for_cancellation_trust_issues: fA,
  reasons_for_cancellation_work_related: pA,
  reasons_other_comment_needed: hA
}, gA = "", vA = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  no_result: gA
}, yA = "Nachdem Sie diesen Haustausch vorläufig bestätigt haben, muss Ihr Tauschpartner ihn finalisieren. Dazu hat Ihr Partner {nbDays} Tage Zeit (bis {date}). Nach Ablauf dieser Frist erlischt Ihre Vorabbestätigung und Sie müssen den Haustausch erneut vorläufig bestätigen.", bA = "Doppelbuchung (über eine andere Plattform)", _A = "Familiäre Gründe", wA = "Gesundheitliche Probleme", kA = "Schäden an der Unterkunft", xA = "Umzug", SA = "Sie müssten bitte die Gründe für Ihre Annullierung angeben.", EA = "Andere", CA = "Probleme bei der An-/Abreise", TA = "Vertrauensprobleme", RA = "Arbeitsbedingte Gründe", PA = "Sie müssen einen Grund angeben", NA = {
  "cancellation-page.cancel-exchange": "Den Tausch stornieren",
  "cancellation-page.continue-cancellation": "Stornierung fortsetzen",
  "cancellation-page.keep-exchange": "Meinen Haustausch beibehalten",
  "cancellation-page.reason_step.checboxes_label": "Wählen Sie den Hauptgrund für Ihre Stornierung aus:",
  "cancellation-page.reason_step.comment_placeholder": "Bitte geben Sie hier den Grund für Ihre Stornierung an",
  "cancellation-page.reason_step.error": "Sie müssen einen Grund angeben",
  "cancellation-page.reason_step.title": "Warum müssen Sie stornieren?",
  "cancellation-page.warning-step.first-warning": "Beachten Sie, dass die Stornierung Ihres Haustauschs negative Auswirkungen auf Ihre Tauschpartner haben könnte, die möglicherweise bereits Reisepläne gemacht haben!",
  "cancellation-page.warning-step.second-warning": "Wichtig: Zu viele ungerechtfertigte Stornierungen können dazu führen, dass Ihr Konto als Gastgeber*in offline gestellt wird. Als Gast*in können Ihnen möglicherweise nicht alle Ihre GuestPoints zurückerstattet werden.",
  pre_approval_modal_expiration_description: yA,
  reasons_for_cancellation_double_booking_rental: bA,
  reasons_for_cancellation_family_issues: _A,
  reasons_for_cancellation_health_issues: wA,
  reasons_for_cancellation_home_damage: kA,
  reasons_for_cancellation_moving: xA,
  reasons_for_cancellation_needed: SA,
  reasons_for_cancellation_other: EA,
  reasons_for_cancellation_transportation_issues: CA,
  reasons_for_cancellation_trust_issues: TA,
  reasons_for_cancellation_work_related: RA,
  reasons_other_comment_needed: PA
}, OA = "No result", LA = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  no_result: OA
}, DA = "After you pre-approve this exchange, your exchange partner will need to finalize it. They have {nbDays} days to finalize the exchange (until {date}). Otherwise, your pre-approval will expire and you will have to preapprove the exchange again.", zA = "Double booking (via another platform)", IA = "Family issue", AA = "Health issue", MA = "Home damage", FA = "Moving home", $A = "You need to indicate the reasons for your cancellation.", jA = "Other", UA = "Transport issue", VA = "Trust issue", BA = "Work related", WA = "You need to enter a reason", qA = {
  "cancellation-page.cancel-exchange": "Cancel the exchange",
  "cancellation-page.continue-cancellation": "Continue cancellation",
  "cancellation-page.keep-exchange": "Keep my exchange",
  "cancellation-page.reason_step.checboxes_label": "Select the main reason for your cancellation:",
  "cancellation-page.reason_step.comment_placeholder": "Write the reason for your cancellation here",
  "cancellation-page.reason_step.error": "You need to enter a reason",
  "cancellation-page.reason_step.title": "Why do you need to cancel?",
  "cancellation-page.warning-step.first-warning": "Remember that cancelling your exchange could impact negatively on your exchange partner, who might already have made plans!",
  "cancellation-page.warning-step.second-warning": "Important: In case of excessive unjustified cancellations as a host, your account may be taken offline. And as a guest, you may not have all your GuestPoints returned to you.",
  pre_approval_modal_expiration_description: DA,
  reasons_for_cancellation_double_booking_rental: zA,
  reasons_for_cancellation_family_issues: IA,
  reasons_for_cancellation_health_issues: AA,
  reasons_for_cancellation_home_damage: MA,
  reasons_for_cancellation_moving: FA,
  reasons_for_cancellation_needed: $A,
  reasons_for_cancellation_other: jA,
  reasons_for_cancellation_transportation_issues: UA,
  reasons_for_cancellation_trust_issues: VA,
  reasons_for_cancellation_work_related: BA,
  reasons_other_comment_needed: WA
}, HA = "", ZA = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  "button.free-signup": "Sign up for free",
  "button.validate": "",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "",
  "errors.unable_to_submit.title": "",
  no_result: HA
}, QA = "After you pre-approve this exchange, your exchange partner will need to finalize it. They have {nbDays} days to finalize the exchange (until {date}). Otherwise, your pre-approval will expire and you will have to preapprove the exchange again.", KA = "Double booking (via another platform)", YA = "Family issue", GA = "Health issue", JA = "Home damage", XA = "Moving home", eM = "", tM = "", nM = "Transport issue", rM = "Trust issue", aM = "Work related", oM = "", iM = {
  "cancellation-page.cancel-exchange": "Cancel the exchange",
  "cancellation-page.continue-cancellation": "Continue cancellation",
  "cancellation-page.keep-exchange": "Keep my exchange",
  "cancellation-page.reason_step.checboxes_label": "Select the main reason for your cancellation:",
  "cancellation-page.reason_step.comment_placeholder": "",
  "cancellation-page.reason_step.error": "You need to enter a reason",
  "cancellation-page.reason_step.title": "Why do you need to cancel?",
  "cancellation-page.warning-step.first-warning": "Remember that cancelling your exchange could impact negatively on your exchange partner, who might already have made plans!",
  "cancellation-page.warning-step.second-warning": "Important: In case of excessive unjustified cancellations as a host, your account may be taken offline. And as a guest, you may not have all your GuestPoints returned to you.",
  pre_approval_modal_expiration_description: QA,
  reasons_for_cancellation_double_booking_rental: KA,
  reasons_for_cancellation_family_issues: YA,
  reasons_for_cancellation_health_issues: GA,
  reasons_for_cancellation_home_damage: JA,
  reasons_for_cancellation_moving: XA,
  reasons_for_cancellation_needed: eM,
  reasons_for_cancellation_other: tM,
  reasons_for_cancellation_transportation_issues: nM,
  reasons_for_cancellation_trust_issues: rM,
  reasons_for_cancellation_work_related: aM,
  reasons_other_comment_needed: oM
}, sM = "", lM = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  no_result: sM
}, uM = "Después de preaprobar este intercambio, tus compañeros de intercambio tendrán que registrarlo. Tienes {nbDays} días para registrar el intercambio (hasta el {date}). De lo contrario, la preaprobación caducará y tendrás que volver a preaprobar el intercambio.", cM = "Reserva doble (otra plataforma)", dM = "Asuntos familiares", fM = "Temas de salud", pM = "Daños en la casa", hM = "Mudanza", mM = "Por favor, indica las razones de la cancelación", gM = "Otro", vM = "Problemas con el transporte", yM = "Temas de confianza", bM = "Asuntos laborales", _M = "Debes introducir un motivo", wM = {
  "cancellation-page.cancel-exchange": "Cancelar el intercambio",
  "cancellation-page.continue-cancellation": "Continuar con la cancelación",
  "cancellation-page.keep-exchange": "Mantener el intercambio",
  "cancellation-page.reason_step.checboxes_label": "Selecciona el motivo principal de la cancelación:",
  "cancellation-page.reason_step.comment_placeholder": "",
  "cancellation-page.reason_step.error": "Debes introducir un motivo",
  "cancellation-page.reason_step.title": "¿Por qué quieres cancelar el intercambio?",
  "cancellation-page.warning-step.first-warning": "No olvides que cancelar el intercambio puede afectar a tus compañeros de intercambio, que seguramente han hecho planes.",
  "cancellation-page.warning-step.second-warning": "Importante: un exceso de cancelaciones injustificadas por parte de los anfitriones puede resultar en la desactivación de su cuenta y, por parte de los invitados, puede implicar que no se recuperen todos los GuestPoints.",
  pre_approval_modal_expiration_description: uM,
  reasons_for_cancellation_double_booking_rental: cM,
  reasons_for_cancellation_family_issues: dM,
  reasons_for_cancellation_health_issues: fM,
  reasons_for_cancellation_home_damage: pM,
  reasons_for_cancellation_moving: hM,
  reasons_for_cancellation_needed: mM,
  reasons_for_cancellation_other: gM,
  reasons_for_cancellation_transportation_issues: vM,
  reasons_for_cancellation_trust_issues: yM,
  reasons_for_cancellation_work_related: bM,
  reasons_other_comment_needed: _M
}, kM = "", xM = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  no_result: kM
}, SM = "Après cette pré-approbation, votre partenaire d'échange disposera de {nbDays} jour(s) pour finaliser (jusqu'au {date}). Sinon, votre pré-approbation expirera et vous devrez pré-approuver l'échange de nouveau.", EM = "Double réservation (via une autre plateforme)", CM = "Imprévu familial", TM = "Problème de santé", RM = "Dégâts à mon domicile", PM = "Déménagement", NM = "Vous devez indiquer les raisons de votre annulation.", OM = "Autre", LM = "Problème de transport", DM = "Problème de confiance", zM = "Imprévu professionnel", IM = "Vous devez saisir un motif", AM = {
  "cancellation-page.cancel-exchange": "Annuler l'échange",
  "cancellation-page.continue-cancellation": "Poursuivre l'annulation",
  "cancellation-page.keep-exchange": "Conserver mon échange",
  "cancellation-page.reason_step.checboxes_label": "Sélectionnez la raison principale de votre annulation :",
  "cancellation-page.reason_step.comment_placeholder": "Indiquez la raison de votre annulation juste ici",
  "cancellation-page.reason_step.error": "Vous devez saisir un motif",
  "cancellation-page.reason_step.title": "Pourquoi devez-vous annuler ?",
  "cancellation-page.warning-step.first-warning": "N'oubliez pas que l'annulation de votre échange peut avoir un impact négatif sur votre partenaire d'échange, qui a peut-être déjà planifié son voyage !",
  "cancellation-page.warning-step.second-warning": "Important : Face à un nombre excessif d'annulations injustifiées en tant qu'hôte, votre compte pourrait être mis hors ligne et, en tant qu'invité-e, vous pourriez ne pas récupérer l'intégralité de vos GuestPoints.",
  pre_approval_modal_expiration_description: SM,
  reasons_for_cancellation_double_booking_rental: EM,
  reasons_for_cancellation_family_issues: CM,
  reasons_for_cancellation_health_issues: TM,
  reasons_for_cancellation_home_damage: RM,
  reasons_for_cancellation_moving: PM,
  reasons_for_cancellation_needed: NM,
  reasons_for_cancellation_other: OM,
  reasons_for_cancellation_transportation_issues: LM,
  reasons_for_cancellation_trust_issues: DM,
  reasons_for_cancellation_work_related: zM,
  reasons_other_comment_needed: IM
}, MM = "", FM = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  no_result: MM
}, $M = "Nakon što unaprijed odobrite ovu zamjenu, Vaš partner za zamjenu ju mora finalizirati. Za to ima {nbDays} dana (do {date}). Ako ne, Vaše će prethodno odobrenje isteći i trebat ćete ponovno prethodno odobriti zamjenu.", jM = "Dvostruka rezervacija (druga platforma)", UM = "Obiteljski problemi", VM = "Zdravstveni problemi", BM = "Oštećenje doma", WM = "Preseljenje", qM = "Morate navesti razloge otkazivanja", HM = "Ostalo", ZM = "Problemi s prijevozom", QM = "Nepovjerenje", KM = "Poslovni problemi", YM = "Trebate unijeti razlog", GM = {
  "cancellation-page.cancel-exchange": "Otkažite zamjenu",
  "cancellation-page.continue-cancellation": "Nastavite s otkazivanjem",
  "cancellation-page.keep-exchange": "Zadržite svoju zamjenu",
  "cancellation-page.reason_step.checboxes_label": "Odaberite glavni razlog zašto otkazujete:",
  "cancellation-page.reason_step.comment_placeholder": "Ovdje unesite razlog otkazivanja zamjene",
  "cancellation-page.reason_step.error": "Trebate unijeti razlog",
  "cancellation-page.reason_step.title": "Zašto trebate otkazati?",
  "cancellation-page.warning-step.first-warning": "Vodite računa o tome da otkazivanje zamjene može negativno utjecati na Vašeg partnera za zamjenu koji je već možda napravio planove za putovanje!",
  "cancellation-page.warning-step.second-warning": "Važno: U slučaju pretjeranih neopradanih otkazivanja u svojstvu domaćina, Vaš dom može biti uklonjen s interneta. A kao gost, možda nećete dobiti natrag svoje GuestPoints.",
  pre_approval_modal_expiration_description: $M,
  reasons_for_cancellation_double_booking_rental: jM,
  reasons_for_cancellation_family_issues: UM,
  reasons_for_cancellation_health_issues: VM,
  reasons_for_cancellation_home_damage: BM,
  reasons_for_cancellation_moving: WM,
  reasons_for_cancellation_needed: qM,
  reasons_for_cancellation_other: HM,
  reasons_for_cancellation_transportation_issues: ZM,
  reasons_for_cancellation_trust_issues: QM,
  reasons_for_cancellation_work_related: KM,
  reasons_other_comment_needed: YM
}, JM = "", XM = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  no_result: JM
}, eF = "Dopo aver pre-approvato questo scambio, il tuo partner di scambio dovrà finalizzarlo. Avrà tempo {nbDays} giorni per finalizzare lo scambio (fino al giorno {date}). In caso contrario, la tua pre-approvazione scadrà e dovrai pre-approvare lo scambio nuovamente.", tF = "Doppia prenotazione (con un'altra piattaforma)", nF = "Ragioni familiari", rF = "Motivi di salute", aF = "Danni alla proprietà", oF = "Trasferimento", iF = "È necessario indicare i motivi per la cancellazione.", sF = "Altro", lF = "Problemi di trasporto", uF = "Problemi di fiducia", cF = "Motivi legati al lavoro", dF = "È necessario inserire un motivo", fF = {
  "cancellation-page.cancel-exchange": "Annulla lo scambio",
  "cancellation-page.continue-cancellation": "Continua con la cancellazione",
  "cancellation-page.keep-exchange": "Mantieni il mio scambio",
  "cancellation-page.reason_step.checboxes_label": "Seleziona il motivo principale della tua cancellazione:",
  "cancellation-page.reason_step.comment_placeholder": "Inserisci qui la ragione della cancellazione",
  "cancellation-page.reason_step.error": "È necessario inserire un motivo",
  "cancellation-page.reason_step.title": "Perché devi annullare?",
  "cancellation-page.warning-step.first-warning": "Ricorda che annullare il tuo scambio può avere un impatto negativo sul tuo partner di scambio, che potrebbe già aver pianificato il viaggio!",
  "cancellation-page.warning-step.second-warning": "Importante: In caso di eccessive cancellazioni ingiustificate in qualità di host, il tuo account potrebbe essere disattivato. E come ospite, potresti non recuperare tutti i tuoi GuestPoints.",
  pre_approval_modal_expiration_description: eF,
  reasons_for_cancellation_double_booking_rental: tF,
  reasons_for_cancellation_family_issues: nF,
  reasons_for_cancellation_health_issues: rF,
  reasons_for_cancellation_home_damage: aF,
  reasons_for_cancellation_moving: oF,
  reasons_for_cancellation_needed: iF,
  reasons_for_cancellation_other: sF,
  reasons_for_cancellation_transportation_issues: lF,
  reasons_for_cancellation_trust_issues: uF,
  reasons_for_cancellation_work_related: cF,
  reasons_other_comment_needed: dF
}, pF = "", hF = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  no_result: pF
}, mF = "Etter at du har forhåndsgodkjent dette boligbyttet må din boligbyttepartner ferdigstille det. De har {nbDays} dager på seg til å ferdigstille boligbyttet (frem til {date}). Om ikke vil forhåndsgodkjenningen din utløpe, og du må forhåndsgodkjenne boligbyttet på nytt.", gF = "Dobbelbooking (via en annen plattform)", vF = "Famileproblemer", yF = "Helseproblemer", bF = "Skade på boligen", _F = "Flytting", wF = "Du må angi årsakene til avbestillingen.", kF = "Annet", xF = "Transportproblemer", SF = "Tillitsbrudd", EF = "Arbeidsrelatert", CF = "Du må oppgi en grunn", TF = {
  "cancellation-page.cancel-exchange": "Kanseller boligbyttet",
  "cancellation-page.continue-cancellation": "Fortsett kansellering",
  "cancellation-page.keep-exchange": "Behold boligbyttet",
  "cancellation-page.reason_step.checboxes_label": "Velg hovedårsaken for din kansellering:",
  "cancellation-page.reason_step.comment_placeholder": "Oppgi årsaken for din kansellering her",
  "cancellation-page.reason_step.error": "Du må oppgi en grunn",
  "cancellation-page.reason_step.title": "Hvorfor ønsker du å kansellere?",
  "cancellation-page.warning-step.first-warning": "Husk at det å kansellere boligbyttet kan ha en negativ innvirkning på din boligbyttepartner, som kanskje allerede har lagt reiseplaner!",
  "cancellation-page.warning-step.second-warning": "Viktig: Dersom du kansellerer et boligbytte som vert uten gyldig grunn kan din konto bli sperret. Som gjest kan konsekvensen være at du ikke får refundert alle dine GuestPoints.",
  pre_approval_modal_expiration_description: mF,
  reasons_for_cancellation_double_booking_rental: gF,
  reasons_for_cancellation_family_issues: vF,
  reasons_for_cancellation_health_issues: yF,
  reasons_for_cancellation_home_damage: bF,
  reasons_for_cancellation_moving: _F,
  reasons_for_cancellation_needed: wF,
  reasons_for_cancellation_other: kF,
  reasons_for_cancellation_transportation_issues: xF,
  reasons_for_cancellation_trust_issues: SF,
  reasons_for_cancellation_work_related: EF,
  reasons_other_comment_needed: CF
}, RF = "Geen resultaat", PF = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  no_result: RF
}, NF = "Nadat je de uitwisseling hebt goedgekeurd, moet je uitwisselingspartner deze bevestigen. Hij of zij heeft {nbDays} dagen de tijd om dit te doen (tot {date}). Anders vervalt je voorlopige goedkeuring en moet je de uitwisseling opnieuw goedkeuren.", OF = "Dubbele boeking (via een ander platform)", LF = "Familiale redenen", DF = "Gezondheidsproblemen", zF = "Schade aan het huis", IF = "Verhuis", AF = "U dient aan te geven in de redenen voor uw annulering.", MF = "Andere", FF = "Problemen met het transport", $F = "Vertrouwenskwestie", jF = "Werkgerelateerde redenen", UF = "Je moet een reden opgeven", VF = {
  "cancellation-page.cancel-exchange": "Annuleer de uitwisseling",
  "cancellation-page.continue-cancellation": "Doorgaan met annuleren",
  "cancellation-page.keep-exchange": "Mijn uitwisseling behouden",
  "cancellation-page.reason_step.checboxes_label": "Selecteer de hoofdreden voor je annulering:",
  "cancellation-page.reason_step.comment_placeholder": "Schrijf hier de reden van de annulering.",
  "cancellation-page.reason_step.error": "Je moet een reden opgeven",
  "cancellation-page.reason_step.title": "Waarom moet je annuleren?",
  "cancellation-page.warning-step.first-warning": "Vergeet niet dat het annuleren van je uitwisseling negatieve gevolgen kan hebben voor je uitwisselingspartner, die misschien al reisplannen heeft gemaakt!",
  "cancellation-page.warning-step.second-warning": "Belangrijk: Als je als gastheer/-vrouw te vaak onterecht annuleert, kan je account offline worden gehaald. En als gast kan het zijn dat je niet al je GuestPoints terugkrijgt.",
  pre_approval_modal_expiration_description: NF,
  reasons_for_cancellation_double_booking_rental: OF,
  reasons_for_cancellation_family_issues: LF,
  reasons_for_cancellation_health_issues: DF,
  reasons_for_cancellation_home_damage: zF,
  reasons_for_cancellation_moving: IF,
  reasons_for_cancellation_needed: AF,
  reasons_for_cancellation_other: MF,
  reasons_for_cancellation_transportation_issues: FF,
  reasons_for_cancellation_trust_issues: $F,
  reasons_for_cancellation_work_related: jF,
  reasons_other_comment_needed: UF
}, BF = "", WF = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  no_result: BF
}, qF = "Após pré-aprovar esta troca, o seu parceiro de troca terá de a finalizar e terá {nbDays} dias para o fazer (até {date}). Caso contrário, a sua pré-aprovação irá expirar e terá de voltar a pré-aprovar a troca.", HF = "Reserva dupla (outra plataforma)", ZF = "Motivos familiares", QF = "Motivos de saúde", KF = "Danos na propriedade", YF = "Mudanças", GF = "Você precisa indicar os motivos do cancelamento.", JF = "Outro", XF = "Problemas de transporte", e3 = "Problemas de confiança", t3 = "Motivos laborais", n3 = "É obrigatório introduzir um motivo", r3 = {
  "cancellation-page.cancel-exchange": "Cancelar a troca",
  "cancellation-page.continue-cancellation": "Continuar com o cancelamento",
  "cancellation-page.keep-exchange": "Manter a minha troca",
  "cancellation-page.reason_step.checboxes_label": "Selecione o motivo principal para o cancelamento:",
  "cancellation-page.reason_step.comment_placeholder": "Escreva aqui o motivo do cancelamento",
  "cancellation-page.reason_step.error": "É obrigatório introduzir um motivo",
  "cancellation-page.reason_step.title": "Por que motivo precisa de cancelar?",
  "cancellation-page.warning-step.first-warning": "Lembre-se que cancelar a sua troca pode ter um impacto negativo para o seu parceiro de troca, que pode já ter feito planos de viagem!",
  "cancellation-page.warning-step.second-warning": "Importante: Caso tenha demasiados cancelamentos injustificados como anfitrião, a sua conta poderá ser colocada offline. Caso isto aconteça enquanto convidado, poderá não receber todos os seus GuestPoints de volta.",
  pre_approval_modal_expiration_description: qF,
  reasons_for_cancellation_double_booking_rental: HF,
  reasons_for_cancellation_family_issues: ZF,
  reasons_for_cancellation_health_issues: QF,
  reasons_for_cancellation_home_damage: KF,
  reasons_for_cancellation_moving: YF,
  reasons_for_cancellation_needed: GF,
  reasons_for_cancellation_other: JF,
  reasons_for_cancellation_transportation_issues: XF,
  reasons_for_cancellation_trust_issues: e3,
  reasons_for_cancellation_work_related: t3,
  reasons_other_comment_needed: n3
}, a3 = "", o3 = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  no_result: a3
}, i3 = "Efter att du har förgodkänt det här hembytet behöver din hembytespartner bekräfta det. Hen har {nbDays} dagar på sig att bekräfta det (till {date}). Annars kommer ditt förgodkännande att löpa ut och du behöver förgodkänna hembytet igen.", s3 = "Dubbelbokning (annan plattform)", l3 = "Familjeproblem", u3 = "Hälsoproblem", c3 = "Skada i hemmet", d3 = "Flytt", f3 = "Du måste ange orsaken till din avbokning.", p3 = "Övrigt", h3 = "Transportproblem", m3 = "Bristande förtroende", g3 = "Arbetsrelaterat", v3 = "Du behöver ange en anledning", y3 = {
  "cancellation-page.cancel-exchange": "Avboka hembytet",
  "cancellation-page.continue-cancellation": "Fortsätt avbokning",
  "cancellation-page.keep-exchange": "Behåll mitt hembyte",
  "cancellation-page.reason_step.checboxes_label": "Välj huvudanledningen till din avbokning:",
  "cancellation-page.reason_step.comment_placeholder": "Ange anledningen till din avbokning här.",
  "cancellation-page.reason_step.error": "Du behöver ange en anledning",
  "cancellation-page.reason_step.title": "Varför behöver du avboka?",
  "cancellation-page.warning-step.first-warning": "Kom ihåg att ifall du avbokar ditt hembyte kan det ha en negativ inverkan på din hembytespartner, som kanske redan har planerat sin resa!",
  "cancellation-page.warning-step.second-warning": "Viktigt: Vid överdrivna och omotiverade avbokningar som värd kan ditt konto tas offline. Och som gäst kanske inte alla dina GuestPoints återgäldas till dig.",
  pre_approval_modal_expiration_description: i3,
  reasons_for_cancellation_double_booking_rental: s3,
  reasons_for_cancellation_family_issues: l3,
  reasons_for_cancellation_health_issues: u3,
  reasons_for_cancellation_home_damage: c3,
  reasons_for_cancellation_moving: d3,
  reasons_for_cancellation_needed: f3,
  reasons_for_cancellation_other: p3,
  reasons_for_cancellation_transportation_issues: h3,
  reasons_for_cancellation_trust_issues: m3,
  reasons_for_cancellation_work_related: g3,
  reasons_other_comment_needed: v3
}, b3 = "en", VC = eA({
  fallbackLng: b3,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  resources: {
    da: {
      common: nA,
      conversations: mA
    },
    de: {
      common: vA,
      conversations: NA
    },
    en: {
      conversations: qA,
      common: LA
    },
    en_US: {
      conversations: iM,
      common: ZA
    },
    es: {
      conversations: wM,
      common: lM
    },
    fr: {
      conversations: AM,
      common: xM
    },
    hr: {
      conversations: GM,
      common: FM
    },
    it: {
      conversations: fF,
      common: XM
    },
    nb: {
      conversations: TF,
      common: hF
    },
    nl: {
      conversations: VF,
      common: PF
    },
    pt: {
      conversations: r3,
      common: WF
    },
    sv: {
      conversations: y3,
      common: o3
    }
  }
});
VC.init();
const TE = VC, _3 = (u, o) => {
  $C("exchange_status", u, o);
}, R3 = (u, o) => {
  const s = {
    weekday: "long",
    month: "long",
    day: "numeric"
  };
  return DE(new Date(u), o).toLocaleDateString(document.body.dataset.locale, s);
}, P3 = (u, o, s) => {
  const d = DE(new Date(o), s);
  return new Date(u) > d;
}, Zk = "warning_step", BC = "reason_step", w3 = {
  [Zk]: L2,
  [BC]: O2
};
function k3({
  cancellationReasons: u,
  conversation: o,
  user: s
}) {
  const [d, h] = Vl(Zk), m = w3[d], { url: g } = ox(`/conversations/${o.id}`);
  return nm(() => {
    var S;
    const k = I2({
      isHeCollection: s.is_he_collection,
      subscriptionEndOn: (S = s == null ? void 0 : s.subscription) == null ? void 0 : S.end_on
    });
    D2(s.id, k, s.is_he_collection);
  }, [s]), /* @__PURE__ */ le(rI, { reverseBGColor: !0, isFullHeight: !0, centerContent: !0, children: /* @__PURE__ */ le(eI, { children: /* @__PURE__ */ le(
    m,
    {
      cancellationReasons: u,
      conversation: o,
      user: s,
      onClickContinue: () => {
        d === Zk ? (z2("exchange_cancellation", "exchange_cancellation_reason_selection", {
          collection: s.is_he_collection
        }), scrollTo(0, 0), h(BC)) : window.location.assign(g);
      }
    }
  ) }) });
}
function N3({ cancellationReasons: u, conversation: o, locale: s, user: d, apiUrl: h }) {
  return TE.changeLanguage(s), DL(h), /* @__PURE__ */ le(fI, { locale: s, children: /* @__PURE__ */ le(fD, { i18n: TE, children: /* @__PURE__ */ le(k3, { cancellationReasons: u, conversation: o, user: d }) }) });
}
const O3 = "WITH-GP", L3 = "RECIPROCAL", D3 = "RECIPROCAL-WITH-GP", z3 = "NEW", I3 = "ACCEPTED", A3 = "EXPIRED", M3 = "MANUALLY_DECLINED", F3 = "AUTOMATICALLY_DECLINED", $3 = "PAST_DATES_DECLINE";
export {
  N3 as CancellationPage,
  O2 as ReasonStep,
  I3 as STAY_REQUEST_STATUS_ACCEPTED,
  F3 as STAY_REQUEST_STATUS_AUTOMATICALLY_DECLINED,
  A3 as STAY_REQUEST_STATUS_EXPIRED,
  M3 as STAY_REQUEST_STATUS_MANUALLY_DECLINED,
  z3 as STAY_REQUEST_STATUS_NEW,
  $3 as STAY_REQUEST_STATUS_PAST_DATES_DECLINE,
  L3 as STAY_TYPE_RECIPROCAL,
  D3 as STAY_TYPE_RECIPROCAL_WITH_GP,
  O3 as STAY_TYPE_WITH_GP,
  L2 as WarningStep,
  LL as cancel,
  V3 as cancelPreApprobation,
  B3 as changeStayRequestToNonReciprocal,
  W3 as changeStayRequestToReciprocal,
  q3 as createStayRequest,
  H3 as getCancellationInformations,
  Z3 as getExchangeConfig,
  R3 as getExpirationDate,
  Q3 as getStayRequest,
  K3 as heFetch,
  TE as i18nConfig,
  Y3 as isCancellationPossible,
  P3 as isStartDateAfterExpirationDate,
  G3 as manualDecline,
  J3 as preapproveExchange,
  DL as setConversationsFetchConfig,
  _3 as trackExchangeStatus,
  X3 as updateStayRequestDates
};
